webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_acl_rules__);
var _this = this;








var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function encode(e) {
        if (typeof e == "undefined" || e == false || e == null || e == "") {
            return e;
        }
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = Base64._utf8_encode(e);
        while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;
            if (isNaN(r)) {
                u = a = 64;
            } else if (isNaN(i)) {
                a = 64;
            }
            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
        }
        return t;
    },
    decode: function decode(e) {
        if (typeof e == "undefined" || e == false || e == null || e == "") {
            return e;
        }
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
                t = t + String.fromCharCode(r);
            }
            if (a != 64) {
                t = t + String.fromCharCode(i);
            }
        }
        t = Base64._utf8_decode(t);
        return t;
    },
    _utf8_encode: function _utf8_encode(e) {
        if (typeof e == "undefined" || e == false || e == null || e == "") {
            return e;
        }
        e = e.replace(/\r\n/g, "\n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
            } else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }
        return t;
    },
    _utf8_decode: function _utf8_decode(e) {
        if (typeof e == "undefined" || e == false || e == null || e == "") {
            return e;
        }
        var t = "";
        var n = 0;
        var r = 0;
        var c1 = 0;
        var c2 = 0;
        while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
                n++;
            } else if (r > 191 && r < 224) {
                c2 = e.charCodeAt(n + 1);
                t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                n += 2;
            } else {
                c2 = e.charCodeAt(n + 1);
                c3 = e.charCodeAt(n + 2);
                t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                n += 3;
            }
        }
        return t;
    }
};
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

var getLoggedUser = function getLoggedUser() {
    var s = document.cookie.split(";");
    var ret = "-";
    s.forEach(function (c) {
        var kv = c.trim().split("=");
        if (kv[0] == "session_user" && kv[1].length > 0) {
            ret = kv[1];
            if (typeof _this.$store != "undefined") {
                _this.$store.state.logged_user = kv[1];
            }
        }
    });
    return capitalizeFirstLetter(ret);
};
var getLoggedUserDisplay = function getLoggedUserDisplay() {
    var s = document.cookie.split(";");
    var ret = "-";
    s.forEach(function (c) {
        var kv = c.trim().split("=");
        if (kv[0] == "session_display_user_name" && kv[1].length > 0) {
            ret = kv[1];
        }
        if (kv[0] == "session_user" && kv[1].length > 1) {
            if (typeof _this.$store != "undefined") {
                _this.$store.state.logged_user = kv[1];
            }
        }
    });
    return decodeURIComponent(ret);
};

var copyAllowed = function copyAllowed(allowed, data) {
    allowed = "all";
    var ret = {};
    var i = 0;
    for (var d in data) {
        if (allowed == "all" || allowed.indexOf(d) > -1) {
            ret[d] = data[d];
            i++;
        }
    }
    if (i == 0) {
        ret = false;
    }
    return ret;
};

var if_null = function if_null(val) {
    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    if (typeof val == "undefined" || val == null | val == false || val == "") {
        return def;
    } else {
        return val;
    }
};

var format_date = function format_date(d) {
    if (typeof d == "undefined" || d == false || d == null || d == "") {
        return "";
    }
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(d).format("YYYY/MM/DD");
};
var format_date_time = function format_date_time(dt) {
    if (typeof dt == "undefined" || dt == false || dt == null || dt == "") {
        return "";
    }
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(dt).format("YYYY/MM/DD HH:mm");
};
var format_date_time_s = function format_date_time_s(dt) {
    if (typeof dt == "undefined" || dt == false || dt == null || dt == "") {
        return "";
    }
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(dt).format("YYYY/MM/DD HH:mm:ss");
};

var local_user_permissions = false;
var reset_user_permissions = function reset_user_permissions() {
    local_user_permissions = false;
};
var get_user_permissions = function get_user_permissions() {
    if (local_user_permissions == false) {
        var temp = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole");
        switch (temp) {
            case __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.ID_OPERATIONS_PERSONNEL:
                local_user_permissions = __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.ID_OPERATIONS_PERSONNEL;
                break;
            case __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.ADMINISTRATOR:
                local_user_permissions = __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.ADMINISTRATOR;
                break;
            case __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.CHIEF_ADMINISTRATOR:
                local_user_permissions = __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.CHIEF_ADMINISTRATOR;
                break;
            case __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR:
                local_user_permissions = __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR;
                break;
            case __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF:
                local_user_permissions = __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF;
                break;
            default:
                local_user_permissions = __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION.NONE;
                break;
        }
    }
    return local_user_permissions;
};
var check_user_permission = function check_user_permission(page_acl, permission) {
    var requester = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    var user_role = get_user_permissions();
    if (Array.isArray(page_acl.full) && page_acl.full.indexOf(user_role) > -1) {
        return true;
    }
    if (Array.isArray(page_acl[permission]) && page_acl[permission].indexOf(user_role) > -1) {
        return true;
    }
    return false;
};

var utils = {
    extend: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend,
    cextend: function cextend(data, ext) {
        var d = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(data);
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend(d, ext);
    },
    _: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a,
    format_date: format_date,
    format_date_time: format_date_time,
    format_date_time_s: format_date_time_s,
    groupBy: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy,
    orderBy: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy,
    filter: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter,
    remove: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove,
    Base64: Base64,
    copyAllowed: copyAllowed,
    getLoggedUser: getLoggedUser,
    getLoggedUserDisplay: getLoggedUserDisplay,
    test: function test(d) {
        return "---" + d + "---";
    },
    if_null: if_null,
    get_user_permissions: get_user_permissions,
    reset_user_permissions: reset_user_permissions,
    check_user_permission: check_user_permission,
    acl: __WEBPACK_IMPORTED_MODULE_4__rules_acl_rules___default.a,
    PERMISSION_MODE: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.PERMISSION_MODE,
    constants: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a
};
window.addEventListener("storage", function (ev) {
    if (ev.key == "userRole") {
        utils.reset_user_permissions();
    }
});

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_errors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_path__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_search_control__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_search_control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_search_control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_search_control_maker__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_search_control_maker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_search_control_maker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_title_and_search__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_title_and_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_title_and_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_title_and_slot__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_title_and_slot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_title_and_slot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_confirmation_modal__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_modals_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modals_information_icon_modal__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modals_information_icon_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_modals_information_icon_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_async__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_os__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_os___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_os__);





var _this12 = this;






var debug_pageCommon = __WEBPACK_IMPORTED_MODULE_8_debug___default()("esma:page_common");













/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  components: {
    "search-control": __WEBPACK_IMPORTED_MODULE_12__components_search_control___default.a,
    "search-control-maker": __WEBPACK_IMPORTED_MODULE_13__components_search_control_maker___default.a,
    "title-and-search": __WEBPACK_IMPORTED_MODULE_14__components_title_and_search___default.a,
    "title-and-slot": __WEBPACK_IMPORTED_MODULE_15__components_title_and_slot___default.a,
    "confirmation-modal": __WEBPACK_IMPORTED_MODULE_16__components_modals_confirmation_modal___default.a,
    'information-icon-modal': __WEBPACK_IMPORTED_MODULE_17__components_modals_information_icon_modal___default.a
  },
  created: function created() {},
  data: function data() {
    return {
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      user_type: 0,
      read_only: true,
      total_number_of_rows: 0,
      is_first_load: true,
      is_auto_sized: false,
      form_output_text: "帳票出力",
      form_output_qty: 0,
      selected_row_arr: [],
      SELECTED_EMPTY_SELECT_BOX: "SELECTED_EMPTY_SELECT_BOX",
      user_entities_details: "",
      select_all_icon: "glyphicon glyphicon glyphicon-unchecked",
      is_all_selected: false,
      load_mode: "all",
      high_level_debug: {},
      validation_restriction_list: {},
      local_seq_id: -1,
      is_new: false,
      debug_show_page_name: false,
      local_page_container_size_reload: 1,
      local_fields_ref: {},
      executing_filter_on_back: false
    };
  },


  computed: {
    isAdmin: function isAdmin() {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_18__rules_constants___default.a.PERMISSION.CHIEF_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_18__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_18__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF;
    },
    isMultiCompanyAdmin: function isMultiCompanyAdmin() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "保守担当" || role == "システム管理者";
    },
    isApproverAdminForApproveImport: function isApproverAdminForApproveImport() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "保守担当" || role == "システム管理者";
    },
    isApproverAdminForSimpleApprove: function isApproverAdminForSimpleApprove() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "保守担当" || role == "システム管理者";
    },
    isUserIDOperationInCharge: function isUserIDOperationInCharge() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "ユーザIDオペレーション担当者";
    },
    isMaintenanceStaff: function isMaintenanceStaff() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "保守担当";
    },
    isApproverUserId: function isApproverUserId() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "管理担当者" || role == "管理責任者";
    },
    isNoAdminUserId: function isNoAdminUserId() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "管理担当者" || role == "管理責任者";
    },

    selectedRowArr: {
      get: function get() {
        return this.selected_row_arr;
      },
      set: function set(v) {
        this.selected_row_arr = v;
      }
    },
    batchEditText: function batchEditText() {
      if (this.formOutputQty == 0) {
        return "一括編集";
      } else {
        return "一括編集" + " (" + this.formOutputQty + ")";
      }
    },
    disableIfCheckBoxNotSelected: function disableIfCheckBoxNotSelected() {
      if (this.formOutputQty == 0) {
        return true;
      } else {
        return false;
      }
    },
    formBatchEditDisabled: function formBatchEditDisabled() {
      if (this.formOutputQty == 0) {
        return true;
      }
      if (this.disableButton('cancel') == false && this.disableButton('shusei') == true) {
        return true;
      }
      return false;
    },
    formExportFileDisabled: function formExportFileDisabled() {
      if (this.totalNumberOfRows == 0) {
        return true;
      }
      return false;
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.state_current_row != "undefined") {
        return this.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.state_current_editing != "undefined") {
        return this.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.state_is_editing_new != "undefined") {
        return this.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    stateLastFilterOptions: function stateLastFilterOptions() {
      if (typeof this.state_last_filter_options != "undefined") {
        return this.state_last_filter_options;
      } else {
        return "last_filter_options";
      }
    },
    values: function values() {
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },

    readOnly: {
      get: function get() {
        return this.read_only;
      },
      set: function set(v) {
        this.read_only = v;
      }
    },
    commonGridOptions: function commonGridOptions() {
      var _this = this;

      return {
        defaultColDef: {
          editable: false
        },
        getRowNodeId: function getRowNodeId(data) {
          return data.seq_id;
        },
        enableSorting: true,
        enableColResize: true,
        suppressMovableColumns: true,
        rowSelection: 'single',
        suppressHorizontalScroll: true,
        overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
        overlayLoadingTemplate: "<span class=\"ag-overlay-loading-center\">Loading...</span>",
        onColumnResized: function onColumnResized(ev, b) {},
        onRowSelected: function onRowSelected(ev) {
          if (typeof _this.onRowSelected != "undefined") {
            if (ev.node.isSelected()) {
              return _this.onRowSelected(ev);
            }
          }
        },
        onModelUpdated: function onModelUpdated(ev, d) {},
        onGridReady: function onGridReady() {},
        getRowStyle: function getRowStyle(params) {
          if (params.node.data && (params.node.data.is_selected == true || _this.isAllSelected == true)) {
            if (_this.getRowStyleBackground) {
              return { background: _this.getRowStyleBackground };
            } else {
              return { background: "orange" };
            }
          }
        }
      };
    },
    defaultCreateColumn: function defaultCreateColumn() {
      return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep([{
        headerName: 'Seq',
        field: 'seq_id',
        hide: true,
        sort: 'desc'
      }, {
        headerName: "SearchControl",
        field: "search_control",
        hide: true
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: true
      }]);
    },

    validationRestrictionList: {
      get: function get() {
        return this.validation_restriction_list;
      },
      set: function set(v) {
        this.validation_restriction_list = v;
      }
    },
    highLevelDebug: {
      get: function get() {
        if (this.disableButton('toroku') == false) {
          return [];
        }
        if (this.disableButton('shusei') == true && this.selectedRowArr && this.selectedRowArr.length == 0) {
          return [];
        }
        var high_level_debug_enabled = localStorage.getItem("highLevelDebugEnabled");
        if (high_level_debug_enabled == "1") {
          return this.high_level_debug;
        } else {
          if (typeof high_level_debug_enabled == "undefined" || high_level_debug_enabled == null) {
            localStorage.setItem("highLevelDebugEnabled", "0");
          }
          return [];
        }
      },
      set: function set() {}
    },
    selectAllIcon: {
      get: function get() {
        return this.select_all_icon;
      },
      set: function set(v) {
        if (v == "checked") {
          this.select_all_icon = "glyphicon glyphicon glyphicon-check";
        } else if (v == "unchecked") {
          this.select_all_icon = "glyphicon glyphicon glyphicon-unchecked";
        } else {
          this.select_all_icon = "glyphicon glyphicon glyphicon glyphicon-edit";
        }
      }
    },
    isAllSelected: {
      get: function get() {
        return this.is_all_selected;
      },
      set: function set(v) {
        this.is_all_selected = v;
      }
    },
    userEntitiesDetails: {
      get: function get() {
        return this.user_entities_details;
      },
      set: function set(v) {
        this.user_entities_details = v;
      }
    },
    defaultPasscode: function defaultPasscode() {
      if (this.userEntitiesDetails.indexOf("TB") > -1 || this.userEntitiesDetails.indexOf("MHTB") > -1) {
        return "mizuho2016";
      } else if (this.userEntitiesDetails.indexOf("IR") > -1 || this.userEntitiesDetails.indexOf("MHIR") > -1) {
        return "";
      } else {
        return "mizuho2006";
      }
    },

    formOutputText: {
      get: function get() {
        if (this.formOutputQty > 0) {
          return this.form_output_text + " (" + this.formOutputQty + ")";
        } else {
          return this.form_output_text;
        }
      },
      set: function set(v) {
        this.form_output_text = v;
      }
    },
    formOutputQty: {
      get: function get() {
        return this.form_output_qty;
      },
      set: function set(v) {
        this.form_output_qty = v;
      }
    },

    allFields: function allFields() {
      var _this2 = this;

      var arr = [];

      if (typeof this.formFields != "undefined") {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.formFields).forEach(function (k) {
          _this2.formFields[k].forEach(function (f) {
            arr.push(f);
          });
        });
      } else if (typeof this.tabFieldList != "undefined") {
        this.tabFieldList.forEach(function (f) {
          arr.push(f);
        });
      }

      return arr;
    },

    totalNumberOfRows: {
      get: function get() {
        return this.total_number_of_rows;
      },
      set: function set(v) {
        this.total_number_of_rows = v;
      }
    },
    pageContainerSize: {
      get: function get() {
        var s = this.local_page_container_size_reload > -1 ? localStorage.getItem("pageContainerSize") : false;
        if (s) {
          return "container_" + s;
        } else {
          return "container_auto";
        }
      },
      set: function set(v) {
        this.local_page_container_size_reload++;
      }
    },

    aclAllowBrowse: function aclAllowBrowse() {
      return this.page_acl.browse.indexOf(this.user_type) > -1;
    },
    aclAllowAdd: function aclAllowAdd() {
      return this.page_acl.add.indexOf(this.user_type) > -1;
    },
    aclAllowEdit: function aclAllowEdit() {
      return this.page_acl.edit.indexOf(this.user_type) > -1;
    },
    aclAllowSave: function aclAllowSave() {
      return this.page_acl.save.indexOf(this.user_type) > -1;
    },
    aclAllowDelete: function aclAllowDelete() {
      return this.page_acl.delete.indexOf(this.user_type) > -1;
    },
    acl: function acl() {
      return __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].acl;
    },
    permissionMode: function permissionMode() {
      return __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].PERMISSION_MODE;
    },
    installedFieldList: function installedFieldList() {
      var list = {};
      var arr = [];
      var local_form_fields = this.formFields;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(local_form_fields).forEach(function (k) {
        var col = local_form_fields[k];
        col.forEach(function (f) {
          list[f.id] = f;
          arr.push(f);
        });
      });
      list.array = arr;
      return list;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.user_type = parseInt(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get('userType'));
    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$on("on_insert_rule", function (data) {
      var rule = data.rule[0];
      var value = data.value;
      if (rule.rule == "copy") {
        var obj = {};
        obj[rule.vkey] = value;

        _this3.$ajax.post(rule.source_api, obj, function (err, result) {
          if (result) {
            rule.fields.forEach(function (e) {
              if (typeof result[e.from] != "undefined" && result[e.from] && __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(result, [e.from], "").length > 0) {
                debug_pageCommon("SETTING", _this3.$store.state[_this3.stateCurrentRow][e.to]);
                __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit(e.to, result[e.from]);
              }
            });
          }
        });
      } else {
        console.log("on_insert_rule UNKNOWN rule ", rule);
      }
    });
    if (this.execute_filter_on_back == true) {
      var lfo = this.$store.state[this.stateLastFilterOptions][this.api_name];
      this.executing_filter_on_back = false;
      if (lfo && typeof lfo != "undefined") {
        if (typeof lfo.filter != "undefined" && lfo.filter != false) {
          this.$store.state.search_data = {};
          if (lfo.filter["1"] && lfo.filter["1"].value && lfo.filter["1"].value.length > 0) {
            this.$store.state.search_data["1"] = lfo.filter["1"];
            this.executing_filter_on_back = true;
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: lfo.filter["1"].field, val: lfo.filter["1"].value });
            }, 100);
          }
          if (lfo.filter["2"] && lfo.filter["2"].value && lfo.filter["2"].value.length > 0) {
            this.$store.state.search_data["2"] = lfo.filter["2"];
            this.executing_filter_on_back = true;
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onOpenPageFilter2", { field: lfo.filter["2"].field, val: lfo.filter["2"].value });
            }, 100);
          }
          if (lfo.filter["3"] && lfo.filter["3"].value && lfo.filter["3"].value.length > 0) {
            this.$store.state.search_data["3"] = lfo.filter["3"];
            this.executing_filter_on_back = true;
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onOpenPageFilter3", { field: lfo.filter["3"].field, val: lfo.filter["3"].value });
            }, 100);
          }
          if (lfo.filter["j1"] && lfo.filter["j1"] && lfo.filter["j1"].length > 0) {
            this.$store.state.search_data["j1"] = lfo.filter["j1"];
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onOpenPageFilterJoin1", lfo.filter["j1"]);
            }, 100);
          }
          if (lfo.filter["j2"] && lfo.filter["j2"] && lfo.filter["j2"].length > 0) {
            this.$store.state.search_data["j2"] = lfo.filter["j2"];
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onOpenPageFilterJoin2", lfo.filter["j2"]);
            }, 100);
          }
        }
        if (typeof lfo.sort != "undefined" && lfo.sort != false) {
          this.last_data_source_sort = lfo.sort;
        }
        if (typeof lfo.sort_key != "undefined" && lfo.sort_key != false) {
          this.last_data_source_sort_key = lfo.sort_key;
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    var userEntitiesDetails = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userEntitiesDetails");
    if (userEntitiesDetails && userEntitiesDetails.length > 0) {
      userEntitiesDetails = JSON.parse(userEntitiesDetails);
      this.userEntitiesDetails = userEntitiesDetails;
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$off("on_insert_rule");
    this.local_fields_ref = {};
    this.executing_filter_on_back = false;
  },

  methods: {
    loadSelectedApprovalHistory: function loadSelectedApprovalHistory() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'selected_approval_history';

      var selected_approval_history = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get(name) || [];
      try {
        selected_approval_history = JSON.parse(selected_approval_history);
      } catch (error) {
        selected_approval_history = [];
      }
      if (Array.isArray(selected_approval_history) == false) {
        selected_approval_history = [];
      }
      return selected_approval_history;
    },
    clearSearchFields: function clearSearchFields() {
      __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onSearchClear", "");
    },
    commonAllChecked: function commonAllChecked(alert_tag) {
      var _this4 = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var limit = 100;
      setTimeout(function () {
        if (_this4.checkBoxSelectAll == false) {
          _this4.gridOptions.api.forEachNode(function (node) {
            if (_this4.hideCheckBox(node.data) == false) {
              node.data.is_selected = false;
            }
          });
          if (cb) {
            cb(null, 0);
          }
        } else {
          if (_this4.totalNumberOfRows > 100) {
            __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit(alert_tag, {
              icon: "glyphicon glyphicon-alert",
              message: "1度に選択できるレコードは100件までです。<br>100件以上の処理を行う場合は先に選択済みの100件を処理した後、再度選択してください。",
              yes_label: "OK",
              yes_color: "danger",
              model_height: "50"
            });
            if (cb) {
              cb(null, 100);
            }
          }
          var count = 0;
          _this4.gridOptions.api.forEachNode(function (node) {
            if (_this4.hideCheckBox(node.data) == false) {
              if (limit > 0) {
                count++;
                node.data.is_selected = true;
              }
              limit--;
            }
          });
          if (cb) {
            cb(null, count);
          }
        }
        _this4.onReprocessIsSelectedClickDatasource({});
      }, 100);
    },
    getFieldLastValue: function getFieldLastValue(field_id) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return this.$store.state[this.stateCurrentEditing][field_id] || this.$store.state[this.stateCurrentRow][field_id] || def;
    },
    isMultiCompanyAdminByArray: function isMultiCompanyAdminByArray(array_or_roles) {
      var ret = false;
      array_or_roles.forEach(function (role) {
        if (role == "保守担当" || role == "システム管理者") {
          ret = true;
        }
      });
      return ret;
    },
    isObject: function isObject(val) {
      if (val === null || val === null) {
        return false;
      }
      return (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(val).length > 0;
    },
    checkUserPermission: function checkUserPermission(page_acl, permission) {
      var requester = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      if (page_acl == null || page_acl == true) {
        page_acl = this.page_acl;
      }
      return __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].check_user_permission(page_acl, permission, requester);
    },
    hasHtmlClass: function hasHtmlClass(ele, cls) {
      return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
    },
    addHtmlClass: function addHtmlClass(ele, cls) {
      if (!this.hasHtmlClass(ele, cls)) ele.className += " " + cls;
    },
    removeHtmlClass: function removeHtmlClass(ele, cls) {
      if (this.hasHtmlClass(ele, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        ele.className = ele.className.replace(reg, ' ');
      }
    },
    singleSearchCreate: function singleSearchCreate(field, val) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "input";

      return {
        1: {
          block: "1",
          field: field,
          value: val,
          ct: "v",
          ca: false,
          t: type,
          exact_value: true
        },
        2: false,
        3: false,
        b2_disabled: false,
        b3_disabled: true,
        j1: "AND",
        j2: "AND"
      };
    },
    doubleAndSearchCreate: function doubleAndSearchCreate(field1, val1, field2, val2) {
      var type1 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "input";
      var type2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "input";

      return {
        1: {
          block: "1",
          field: field1,
          value: val1,
          ct: "v",
          ca: false,
          t: type1,
          exact_value: true
        },
        2: {
          block: "2",
          field: field2,
          value: val2,
          ct: "v",
          ca: false,
          t: type2,
          exact_value: true
        },
        3: false,
        b2_disabled: false,
        b3_disabled: true,
        j1: "AND",
        j2: "AND"
      };
    },
    commonCreateColumnDefs: function commonCreateColumnDefs(_ref) {
      var _this5 = this;

      var show_details = _ref.show_details,
          show_checkbox = _ref.show_checkbox,
          field_list_name = _ref.field_list_name,
          _ref$force_sort = _ref.force_sort,
          force_sort = _ref$force_sort === undefined ? false : _ref$force_sort;

      var arr = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.clone(this.defaultCreateColumn);
      if (force_sort != false) {
        arr.forEach(function (e) {
          delete e.sort;
        });
      }
      var i = 0;
      if (typeof field_list_name == "undefined") {
        field_list_name = "tabFieldList";
      }
      this[field_list_name].forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.suppressSorting == true) {
          fi.suppressSorting = true;
        }
        if (force_sort != false) {
          if (force_sort.id == fi.field) {
            fi.sort = force_sort.direction;
            _this5.last_data_source_sort = [{
              colId: fi.field,
              sort: force_sort.direction
            }];
          }
        }
        if (f.type == "date_picker") {
          fi.cellRenderer = function (params) {
            return __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].format_date(params.value);
          };
        } else if (f.type == "select") {
          fi.cellRenderer = function (params) {
            if (f.table_field_style && __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.size(f.table_field_style) > 0) {
              return "<span style='" + f.table_field_style[params.value] + "'>" + params.value + "</span>";
            } else {
              return params.value;
            }
          };
        } else if (f.type == "select2") {
          fi.cellRenderer = function (params) {
            var found = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(f.options, function (d) {
              return params.value == d.value;
            });
            var ret = "";
            if (found && typeof found != "undefined") {
              ret = found.label;
            } else {
              ret = params.value;
            }
            if (f.table_field_style && __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.size(f.table_field_style) > 0 && typeof f.table_field_style[params.value] != "undefined") {
              return "<span style='" + f.table_field_style[params.value] + "'>" + ret + "</span>";
            } else {
              return ret;
            }
          };
        } else if (f.type == "select4" && typeof f.api_tab_label != "undefined") {
          fi.cellRenderer = function (params) {
            if (typeof f.api_complement_array != "undefined" && Array.isArray(f.api_complement_array)) {
              var found = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(f.api_complement_array, function (d) {
                return params.value == d[f.api_field_name];
              });
              if (found && found[f.api_tab_label]) {
                return found[f.api_tab_label];
              }
            }
            return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(params, "data." + f.api_tab_label, params.value) || params.value;
          };
        } else if (f.type == "datetime_picker" || f.type == "date_picker" || f.type == "current_time") {
          fi.cellRenderer = function (params) {
            return __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].format_date_time(params.value);
          };
        } else if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        if (_this5.cellStyle) {
          fi.cellStyle = _this5.cellStyle;
        }
        arr.push(fi);
      });
      var extra_fields = [];
      if (show_details == true) {
        extra_fields.push(this.fieldList.more_details);
      }
      if (show_checkbox == true) {
        extra_fields.push(this.fieldList.button_options);
      }

      extra_fields.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: function cellRenderer(params) {
            if (params.column.colId == "more_details") {
              return _this5.createGridTextButton(_this5.show_details_label || "詳細", "color: #5b9bd5;", _this5.onDetailsClick, params.data);
            }
            if (params.column.colId == "button_options") {
              if (_this5.hideCheckBox) {
                if (_this5.hideCheckBox(params.data) == true) {
                  return "";
                }
              }
              return _this5.createGridButton("glyphicon glyphicon glyphicon-unchecked", "color: #5b9bd5;", function (ev, selected_row) {
                if (_this5.hideCheckBox) {
                  if (_this5.hideCheckBox(params.data) == true) {
                    return;
                  }
                }
                _this5.onSelectedClickDatasource(ev, selected_row);
              }, params.data);
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    },
    validationRestriction: function validationRestriction(data) {
      this.validationRestrictionList[data.id] = data;
    },
    setHighLevelDebug: function setHighLevelDebug(key, label, text) {
      this.highLevelDebug[key] = { label: label, text: text };
    },
    cleanHighLevelDebug: function cleanHighLevelDebug(key) {
      delete this.highLevelDebug[key];
    },
    cleanAllHighLevelDebug: function cleanAllHighLevelDebug() {
      this.highLevelDebug = {};
    },
    customSort: function customSort(valueA, valueB, nodeA, nodeB, isInverted) {
      if (isNaN(valueA) == false && isNaN(valueB) == false) {
        return parseInt(valueA) > parseInt(valueB) ? 1 : -1;
      } else {
        return ('' + valueA).localeCompare(valueB, { numeric: true, sensitivity: 'base' });
      }
    },
    searchControlChanged: function searchControlChanged(d) {
      var _this6 = this;

      if (this.clearSelections) {
        this.clearSelections();
      }

      var filter_count = 0;
      var proc1 = false;
      var proc2 = false;
      var proc3 = false;
      if (d[1] != false && d[1].value && d[1].value != "") {
        filter_count++;
        proc1 = true;
      }
      if (d.b2_disabled == false && d[2] != false && d[2].value && d[2].value != "") {
        filter_count++;
        proc2 = true;
      }
      if (d.b3_disabled == false && d[3] != false && d[3].value && d[3].value != "") {
        filter_count++;
        proc3 = true;
      }

      var R_INIT = 0;
      var R_FOUND = 1;
      var R_NOT_FOUND = 3;
      var d_j1 = d.j1;
      var d_j2 = d.j2;
      if (filter_count > 0) {

        if (d.b2_disabled == true) {
          d_j1 = "DISABLED";
        }
        if (d.b3_disabled == true) {
          d_j2 = "DISABLED";
        }
        this.gridOptions.api.forEachNode(function (node) {
          var found = false;
          var foundA = false;
          var foundB = false;
          var found1 = R_INIT;
          var found2 = R_INIT;
          var found3 = R_INIT;

          if (proc1) {
            if (node.data[d[1].field]) {
              if (d[1].t != "select" && node.data[d[1].field].indexOf(d[1].value) > -1) {
                found1 = R_FOUND;
              } else if (d[1].t == "select" && node.data[d[1].field] == d[1].value) {
                found1 = R_FOUND;
              } else {
                found1 = R_NOT_FOUND;
              }
            } else if (d[1].value == _this6.SELECTED_EMPTY_SELECT_BOX && (node.data[d[1].field] == "" || node.data[d[1].field] == null || node.data[d[1].field] == false)) {
              found1 = R_FOUND;
            }
          }
          if (proc2) {
            if (node.data[d[2].field]) {
              if (d[2].t != "select" && node.data[d[2].field].indexOf(d[2].value) > -1) {
                found2 = R_FOUND;
              } else if (d[2].t == "select" && node.data[d[2].field] == d[2].value) {
                found2 = R_FOUND;
              } else {
                found2 = R_NOT_FOUND;
              }
            } else if (d[2].value == _this6.SELECTED_EMPTY_SELECT_BOX && (node.data[d[2].field] == "" || node.data[d[2].field] == null || node.data[d[2].field] == false)) {
              found2 = R_FOUND;
            }
          }
          if (proc3) {
            if (node.data[d[3].field]) {
              if (d[3].t != "select" && node.data[d[3].field].indexOf(d[3].value) > -1) {
                found3 = R_FOUND;
              } else if (d[3].t == "select" && node.data[d[3].field] == d[3].value) {
                found3 = R_FOUND;
              } else {
                found3 = R_NOT_FOUND;
              }
            } else if (d[3].value == _this6.SELECTED_EMPTY_SELECT_BOX && (node.data[d[3].field] == "" || node.data[d[3].field] == null || node.data[d[3].field] == false)) {
              found3 = R_FOUND;
            }
          }

          if (proc2 == false && proc3 == false) {
            found = found1 == R_FOUND;
          }

          if (proc2 == true && d_j1 != "DISABLED") {
            if (d_j1 == "AND") {
              if (found1 != R_INIT && found2 != R_INIT) {
                foundA = found1 == R_FOUND && found2 == R_FOUND;
              }
            } else if (d_j1 == "OR") {
              if (found1 != R_INIT || found2 != R_INIT) {
                foundA = found1 == R_FOUND || found2 == R_FOUND;
              }
            }
            found = foundA;
          }
          if (proc3 == true && d_j2 != "DISABLED") {
            if (d_j2 == "AND") {
              if (found2 != R_INIT && found3 != R_INIT) {
                foundB = found3 == R_FOUND && foundA == true;
              }
            } else if (d_j2 == "OR") {
              if (foundA == true) {
                foundB = true;
              } else {
                if (found3 != R_INIT) {
                  foundB = found3 == R_FOUND;
                }
              }
            }
            found = foundB;
          }

          if (typeof node != "undefined" && typeof node.data != "undefined") {
            node.data.search_control = found;
          }
        });
      } else {
        console.log("Will not filter");
        this.gridOptions.api.forEachNode(function (node) {
          if (typeof node != "undefined" && typeof node.data != "undefined") {
            node.data.search_control = true;
          }
        });
      }
      this.applyFilterOnSearchControl();
    },
    applyFilterOnSearchControl: function applyFilterOnSearchControl() {
      var filterComponent = this.gridOptions.api.getFilterInstance("search_control");
      if (typeof filterComponent == "undefined") {
        return;
      }
      var model = filterComponent.getModel();
      filterComponent.setModel({ type: 'equals', filter: true });
      filterComponent.onFilterChanged();
    },
    autoSizeAll: function autoSizeAll() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.is_auto_sized == false || force == true) {
        this.is_auto_sized = true;
        var allColumnIds = [];
        this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
          if (column.visible && column.colId != "more_details" && column.colId != "button_options") {
            allColumnIds.push(column.colId);
          }
        });
        console.log("autoSizeAll do");
        this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
      }
    },
    checkForFilters: function checkForFilters() {
      if (this.is_first_load) {
        this.is_first_load = false;
      }
    },
    listOfFields: function listOfFields() {
      var list = [];
      this.formFieldsCol1.forEach(function (d) {
        list.push(d);
      });
      this.formFieldsCol2.forEach(function (d) {
        list.push(d);
      });
      this.formFieldsCol3.forEach(function (d) {
        list.push(d);
      });
      if (this.formFieldsCol4) {
        this.formFieldsCol4.forEach(function (d) {
          list.push(d);
        });
      }
      return list;
    },
    checkRequiredFields: function checkRequiredFields(fields, required_fields) {
      var _this7 = this;

      debug_pageCommon("checkRequiredFields", fields, required_fields);
      var ready = true;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        if (required_fields) {
          required_fields.forEach(function (f) {
            if (typeof _this7.$store.state[_this7.stateCurrentEditing][f] == "undefined") {
              debug_pageCommon("checkRequiredFields failed", f);
              _this7.$notify({
                title: "登録を行うためには、「" + fields[f].label + "」の入力が必要です",
                type: "error",
                duration: 5000
              });
              ready = false;
            }
          });
        }
      }
      return ready;
    },
    btnAddNew: function btnAddNew() {
      var _this8 = this;

      var ignore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var new_vals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.validationRestrictionList = {};
      this.$store.state[this.stateIsEditingNew] = true;
      this.$store.state[this.stateCurrentRow] = {};
      this.$store.state[this.stateCurrentEditing] = {};
      this.listOfFields().forEach(function (d) {
        if (ignore.indexOf(d.id) < 0) {
          debug_pageCommon("btnAddNew", d.id);
          _this8.$store.state[_this8.stateCurrentRow][d.id] = "";
          delete _this8.$store.state[_this8.stateCurrentEditing][d.id];
        }
        if (d.id == "entity") {
          var userEntitiesDetails = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userEntitiesDetails");
          if (userEntitiesDetails && userEntitiesDetails.length > 0) {
            userEntitiesDetails = JSON.parse(userEntitiesDetails);
          }
          _this8.$store.state[_this8.stateCurrentRow][d.id] = userEntitiesDetails[0] || "";
          _this8.$store.state[_this8.stateCurrentEditing][d.id] = userEntitiesDetails[0] || "";
        }
      });
      this.$store.state[this.stateCurrentRow]["seq_id"] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
      if (new_vals != false) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(new_vals).forEach(function (k) {
          _this8.$store.state[_this8.stateCurrentRow][k] = new_vals[k];
          _this8.$store.state[_this8.stateCurrentEditing][k] = new_vals[k];
        });
      }
      this.btnSetReadOnly(false);
      this.selected_row = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
    },
    btnEditBatch: function btnEditBatch() {
      var _this9 = this;

      var allow_only = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.$store.state[this.stateIsEditingNew] = true;
      this.$store.state.is_editing_batch = true;
      this.$store.state[this.stateCurrentRow] = {};
      this.listOfFields().forEach(function (d) {
        if (allow_only.indexOf(d.id) > -1) {
          debug_pageCommon("btnAddNew", d.id);
          _this9.$store.state[_this9.stateCurrentRow][d.id] = "";
          delete _this9.$store.state[_this9.stateCurrentEditing][d.id];
        }
      });
      this.$store.state[this.stateCurrentRow]["seq_id"] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a - 10;
      this.btnSetReadOnly(false);
      this.selected_row = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a - 10;
    },
    disableButton: function disableButton(name) {

      switch (name) {
        case "tsuika":
          if (!this.aclAllowAdd) {
            return true;
          }
          return this.readOnly == false;
          break;
        case "shusei":
          if (!this.aclAllowEdit) {
            return true;
          }
          return this.selected_row == -1 || this.readOnly == false;
          break;
        case "toroku":
          if (!this.aclAllowSave) {
            return true;
          }
          return this.selected_row == -1 || this.readOnly == true;
          break;
        case "delete":
          if (!this.aclAllowSave) {
            return true;
          }
          return this.selected_row == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a || this.selected_row == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a - 10 || this.selected_row == -1 || this.readOnly == true;
          break;
        case "cancel":
          return this.selected_row == -1;
          break;
        default:
          return false;
          break;
      }
    },
    btnSetReadOnly: function btnSetReadOnly(mode) {
      this.read_only = mode;
    },
    createGridButton: function createGridButton(icon, style, onClick, row_data) {
      var center = document.createElement('center');
      var btn = document.createElement('button');

      btn.className = "btn btn-link btn-xs";
      btn.innerHTML = '<center><span class="' + icon + '" style="' + style + '" aria-hidden="true"></span></center>';
      btn.addEventListener('click', function (ev) {
        onClick(ev, row_data);
      });
      center.appendChild(btn);
      return center;
    },
    createGridTextButton: function createGridTextButton(text, style, onClick, row_data) {
      var center = document.createElement('center');
      var btn = document.createElement('button');

      btn.className = "btn btn-link btn-xs";
      btn.innerHTML = '<center><span style="' + style + '" aria-hidden="true">' + text + '</span></center>';
      btn.addEventListener('click', function (ev) {
        onClick(ev, row_data);
      });
      center.appendChild(btn);
      return center;
    },
    selectSeqId: function selectSeqId(seq_id, retry) {
      var _this10 = this;

      setTimeout(function () {
        var found = false;
        _this10.gridOptions.api.refreshView();
        _this10.gridOptions.api.forEachNode(function (node) {
          if (node.data && node.data.seq_id == seq_id) {
            found = true;
            _this10.gridOptions.api.ensureIndexVisible(node.childIndex);
            _this10.gridOptions.api.selectNode(node, true);
            node.setSelected(true);
          }
        });
        if (found == false) {
          if (retry > 0) {
            _this10.selectSeqId(seq_id, retry - 1);
          }
        }
      }, 50);
    },
    refreshNewRow: function refreshNewRow(result, mode) {
      this.$store.state[this.stateIsEditingNew] = false;
      if (this.load_mode == "all") {
        this.row_data.push(result);
        this.gridOptions.api.refreshView();
        this.selectSeqId(result.seq_id, 3);
      } else {
        this.refreshNewRowDatasource(result, mode);
      }
    },
    refreshDeletedRow: function refreshDeletedRow(id) {
      this.$store.state[this.stateIsEditingNew] = false;
      debug_pageCommon("refreshDeletedRow", id);

      var selectedData = this.gridOptions.api.getSelectedRows();
      this.cancelCurrentSelection(false);
      var res = this.gridOptions.api.updateRowData({ remove: selectedData });

      var removed = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.remove(this.row_data, { seq_id: id });
      var found = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(this.row_data, { seq_id: id });

      debug_pageCommon("refreshDeletedRow removed", removed, "found", found, "res", res);

      this.gridOptions.api.refreshView();
    },
    refreshRow: function refreshRow(result) {
      var show_diff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      debug_pageCommon("refreshRow", result, show_diff);
      this.$store.state[this.stateIsEditingNew] = false;
      var diff = [];

      if (this.load_mode == "all") {
        var len = this.row_data.length;
        for (var i = 0; i < len; i++) {
          if (this.row_data[i].seq_id == result.seq_id) {
            for (var key in result) {
              if (result[key] != this.row_data[i][key]) {
                if (show_diff) {
                  diff.push(key);
                }
                this.row_data[i][key] = result[key];
              }
            }
          }
        }
      } else {
        this.gridOptions.api.forEachNode(function (node) {
          if (node.data && node.data.seq_id == result.seq_id) {
            for (var key in result) {
              if (result[key] != node.data[key]) {
                if (show_diff) {
                  diff.push(key);
                }
                node.data[key] = result[key];
              }
            }
          }
        });
      }
      this.data_values_original = result;
      this.$store.state[this.stateCurrentRow] = result;

      this.data_values = result;

      this.gridOptions.api.refreshView();
      if (show_diff) {
        return diff;
      }
    },
    cancelCurrentSelectEdition: function cancelCurrentSelectEdition() {
      var showCanceledToast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


      this.gridOptions.suppressRowClickSelection = false;
      this.$store.state[this.stateIsEditingNew] = false;
      this.read_only = true;
      if (showCanceledToast) {
        this.$notify({
          title: 'キャンセルしました',
          type: 'info',
          duration: 1000
        });
      }
    },
    cancelCurrentSelection: function cancelCurrentSelection() {
      var _this11 = this;

      var showCanceledToast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.validationRestrictionList = {};

      this.$store.state[this.stateIsEditingNew] = false;
      this.selected_row = -1;
      this.read_only = true;
      if (!(this.gridOptions && this.gridOptions.api)) {
        return;
      }
      this.gridOptions.api.forEachNode(function (node) {
        if (node.isSelected()) {
          node.setSelected(false);
          for (var key in _this11.$store.state[_this11.stateCurrentRow]) {
            _this11.$store.state[_this11.stateCurrentRow][key] = "";
          }
          _this11.$store.state[_this11.stateCurrentRow] = {};
          if (showCanceledToast) {
            _this11.$notify({
              title: 'キャンセルしました',
              type: 'info',
              duration: 1000
            });
          }
        }
      });
    },
    cleanUpForm: function cleanUpForm(vm) {
      vm.$store.state[vm.stateCurrentEditing] = [];
      vm.data_values = {};
    },

    commonOnRowSelected: function commonOnRowSelected(vm, ev, mode) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      vm.validationRestrictionList = {};
      debug_pageCommon("common OnRowSelected", vm.lock_grid);
      if (vm.lock_grid == true) {
        return false;
      }
      if (ev.node && ev.node.isSelected() && ev.node.data) {
        vm.cleanUpForm(vm);
        vm.$store.state[_this12.stateIsEditingNew] = false;
        vm.$ajax.post('/' + mode + '/get/' + ev.node.data.seq_id, {}, function (err, result) {
          if (err) {
            if (err == "Not logged") {
              vm.$notify({
                title: 'セッションの有効期限が切れましたので、もう一度ログインを行ってください',
                type: 'error',
                duration: 10000
              });
            } else {
              vm.$notify({
                title: 'データの読込に失敗しました。',
                type: 'error',
                duration: 10000
              });
            }
          } else {
            vm.data_values = result.data;
            vm.data_values_original = result.data;
            vm.$store.state[vm.stateCurrentRow] = result.data;
            vm.selected_row = result.data.seq_id;
            vm.btnSetReadOnly(true);
            return cb(vm);
          }
        });
      }
    },
    saveBulk: function saveBulk(api_name, seq_id_list) {
      var _this13 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments[3];

      var new_vals = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.fieldList).forEach(function (k) {
        if (_this13.$store.state[_this13.stateCurrentEditing][k] && ("" + _this13.$store.state[_this13.stateCurrentEditing][k]).length > 0) {
          new_vals[k] = _this13.$store.state[_this13.stateCurrentEditing][k];
        }
      });
      if (options && Array.isArray(options.disabled_fields) && options.disabled_fields.length > 0) {
        options.disabled_fields.forEach(function (k) {
          delete new_vals[k];
        });
      }
      this.$ajax.post('/' + api_name + '/save_bulk/', {
        changes: new_vals,
        seq_id_list: seq_id_list,
        from_edit_form: options.from_edit_form || false
      }, function (err, result, error_code) {
        console.log("saveBulk ERROR", { err: err, result: result, error_code: error_code });
        _this13.$notify({ clear: true });
        if (err) {
          _this13.$notify({ clean: true });
          var title = "予期しないエラーが発生し、登録が行えません";
          if (err && err.indexOf("::") == 0) {
            title = err.replace("::", "");
            err = "";
          }
          _this13.$notify({ clean: true });
          var obj = {
            title: title,
            text: err,
            type: 'error',
            duration: 10000
          };
          _this13.$notify(obj);
          return cb(err);
        } else {
          _this13.$notify({
            title: '保存しました!',
            type: 'success',
            duration: 2000
          });
          return cb(null);
        }
      });
    },

    commonEditDeleteCmdHandler: function commonEditDeleteCmdHandler(vm) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (vm.$route && vm.$route.params) {
        if (vm.$route.params.cmd == "edit") {
          setTimeout(function () {
            vm.read_only = false;
            cb();
          }, 300);
        } else if (vm.$route.params.cmd == "delete") {
          setTimeout(function () {
            vm.onDelete();
            cb();
          }, 100);
        } else {
          cb();
        }
        console.log("CMD IN", vm.$route.params.cmd);
      } else {
        cb();
      }
    },
    commonLoadRecord: function commonLoadRecord(options) {
      var _this14 = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (this.$route.params.seq_id == "new" || options.force_seq_id == "new") {
        this.local_seq_id = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
        this.$store.state[this.stateCurrentRow] = {
          seq_id: this.local_seq_id
        };
        this.allFields.forEach(function (f) {
          _this14.$store.state[_this14.stateCurrentRow][f.id] = "";
        });
        setTimeout(function () {
          _this14.$store.state[_this14.stateIsEditingNew] = true;
          _this14.read_only = false;
          _this14.is_new = true;
        }, 300);
        debug_pageCommon("mounted as new");
        return cb(null, {});
      } else {
        this.is_new = false;
        this.local_seq_id = options.force_seq_id || this.$route.params.seq_id;
        if (typeof this.local_seq_id == "undefined") {
          console.error('UNEXPECTED REQUEST TO URL: ', '/' + this.api_name + '/get/' + this.local_seq_id);
          console.trace('UNEXPECTED REQUEST TO URL: ', '/' + this.api_name + '/get/' + this.local_seq_id);
        }
        this.$ajax.post('/' + this.api_name + '/get/' + this.local_seq_id, {}, function (err, result) {
          if (err) {
            _this14.$notify({
              title: 'データの読込に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          } else if (_this14.isObject(result) == false) {
            _this14.$notify({
              title: 'データの読込に失敗しました。',
              text: "Returned empty data",
              type: 'error',
              duration: 10000
            });
          }
          _this14.$store.state[_this14.stateCurrentRow] = result.data;

          _this14.commonSetStyleForChangedFields(result.data);

          debug_pageCommon("LOAD DATA RECORD", { err: err, result: result });
          return cb(err, result);
        });
      }
    },
    commonSetStyleForChangedFields: function commonSetStyleForChangedFields(data) {
      if (typeof data["last_changed_fields"] == "string" && data["last_changed_fields"].length > 0) {
        var last_changed_fields = data["last_changed_fields"].split(",");
        var store_key_name = this.stateCurrentRow.replace("current_row", "current_field_style");

        this.processFieldStyle(store_key_name, last_changed_fields);
      }
    },
    commonOnEdit: function commonOnEdit() {
      var _this15 = this;

      this.$store.state[this.stateCurrentEditing] = {};
      setTimeout(function () {
        _this15.read_only = false;
      }, 300);
    },
    commonValidateFieldsClear: function commonValidateFieldsClear(vm, cb) {
      var working_field_list = vm.fieldList;
      if (vm.installedFieldList) {
        working_field_list = vm.installedFieldList;
      }
      working_field_list.array.forEach(function (f) {
        if (f.error_if_blank == true) {
          working_field_list[f.id].on_field_messages(vm, { msg_type: "error", show_as_error_mode: false }, function () {});
        }
      });
      cb();
    },
    commonValidateFields: function commonValidateFields(vm, options, cb) {

      if (this.fields_validation_is_disabled == true) {
        return cb(false);
      }
      var ignoreFieldValidation = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("forceIgnoreFieldValidation") || 0;
      if (ignoreFieldValidation == "12349856") {
        return cb(false);
      }
      var pre_defined_errors = [];
      if (options && options.pre_defined_errors && options.pre_defined_errors.length > 0) {
        pre_defined_errors = options.pre_defined_errors;
      }
      var working_field_list = vm.fieldList;
      if (vm.installedFieldList) {
        working_field_list = vm.installedFieldList;
      } else {}
      var seq_id = vm.$store.state[vm.stateCurrentRow].seq_id;
      var is_editing = false;
      if (seq_id != __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a && seq_id != "new") {
        is_editing = true;
      }
      var array_err = [];

      __WEBPACK_IMPORTED_MODULE_19_async___default.a.mapLimit(working_field_list.array, 1, function (f, done) {
        if (f.error_if_blank == true) {
          var val = vm.$store.state[vm.stateCurrentEditing][f.id] || vm.$store.state[vm.stateCurrentRow][f.id];
          if (is_editing) {
            val = vm.$store.state[vm.stateCurrentEditing][f.id];
            if (typeof val == "undefined") {
              val = vm.$store.state[vm.stateCurrentRow][f.id];
            }
          }
          if (f.type == "email") {
            if (__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].if_null(val) == "") {} else if (val.indexOf("@") < 0) {
              val = "";
            } else if (val.split("@").length != 2) {
              val = "";
            } else if (__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].if_null(val.split("@")[0]) == "") {
              val = "";
            } else if (__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].if_null(val.split("@")[1]) == "") {
              val = "";
            }
          }
          if (f.type == "input" && f.field_type == "number") {
            if (f.type == "input" && f.field_type == "number" && isNaN(val)) {
              val = "";
            } else if (f.type == "input" && f.field_type == "number" && typeof f.min_value != "undefined") {
              if (parseInt(val) < parseInt(f.min_value)) {
                val = "";
              }
            }
          }

          if (__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].if_null(val) == "" && typeof val != "number") {
            if (working_field_list[f.id].on_field_messages) {
              working_field_list[f.id].on_field_messages(vm, { msg_type: "error", show_as_error_mode: true, only_if_enabled: true }, function (show) {
                if (show) {
                  array_err.push({ field: f, type: "blank" });
                }
                done();
              });
            } else {
              array_err.push({ field: f, type: "blank" });
              done();
            }
          } else {
            if (working_field_list[f.id].on_field_messages) {
              working_field_list[f.id].on_field_messages(vm, { msg_type: "error", show_as_error_mode: false }, function () {
                done();
              });
            } else {
              done();
            }
          }
        } else {
          if (working_field_list[f.id].on_field_messages) {
            working_field_list[f.id].on_field_messages(vm, { msg_type: "error", show_as_error_mode: false }, function () {
              done();
            });
          } else {
            done();
          }
        }
      }, function (err, allDone) {
        vm.$notify({ clean: true });
        if (pre_defined_errors.length > 0) {
          pre_defined_errors.forEach(function (f) {
            if (working_field_list[f.id].on_field_messages) {
              working_field_list[f.id].on_field_messages(vm, { msg_type: "error", show_as_error_mode: true, only_if_enabled: true }, function () {});
            }
            array_err.push({ field: f, type: "blank" });
          });
        }
        if (array_err.length > 0) {
          var error_field_names = array_err.map(function (m) {
            return m.field.label;
          }).join("/");
          vm.$notify({
            title: error_field_names + ' は入力必須項目になります。',
            type: 'error',
            duration: 10000
          });
        } else {
          return cb(array_err);
        }
      });
    },
    commonSaveIfNotBlank: function commonSaveIfNotBlank(vm, mode, options, field_name_arr) {
      var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

      var has_error = false;
      vm.$notify({ clean: true });
      field_name_arr.forEach(function (field_id) {

        var temp_val = "";
        if (has_error == false) {
          if (vm.is_new) {
            temp_val = vm.$store.state[vm.stateCurrentEditing][field_id];
          } else {
            temp_val = vm.$store.state[vm.stateCurrentEditing][field_id];
            if (typeof temp_val == "undefined") {
              temp_val = "-";
            }
          }
          var val = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.trim(__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].if_null(temp_val, ""));
          if (val.length < 1) {
            vm.$notify({
              title: '入力されていない項目があります。',

              type: 'error',
              duration: 10000
            });
            has_error = true;
          }
        }
      });
      if (has_error == false) {
        vm.read_only = false;
        vm.commonSaveInfo(vm, mode, options, cb);
      } else {
        return cb('入力されていない項目があります。');
      }
    },

    commonSaveInfo: function commonSaveInfo(vm, mode) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      debug_pageCommon("save info", vm.values, vm.$store.state[vm.stateCurrentEditing]);
      if (__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(vm.validationRestrictionList, { active: true })) {
        vm.$notify({ clean: true });
        vm.$notify({
          title: 'エラーが表示されている項目を修正してください',
          type: 'error',
          duration: 5000
        });
        return;
      }

      vm.validationRestrictionList = {};
      var changes = __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].copyAllowed(mode, vm.$store.state[vm.stateCurrentEditing]);
      if (changes == false || changes == null || typeof changes == "undefined" || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(changes).length == 0) {
        if (options.ignore_empty_changes == true) {
          return cb();
        }
        vm.$notify({
          title: '保存する変更はありません。',
          type: 'error',
          duration: 5000
        });
      } else {
        var last_changed_uuid = (vm.$store.state[vm.stateCurrentRow].last_changed_uuid || "") + "";
        if (last_changed_uuid.length > 0) {
          changes.last_changed_uuid = last_changed_uuid;
        }
        var method_name = '/set/';
        if (options.use_transaction == true) {
          method_name = '/t_set/';
        }
        vm.$ajax.post('/' + mode + method_name + vm.$store.state[vm.stateCurrentRow].seq_id, {
          changes: changes,
          check_field_size: true,
          form_confirmation: vm.form_confirmation || {},
          from_edit_form: options.from_edit_form == true,
          overwrite_changed_fields: options.overwrite_changed_fields == true,
          approval_id: options.approval_id || null,
          seq_id: vm.$store.state[vm.stateCurrentRow].seq_id
        }, function (err, result, error_code) {
          debug_pageCommon("common SaveInfo", { err: err, result: result });
          vm.$notify({ clean: true });
          if (err) {
            setTimeout(function () {
              vm.$notify({ clean: true });
              var title = "予期しないエラーが発生し、登録が行えません";
              if (err && err.err_type == "invalid_size") {
                var obj = {
                  title: title,
                  text: err.err,
                  type: 'error',
                  duration: 10000
                };
              } else {
                if (err && err.indexOf("::") == 0) {
                  title = err.replace("::", "");
                  err = "";
                }
                vm.$notify({ clean: true });
                var obj = {
                  title: title,
                  text: err,
                  type: 'error',
                  duration: 10000
                };
              }
              console.log("common SaveInfo message", obj);
              vm.$notify(obj);
            }, 50);
          } else {
            if (vm.selected_row == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a) {
              if (typeof result.seq_id != "undefined") {
                vm.refreshNewRow(result, mode);
              } else {
                vm.refreshNewRow(result.data, mode);
              }
            } else {
              vm.$store.state[vm.stateCurrentRow] = result.data;
              if (vm.gridOptions) {
                vm.refreshRow(result.data);
              }
            }

            var title = "編集が完了しました!";
            if (vm.is_new == true) {
              title = "新規登録が完了しました!";
            }

            vm.btnSetReadOnly(true);
            vm.$notify({
              title: title,
              type: 'success',
              duration: 2000
            });
            vm.commonSetStyleForChangedFields(result.data);
          }
          cb(err, result.data || result);
        });
      }
    },
    commonDelete: function commonDelete(vm) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log("commonDelete", vm.api_name);
      vm.$ajax.post('/' + vm.api_name + '/delete/', {
        seq_id: vm.$store.state[vm.stateCurrentRow].seq_id,
        seq_id_match3: vm.$store.state[vm.stateCurrentRow].seq_id * 3
      }, function (err, result, error_code) {
        vm.$notify({ clear: true });
        if (err) {
          var err_msg = "ファイルの削除に失敗しました。";
          if (err.indexOf("::") == 0) {
            err_msg = err.replace("::", "");
          }
          vm.$notify({
            title: err_msg,
            type: 'error',
            duration: 10000
          });
        } else {
          if (cb == false) {
            vm.backToList();
          } else {
            return cb(err, result, vm);
          }
        }
      });
    },
    commonDeleteArr: function commonDeleteArr(vm, arr, cb) {
      if (Array.isArray(arr) == false || arr.length < 1) {
        return;
      }
      arr = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.uniq(arr);
      console.log("commonDeleteArr", vm.api_name);
      vm.$notify({ clear: true });
      vm.$ajax.post('/' + vm.api_name + '/delete_arr/', {
        array: arr,
        array_match3: arr.length * 3
      }, function (err, result, error_code) {
        if (err) {
          var err_msg = "ユーザの削除に失敗しました。削除するユーザを対象に申請されている情報がある可能性があります。";
          if (err.indexOf("::") == 0) {
            err_msg = err.replace("::", "");
          }
          vm.$notify({
            title: err_msg,
            type: 'error',
            duration: 10000
          });
        } else {
          vm.gridOptions.api.purgeInfiniteCache();
          vm.countRows("commonDeleteArr");
          cb();
        }
      });
    },
    getEditingOrCurrentRow: function getEditingOrCurrentRow(state, field_name) {

      if (typeof state[_this12.stateCurrentEditing][field_name] == 'undefined') {
        return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(state[_this12.stateCurrentRow], field_name, "");
      } else {
        return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(state[_this12.stateCurrentEditing], field_name, "");
      }
    }

  }
}, 'beforeDestroy', function beforeDestroy() {
  debug_pageCommon("COMMON beforeDestroy ", this.api_name, this.stateCurrentEditing);
  this.$store.state[this.stateCurrentEditing] = {};
}));

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_errors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);







var debug_pageDatasource = __WEBPACK_IMPORTED_MODULE_6_debug___default()("esma:datasource");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {
      pageDataSource: null,
      state: false,
      last_data_source_sort_key: "",
      last_data_source_sort: false,
      last_data_source_filter_key: "",
      last_data_source_filter: false,
      search_timer: false,
      select_on_load: false,
      select_on_load_position: 0,
      grid_option: false,
      get_rows_count: 0,
      load_only_with_filter: false,
      init_data_source_options: {}
    };
  },

  computed: {
    gridOptions: {
      get: function get() {
        return this.grid_option;
      },
      set: function set(v) {
        this.grid_option = v;
      }
    }
  },
  methods: {
    beforeRouteLeaveFlag: function beforeRouteLeaveFlag() {
      return true;
    },
    beforeRouteLeaveDialog: function beforeRouteLeaveDialog() {
      return true;
    },
    get_def: function get_def(val) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      if (typeof val == "undefined" || val == null || val == false || val == "") {
        return def;
      } else {
        return val;
      }
    },
    clearSelectionsDatasource: function clearSelectionsDatasource() {
      if (!this.gridOptions.api) {
        return;
      }
      this.gridOptions.api.forEachNode(function (node) {
        if (typeof node != "undefined" && typeof node.data != "undefined") {
          if (typeof node.data.is_selected != "undefined") {
            if (node.data.is_selected == true) {
              node.data.is_selected = false;
            }
          }
        }
      });
      this.formOutputQty = 0;
      this.selectAllIcon = "unchecked";
      this.isAllSelected = false;
      this.selectedRowArr = [];
      this.gridOptions.api.refreshView();
    },
    searchByListDatasource: function searchByListDatasource(filter) {
      var filter_key = this.get_def(filter["by_list"]) + "_" + this.get_def(filter["filter_by"]) + "_" + this.get_def(filter["list"]);
      debug_pageDatasource("searchByOneDatasource", filter, filter_key);

      if (filter_key == this.last_data_source_filter_key) {
        return;
      }
      this.last_data_source_filter_key = filter_key;

      this.last_data_source_filter = filter;

      if (this.clearSelectionsDatasource) {
        this.clearSelectionsDatasource();
      }
      this.cancelCurrentSelection(true);
      if (!this.state.gridOptions.api) {
        return;
      }
      var filterComponent = this.state.gridOptions.api.getFilterInstance("search_flow_control");
      var model = filterComponent.getModel();
      filterComponent.setModel({
        type: "contains",
        filter: new Date().getTime()
      });
      filterComponent.onFilterChanged();
      this.state.gridOptions.api.setDatasource(this.pageDataSource);
      this.state.countRows("searchByListDatasource");
    },
    searchByOneDatasource: function searchByOneDatasource(filter) {
      var filter_key = this.get_def(filter["by_one"]) + "_" + this.get_def(filter["filter_by"]) + "_" + this.get_def(filter["one_value"]);
      debug_pageDatasource("searchByOneDatasource", filter, filter_key);

      if (filter_key == this.last_data_source_filter_key) {
        return;
      }
      this.last_data_source_filter_key = filter_key;

      this.last_data_source_filter = filter;

      if (this.clearSelectionsDatasource) {
        this.clearSelectionsDatasource();
      }
      this.cancelCurrentSelection(true);
      if (!this.state.gridOptions.api) {
        return;
      }
      var filterComponent = this.state.gridOptions.api.getFilterInstance("search_flow_control");
      var model = filterComponent.getModel();
      filterComponent.setModel({
        type: "contains",
        filter: new Date().getTime()
      });
      filterComponent.onFilterChanged();
      this.state.gridOptions.api.setDatasource(this.pageDataSource);
      this.state.countRows("searchByOneDatasource");
    },
    onSelectedClickDatasource: function onSelectedClickDatasource(ev, selected_row) {
      var _this = this;

      debug_pageDatasource("on_SelectedClick", selected_row);

      var set_as_selected = 3;
      var select_action = "NA";
      this.gridOptions.api.forEachNode(function (node) {
        if (typeof node != "undefined" && typeof node.data != "undefined") {
          if (typeof node.data.seq_id != "undefined") {
            if (node.data.seq_id == selected_row.seq_id) {
              var row_was_selected = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(_this.selectedRowArr, function (d) {
                return d.seq_id == selected_row.seq_id && set_as_selected == 3;
              });
              var in_arr = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(_this.selectedRowArr, function (d) {
                return d.seq_id == selected_row.seq_id;
              });
              if (row_was_selected || set_as_selected == -1) {
                if (set_as_selected == 3) {
                  set_as_selected = -1;
                }
                node.data.is_selected = false;
                select_action = "uncheck";
                __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].remove(_this.selectedRowArr, function (d) {
                  return d.seq_id == selected_row.seq_id;
                });
              } else {
                if (set_as_selected == 3) {
                  set_as_selected = 1;
                }
                if (!in_arr) {
                  select_action = "check";
                  _this.selectedRowArr.push(selected_row);
                }
                node.data.is_selected = true;
              }
            }
          }
        }
      });
      this.gridOptions.api.refreshView();

      this.formOutputQty = this.selectedRowArr.length;
      if (this.selectedRowArr.length == 0) {
        this.selectAllIcon = "unchecked";
        this.isAllSelected = false;
      } else {
        this.selectAllIcon = "many";
        this.isAllSelected = false;
      }
      if (typeof this.onArraySelected != "undefined") {
        this.onArraySelected({ row: selected_row, select_action: select_action });
      }
    },
    onReprocessIsSelectedClickDatasource: function onReprocessIsSelectedClickDatasource(ev) {
      var _this2 = this;

      var set_as_selected = 3;
      var select_action = "NA";
      this.selectedRowArr = [];
      this.formOutputQty = 0;
      this.gridOptions.api.forEachNode(function (node) {
        if (typeof node != "undefined" && typeof node.data != "undefined") {
          if (typeof node.data.seq_id != "undefined") {
            if (node.data.is_selected == true) {

              _this2.selectedRowArr.push(node.data);
            }
          }
        }
      });
      this.gridOptions.api.refreshView();
      this.formOutputQty = this.selectedRowArr.length;
      if (this.selectedRowArr.length == 0) {
        this.selectAllIcon = "unchecked";
        this.isAllSelected = false;
      } else {
        this.selectAllIcon = "many";
        this.isAllSelected = false;
      }
    },
    emulateSearchControlChangedDatasource: function emulateSearchControlChangedDatasource() {
      var force_clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.last_data_source_filter && force_clear == false) {
        this.searchControlChangedDatasource(this.last_data_source_filter);
      } else {
        this.searchControlChangedDatasource(this.singleSearchCreate("emulate_search_" + __WEBPACK_IMPORTED_MODULE_8_uuid___default.a.v4(), " "));
      }
    },
    searchControlChangedDatasource: function searchControlChangedDatasource(f) {
      var _this3 = this;

      console.log("search ControlChangedDatasource IN ", f);
      if (this.load_mode != "ds") {
        return this.searchControlChanged(f);
      }
      if (this.clearSelectionsDatasource) {
        this.clearSelectionsDatasource();
      }
      this.cancelCurrentSelection(false);


      var cont = false;
      var filter_key = "";
      ["1", "2", "3"].forEach(function (fi) {
        var v = _this3.get_def(f[fi].value);
        var ca = _this3.get_def(f[fi].ca, false);
        var ct = _this3.get_def(f[fi].ct);
        if (v.length > 0 || ca == true || ct == "v") {
          cont = true;
        }
        filter_key += v + "_";
      });
      filter_key += this.get_def(f["b2_disabled"]) + "_" + this.get_def(f["b3_disabled"]) + "_" + this.get_def(f["j1"]) + "_" + this.get_def(f["j2"]);
      debug_pageDatasource("search ControlChangedDatasource", f, filter_key);
      if (this.search_timer) {
        clearTimeout(this.search_timer);
      }
      this.search_timer = setTimeout(function () {
        debug_pageDatasource("search ControlChangedDatasource checking", {
          f: f,
          filter_key: filter_key,
          cont: cont
        });
        if (filter_key != _this3.last_data_source_filter_key && cont == true) {
          debug_pageDatasource("search ControlChangedDatasource PROCESSING", f, filter_key);
          _this3.last_data_source_filter = f;
          if (!_this3.state.gridOptions.api) {
            return;
          }
          var filterComponent = _this3.state.gridOptions.api.getFilterInstance("search_flow_control");
          var model = filterComponent.getModel();
          filterComponent.setModel({
            type: "contains",
            filter: new Date().getTime()
          });
          filterComponent.onFilterChanged();
          _this3.state.gridOptions.api.setDatasource(_this3.pageDataSource);
          _this3.state.countRows("search ControlChangedDatasource");
        }
      }, 500);
    },
    selectAllDatasource: function selectAllDatasource() {
      var _this4 = this;

      debug_pageDatasource("select_AllDatasource");
      var rows_limit = 1000;
      var current_lines = this.gridOptions.api.getInfiniteRowCount();
      if (current_lines > rows_limit) {
        __WEBPACK_IMPORTED_MODULE_3__libs_bus__["a" /* bus */].$emit("showInformationModal", {
          message: "毎回" + rows_limit + "行以上を選択することはできません。現在は" + current_lines + " 行あります。<br>フィルターを使用して削減します。"
        });
        return;
      }
      if (this.isAllSelected == true) {
        return this.clearSelectionsDatasource();
      }

      this.clearSelectionsDatasource();
      this.state.gridOptions.api.showLoadingOverlay();
      this.state.$ajax.post("/" + this.api_name + "/datasource_load_for_select_all/", { filter: this.last_data_source_filter }, function (err, result) {
        _this4.state.gridOptions.api.hideOverlay();
        result.forEach(function (selected_row) {
          _this4.selectedRowArr.push(selected_row);
        });

        _this4.gridOptions.api.forEachNode(function (node) {
          node.data.is_selected = true;
        });
        _this4.gridOptions.api.refreshView();
        _this4.selectAllIcon = "checked";
        _this4.isAllSelected = true;
        _this4.formOutputQty = _this4.selectedRowArr.length;
      });
    },
    refreshNewRowDatasource: function refreshNewRowDatasource(result, mode) {
      var _this5 = this;

      var seq_id = result.seq_id;
      this.countRows("refreshNewRowDatasource");

      var obj = {};
      if (this.last_data_source_filter) {
        obj.filter = this.last_data_source_filter;
      }
      if (this.last_data_source_sort) {
        obj.sort = this.last_data_source_sort;
      }

      this.$ajax.post("/" + mode + "/datasource_position/" + seq_id, obj, function (err, result) {
        _this5.select_on_load = seq_id;
        _this5.select_on_load_position = result.data;
        _this5.gridOptions.api.ensureIndexVisible(result.data);
        _this5.gridOptions.api.purgeInfiniteCache();
      });
    },
    setAsZeroRows: function setAsZeroRows() {
      var result = 0;
      if (this.gridOptions.api) {
        this.gridOptions.api.setInfiniteRowCount(parseInt(result), true);
      } else if (this.state.gridOptions.api) {
        this.state.gridOptions.api.setInfiniteRowCount(parseInt(result), true);
      }
      this.totalNumberOfRows = result;
      return;
    },
    setManualCountRows: function setManualCountRows(n) {
      var force_count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (n > 100 || force_count > 0) {
        return this.state.countRows("set_ManualCountRows 2", { ignore_count_from_result: true });
      }
      var result = n;
      if (this.gridOptions.api) {
        this.gridOptions.api.setInfiniteRowCount(parseInt(result), true);
      } else if (this.state.gridOptions.api) {
        this.state.gridOptions.api.setInfiniteRowCount(parseInt(result), true);
      }
      this.totalNumberOfRows = result;
      return;
    },
    countRows: function countRows() {
      var _this6 = this;

      var requester = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "~";
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.count_from_result == true && options.ignore_count_from_result != true) {
        return 1;
      }
      if (this.load_only_with_filter && (this.last_data_source_filter == false || this.last_data_source_filter[1] && this.last_data_source_filter[1].value == "")) {
        return this.setAsZeroRows();
      }
      var req_data = { filter: this.last_data_source_filter, requester: requester };

      if (this.api_request_options) {
        req_data.api_request_options = this.api_request_options;
        if (typeof this.api_request_options.sub_search == "string" && this.api_request_options.sub_search.length > 0) {
          if (typeof this[this.api_request_options.sub_search] != "undefined") {
            req_data.sub_search = this[this.api_request_options.sub_search];
          }
        }
      }
      if (this.api_request_options) {
        if (!req_data.api_request_options) {
          req_data.api_request_options = this.api_request_options;
        }
        if (typeof this.api_request_options.filter_mode == "string" && this.api_request_options.filter_mode.length > 0) {
          if (typeof this[this.api_request_options.filter_mode] != "undefined") {
            req_data.filter_mode = this[this.api_request_options.filter_mode];
          }
        }
      }
      this.$ajax.post_cached_ttl("/" + this.api_name + "/datasource_count/", req_data, this.post_cached_timeout || 0, function (err, result) {
        if (err == null) {
          var orig_result = result;
          if (typeof result.qty == "undefined") {
            if ((typeof result === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(result)) == "object" && result.length > 0) {
              result = result[0];
            }
            if ((typeof result === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(result)) == "object") {
              result = result.qty;
            }
          }


          if (_this6.gridOptions.api) {
            _this6.gridOptions.api.setInfiniteRowCount(parseInt(result), true);
            if (result == 0) {
              _this6.gridOptions.api.showNoRowsOverlay();
            } else {
              _this6.gridOptions.api.hideOverlay();
            }
          } else if (_this6.state.gridOptions.api) {
            _this6.state.gridOptions.api.setInfiniteRowCount(parseInt(result), true);
            if (result == 0) {
              _this6.state.gridOptions.api.showNoRowsOverlay();
            } else {
              _this6.state.gridOptions.api.hideOverlay();
            }
          }
          _this6.totalNumberOfRows = result;
          if (typeof options != "undefined" && typeof options.counted_cb != "undefined") {
            options.counted_cb(null, result);
          }
        } else {
          if (typeof options != "undefined" && typeof options.counted_cb != "undefined") {
            options.counted_cb(err, null);
          }
        }
      });
    },
    initDatasource: function initDatasource() {
      var _this7 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


      this.init_data_source_options = options;
      this.load_mode = "ds";
      this.gridOptions.columnDefs = this.createColumnDefs();
      this.gridOptions.rowModelType = "infinite";
      this.gridOptions.enableServerSideSorting = true;
      this.gridOptions.sortingOrder = ["desc", "asc"];
      this.gridOptions.blockLoadDebounceMillis = 200;
      this.gridOptions.cacheOverflowSize = 100;
      this.gridOptions.cacheBlockSize = 100;
      this.gridOptions.maxBlocksInCache = 10;
      this.gridOptions.overlayNoRowsTemplate = '<span class="ag-overlay-loading-center">対象のデータはありません</span>';
      var initial_count_rows = true;
      this.pageDataSource = {
        state: false,
        setState: function setState(s) {
          _this7.state = s;
        },
        getRows: function getRows(params) {
          debug_pageDatasource(params, " requested page DataSource with params", { params: params, rowData: _this7.state.rowData, last_data_source_filter: _this7.last_data_source_filter });
          var load_data = true;
          if (_this7.init_data_source_options.load_only_with_filter == true && (_this7.last_data_source_filter == false || _this7.last_data_source_filter[1] && _this7.last_data_source_filter[1].value == "")) {
            _this7.load_only_with_filter = true;
            initial_count_rows = false;
            load_data = false;
          }
          var start = params.startRow;
          if (start < 0) {
            start = 0;
          }

          var end = params.endRow;
          if (end < 0) {
            end = 0;
          }
          if (start == 0 && end == 0) {
            return;
          }
          if (load_data == false) {
            _this7.gridOptions.datasource = [];
            _this7.setAsZeroRows();
            return;
          }
          console.log("Sort model", params.sortModel, _this7.last_data_source_sort);
          if (_this7.last_data_source_sort && _this7.last_data_source_sort != false && _this7.last_data_source_sort.length > 0) {
            if (params.sortModel && params.sortModel.length == 0) {
              params.sortModel = _this7.last_data_source_sort;
            }
          }
          var req_data = { filter: _this7.last_data_source_filter, sort: params.sortModel };
          if (_this7.api_request_options) {
            req_data.api_request_options = _this7.api_request_options;
            if (typeof _this7.api_request_options.sub_search == "string" && _this7.api_request_options.sub_search.length > 0) {
              if (typeof _this7[_this7.api_request_options.sub_search] != "undefined") {
                req_data.sub_search = _this7[_this7.api_request_options.sub_search];
              }
            }
          }
          _this7.state.gridOptions.api.showLoadingOverlay();
          _this7.state.$ajax.post("/" + _this7.api_name + "/datasource_load/" + start + "/" + end, req_data, function (err, result) {

            if (Array.isArray(result) == true && _this7.count_from_result == true) {
              _this7.setManualCountRows(result.length, start > 0);
            }
            if (_this7.state && _this7.state.gridOptions && _this7.state.gridOptions.api) {
              _this7.state.gridOptions.api.hideOverlay();
              if (_this7.totalNumberOfRows < 1 && (result.length < 1 || Array.isArray(result) == false)) {
                _this7.state.gridOptions.api.showNoRowsOverlay();
              }
            } else {
              console.log('The this.state.gridOptions.api do not exist., URL:', "/" + _this7.api_name + "/datasource_load/" + start + "/" + end);
            }
            var data_source_sort_key = "";

            if (params.sortModel) {
              data_source_sort_key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params.sortModel);
            }

            if (data_source_sort_key != _this7.last_data_source_sort_key) {

              if (_this7.clearSelectionsDatasource) {
                _this7.clearSelectionsDatasource();
              }
              _this7.last_data_source_sort_key = data_source_sort_key;
              _this7.last_data_source_sort = params.sortModel;
              if (_this7.count_from_result == true) {
                _this7.setManualCountRows(result.length, start > 0);
              } else {
                _this7.state.countRows("initDatasource 1");
              }
            } else if (_this7.init_data_source_options.force_count_on_load == true) {

              _this7.last_data_source_sort_key = data_source_sort_key;
              _this7.last_data_source_sort = params.sortModel;
              if (_this7.count_from_result == true) {
                _this7.setManualCountRows(result.length, start > 0);
              } else {
                _this7.state.countRows("initDatasource 2");
              }
            }
            _this7.$store.state[_this7.stateLastFilterOptions][_this7.api_name] = {
              filter: _this7.last_data_source_filter,
              sort: _this7.last_data_source_sort,
              sort_key: _this7.last_data_source_sort_key
            };
            if (err == null) {
              var select_on_load_found = false;
              result.forEach(function (d) {
                d.is_selected = false;
                d.search_control = false;
                d.search_flow_control = false;
                if (_this7.select_on_load && _this7.select_on_load == d.seq_id) {
                  select_on_load_found = true;
                }
              });

              params.successCallback(result);
              if (select_on_load_found) {
                _this7.gridOptions.api.ensureIndexVisible(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.clone(_this7.select_on_load_position));
                _this7.selectSeqId(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.clone(_this7.select_on_load), 20);
                _this7.select_on_load = false;
                _this7.select_on_load_position = 0;
              }
              if (typeof _this7.init_data_source_options.loaded_cb != "undefined") {
                _this7.init_data_source_options.loaded_cb(null, result, _this7);
              }
            } else {
              if (err == "Not logged") {
                _this7.state.$notify({
                  title: "セッションの有効期限が切れましたので、もう一度ログインを行ってください",

                  type: "error",
                  duration: 5000
                });
              } else {
                _this7.$notify({
                  title: "データの読込中にエラーが発生しました。",
                  text: err,
                  type: "error",
                  duration: 5000
                });
              }
            }
          });
        }
      };
      this.pageDataSource.setState(this);
      this.gridOptions.datasource = this.pageDataSource;
      if (initial_count_rows) {
        if (this.count_from_result) {
          this.setAsZeroRows();
        } else {
          this.countRows("getRows end");
        }
      } else {
        this.setAsZeroRows();
      }
    },
    initDatasourceNoFilter: function initDatasourceNoFilter() {
      var _this8 = this;

      this.gridOptions.columnDefs = this.createColumnDefs();
      this.gridOptions.rowModelType = "infinite";
      this.gridOptions.enableServerSideSorting = true;
      this.gridOptions.sortingOrder = ["desc", "asc"];
      this.pageDataSource = {
        state: false,
        setState: function setState(s) {
          _this8.state = s;
        },
        getRows: function getRows(params) {
          debug_pageDatasource(params.startRow, " requested page DataSource with params", params, _this8.state.rowData, "sortMOdel", params.sortModel);

          if (params.startRow < 0) {
            params.startRow = 0;
          }
          if (params.endRow < 1) {
            params.endRow = 0;
          }

          if (_this8.api_name == "master/load_empty_yobiki") {
            params.successCallback([]);
            return;
          }

          var url = "/" + _this8.api_name + "/datasource_load/" + params.startRow + "/" + params.endRow;
          _this8.state.gridOptions.api.showLoadingOverlay();
          _this8.state.$ajax.post(url, { sort: params.sortModel }, function (err, result) {
            _this8.state.gridOptions.api.hideOverlay();
            debug_pageDatasource("result", result);
            if (err == null) {
              debug_pageDatasource("Returned data", result);
              params.successCallback(result);
              setTimeout(function () {
                if (params.startRow == 0) {
                  try {
                    _this8.state.gridOptions.api.sizeColumnsToFit();
                  } catch (error) {
                    debug_pageDatasource("failed to run sizeColumnsToFit", error);
                  }
                }
                try {
                  debug_pageDatasource(" =================  getCacheBlockState ================= ", _this8.state.gridOptions.api.getCacheBlockState());
                } catch (error) {
                  debug_pageDatasource("failed to run getCacheBlockState", error);
                }
              }, 3);
            } else {
              console.error({
                title: "データの読込中にエラーが発生しました。",
                type: "error",
                text: err,
                url: url
              });
              if (err == "Not logged") {
                _this8.state.$notify({
                  title: "セッションの有効期限が切れましたので、もう一度ログインを行ってください",

                  type: "error",
                  duration: 5000
                });
              } else {
                _this8.$notify({
                  title: "データの読込中にエラーが発生しました。",
                  type: "error",
                  text: err,
                  duration: 5000
                });
              }
            }
          });
        }
      };
      this.pageDataSource.setState(this);
      this.gridOptions.datasource = this.pageDataSource;
      this.countRows("initDatasourceNoFilter");
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

var GUEST = 1;
var GENERAL = 5;
var ADMIN = 9;
var PERMISSION = {
  ID_OPERATIONS_PERSONNEL: "ユーザIDオペレーション担当者",
  ADMINISTRATOR: "管理担当者",
  CHIEF_ADMINISTRATOR: "管理責任者",
  SYSTEM_ADMINISTRATOR: "システム管理者",
  MAINTENANCE_STAFF: "保守担当"
};
var access_rules = {
  generic: {},
  device_embedded_information: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  device_embedded_information_detail: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  device_embedded_detail: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  certificate_information: {
    browse: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  certificate_information_detail: {
    browse: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  associated_device: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },

  certificate_software: {
    browse: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  certificate: {
    browse: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },

  surplus_license: {
    browse: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  surplus_license_detail: {
    browse: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  surplus_license_allocation_request: {
    full: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  approval_history: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  inventory: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  inventory_report: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  inventory_report_check: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  bulk_import: {
    full: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  bulk_import2: {
    full: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  master_user_password: {
    full: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  master_user: {
    browse: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  master_user_detail: {
    browse: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ID_OPERATIONS_PERSONNEL, PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  master: {
    full: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  master_bel_mak_sys: {
    browse: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    add: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    edit: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    delete: [PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF],
    export: [PERMISSION.ADMINISTRATOR, PERMISSION.CHIEF_ADMINISTRATOR, PERMISSION.SYSTEM_ADMINISTRATOR, PERMISSION.MAINTENANCE_STAFF]
  },
  maintenance: {
    full: [PERMISSION.MAINTENANCE_STAFF]
  }
};

module.exports = access_rules;

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = {
  TABLE_ID: {
    DEVICE_EMBEDDED_INFORMATION: 1,
    CERTIFICATE_INFORMATION: 2,
    APPROVAL_HISTORY: 3,
    DEVICE_EMBEDDED_DETAIL: 4,
    ASSOCIATED_DEVICE: 5,
    USER: 6,
    TEMP_BATCH_IMPORT: 7,
    CERTIFICATE: 8,
    CERTIFICATE_SOFTWARE: 9,
    MAIL_MESSAGE: 60,
    BELONGS: 70,
    SYSTEM: 80,
    MAKER: 90,
    SOFTWARE: 100,
    INVENTORY_REPORTING_PERIOD: 110,
    INVENTORY: 120,
    APPLICATION_FLOW_CERTIFICATE_SOFTWARE: 51,
    APPLICATION_FLOW_DEVICE_EMBEDDED_INFORMATION: 52
  },
  SYUBETU: {
    DEVICE: "機器・組込情報",
    CERTIFICATE: "証書情報",
    DEVICE_DETAIL: "組込情報",
    ASSOCIATED_DEVICE: "ソフトウェア情報",
    USER: "ユーザ",
    BATCH_IMPORT: "一括取込",
    INVENTORY: "棚卸"
  },
  SOFTWARE_JURISDICTION: {
    OWN_DEPARTMENT: "当該部署所管",
    OTHER_DEPARTMENT: "他部署所管",
    PRE_INSTALL: "プレインストール",
    LEASING_AND_RENTAL: "リース/レンタル"
  },
  USER_STATUS: {
    ACTIVE: 1,
    BLOCKED: 9
  },
  COMPANY: {
    ALL: "ライセンス管理窓口",
    MHFG: "MHFG",
    MHBK: "MHBK",
    MHTB: "MHTB"
  },
  PERMISSION: {
    ID_OPERATIONS_PERSONNEL: "ユーザIDオペレーション担当者",
    ADMINISTRATOR: "管理担当者",
    CHIEF_ADMINISTRATOR: "管理責任者",
    SYSTEM_ADMINISTRATOR: "システム管理者",
    MAINTENANCE_STAFF: "保守担当",
    NONE: 'none'
  },
  PERMISSION_MODE: {
    BROWSE: "browse",
    ADD: "add",
    EDIT: "edit",
    DELETE: "delete",
    EXPORT: "export"
  },
  HISTORY_MODE: {
    NEW: 1,
    UPDATE: 2,
    DELETE: 3,
    UPDATE_APPLICATION: 4
  },
  COMMON: {
    ALL_USERS_LABEL: "全ユーザ",
    ALL_USERS_VALUE: "all_users"
  },
  INVENTORY: {
    INVENTORY_APPROVAL_Number: 20
  }
};

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(943),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e7aff52",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(793)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1073),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5240dc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "下書中", "差戻"],
  table_field_style: {
    "承認済": "color:;",
    "申請中": "color:blue;",
    "下書中": "color:#a0283a",
    "差戻": "color:red;"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "B"
  }
}, {
  id: "device_control_number",
  label: "機器管理番号",
  type: types.INPUT,
  listen_for_value: "device_number_force_update",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "D"
  }
}, {
  id: "computer_name",
  label: "コンピュータ名",
  type: types.INPUT,
  error_if_blank: true,
  import: {
    enabled: true,
    alias: ["コンピュータ名"]
  },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "F"
  }
}, {
  id: "virtual_environment",
  label: "仮想環境",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "virtual_base_unit",
  label: "仮想基盤の親機",
  type: types.INPUT,
  listen_for_value: "device_number_force_update",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "company",
  label: "機器所管会社",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  page_controller: true,
  api_uniq_grouping: true,
  default_from_local_storage: "userCompany",

  api: "/master_belongs/list_team_and_department",
  api_field_name: "company",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "A"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "equipment_in_charge_department", api: "department" },
      team: { field: "equipment_in_charge_team", api: "team" }
    },
    clear_on_reset: ["equipment_in_charge_department", "equipment_in_charge_team"]
  }
}, {
  id: "equipment_in_charge_department",
  label: "機器所管部署",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,

  api: "/master_belongs/list_team_and_department",
  api_field_name: "department",
  default_from_local_storage: "userDepartment",
  limit_department_on_search: true,
  limit_department_on_load: true,
  page_controller: true,
  api_uniq_grouping: true,

  search_option: {
    define_department_limit_to_key: "equipment_in_charge_team"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "G"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "equipment_in_charge_department", api: "department" },
      team: { field: "equipment_in_charge_team", api: "team" }
    },
    clear_on_reset: ["equipment_in_charge_team"]
  }
}, {
  id: "equipment_in_charge_team",
  label: "機器所管チーム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  api_uniq_grouping: true,
  default_from_local_storage: "userTeam",
  api: "/master_belongs/list_team_and_department",
  api_field_name: "team",
  limit_department_on_search: true,
  page_controller: true,

  search_option: {
    define_department_limit_by_key: "equipment_in_charge_department",
    api_field_name: "department"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "H"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "equipment_in_charge_department", api: "department" },
      team: { field: "equipment_in_charge_team", api: "team" }
    },
    clear_on_reset: []
  }
}, {
  id: "equipment_in_charge_classification",
  label: "所管区分",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["EUC・その他", "IT所管システム"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "I"
  }
}, {
  id: "equipment_in_charge_system_it",
  label: "機器所管システム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  api_uniq_grouping: true,
  api: "/master_system/list_system_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "J"
  }
}, {
  id: "equipment_in_charge_system",
  label: "所管システム/用途",
  type: types.INPUT
}, {
  id: "leasing_or_rental",
  label: "リース/レンタル",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "manufacture_name",
  label: "メーカ名",
  type: types.INPUT,
  error_if_blank: true,
  import: {
    enabled: true,
    alias: ["メーカ名"]
  },
  export: {
    enabled: true,
    sequence: 1000,
    label: "メーカ名"
  }
}, {
  id: "model_name",
  label: "機種名",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "equipment_classification",
  label: "機器区分",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["サーバ", "PC", "その他"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "cpu_count",
  label: "CPU数",
  type: types.INPUT,
  min_value: "0",
  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "remarks",
  label: "備考",
  type: types.TEXT_AREA,
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "retraction_reason",
  label: "差戻通知",
  type: types.TEXT_AREA,
  field_message: "※[差戻通知]は承認完了後削除されます。",
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "installation_department",
  label: "設置部署",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  search_mode_type_ahead: true,
  sort_result: true,
  api: "/master_belongs/list_department",
  default_from_local_storage: "userDepartment",
  limit_department_on_search: true,
  limit_department_on_load: true,
  api_uniq_grouping: true,
  global_emit: "equipment_in_charge_department_selected_in",
  search_option: {
    define_department_limit_to_key: "installation_team"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "K"
  }
}, {
  id: "installation_team",
  label: "設置チーム",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  search_mode_type_ahead: true,
  sort_result: true,
  default_from_local_storage: "userTeam",
  api: "/master_belongs/list_team_and_department",
  api_field_name: "team",
  limit_department_on_search: true,
  api_uniq_grouping: true,

  api_filter_to_other_field: {
    by_field: "installation_department",
    compare_api_key: "department",
    filter_data_on_event: "equipment_in_charge_department_selected_in"
  },
  search_option: {
    define_department_limit_by_key: "installation_department",
    api_field_name: "department"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "L"
  }
}, {
  id: "installation_base",
  label: "設置拠点",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "M"
  }
}, {
  id: "floor",
  label: "フロア",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "user_name",
  label: "使用者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "N"
  }
}, {
  id: "registration_date",
  label: "登録日",
  type: types.DATE_PICKER,
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "E"
  }
}, {
  id: "last_update_date",
  label: "最終更新日",
  type: types.DATE_PICKER
}, {
  id: "management_person_name",
  label: "管理担当者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "O"
  }
}, {
  id: "status",
  label: "状態",
  type: types.SELECT_BOX,
  options: ["使用中", "廃棄"],
  options_for_new: ["使用中"],
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    device_embedded_information: "C"
  }
}, {
  id: "approval_status_flag",
  label: "approval_status_flag",
  type: types.INPUT,
  import: { enabled: false },
  export: { enabled: false }
}, {
  id: "item_number",
  label: "本数",
  type: types.INPUT
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;

var fields = ret;
var filed_types = types;

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _ref;

var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT
}, {
  id: "certificate_seq_id",
  label: "証書管理番号(ref)",
  type: types.INPUT,
  import: {
    enabled: true
  }
}, {
  id: "certificate_software_number",
  label: "証書管理番号",
  type: types.INPUT,
  import: {
    enabled: true,
    alias: ["証書管理番号\r\n(必須)"]
  },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software_deposit: "F",
    certificate_software: "D",
    surplus_license: "C"
  }
}, {
  id: "maker",
  label: "メーカ",

  type: types.SELECT_BOX4,
  error_if_blank: true,
  api_uniq_grouping: true,
  api: "/master_maker/list_maker_name",

  event_emit_bus_key: "certificate_software_manufacture_name_software_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "I",
    certificate_software: "J",
    certificate_software_deposit: "B",
    surplus_license: "B"
  }
}, (_ref = {
  id: "software_name",
  label: "ソフトウェア名",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api_uniq_grouping: true,
  api: "/master_software/list_software_name_maker_name"
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "error_if_blank", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "import", { enabled: true }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "api_field_name", "software_name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "api_filter_to_other_field", {
  by_field: "maker",
  compare_api_key: "maker_name",
  filter_data_on_event: "certificate_software_manufacture_name_software_name"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "export", {
  enabled: true,
  sequence: 1000,
  certificate_software: "K",
  surplus_license: "D"
}), _ref), {
  id: "license_name",
  label: "ライセンス名",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software_deposit: "C",
    certificate_software: "L"
  }
}, {
  id: "jurisdiction_classification",
  label: "所管区分",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["EUC・その他", "IT所管システム"],
  import: { enabled: true },
  api_uniq_grouping: true,
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "F"
  }
}, {
  id: "company",
  label: "ライセンス所管会社",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  page_controller: true,
  api_uniq_grouping: true,
  default_from_local_storage: "userCompany",

  api: "/master_belongs/list_team_and_department",
  api_field_name: "company",
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "E"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "licensed_department", api: "department" },
      team: { field: "license_jurisdiction_team", api: "team" }
    },
    clear_on_reset: ["licensed_department", "license_jurisdiction_team"]
  }
}, {
  id: "licensed_department",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,

  default_from_local_storage: "userDepartment",
  limit_department_on_search: true,

  api: "/master_belongs/list_team_and_department",
  api_field_name: "department",
  page_controller: true,
  api_uniq_grouping: true,
  search_option: {
    define_department_limit_to_key: "license_jurisdiction_team"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "G"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "licensed_department", api: "department" },
      team: { field: "license_jurisdiction_team", api: "team" }
    },
    clear_on_reset: ["license_jurisdiction_team"]
  }
}, {
  id: "license_jurisdiction_team",
  label: "ライセンス所管チーム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  default_from_local_storage: "userTeam",
  api: "/master_belongs/list_team_and_department",
  api_field_name: "team",
  api_uniq_grouping: true,

  limit_department_on_search: true,

  page_controller: true,
  search_option: {
    define_department_limit_by_key: "licensed_department",
    api_field_name: "department"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "H"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "licensed_department", api: "department" },
      team: { field: "license_jurisdiction_team", api: "team" }
    },
    clear_on_reset: []
  }
}, {
  id: "license_jurisdiction_system",
  label: "ライセンス所管システム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  api_uniq_grouping: true,
  api: "/master_system/list_system_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "I"
  }
}, {
  id: "equipment_in_charge_system",
  label: "所管システム/用途",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "product_key",
  label: "プロダクトキー",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "upgrade",
  label: "アップグレード",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  default_value: "無",
  import: {
    enabled: true,
    alias: ["アップグレード\r\n(有/無)"]
  }
}, {
  id: "upgrade_source",
  label: "アップグレード元",
  type: types.INPUT,
  error_if_blank: true,
  min_value: "0",
  import: { enabled: true }
}, {
  id: "upgrade_destination",
  label: "アップグレード先",
  type: types.INPUT,
  read_only: true,
  disabled: true,
  min_value: "0",
  import: { enabled: true }
}, {
  id: "deadline_alert",
  label: "有効期限　有無",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true
  }
}, {
  id: "expiration_date",
  label: "有効期限",
  type: types.DATE_PICKER,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "Q",
    surplus_license: "F"
  }
}, {
  id: "maintenance_deadline",
  label: "保守期限",
  type: types.DATE_PICKER,
  import: { enabled: true, date_format: "YYYY-MM-DD" },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "R",
    surplus_license: "G"
  }
}, {
  id: "second_number",
  label: "セカンド数",
  type: types.INPUT,
  field_type: "number",
  min_value: "0",
  import: { enabled: true }
}, {
  id: "unlimited",
  label: "無制限",
  type: types.SELECT_BOX,
  no_blank: true,
  default_value: "ー",
  options: ["無制限", "ー"],
  import: {
    enabled: true,
    alias: ["無制限\r\n(無制限/-)"],
    sequence: 1000,
    certificate_software: "M"
  },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "M"
  }
}, {
  id: "license",
  label: "ライセンス数",
  type: types.INPUT,
  error_if_blank: true,
  field_type: "number",
  min_value: "1",
  import: { enabled: true },
  export: {
    enabled: true, sequence: 1000,
    certificate_software_deposit: "E",
    surplus_license: "E",
    certificate_software: "N"
  }

}, {
  id: "applicant_name",
  label: "申請者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "management_person_name",
  label: "管理担当者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "comprehensive_contract",
  label: "包括契約",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "effective_number",
  label: "使用数",
  type: types.INPUT,
  exact_value: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "O"
  }
}, {
  id: "remaining_number",
  label: "残数",
  exact_value: true,
  type: types.INPUT,
  tab_size: 20,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "P"
  }
}, {
  id: "remark",
  label: "備考",
  type: types.TEXT_AREA,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "retraction_reason",
  label: "差戻通知",
  type: types.TEXT_AREA,
  field_message: "※[差戻通知]は承認完了後削除されます。",
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "下書中", "差戻"],
  table_field_style: {
    "承認済": "color:;",
    "申請中": "color:blue;",
    "下書中": "color:#a0283a",
    "差戻": "color:red;"
  },
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "B",
    surplus_license: "A"
  }
}, {
  id: "status",
  label: "状態",
  type: types.SELECT_BOX,
  options: ["使用中", "廃棄"],
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "C"
  }
}, {
  id: "registration_date",
  label: "登録日",
  type: types.DATE_PICKER,
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "A"
  }
}, {
  id: "last_update_date",
  label: "最終更新日",
  type: types.DATE_PICKER
}, {
  id: "second",
  label: "セカンド",
  tab_size: 10,
  type: types.SELECT_BOX,
  default_value: "無",
  options: ["有", "無"],
  import: { enabled: true }
}, {
  id: "downgrade",
  label: "アップ・ダウングレード",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "license_certificate_type",
  label: "ライセンス証書種類",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software_deposit: "D"
  }
}, {
  id: "deadline_check",
  label: "期限チェック",
  tab_size: 25,
  type: types.INPUT,
  error_if_blank: true,
  field_type: "number",
  min_value: "0",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "H"
  }
}, {
  id: "disable_validation",
  label: "disable_validation",
  type: types.INPUT
}, {
  id: "status_at_approve_request",
  label: "status_at_approve_request",
  type: types.INPUT
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(672)
  __webpack_require__(673)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b642b7b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "下書中", "差戻"],
  table_field_style: {
    "承認済": "color:;",
    "申請中": "color:blue;",
    "下書中": "color:#a0283a",
    "差戻": "color:red;"
  },
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "B"
  }
}, {
  id: "status",
  label: "状態",
  type: types.SELECT_BOX,
  options: ["使用中", "廃棄"],
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "C"
  }
}, {
  id: "registration_date",
  label: "登録日",
  type: types.DATE_PICKER,
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "A"
  }
}, {
  id: "certificate_management_number",
  label: "証書管理番号",
  type: types.INPUT,
  listen_for_value: "management_number_force_update",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "D"
  }
}, {
  id: "company",
  label: "ライセンス所管会社",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  page_controller: true,
  default_from_local_storage: "userCompany",
  api: "/master_company/list_company_name"
}, {
  id: "licensed_department",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api: "/master_belongs/list_department",
  default_from_local_storage: "userDepartment",
  limit_department_on_search: true,

  page_controller: true,
  search_option: {
    define_department_limit_to_key: "license_jurisdiction_team"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "H"
  }
}, {
  id: "license_jurisdiction_team",
  label: "ライセンス所管チーム",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api: "/master_belongs/list_team_and_department",
  default_from_local_storage: "userTeam",
  api_field_name: "team",
  limit_department_on_search: true,

  page_controller: true,
  search_option: {
    define_department_limit_by_key: "licensed_department",
    api_field_name: "department"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "E"
  }
}, {
  id: "jurisdiction_classification",
  label: "所管区分",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["EUC・その他", "IT所管システム"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "F"
  }
}, {
  id: "license_jurisdiction_system",
  label: "ライセンス所管システム",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api: "/master_system/list_system_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "G"
  }
}, {
  id: "maker",
  label: "メーカ",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api: "/master_maker/list_maker_name",

  event_emit_bus_key: "associated_device_manufacture_name_software_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "I"
  }
}, {
  id: "license_name",
  label: "ライセンス名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "equipment_in_charge_system",
  label: "所管システム/用途",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "effective_number",
  label: "有効数",
  type: types.INPUT,
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "J"
  }
}, {
  id: "remaining_number",
  label: "残数",
  type: types.INPUT,
  tab_size: 20,
  import: { enabled: true, default: 0 },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "K"
  }
}, {
  id: "license_certificate_type",
  label: "ライセンス証書種類",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "certificate_individual_number",
  label: "証書個別番号",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "comprehensive_contract",
  label: "包括契約",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "sales_company",
  label: "販売会社",
  type: types.INPUT,
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "applicant_name",
  label: "申請者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "management_person_name",
  label: "管理担当者名",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "downgrade",
  label: "アップ・ダウングレード",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "expiration_date",
  label: "有効期限",
  type: types.CURRENT_TIME,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "maintenance_deadline",
  label: "保守期限",
  type: types.CURRENT_TIME,
  import: { enabled: true, date_format: "YYYY-MM-DD" },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "deadline_alert",
  label: "有効期限　有無",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true
  }
}, {
  id: "remark",
  label: "備考",
  type: types.TEXT_AREA,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "other_items_by_manufacturer",
  label: "その他メーカ別項目",
  type: types.TEXT_AREA,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "software_name",
  label: "ソフトウェア名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "approval_status_flag",
  label: "状態",
  type: types.INPUT,
  import: { enabled: false },
  export: { enabled: false }
}, {
  id: "license",
  min_val: 1,
  label: "ライセンス数",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1056),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ba0810c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_errors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rules_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);






var debug_menuCommon = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:menu_common");


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},
  data: function data() {
    return {
      user_type: 0
    };
  },

  computed: {
    acl: function acl() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].acl;
    },
    permissionMode: function permissionMode() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].PERMISSION_MODE;
    }
  },
  mounted: function mounted() {
    this.user_type = parseInt(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('userType'));
  },

  methods: {
    checkMenuUserPermission: function checkMenuUserPermission(page_acl) {
      var permission = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].PERMISSION_MODE.BROWSE;
      var requester = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      return __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].check_user_permission(page_acl, permission, requester);
    },
    resetMenuUserPermission: function resetMenuUserPermission() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].reset_user_permissions();
    },
    allowMenuItemAsString: function allowMenuItemAsString(arr) {
      var _this = this;

      var ret = "false";
      arr.forEach(function (name) {
        debug_menuCommon("allowMenuItem", _this.user_type, __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a[name].browse.indexOf(_this.user_type) > -1, name, __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a[name]);
        if (__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a[name].browse.indexOf(_this.user_type) > -1) {
          ret = "true";
        }
      });
      debug_menuCommon("allowMenuItem return ", ret);
      return ret;
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = {
  forms: [{
    n_id: 1,
    group1: true,
    id: "sending_and_receiving_slips",
    label: "送付授受票",
    print_rule: "T0001"
  }, {
    n_id: 2,
    group1: true,
    id: "collection_and_receipt_slips",
    label: "回収授受票",
    print_rule: "T0002",
    alternatives: {
      page1: "T0002",
      page4: "T0003"
    }
  }, {
    n_id: 3,
    group1: true,
    id: "return_delivery_form",
    label: "返却授受票",

    print_rule: "T0003"
  }, {
    n_id: 4,
    group1: true,
    id: "distribution_check_list",
    label: "配布チェックリスト",
    disabled: false,
    print_rule: "T0004A",
    alternatives: {
      page1: "T0004B",
      page4: "T0004A",
      page1_paper: "T0004Bp"
    }
  }, {
    n_id: 15,
    group1: true,
    id: "return_check_list",
    label: "返却チェックリスト",
    disabled: false,
    print_rule: "T0024A",
    alternatives: {
      page1: "T0024B",
      page4: "T0024A"
    }
  }, {
    n_id: 5,
    group1: true,
    id: "tablet_terminal_apple_id_password_management_slip",
    label: "タブレット端末 AppleIDパスワード管理表",
    disabled: false,
    print_rule: "T0005A",
    alternatives: {
      page1: "T0005B",
      page2: "T0005A"
    }
  }, {
    n_id: 6,
    group1: true,
    id: "registered_shipping_and_receiving_book",
    label: "書留発送簿兼授受簿",
    disabled: false,
    print_rule: "T0006A",
    alternatives: {
      page1: "T0006B",
      page4: "T0006A"
    }
  }, {
    n_id: 7,
    group1: true,
    id: "label_8_pieces",
    label: "ラベル 8面",
    disabled: false,
    require_position_selection: true,
    positions: { r: 4, c: 2 },
    print_rule: "T0007",
    alternatives: {
      page1: "T0007B",
      page4: "T0007A"
    }
  }, {
    n_id: 8,
    group1: true,
    id: "label_36_pieces",
    label: "ラベル 36面",
    disabled: false,
    require_position_selection: true,
    positions: { r: 12, c: 3 },
    print_rule: "T0008",
    alternatives: {
      page1: "T0008B",
      page4: "T0008A"
    }
  }, {
    n_id: 11,
    id: "enroll",
    label: "エンロール削除",
    disabled: false,
    print_rule: "T0011"
  }, {
    n_id: 12,
    id: "revocation_correspondence",
    label: "リボーク対応",
    disabled: false,
    print_rule: "T0012"
  }, {
    n_id: 13,
    id: "pass_unlock",
    label: "パスコード解除",
    disabled: false,
    print_rule: "T0013"
  }, {
    n_id: 14,
    id: "tablet_device_information_sheet",
    label: "タブレット端末情報シート",
    disabled: false,
    print_rule: "T0014"
  }, {
    n_id: 15,
    id: "cancellation_checklist_sheet",
    label: "解約チェックリスト",
    disabled: false,
    print_rule: "T0025"
  }]
};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c0f1ba4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1017),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67103126",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "差戻", "承認完了"],
  table_field_style: {
    "承認済": "color:;",
    "申請中": "color:blue;",
    "下書中": "color:#a0283a",
    "差戻": "color:red;"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "A"
  }
}, {
  id: "fk_id",
  label: "fk_id",
  type: types.INPUT
}, {
  id: "tab_id",
  label: "tab_id",
  type: types.INPUT
}, {
  id: "ref_id",
  label: "ref_id",
  type: types.INPUT
}, {
  id: "syubetu",
  label: "種別",
  type: types.SELECT_BOX,
  options: ["機器・組込情報", "証書情報"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "C"
  }
}, {
  id: "control_number",
  label: "管理番号",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "D"
  }
}, {
  id: "toroku_number",
  label: "申請No",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "E"
  }
}, {
  id: "bulk_toroku_number",
  label: "一括編集No",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "F"
  }
}, {
  id: "applicant",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant_team",
  label: "申請者チーム",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "update_name",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "next_approver",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant_label",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "H"
  }
}, {
  id: "update_name_label",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "J"
  }
}, {
  id: "next_approver_label",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "I"
  }
}, {
  id: "create_time",
  label: "開始日時",
  type: types.CURRENT_TIME,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "K"
  }
}, {
  id: "update_time",
  label: "更新日時",
  type: types.CURRENT_TIME,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "L"
  }
}, {
  id: "licensed_department",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_department",
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}, {
  id: "record_checked",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}, {
  id: "status_0",
  label: "状態0",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_1",
  label: "所属チーム1",

  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_1_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_label_1",
  label: "承認者1",
  type: types.INPUT
}, {
  id: "approver_label_2",
  label: "承認者2",
  type: types.INPUT
}, {
  id: "approver_label_3",
  label: "承認者3",
  type: types.INPUT
}, {
  id: "approver_label_4",
  label: "承認者4",
  type: types.INPUT
}, {
  id: "approver_label_5",
  label: "承認者5",
  type: types.INPUT
}, {
  id: "approver_label_final",
  label: "最終承認者",
  type: types.INPUT
}, {
  id: "approver_1",
  label: "承認者1",
  pre_load_data: true,

  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_1",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_1_selected",
  do_not_repeat: ["approver_2", "approver_3", "approver_4", "approver_5"],
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_1",
    compare_api_key: "team",
    filter_data_on_event: "team_1_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_1",
  label: "状態1",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_2",
  label: "所属チーム2",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_2_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_1_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_2",
  label: "承認者2",
  pre_load_data: true,
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_2",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_2_selected",
  do_not_repeat: ["approver_1", "approver_3", "approver_4", "approver_5"],
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_2",
    compare_api_key: "team",
    filter_data_on_event: "team_2_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_2",
  label: "状態2",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_3",
  label: "所属チーム3",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_3_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_2_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_3",
  label: "承認者3",
  pre_load_data: true,
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_3",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_3_selected",
  do_not_repeat: ["approver_1", "approver_2", "approver_4", "approver_5"],
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_3",
    compare_api_key: "team",
    filter_data_on_event: "team_3_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_3",
  label: "状態3",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_4",
  label: "所属チーム4",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_4_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_3_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_4",
  label: "承認者4",
  pre_load_data: true,
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_4",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_4_selected",
  do_not_repeat: ["approver_1", "approver_2", "approver_3", "approver_5"],
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_4",
    compare_api_key: "team",
    filter_data_on_event: "team_4_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_4",
  label: "状態4",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_5",
  label: "所属チーム5",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_5_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_4_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_5",
  label: "承認者5",
  pre_load_data: true,
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_5",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",

  do_not_repeat: ["approver_1", "approver_2", "approver_3", "approver_4"],
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_5",
    compare_api_key: "team",
    filter_data_on_event: "team_5_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_5",
  label: "状態5",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "approver_final",
  label: "最終承認者",

  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_final",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",

  import: { enabled: true }
}, {
  id: "status_final",
  label: "状態6",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "current_status",
  label: "状態",
  type: types.SELECT_BOX,
  options: ["使用中", "廃棄", "余剰"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "B"
  }
}, {
  id: "department",
  label: "申請部署",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    approval_history: "G"
  }
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _ref;

var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id",
  label: "Unique ID",
  type: types.INPUT,
  tab_size: 10
}, {
  id: "mail_message_number",
  label: "メールメッセージ番号",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    mail_message: "A"
  }
}, (_ref = {
  id: "mail_type",
  label: "メール区分",
  type: types.INPUT
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "type", types.SELECT_BOX), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tab_size", 15), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "options", ["個別連絡事項", "通達", "ID申請"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "export", {
  enabled: true,
  sequence: 1000,
  mail_message: "B"
}), _ref), {
  id: "mail_subject",
  label: "メールタイトル",
  type: types.INPUT,
  tab_size: 60,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    mail_message: "C"
  }
}, {
  id: "mail_content",
  label: "メール本文",
  type: types.TEXT_AREA,
  tab_size: 100,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    mail_message: "D"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  DATETIME_PICKER: "datetime_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
  EMAIL: "email"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "下書中", "差戻"],
  import: { enabled: false }
}, {
  id: "user_id",
  label: "ユーザID",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  page_controller: true,
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "B"
  }
}, {
  id: "user_shimei",
  label: "ユーザ氏名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  page_controller: true,
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "C"
  }
}, {
  id: "role",
  label: "役割",
  type: types.SELECT_BOX,
  error_if_blank: true,
  page_controller: true,
  options: ["ユーザIDオペレーション担当者", "管理担当者", "管理責任者", "システム管理者", "保守担当"],

  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "D"
  }
}, {
  id: "company",
  label: "所属会社",
  type: types.SELECT_BOX4,
  search_limit_no_admin_company_from_local_storage: true,
  error_if_blank: true,
  page_controller: true,
  api: "/master_belongs/list_department_for_user_control",
  api_field_name: "company",
  api_uniq_grouping: true,
  emit_input: true,
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "E"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "department", api: "department" },
      team: { field: "team", api: "team" }
    },
    clear_on_reset: ["department", "team"]
  }
}, {
  id: "department",
  label: "所属部署名",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  api_uniq_grouping: true,
  api: "/master_belongs/list_department_for_user_control",
  api_field_name: "department",
  page_controller: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "F"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "department", api: "department" },
      team: { field: "team", api: "team" }
    },
    clear_on_reset: ["team"]
  }
}, {
  id: "team",
  label: "所属チーム名",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  api_uniq_grouping: true,
  error_if_blank: true,
  page_controller: true,
  api: "/master_belongs/list_department_for_user_control",
  api_field_name: "team",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "G"
  },
  search_dependency: {
    algorithm: "company",
    fields: {
      company: { field: "company", api: "company" },
      department: { field: "department", api: "department" },
      team: { field: "team", api: "team" }
    },
    clear_on_reset: []
  }
}, {
  id: "login_failure_count",
  label: "ログイン失敗回数",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "password",
  label: "パスワード",
  type: types.PASSWORD,
  error_if_blank: true,
  import: { enabled: false }
}, {
  id: "mail_address",
  label: "メールアドレス",
  type: types.EMAIL,
  error_if_blank: true,
  page_controller: true,
  options: ["mizuhofg.co.jp", "mizuho-bk.co.jp", "mizuhotb.co.jp", "mizuho-rt.co.jp"],
  import: { enabled: true }
}, {
  id: "last_login_date",
  label: "最終ログイン日時",
  type: types.DATETIME_PICKER,
  import: { enabled: false }
}, {
  id: "last_password_changed_date",
  label: "パスワード最終更新日",
  type: types.DATE_PICKER,
  disabled: true,
  read_only: true
}, {
  id: "status",
  label: "アクセス状態",
  type: types.SELECT_BOX2,
  error_if_blank: true,
  page_controller: true,
  options: [{ value: 1, label: "有効" }, { value: 9, label: "無効" }],
  table_field_style: {
    1: "",
    9: "color:red;"
  },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "A"
  }
}, {
  id: "authority_1",
  label: "兼務設定【１】",
  type: types.CHECKBOX,
  global_emit: "authority_1_selected",
  page_controller: true,
  import: { enabled: false }
}, {
  id: "role_1",
  label: "役割",
  type: types.SELECT_BOX,
  error_if_blank: true,
  page_controller: true,
  options: ["ユーザIDオペレーション担当者", "管理担当者", "管理責任者", "システム管理者", "保守担当"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "D"
  }
}, {
  id: "company_1",
  label: "所属会社",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api: "/master_company/list_company_name_for_user_control",
  emit_input: true,
  page_controller: true,
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "E"
  }
}, {
  id: "department_1",
  label: "所属部署名",
  type: types.SELECT_BOX4,
  page_controller: true,
  sort_result: true,
  error_if_blank: true,
  api: "/master_belongs/list_department_for_user_control",
  api_field_name: "department",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "F"
  }
}, {
  id: "team_1",
  label: "所属チーム名",
  type: types.SELECT_BOX4,
  sort_result: true,
  error_if_blank: true,
  api: "/master_belongs/list_department_for_user_control",
  api_field_name: "team",
  page_controller: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "G"
  }
}, {
  id: "authority_2",
  label: "兼務設定【２】",
  type: types.CHECKBOX,
  global_emit: "authority_2_selected",
  page_controller: true,
  import: { enabled: false }
}, {
  id: "role_2",
  label: "役割",
  type: types.SELECT_BOX,
  error_if_blank: true,
  page_controller: true,
  options: ["ユーザIDオペレーション担当者", "管理担当者", "管理責任者", "システム管理者", "保守担当"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "D"
  }
}, {
  id: "company_2",
  label: "所属会社",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  page_controller: true,
  api: "/master_company/list_company_name_for_user_control",
  emit_input: true,
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "E"
  }
}, {
  id: "department_2",
  label: "所属部署名",
  type: types.SELECT_BOX4,
  page_controller: true,
  sort_result: true,
  error_if_blank: true,
  api: "/master_belongs/list_department_for_user_control",
  api_field_name: "department",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "F"
  }
}, {
  id: "team_2",
  label: "所属チーム名",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  sort_result: true,
  api: "/master_belongs/list_department_for_user_control",
  api_field_name: "team",
  page_controller: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_user: "G"
  }
}, {
  id: "has_multiple",
  label: "has_multiple",
  type: types.INPUT
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _ref;

var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT
}, {
  id: "approval_status",
  label: "状態",
  tab_size: 15,
  type: types.SELECT_BOX,
  options: ["未対応", "対応完了", "差戻"],
  table_field_style: {
    "対応完了": "color:#0e962b;",
    "未対応": "color:orange;font-weight: 600;",
    "差戻": "color:red;"
  },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "A"
  }
}, (_ref = {
  id: "maker",
  label: "メーカー",
  type: types.INPUT,
  tab_size: 50
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "type", types.SELECT_BOX4), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "search_mode_type_ahead", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "sort_result", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "api", "/master_maker/list_maker_name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "on_select_event_emit_bus_key", "surplus_license_maker_software_name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "export", {
  enabled: true,
  sequence: 1000,
  surplus_license: "B"
}), _ref), {
  id: "certificate_software_number",
  label: "証書管理番号",
  type: types.INPUT,
  tab_size: 30,
  import: {
    enabled: true,
    alias: ["証書管理番号\r\n(必須)"]
  },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "C"
  }
}, {
  id: "software_name",
  label: "ソフトウェア名",
  type: types.INPUT,
  tab_size: 90,
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "D"
  }
}, {
  id: "license",
  label: "ライセンス数",
  type: types.INPUT,
  error_if_blank: true,
  tab_size: 25,
  field_type: "number",
  min_value: "0",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "E"
  }
}, {
  id: "expiration_date",
  label: "有効期限",
  tab_size: 25,
  type: types.DATE_PICKER,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "F"
  }
}, {
  id: "maintenance_deadline",
  label: "保守期限",
  tab_size: 25,
  type: types.DATE_PICKER,
  import: { enabled: true, date_format: "YYYY-MM-DD" },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "G"
  }
}, {
  id: "deadline_check",
  label: "期限チェック",
  tab_size: 25,
  type: types.INPUT,
  error_if_blank: true,
  field_type: "number",
  min_value: "0",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "H"
  }
}, {
  id: "surplus_license_seq_id",
  label: "Reference Unique Key",
  type: types.INPUT
}, {
  id: "effective_number",
  label: "有効数",
  type: types.INPUT,
  field_type: "number"
}, {
  id: "initial_number",
  label: "有効数_initial",
  type: types.INPUT,
  field_type: "number"
}, {
  id: "jurisdiction_department",
  label: "所管部署",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_department",
  default_from_local_storage: "userDepartment"
}, {
  id: "jurisdiction_team",
  label: "所管チーム",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_team_and_department",
  default_from_local_storage: "userTeam"
}, {
  id: "desired_number",
  label: "希望数",
  field_type: "number",
  type: types.INPUT
}, {
  id: "requester",
  label: "依頼者",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  default_from_local_storage: "userID"
}, {
  id: "registration_date",
  label: "登録日",
  type: types.DATE_PICKER
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1002),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e1c1a41",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(947),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-235fdb4b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(945),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21ef51f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(795)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1075),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffd53604",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports) {

var error_codes = {
  arr: [{
    id: "DATA_NOT_FOUND",
    code: 90001,
    description: "データが見つかりません"
  }, {
    id: "DEVICE_ID_NOT_FOUND",
    code: 90002,
    description: "'端末番号'が見つかりません"
  }, {
    id: "CONTROL_NUMBER_ALREADY_EXIST",
    code: 90003,
    description: "'管理番号'と'申請事項'はすでに存在しています！"
  },, {
    id: "MYSQL_ERROR",
    code: 90004,
    description: "MySqlエラー"
  }, {
    id: "DATA_DUPLICATED",
    code: 90005,
    description: "データの複製"
  }, {
    id: "INVALID_DATA",
    code: 90006,
    description: "Invalid data"
  }],
  getError: function getError(code, def) {
    var temp = {
      id: "UNDEFINED ERROR",
      code: code || "99999",
      description: def
    };
    error_codes.arr.forEach(function (d) {
      if (code == d.code) {
        temp = d;
      }
    });
    return temp;
  }
};

error_codes.arr.forEach(function (d) {
  error_codes[d.id] = d.code;
});
module.exports = error_codes;

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};
var constants = __webpack_require__(15);

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT
}, {
  id: "ref_id",
  label: "機器管理番号",
  type: types.INPUT,
  import: {
    enabled: true,
    alias: ["機器管理番号\r\n(必須)"]
  }
}, {
  id: "fk_id",
  label: "fk_id",
  type: types.INPUT
}, {
  id: "tab_id",
  label: "tab_id",
  type: types.INPUT
}, {
  id: "req_seq",
  tab_size: 10,
  label: "証書管理番号",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "jurisdiction_classification",
  label: "所管区分",
  type: types.SELECT_BOX,
  error_if_blank: true,
  listen_for_value: "jurisdiction_classification_force_update",
  options: ["EUC・その他", "IT所管システム"],
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "department_in_charge",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api: "/master_belongs/list_department",
  default_from_local_storage: "userDepartment",
  listen_for_value: "department_in_charge_force_update",
  limit_department_on_search: true,
  limit_department_on_load: true,
  api_uniq_grouping: true,
  global_emit: "equipment_in_charge_department_selected",
  search_option: {
    define_department_limit_to_key: "responsible_team"
  },
  import: { enabled: true }
}, {
  id: "responsible_team",
  label: "ライセンス所管チーム",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  default_from_local_storage: "userTeam",
  api: "/master_belongs/list_team_and_department",
  listen_for_value: "responsible_team_force_update",
  api_field_name: "team",
  api_uniq_grouping: true,
  limit_department_on_search: true,
  api_filter_to_other_field: {
    by_field: "department_in_charge",
    compare_api_key: "department",
    filter_data_on_event: "equipment_in_charge_department_selected"
  },
  search_option: {
    define_department_limit_by_key: "department_in_charge",
    api_field_name: "department"
  },
  import: { enabled: true }
}, {
  id: "jurisdiction_system",
  label: "ライセンス所管システム",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api_uniq_grouping: true,
  listen_for_value: "jurisdiction_system_force_update",
  api: "/master_system/list_system_name",
  import: { enabled: true }
}, {
  id: "jurisdiction_system_name_in_use",
  label: "所管システム/用途",
  type: types.INPUT,
  listen_for_value: "jurisdiction_system_name_in_use_force_update",
  import: { enabled: true }
}, {
  id: "maker",
  label: "メーカ",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  listen_for_value: "maker_force_update",
  api_uniq_grouping: true,
  event_emit_bus_key: "associated_device_manufacture_name_software_name",
  api: "/master_maker/list_maker_name",
  import: { enabled: true }
}, {
  id: "software",
  label: "ソフトウェア名",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api_uniq_grouping: true,
  listen_for_value: "software_force_update",
  api: "/master_software/list_software_name",
  api_filter_bus_key: "associated_device_manufacture_name_software_name",
  import: { enabled: true }
}, {
  id: "software_jurisdiction",
  label: "ソフトウェア所管",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: [constants.SOFTWARE_JURISDICTION.OWN_DEPARTMENT, constants.SOFTWARE_JURISDICTION.OTHER_DEPARTMENT, constants.SOFTWARE_JURISDICTION.PRE_INSTALL, constants.SOFTWARE_JURISDICTION.LEASING_AND_RENTAL],
  default_value: constants.SOFTWARE_JURISDICTION.OWN_DEPARTMENT,
  import: { enabled: true }
}, {
  id: "item_number",
  label: "使用するライセンス数",
  tab_size: 10,
  type: types.INPUT,
  error_if_blank: true,
  listen_for_value: "licence_item_number_force_update",
  field_type: "number",
  min_value: "1",
  import: { enabled: true,
    alias: ["紐付本数\r\n(半角数字)"] }
}, {
  id: "virtual_id",
  label: "仮想",
  tab_size: 10,
  type: types.SELECT_BOX,
  default_value: "無",
  options: ["有", "無"],
  import: { enabled: true,
    alias: ["仮想\r\n(有/無)"] }
}, {
  id: "certificate_management_number",
  label: "証書管理番号",
  type: types.INPUT,
  listen_for_value: "management_number_force_update",
  import: {
    enabled: true,
    alias: ["紐付証書管理番号"]
  }
}, {
  id: "certificate_software_number",
  label: "証書管理番号",
  type: types.INPUT,
  listen_for_value: "management_number_force_update",
  import: {
    enabled: true,
    alias: ["紐付証書管理番号"]
  }
}, {
  id: "associated_device_seq_id",
  label: "associated_device_seq_id",
  type: types.INPUT
}, {
  id: "certificate_software_seq_id",
  label: "certificate_software_seq_id",
  type: types.INPUT
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _ref, _ref2;

var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "registration_key",
  label: "登録キー",
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  type: types.INPUT
}, {
  id: "approval_status",
  label: "状態",
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  type: types.SELECT_BOX,
  options: ["報告済", "申請中", "下書中", "差戻"],
  table_field_style: {
    "報告済": "color:;",
    "申請中": "color:blue;",
    "下書中": "color:#a0283a",
    "差戻": "color:red;"
  },
  export: {
    enabled: true,
    sequence: 1000,
    inventory_unreport_list_euc: "A",
    inventory_unreport_list_it: "A"
  }
}, {
  id: "reporting_period",
  label: "棚卸報告年度区分",
  type: types.SELECT_BOX4,
  api: "/master_inventory_reporting_period/list_reporting_period",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report_form: "C6"
  }
}, {
  id: "created_by",
  label: "報告者",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report_form: "C12"
  }
}, {
  id: "contact_person",
  label: "担当者（ﾌﾙﾈｰﾑ）",
  type: types.TEXT_AREA,
  label_length_4: true,
  error_if_blank: true,
  field_style: "height:60px",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "G",
    inventory_report_form: "C11"
  }
}, (_ref = {
  id: "extension_number",
  label: "内線番号",
  error_if_blank: true,
  type: types.INPUT
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "error_if_blank", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "import", { enabled: true }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "export", {
  enabled: true
}), _ref), {
  id: "created_date",
  label: "報告日",
  type: types.DATE_PICKER,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  import: { enabled: true },
  export: {
    inventory_report: "F",
    enabled: true
  }
}, {
  id: "last_update_date",
  label: "更新日時",
  type: types.CURRENT_TIME,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  import: { enabled: true },
  export: {
    enabled: true
  }
}, {
  id: "ledger_check",
  label: "機器・ソフトウェア紐付明細の確認",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["一致", "不一致"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "Q",
    inventory_report_form: "F30"
  }
}, {
  id: "new_registration_of_equipment",
  label: "機器の新規登録",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "R",
    inventory_report_form: "F31"
  }
}, {
  id: "change_device_information",
  label: "機器情報の変更",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "S",
    inventory_report_form: "F32"
  }
}, {
  id: "disposal_of_device_information",
  label: "機器情報の廃棄",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "T",
    inventory_report_form: "F33"
  }
}, {
  id: "certificate_list_check",
  label: "証書一覧の確認",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["一致", "不一致"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "H",
    inventory_report_form: "F17"
  }
}, {
  id: "new_license_registration",
  label: "ライセンスの新規登録",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "I",
    inventory_report_form: "F18"
  }
}, {
  id: "change_license_information",
  label: "ライセンス情報の変更",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "J",
    inventory_report_form: "F19"
  }
}, {
  id: "disposal_of_license",
  label: "ライセンスの廃棄",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "K",
    inventory_report_form: "F20"
  }
}, {
  id: "reason_not_using",
  label: "ライセンスの未使用理由",
  type: types.TEXT_AREA,
  label_length_4: true,
  field_style: "height:100px",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "M",
    inventory_report_form: "F22"
  }
}, {
  id: "expired_license_support",
  label: "期限切れライセンス対応",
  type: types.SELECT_BOX,
  import: { enabled: true },
  options: ["　", "廃棄もしくは更新予定", "その他(備考に詳細を記入)"],
  export: {
    enabled: true,
    inventory_report: "O",
    inventory_report_form: "F24"
  }
}, {
  id: "certificate_remarks",
  label: "証書一覧備考",
  type: types.TEXT_AREA,
  label_length_4: true,
  field_style: "height:100px",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "P",
    inventory_report_form: "F25"
  }
}, {
  id: "lack_of_license",
  label: "①ライセンス購入数の不足",
  emit_input: true,
  field_type: "number",
  error_if_blank: true,
  min_value: "0",
  field_style: "text-align: right;",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "U",
    inventory_report_form: "F35"
  }
}, {
  id: "lost_license_certificate",
  label: "②ライセンス証書の紛失",
  error_if_blank: true,
  emit_input: true,
  field_type: "number",
  min_value: "0",
  field_style: "text-align: right;",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "V",
    inventory_report_form: "F36"
  }
}, {
  id: "no_evidence_of_license_receipt",
  label: "③ライセンス証書の受領形跡無し",
  error_if_blank: true,
  emit_input: true,
  field_type: "number",
  min_value: "0",
  field_style: "text-align: right;",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "W",
    inventory_report_form: "F37"
  }
}, {
  id: "other",
  label: "④その他",
  emit_input: true,
  field_type: "number",
  error_if_blank: true,
  min_value: "0",
  field_style: "text-align: right;",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "X",
    inventory_report_form: "F38"
  }
}, {
  id: "remarks",
  label: "ソフトウェア紐付備考",
  type: types.TEXT_AREA,
  label_length_4: true,
  field_style: "height:100px",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "Z",
    inventory_report_form: "F39"
  }
}, {
  id: "unused_license",
  label: "未使用ライセンス",
  type: types.INPUT,
  read_only: true,
  field_style: "text-align: right;",
  label_style: "background-color: #CCCCCC !important;",

  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "L",
    inventory_report_form: "F21"
  }
}, {
  id: "expired_license",
  label: "期限切れライセンス",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  field_style: "text-align: right;",

  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "N",
    inventory_report_form: "F23"
  }
}, {
  id: "admin_remark",
  label: "所見",
  type: types.TEXT_AREA,
  label_length_4: true,
  field_style: "height:100px",
  import: { enabled: true },
  export: {
    inventory_report: "AH",
    enabled: true
  }
}, {
  id: "retraction_reason",
  label: "差戻理由",
  type: types.TEXT_AREA,
  label_length_4: true,
  field_style: "height:100px"
}, {
  id: "retraction_person",
  label: "差戻者",
  type: types.INPUT,
  label_length_4: true
}, {
  id: "retraction_person_label",
  label: "差戻者",
  type: types.INPUT,
  label_length_4: true
}, {
  id: "retraction_person_name",
  label: "差戻者",
  type: types.INPUT,
  label_length_4: true
}, {
  id: "number_of_unattached",
  label: "未紐付数",
  type: types.INPUT,
  read_only: true,
  field_style: "text-align: right;",
  label_style: "background-color: #CCCCCC !important;",
  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report_form: "F34"
  }
}, {
  id: "company",
  label: "会社",
  type: types.SELECT_BOX4,
  page_controller: true,
  api_uniq_grouping: true,
  api: "/master_company/list_company_name",
  export: {
    enabled: true,
    sequence: 1000,
    inventory_report: "D",
    inventory_unreport_list_euc: "B"
  }
}, {
  id: "jurisdiction_classification",
  label: "所管区分",
  type: types.SELECT_BOX,
  options: ["EUC・その他", "IT所管システム"],
  import: { enabled: true },
  api_uniq_grouping: true,
  export: {
    enabled: true,
    sequence: 1000
  }
}, (_ref2 = {
  id: "department_in_charge",
  label: "所管部署",
  type: types.SELECT_BOX4
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "type", types.SELECT_BOX4), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "search_mode_type_ahead", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "sort_result", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "api", "/master_belongs/list_department"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "limit_department_on_search", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "page_controller", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "api_uniq_grouping", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "search_option", {
  define_department_limit_to_key: "report_team"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "import", { enabled: true }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, "export", {
  enabled: true,
  inventory_report: "E",
  inventory_report_form: "C8",
  inventory_unreport_list_euc: "C",
  inventory_unreport_list_it: "C"
}), _ref2), {
  id: "team_in_charge",
  label: "所管チーム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  api: "/master_belongs/list_team_and_department",
  api_field_name: "team",
  api_uniq_grouping: true,

  limit_department_on_search: true,

  page_controller: true,
  read_only: true,
  search_option: {
    define_department_limit_by_key: "report_department",
    api_field_name: "department"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "C",
    inventory_report_form: "C9",
    inventory_unreport_list_euc: "D"
  }
}, {
  id: "reporting_system",
  label: "所管システム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  api: "/master_system/list_system_name",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "B",
    inventory_report_form: "C10",
    inventory_unreport_list_it: "B"
  }
}, {
  id: "number_of_registered_devices",
  label: "登録機器台数",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  field_style: "text-align: right;",
  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "AC"
  }
}, {
  id: "number_of_registered_licenses",
  label: "登録ライセンス数",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  field_style: "text-align: right;",
  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "AD"
  }
}, {
  id: "number_of_software_packages_used",
  label: "使用ソフトウェア数",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  field_style: "text-align: right;",
  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "AE"
  }
}, {
  id: "number_of_installed_software_to_be_linked",
  label: "紐付け対象インストールソフト数",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  field_style: "text-align: right;",
  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "AF"
  }
}, {
  id: "number_of_installation_software_licenses_attached",
  label: "インストールソフト-ライセンスの紐付数",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  field_style: "text-align: right;",
  field_type: "number",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "AG"
  }
}, {
  id: "linkage_ratio",
  label: "紐付率",
  type: types.INPUT,
  read_only: true,

  field_style: "text-align: right;",
  label_style: "background-color: #CCCCCC !important;",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "AA"
  }
}, {
  id: "last_linkage_ratio",
  label: "前回紐付率",
  type: types.INPUT,
  read_only: true,
  field_style: "text-align: right;",
  label_style: "background-color: #CCCCCC !important;",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report: "AB"
  }
}, {
  id: "new_or_resubmit",
  label: "新規/再提出",
  type: types.SELECT_BOX,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  options: ["新規", "再提出"],
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report_form: "C7"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}, { id: "a_seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "syubetu",
  label: "種別",
  type: types.SELECT_BOX,
  options: ["機器・組込情報", "証書情報"],
  import: { enabled: true }
}, {
  id: "control_number",
  label: "管理番号",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "toroku_number",
  label: "申請No",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "bulk_toroku_number",
  label: "一括編集No",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant_team",
  label: "申請者チーム",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "update_name",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "next_approver",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant_label",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "update_name_label",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "next_approver_label",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "create_time",
  label: "開始日時",
  type: types.CURRENT_TIME,
  import: { enabled: true }
}, {
  id: "update_time",
  label: "更新日時",
  type: types.CURRENT_TIME,
  import: { enabled: true }
}, {
  id: "licensed_department",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_department",
  import: { enabled: true }
}, {
  id: "status_0",
  label: "状態0",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_1",
  label: "所属チーム1",

  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_1_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_1",
  label: "承認者1",

  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_1_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_1",
    compare_api_key: "team",
    filter_data_on_event: "team_1_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_1",
  label: "状態1",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_2",
  label: "所属チーム2",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_2_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_1_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_2",
  label: "承認者2",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_2_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_2",
    compare_api_key: "team",
    filter_data_on_event: "team_2_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_2",
  label: "状態2",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_3",
  label: "所属チーム3",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_3_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_2_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_3",
  label: "承認者3",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_3_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_3",
    compare_api_key: "team",
    filter_data_on_event: "team_3_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_3",
  label: "状態3",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_4",
  label: "所属チーム4",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_4_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_3_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_4",
  label: "承認者4",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_4_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_4",
    compare_api_key: "team",
    filter_data_on_event: "team_4_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_4",
  label: "状態4",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_5",
  label: "所属チーム5",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_5_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_4_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_5",
  label: "承認者5",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",

  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_5",
    compare_api_key: "team",
    filter_data_on_event: "team_5_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_5",
  label: "状態5",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_6",
  label: "所属チーム6",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_6_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_5_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_6",
  label: "承認者6",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_6_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_6",
    compare_api_key: "team",
    filter_data_on_event: "team_6_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_6",
  label: "状態6",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_7",
  label: "所属チーム7",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_7_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_6_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_7",
  label: "承認者7",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_7_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_7",
    compare_api_key: "team",
    filter_data_on_event: "team_7_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_7",
  label: "状態7",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_8",
  label: "所属チーム8",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_8_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_7_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_8",
  label: "承認者8",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_8_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_8",
    compare_api_key: "team",
    filter_data_on_event: "team_8_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_8",
  label: "状態8",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_9",
  label: "所属チーム9",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_9_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_8_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_9",
  label: "承認者9",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_9_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_9",
    compare_api_key: "team",
    filter_data_on_event: "team_9_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_9",
  label: "状態9",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_10",
  label: "所属チーム10",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_10_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_9_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_10",
  label: "承認者10",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_10_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_10",
    compare_api_key: "team",
    filter_data_on_event: "team_10_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_10",
  label: "状態10",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_11",
  label: "所属チーム11",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_11_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_10_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_11",
  label: "承認者11",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_11_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_11",
    compare_api_key: "team",
    filter_data_on_event: "team_11_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_11",
  label: "状態11",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_12",
  label: "所属チーム12",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_12_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_11_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_12",
  label: "承認者12",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_12_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_12",
    compare_api_key: "team",
    filter_data_on_event: "team_12_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_12",
  label: "状態12",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_13",
  label: "所属チーム13",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_13_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_12_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_13",
  label: "承認者13",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_13_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_13",
    compare_api_key: "team",
    filter_data_on_event: "team_13_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_13",
  label: "状態13",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_14",
  label: "所属チーム14",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_14_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_13_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_14",
  label: "承認者14",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_14_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_14",
    compare_api_key: "team",
    filter_data_on_event: "team_14_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_14",
  label: "状態14",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_15",
  label: "所属チーム15",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_15_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_14_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_15",
  label: "承認者15",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_15_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_15",
    compare_api_key: "team",
    filter_data_on_event: "team_15_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_15",
  label: "状態15",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_16",
  label: "所属チーム16",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_16_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_15_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_16",
  label: "承認者16",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_16_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_16",
    compare_api_key: "team",
    filter_data_on_event: "team_16_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_16",
  label: "状態16",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_17",
  label: "所属チーム17",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_17_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_16_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_17",
  label: "承認者17",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_17_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_17",
    compare_api_key: "team",
    filter_data_on_event: "team_17_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_17",
  label: "状態17",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_18",
  label: "所属チーム18",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_18_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_17_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_18",
  label: "承認者18",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_18_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_18",
    compare_api_key: "team",
    filter_data_on_event: "team_18_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_18",
  label: "状態18",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_19",
  label: "所属チーム19",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_19_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_18_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_19",
  label: "承認者19",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_19_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_19",
    compare_api_key: "team",
    filter_data_on_event: "team_19_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_19",
  label: "状態19",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "team_20",
  label: "所属チーム20",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_20_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_19_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_20",
  label: "承認者20",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",

  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_20",
    compare_api_key: "team",
    filter_data_on_event: "team_20_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_20",
  label: "状態20",
  type: types.INPUT,
  import: { enabled: true },
  table_field_style: {
    "承認済": "color:;",
    "未承認": "color:blue;",
    "差戻": "color:red;"
  }
}, {
  id: "created_by_label",
  label: "報告者",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  import: { enabled: true },
  export: {
    enabled: true,
    inventory_report_form: "C12"
  }
}, {
  id: "created_by_name",
  label: "報告者",
  type: types.INPUT,
  read_only: true,
  label_style: "background-color: #CCCCCC !important;",
  import: { enabled: true },
  export: {
    enabled: true
  }
}, {
  id: "approver_1_label",
  label: "承認者1",

  type: types.INPUT
}, {
  id: "approver_2_label",
  label: "承認者2",

  type: types.INPUT
}, {
  id: "approver_3_label",
  label: "承認者3",

  type: types.INPUT
}, {
  id: "approver_4_label",
  label: "承認者4",

  type: types.INPUT
}, {
  id: "approver_5_label",
  label: "承認者5",

  type: types.INPUT
}, {
  id: "approver_6_label",
  label: "承認者6",

  type: types.INPUT
}, {
  id: "approver_7_label",
  label: "承認者7",

  type: types.INPUT
}, {
  id: "approver_8_label",
  label: "承認者8",

  type: types.INPUT
}, {
  id: "approver_9_label",
  label: "承認者9",

  type: types.INPUT
}, {
  id: "approver_10_label",
  label: "承認者10",

  type: types.INPUT
}, {
  id: "approver_11_label",
  label: "承認者11",

  type: types.INPUT
}, {
  id: "approver_12_label",
  label: "承認者12",

  type: types.INPUT
}, {
  id: "approver_13_label",
  label: "承認者13",

  type: types.INPUT
}, {
  id: "approver_14_label",
  label: "承認者14",

  type: types.INPUT
}, {
  id: "approver_15_label",
  label: "承認者15",

  type: types.INPUT
}, {
  id: "approver_16_label",
  label: "承認者16",

  type: types.INPUT
}, {
  id: "approver_17_label",
  label: "承認者17",

  type: types.INPUT
}, {
  id: "approver_18_label",
  label: "承認者18",

  type: types.INPUT
}, {
  id: "approver_19_label",
  label: "承認者19",

  type: types.INPUT
}, {
  id: "approver_20_label",
  label: "承認者20",

  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  DATETIME_PICKER: "datetime_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var tab_name = "notice";
var arr = [{
  id: "from_user",
  label: "送信者",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  api_tab_label: "from_user_shimei",
  api_mode: "on_new_set_logged_user_no_edit",
  tab_size: 20
}, {
  id: "to_company",
  label: "所管会社",
  type: types.SELECT_BOX4,
  page_controller: true,
  api_uniq_grouping: true,
  default_from_local_storage: "userCompany",
  api: "/master_company/list_company_name"
}, {
  id: "to_department",
  label: "所管部署",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_department",
  limit_department_on_search: true,
  default_from_local_storage: "userDepartment",
  page_controller: true,
  api_uniq_grouping: true,
  search_option: {
    define_department_limit_to_key: "license_jurisdiction_team"
  }
}, {
  id: "to_team",
  label: "所管チーム",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_team_and_department",
  api_field_name: "team",
  default_from_local_storage: "userTeam",
  api_uniq_grouping: true,
  limit_department_on_search: true,
  page_controller: true,
  search_option: {
    define_department_limit_by_key: "licensed_department",
    api_field_name: "department"
  }
}, {
  id: "to_user",
  label: "ユーザ名",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  api_tab_label: "to_user_shimei",
  page_controller: true,
  page_controller_use_key_name: true,
  api_complement_array: [{ user_id: "all_users", user_shimei: "全ユーザ", to_user_shimei: "全ユーザ" }],
  style: "max-width: 160px;",
  tab_size: 20
}, {
  id: "from_user_shimei",
  label: "送信者*",
  type: types.INPUT
}, {
  id: "to_user_shimei",
  label: "宛先*",
  type: types.INPUT
}, {
  id: "is_history",
  label: "is_history",
  type: types.INPUT
}, {
  id: "message",
  label: "内容",
  field_style: "",
  type: types.TEXT_AREA,
  tab_size: 60
}, {
  id: "importance",
  label: "メッセージの重要度",
  type: types.SELECT_BOX2,
  options: [{
    label: "緊急",
    value: 9,
    style: "color:red"
  }, {
    label: "重要",
    value: 6,
    style: ""
  }, {
    label: "連絡",
    value: 3,
    style: ""
  }],
  tab_size: 5
}, {
  id: "history_date",
  label: "削除日",
  type: types.INPUT,
  tab_size: 5
}, {
  id: "create_date",
  label: "登録日",
  type: types.DATE_PICKER,
  tab_size: 5
}, {
  id: "message_schedule",
  label: "メッセージ追加日時",
  type: types.DATETIME_PICKER,
  tab_size: 5
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];

var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "authentication_mode",
  label: "認証モード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "C"
  }
}, {
  id: "permission_mode",
  label: "権限モード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "D"
  }
}, {
  id: "ldap_host",
  label: "LDAPホスト",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "A"
  }
}, {
  id: "number_of_login_attempts",
  label: "ログイン試行回数",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "B"
  }
}, {
  id: "unlimited_account_lock_flag",
  label: "無制限アカウントロックフラグ",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "C"
  }
}, {
  id: "login_lock_time",
  label: "ログインロック時間（分）",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "D"
  }
}, {
  id: "password_expiration_date",
  label: "パスワード有効期限（日）",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "A"
  }
}, {
  id: "password_syntax",
  label: "パスワード構文（正規表現）",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "B"
  }
}, {
  id: "maximum_number_of_passwords",
  label: "パスワード最大値数",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "C"
  }
}, {
  id: "minimum_number_of_passwords",
  label: "パスワード最小値数",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "D"
  }
}, {
  id: "directory_to_be_viewed",
  label: "監視対象ディレクトリ（セミコロン区切り）",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "A"
  }
}, {
  id: "log_level",
  label: "ログレベル",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "C"
  }
}, {
  id: "log_cycle",
  label: "ログ周期",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "D"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1012),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64b76e4f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1007),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60c14860",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(732)
  __webpack_require__(733)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1015),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66908d36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(996),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58ec6eda",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  translations: {
    'ar': {
      'months': {
        'original': ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوڤمبر', 'ديسمبر'],
        'abbr': ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوڤمبر', 'ديسمبر']
      },
      'days': ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت']
    },
    'da': {
      'months': {
        'original': ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
        'abbr': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
      },
      'days': ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø']
    },

    'en': {
      'months': {
        'original': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        'abbr': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
      'days': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    },

    'es': {
      'months': {
        'original': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        'abbr': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
      },
      'days': ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sab']
    },

    'fi': {
      'months': {
        'original': ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
        'abbr': ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu']
      },
      'days': ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la']
    },

    'fr': {
      'months': {
        'original': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        'abbr': ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc']
      },
      'days': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
    },

    'hu': {
      'months': {
        'original': ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
        'abbr': ['Jan', 'Febr', 'Márc', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szept', 'Okt', 'Nov', 'Dec']
      },
      'days': ['Vas', 'Hét', 'Ke', 'Sze', 'Csü', 'Pén', 'Szo']
    },

    'hr': {
      'months': {
        'original': ['Siječanj', 'Veljača', 'Ožujak', 'Travanj', 'Svibanj', 'Lipanj', 'Srpanj', 'Kolovoz', 'Rujan', 'Listopad', 'Studeni', 'Prosinac'],
        'abbr': ['Sij', 'Velj', 'Ožu', 'Tra', 'Svi', 'Lip', 'Srp', 'Kol', 'Ruj', 'Lis', 'Stu', 'Pro']
      },
      'days': ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub']
    },

    'id': {
      'months': {
        'original': ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
        'abbr': ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']
      },
      'days': ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']
    },

    'it': {
      'months': {
        'original': ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
        'abbr': ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
      },
      'days': ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab']
    },

    'lt': {
      'months': {
        'original': ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
        'abbr': ['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rugp', 'Rugs', 'Spa', 'Lap', 'Gru']
      },
      'days': ['Sek', 'Pir', 'Ant', 'Tre', 'Ket', 'Pen', 'Šeš']
    },

    'nl': {
      'months': {
        'original': ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
        'abbr': ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec']
      },
      'days': ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']
    },

    'de': {
      'months': {
        'original': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        'abbr': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
      },
      'days': ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.']
    },

    'pt-br': {
      'months': {
        'original': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        'abbr': ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      },
      'days': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
    },

    'vi': {
      'months': {
        'original': ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
        'abbr': ['T 01', 'T 02', 'T 03', 'T 04', 'T 05', 'T 06', 'T 07', 'T 08', 'T 09', 'T 10', 'T 11', 'T 12']
      },
      'days': ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']
    },

    'zh': {
      'months': {
        'original': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        'abbr': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      },
      'days': ['日', '一', '二', '三', '四', '五', '六']
    },

    'ja': {
      'months': {
        'original': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        'abbr': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      },
      'days': ['日', '月', '火', '水', '木', '金', '土']
    },

    'he': {
      'months': {
        'original': ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
        'abbr': ['ינו', 'פבר', 'מרץ', 'אפר', 'מאי', 'יונ', 'יול', 'אוג', 'ספט', 'אוק', 'נוב', 'דצמ']
      },
      'days': ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']
    },

    'cs': {
      'months': {
        'original': ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'],
        'abbr': ['led', 'úno', 'bře', 'dub', 'kvě', 'čer', 'čec', 'srp', 'zář', 'říj', 'lis', 'pro']
      },
      'days': ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so']
    },

    'sk': {
      'months': {
        'original': ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december'],
        'abbr': ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec']
      },
      'days': ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so']
    },

    'ru': {
      'months': {
        'original': ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        'abbr': ['Янв', 'Февр', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек']
      },
      'days': ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    },

    'uk': {
      'months': {
        'original': ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
        'abbr': ['Січ', 'Лют', 'Бер', 'Квіт', 'Трав', 'Чер', 'Лип', 'Серп', 'Вер', 'Жовт', 'Лист', 'Груд']
      },
      'days': ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    },

    'bg': {
      'months': {
        'original': ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'],
        'abbr': ['Ян', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек']
      },
      'days': ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    },

    'sv': {
      'months': {
        'original': ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
        'abbr': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
      'days': ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör']
    },

    'th': {
      'months': {
        'original': ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        'abbr': ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
      },
      'days': ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส']
    },

    'ro': {
      'months': {
        'original': ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'],
        'abbr': ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec']
      },
      'days': ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S']
    },

    'sl-si': {
      'months': {
        'original': ['Januar', 'Februar', 'Marec', 'April', 'Maj', 'Junij', 'Julij', 'Avgust', 'September', 'Oktober', 'November', 'December'],
        'abbr': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec']
      },
      'days': ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob']
    },

    'pl': {
      'months': {
        'original': ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        'abbr': ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru']
      },
      'days': ['Nd', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob']
    },

    'nb-no': {
      'months': {
        'original': ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
        'abbr': ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des']
      },
      'days': ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø']
    },

    'ee': {
      'months': {
        'original': ['Jaanuar', 'Veebruar', 'Märts', 'Aprill', 'Mai', 'Juuni', 'Juuli', 'August', 'September', 'Oktoober', 'November', 'Detsember'],
        'abbr': ['Jaan', 'Veebr', 'Märts', 'Apr', 'Mai', 'Juuni', 'Juuli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dets']
      },
      'days': ['P', 'E', 'T', 'K', 'N', 'R', 'L']
    },

    'ko': {
      'months': {
        'original': ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        'abbr': ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
      },
      'days': ['일', '월', '화', '수', '목', '금', '토']
    },
    'tr': {
      'months': {
        'original': ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
        'abbr': ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara']
      },
      'days': ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz']
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filed_types; });
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  CHECKBOX: "checkbox",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  DATETIME_PICKER: "datetime_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  SPACE: "space",
  BUTTON: "button",
  EMAIL: "email"
};

var filed_types = types;

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fields */
/* unused harmony export filed_types */
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT
}, {
  id: "fk_id",
  label: "fk_id",
  type: types.INPUT
}, {
  id: "tab_id",
  label: "tab_id",
  type: types.INPUT
}, {
  id: "ref_id",
  label: "証書管理番号",
  type: types.INPUT,
  import: {
    enabled: true,
    alias: ["証書管理番号\r\n(必須)"]
  }
}, {
  id: "req_seq",
  tab_size: 10,
  label: "証書管理番号(old)",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "number_cert",
  tab_size: 15,
  label: "証書管理番号",
  type: types.INPUT,
  import: {
    enabled: true
  }
}, {
  id: "license_name",
  label: "ライセンス名",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true }
}, {
  id: "software_name",
  label: "ソフトウェア名",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api: "/master_software/list_software_name",

  api_filter_bus_key: "associated_device_manufacture_name_software_name",
  import: { enabled: true }
}, {
  id: "product_key",
  label: "プロダクトキー",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "upgrade",
  label: "アップグレード",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  default_value: "無",
  import: {
    enabled: true,
    alias: ["アップグレード\r\n(有/無)"]
  }
}, {
  id: "unlimited",
  label: "無制限",
  type: types.SELECT_BOX,
  no_blank: true,
  default_value: "ー",
  options: ["無制限", "ー"],
  import: {
    enabled: true,
    alias: ["無制限\r\n(無制限/-)"]
  }
}, {
  id: "license",
  label: "使用するライセンス数",
  type: types.INPUT,
  error_if_blank: true,
  field_type: "number",
  min_value: "0",
  import: { enabled: true }
}, {
  id: "number_of_upgrades",
  label: "アップグレード数",
  type: types.INPUT,
  field_type: "number",
  min_value: "0",
  import: { enabled: true }
}, {
  id: "effective_number",
  label: "有効数",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "second",
  label: "セカンド",
  tab_size: 10,
  type: types.SELECT_BOX,
  default_value: "無",
  options: ["有", "無"],
  import: { enabled: true }
}, {
  id: "maximum_usable_number",
  label: "最大使用可能数",
  tab_size: 10,
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "number_of_use",
  label: "使用数",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "the_number_of_remaining",
  label: "残数",
  type: types.INPUT,
  tab_size: 20,
  import: { enabled: true }
}, {
  id: "second_number",
  label: "セカンド数",
  type: types.INPUT,
  field_type: "number",
  min_value: "0",
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT
}, {
  id: "device_control_number",
  label: "機器管理番号",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "computer_name",
  label: "コンピュータ名",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "virtual_environment",
  label: "仮想環境",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "virtual_base_unit",
  label: "仮想基盤の親機",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "equipment_in_charge_department",
  label: "所管部署",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "equipment_in_charge_team",
  label: "所管チーム",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "equipment_in_charge_classification",
  label: "機器所管区分",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "equipment_in_charge_system",
  label: "所管システム",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "leasing_or_rental",
  label: "リース/レンタル",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "manufacture_name",
  label: "メーカ名",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "model_name",
  label: "機種名",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "equipment_classification",
  label: "機器区分",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "cpu_count",
  label: "CPU数",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "remarks",
  label: "備考",
  type: types.TEXT_AREA,
  import: { enabled: true }
}, {
  id: "installation_department",
  label: "設置部署",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "installation_team",
  label: "設置チーム",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "installation_base",
  label: "設置拠点",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "floor",
  label: "フロア",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "user_name",
  label: "使用者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "registration_date",
  label: "登録日",
  type: types.DATE_PICKER
}, {
  id: "last_update_date",
  label: "最終更新日",
  type: types.DATE_PICKER
}, {
  id: "management_person_name",
  label: "管理担当者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* unused harmony export filed_types */
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "certificate_management_number",
  label: "証書管理番号",
  type: types.INPUT,
  listen_for_value: "management_number_force_update",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "D"
  }
}, {
  id: "license_certificate_type",
  label: "ライセンス証書種類",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "certificate_individual_number",
  label: "証書個別番号",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "sales_company",
  label: "販売会社",
  type: types.SELECT_BOX4,
  listen_for_value: "maker_force_update",
  api_uniq_grouping: true,
  event_emit_bus_key: "associated_device_manufacture_name_software_name",
  api: "/master_maker/list_maker_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "remark",
  label: "備考",
  type: types.TEXT_AREA,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
  EMAIL: "email"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "差戻"],
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "fk_id",
  label: "fk_id",
  type: types.INPUT
}, {
  id: "tab_id",
  label: "tab_id",
  type: types.INPUT
}, {
  id: "ref_id",
  label: "ref_id",
  type: types.INPUT
}, {
  id: "syubetu",
  label: "種別",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "control_number",
  label: "ID",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "toroku_number",
  label: "申請No",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "update_name",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "next_approver",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant_label",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "next_approver_label",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "update_name_label",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "create_time",
  label: "開始日時",
  type: types.CURRENT_TIME,
  import: { enabled: true }
}, {
  id: "update_time",
  label: "更新日時",
  type: types.CURRENT_TIME,
  import: { enabled: true }
}, {
  id: "licensed_department",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_department",
  import: { enabled: true }
}, {
  id: "application_date",
  label: "申請日",
  type: types.DATE_PICKER
}, {
  id: "correspondence_situation",
  label: "対応状況",
  type: types.SELECT_BOX,
  options: ["未対応", "差戻", "対応完了"],
  import: { enabled: true }
}, {
  id: "name",
  label: "ユーザ氏名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "mail_address",
  label: "メールアドレス",
  type: types.EMAIL,
  options: ["@mizuhofg.co.jp", "@mizuho-bk.co.jp", "@mizuhotb.co.jp"],
  import: { enabled: true }
}, {
  id: "user_id",
  label: "ユーザID",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "role",
  label: "役割",
  type: types.SELECT_BOX,
  options: ["ユーザIDオペレーション担当者"],
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}, {
  id: "record_checked",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}, {
  id: "status_0",
  label: "状態0",
  type: types.SELECT_BOX,
  options: ["申請中", "差戻"],
  import: { enabled: true }
}, {
  id: "team_1",
  label: "所属チーム1",

  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_1_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_1",
  label: "承認者1",

  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  api_filter_to_other_field: {
    by_field: "team_1",
    compare_api_key: "team",
    filter_data_on_event: "team_1_selected"
  },
  import: { enabled: true }
}, {
  id: "status_1",
  label: "状態1",
  type: types.SELECT_BOX,
  options: ["承認済", "未承認", "差戻"],
  import: { enabled: true }
}, {
  id: "team_2",
  label: "所属チーム2",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_2_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_2",
  label: "承認者2",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  api_filter_to_other_field: {
    by_field: "team_2",
    compare_api_key: "team",
    filter_data_on_event: "team_2_selected"
  },
  import: { enabled: true }
}, {
  id: "status_2",
  label: "状態2",
  type: types.SELECT_BOX,
  options: ["承認済", "未承認", "差戻"],
  import: { enabled: true }
}, {
  id: "team_3",
  label: "所属チーム3",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_3_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_3",
  label: "承認者3",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  api_filter_to_other_field: {
    by_field: "team_3",
    compare_api_key: "team",
    filter_data_on_event: "team_3_selected"
  },
  import: { enabled: true }
}, {
  id: "status_3",
  label: "状態3",
  type: types.SELECT_BOX,
  options: ["承認済", "未承認", "差戻"],
  import: { enabled: true }
}, {
  id: "team_4",
  label: "所属チーム4",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_4_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_4",
  label: "承認者4",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  api_filter_to_other_field: {
    by_field: "team_4",
    compare_api_key: "team",
    filter_data_on_event: "team_4_selected"
  },
  import: { enabled: true }
}, {
  id: "status_4",
  label: "状態4",
  type: types.SELECT_BOX,
  options: ["承認済", "未承認", "差戻"],
  import: { enabled: true }
}, {
  id: "team_5",
  label: "所属チーム5",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_5_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_5",
  label: "承認者5",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  api_filter_to_other_field: {
    by_field: "team_5",
    compare_api_key: "team",
    filter_data_on_event: "team_5_selected"
  },
  import: { enabled: true }
}, {
  id: "status_5",
  label: "状態5",
  type: types.SELECT_BOX,
  options: ["承認済", "未承認", "差戻"],
  import: { enabled: true }
}, {
  id: "approver_final",
  label: "最終承認者",

  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",

  import: { enabled: true }
}, {
  id: "status_final",
  label: "状態6",
  type: types.SELECT_BOX,
  options: ["承認済", "未承認", "差戻"],
  import: { enabled: true }
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "company",
  label: "所属会社",
  type: types.SELECT_BOX4,
  api: "/master_company/list_company_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_belongs: "A"
  }
}, {
  id: "department",
  label: "部署名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_belongs: "C"
  }
}, {
  id: "team",
  label: "チーム名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_belongs: "E"
  }
}, {
  id: "team_code",
  label: "チームコード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_belongs: "D"
  }
}, {
  id: "department_code",
  label: "部署コード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_belongs: "B"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "current_password",
  label: "現在のパスワード",
  type: types.PASSWORD,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "A"
  }
}, {
  id: "new_password",
  label: "新しいパスワード",
  type: types.PASSWORD,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "B"
  }
}, {
  id: "confirm_password",
  label: "新しいパスワード(確認)",
  type: types.PASSWORD,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "C"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "company_id",
  label: "会社コード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_company: "A"
  }
}, {
  id: "company_name",
  label: "会社名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_company: "B"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "comprehensive_contract_code",
  label: "包括契約コード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_comprehensive_contract: "A"
  }
}, {
  id: "comprehensive_contract_name",
  label: "包括契約名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_comprehensive_contract: "B"
  }
}, {
  id: "maker_name",
  label: "メーカー名",
  type: types.SELECT_BOX4,
  api: "/master_maker/list_maker_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_comprehensive_contract: "C"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "reporting_period",
  label: "報告期分",
  error_if_blank: true,
  type: types.INPUT
}, {
  id: "expiration_date_start",
  label: "開始期限",
  error_if_blank: true,
  type: types.DATE_PICKER,
  export: { enabled: true, sequence: 1000 }
}, {
  id: "expiration_date_end",
  label: "終了期限",
  error_if_blank: true,
  type: types.DATE_PICKER,
  export: { enabled: true, sequence: 1000 }
}, {
  id: "last_reporting_period",
  label: "前回報告期分",
  type: types.SELECT_BOX4,
  api: "/master_inventory_reporting_period/list_reporting_period",
  export: { enabled: true, sequence: 1000 }
}, {
  id: "editable",
  label: "編集許可",
  error_if_blank: true,
  type: types.SELECT_BOX,
  default_value: "許可",
  options: ["許可", "不許可"],
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "esma_code",
  label: "e-smaコード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_maker: "A"
  }
}, {
  id: "maker_code",
  label: "メーカコード",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "maker_name",
  label: "メーカ名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_maker: "B"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "esma_code",
  label: "e-smaコード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_software: "B"
  }
}, {
  id: "software_code",
  label: "ソフトウェアコード",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "software_name",
  label: "ソフトウェア名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_software: "C"
  }
}, {
  id: "maker_code",
  label: "メーカコード",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "maker_name",
  label: "メーカ名",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  api: "/master_maker/list_maker_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_software: "D"
  }
}, {
  id: "software_category",
  label: "ソフトウェアカテゴリ",
  type: types.SELECT_BOX,
  options: ["アプリケーション", "OS", "ミドルウェア", "DBソフトウェア", "ウイルス対策", "その他"],
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    master_software: "A"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "category",
  label: "カテゴリー",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "category_name",
  label: "カテゴリー名",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "system_code",
  label: "システムコード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "A"
  }
}, {
  id: "system_name",
  label: "システム名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "B"
  }
}, {
  id: "company",
  label: "所管会社",
  type: types.SELECT_BOX4,

  page_controller: true,
  default_from_local_storage: "userCompany",
  api: "/master_company/list_company_name"
}, {
  id: "equipment_in_charge_department",
  label: "所管部署",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  api_uniq_grouping: true,
  sort_result: true,

  api: "/master_belongs/list_department",
  default_from_local_storage: "userDepartment",
  limit_department_on_search: false,
  limit_department_on_load: false,
  page_controller: true,

  search_option: {
    define_department_limit_to_key: "system_jurisdiction_team"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "C"
  }
}, {
  id: "system_jurisdiction_team",
  label: "所管チーム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  api_uniq_grouping: true,
  sort_result: true,

  default_from_local_storage: "userTeam",
  api: "/master_belongs/list_team_and_department",
  api_field_name: "team",
  limit_department_on_search: false,
  page_controller: true,
  search_option: {
    define_department_limit_by_key: "equipment_in_charge_department",
    api_field_name: "department"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    master_system: "D"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "program_code",
  label: "プログラムコード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    programs_and_permissions: "A"
  }
}, {
  id: "program_name",
  label: "プログラム名",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    programs_and_permissions: "B"
  }
}, {
  id: "order_id",
  label: "順序",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    programs_and_permissions: "C"
  }
}, {
  id: "program_link",
  label: "プログラムリンク",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    programs_and_permissions: "D"
  }
}, {
  id: "parent_program_code",
  label: "親プログラムコード",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    programs_and_permissions: "E"
  }
}, {
  id: "type",
  label: "種別",
  type: types.SELECT_BOX,
  options: ["画面", "画面（メニュー非表示）", "バッチ"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    programs_and_permissions: "F"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(753)
  __webpack_require__(754)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1035),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7931e154",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(788)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1068),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e4d1a702",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(746)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1028),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7118717f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1069),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e68e661e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1044),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-89b984d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00bca0fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1070),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ee33c5f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(714)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(999),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a9af484",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(719)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1003),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ed6e725",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1071),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f141d688",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(750)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1032),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78f6b51b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(948),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23c7f7c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(981),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bb1ea80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(993),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57917fcd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_constants__);










var ajax_debug = __WEBPACK_IMPORTED_MODULE_6_debug___default()("__esma:ajax");
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
var server_url = "/api";
var queue = __webpack_require__(796)(caching_worker, 1);

var cache = __webpack_require__(569).cache;
var from_cache_count = 0;

function caching_worker(arg, cb) {
  window.sessionStorage.setItem('last_event_time', new Date().getTime());
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(arg.data) == "object") {
    arg.data.selectedCompany = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("selectedCompany");
  }
  var cache_key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ path: arg.path, data: arg.data });
  var cached = cache.get(cache_key);

  if (cached != null) {
    from_cache_count++;

    if (cached.body.success == true) {
      return cb(null, cached.body.data);
    } else {
      return cb(cached.body.error, cached, cached.body.error_code || false);
    }
  }


  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(server_url + arg.path, arg.data, {
    method: "POST"
  }).then(function (response) {
    cache.set(cache_key, { body: response.body });
    if (response.body.success == true) {
      return cb(null, response.body.data);
    } else {
      return cb(response.body.error, response, response.body.error_code || false);
    }
  }, function (response) {
    return cb("サーバーへのアクセス中にエラーが発生しました。", null);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  serverUrl: server_url,
  get_version: function get_version(cb) {
    window.sessionStorage.setItem('last_event_time', new Date().getTime());
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("/static/version.txt").then(function (response) {
      if (response.status == 200) {
        console.log("VERSION", response.body);
        try {
          cb(response.body.split("\n")[0].split(":")[1].trim());
        } catch (error) {
          cb("--");
        }
      }
    });
  },
  get: function get(path, cb) {
    window.sessionStorage.setItem('last_event_time', new Date().getTime());
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(server_url + path).then(function (response) {
      ajax_debug("AJAX GET ON SUCCESS", response);
      if (response.body.success == true) {
        return cb(null, response.body.data);
      } else {
        return cb(response.body.error, response);
      }
    }, function (response) {
      ajax_debug("AJAX GET ON ERROR", response);
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);
    });
  },
  post_cached_queued: function post_cached_queued(path, data, cb) {
    queue.push({ path: path, data: data }, cb);
  },

  post_cached_ttl: function post_cached_ttl(path, data, ttl, cb) {
    window.sessionStorage.setItem('last_event_time', new Date().getTime());
    if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) == "object") {
      data.selectedCompany = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("selectedCompany");
    }
    var cache_key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ path: path, data: data });
    var cached = cache.get(cache_key);
    if (cached != null) {
      from_cache_count++;

      if (cached.body.success == true) {
        return cb(null, cached.body.data);
      } else {
        return cb(cached.body.error, cached, cached.body.error_code || false);
      }
    }

    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(server_url + path, data, {
      method: "POST"
    }).then(function (response) {
      ajax_debug("AJAX POST ON SUCCESS", response);
      if (response.body.success == true) {
        cache.set(cache_key, { body: response.body }, ttl);
        return cb(null, response.body.data);
      } else {
        return cb(response.body.error, response, response.body.error_code || false);
      }
    }, function (response) {
      console.log("AJAX POST ON ERROR", response);
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);
    });
  },
  post: function post(path, data, cb) {
    window.sessionStorage.setItem('last_event_time', new Date().getTime());
    if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) == "object") {
      data.selectedCompany = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("selectedCompany");
    }
    if (path.indexOf("/set/") > -1 || path.indexOf("delete") > -1) {
      cache.clear();
    }

    ajax_debug("Ajax post", path, data);

    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(server_url + path, data, {
      method: "POST"
    }).then(function (response) {
      ajax_debug("AJAX POST ON SUCCESS", response);
      if (response.body.success == true) {
        return cb(null, response.body.data);
      } else {
        return cb(response.body.error, response, response.body.error_code || false);
      }
    }, function (response) {
      console.log("AJAX POST ON ERROR", response);
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);
    });
  },
  postExtended: function postExtended(path, data, cb) {
    window.sessionStorage.setItem('last_event_time', new Date().getTime());
    if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) == "object") {
      data.selectedCompany = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("selectedCompany");
    }
    if (path.indexOf("/set/") > -1 || path.indexOf("delete") > -1) {
      cache.clear();
    }
    ajax_debug("test ajax post", path, data);
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(server_url + path, data, {
      method: "POST"
    }).then(function (response) {
      ajax_debug("AJAX POST ON SUCCESS", response);
      if (response.body.success == true) {
        return cb(null, response.body);
      } else {
        return cb(response.body.error, response);
      }
    }, function (response) {
      console.log("AJAX POST ON ERROR", response);
      return cb("サーバーへのアクセス中にエラーが発生しました。", null);
    });
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_login__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_menu__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_menu_master__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_menu_master___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_menu_master__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_menu_maintenance__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_menu_maintenance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_menu_maintenance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_menu_configuration__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_menu_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_menu_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_menu_certificate__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_menu_certificate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_menu_certificate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_menu_inventory__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_menu_inventory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_menu_inventory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_company__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_page_0001_reset_password__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_page_0001_reset_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_page_0001_reset_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_page_0002_login_expired__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_page_0002_login_expired___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_page_0002_login_expired__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_page_0010_device_embedded_information__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_page_0010_device_embedded_information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_page_0010_device_embedded_information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_page_0010_device_embedded_information_detail__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_page_0010_device_embedded_information_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_page_0010_device_embedded_information_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_page_0010_device_embedded_information_detail_bulk_edit__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_page_0010_device_embedded_information_detail_bulk_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_page_0010_device_embedded_information_detail_bulk_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_page_0015_device_embedded_information_pegging__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_page_0015_device_embedded_information_pegging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_page_0015_device_embedded_information_pegging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_page_0016_device_embedded_information_pegging2__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_page_0016_device_embedded_information_pegging2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_page_0016_device_embedded_information_pegging2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_page_0030_bulk_import__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_page_0030_bulk_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_page_0030_bulk_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_page_0020_surplus_license__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_page_0020_surplus_license___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_page_0020_surplus_license__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_page_0020_surplus_license_detail__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_page_0020_surplus_license_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_page_0020_surplus_license_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_page_0020_surplus_license_request__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_page_0020_surplus_license_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_page_0020_surplus_license_request__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_page_0040_certificate_software__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_page_0040_certificate_software___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_page_0040_certificate_software__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_page_0040_certificate_software_detail_bulk_edit__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_page_0040_certificate_software_detail_bulk_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_page_0040_certificate_software_detail_bulk_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_page_0040_certificate_software_linked_devices__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_page_0040_certificate_software_linked_devices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_page_0040_certificate_software_linked_devices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_page_0040_certificate_software_linked_devices_select__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_page_0040_certificate_software_linked_devices_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_page_0040_certificate_software_linked_devices_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_page_0040_certificate_information__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_page_0040_certificate_information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_page_0040_certificate_information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_page_0040_certificate_information_detail__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_page_0040_certificate_information_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_page_0040_certificate_information_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_page_0040_certificate_information_pegging__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_page_0040_certificate_information_pegging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_page_0040_certificate_information_pegging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_page_0040_certificate_information_pegging_choice__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_page_0040_certificate_information_pegging_choice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_page_0040_certificate_information_pegging_choice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_page_0040_certificate_information_detail_bulk_edit__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_page_0040_certificate_information_detail_bulk_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_page_0040_certificate_information_detail_bulk_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_page_0040_certificate_information_linked_devices__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_page_0040_certificate_information_linked_devices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_page_0040_certificate_information_linked_devices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_page_0040_certificate_information_linked_devices_select__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_page_0040_certificate_information_linked_devices_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_page_0040_certificate_information_linked_devices_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_page_0040_notification_certificate__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_page_0040_notification_certificate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_page_0040_notification_certificate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_page_0041_master_user__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_page_0041_master_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_page_0041_master_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_page_0041_master_user_detail__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_page_0041_master_user_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_page_0041_master_user_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_page_0041_master_user_detail_bulk_edit__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_page_0041_master_user_detail_bulk_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_page_0041_master_user_detail_bulk_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_page_0041_master_belongs_detail__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_page_0041_master_belongs_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_page_0041_master_belongs_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_page_0041_master_belongs__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_page_0041_master_belongs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_page_0041_master_belongs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_page_0041_master_software_category_detail__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_page_0041_master_software_category_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_page_0041_master_software_category_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_page_0041_master_software_category__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_page_0041_master_software_category___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_page_0041_master_software_category__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_page_0041_master_company_detail__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_page_0041_master_company_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__pages_page_0041_master_company_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_page_0041_master_company__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_page_0041_master_company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__pages_page_0041_master_company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_page_0041_master_comprehensive_contract_detail__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_page_0041_master_comprehensive_contract_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__pages_page_0041_master_comprehensive_contract_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_page_0041_master_comprehensive_contract__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_page_0041_master_comprehensive_contract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__pages_page_0041_master_comprehensive_contract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_page_0041_master_software_detail__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_page_0041_master_software_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__pages_page_0041_master_software_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_page_0041_master_software__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_page_0041_master_software___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__pages_page_0041_master_software__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_page_0041_master_system_detail__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_page_0041_master_system_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__pages_page_0041_master_system_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_page_0041_master_system__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_page_0041_master_system___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__pages_page_0041_master_system__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_page_0041_master_maker__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_page_0041_master_maker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__pages_page_0041_master_maker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_page_0041_master_maker_detail__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_page_0041_master_maker_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__pages_page_0041_master_maker_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_page_0041_master_inventory_reporting_period__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_page_0041_master_inventory_reporting_period___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__pages_page_0041_master_inventory_reporting_period__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_page_0041_master_inventory_reporting_period_detail__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_page_0041_master_inventory_reporting_period_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__pages_page_0041_master_inventory_reporting_period_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_page_0041_master_change_password__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_page_0041_master_change_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__pages_page_0041_master_change_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_first_time_change_password__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_first_time_change_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__pages_first_time_change_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_page_0050_approval_history_detail__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_page_0050_approval_history_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__pages_page_0050_approval_history_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__pages_page_0050_id_approval_history__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__pages_page_0050_id_approval_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__pages_page_0050_id_approval_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pages_page_0051_approval_history_device_embedded_information_detail__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pages_page_0051_approval_history_device_embedded_information_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__pages_page_0051_approval_history_device_embedded_information_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pages_page_0060_redirect__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pages_page_0060_redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__pages_page_0060_redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pages_page_0071_inventory_report__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pages_page_0071_inventory_report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__pages_page_0071_inventory_report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__pages_page_0072_inventory_report_check__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__pages_page_0072_inventory_report_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__pages_page_0072_inventory_report_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__pages_page_0070_inventory_tabs__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__pages_page_0070_inventory_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__pages_page_0070_inventory_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__pages_page_0073_excess_deficiency_summary__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__pages_page_0073_excess_deficiency_summary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__pages_page_0073_excess_deficiency_summary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__pages_page_0080_system_setting_detail__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__pages_page_0080_system_setting_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__pages_page_0080_system_setting_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__pages_page_0080_browser_setting_detail__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__pages_page_0080_browser_setting_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__pages_page_0080_browser_setting_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__pages_page_0081_mail_message__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__pages_page_0081_mail_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__pages_page_0081_mail_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__pages_page_0081_mail_message_detail__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__pages_page_0081_mail_message_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__pages_page_0081_mail_message_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__pages_page_0081_mail_message_create__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__pages_page_0081_mail_message_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__pages_page_0081_mail_message_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__pages_page_0081_mail_message_users__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__pages_page_0081_mail_message_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__pages_page_0081_mail_message_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__pages_page_0090_notice__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__pages_page_0090_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__pages_page_0090_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__pages_page_0090_notice_detail__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__pages_page_0090_notice_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__pages_page_0090_notice_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__pages_page_0090_deposit_certificate_output__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__pages_page_0090_deposit_certificate_output___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__pages_page_0090_deposit_certificate_output__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__pages_page_0091_programs_and_permissions__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__pages_page_0091_programs_and_permissions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__pages_page_0091_programs_and_permissions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__pages_page_0091_programs_and_permissions_detail__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__pages_page_0091_programs_and_permissions_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__pages_page_0091_programs_and_permissions_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__pages_page_0092_reload__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__pages_page_0092_reload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__pages_page_0092_reload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__pages_page_0093_old_bulk_import__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__pages_page_0093_old_bulk_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__pages_page_0093_old_bulk_import__);








































































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_login___default.a,
    meta: {
      requiresAuth: false,
      isLogin: true
    }
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_login___default.a,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/logout/duo',
    name: 'LogoutDuo',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_login___default.a,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/expired',
    name: 'page_0002_login_expired',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_page_0002_login_expired___default.a,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/reset_password',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_page_0001_reset_password___default.a,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/company',
    name: 'Company',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_company___default.a,
    meta: {
      requiresAuth: true,
      isPreLogin: true
    }
  }, {
    path: '/change_password/expired',
    name: 'first_time_change_password_expired',
    component: __WEBPACK_IMPORTED_MODULE_54__pages_first_time_change_password___default.a,
    meta: {
      requiresAuth: true,
      isPreLogin: true,
      password_expired: true
    }
  }, {
    path: '/change_password',
    name: 'first_time_change_password',
    component: __WEBPACK_IMPORTED_MODULE_54__pages_first_time_change_password___default.a,
    meta: {
      requiresAuth: true,
      isPreLogin: true
    }
  }, {
    path: '/redirect',
    name: 'page_0060_redirect',
    component: __WEBPACK_IMPORTED_MODULE_59__pages_page_0060_redirect___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/inventory',
    name: 'page_0070_inventory_tabs',
    component: __WEBPACK_IMPORTED_MODULE_62__pages_page_0070_inventory_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "inventory_management",
      tab_index: 0
    }
  }, {
    path: '/inventory_management',
    name: 'page_0070_inventory_tabs_management',
    component: __WEBPACK_IMPORTED_MODULE_62__pages_page_0070_inventory_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "inventory_management",
      tab_index: 0
    }
  }, {
    path: '/inventory_certificate_list',
    name: 'page_0070_inventory_tabs_certificate_list',
    component: __WEBPACK_IMPORTED_MODULE_62__pages_page_0070_inventory_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "inventory_certificate_list",
      tab_index: 1
    }
  }, {
    path: '/inventory_pending_items',
    name: 'page_0070_inventory_tabs_pending_items',
    component: __WEBPACK_IMPORTED_MODULE_62__pages_page_0070_inventory_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "inventory_pending_items",
      tab_index: 2
    }
  }, {
    path: '/inventory_report',
    name: 'page_0071_inventory_report',
    component: __WEBPACK_IMPORTED_MODULE_60__pages_page_0071_inventory_report___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/inventory_report_check',
    name: 'page_0072_inventory_report_check',
    component: __WEBPACK_IMPORTED_MODULE_61__pages_page_0072_inventory_report_check___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/excess_deficiency_summary',
    name: 'page_0073_excess_deficiency_summary',
    component: __WEBPACK_IMPORTED_MODULE_63__pages_page_0073_excess_deficiency_summary___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information',
    name: 'page_0010_device_embedded_information',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_page_0010_device_embedded_information___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information/tab/:mode',
    name: 'page_0010_device_embedded_information_tab',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_page_0010_device_embedded_information___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information/clone/:seq_id',
    name: 'page_0010_device_embedded_information_detail_clone',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_page_0010_device_embedded_information_detail___default.a,
    meta: {
      load_by: "clone",
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information/:seq_id',
    name: 'page_0010_device_embedded_information_detail',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_page_0010_device_embedded_information_detail___default.a,
    meta: {
      load_by: "seq_id",
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information/bulk_edit/:p_id',
    name: 'page_0010_device_embedded_information_detail_bulk_edit',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_page_0010_device_embedded_information_detail_bulk_edit___default.a,
    meta: {
      load_by: "seq_id",
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information/approval/:approval_id/:fk_id',
    name: 'page_0010_device_embedded_information_detail_fk_id',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_page_0010_device_embedded_information_detail___default.a,
    meta: {
      load_by: "fk_id",
      approval_mode: true,
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information_pegging/:seq_id',
    name: 'page_0015_device_embedded_information_pegging',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_page_0015_device_embedded_information_pegging___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/device_embedded_information_pegging2',
    name: 'page_0016_device_embedded_information_pegging2',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_page_0016_device_embedded_information_pegging2___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/surplus_license',
    name: 'page_0020_surplus_license',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_page_0020_surplus_license___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/surplus_license/:seq_id',
    name: 'page_0020_surplus_license_detail',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_page_0020_surplus_license_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/surplus_license/review/:seq_id/:review_seq_id',
    name: 'page_0020_surplus_license_detail_review',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_page_0020_surplus_license_detail___default.a,
    meta: {
      load_by: "review",
      requiresAuth: true
    }
  }, {
    path: '/surplus_license_request',
    name: 'page_0020_surplus_license_request',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_page_0020_surplus_license_request___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/bulk_import',
    name: 'page_0030_bulk_import',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_page_0030_bulk_import___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/bulk_import/:page/:session_id',
    name: 'page_0030_bulk_import_by_id',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_page_0030_bulk_import___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate/tab/:mode',
    name: 'page_0040_certificate_software_tab',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_page_0040_certificate_software___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate',
    name: 'page_0040_certificate_software',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_page_0040_certificate_software___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate/n/:certificate_software_number',
    name: 'page_0040_certificate_software_detail_number',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail___default.a,
    meta: {
      load_by: "certificate_software_number",
      requiresAuth: true
    }
  }, {
    path: '/certificate/deposit/:seq_id',
    name: 'page_0040_certificate_software_detail_number_deposit',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail___default.a,
    meta: {
      load_by: "deposit_certificate_output",
      requiresAuth: true
    }
  }, {
    path: '/certificate/:seq_id',
    name: 'page_0040_certificate_software_detail',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate/clone/:seq_id',
    name: 'page_0040_certificate_software_detail_clone',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail___default.a,
    meta: {
      load_by: "clone",
      requiresAuth: true
    }
  }, {
    path: '/certificate/approval/:approval_id/:fk_id',
    name: 'page_0040_certificate_information_detail_fk_id',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_page_0040_certificate_software_detail___default.a,
    meta: {
      load_by: "fk_id",
      requiresAuth: true
    }
  }, {
    path: '/certificate_software_linked_devices/list/:req_certificate_software_seq_id',
    name: 'page_0040_certificate_software_linked_devices',
    component: __WEBPACK_IMPORTED_MODULE_24__pages_page_0040_certificate_software_linked_devices___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate_software_linked_devices/select/:req_certificate_software_seq_id',
    name: 'page_0040_certificate_software_linked_devices_select',
    component: __WEBPACK_IMPORTED_MODULE_25__pages_page_0040_certificate_software_linked_devices_select___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate/bulk_edit/:p_id',
    name: 'page_0040_certificate_software_detail_bulk_edit',
    component: __WEBPACK_IMPORTED_MODULE_23__pages_page_0040_certificate_software_detail_bulk_edit___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate_information',
    name: 'page_0040_certificate_information',
    component: __WEBPACK_IMPORTED_MODULE_26__pages_page_0040_certificate_information___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate_information/clone/:seq_id',
    name: 'page_0040_certificate_information_detail_clone',
    component: __WEBPACK_IMPORTED_MODULE_27__pages_page_0040_certificate_information_detail___default.a,
    meta: {
      load_by: "clone",
      requiresAuth: true
    }
  }, {
    path: '/certificate_information/:seq_id',
    name: 'page_0040_certificate_information_detail',
    component: __WEBPACK_IMPORTED_MODULE_27__pages_page_0040_certificate_information_detail___default.a,
    meta: {
      load_by: "seq_id",
      requiresAuth: true
    }
  }, {
    path: '/certificate_information_number/:certificate_information_number',
    name: 'page_0040_certificate_information_detail_by_number',
    component: __WEBPACK_IMPORTED_MODULE_27__pages_page_0040_certificate_information_detail___default.a,
    meta: {
      load_by: "certificate_information_number",
      requiresAuth: true
    }
  }, {
    path: '/certificate_information/approval/:approval_id/:fk_id',
    name: 'page_0040_certificate_information_detail_fk_id',
    component: __WEBPACK_IMPORTED_MODULE_27__pages_page_0040_certificate_information_detail___default.a,
    meta: {
      load_by: "fk_id",
      requiresAuth: true
    }
  }, {
    path: '/certificate_information_pegging',
    name: 'page_0040_certificate_information_pegging',
    component: __WEBPACK_IMPORTED_MODULE_28__pages_page_0040_certificate_information_pegging___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate_information_pegging_choice',
    name: 'page_0040_certificate_information_pegging_choice',
    component: __WEBPACK_IMPORTED_MODULE_29__pages_page_0040_certificate_information_pegging_choice___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate_information_linked_devices/list/:req_ad_seq_id/:cert_id',
    name: 'page_0040_certificate_information_linked_devices',
    component: __WEBPACK_IMPORTED_MODULE_31__pages_page_0040_certificate_information_linked_devices___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate_information_linked_devices/select/:req_ad_seq_id/:cert_id',
    name: 'page_0040_certificate_information_linked_devices_select',
    component: __WEBPACK_IMPORTED_MODULE_32__pages_page_0040_certificate_information_linked_devices_select___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/certificate_information/bulk_edit/:p_id',
    name: 'page_0040_certificate_information_detail_bulk_edit',
    component: __WEBPACK_IMPORTED_MODULE_30__pages_page_0040_certificate_information_detail_bulk_edit___default.a,
    meta: {
      load_by: "seq_id",
      requiresAuth: true
    }
  }, {
    path: '/notification_certificate/certificate_3_months',
    name: 'page_0040_notification_certificate1',
    component: __WEBPACK_IMPORTED_MODULE_33__pages_page_0040_notification_certificate___default.a,
    meta: {
      requiresAuth: true,
      mode: "certificate_that_expires_in_3_months"
    }
  }, {
    path: '/notification_certificate/certificate_expired',
    name: 'page_0040_notification_certificate2',
    component: __WEBPACK_IMPORTED_MODULE_33__pages_page_0040_notification_certificate___default.a,
    meta: {
      requiresAuth: true,
      mode: "certificate_expired_license"
    }
  }, {
    path: '/notification_certificate/surplus_3_months',
    name: 'page_0040_notification_certificate3',
    component: __WEBPACK_IMPORTED_MODULE_33__pages_page_0040_notification_certificate___default.a,
    meta: {
      requiresAuth: true,
      mode: "surplus_license_that_expires_in_3_months"
    }
  }, {
    path: '/notification_certificate/surplus_expired',
    name: 'page_0040_notification_certificate4',
    component: __WEBPACK_IMPORTED_MODULE_33__pages_page_0040_notification_certificate___default.a,
    meta: {
      requiresAuth: true,
      mode: "surplus_expired_license"
    }
  }, {
    path: '/expired',
    name: 'Expired',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_login___default.a,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/menu',
    name: 'menu',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_menu___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/menu_master',
    name: 'menu_master',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_menu_master___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/menu_maintenance',
    name: 'menu_maintenance',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_menu_maintenance___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/menu_configuration',
    name: 'menu_configuration',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_menu_configuration___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/menu_certificate',
    name: 'menu_certificate',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_menu_certificate___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/menu_inventory',
    name: 'menu_inventory',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_menu_inventory___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_change_password',
    name: 'page_0041_master_change_password',
    component: __WEBPACK_IMPORTED_MODULE_53__pages_page_0041_master_change_password___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_user/:seq_id',
    name: 'page_0041_master_user_detail',
    component: __WEBPACK_IMPORTED_MODULE_35__pages_page_0041_master_user_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_user',
    name: 'page_0041_master_user',
    component: __WEBPACK_IMPORTED_MODULE_34__pages_page_0041_master_user___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_user/bulk_edit/:p_id',
    name: 'page_0041_master_user_detail_bulk_edit',
    component: __WEBPACK_IMPORTED_MODULE_36__pages_page_0041_master_user_detail_bulk_edit___default.a,
    meta: {
      load_by: "seq_id",
      requiresAuth: true
    }
  }, {
    path: '/master_user/approval/:approval_id/:fk_id',
    name: 'page_0041_master_user_detail_bulk_detail_fk_bk',
    component: __WEBPACK_IMPORTED_MODULE_35__pages_page_0041_master_user_detail___default.a,
    meta: {
      load_by: "fk_id",
      requiresAuth: true
    }
  }, {
    path: '/master_belongs/:seq_id',
    name: 'page_0041_master_belongs_detail',
    component: __WEBPACK_IMPORTED_MODULE_37__pages_page_0041_master_belongs_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_belongs',
    name: 'page_0041_master_belongs',
    component: __WEBPACK_IMPORTED_MODULE_38__pages_page_0041_master_belongs___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_belongs/clone/:seq_id',
    name: 'page_0010_master_belongs_detail_clone',
    component: __WEBPACK_IMPORTED_MODULE_37__pages_page_0041_master_belongs_detail___default.a,
    meta: {
      load_by: "clone",
      requiresAuth: true
    }
  }, {
    path: '/master_software_category/:seq_id',
    name: 'page_0041_master_software_category_detail',
    component: __WEBPACK_IMPORTED_MODULE_39__pages_page_0041_master_software_category_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_software_category',
    name: 'page_0041_master_software_category',
    component: __WEBPACK_IMPORTED_MODULE_40__pages_page_0041_master_software_category___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_company/:seq_id',
    name: 'page_0041_master_company_detail',
    component: __WEBPACK_IMPORTED_MODULE_41__pages_page_0041_master_company_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_company',
    name: 'page_0041_master_company',
    component: __WEBPACK_IMPORTED_MODULE_42__pages_page_0041_master_company___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_software/:seq_id',
    name: 'page_0041_master_software_detail',
    component: __WEBPACK_IMPORTED_MODULE_45__pages_page_0041_master_software_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_software',
    name: 'page_0041_master_software',
    component: __WEBPACK_IMPORTED_MODULE_46__pages_page_0041_master_software___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_system/:seq_id',
    name: 'page_0041_master_system_detail',
    component: __WEBPACK_IMPORTED_MODULE_47__pages_page_0041_master_system_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_system',
    name: 'page_0041_master_system',
    component: __WEBPACK_IMPORTED_MODULE_48__pages_page_0041_master_system___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_maker/:seq_id',
    name: 'page_0041_master_maker_detail',
    component: __WEBPACK_IMPORTED_MODULE_50__pages_page_0041_master_maker_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_maker',
    name: 'page_0041_master_maker',
    component: __WEBPACK_IMPORTED_MODULE_49__pages_page_0041_master_maker___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/inventory_reporting_period_detail/:seq_id',
    name: 'page_0041_master_inventory_reporting_period_detail',
    component: __WEBPACK_IMPORTED_MODULE_52__pages_page_0041_master_inventory_reporting_period_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/inventory_reporting_period',
    name: 'page_0041_master_inventory_reporting_period',
    component: __WEBPACK_IMPORTED_MODULE_51__pages_page_0041_master_inventory_reporting_period___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_comprehensive_contract/:seq_id',
    name: 'page_0041_master_comprehensive_contract_detail',
    component: __WEBPACK_IMPORTED_MODULE_43__pages_page_0041_master_comprehensive_contract_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/master_comprehensive_contract',
    name: 'page_0041_master_comprehensive_contract',
    component: __WEBPACK_IMPORTED_MODULE_44__pages_page_0041_master_comprehensive_contract___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/approval_history',
    name: 'page_0050_approval_history_tabs',
    component: __WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "approval_history",
      tab_index: 0,
      mode: "normal"
    }
  }, {
    path: '/approval_history/toroku_filter/:bulk_toroku_number',
    name: 'page_0050_approval_history_tabs_toroku_filter',
    component: __WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "approval_history",
      tab_index: 0,
      mode: "toroku_filter"
    }
  }, {
    path: '/approval_history/all',
    name: 'page_0050_approval_history_tabs_all',
    component: __WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "approval_history_all",
      tab_index: 1,
      mode: "normal"
    }
  }, {
    path: '/approval_history/rejected',
    name: 'page_0050_approval_history_tabs_rejected',
    component: __WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "approval_history",
      tab_index: 0,
      mode: "rejected"
    }
  }, {
    path: '/approval_history/all/rejected',
    name: 'page_0050_approval_history_tabs_all_rejected',
    component: __WEBPACK_IMPORTED_MODULE_55__pages_page_0050_approval_history_tabs___default.a,
    meta: {
      requiresAuth: true,
      tab: "approval_history_all",
      tab_index: 1,
      mode: "rejected"
    }
  }, {
    path: '/approval_history/detail/:session_id/:validate',
    name: 'page_0050_approval_history_tabs_detail',
    component: __WEBPACK_IMPORTED_MODULE_56__pages_page_0050_approval_history_detail___default.a,
    meta: {
      requiresAuth: true,
      tab: "approval_history_all",
      tab_index: 1
    }
  }, {
    path: '/id_approval_history',
    name: 'page_0050_id_approval_history',
    component: __WEBPACK_IMPORTED_MODULE_57__pages_page_0050_id_approval_history___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/approval_history_device_embedded_information_detail/:seq_id',
    name: 'page_0051_approval_history_device_embedded_information_detail',
    component: __WEBPACK_IMPORTED_MODULE_58__pages_page_0051_approval_history_device_embedded_information_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/notice/:seq_id',
    name: 'page_0090_notice_detail',
    component: __WEBPACK_IMPORTED_MODULE_71__pages_page_0090_notice_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/notice',
    name: 'page_0090_notice',
    component: __WEBPACK_IMPORTED_MODULE_70__pages_page_0090_notice___default.a,
    meta: {
      requiresAuth: true,
      tab_index: 0
    }
  }, {
    path: '/system_setting',
    name: 'page_0080_system_setting',
    component: __WEBPACK_IMPORTED_MODULE_64__pages_page_0080_system_setting_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/browser_setting',
    name: 'page_0080_browser_setting',
    component: __WEBPACK_IMPORTED_MODULE_65__pages_page_0080_browser_setting_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/mail_message/:seq_id',
    name: 'page_0081_mail_message_detail',
    component: __WEBPACK_IMPORTED_MODULE_67__pages_page_0081_mail_message_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/mail_message_create/:seq_id',
    name: 'page_0081_mail_message_create',
    component: __WEBPACK_IMPORTED_MODULE_68__pages_page_0081_mail_message_create___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/mail_message_users/:seq_id',
    name: 'page_0081_mail_message_users',
    component: __WEBPACK_IMPORTED_MODULE_69__pages_page_0081_mail_message_users___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/mail_message',
    name: 'page_0081_mail_message',
    component: __WEBPACK_IMPORTED_MODULE_66__pages_page_0081_mail_message___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/notice_history',
    name: 'page_0090_notice_history',
    component: __WEBPACK_IMPORTED_MODULE_70__pages_page_0090_notice___default.a,
    meta: {
      requiresAuth: true,
      tab_index: 1
    }
  }, {
    path: '/programs_and_permissions/:seq_id',
    name: 'page_0091_programs_and_permissions_detail',
    component: __WEBPACK_IMPORTED_MODULE_74__pages_page_0091_programs_and_permissions_detail___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/programs_and_permissions',
    name: 'page_0091_programs_and_permissions',
    component: __WEBPACK_IMPORTED_MODULE_73__pages_page_0091_programs_and_permissions___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/deposit_certificate_output',
    name: 'page_0090_deposit_certificate_output',
    component: __WEBPACK_IMPORTED_MODULE_72__pages_page_0090_deposit_certificate_output___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/reload',
    name: 'page_0092_reload',
    component: __WEBPACK_IMPORTED_MODULE_75__pages_page_0092_reload___default.a,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/old_bulk_import',
    name: 'page_0093_old_bulk_import',
    component: __WEBPACK_IMPORTED_MODULE_76__pages_page_0093_old_bulk_import___default.a,
    meta: {
      requiresAuth: true
    }
  }]
});

var checkCookies = function checkCookies() {
  var found = 0;
  var s = document.cookie.split(";");
  s.forEach(function (c) {
    var kv = c.trim().split("=");
    if (kv[0] == "session_key" && kv[1].length > 70) {
      found++;
    }
    if (kv[0] == "session_user" && kv[1].length > 0) {
      found++;
    }
  });
  return found == 2;
};
var checkPreLoginCookies = function checkPreLoginCookies() {
  var found = 0;
  var s = document.cookie.split(";");
  s.forEach(function (c) {
    var kv = c.trim().split("=");
    if (kv[0] == "session_pre_login_key" && kv[1].length > 70) {
      found++;
    }
    if (kv[0] == "session_user" && kv[1].length > 0) {
      found++;
    }
  });
  return found == 2;
};

router.beforeEach(function (to, from, next) {
  if (to.meta.isLogin == true && checkCookies() == true) {
    next({
      path: '/menu'
    });
  } else if (to.meta.isPreLogin == true && checkPreLoginCookies() == true) {
    next();
  } else if (to.meta.isPreLogin == true && checkCookies() == true) {
    next({
      path: '/menu'
    });
  } else if (to.meta.isResetPassword == true && checkCookies() == true) {
    next({
      path: '/menu'
    });
  } else if (to.meta.requiresAuth == true && checkCookies() == false) {
    next({
      path: '/expired'
    });
  } else {
    console.log("router accessing page", to.name);
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);


var store_debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:store");

var server_url = "/api";
store_debug("TESTING STORE ", server_url);

var copy_allowed = function copy_allowed(allowed, data) {
    var ret = {};
    var i = 0;
    for (var d in data) {
        if (allowed.indexOf(d) > -1) {
            ret[d] = data[d];
            i++;
        }
    }
    if (i == 0) {
        ret = false;
    }
    return ret;
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        mdm_list: false,

        is_editing_batch: false,
        logged_user: "",
        show_message_after_login: true,
        server_url: server_url,
        row_data: [],

        is_editing_new: false,
        current_row: {},
        current_field_style: {},
        current_editing: [],
        last_filter_options: {},

        current_row2: {},
        current_field_style2: {},
        is_editing_new2: false,
        current_editing2: [],
        last_filter_options2: {},

        current_row3: {},
        current_field_style3: {},
        is_editing_new3: false,
        current_editing3: [],
        last_filter_options3: {},

        last_filter_options_history: {},

        notify_about_data_updated: 0,
        last_save_result: false,
        table_notes: [],
        last_notify_event: { event_time: 0, type: "undefined" },
        last_notify_event_sequence: 0,

        search_dependency_groups: {},
        search_data: {},

        cached_lists: [],
        define_department_limit: false
    },
    mutations: {
        onAllNoteLoadedData: function onAllNoteLoadedData(state, data) {
            state.table_notes = data;
        },
        onOneNoteLoadedData: function onOneNoteLoadedData(state, data) {
            var len = state.table_notes.length;
            for (var i = 0; i < len; i++) {
                if (state.table_notes[i].seq_id == data.seq_id) {
                    store_debug("YES, set", state.table_notes[i].message, data.message);
                    for (var key in data) {
                        if (data[key] != state.table_notes[i][key]) {
                            state.table_notes[i][key] = data[key];
                        }
                    }
                }
            }
            state.current_row = data;
        },
        OnLoadedData: function OnLoadedData(state, data) {
            if (data.success) {
                state.row_data = data.data;
            } else {
                state.row_data = [];
            }
        },
        OnLoadedDataOneRow: function OnLoadedDataOneRow(state, data) {
            if (data.success) {
                var id = data.data.id;
                var len = state.row_data.length;
                for (var i = 0; i < len; i++) {
                    if (state.row_data[i].id == id) {
                        for (var key in data.data) {
                            if (data.data[key] != state.row_data[i][key]) {
                                state.row_data[i][key] = data.data[key];
                            }
                        }
                    }
                }
                state.notify_about_data_updated = new Date().getTime();
            } else {
                state.notify_about_data_updated = new Date().getTime();
            }
        },
        StoreNotify: function StoreNotify(state, ev_data) {
            ev_data.event_time = new Date().getTime();
            __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$emit(ev_data.type, ev_data);
        },
        OnSuccess: function OnSuccess(state, data) {
            state.last_save_result = { success: true, type: data.type };
            state.notify_about_data_updated = new Date().getTime();
        },
        OnError: function OnError(state, data) {
            state.last_save_result = { success: false, message: data.message, type: data.type };
            state.notify_about_data_updated = new Date().getTime();
        }
    },
    actions: {
        setOneNote: function setOneNote(context, data) {
            context.commit('onOneNoteLoadedData', data);
        },
        setAllNote: function setAllNote(context, data) {
            context.commit('onAllNoteLoadedData', data);
        },
        makeLogin: function makeLogin(context, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(server_url + '/login', {
                user_name: __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].Base64.encode(data.user_name),
                pass: __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].Base64.encode(data.pass)
            }, [{ method: "POST" }]).then(function (response) {
                if (response.body.success == true) {
                    context.commit('StoreNotify', { type: "Login", success: true });
                } else {
                    context.commit('StoreNotify', { type: "Login", success: false, error: response.body.error });
                }
            }, function (response) {
                context.commit('StoreNotify', { type: "Login", success: false, error: "Error to access API" });
            });
        },
        makeLogout: function makeLogout(context, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(server_url + '/logout', {}, [{ method: "POST" }]).then(function (response) {
                if (response.body.success == true) {
                    context.commit('StoreNotify', { type: "Logout", success: true });
                } else {
                    context.commit('StoreNotify', { type: "Logout", success: false, error: response.body.error });
                }
            }, function (response) {
                context.commit('StoreNotify', { type: "Logout", success: false, error: "Error to access API" });
            });
        },
        getApplePassword: function getApplePassword(context, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(server_url + '/master/apple_pw', {
                user_pass: data.userPassword,
                serial: data.serial
            }, [{ method: "POST" }]).then(function (response) {
                if (response.body.success == true) {
                    context.commit('StoreNotify', { type: "ApplePassword", success: true, password: response.body.apple_pw });
                } else {
                    context.commit('StoreNotify', { type: "ApplePassword", success: false, error: response.body.error });
                }
            }, function (response) {
                context.commit('StoreNotify', { type: "ApplePassword", success: false, error: "Error to access API" });
            });
        },
        getPage1Data: function getPage1Data(context) {},
        getPage2Data: function getPage2Data(context) {},
        getPage3Data: function getPage3Data(context) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(server_url + '/list').then(function (response) {
                context.commit('OnLoadedData', response.data);
                context.commit('OnSuccess', { type: "loaded" });
            }, function (response) {
                context.commit('OnError', { type: "loaded", message: "データの読込に失敗しました。" });
                context.commit('OnLoadedData', { success: false });
            });
        },
        saveInfo: function saveInfo(context, details) {
            var changes = false;

            if (changes == false) {
                return context.commit('OnError', { message: "No changes to be saved.", type: "save" });
            }
            if (changes != false) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(server_url + '/save', {
                    page: details.page,
                    mode: details.mode,
                    changes: changes,
                    seq_id: context.state.current_row.seq_id

                }, [{
                    method: "POST"
                }]).then(function (response) {

                    if (response.body.success == true) {

                        context.commit('OnLoadedDataOneRow', response.body);
                        context.commit('OnSuccess', { type: "save" });
                    } else {
                        context.commit('OnError', { message: "Unknown data base error", type: "save" });
                    }
                }, function (response) {
                    context.commit('OnError', { message: "Unknown data base error", type: "save" });
                });
            }
        }
    },
    getters: {}
});

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1013),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-302f7786",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(720)
  __webpack_require__(721)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1004),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ef0d086",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentFactory_js__ = __webpack_require__(1076);
//




if (__webpack_require__.i({"NODE_ENV":"production"}).VUE_ENV !== 'server') {

	var pdfjsWrapper = __webpack_require__(1077).default;
	var PDFJS = __webpack_require__(349);

	if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {

		var PdfjsWorker = __webpack_require__(1081);
		PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker();
	}

	var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])(pdfjsWrapper(PDFJS));
} else {

	var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])({});
}

/* harmony default export */ __webpack_exports__["default"] = (component);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      input_buff: "",
      decoder: false,
      local_page_container_size: false
    };
  },

  computed: {
    buttonStyle: function buttonStyle() {
      this.local_page_container_size = parseInt(localStorage.getItem("pageContainerSize"));
      var s = 5;

      if (this.local_page_container_size < 1120) {
        s = -30;
      } else if (this.local_page_container_size < 1320) {
        s = -15;
      } else if (this.local_page_container_size < 1520) {
        s = 0;
      } else if (this.local_page_container_size > 1420) {
        s = 15;
      }
      console.log("buttonStyle " + this.local_page_container_size + " > " + 0);

      return "width: 100px;float: right;margin-right: " + s + "px;";
    },
    isShowInputBox: function isShowInputBox() {
      return this.$props.showinputbox;
    },
    isShowClearButton: function isShowClearButton() {
      return this.$props.showclearbutton;
    },
    showQrCode: function showQrCode() {
      return this.isIOS();
    }
  },
  methods: {
    isIOS: function isIOS() {
      return ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
    },
    scannQRCode: function scannQRCode() {
      var _this = this;

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var camera = this.$refs.camera;
      camera.click();
      camera.addEventListener('change', function (event) {
        _this.$refs.barcodeInput.placeholder = "QRコード processing ... ";
        console.log("camera changed");
        if (event.target && event.target.files.length > 0) {
          console.log("camera changed", event.target.files.length);
          var img = _this.$refs.qrCodeImg;
          _this.decoder.onmessage = function (event) {
            if (event.data.length > 0) {
              var qrcode = event.data[0][2];
              console.log("qrcode", qrcode);
              _this.$refs.barcodeInput.placeholder = "Found " + qrcode;
              _this.onBarcodeEnter(qrcode, qrcode);
            } else {
              _this.$refs.barcodeInput.placeholder = "QRコード not found ";
            }
            setTimeout(function () {
              _this.$refs.barcodeInput.placeholder = "バーコード入力";
            }, 2000);
          };
          setTimeout(function () {
            img.src = URL.createObjectURL(event.target.files[0]);
            setTimeout(function () {
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
              var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
              _this.decoder.postMessage(imgData);
            }, 300);
          }, 30);
        } else {
          _this.$refs.barcodeInput.placeholder = "バーコード入力";
        }
      });
    },
    onSubmit: function onSubmit(ev) {
      ev.preventDefault();
      return false;
    },
    clearBarcode: function clearBarcode() {
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit("onSearchClear", "");

      this.$emit("onBarcodeClear", "");
      if (this.isShowInputBox) {
        this.$refs.barcodeInput.value = "";
        this.$refs.barcodeInput.focus();
      }
      this.input_buff = "";
    },
    onKeyUp: function onKeyUp(mode, value, event) {
      if (this.isIOS() == false) {
        if (event.key == "Enter") {
          this.onBarcodeEnter(value, "");
          this.input_buff = "";
          this.$refs.barcodeInput.value = "";
        }
        return;
      }
      if (mode == "UP") if (event.key == "Backspace") {
          event.preventDefault();
          this.$refs.barcodeInput.value = this.input_buff;
        } else if (event.key == "Enter") {
          this.onBarcodeEnter(value, this.input_buff);
          this.input_buff = "";
          this.$refs.barcodeInput.value = "";
        } else {
          this.input_buff += event.key;
        }
    },
    onBarcodeEnter: function onBarcodeEnter(val, buff) {
      console.log("============ onBarcodeEnter  component =================", buff, this.$refs.barcodeInput);
      if (this.isIOS()) {
        this.$emit("onBarcodeInputed", { value: buff });
      } else {
        this.$emit("onBarcodeInputed", { value: this.$refs.barcodeInput.value });
      }
    }
  }, mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on("BarcodeClearInitiated", function () {
      _this2.$refs.barcodeInput.focus();
    });
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on("barcodeTestOne", function (data) {
      console.log("barcodeTestOne", data);
      _this2.input_buff = data;
      if (typeof _this2.$refs != "undefined" && typeof _this2.$refs.barcodeInput != "undefined") _this2.$refs.barcodeInput.value = data;
    });
    this.decoder = new Worker("static/decoder.min.js");
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off("BarcodeClearInitiated");
  },

  props: {
    showinputbox: {
      type: Boolean
    },
    showclearbutton: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_DateUtils_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_DateLanguages_js__ = __webpack_require__(200);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      validator: function validator(val) {
        var ret = val === null || val instanceof Date || typeof val === 'string';

        return ret;
      }
    },
    controller: {
      type: Object
    },
    name: {
      type: String
    },
    id: {
      type: String
    },
    format: {
      type: String,
      default: 'yyyy/MM/dd'
    },
    language: {
      type: String,
      default: 'ja'
    },
    disabled: {
      type: Object
    },
    highlighted: {
      type: Object
    },
    placeholder: {
      type: String
    },
    inline: {
      type: Boolean
    },
    inputClass: {
      type: String
    },
    inputStyle: {
      type: String
    },
    calendarStyle: {
      type: String
    },
    inputButtonStyle: {
      type: String
    },
    wrapperClass: {
      type: String
    },
    mondayFirst: {
      type: Boolean,
      default: false
    },
    clearButton: {
      type: Boolean,
      default: true
    },
    clearButtonIcon: {
      type: String,
      default: 'glyphicon glyphicon-remove'
    },
    calendarButton: {
      type: Boolean,
      default: true
    },
    calendarButtonIcon: {
      type: String,
      default: 'glyphicon glyphicon-calendar'
    },
    bootstrapStyling: {
      type: Boolean,
      default: true
    },
    initialView: {
      type: String,
      default: 'day'
    },
    disabledPicker: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime(),

      selectedDate: null,

      showDayView: false,
      showMonthView: false,
      showYearView: false,

      calendarHeight: 0,
      has_error: false

    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    }
  },
  computed: {
    hasError: {
      get: function get() {
        return this.has_error;
      },
      set: function set(v) {
        this.has_error = v;
      }
    },
    formattedValue: function formattedValue() {
      if (!this.selectedDate) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0__utils_DateUtils_js__["a" /* default */].formatDate(new Date(this.selectedDate), this.format, this.translation);
    },
    translation: function translation() {
      return __WEBPACK_IMPORTED_MODULE_1__utils_DateLanguages_js__["a" /* default */].translations[this.language];
    },
    currMonthName: function currMonthName() {
      var d = new Date(this.currDate);
      return __WEBPACK_IMPORTED_MODULE_0__utils_DateUtils_js__["a" /* default */].getMonthNameAbbr(d.getMonth(), this.translation.months.abbr);
    },
    currYear: function currYear() {
      var d = new Date(this.currDate);
      return d.getFullYear();
    },
    blankDays: function blankDays() {
      var d = new Date(this.currDate);
      var dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      if (this.mondayFirst) {
        return dObj.getDay() > 0 ? dObj.getDay() - 1 : 6;
      }
      return dObj.getDay();
    },
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }
      return this.translation.days;
    },
    days: function days() {
      var d = new Date(this.currDate);
      var days = [];

      var dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = __WEBPACK_IMPORTED_MODULE_0__utils_DateUtils_js__["a" /* default */].daysInMonth(dObj.getFullYear(), dObj.getMonth());
      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: dObj.getDate(),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj),
          isHighlighted: this.isHighlightedDate(dObj),
          isToday: dObj.toDateString() === new Date().toDateString()
        });
        dObj.setDate(dObj.getDate() + 1);
      }
      return days;
    },
    months: function months() {
      var d = new Date(this.currDate);
      var months = [];

      var dObj = new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 12; i++) {
        months.push({
          month: __WEBPACK_IMPORTED_MODULE_0__utils_DateUtils_js__["a" /* default */].getMonthName(i, this.translation.months.original),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        });
        dObj.setMonth(dObj.getMonth() + 1);
      }
      return months;
    },
    years: function years() {
      var d = new Date(this.currDate);
      var years = [];

      var dObj = new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 10; i++) {
        years.push({
          year: dObj.getFullYear(),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        });
        dObj.setFullYear(dObj.getFullYear() + 1);
      }
      return years;
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function isInline() {
      return typeof this.inline !== 'undefined' && this.inline;
    }
  },
  methods: {
    close: function close() {
      this.showDayView = this.showMonthView = this.showYearView = false;
      this.$emit('closed');
      document.removeEventListener('click', this.clickOutside, false);
    },
    getDefaultDate: function getDefaultDate() {
      return new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime();
    },
    resetDefaultDate: function resetDefaultDate() {
      if (this.selectedDate === null) {
        this.currDate = this.getDefaultDate();
        return;
      }
      this.currDate = this.currDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1).getTime();
    },
    showCalendar: function showCalendar() {

      if (this.disabledPicker) {
        return false;
      }
      if (this.isInline) {
        return false;
      }
      if (this.isOpen) {
        return this.close();
      }
      switch (this.initialView) {
        case 'year':
          this.showYearCalendar();
          break;
        case 'month':
          this.showMonthCalendar();
          break;
        default:
          this.showDayCalendar();
          break;
      }
    },
    showDayCalendar: function showDayCalendar() {
      this.close();
      this.showDayView = true;
      this.$emit('opened');
      document.addEventListener('click', this.clickOutside, false);
    },
    showMonthCalendar: function showMonthCalendar() {
      this.close();
      this.showMonthView = true;
      document.addEventListener('click', this.clickOutside, false);
    },
    showYearCalendar: function showYearCalendar() {
      this.close();
      this.showYearView = true;
      document.addEventListener('click', this.clickOutside, false);
    },
    updateValue: function updateValue(text) {
      var d = new Date(text);
      if (isNaN(d.getTime()) || d.getTime() < 0 || text.length < 10) {} else {
        this.setDate(text);
      }
    },
    checkForCompletedInput: function checkForCompletedInput(text, ev) {
      var _this = this;

      if (text == "") {
        return;
      }
      if (ev.code == "Enter" || ev.code == "focusoutevent") {
        text = text.replace(/-/g, "/");
        var date = text;
        if (RegExp(/^0?\d{1,2}$/).test(text)) {
          date = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + text;
        } else if (RegExp(/^0?\d{1,2}\/0?\d{1,2}$/).test(text)) {
          date = new Date().getFullYear() + "/" + text;
        } else if (RegExp(/^\d{1}\/0?\d{1,2}\/0?\d{1,2}$/).test(text)) {
          date = "200" + text;
        } else if (RegExp(/^\d{2}\/0?\d{1,2}\/0?\d{1,2}$/).test(text)) {
          date = "20" + text;
        } else if (RegExp(/^\d{1,4}\/0?\d{1,2}\/0?\d{1,2}$/).test(text)) {
          date = text;
        }
        this.hasError = false;

        if (date.length >= 8) {
          var d = new Date(date);
          if (isNaN(d.getTime()) == false && d.getTime() > 0) {
            this.setDate(date);
          } else if (date.length > 0) {
            this.hasError = true;
          }
        } else if (date.length > 0) {
          this.hasError = true;
        }
        setTimeout(function () {
          _this.hasError = false;
        }, 1000);
      }
    },
    setDate: function setDate(timestamp) {
      this.selectedDate = new Date(timestamp);
      this.currDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1).getTime();
      this.$emit('selected', new Date(timestamp));
      this.$emit('input', new Date(timestamp));
    },
    clearDate: function clearDate() {
      this.selectedDate = null;
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },
    selectDate: function selectDate(day) {
      if (day.isDisabled) {
        return false;
      }
      this.setDate(day.timestamp);
      if (this.isInline) {
        return this.showDayCalendar();
      }
      this.close();
    },
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }
      this.currDate = month.timestamp;
      this.showDayCalendar();
      this.$emit('changedMonth', month);
    },
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }
      this.currDate = year.timestamp;
      this.showMonthCalendar();
      this.$emit('changedYear', year);
    },
    getMonth: function getMonth() {
      var d = new Date(this.currDate);
      return d.getMonth();
    },
    getYear: function getYear() {
      var d = new Date(this.currDate);
      return d.getFullYear();
    },
    getDecade: function getDecade() {
      var d = new Date(this.currDate);
      var sD = Math.floor(d.getFullYear() / 10) * 10;
      return sD + '\'s';
    },
    previousMonth: function previousMonth() {
      if (this.previousMonthDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setMonth(d.getMonth() - 1);
      this.currDate = d.getTime();
      this.$emit('changedMonth', d);
    },
    previousMonthDisabled: function previousMonthDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.to.getMonth() >= d.getMonth() && this.disabled.to.getFullYear() >= d.getFullYear()) {
        return true;
      }
      return false;
    },
    nextMonth: function nextMonth() {
      if (this.nextMonthDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      var daysInMonth = __WEBPACK_IMPORTED_MODULE_0__utils_DateUtils_js__["a" /* default */].daysInMonth(d.getFullYear(), d.getMonth());
      d.setDate(d.getDate() + daysInMonth);
      this.currDate = d.getTime();
      this.$emit('changedMonth', d);
    },
    nextMonthDisabled: function nextMonthDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.from.getMonth() <= d.getMonth() && this.disabled.from.getFullYear() <= d.getFullYear()) {
        return true;
      }
      return false;
    },
    previousYear: function previousYear() {
      if (this.previousYearDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() - 1);
      this.currDate = d.getTime();
      this.$emit('changedYear');
    },
    previousYearDisabled: function previousYearDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.to.getFullYear() >= d.getFullYear()) {
        return true;
      }
      return false;
    },
    nextYear: function nextYear() {
      if (this.nextYearDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() + 1);
      this.currDate = d.getTime();
      this.$emit('changedYear');
    },
    nextYearDisabled: function nextYearDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.from.getFullYear() <= d.getFullYear()) {
        return true;
      }
      return false;
    },
    previousDecade: function previousDecade() {
      if (this.previousDecadeDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() - 10);
      this.currDate = d.getTime();
      this.$emit('changedDecade');
    },
    previousDecadeDisabled: function previousDecadeDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false;
      }
      var d = new Date(this.currDate);
      if (Math.floor(this.disabled.to.getFullYear() / 10) * 10 >= Math.floor(d.getFullYear() / 10) * 10) {
        return true;
      }
      return false;
    },
    nextDecade: function nextDecade() {
      if (this.nextDecadeDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() + 10);
      this.currDate = d.getTime();
      this.$emit('changedDecade');
    },
    nextDecadeDisabled: function nextDecadeDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false;
      }
      var d = new Date(this.currDate);
      if (Math.ceil(this.disabled.from.getFullYear() / 10) * 10 <= Math.ceil(d.getFullYear() / 10) * 10) {
        return true;
      }
      return false;
    },
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.selectedDate.toDateString() === dObj.toDateString();
    },
    isDisabledDate: function isDisabledDate(date) {
      var disabled = false;

      if (typeof this.disabled === 'undefined') {
        return false;
      }

      if (typeof this.disabled.dates !== 'undefined') {
        this.disabled.dates.forEach(function (d) {
          if (date.toDateString() === d.toDateString()) {
            disabled = true;
            return true;
          }
        });
      }
      if (typeof this.disabled.to !== 'undefined' && this.disabled.to && date < this.disabled.to) {
        disabled = true;
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from && date > this.disabled.from) {
        disabled = true;
      }
      if (typeof this.disabled.days !== 'undefined' && this.disabled.days.indexOf(date.getDay()) !== -1) {
        disabled = true;
      }
      return disabled;
    },
    isHighlightedDate: function isHighlightedDate(date) {
      if (this.isDisabledDate(date)) {
        return false;
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false;
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (date.toDateString() === d.toDateString()) {
            highlighted = true;
            return true;
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(date.getDay()) !== -1) {
        highlighted = true;
      }
      return highlighted;
    },
    isDefined: function isDefined(prop) {
      return typeof prop !== 'undefined' && prop;
    },
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.selectedDate.getFullYear() === date.getFullYear() && this.selectedDate.getMonth() === date.getMonth();
    },
    isDisabledMonth: function isDisabledMonth(date) {
      var disabled = false;

      if (typeof this.disabled === 'undefined') {
        return false;
      }

      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
        if (date.getMonth() < this.disabled.to.getMonth() && date.getFullYear() <= this.disabled.to.getFullYear() || date.getFullYear() < this.disabled.to.getFullYear()) {
          disabled = true;
        }
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
        if (this.disabled.from && date.getMonth() > this.disabled.from.getMonth() && date.getFullYear() >= this.disabled.from.getFullYear() || date.getFullYear() > this.disabled.from.getFullYear()) {
          disabled = true;
        }
      }
      return disabled;
    },
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.selectedDate.getFullYear() === date.getFullYear();
    },
    isDisabledYear: function isDisabledYear(date) {
      var disabled = false;
      if (typeof this.disabled === 'undefined' || !this.disabled) {
        return false;
      }

      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
        if (date.getFullYear() < this.disabled.to.getFullYear()) {
          disabled = true;
        }
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
        if (date.getFullYear() > this.disabled.from.getFullYear()) {
          disabled = true;
        }
      }

      return disabled;
    },
    setValue: function setValue(date) {

      if (typeof date === 'string') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }

      if (!date) {
        var d = new Date();
        this.currDate = new Date(d.getFullYear(), d.getMonth(), 1).getTime();
        this.selectedDate = null;
        return;
      }
      if (date.getTime() >= new Date("3000-01-01").getTime()) {
        var _d = new Date();
        this.currDate = new Date(_d.getFullYear(), _d.getMonth(), 1).getTime();
        this.selectedDate = null;
        return;
      }

      this.selectedDate = date;
      this.currDate = new Date(date.getFullYear(), date.getMonth(), 1).getTime();
    },
    clickOutside: function clickOutside(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        if (this.isInline) {
          return this.showDayCalendar();
        }
        this.resetDefaultDate();
        this.close();
        document.removeEventListener('click', this.clickOutside, false);
      }
    },
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }
      if (this.isInline) {
        this.showDayCalendar();
      }
    }
  },
  ready: function ready() {
    this.init();
  },
  mounted: function mounted() {
    this.init();
    if (this.$props.controller) {
      this.$props.controller.ref_field = this;
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ctk_date_time_picker__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ctk_date_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ctk_date_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_local_vue_ctk_date_time_picker_css__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_local_vue_ctk_date_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_local_vue_ctk_date_time_picker_css__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueCtkDateTimePicker: __WEBPACK_IMPORTED_MODULE_1_vue_ctk_date_time_picker___default.a
  },
  data: function data() {
    return {
      local_model: null,
      disable_in_value: false
    };
  },

  watch: {
    inValue: function inValue(value) {
      setTimeout(function () {}, 100);
    }
  },
  computed: {
    fieldID: function fieldID() {
      return this.$props.id;
    },
    inValue: function inValue() {
      if (this.$props.value && this.$props.value.indexOf("nvalid") > -1) {
        return null;
      }
      if (this.disable_in_value == false) {
        this.local_model = this.$props.value;
      }

      return this.$props.value;
    },

    localModel: {
      get: function get() {
        return this.local_model;
      },
      set: function set(v) {
        this.disable_in_value = true;
        this.$emit("input", v);
        this.local_model = v;
      }
    },
    isDisabled: function isDisabled() {
      return this.$props.disabled == true;
    }
  },
  methods: {
    clearCalendar: function clearCalendar() {
      if (this.isDisabled) {
        return;
      }
      this.localModel = null;
    }
  },
  mounted: function mounted() {},

  props: ["disabled", "value", "id", "inputStyle"]
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      local_value: null,
      checked_value: 1,
      local_disabled: false
    };
  },

  methods: {
    onClick: function onClick(b) {
      if (b.type == "add_to_input") {
        this.$refs.local_value.value = b.text;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text;
      }
      if (b.type == "link") {
        this.$router.push(b.link);
      }
      return false;
    },
    updateValue: function updateValue(d, d2) {
      if (typeof this.$store.state[this.stateCurrentEditing][this.fieldID] == "undefined") {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$store.state[this.stateCurrentRow][this.fieldID];
      }
      this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$store.state[this.stateCurrentEditing][this.fieldID] == 1 ? 0 : 1;
      if (typeof this.$props.data.global_emit != "undefined") {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(this.$props.data.global_emit, this.$store.state[this.stateCurrentEditing][this.fieldID]);
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    }
  },
  computed: {
    localDisabled: {
      get: function get() {
        return this.local_disabled;
      },
      set: function set(v) {
        this.local_disabled = v;
      }
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    fieldClass: function fieldClass() {
      return "col-xs-8";
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldSubLabel: function fieldSubLabel() {
      return this.$props.data.sub_label;
    },
    fieldValue: function fieldValue() {
      return this.$store.state[this.stateCurrentRow][this.fieldID];
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    isDisabled: function isDisabled() {
      return this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
    },
    filedStyle: function filedStyle() {
      var h = this.fieldRows * 20;
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || "";
      return (this.getOption("field_style", this.$props.data.field_style || "height: " + h + "px !important;") || "") + store_style;
    }
  },
  props: ["data", "value", "option", "read"],
  mounted: function mounted() {
    var _this = this;

    this.$props.data.ref_field = this;
    setInterval(function () {}, 2000);

    if (this.$props.data.page_controller) {
      this.$props.data.page_controller_msg = function (options) {
        switch (options.cmd) {
          case "enable":
            _this.localDisabled = false;
            break;
          case "disable":
            _this.localDisabled = true;
            break;
          default:
            break;
        }
      };
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dp_Datepicker__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dp_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dp_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('datepicker', __WEBPACK_IMPORTED_MODULE_1__dp_Datepicker___default.a);


var debug_date_box = __WEBPACK_IMPORTED_MODULE_3_debug___default()('esma:date_box');
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      count: 0,
      local_refresh_sequecnce: 1,
      show_as_error: false,
      cache_for_disable_and_clean_if_value: false,
      local_disabled: false,
      dp_controller: { ref_field: null }
    };
  },

  computed: {
    localDisabled: {
      get: function get() {
        return this.local_disabled;
      },
      set: function set(v) {
        this.local_disabled = v;
      }
    },
    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    seqId: function seqId() {
      return this.$props.data.seq_id;
    },
    bootstrapStylingTrue: function bootstrapStylingTrue() {
      return true;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    isRequired: function isRequired() {
      return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
    },
    fieldClass: function fieldClass() {
      if (this.getOption('hide_label', false) == true) {
        return 'col-xs-12';
      } else {
        return 'col-xs-8';
      }
    },
    showLabel: function showLabel() {
      if (this.getOption('hide_label', false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldValue: function fieldValue() {
      debug_date_box('fieldValue');

      if (this.$store.state[this.stateCurrentRow][this.fieldID] == null) {
        this.count++;
        if (this.count > 2000) {
          this.count = 0;
        }
        debug_date_box('fieldValue return 1');
        return 3000 + this.count + '-01-01';
      } else {
        debug_date_box('fieldValue return 2 ', this.$store.state[this.stateCurrentRow][this.fieldID]);
        return this.localRefreshSequecnce > 0 ? this.$store.state[this.stateCurrentRow][this.fieldID] : "";
      }
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    disabledStyle: function disabledStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.localDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      return this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    buttonStyle: function buttonStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        debug_date_box('buttonStyle is_editing_new', typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
        return;
        typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      debug_date_box('buttonStyle ', this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
      return this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    isDisabled: function isDisabled() {
      debug_date_box("isDisabled");
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.localDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined';
      }
      var ret = this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined';
      if (ret) {
        if (this.dp_controller && this.dp_controller.ref_field) {
          this.dp_controller.ref_field.setValue(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
      }
      return ret;
    }
  },
  methods: {
    updateValue: function updateValue(d) {
      debug_date_box('SET DATE', this.fieldID, d, this.$props.value);
      if (d == null) {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = null;
      } else {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(d).format("YYYY-MM-DD");
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == 'undefined') {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents: function onReceiveEvents(e, data) {
      if (e.mode == "disable_if_value") {
        if (e.disable_if_value == data.val) {
          this.localDisabled = false;
        } else {
          this.localDisabled = true;
        }
      } else if (e.mode == "disable_and_clean_if_value") {
        if (e.disable_if_value == data.val) {
          if (this.localDisabled != false) {
            this.$store.state[this.stateCurrentRow][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
            this.$store.state[this.stateCurrentEditing][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
          }
          this.localDisabled = false;
        } else {
          if (this.localDisabled != true) {
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID] || this.$props.data.default || "";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentRow][this.fieldID] = this.$props.data.default || "";
          this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$props.data.default || "";
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(function (e) {
        __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off(e.name).$on(e.name, function (data) {
          _this.onReceiveEvents(e, data);
        });
      });
    }

    this.$props.data.ref_field = this;
    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this.showAsError == false) {
          return cb(false);
        }
        var local_val = _.clone(_this.$store.state[_this.stateCurrentEditing][_this.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = _.clone(_this.$store.state[_this.stateCurrentRow][_this.fieldID]) || null;
        }
        if (msg.show_as_error_mode && msg.only_if_enabled == true && _this.isDisabled == true) {
          _this.showAsError = false;
          _this.$store.state[_this.stateCurrentRow][_this.fieldID] = local_val;
          _this.updateValue(local_val);
          _this.localRefreshSequecnce++;
          return cb(false);
        }
        _this.showAsError = msg.show_as_error_mode || false;
        _this.$store.state[_this.stateCurrentRow][_this.fieldID] = local_val;
        _this.updateValue(local_val);
        _this.localRefreshSequecnce++;
        return cb(true);
      }
    };
  },

  props: ['data', 'value', 'option', 'read']
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dp_Datetimepicker2__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dp_Datetimepicker2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dp_Datetimepicker2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('datetimepicker', __WEBPACK_IMPORTED_MODULE_1__dp_Datetimepicker2___default.a);


var debug_date_box = __WEBPACK_IMPORTED_MODULE_2_debug___default()('esma:date_box');
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      count: 0
    };
  },

  methods: {
    updateValue: function updateValue(d) {
      debug_date_box('SET DATE', this.fieldID, d, this.$props.value);
      if (d == null) {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = null;
      } else {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = __WEBPACK_IMPORTED_MODULE_3_moment___default()(d).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == 'undefined') {
        return def;
      }
      return this.$props.option[name];
    }
  },
  computed: {
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    seqId: function seqId() {
      return this.$props.data.seq_id;
    },
    bootstrapStylingTrue: function bootstrapStylingTrue() {
      return true;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldClass: function fieldClass() {
      if (this.getOption('hide_label', false) == true) {
        return 'col-xs-12';
      } else {
        return 'col-xs-8';
      }
    },
    showLabel: function showLabel() {
      if (this.getOption('hide_label', false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldValue: function fieldValue() {
      debug_date_box('fieldValue');

      if (this.$store.state[this.stateCurrentRow][this.fieldID] == null) {
        this.count++;
        if (this.count > 2000) {
          this.count = 0;
        }
        debug_date_box('fieldValue return 1');
        return null;
      } else {
        debug_date_box('fieldValue return 2 ', this.$store.state[this.stateCurrentRow][this.fieldID]);
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.$store.state[this.stateCurrentRow][this.fieldID]).format("YYYY/MM/DD HH:mm");
      }
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    disabledStyle: function disabledStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      return this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    buttonStyle: function buttonStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        debug_date_box('buttonStyle is_editing_new', typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
        return;
        typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      debug_date_box('buttonStyle ', this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
      return this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    isDisabled: function isDisabled() {
      debug_date_box("isDisabled");
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined';
      }
      return this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined';
    }
  },
  props: ['data', 'value', 'option', 'read'],
  mounted: function mounted() {
    this.$props.data.ref_field = this;
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_select__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_vue_select_dist_vue_select_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__node_modules_vue_select_dist_vue_select_css__);







var debug_select = __WEBPACK_IMPORTED_MODULE_2_debug___default()("esma:select-box");


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated: false,
      cache_for_disable_and_clean_if_value: false,
      local_disabled: false,
      label_class: "col-xs-4 control-label esma_form_label",
      value_user: "",
      value_domain: "",
      updated_value_user: false,
      updated_value_domain: false,
      updated_value_user_set: false,
      updated_value_domain_set: false,
      local_refresh_sequecnce: 1,
      show_as_error: false,
      last_disabled_status: null,
      page_controller_disabled: false
    };
  },

  components: {
    'v-select': __WEBPACK_IMPORTED_MODULE_5_vue_select___default.a
  },
  computed: {
    pageControllerDisabled: {
      get: function get() {
        return this.page_controller_disabled;
      },
      set: function set(v) {
        this.page_controller_disabled = v;
      }
    },
    isRequired: function isRequired() {
      return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
    },

    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    valueUser: {
      get: function get() {
        return this.value_user;
      },
      set: function set(v) {
        this.value_user = v;
      }
    },
    valueDomain: {
      get: function get() {
        return this.value_domain;
      },
      set: function set(v) {
        this.value_domain = v;
      }
    },
    labelClass: function labelClass() {
      var complement = this.showAsError == true ? " esma_error_field" : "";
      if (typeof this.$props.data.label_class != "undefined") {
        return this.$props.data.label_class + complement;
      } else {
        return this.label_class + complement;
      }
    },

    localDisabled: {
      get: function get() {
        return this.local_disabled;
      },
      set: function set(v) {
        this.local_disabled = v;
      }
    },
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.field_style || "") + store_style + "";
    },
    vSelectFiledDisabledStyle: function vSelectFiledDisabledStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.field_style || "") + store_style + ";text-align: start;";
    },
    vSelectFiledStyle: function vSelectFiledStyle() {
      return "";
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldOptions: function fieldOptions() {
      var _this = this;

      var base_options = this.$props.data.options;

      this.local_options = [];
      base_options.forEach(function (d) {
        _this.local_options.push(d);
      });
      if (this.local_options.indexOf(this.fieldValue) < 0) {
        this.local_options.unshift(this.fieldValue);
      }
      if (this.local_options.indexOf("") < 0 && this.fieldValue != "" && this.fieldValue != null) {
        this.local_options.unshift("");
      }
      return this.local_options;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValueUser: function fieldValueUser() {
      this.valueUser = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
      if (this.valueUser && this.valueUser.indexOf("@") > -1) {
        this.valueUser = this.valueUser.split("@")[0];
      }

      return this.localRefreshSequecnce > 0 ? this.valueUser : "";
    },
    fieldValue: function fieldValue() {
      this.valueDomain = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
      if (this.valueDomain && this.valueDomain.indexOf("@") > -1) {
        this.valueDomain = this.valueDomain.split("@")[1];
      } else {
        this.valueDomain = "";
      }
      if (typeof this.$props.data.on_set_value == "function") {
        this.$props.data.on_set_value(this.valueDomain);
      }
      return this.localRefreshSequecnce > 0 ? this.valueDomain : "";
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    fieldClass: function fieldClass() {
      if (typeof this.$props.data.field_class != "undefined") {
        return this.$props.data.field_class;
      } else if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    isDisabled: function isDisabled() {
      var ret = null;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.pageControllerDisabled || this.localDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      } else {
        ret = this.pageControllerDisabled || this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      if (this.last_disabled_status != null && this.last_disabled_status != ret) {
        this.localRefreshSequecnce++;
      }
      this.last_disabled_status = ret;
      return ret;
    }
  },
  methods: {
    onClick: function onClick() {},
    updateValueDomainOption: function updateValueDomainOption(v) {
      if (v && v.length > 0 && v.indexOf("@") != 0) {
        v = "@" + v;
      }

      this.updateValueDomain(v);
    },
    updateValueDomain: function updateValueDomain(d) {
      this.updated_value_domain = d;
      this.updated_value_domain_set = true;
      var user = "";
      if (this.updated_value_user_set == true) {
        user = this.updated_value_user;
      } else {
        user = this.valueUser;
      }
      debug_select("updateValueDomain", d);
      this.value_updated = true;
      this.$store.state[this.stateCurrentEditing][this.fieldID] = user + d;
      this.$store.state[this.stateCurrentRow][this.fieldID] = user + d;

      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: this.$store.state[this.stateCurrentEditing][this.fieldID] });
      }
      this.localRefreshSequecnce++;
    },
    updateValueUser: function updateValueUser(d) {
      var domain = "";
      if (this.updated_value_domain_set) {
        domain = this.updated_value_domain;
      } else {
        domain = this.valueDomain;
      }
      if ((d || "").indexOf("@") > -1) {
        d = d.replace(/@/g, "");
      }
      this.updated_value_user = d;
      this.updated_value_user_set = true;
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d + domain;
      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: this.$store.state[this.stateCurrentEditing][this.fieldID] });
      }
    },
    updateValue: function updateValue(d) {
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: this.$store.state[this.stateCurrentEditing][this.fieldID] });
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents: function onReceiveEvents(e, data) {},
    refreshOptions: function refreshOptions() {
      var _this2 = this;

      var temp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.local_options);
      this.local_options = [];
      temp.forEach(function (e) {
        _this2.local_options.push(e);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$props.data.ref_field = this;
    this.valueUser = "";
    this.valueDomain = "";

    if (typeof this.$props.data.selection_rules != "undefined" && this.$props.data.selection_rules.length > 0) {
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(function (e) {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(e.name).$on(e.name, function (data) {
          _this3.onReceiveEvents(e, data);
        });
      });
    }

    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this3.showAsError == false) {
          _this3.localRefreshSequecnce++;
          return cb(false);
        }
        var local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this3.$store.state[_this3.stateCurrentEditing][_this3.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this3.$store.state[_this3.stateCurrentRow][_this3.fieldID]);
        }
        _this3.showAsError = msg.show_as_error_mode || false;
        if (__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].if_null(local_val) == "") {} else if (local_val.indexOf("@") < 0 || __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].if_null(local_val.split("@")[1]) == "") {
          _this3.updated_value_domain_set = true;
          _this3.updated_value_domain = "";
          _this3.valueDomain = "";
          _this3.$store.state[_this3.stateCurrentRow][_this3.fieldID] = local_val;
          _this3.updateValueUser(local_val);
        } else if (local_val.split("@").length == 1 && __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].if_null(local_val.split("@")[0]) == "") {
          _this3.updated_value_user_set = true;
          _this3.updated_value_user = "";
          _this3.valueUser = "";
          _this3.$store.state[_this3.stateCurrentRow][_this3.fieldID] = local_val;
          _this3.updateValueDomain(local_val);
        } else {
          _this3.$store.state[_this3.stateCurrentRow][_this3.fieldID] = local_val;
          _this3.updateValue(local_val);
        }
        _this3.localRefreshSequecnce++;
        return cb(true);
      }
    };
    if (this.$props.data.page_controller) {
      this.$props.data.page_controller_msg = function (options) {
        switch (options.cmd) {
          case "enable":
            _this3.pageControllerDisabled = false;
            break;
          case "disable":
            _this3.pageControllerDisabled = true;
            break;
          default:
            break;
        }
      };
    }
  },


  props: ["data", "value", "option", "read"]
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);




var debug_search_control = __WEBPACK_IMPORTED_MODULE_1_debug___default()("esma:input-box-result");
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  computed: {
    labelClass: function labelClass() {
      return this.$props["labelSize"] == "L" ? "col-xs-7" : "col-xs-4";
    },
    fieldValue: function fieldValue() {
      return this.$props.value;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.label;
    }
  },
  methods: {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  afterMount: function afterMount() {},
  beforeDestroy: function beforeDestroy() {},

  props: ["value", "label", "label-size"]
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js__);





var debug_input = __WEBPACK_IMPORTED_MODULE_2_debug___default()("esma:input-box");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("dropdown", __WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js__["dropdown"]);
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      localDisabled: false,
      showErrorMessage: false,
      erroMessage: "",
      local_value: null,
      local_style: "",
      use_on_insert_rules: false,
      timeout_control: false,
      validation_message: "",
      validate_error_is_active: false,
      last_disable_status: true,
      cache_for_disable_and_clean_if_value: false,
      label_class: "col-xs-4 control-label esma_form_label",
      local_refresh_sequecnce: 1,
      show_as_error: false,
      disabled_is_required: false,
      external_disabled: false,
      page_controller_disabled: false
    };
  },

  computed: {
    pageControllerDisabled: {
      get: function get() {
        return this.page_controller_disabled;
      },
      set: function set(v) {
        this.page_controller_disabled = v;
      }
    },
    externalDisabled: {
      get: function get() {
        return this.external_disabled;
      },
      set: function set(v) {
        this.external_disabled = v;
      }
    },
    disabledIsRequired: {
      get: function get() {
        return this.disabled_is_required;
      },
      set: function set(v) {
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.disabled_is_required = v;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
      }
    },
    isRequired: function isRequired() {
      return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
    },

    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    minVal: function minVal() {
      if (this.$props.data.min_value) {
        return parseInt(this.$props.data.min_value);
      } else {
        return false;
      }
    },
    maxVal: function maxVal() {
      return this.$props.data.max_value || false;
    },
    labelClass: function labelClass() {
      var complement = this.showAsError == true ? " esma_error_field" : "";
      if (typeof this.$props.data.label_class != "undefined") {
        return this.$props.data.label_class + complement;
      } else {
        return this.label_class + complement;
      }
    },

    myModel: {
      get: function get() {
        return this.my_model;
      },
      set: function set(v) {
        this.my_model = v;
      }
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        console.log("stateCurrentEditing YES", this.$props.data.label);
        return this.$props.data.state_current_editing;
      } else {
        console.log("stateCurrentEditing NO");
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    realValueEmpty: function realValueEmpty() {
      return true;
    },
    fieldLabel: function fieldLabel() {
      this.erroMessage = "";
      this.showErrorMessage = false;
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      var _this = this;

      if (typeof this.$props.data.default != "undefined" && (typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined" || this.$store.state[this.stateCurrentRow][this.fieldID].length == 0)) {
        this.updateValue(this.$props.data.default);
        return this.$props.data.default;
      } else {
        setTimeout(function () {
          _this.validate(_this.$store.state[_this.stateCurrentRow][_this.fieldID], "fieldValue 2");
        }, 100);

        return this.localRefreshSequecnce > 0 ? this.$store.state[this.stateCurrentRow][this.fieldID] : "";
      }
    },
    fieldClass: function fieldClass() {
      if (typeof this.$props.data.field_class != "undefined") {
        return this.$props.data.field_class;
      } else if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    isReadOnly: function isReadOnly() {
      return this.$props.data.force_readonly || false;
    },
    isDisabled: function isDisabled() {
      var ret = false;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.pageControllerDisabled || this.localDisabled || this.externalDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      } else {
        ret = this.pageControllerDisabled || this.localDisabled || this.externalDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      if (this.last_disable_status != ret) {
        this.last_disable_status = ret;
        if (ret == true) {
          this.validate(this.$store.state[this.stateCurrentRow][this.fieldID], "isDisabled");
        }
      }

      return ret;
    },
    buttons: function buttons() {
      return this.$props.data.buttons || [];
    },
    dbuttons: function dbuttons() {
      return this.$props.data.dbuttons || [];
    },
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + this.local_style + store_style;
    },
    fieldType: function fieldType() {
      return this.$props.data.field_type || "text";
    },
    labelStyle: function labelStyle() {
      return (this.$props.data.label_style || "") + this.local_style;
    }
  },
  methods: {
    validate: function validate(str, requester) {
      var _this2 = this;

      var valid = true;
      var error_message = "";
      var error_mode = "none";
      if (str && str.length > 0 && this.$props.data.format_rules) {

        var format_rules_arr = this.$props.data.format_rules;
        format_rules_arr = Array.isArray(format_rules_arr) ? format_rules_arr : [format_rules_arr];

        format_rules_arr.forEach(function (format_rules) {
          if (valid != false) {
            var code, i, len;
            var accept = format_rules.accept || "all";
            error_mode = format_rules.mode;
            var l_str = _.clone(str);

            switch (accept) {
              case "regex":
                var regex = format_rules.regex;
                var msg = format_rules.regex_err_msg || "error";
                valid = RegExp(format_rules.regex).test(l_str);
                if (!valid) {
                  if (error_mode == "restrict") {
                    error_message = "エラー：「" + _this2.fieldLabel + "」 " + msg;
                  } else {
                    error_message = "注意 ：「" + _this2.fieldLabel + "」 " + msg;
                  }
                }
                break;
              case "all":
              default:
                break;
            }
          }
        });

        this.$notify({ clean: true });
      } else if (this.validate_error_is_active == true) {
        error_mode = Array.isArray(this.$props.data.format_rules) ? this.$props.data.format_rules[0].mode : this.$props.data.format_rules.mode;
      }
      if (!valid) {
        this.validate_error_is_active = true;
        this.$emit("error_msg", { msg: error_message, error_mode: error_mode });
      } else if (this.validate_error_is_active == true) {
        this.validate_error_is_active = false;
        this.$emit("error_msg", { msg: "", error_mode: error_mode });
      }
      return valid;
    },
    onClick: function onClick(b, ev) {
      var _this3 = this;

      if (ev.clientX == 0) {
        return;
      }
      if (b.type == "add_to_input") {
        this.$refs.local_value.value = b.text;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text;
      }
      if (b.type == "link") {
        this.$router.push(b.link);
      }
      if (b.type == "callback") {
        b.callback(b);
      }
      if (b.type == "dlink") {
        var url = b.link;
        if (this.fieldValue && this.fieldValue.length > 0) {
          url = url.replace("{{val}}", this.fieldValue);
          this.$ajax.post(url.replace("/#/open_", "/check_"), {}, function (err, result, error_code) {
            _this3.$notify({ clear: true });
            if (result == true) {
              window.open(url, "_blank");
            } else if (err) {
              _this3.$notify({
                title: "エラー",
                text: err,
                type: "error",
                duration: 10000
              });
            } else {
              _this3.$notify({
                title: "エラー",
                text: " 宛先ページで" + _this3.fieldLabel + " = " + _this3.fieldValue + " が見つかりませんでした。",
                type: "warn",
                duration: 7000
              });
            }
          });
        }
      }
      return false;
    },
    updateValue: function updateValue(d) {
      var _this4 = this;

      this.validate(_.clone(d), "updateValue");
      this.$notify({ clean: true });
      if (this.fieldType == "number" && (isNaN(d) || this.minVal !== false && parseInt(d) < parseInt(this.minVal))) {

        d = parseInt(("" + d).replace(/[^0-9-.]/g, '') || 0);
        if (isNaN(d)) {
          d = "";
        }
        if (d < this.minVal) {
          d = "";
        }
        setTimeout(function () {
          _this4.$store.state[_this4.stateCurrentRow][_this4.fieldID] = d;
          _this4.$store.state[_this4.stateCurrentEditing][_this4.fieldID] = d;

          _this4.localRefreshSequecnce++;
          _this4.$notify({
            title: (_this4.minVal || 0) + '以下の数量を登録することはできません。',
            text: "",
            type: 'error',
            duration: 10000
          });
        }, 100);
      } else if (this.fieldType == "number" && this.minVal !== false && parseInt(d) >= parseInt(this.minVal)) {
        d = parseInt(d);
        this.$store.state[this.stateCurrentRow][this.fieldID] = d;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
        this.localRefreshSequecnce++;
      } else {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
      }
      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: d });
      }
      if (typeof this.$props.data.on_set_value == "function") {
        this.$props.data.on_set_value(d);
      }
      if (this.use_on_insert_rules) {
        clearTimeout(this.timeout_control);
        this.timeout_control = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit("on_insert_rule", {
            rule: _this4.$props.data.on_insert_rules,
            value: d
          });
        }, 500);
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    }
  },

  props: ["data", "value", "option", "read"],
  mounted: function mounted() {
    var _this5 = this;

    this.$props.data.ref_field = this;
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(function (e) {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(e.name).$on(e.name, function (data) {
          if (e.mode == "disable_if_value") {
            if (e.disable_if_value == data.val) {
              _this5.localDisabled = false;
            } else {
              _this5.localDisabled = true;
            }
          } else if (e.mode == "disable_and_clean_if_value") {

            if (e.disable_if_value == data.val) {
              if (_this5.localDisabled != false && _this5.cache_for_disable_and_clean_if_value != false) {
                _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] = _this5.cache_for_disable_and_clean_if_value || "";
                _this5.$store.state[_this5.stateCurrentEditing][_this5.fieldID] = _this5.cache_for_disable_and_clean_if_value || "";
                _this5.cache_for_disable_and_clean_if_value = "";
              }
              _this5.localDisabled = false;
            } else {
              if (_this5.localDisabled != true) {
                _this5.cache_for_disable_and_clean_if_value = "" + (_this5.$store.state[_this5.stateCurrentEditing][_this5.fieldID] || _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] || _this5.$props.data.default || "");
              }
              _this5.localDisabled = true;
              _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] = _this5.$props.data.default || "";
              _this5.$store.state[_this5.stateCurrentEditing][_this5.fieldID] = _this5.$props.data.default || "";
            }
          }
        });
      });
    }

    if (typeof this.$props.data.listen_for_value != "undefined") {
      var bus_name = this.$props.data.listen_for_value;
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(bus_name).$on(bus_name, function (new_value) {
        debug_input("listen_for_value", _this5.fieldID, new_value, _this5.$store.state[_this5.stateCurrentEditing][_this5.fieldID]);
        _this5.$refs.local_value.value = new_value;
        _this5.updateValue(new_value);
      });
    }

    if (typeof this.$props.data.on_insert_rules != "undefined") {
      this.use_on_insert_rules = true;
    }

    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this5.showAsError == false) {
          return cb(false);
        }
        var local_val = _.clone(_this5.$store.state[_this5.stateCurrentEditing][_this5.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = _.clone(_this5.$store.state[_this5.stateCurrentRow][_this5.fieldID]);
        }
        if (msg.show_as_error_mode && msg.only_if_enabled == true && _this5.isDisabled == true) {
          _this5.showAsError = false;
          _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] = local_val;
          _this5.updateValue(local_val);
          _this5.localRefreshSequecnce++;
          return cb(false);
        }
        _this5.showAsError = msg.show_as_error_mode || false;
        _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] = local_val;
        _this5.updateValue(local_val);
        _this5.localRefreshSequecnce++;
        return cb(true);
      }
    };

    if (this.$props.data.page_controller) {
      this.$props.data.page_controller_msg = function (options) {
        switch (options.cmd) {
          case "enable":
            _this5.pageControllerDisabled = false;
            break;
          case "disable":
            _this5.pageControllerDisabled = true;
            break;
          default:
            break;
        }
      };
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);





var debug_pass_box = __WEBPACK_IMPORTED_MODULE_2_debug___default()("esma:pass_box");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal_password: false,
      local_value: null,
      local_style: "",
      had_focus: false,
      local_refresh_sequecnce: 1,
      show_as_error: false
    };
  },


  computed: {
    isRequired: function isRequired() {
      return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
    },

    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    labelStyle: function labelStyle() {
      return (this.$props.data.label_style || "") + this.local_style;
    },
    apiName: function apiName() {
      return this.$props.data.api_name;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      var len = this.$store.state[this.stateCurrentRow][this.fieldID] ? this.$store.state[this.stateCurrentRow][this.fieldID].length : 0;
      return this.localRefreshSequecnce > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.repeat("*", len) : "";
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    isDisabled: function isDisabled() {

      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      var ret = this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      if (ret && this.had_focus) {
        this.had_focus = false;
      }
      return ret;
    },
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || "";
      return "display: inline-block;width: 100%;" + store_style;
    }
  },
  methods: {
    atFocus: function atFocus() {
      console.log("atFocus ", this.had_focus);
      if (this.had_focus == false) {
        console.log("atFocus false");
        this.had_focus = true;
        this.$store.state[this.stateCurrentRow][this.fieldID] = "";
      }
    },
    onClick: function onClick(b) {
      if (b.type == "add_to_input") {
        this.$refs.local_value.value = b.text;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text;
      }
      if (b.type == "link") {
        this.$router.push(b.link);
      }
      return false;
    },
    updateValue: function updateValue(d) {
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$props.data.ref_field = this;
    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this.showAsError == false) {
          return cb(false);
        }
        var local_val = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(_this.$store.state[_this.stateCurrentEditing][_this.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(_this.$store.state[_this.stateCurrentRow][_this.fieldID]);
        }
        if (msg.show_as_error_mode && msg.only_if_enabled == true && _this.isDisabled == true) {
          _this.showAsError = false;
          _this.$store.state[_this.stateCurrentRow][_this.fieldID] = local_val;
          _this.updateValue(local_val);
          _this.localRefreshSequecnce++;
          return cb(false);
        }
        _this.showAsError = msg.show_as_error_mode || false;
        _this.$store.state[_this.stateCurrentRow][_this.fieldID] = local_val;
        _this.updateValue(local_val);
        _this.localRefreshSequecnce++;
        return cb(true);
      }
    };
  },

  props: ['data', 'value', 'date', 'read']
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_bus__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    onClick: function onClick(d, event) {
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d.text;
    },
    isChecked: function isChecked(val) {
      return this.$store.state[this.stateCurrentRow][this.fieldID] == val;
    }
  },
  computed: {
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    buttons: function buttons() {
      return this.$props.data.buttons;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      return this.$store.state[this.stateCurrentEditing][this.fieldID];
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    isDisabled: function isDisabled() {

      return this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$props.data.ref_field = this;
    if (typeof this.$props.data.set_global_on != "undefined") {

      __WEBPACK_IMPORTED_MODULE_0__libs_bus__["a" /* bus */].$on(this.$props.data.set_global_on.watch, function (val) {
        var new_val = _this.$props.data.set_global_on.options[val] || false;
        console.log("RADIO RECEIVED ", _this.$props.data.set_global_on.watch, " event with ", val, "to set to ", new_val);
        if (new_val) {
          _this.$store.state[_this.stateCurrentRow][_this.fieldID] = new_val;
          _this.$store.state[_this.stateCurrentEditing][_this.fieldID] = new_val;
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof this.$props.data.set_global_on != "undefined") {

      __WEBPACK_IMPORTED_MODULE_0__libs_bus__["a" /* bus */].$off(this.$props.data.set_global_on.watch);
    }
  },


  props: ['data', 'value', 'read']
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_constants__);







var debug_select = __WEBPACK_IMPORTED_MODULE_2_debug___default()("__esma:select-box");
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated: false,
      cache_for_disable_and_clean_if_value: false,
      local_disabled: false,
      label_class: "col-xs-4 control-label esma_form_label",
      local_refresh_sequecnce: 1,
      show_as_error: false,
      last_emit_value: false,
      last_emit_time: 0,
      disabled_is_required: false,
      external_disabled: false
    };
  },

  computed: {
    externalDisabled: {
      get: function get() {
        return this.external_disabled;
      },
      set: function set(v) {
        this.external_disabled = v;
      }
    },
    disabledIsRequired: {
      get: function get() {
        return this.disabled_is_required;
      },
      set: function set(v) {
        var local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.disabled_is_required = v;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
      }
    },
    isRequired: function isRequired() {
      return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
    },

    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    labelClass: function labelClass() {
      var complement = this.showAsError == true ? " esma_error_field" : "";
      if (typeof this.$props.data.label_class != "undefined") {
        return this.$props.data.label_class + complement;
      } else {
        return this.label_class + complement;
      }
    },

    localDisabled: {
      get: function get() {
        return this.local_disabled;
      },
      set: function set(v) {
        this.local_disabled = v;
      }
    },
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldOptions: function fieldOptions() {
      var _this = this;

      var base_options = this.$props.data.options;

      if (typeof this.$props.data.from_local_storage != "undefiend" && this.$props.data.from_local_storage && this.$props.data.from_local_storage.length > 0) {
        var ls = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(this.$props.data.from_local_storage);
        var default_val = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(this.$props.data.default_from_local_storage);
        if (default_val == __WEBPACK_IMPORTED_MODULE_4__rules_constants___default.a.COMPANY.ALL) {
          default_val = "";
        }
        if (ls && ls.length > 0) {
          base_options = [];
          JSON.parse(ls).forEach(function (v) {
            base_options.push(v.value);
            if (default_val && default_val.length > 0 && v.value == default_val && _this.value_updated == false) {
              setTimeout(function () {
                if (_this.fieldValue == "") {
                  _this.updateValue("");
                  _this.$store.state[_this.stateCurrentRow][_this.fieldID] = default_val;
                  _this.updateValue(default_val);
                  _this.refreshOptions();
                }
              }, 100);
            }
          });
        }
      } else if (typeof this.$props.data.default_value != "undefiend" && this.$props.data.default_value && this.$props.data.default_value.length > 0) {
        if (this.fieldValue == "") {
          this.updateValue("");
          this.$store.state[this.stateCurrentRow][this.fieldID] = this.$props.data.default_value;
          this.updateValue(this.$props.data.default_value);
          this.refreshOptions();
        }
      }

      debug_select("base_options", base_options);
      debug_select("select-box this.$props.data", this.$props.data);

      if (this.forced_options != null && this.isDisabled == false) {
        debug_select("field Options using forced options", this.forced_options);
        base_options = this.forced_options;
      } else {
        debug_select("field Options using normal options", this.forced_options, base_options);
      }
      this.local_options = [];
      base_options.forEach(function (d) {
        _this.local_options.push(d);
      });
      if (this.local_options.indexOf(this.fieldValue) < 0) {
        debug_select("field Options step 1", this.fieldValue);
        if (this.forced_options == null) {
          debug_select("field Options step 2", this.fieldValue);
          this.local_options.unshift(this.fieldValue);
        } else {
          debug_select("field Options step 3", this.fieldID);
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
        }
      }
      debug_select("field Options using FINAL options", { forced_options: this.forced_options, local_options: this.local_options });

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(this.local_options, function (d) {
        return d == "" || d == null;
      });
      return this.local_options;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      var val = this.$store.state[this.stateCurrentRow][this.fieldID];
      if (this.local_options.indexOf(val) < 0) {
        if (this.forced_options == null) {
          this.local_options.unshift(val);
        } else {
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
        }
      }
      if (typeof this.$props.data.on_set_value == "function") {
        var now = new Date().getTime();

        if (this.last_emit_value != this.$store.state[this.stateCurrentRow][this.fieldID] || now - this.last_emit_time > 500) {
          this.last_emit_time = now;
          this.last_emit_value = this.$store.state[this.stateCurrentRow][this.fieldID];
          this.$props.data.on_set_value(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
      }
      return this.localRefreshSequecnce > 0 ? this.$store.state[this.stateCurrentRow][this.fieldID] : "";
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    fieldClass: function fieldClass() {
      if (typeof this.$props.data.field_class != "undefined") {
        return this.$props.data.field_class;
      } else if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    isDisabled: function isDisabled() {
      var ret = null;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.localDisabled || this.externalDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      } else {
        ret = this.localDisabled || this.externalDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      if (ret == false) {
        this.checkToApplySelectionRules(this.$store.state[this.stateCurrentRow][this.fieldID]);
      }
      return ret;
    }
  },
  methods: {
    specialLabels: function specialLabels(v) {
      return v;
    },
    onClick: function onClick() {},
    updateValue: function updateValue(d) {
      debug_select("updateValue", d);
      this.value_updated = true;

      if (typeof this.$props.data.global_emit != "undefined") {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(this.$props.data.global_emit, d);
      }
      if (typeof this.$props.data.on_set_value == "function") {
        this.$props.data.on_set_value(d);
      }
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
      this.checkToApplySelectionRules(d);
      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: d });
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents: function onReceiveEvents(e, data) {
      var _this2 = this;

      if (e.mode == "select_only") {
        debug_select("RECEIVING '", this.$props.data.id, "' set only '", data.allow, "' as requested by '", e.name, "'");
        this.forced_options = data.allow;
        if (data.allow && data.allow.length == 1 && data.allow[0] == "") {
          this.$store.state[this.stateCurrentRow][this.$props.data.id] = "";
          this.$store.state[this.stateCurrentEditing][this.$props.data.id] = "";
        }
      } else if (e.mode == "select_and_set_only") {
        debug_select("RECEIVING '", this.fieldID, "' set only '", data.allow, "' as requested by '", e.name, "'");
        this.forced_options = data.allow;
        if (data.disable === true) {
          this.localDisabled = true;
        } else if (data.disable === false) {
          this.localDisabled = false;
        }
        if (data.allow && data.allow.length == 1 && data.select == true) {
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
          this.$store.state[this.stateCurrentEditing][this.fieldID] = "";
          this.localRefreshSequecnce++;
          setTimeout(function () {
            _this2.$store.state[_this2.stateCurrentRow][_this2.fieldID] = data.allow[0];
            _this2.$store.state[_this2.stateCurrentEditing][_this2.fieldID] = data.allow[0];
            _this2.localRefreshSequecnce++;
          }, 200);
        }
      } else if (e.mode == "disable_if_value") {
        if (e.disable_if_value == data.val) {
          this.localDisabled = false;
        } else {
          this.localDisabled = true;
        }
      } else if (e.mode == "disable_and_clean_if_value") {
        if (e.disable_if_value == data.val) {
          if (this.localDisabled != false) {
            this.$store.state[this.stateCurrentRow][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
            this.$store.state[this.stateCurrentEditing][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
          }
          this.localDisabled = false;
        } else {
          if (this.localDisabled != true) {
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID] || this.$props.data.default || "";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentRow][this.fieldID] = this.$props.data.default || "";
          this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$props.data.default || "";
        }
      }
    },
    checkToApplySelectionRules: function checkToApplySelectionRules(selected) {
      var _this3 = this;

      if (this.selection_rules != false) {
        debug_select("checkToApplySelectionRules for ", selected);
        this.selection_rules.forEach(function (rule) {
          if (rule.action == "select_only" && rule.mode == "on_select") {
            var allow = rule.options[selected] || null;
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, { allow: allow, from: _this3.$props.data.id });
            __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(rule.event_name, { allow: allow, from: _this3.$props.data.id });
          } else if (rule.action == "enable_if_match_or_empty" && rule.mode == "on_select") {
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, { selected: selected, id: _this3.fieldID });
            __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(rule.event_name, { selected: selected, id: _this3.fieldID });
          }
        });
      }
    },
    refreshOptions: function refreshOptions() {
      var _this4 = this;

      var temp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.local_options);
      this.local_options = [];
      temp.forEach(function (e) {
        _this4.local_options.push(e);
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$props.data.ref_field = this;

    if (typeof this.$props.data.selection_rules != "undefined" && this.$props.data.selection_rules.length > 0) {
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(function (e) {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(e.name).$on(e.name, function (data) {
          _this5.onReceiveEvents(e, data);
        });
      });
    }
    if (typeof this.$props.data.listen_for_value != "undefined") {
      var bus_name = this.$props.data.listen_for_value;
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(bus_name).$on(bus_name, function (new_value) {
        _this5.updateValue(new_value);
        _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] = new_value;
        _this5.localRefreshSequecnce++;
      });
    }
    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this5.showAsError == false) {
          return cb(false);
        }
        var local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this5.$store.state[_this5.stateCurrentEditing][_this5.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this5.$store.state[_this5.stateCurrentRow][_this5.fieldID]);
        }
        if (msg.show_as_error_mode && msg.only_if_enabled == true && _this5.isDisabled == true) {
          _this5.showAsError = false;
          _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] = local_val;
          _this5.updateValue(local_val);
          _this5.localRefreshSequecnce++;
          return cb(false);
        }
        _this5.showAsError = msg.show_as_error_mode || false;
        _this5.$store.state[_this5.stateCurrentRow][_this5.fieldID] = local_val;
        _this5.updateValue(local_val);
        _this5.localRefreshSequecnce++;
        return cb(true);
      }
    };
    if (this.$props.data.page_controller) {
      this.$props.data.page_controller_msg = function (options) {
        switch (options.cmd) {
          case "enable":
            _this5.localDisabled = false;
            break;
          case "disable":
            _this5.localDisabled = true;
            break;
          default:
            break;
        }
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof this.$props.data.listen_for_value != "undefined") {
      var bus_name = this.$props.data.listen_for_value;
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(bus_name);
    }
  },


  props: ["data", "value", "option", "read"]
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);




var select2_debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()("__esma:select-box2");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      local_options: [],
      local_refresh_sequecnce: 1,
      show_as_error: false,
      disabled_is_required: false,
      page_controller_disabled: false
    };
  },


  computed: {
    pageControllerDisabled: {
      get: function get() {
        return this.page_controller_disabled;
      },
      set: function set(v) {
        this.page_controller_disabled = v;
      }
    },
    disabledIsRequired: {
      get: function get() {
        return this.disabled_is_required;
      },
      set: function set(v) {
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.disabled_is_required = v;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
      }
    },
    isRequired: function isRequired() {
      return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
    },

    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    fieldStyle: function fieldStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.style || "") + store_style;
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldOptions: function fieldOptions() {
      var _this = this;

      select2_debug("fieldOptions", this.$props.data.options);
      this.local_options = [];
      this.$props.data.options.forEach(function (d) {
        _this.local_options.push(d);
      });
      if (this.local_options.indexOf(this.fieldValue) < 0) {
        select2_debug("adding ", this.fieldValue);
      }
      select2_debug("options", this.local_options);
      return this.local_options;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      var val = this.$store.state[this.stateCurrentRow][this.fieldID];
      if (typeof val == "undefined") {
        return false;
      }
      if (this.local_options.indexOf(val) < 0 && val != null && val != "") {}
      select2_debug("fieldValue d", val, this.$store.state[this.stateCurrentRow][this.fieldID], this.fieldID);
      if (this.$store.state[this.stateCurrentRow][this.fieldID] === 0) {
        return 0;
      }
      return this.$store.state[this.stateCurrentRow][this.fieldID] || "";
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    fieldClass: function fieldClass() {
      if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    isDisabled: function isDisabled() {
      var ret = null;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.pageControllerDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      } else {
        ret = this.pageControllerDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      select2_debug("isDisabled", ret, this.$props.data.disabled, this.$props.read, this.$store.state[this.stateCurrentRow][this.fieldID]);
      return ret;
    }
  },
  methods: {
    updateValue: function updateValue(d) {
      if (typeof this.$props.data.global_emit != "undefined") {
        __WEBPACK_IMPORTED_MODULE_0__libs_bus__["a" /* bus */].$emit(this.$props.data.global_emit, d);
      }
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: d });
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$props.data.ref_field = this;
    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this2.showAsError == false) {
          return cb(false);
        }
        var local_val = _.clone(_this2.$store.state[_this2.stateCurrentEditing][_this2.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = _.clone(_this2.$store.state[_this2.stateCurrentRow][_this2.fieldID]);
        }
        if (msg.show_as_error_mode && msg.only_if_enabled == true && _this2.isDisabled == true) {
          _this2.showAsError = false;
          _this2.$store.state[_this2.stateCurrentRow][_this2.fieldID] = local_val;
          _this2.updateValue(local_val);
          _this2.localRefreshSequecnce++;
          return cb(false);
        }
        _this2.showAsError = msg.show_as_error_mode || false;
        _this2.$store.state[_this2.stateCurrentRow][_this2.fieldID] = local_val;
        _this2.updateValue(local_val);
        _this2.localRefreshSequecnce++;
        return cb(true);
      }
    };

    if (this.$props.data.page_controller) {
      this.$props.data.page_controller_msg = function (options) {
        switch (options.cmd) {
          case "enable":
            _this2.pageControllerDisabled = false;
            break;
          case "disable":
            _this2.pageControllerDisabled = true;
            break;
          default:
            break;
        }
      };
    }
  },

  props: ["data", "value", 'option', 'read']
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_input_modal__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_input_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_input_modal__);





var debug_select = __WEBPACK_IMPORTED_MODULE_2_debug___default()("__esma:select-box3");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("input-modal", __WEBPACK_IMPORTED_MODULE_4__components_modals_input_modal___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated: false,
      last_disabled_status: true
    };
  },

  methods: {
    specialLabels: function specialLabels(v) {
      return v;
    },
    onClick: function onClick() {},
    onManualSelect: function onManualSelect(val) {
      this.value_updated = true;
      console.log("onManualSelect in > ", val);
      if (typeof this.$props.data.global_emit != "undefined") {
        console.log("onManualSelect in (not undefined)> ", val);
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(this.$props.data.global_emit, val);
      }
      this.$store.state[this.stateCurrentEditing][this.fieldID] = val;
      this.$store.state[this.stateCurrentRow][this.fieldID] = val;
      this.checkToApplySelectionRules(val);
      this.refreshOptions();
    },
    updateValue: function updateValue(d) {
      this.value_updated = true;

      if (d == "manual_input") {
        console.log("manual_input INPUT");
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit("showInputModal" + this.fieldID, {
          title: this.fieldLabel + "手入力",
          initial_value: this.$store.state[this.stateCurrentRow][this.fieldID]
        });
      } else {
        console.log("manual_input out");
        if (typeof this.$props.data.global_emit != "undefined") {
          console.log("manual_input IN");
          __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(this.$props.data.global_emit, d);
        }
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
        this.checkToApplySelectionRules(d);
      }
      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: d });
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents: function onReceiveEvents(ev, data) {
      if (ev.mode == "select_only") {
        debug_select("RECEIVING '", this.$props.data.id, "' set only '", data.allow, "' as requested by '", ev.name, "'");
        this.forced_options = data.allow;
        if (data.allow && data.allow.length == 1 && data.allow[0] == "") {
          this.$store.state[this.stateCurrentRow][this.$props.data.id] = "";
          this.$store.state[this.stateCurrentEditing][this.$props.data.id] = "";
        }
      }
    },
    checkToApplySelectionRules: function checkToApplySelectionRules(selected) {
      var _this = this;

      debug_select("checkToApplySelectionRules for (start)", selected, this.selection_rules);
      if (this.selection_rules != false) {
        debug_select("checkToApplySelectionRules for (in)", selected);
        this.selection_rules.forEach(function (rule) {
          if (rule.action == "select_only" && rule.mode == "on_select") {
            var allow = rule.options[selected] || null;
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, { allow: allow, from: _this.$props.data.id });
            __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(rule.event_name, { allow: allow, from: _this.$props.data.id });
          } else if (rule.action == "enable_if_match_or_empty" && rule.mode == "on_select") {
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, { selected: selected, id: _this.fieldID });
            __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(rule.event_name, { selected: selected, id: _this.fieldID });
          }
        });
      }
    },
    refreshOptions: function refreshOptions() {
      var _this2 = this;

      var temp = _.clone(this.local_options);
      this.local_options = [];
      temp.forEach(function (e) {
        _this2.local_options.push(e);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$props.data.ref_field = this;

    if (typeof this.$props.data.selection_rules != "undefined" && this.$props.data.selection_rules.length > 0) {
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(function (e) {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(e.name).$on(e.name, function (data) {
          _this3.onReceiveEvents(e, data);
        });
      });
    }
  },

  computed: {
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldOptions: function fieldOptions() {
      var _this4 = this;

      var base_options = this.$props.data.options;
      if (typeof this.$props.data.from_local_storage != "undefiend" && this.$props.data.from_local_storage && this.$props.data.from_local_storage.length > 0) {
        var ls = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(this.$props.data.from_local_storage);
        var default_val = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(this.$props.data.default_from_local_storage);
        if (default_val == __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.ALL) {
          default_val = "";
        }
        if (ls && ls.length > 0) {
          base_options = [];
          JSON.parse(ls).forEach(function (v) {
            base_options.push(v.value);
            if (default_val && default_val.length > 0 && v.value == default_val && _this4.value_updated == false) {
              setTimeout(function () {
                if (_this4.fieldValue == "") {
                  _this4.updateValue("");
                  _this4.$store.state[_this4.stateCurrentRow][_this4.fieldID] = default_val;
                  _this4.updateValue(default_val);
                  _this4.refreshOptions();
                }
              }, 100);
            }
          });
        }
      }

      debug_select("base_options", base_options);

      if (this.forced_options != null && this.isDisabled == false) {
        debug_select("field Options using forced options", this.forced_options);
        base_options = this.forced_options;
      } else {
        debug_select("field Options using normal options", this.forced_options, base_options);
      }
      this.local_options = [];
      base_options.forEach(function (d) {
        _this4.local_options.push(d);
      });
      if (this.local_options.indexOf(this.fieldValue) < 0) {
        debug_select("field Options step 1", this.fieldValue);
        if (this.forced_options == null) {
          debug_select("field Options step 2", this.fieldValue);
          this.local_options.unshift(this.fieldValue);
        } else {
          debug_select("field Options step 3", this.fieldID);
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
        }
      }
      if (this.local_options.indexOf("") < 0 && this.fieldValue != "" && this.fieldValue != null) {
        this.local_options.unshift("");
      }
      debug_select("field Options using FINAL options", { forced_options: this.forced_options, local_options: this.local_options });
      return this.local_options;
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      var val = this.$store.state[this.stateCurrentRow][this.fieldID];
      if (this.local_options.indexOf(val) < 0) {
        if (this.forced_options == null) {
          this.local_options.unshift(val);
        } else {
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
        }
      }
      return this.$store.state[this.stateCurrentRow][this.fieldID];
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    fieldClass: function fieldClass() {
      if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    isDisabled: function isDisabled() {
      var ret = null;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      } else {
        ret = this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      if (ret == false) {
        this.checkToApplySelectionRules(this.$store.state[this.stateCurrentRow][this.fieldID]);
      }
      if (this.last_disabled_status != ret) {
        this.last_disabled_status = ret;
        this.value_updated = false;
      }
      return ret;
    }
  },
  props: ["data", "value", "option", "read"]
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_vue_select_dist_vue_select_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_vue_select_dist_vue_select_css__);








var debug_select = __WEBPACK_IMPORTED_MODULE_2_debug___default()("__esma:select-box");



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-select': __WEBPACK_IMPORTED_MODULE_6_vue_select___default.a
  },
  data: function data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated: false,
      field_options: [],
      original_field_options: [],
      cache_for_disable_and_clean_if_value: false,
      local_disabled: false,
      last_search_value: false,
      local_refresh_sequecnce: 1,
      show_as_error: false,
      page_controller_on_select: false,
      local_data_loaded: false,
      is_loading: false,
      disabled_is_required: false,
      external_disabled: false,
      force_edit: false,
      current_user: "",
      ignore_values: []

    };
  },

  computed: {
    ignoreValues: {
      get: function get() {
        return this.ignore_values;
      },
      set: function set(v) {
        this.ignore_values = v;
      }
    },
    currentUser: {
      get: function get() {
        return this.current_user;
      },
      set: function set(v) {
        this.current_user = v;
      }
    },
    forceEdit: {
      get: function get() {
        return this.force_edit;
      },
      set: function set(v) {
        this.force_edit = v;
      }
    },
    isNoAdminUserId: function isNoAdminUserId() {
      var role = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userRole");
      return role == "管理担当者" || role == "管理責任者";
    },

    externalDisabled: {
      get: function get() {
        return this.external_disabled;
      },
      set: function set(v) {
        this.external_disabled = v;
      }
    },
    disabledIsRequired: {
      get: function get() {
        return this.disabled_is_required;
      },
      set: function set(v) {
        this.page_controller_disable_propagate = true;
        var local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.disabled_is_required = v;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        this.page_controller_disable_propagate = false;
      }
    },
    searchModeTypeahead: function searchModeTypeahead() {
      return this.$props.data.search_mode_type_ahead || false;
    },

    isLoading: {
      get: function get() {
        return this.is_loading;
      },
      set: function set(v) {
        this.is_loading = v;
      }
    },
    isRequired: function isRequired() {
      return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
    },

    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    disallowFirstEmptyOption: function disallowFirstEmptyOption() {
      if (typeof this.$props.data.allow_first_empty_option == "undefined") {
        return true;
      }
      return this.$props.data.allow_first_empty_option != true;
    },

    localDisabled: {
      get: function get() {
        return this.local_disabled;
      },
      set: function set(v) {
        this.local_disabled = v;
      }
    },
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },


    originalFieldOptions: {
      get: function get() {
        return this.original_field_options;
      },
      set: function set(v) {
        this.original_field_options = v;
      }
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      var _this = this;

      if (this.isSearchMode) {
        if (this.last_search_value != false) {
          return this.last_search_value;
        }
        if (typeof this.$props.search_value == "string" && this.$props.search_value.length > 0) {
          return this.$props.search_value;
        }
        return "";
      }
      var val = this.$store.state[this.stateCurrentRow][this.fieldID];
      this.fieldOptions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.originalFieldOptions);
      if (this.fieldOptions.indexOf(val) < 0) {
        this.fieldOptions.unshift(val);
      }

      if (typeof this.$props.data.event_emit_bus_key == "string" && this.$props.data.event_emit_bus_key.length > 0) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(_this.$props.data.event_emit_bus_key, { val: _this.$store.state[_this.stateCurrentRow][_this.fieldID] });
        }, 500);
      }
      return this.localRefreshSequecnce > 0 ? this.$store.state[this.stateCurrentRow][this.fieldID] : "";
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    fieldClass: function fieldClass() {
      if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    isSearchMode: function isSearchMode() {
      if (this.getOption("search_mode", false) == true) {
        return true;
      } else {
        return false;
      }
    },
    isSearchBlockID: function isSearchBlockID() {
      return parseInt(this.getOption("search_block_id", false) || -1);
    },
    isDisabled: function isDisabled() {
      var ret = null;
      if (this.isSearchMode == true) {
        return false;
      }
      if (this.forceEdit == true) {
        return false;
      }
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.isLoading || this.externalDisabled || this.localDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      } else {
        ret = this.isLoading || this.externalDisabled || this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      if (ret == false) {
        if (this.local_data_loaded == false) {
          this.load_local_data();
        }
        this.checkToApplySelectionRules(this.$store.state[this.stateCurrentRow][this.fieldID]);
      }
      return ret;
    },

    fieldOptions: {
      get: function get() {
        var _this2 = this;

        if (this.$props.data.page_controller == true && this.isSearchMode != true) {
          if (this.$props.data && this.$props.data.page_controller_use_key_name == true) {
            var temp = this.field_options || [];
            var temp2 = [];
            if (typeof this.$props.data.api_field_name != "undefined" && this.$props.data.api_field_name.length > 0) {
              temp2 = temp.map(function (o) {
                var r = o[_this2.$props.data.api_field_name] || "";
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(r);
              });;
            } else {
              temp2 = temp.map(function (o) {
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(o.val || "");
              });;
            }
            if (this.$props.data.sort_result == true) {
              temp2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(temp2, function (d) {
                return d.toLowerCase();
              });
            }
            return temp2;
          } else {
            if (this.$props.data.sort_result == true) {
              return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(this.field_options, function (d) {
                return d.toLowerCase();
              });
            } else {
              return this.field_options;
            }
          }
        }

        var temp = this.field_options || [];
        if (this.isSearchMode == true) {
          var found_as_dependency = false;
          if (this.$props.data && this.$props.data.search_dependency) {
            var sd = this.$props.data.search_dependency;
            if (sd.algorithm == "company") {
              var search_data = this.$store.state.search_data;
              if (this.fieldID == sd.fields.company) {}

              if (this.fieldID == sd.fields.department.field || this.fieldID == sd.fields.team.field) {
                found_as_dependency = true;

                var companies = this.loadFromSearch(sd.fields.company.field);
                var temp2 = temp;
                if (companies.length == 1) {
                  temp2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(temp, function (obj) {
                    return obj[sd.fields.company.api] == companies[0].value;
                  });
                } else if (companies.length == 2) {
                  temp2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(temp, function (obj) {
                    return obj[sd.fields.company.api] == companies[0].value || obj[sd.fields.company.api] == companies[1].value;
                  });
                }
                temp = temp2;
              }

              if (this.fieldID == sd.fields.team.field) {
                found_as_dependency = true;
                var departments = this.loadFromSearch(sd.fields.department.field);
                var temp2 = temp;
                if (departments.length == 1) {
                  temp2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(temp, function (obj) {
                    return obj[sd.fields.department.api] == departments[0].value;
                  });
                } else if (departments.length == 2) {
                  temp2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(temp, function (obj) {
                    return obj[sd.fields.department.api] == departments[0].value || obj[sd.fields.department.api] == departments[1].value;
                  });
                }
                temp = temp2;
              }
            }
          }
          if (found_as_dependency == false && this.$props.data.search_limit_no_admin_company_from_local_storage == true) {
            var user_company = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userCompany");
            if (user_company != __WEBPACK_IMPORTED_MODULE_5__rules_constants___default.a.COMPANY.ALL && user_company && user_company.length > 0 && this.isNoAdminUserId) {
              temp = [{ val: user_company }];
            }
          } else if (found_as_dependency == false && typeof this.$props.data.search_option != "undefined" && typeof this.$props.data.search_option.define_department_limit_by_key != "undefined") {
            if (this.$store.state.define_department_limit != false) {
              if (this.$store.state.define_department_limit.by_key == this.$props.data.search_option.define_department_limit_by_key) {
                var temp2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(temp, function (obj) {
                  return obj[_this2.$props.data.search_option.api_field_name] == _this2.$store.state.define_department_limit.val;
                });
                temp = temp2;
              }
            }
          }
        } else {
          if (typeof this.$props.data.api_filter_to_other_field != "undefined") {
            if (typeof this.$props.data.api_filter_to_other_field.by_field != "undefined" && typeof this.$props.data.api_filter_to_other_field.compare_api_key != "undefined") {
              var by_field = this.$props.data.api_filter_to_other_field.by_field || "";
              var compare_api_key = this.$props.data.api_filter_to_other_field.compare_api_key || "";
              if (by_field.length > 0 && compare_api_key.length > 0) {
                var current_value = "";
                if (typeof this.$store.state[this.stateCurrentRow] != "undefined" && typeof this.$store.state[this.stateCurrentRow][by_field] != "undefined" && this.$store.state[this.stateCurrentRow][by_field] != null && this.$store.state[this.stateCurrentRow][by_field].length > 0) {
                  current_value = this.$store.state[this.stateCurrentRow][by_field];
                }
                if (typeof this.$store.state[this.stateCurrentEditing] != "undefined" && typeof this.$store.state[this.stateCurrentEditing][by_field] != "undefined" && this.$store.state[this.stateCurrentEditing][by_field] != null && this.$store.state[this.stateCurrentEditing][by_field].length > 0) {
                  current_value = this.$store.state[this.stateCurrentEditing][by_field];
                }

                if (current_value.length > 0) {
                  temp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(temp, function (o) {
                    return o[compare_api_key] == current_value;
                  });
                }
              }
            }
          }
        }
        if (this.stateIsEditingNew) {
          if (typeof this.$props.data.default_from_local_storage != "undefined") {
            var default_val = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(this.$props.data.default_from_local_storage);
            if (default_val == __WEBPACK_IMPORTED_MODULE_5__rules_constants___default.a.COMPANY.ALL) {
              default_val = "";
            }
            if (this.isNoAdminUserId == false && this.isSearchMode == true) {
              default_val = "";
            }
            if (default_val && default_val.length > 0 && this.value_updated == false) {
              setTimeout(function () {
                if (_this2.fieldValue == "") {
                  _this2.updateValue("");
                  _this2.$store.state[_this2.stateCurrentRow][_this2.fieldID] = default_val;
                  _this2.updateValue(default_val);
                  _this2.refreshOptions();
                }
              }, 200);
            }
          }
        }

        var temp2 = [];
        if (typeof this.$props.data.api_field_name != "undefined" && this.$props.data.api_field_name.length > 0) {
          temp2 = temp.map(function (o) {
            var r = o[_this2.$props.data.api_field_name] || "";
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(r);
          });;
        } else {
          temp2 = temp.map(function (o) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(o.val || "");
          });;
        }
        if (this.$props.data.sort_result == true) {
          temp2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(temp2, function (d) {
            return d;
          });
        }
        var i = 0;
        var removed = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(temp2, function (d) {
          return typeof d == "undefined" || d == "" || d == null || d == undefined;
        });

        if (Array.isArray(this.$props.data.do_not_repeat) && this.$props.data.do_not_repeat.length > 0) {
          this.$props.data.do_not_repeat.forEach(function (dnr) {
            var dnr_v = _this2.$store.state[_this2.stateCurrentEditing][dnr];
            if (_this2.forceEdit == true && !(dnr_v && dnr_v.length > 0)) {
              dnr_v = _this2.$store.state[_this2.stateCurrentRow][dnr];
            }
            if (dnr_v && dnr_v.length > 0) {
              __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(temp2, function (t) {
                return t == dnr_v;
              });
            }
          });
        }
        if (this.$props.data.ignore_current_user == true) {
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(temp2, function (t) {
            return t == _this2.currentUser;
          });
        }
        if (Array.isArray(this.ignoreValues) && this.ignoreValues.length > 0) {
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(temp2, function (t) {
            return _this2.ignoreValues.indexOf(t) > -1;
          });
        }
        if (this.$props.data.api_uniq_grouping == true) {
          return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(temp2);
        } else {
          return temp2;
        }
      },
      set: function set(v) {
        this.field_options = v;
      }
    }
  },
  methods: {
    loadFromSearch: function loadFromSearch(field_id) {
      var search_data = this.$store.state.search_data;
      var ret = [];
      if (search_data[1] && search_data[1].field == field_id) {
        ret.push(search_data[1]);
      }
      if (search_data[2] && search_data[2].field == field_id) {
        ret.push(search_data[2]);
      }
      if (search_data[3] && search_data[3].field == field_id) {
        ret.push(search_data[3]);
      }
      return ret;
    },
    specialLabels: function specialLabels(v) {
      var _this3 = this;

      if (v && v.length > 0) {
        if (typeof this.$props.data.field_label_reference != "undefined" && this.$props.data.field_label_reference.length > 0 && this.$store.state[this.stateCurrentRow][this.fieldID] == v && typeof this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference] != "undefined" && this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference] && this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference].length > 0) {
          return this.$store.state[this.stateCurrentRow][this.$props.data.field_label_reference];
        }
      }
      if (typeof this.$props.data.api_field_label != "undefined" && this.$props.data.api_field_label.length > 0 && typeof this.$props.data.api_field_name != "undefined" && this.$props.data.api_field_name.length > 0) {
        var val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.originalFieldOptions, function (o) {
          return o[_this3.$props.data.api_field_name] == v;
        });
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(val, [this.$props.data.api_field_label], v);
      } else {
        return v;
      }
    },
    onClick: function onClick(d) {
      if (this.$props.data.emit_click_event == true) {
        var val = false;
        if (this.$store.state[this.stateCurrentEditing][this.fieldID]) {
          val = this.$store.state[this.stateCurrentEditing][this.fieldID];
        } else if (this.$store.state[this.stateCurrentRow][this.fieldID]) {
          val = this.$store.state[this.stateCurrentRow][this.fieldID];
        }
        if (val && (val + "").length > 0) {
          this.updateValue(val);
        }
      }
    },
    updateValue: function updateValue(d) {
      var _this4 = this;

      debug_select("updateValue", d);
      if (this.$props.data && this.$props.data.search_dependency) {
        var sd = this.$props.data.search_dependency;
        if (Array.isArray(sd.clear_on_reset) && sd.clear_on_reset.length > 0) {
          sd.clear_on_reset.forEach(function (csd) {
            __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit("onSearchClearById", { field_id: csd, block_id: _this4.isSearchBlockID });
          });
        }
      }
      this.value_updated = true;

      if (this.$props.data.emit_input == true) {
        this.$emit("on_update", { field: this.fieldID, val: d });
      }
      if (typeof this.$props.data.global_emit != "undefined") {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(this.$props.data.global_emit, d);
      }
      if (this.isSearchMode == true) {
        this.$emit("change", d);
        this.last_search_value = d;
      } else {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
        this.checkToApplySelectionRules(d);
      }

      if (this.isSearchMode == true) {
        if (typeof this.$props.data.search_option != "undefined" && typeof this.$props.data.search_option.define_department_limit_to_key != "undefined") {
          this.$store.state.define_department_limit = {
            by_key: this.fieldID,
            val: d
          };
        }
      }
      if (typeof this.$props.data.on_select_event_emit_bus_key == "string" && this.$props.data.on_select_event_emit_bus_key.length > 0) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(_this4.$props.data.on_select_event_emit_bus_key, { val: d });
        }, 500);
      }
      if (typeof this.$props.data.event_emit_bus_key == "string" && this.$props.data.event_emit_bus_key.length > 0) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(_this4.$props.data.event_emit_bus_key, { val: d });
        }, 500);
      }
      if (this.page_controller_on_select) {
        this.page_controller_on_select(d);
      }
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents: function onReceiveEvents(e, data) {
      debug_select("onReceiveEvents my id ", this.$props.data.id, "Event", e, "Data", data);
      if (e.mode == "select_only") {
        debug_select("RECEIVING '", this.$props.data.id, "' set only '", data.allow, "' as requested by '", e.name, "'");
        this.forced_options = data.allow;
        if (data.allow && data.allow.length == 1 && data.allow[0] == "") {
          this.$store.state[this.stateCurrentRow][this.$props.data.id] = "";
          this.$store.state[this.stateCurrentEditing][this.$props.data.id] = "";
        }
      } else if (e.mode == "disable_if_value") {
        if (e.disable_if_value == data.val) {
          this.localDisabled = false;
        } else {
          this.localDisabled = true;
        }
      } else if (e.mode == "disable_and_clean_if_value") {
        if (e.disable_if_value == data.val) {
          if (this.localDisabled != false) {
            this.$store.state[this.stateCurrentRow][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
            this.$store.state[this.stateCurrentEditing][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
          }
          this.localDisabled = false;
        } else {
          if (this.localDisabled != true) {
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID] || this.$props.data.default || "";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentRow][this.fieldID] = this.$props.data.default || "";
          this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$props.data.default || "";
        }
      } else if (e.mode == "disable_and_set_message_if_value") {
        if (e.disable_if_value == data.val) {
          if (this.localDisabled != false) {
            this.$store.state[this.stateCurrentRow][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
            this.$store.state[this.stateCurrentEditing][this.fieldID] = this.cache_for_disable_and_clean_if_value || "";
          }
          this.localDisabled = false;
          this.localRefreshSequecnce++;
        } else {
          if (this.localDisabled != true) {
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID] || this.$props.data.default || "";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$props.data.default || "";
          this.$store.state[this.stateCurrentRow][this.fieldID] = e.msg || "";
          this.localRefreshSequecnce++;
        }
      }
    },
    checkToApplySelectionRules: function checkToApplySelectionRules(selected) {
      var _this5 = this;

      if (this.selection_rules != false) {
        debug_select("checkToApplySelectionRules for ", selected);
        this.selection_rules.forEach(function (rule) {
          if (rule.action == "select_only" && rule.mode == "on_select") {
            var allow = rule.options[selected] || null;
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, { allow: allow, from: _this5.$props.data.id });
            __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(rule.event_name, { allow: allow, from: _this5.$props.data.id });
          } else if (rule.action == "enable_if_match_or_empty" && rule.mode == "on_select") {
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, { selected: selected, id: _this5.fieldID });
            __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit(rule.event_name, { selected: selected, id: _this5.fieldID });
          }
        });
      }
    },
    refreshOptions: function refreshOptions() {
      var _this6 = this;

      var temp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.local_options);
      this.local_options = [];
      temp.forEach(function (e) {
        _this6.local_options.push(e);
      });
    },
    load_data: function load_data() {
      var _this7 = this;

      var api_filter_value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var cache_key = this.fieldID;
      if (this.isSearchMode == true) {
        cache_key = this.fieldID + "_for_search";
      }
      var cache = this.$store.state.cached_lists[cache_key];
      if (api_filter_value != false) {
        cache = this.$store.state.cached_lists[cache_key + api_filter_value];
      }

      cache = false;
      if (typeof cache != "undefined" && cache && cache != false && cache.length > 0) {
        this.fieldOptions = cache;
        this.originalFieldOptions = cache;
        if (typeof this.$props.data.force_select_first_option != "undefined" && this.$props.data.force_select_first_option == true) {
          this.updateValue(cache[0].val);
          this.last_search_value = cache[0].val;
        }
      } else {
        var data_obj = {};
        if (this.isSearchMode == true) {
          data_obj.limit_department_on_search = false;
          if (this.$props.data.limit_department_on_search || false) {
            data_obj.limit_department_on_search = this.isNoAdminUserId && this.$props.data.limit_department_on_search;
          }
          if (this.$props.data.limit_admin_department_on_search || false) {
            data_obj.limit_admin_department_on_search = this.$props.data.limit_admin_department_on_search || false;
          }
        } else {
          if (this.$props.data.limit_department_on_load || false) {
            data_obj.limit_department_on_load = this.$props.data.limit_department_on_load || false;
          }
        }
        if (typeof this.$props.data.api_filter_bus_key == "string" && this.$props.data.api_filter_bus_key.length > 0) {
          data_obj[this.$props.data.api_filter_bus_key] = api_filter_value != false && api_filter_value != null ? api_filter_value : "";
        }
        if (this.$props.data.page_controller == true && this.isSearchMode != true) {
          this.fieldOptions = [];
          this.originalFieldOptions = [];
        } else {
          this.isLoading = true;
          this.$ajax.post_cached_queued(this.$props.data.api, data_obj, function (err, result) {
            var data = result;
            _this7.isLoading = false;
            if (api_filter_value == false) {
              _this7.$store.state.cached_lists[cache_key] = data;
            } else {
              _this7.$store.state.cached_lists[cache_key + api_filter_value] = data;
            }
            if (typeof _this7.$props.data.api_complement_array != "undefined" && Array.isArray(_this7.$props.data.api_complement_array)) {
              _this7.$props.data.api_complement_array.forEach(function (e) {
                data.push(e);
              });
            }
            _this7.fieldOptions = data;
            _this7.originalFieldOptions = data;
            if (typeof _this7.$props.data.api_mode != "undefined") {
              if (_this7.$props.data.api_mode == "on_new_set_logged_user_no_edit") {
                if (_this7.stateIsEditingNew) {
                  var user = _this7.currentUser;
                  _this7.updateValue(user);
                }
              }
            }
            if (typeof _this7.$props.data.force_select_first_option != "undefined" && _this7.$props.data.force_select_first_option == true) {
              if (data && data[0] && data[0].val) {
                _this7.updateValue(data[0].val);
              }
            }
          });
        }
      }
    },
    load_local_data: function load_local_data() {
      this.local_data_loaded = true;
      if (this.$props.data.page_controller != true) {
        this.load_data(false);
      }
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.currentUser = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userID");
    this.$props.data.ref_field = this;
    if (this.isSearchMode == true || this.$props.data.pre_load_data == true) {
      this.load_data(false);
    }
    if (typeof this.$props.data.api_filter_bus_key == "string" && this.$props.data.api_filter_bus_key.length > 0) {
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.data.api_filter_bus_key, function (data) {
        _this8.load_data(data.val);
      });
    }
    if (typeof this.$props.data.api_filter_to_other_field != "undefined") {
      if (typeof this.$props.data.api_filter_to_other_field.filter_data_on_event != "undefined" && this.$props.data.api_filter_to_other_field.filter_data_on_event.length > 0) {
        if (this.$props.data.api_filter_to_other_field.disable_is_no_value == true) {
          this.localDisabled = true;
        }
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.data.api_filter_to_other_field.filter_data_on_event, function (data) {
          if (_this8.$props.data.api_filter_to_other_field.disable_is_no_value == true) {
            _this8.localDisabled = data == "";
          }
          var temp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this8.field_options);
          _this8.fieldOptions = [];
          setTimeout(function () {
            _this8.fieldOptions = temp;
          }, 50);
        });
      }
    }

    if (typeof this.$props.data.selection_rules != "undefined" && this.$props.data.selection_rules.length > 0) {
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(function (e) {
        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(e.name).$on(e.name, function (data) {
          _this8.onReceiveEvents(e, data);
        });
      });
    }
    if (typeof this.$props.data.listen_for_value != "undefined") {
      var bus_name = this.$props.data.listen_for_value;
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(bus_name).$on(bus_name, function (new_value) {
        _this8.updateValue(new_value);
        _this8.$store.state[_this8.stateCurrentRow][_this8.fieldID] = new_value;
        _this8.localRefreshSequecnce++;
      });
    }
    if (this.$props.data.page_controller) {
      this.$props.data.page_controller_setup = function (options) {
        _this8.page_controller_on_select = function (v) {
          if (_this8.page_controller_disable_propagate == true) {
            return;
          }
          options.on_select(v);
        };
      };
      this.$props.data.page_controller_msg = function (options) {
        switch (options.cmd) {
          case "enable_if_data":
            var fv = _this8.fieldValue;
            if (fv && fv.length > 0) {
              _this8.localDisabled = false;
            } else {
              _this8.localDisabled = true;
            }
            break;
          case "enable":
            _this8.localDisabled = false;
            break;
          case "disable":
            _this8.localDisabled = true;
            break;
          case "set_options":
            _this8.fieldOptions = [];
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(options.options, function (d) {
              return d == "" || d == null;
            });
            _this8.fieldOptions = options.options;
            _this8.originalFieldOptions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(options.options);
            if (_this8.page_controller_on_select && options.reset == true) {
              _this8.page_controller_on_select("");
            }
            if (options.options && options.options[0] && _this8.$store.state[_this8.stateCurrentRow][_this8.fieldID] == "") {} else {}
            break;
          case "set_options_kv":
            _this8.originalFieldOptions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(options.options);
            _this8.fieldOptions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(options.options);
            break;
          case "set_value":
            _this8.$store.state[_this8.stateCurrentRow][_this8.fieldID] = options.val;
            _this8.updateValue(options.val);
            _this8.localRefreshSequecnce++;
            break;

          default:
            break;
        }
      };
    }
    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this8.showAsError == false) {
          return cb(false);
        }
        _this8.page_controller_disable_propagate = true;
        var local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this8.$store.state[_this8.stateCurrentEditing][_this8.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this8.$store.state[_this8.stateCurrentRow][_this8.fieldID]);
        }
        if (msg.show_as_error_mode && msg.only_if_enabled == true && _this8.isDisabled == true) {
          _this8.showAsError = false;
          _this8.$store.state[_this8.stateCurrentRow][_this8.fieldID] = local_val;
          _this8.updateValue(local_val);
          _this8.localRefreshSequecnce++;
          _this8.page_controller_disable_propagate = false;
          return cb(false);
        }
        _this8.showAsError = msg.show_as_error_mode || false;
        _this8.$store.state[_this8.stateCurrentRow][_this8.fieldID] = local_val;
        _this8.updateValue(local_val);
        _this8.localRefreshSequecnce++;
        _this8.page_controller_disable_propagate = false;
        return cb(true);
      }
    };
  },
  beforeDestroy: function beforeDestroy() {

    if (this.isSearchMode == true) {
      if (typeof this.$props.data.search_option != "undefined" && typeof this.$props.data.search_option.define_department_limit_to_key != "undefined") {
        this.$store.state.define_department_limit = false;
      }
    }
    if (typeof this.$props.data.api_filter_bus_key == "string" && this.$props.data.api_filter_bus_key.length > 0) {
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.data.api_filter_bus_key);
    }
    if (typeof this.$props.data.api_filter_to_other_field != "undefined" && typeof this.$props.data.api_filter_to_other_field.filter_data_on_event != "undefined" && this.$props.data.api_filter_to_other_field.filter_data_on_event.length > 0) {
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.data.api_filter_to_other_field.filter_data_on_event);
    }
    if (typeof this.$props.data.listen_for_value != "undefined") {
      var bus_name = this.$props.data.listen_for_value;
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(bus_name);
    }
  },


  props: ["data", "value", "option", "read", "search_value"]
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      local_value: null,
      local_refresh_sequecnce: 1,
      show_as_error: false,
      hide_all: false,
      force_write: false
    };
  },


  computed: {
    fieldMessage: function fieldMessage() {
      return this.$props.data.field_message || "";
    },

    hideAll: {
      get: function get() {
        return this.hide_all;
      },
      set: function set(v) {
        this.hide_all = v;
      }
    },
    forcewrite: {
      get: function get() {
        return this.force_write;
      },
      set: function set(v) {
        this.force_write = v;
      }
    },
    showLabelAs4: function showLabelAs4() {
      return this.$props.data.label_length_4 == true || false;
    },
    isRequired: function isRequired() {
      return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
    },

    showAsError: {
      get: function get() {
        return this.show_as_error;
      },
      set: function set(v) {
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce: {
      get: function get() {
        return this.local_refresh_sequecnce;
      },
      set: function set(v) {
        this.local_refresh_sequecnce = v;
      }
    },
    stateCurrentRow: function stateCurrentRow() {
      if (typeof this.$props.data.state_current_row != "undefined") {
        return this.$props.data.state_current_row;
      } else {
        return "current_row";
      }
    },
    stateCurrentEditing: function stateCurrentEditing() {
      if (typeof this.$props.data.state_current_editing != "undefined") {
        return this.$props.data.state_current_editing;
      } else {
        return "current_editing";
      }
    },
    stateIsEditingNew: function stateIsEditingNew() {
      if (typeof this.$props.data.state_is_editing_new != "undefined") {
        return this.$props.data.state_is_editing_new;
      } else {
        return "is_editing_new";
      }
    },
    fieldClass: function fieldClass() {
      if (this.getOption("hide_label", false) == true || this.getOption("label_in_new_line", false) == true) {
        return "col-xs-12";
      } else {
        if (this.showLabelAs4 == true) {
          return "col-xs-8";
        } else {
          return "col-xs-10";
        }
      }
    },
    fieldLabel: function fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue: function fieldValue() {
      return this.localRefreshSequecnce > 0 ? this.$store.state[this.stateCurrentRow][this.fieldID] : "";
    },
    fieldRows: function fieldRows() {
      return this.getOption("rows", 3);
    },
    showLabel: function showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    labelNewLine: function labelNewLine() {
      return this.getOption("label_in_new_line", false);
    },
    fieldTableName: function fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldID: function fieldID() {
      return this.$props.data.id;
    },
    isDisabled: function isDisabled() {
      var ret = this.localRefreshSequecnce > 0 && (this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined");
      return ret;
    },
    filedStyle: function filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")][this.fieldID] || "";
      var h = this.fieldRows * 20;
      return (this.getOption("field_style", this.$props.data.field_style || "height: " + h + "px !important;") || "") + store_style;
    }
  },
  methods: {
    refresh_hide_force: function refresh_hide_force() {
      this.hideAll = this.$props.data.hide_all == true;
      this.forcewrite = this.$props.data.force_write == true;
    },
    onClick: function onClick(b) {
      if (b.type == "add_to_input") {
        this.$refs.local_value.value = b.text;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text;
      }
      if (b.type == "link") {
        this.$router.push(b.link);
      }
      return false;
    },
    updateValue: function updateValue(d) {
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
    },
    getOption: function getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$props.data.ref_field = this;
    this.refresh_hide_force();

    this.$props.data.on_field_messages = function (vm, msg, cb) {
      if (msg && msg.msg_type == "error") {
        if (msg.show_as_error_mode == false && _this.showAsError == false) {
          return cb(false);
        }
        var local_val = _.clone(_this.$store.state[_this.stateCurrentEditing][_this.fieldID]);
        if (typeof local_val == "undefined") {
          local_val = _.clone(_this.$store.state[_this.stateCurrentRow][_this.fieldID]);
        }
        if (msg.show_as_error_mode && msg.only_if_enabled == true && _this.isDisabled == true) {
          _this.showAsError = false;
          _this.$store.state[_this.stateCurrentRow][_this.fieldID] = local_val;
          _this.updateValue(local_val);
          _this.localRefreshSequecnce++;
          return cb(false);
        }
        _this.showAsError = msg.show_as_error_mode || false;
        _this.$store.state[_this.stateCurrentRow][_this.fieldID] = local_val;
        _this.updateValue(local_val);
        _this.localRefreshSequecnce++;

        return cb(true);
      }
    };
  },

  props: ['data', 'value', 'option', 'read']
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_fields_input_box__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_fields_input_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_fields_input_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fields_password_box__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fields_password_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_fields_password_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_fields_select_box__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_fields_select_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_fields_select_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_fields_select_box2__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_fields_select_box2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_fields_select_box2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fields_select_box3__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fields_select_box3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_fields_select_box3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_fields_select_box4__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_fields_select_box4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_fields_select_box4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_fields_radio_button__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_fields_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_fields_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_fields_date_box__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_fields_date_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_fields_date_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_fields_datetime_box__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_fields_datetime_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_fields_datetime_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fields_text_area__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fields_text_area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_fields_text_area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_fields_checkbox__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_fields_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_fields_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_fields_email_box__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_fields_email_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_fields_email_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_field_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_debug__);



















var debug_form_field = __WEBPACK_IMPORTED_MODULE_15_debug___default()("__esma:form-field");

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "input-box": __WEBPACK_IMPORTED_MODULE_2__components_fields_input_box___default.a,
    "password-box": __WEBPACK_IMPORTED_MODULE_3__components_fields_password_box___default.a,
    "select-box": __WEBPACK_IMPORTED_MODULE_4__components_fields_select_box___default.a,
    "select-box2": __WEBPACK_IMPORTED_MODULE_5__components_fields_select_box2___default.a,
    "select-box3": __WEBPACK_IMPORTED_MODULE_6__components_fields_select_box3___default.a,
    "select-box4": __WEBPACK_IMPORTED_MODULE_7__components_fields_select_box4___default.a,
    "radio-button": __WEBPACK_IMPORTED_MODULE_8__components_fields_radio_button___default.a,
    "date-box": __WEBPACK_IMPORTED_MODULE_9__components_fields_date_box___default.a,
    "datetime-box": __WEBPACK_IMPORTED_MODULE_10__components_fields_datetime_box___default.a,
    "text-area": __WEBPACK_IMPORTED_MODULE_11__components_fields_text_area___default.a,
    "checkbox": __WEBPACK_IMPORTED_MODULE_12__components_fields_checkbox___default.a,
    "email-box": __WEBPACK_IMPORTED_MODULE_13__components_fields_email_box___default.a
  },
  data: function data() {
    return {
      error_msg: "",
      show_error: false,
      show_error_mode: "none"
    };
  },

  computed: {
    styleForError: function styleForError() {},

    errorMode: {
      get: function get() {
        return this.show_error_mode;
      },
      set: function set(v) {
        this.show_error_mode = v;
      }
    },
    errorMsg: {
      get: function get() {
        return this.error_msg;
      },
      set: function set(v) {
        this.error_msg = v;
      }
    },
    showError: {
      get: function get() {
        return this.show_error;
      },
      set: function set(v) {
        this.show_error = v;
      }
    },
    types: function types() {
      return __WEBPACK_IMPORTED_MODULE_14__constants_field_types__["a" /* filed_types */];
    },
    fieldInfo: function fieldInfo() {
      var ret = this.$props.data;
      debug_form_field("fieldInfo.type", ret.type, ret);
      return ret;
    },
    optionInfo: function optionInfo() {
      debug_form_field("this.props.option", this.$props.data.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$props.option));
      return this.$props.option;
    },
    valinfo: function valinfo() {
      if (typeof this.$props.val == "undefined" || this.$props.val == null || this.$props.val.length == 0) {
        return " ";
      } else {
        return this.$props.val;
      }
    },
    readOnly: function readOnly() {
      return this.$props.read || this.$props.data.read_only == true;
    }
  },
  methods: {
    onUpdate: function onUpdate(o) {
      this.$emit("on_update", o);
    },
    onErrorMsg: function onErrorMsg(err_obj) {
      this.errorMsg = err_obj.msg;
      this.showError = err_obj.msg && err_obj.msg.length > 0;
      this.errorMode = err_obj.error_mode;
      if (err_obj.error_mode == "warning") {
        this.$emit("validationRestriction", {
          active: false,
          id: this.fieldInfo.id
        });
      } else if (err_obj.error_mode == "restrict") {
        var ative = false;
        if (err_obj.msg && err_obj.msg.length > 0) {
          ative = true;
        }
        this.$emit("validationRestriction", {
          active: ative,
          id: this.fieldInfo.id
        });
      }
      console.log("this.errorMode", err_obj.error_mode, this.errorMode, err_obj);
    },
    fakeDate: function fakeDate() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("fakeDate") || false;
    }
  },
  mounted: function mounted() {},

  props: {
    read: { default: true },
    data: { default: {} },
    val: { default: "" },
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modals_notice_modal__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modals_notice_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modals_notice_modal__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    dropdown: __WEBPACK_IMPORTED_MODULE_3_vue_strap_dist_vue_strap_js__["dropdown"],
    "information-modal": __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal___default.a,
    "notice-modal": __WEBPACK_IMPORTED_MODULE_7__modals_notice_modal___default.a
  },
  data: function data() {
    return {
      show_back: this.no_back !== true,
      schedule_interval: false,
      scheduler_is_listening: false,
      check_idle_inderval: false
    };
  },

  computed: {
    acl: function acl() {
      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].acl;
    },
    permissionMode: function permissionMode() {
      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].PERMISSION_MODE;
    },
    maintenanceLinks: function maintenanceLinks() {
      return [{ name: "プログラムとアクセス権限", path: "/programs_and_permissions", disabled: this.checkHeaderUserPermission(this.acl.maintenance) == false }, { name: "会社", path: "/master_company", disabled: this.checkHeaderUserPermission(this.acl.maintenance) == false }, { name: "システム設定", path: "/system_setting", disabled: this.checkHeaderUserPermission(this.acl.maintenance) == false }, { name: "旧データ取込", path: "old_bulk_import", disabled: this.checkHeaderUserPermission(this.acl.maintenance) == false }];
    },
    maintenanceLinksDisabled: function maintenanceLinksDisabled() {
      var ret = true;
      this.maintenanceLinks.forEach(function (e) {
        if (e.disabled == false) {
          ret = false;
        }
      });
      return ret;
    },
    masterUserLinks: function masterUserLinks() {
      return [{ name: "パスワードの変更", path: "/master_change_password", disabled: this.checkHeaderUserPermission(this.acl.master_user_password) == false }, { name: "ユーザ一覧", path: "/master_user", disabled: this.checkHeaderUserPermission(this.acl.master_user) == false }];
    },
    masterUserDisabled: function masterUserDisabled() {
      var ret = true;
      this.masterUserLinks.forEach(function (e) {
        if (e.disabled == false) {
          ret = false;
        }
      });
      return ret;
    },
    configurationLinks: function configurationLinks() {
      return [{ name: "部署・チーム", path: "/master_belongs", disabled: this.checkHeaderUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }, { name: "システム", path: "/master_system", disabled: this.checkHeaderUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }, { name: "メーカ", path: "/master_maker", disabled: this.checkHeaderUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }, { name: "ソフトウェア", path: "/master_software", disabled: this.checkHeaderUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }, { name: "メールメッセージ", path: "/mail_message", disabled: this.checkHeaderUserPermission(this.acl.master) == false }, { name: "お知らせ", path: "/notice", disabled: this.checkHeaderUserPermission(this.acl.master) == false }, { name: "預り証出力", path: "/deposit_certificate_output", disabled: this.checkHeaderUserPermission(this.acl.master) == false }, { name: "過不足集計表", path: "/excess_deficiency_summary", disabled: this.checkHeaderUserPermission(this.acl.master) == false }, { name: "棚卸報告年度区分", path: "/inventory_reporting_period", disabled: this.checkHeaderUserPermission(this.acl.master) == false }];
    },
    configurationLinksDisabled: function configurationLinksDisabled() {
      var ret = true;
      this.configurationLinks.forEach(function (e) {
        if (e.disabled == false) {
          ret = false;
        }
      });
      return ret;
    },
    certificateLinks: function certificateLinks() {
      return [{ name: "証書情報", path: "/certificate", disabled: this.checkHeaderUserPermission(this.acl.certificate_software) == false }, { name: "余剰ライセンス", path: "/surplus_license", disabled: this.checkHeaderUserPermission(this.acl.surplus_license) == false }];
    },
    inventoryLinks: function inventoryLinks() {
      return [{ name: "棚卸業務", path: "/inventory", disabled: this.checkHeaderUserPermission(this.acl.inventory_report) == false }, { name: "棚卸報告確認", path: "/inventory_report_check", disabled: this.checkHeaderUserPermission(this.acl.inventory_report_check) == false }];
    },
    certificateLinksDisabled: function certificateLinksDisabled() {
      var ret = true;
      this.certificateLinks.forEach(function (e) {
        if (e.disabled == false) {
          ret = false;
        }
      });
      return ret;
    },
    inventoryLinksDisabled: function inventoryLinksDisabled() {
      var ret = true;
      this.inventoryLinks.forEach(function (e) {
        if (e.disabled == false) {
          ret = false;
        }
      });
      return ret;
    },
    userDepartment: function userDepartment() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userDepartment") || "";
    },
    userTeam: function userTeam() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userTeam") || "";
    },
    userShimei: function userShimei() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userShimei") || "";
    },
    userRole: function userRole() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userRole") || "";
    },
    userCompany: function userCompany() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userCompany") || "";
    },
    loggedUser: function loggedUser() {
      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].getLoggedUserDisplay();
    },
    allowMenu: function allowMenu() {
      var res = this.no_back !== "true";
      return res;
    },
    alloLogout: function alloLogout() {
      var res = this.no_logout !== "true";
      return res;
    },
    allowSettigns: function allowSettigns() {
      var res = typeof this.$props.settings != "undefined";
      return res;
    },
    showMenu: function showMenu() {
      var res = typeof this.$props.no_menu != "undefined" && this.$props.no_menu == "true";
      return res == false;
    },
    getBreadcrumb: function getBreadcrumb() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.initial(this.$props.breadcrumb);
    },
    getBreadcrumbLast: function getBreadcrumbLast() {
      console.log("getBreadcrumbLast", this.$props.breadcrumb[this.$props.breadcrumb.length - 1]);
      return [this.$props.breadcrumb[this.$props.breadcrumb.length - 1]];
    },
    getSettingsOptions: function getSettingsOptions() {
      var arr = [{ val: "fixTerminalStatus", label: "Fix Terminal Status" }, { val: "systemInfo", label: "システム情報" }, { val: "systemZoom", label: "ページサイズ" }, { val: "clear", label: "クリア" }, { val: "reload", label: "リロード" }, { val: "test", label: "テスト" }, { val: "import", label: "データ取込" }, { val: "export", label: "データ出力" }];
      var settings = this.$props.settings || "";
      var allowed = settings.split(",");
      var ret = [];
      arr.forEach(function (v) {
        if (allowed.indexOf(v.val) > -1) {
          ret.push(v);
        }
      });
      return ret;
    }
  },
  methods: {
    onClick: function onClick() {
      console.log('TEST DEBUG 210606 (303 at header.vue)[02:37]: ', this.$route.fullPath);
      if (this.$route.fullPath != "/approval_history") {

        __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit("onSearchClear", "header");
      }
    },
    goToBrowserSettings: function goToBrowserSettings() {
      window.sessionStorage.setItem('broser_setting_back_to', this.$route.fullPath);
      this.$router.push("/browser_setting");
    },
    checkHeaderUserPermission: function checkHeaderUserPermission(page_acl) {
      var permission = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].PERMISSION_MODE.BROWSE;
      var requester = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].check_user_permission(page_acl, permission, requester);
    },
    onClickBreadcrumbLast: function onClickBreadcrumbLast() {
      window.location.reload();
    },
    onMenuClick: function onMenuClick(target, mode) {
      if (mode.val == "systemZoom") {
        this.$router.push({ name: "Page24_page_zoom" });
      } else {
        this.$emit("on" + mode.val.charAt(0).toUpperCase() + mode.val.slice(1), target);
      }
    },
    prevent_return: function prevent_return() {

      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit("prevendReturnMessage", {
        message: "本操作は行うことができません。",
        yes_label: "OK",
        large: false
      });

      history.pushState(null, document.title, location.href);
    },
    prevent_reload: function prevent_reload(e) {
      var confirmationMessage = "このサイトを再度読み込みしますか？\n行った変更が保存されない可能性があります。";
      (e || window.event).returnValue = confirmationMessage;
      return confirmationMessage;
    },
    check_invalid_2tabs: function check_invalid_2tabs() {
      var devMode2 = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('devMode2') || 0;
      if (devMode2 != 1) {
        var ss = window.sessionStorage.getItem('browser_tab_id') || false;
        var ls = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('browser_tab_id') || false;
        if (ls == false || ss == false || ls != ss) {
          window.sessionStorage.setItem('browser_tab_id', false);
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('browser_tab_id', false);
          return this.$router.push({ name: "page_0060_redirect", params: {
              url: "/logout/duo",
              message: "重複して起動されたため、強制ログアウトをします。",
              wait: 1000
            } });
        } else {}
      }
    },
    prevent_2tabs: function prevent_2tabs(ev) {
      if (ev.key == "browser_tab_id") {
        this.check_invalid_2tabs();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.sessionStorage.setItem('last_event_time', new Date().getTime());
    var max_idle_timeout = 1000 * 60 * 30;
    this.check_idle_inderval = setInterval(function () {
      if (location.hash != '#/expired' && location.hash != '#/logout' && location.hash != '#/') {
        var now = new Date().getTime();
        var last_event = parseInt(window.sessionStorage.getItem('last_event_time') || now);
        var print_now = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).format("HH:mm:ss");
        var idle = now - last_event;
        if (idle > max_idle_timeout) {
          if ((__WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('devMode2') || 0) == 1) {
            console.log('DO NOT EXIRE DUE DEV FALG');
            return;
          };
          window.sessionStorage.setItem('last_event_time', new Date().getTime());
          _this.$router.push('/expired');
          console.log(print_now, 'TEST DEBUG 210513 HEADER TIMEOUT');
        }
      } else {
        console.log('TEST DEBUG HEADER LOGED OUT');
      }
    }, 5000);

    var devMode2 = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('devMode2') || 0;
    if (devMode2 != 1) {
      history.pushState(null, document.title, location.href);
      history.pushState(null, document.title, location.href);
      window.addEventListener('popstate', this.prevent_return);
      window.addEventListener("beforeunload", this.prevent_reload);
      window.addEventListener("storage", this.prevent_2tabs);
      this.check_invalid_2tabs();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    console.log('TEST DEBUG 210528 (434 at header.vue)[00:25]: ', { to: to, from: from });
    next();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.check_idle_inderval) {
      clearInterval(this.check_idle_inderval);
    }

    window.removeEventListener('popstate', this.prevent_return);
    window.removeEventListener("beforeunload", this.prevent_reload);
    window.removeEventListener("storage", this.prevent_2tabs);
  },

  props: ["no_back", "breadcrumb", "no_logout", "settings", "no_menu", "delay_check_noticies_for_schedule"]
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_bus__ = __webpack_require__(4);











var debug_menu = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:info_box");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_2__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__["a" /* default */]],
  components: {},
  data: function data() {
    return {
      text_content: "",
      local_data: false,
      is_editing: false,
      show_edit: false
    };
  },


  computed: {
    showEdit: {
      get: function get() {
        return this.show_edit;
      },
      set: function set(v) {
        this.show_edit = v;
      }
    },
    isEditing: {
      get: function get() {
        return this.is_editing;
      },
      set: function set(v) {
        this.is_editing = v;
      }
    },
    textContent: {
      get: function get() {
        return this.text_content;
      },
      set: function set(v) {
        this.text_content = v;
      }
    }
  },
  methods: {
    onSave: function onSave() {
      var _this = this;

      var seq_id = this.local_data.seq_id;
      this.$ajax.post_cached_queued("/key_text/set/" + seq_id, { changes: { k_text: this.textContent } }, function (err, result) {
        if (err) {
          _this.$notify({
            title: 'Failed to load data',
            text: err,
            type: 'error',
            duration: 10000
          });
          return;
        } else {
          _this.isEditing = false;
        }
      });
    },
    onCancel: function onCancel() {
      this.isEditing = false;
      this.textContent = this.local_data.k_text;
    },
    onEdit: function onEdit() {
      this.isEditing = true;
    },
    loadData: function loadData() {
      var _this2 = this;

      this.textContent = "Loading....";
      this.$ajax.post_cached_queued("/key_text/get_by_key/" + this.box_id, {}, function (err, result) {
        if (err) {
          _this2.$notify({
            title: 'Failed to load data',
            text: err,
            type: 'error',
            duration: 10000
          });
          return;
        }
        _this2.local_data = result;
        _this2.textContent = result.k_text || "Data not found";
      });
    }
  },
  mounted: function mounted() {
    this.textContent = this.box_id;
    this.loadData();
    this.showEdit = this.isMultiCompanyAdmin == true;
  },

  props: {
    title: { type: String, default: "--" },
    "box_id": { type: String, default: "x" }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [],
  computed: {
    b3Style: function b3Style() {
      var ret = typeof this.$props.counter_b3_error_message == "undefined" || this.$props.counter_b3_error_message == null || this.$props.counter_b3_error_message == "false" ? "" : "color:red;";
      return ret;
    }
  },
  methods: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {},

  props: {
    t1: { type: String, default: "" },
    t2: { type: String, default: "" },
    t3: { type: String, default: "" },
    t4: { type: String, default: "" },
    u4: { type: String, default: "" },
    b1: { type: String, default: "-" },
    b2: { type: String, default: "-" },
    b3: { type: String, default: "-" },
    b4: { type: String, default: "-" },
    counter_b3_error_message: { type: String, default: "false" }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    btnText: function btnText() {
      var comp = "";
      if (typeof this.$props.textb != "undefined") {
        if (this.$props.textb.length > 0) {
          comp = "<br>" + this.$props.textb;
        }
      }
      return "" + this.$props.text + comp;
    },
    linkTo: function linkTo() {
      return this.$props.link || 'menu';
    },
    isEnable: function isEnable() {
      return this.$props.enabled === 'true';
    },
    div_class: function div_class() {
      if (this.$props.is_full === true) {
        return 'col-xs-12 menu-container';
      } else {
        return 'col-xs-6 menu-container';
      }
    }
  },
  props: ['link', 'enabled', 'text', 'textb', 'is_full', 'btn_class']
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_debug__);














var vm = this;




__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_14__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_15_debug___default()("esma:application-confirmation-modal");
var debug_msg_bulk = __WEBPACK_IMPORTED_MODULE_15_debug___default()("esma:application-confirmation-modal:bulk");

var MODE_DEVICE_EMBEDDED = "mode_device_embedded";
var MODE_CERTIFICATE = "mode_certificate";
var MODE_BULK_IMPORT = "mode_bulk_import";
var MODE_BULK_EDIT_DEVICEE_EMBEDDED = "mode_bulk_edit_device_embedded";
var MODE_BULK_EDIT_CERTIFICATE = "mode_bulk_edit_certificate";
var MODE_USER = "mode_user";
var MODE_INVENTORY = "mode_inventory";

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_9__components_form_field___default.a
  },
  data: function data() {
    return {
      show_modal: false,
      callback: null,
      model_height: "350",
      team_options: [],
      user_options: [],
      local_user_list: [],
      application_mode: null,
      ref_id: null,
      seq_id: null,
      approval_status: null,
      status: null,
      process_import_url: null,
      title_prefix: null,
      title_suffix: null,
      syubetu: null,
      list_team_department: [],
      selected_department: [],
      last_change: 0,
      list_seq_id: null,
      fk_table_id: -1,
      state_current_editing: "current_editing3",
      state_current_row: "current_row3",
      state_is_editing_new: "is_editing_new3",
      state_last_filter_options: "last_filter_options3",
      modal_is_read_only: false,
      approval_history_id: "",
      disable_btn_apply: false,
      approval_history_toroku_number: "",
      session_id: false,
      user_applicant: "-",
      team_applicant: "--",
      is_surplus: false

    };
  },

  computed: {
    MaxNumberApproval: function MaxNumberApproval() {
      switch (this.application_mode) {
        case "inventory":
          var maxnum = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.INVENTORY.INVENTORY_APPROVAL_Number;
          break;
        default:
          var maxnum = 5;
          break;
      }
      return maxnum;
    },
    ApprovalNumberSet: function ApprovalNumberSet() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(Array(this.MaxNumberApproval))).map(function (_, i) {
        return i + 1;
      });
    },

    userApplicant: {
      get: function get() {
        return this.user_applicant;
      },
      set: function set(v) {
        this.user_applicant = v;
      }
    },
    teamApplicant: {
      get: function get() {
        return this.team_applicant;
      },
      set: function set(v) {
        this.team_applicant = v;
      }
    },
    showModal: {
      get: function get() {
        return this.show_modal;
      },
      set: function set(v) {
        this.show_modal = v;
      }
    },
    sessionId: {
      get: function get() {
        return this.session_id;
      },
      set: function set(v) {
        this.session_id = v;
      }
    },
    disableBtnApply: {
      get: function get() {
        return this.disable_btn_apply;
      },
      set: function set(v) {
        this.disable_btn_apply = v;
      }
    },
    approvalHistoryId: {
      get: function get() {
        if (this.approval_history_id && this.approval_history_id > -1) {
          return "申請No：" + this.approval_history_id;
        } else {
          return "";
        }
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    approvalHistoryTorokuNumber: {
      get: function get() {
        if (this.approval_history_toroku_number && this.approval_history_toroku_number > -1) {
          return "申請No：" + this.approval_history_toroku_number;
        } else {
          return this.approvalHistoryId;
        }
      },
      set: function set(v) {
        this.approval_history_toroku_number = v;
      }
    },
    modalIsReadOnly: {
      get: function get() {
        return this.modal_is_read_only;
      },
      set: function set(v) {
        this.modal_is_read_only = v;
      }
    },
    lastChange: {
      get: function get() {
        return this.last_change;
      },
      set: function set(v) {
        this.last_change = v;
      }
    },
    selectedDepartment: {
      get: function get() {
        console.log("GET selectedDepartment", this.selected_department);
        return this.selected_department;
      },
      set: function set(v) {
        console.log("SET selectedDepartment", v);
        this.selected_department = v;
      }
    },
    listTeamDepartment: {
      get: function get() {
        return this.list_team_department;
      },
      set: function set(v) {
        this.list_team_department = v;
      }
    },
    localFields: function localFields() {
      return __WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */];
    },
    formFields2: function formFields2() {},
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].team_1, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].approver_1, {})],
        col3: [this.local_extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_0, { disabled: true, read_only: true })],
        col4: [__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_1, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_2, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_3, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_4, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_5, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_6, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_7, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_8, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_9, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_10, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_11, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_12, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_13, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_14, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_15, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_16, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_17, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_18, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_19, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_20, { disabled: true, read_only: true })],
        col5: [this.local_extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].approver_final, { disabled: true, read_only: true })],
        col6: [this.local_extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */].status_final, { disabled: true, read_only: true })]
      };
    },

    applicationMode: {
      get: function get() {
        switch (this.application_mode) {
          case "device_embedded":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION;
            return MODE_DEVICE_EMBEDDED;
            break;
          case "user":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.USER;
            return MODE_USER;
            break;
          case "bulk_import":
            this.fk_table_id = -1;
            return MODE_BULK_IMPORT;
            break;
          case "bulk_edit_device_embedded":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION;
            return MODE_BULK_EDIT_DEVICEE_EMBEDDED;
            break;
          case "bulk_edit_certificate":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE;
            return MODE_BULK_EDIT_CERTIFICATE;
            break;
          case "inventory":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.INVENTORY;
            return MODE_INVENTORY;
            break;
          default:
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE;
            return MODE_CERTIFICATE;
            break;
        }
      },
      set: function set(v) {
        this.application_mode = v;
      }
    },
    title: function title() {
      if (this.applicationMode == MODE_USER) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（ユーザ）";
        }
      }
      if (this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（一括編集）";
        }
      } else if (this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（一括編集）";
        }
      } else if (this.applicationMode == MODE_BULK_IMPORT) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（一括取込）";
        }
      } else if (this.applicationMode == MODE_DEVICE_EMBEDDED) {
        return "申請ルート（機器・組込情報）";
      } else if (this.applicationMode == MODE_INVENTORY) {
        return "申請ルート（棚卸）";
      } else {
        return "申請ルート（証書情報）";
      }
    },

    localUserList: {
      get: function get() {
        return this.local_user_list;
      },
      set: function set(v) {
        var _this = this;

        var ud = this.userDepartment;
        this.userOptions = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.filter(v, function (o) {
          return o.department == ud && o.user_shimei != _this.userShimei;
        }).map(function (o) {
          return o.user_shimei;
        });
        this.teamOptions = v.map(function (o) {
          return o.team;
        });
        this.local_user_list = v;
      }
    },
    userDepartment: function userDepartment() {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userDepartment") || "";
    },
    userTeam: function userTeam() {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userTeam") || "";
    },
    userShimei: function userShimei() {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userShimei") || "";
    },


    userOptions: {
      get: function get() {
        return this.user_options;
      },
      set: function set(v) {
        this.user_options = v;
      }
    },
    teamOptions: {
      get: function get() {
        return this.team_options;
      },
      set: function set(v) {
        this.team_options = v;
      }
    }
  },
  methods: {
    local_extend: function local_extend(field_info) {
      var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;


      return __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(field_info, ext);
    },
    onTeamSelected: function onTeamSelected(d, n) {
      try {
        var obj = JSON.parse(d);
        var temp = this.selectedDepartment;
        temp[n] = obj.department;
        this.selectedDepartment = temp;
        this.lastChange = new Date().getTime();
      } catch (error) {}
    },
    showModalWindow: function showModalWindow(data) {
      var _this2 = this;

      if (this.showModal == true) {
        return;
      }
      this.disableBtnApply = false;

      this.showModal = true;
      this.titleStyle = data.title_style || "";
      this.ref_id = data.ref_id;
      this.is_surplus = data.is_surplus || false;

      this.applicationMode = data.application_mode;
      this.initselectedDepartment();
      this.process_import_url = data.process_import_url;
      if (data.on_finish_url_name) {
        this.on_finish_url_name = data.on_finish_url_name;
      }
      if (data.title_prefix) {
        this.title_prefix = data.title_prefix;
      }
      if (data.session_id) {
        this.sessionId = data.session_id;
      }
      if (data.title_suffix) {
        this.title_suffix = data.title_suffix;
      }
      if (data.syubetu) {
        this.syubetu = data.syubetu;
      }
      if (data.list_seq_id) {
        this.list_seq_id = data.list_seq_id;
      }
      if (data.modal_is_read_only) {
        this.modalIsReadOnly = true;
        this.ReadOnly = true;
      } else {
        this.modalIsReadOnly = false;
        this.ReadOnly = false;
      }
      this.seq_id = data.seq_id;
      this.$ajax.post_cached_queued("/master_user/load_for_bulk_import/", {}, function (err, load_for_bulk_import_data) {
        _this2.localUserList = load_for_bulk_import_data;
      });
      this.$ajax.post_cached_queued("/master_belongs/list_team_and_department/", {}, function (err, list_team_and_department_data) {
        list_team_and_department_data.forEach(function (d) {
          var value = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(d);
          d.value = value;
        });
        _this2.listTeamDepartment = data;
      });
      if (data.approval_history_toroku_number != false && typeof data.approval_history_toroku_number != "undefined") {
        this.approvalHistoryTorokuNumber = data.approval_history_toroku_number;
      }
      if (data.approval_history_id != false && typeof data.approval_history_id != "undefined") {
        this.approvalHistoryId = data.approval_history_id;
        var approval_history_url = "/approval_history_inventory/get/";
        if (this.applicationMode == MODE_USER) {
          approval_history_url = "/id_approval_history/get/";
        }
        var url = approval_history_url + data.approval_history_id;
        if (data.approval_history_id == -200) {
          this.title_suffix = "一括取込";
          url = "/approval_history_batch_import/get_by_toroku_number/" + data.approval_history_toroku_number;
        }
        this.$ajax.post(url, {}, function (err, approval_history_data) {

          if (approval_history_data && approval_history_data.data && approval_history_data.data.applicant) {
            _this2.userApplicant = approval_history_data.data.applicant;
          }
          if (approval_history_data && approval_history_data.data && approval_history_data.data.applicant_label) {
            _this2.userApplicant = approval_history_data.data.applicant_label;
          }
          if (approval_history_data && approval_history_data.data && approval_history_data.data.applicant_team) {
            _this2.teamApplicant = approval_history_data.data.applicant_team;
          }

          if (approval_history_data && approval_history_data.body && approval_history_data.body.data == null) {
            return _this2.prepareEmptyData();
          }
          if (_this2.modalIsReadOnly == false) {
            return _this2.prepareEmptyData();
          }
          _this2.$store.state[_this2.stateCurrentRow] = approval_history_data.data;

          _this2.$store.state[_this2.stateCurrentEditing] = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(approval_history_data.data).forEach(function (k) {
            if (k.indexOf("status") == 0 || k.indexOf("approver") == 0 || k.indexOf("team") == 0) {
              var val = approval_history_data.data[k] || false;
              var current_status = false;

              if (/\_[1-9]?\d/.test(k)) {
                current_status = approval_history_data.data["current_status"] || false;
              }

              if (val) {
                _this2.$store.state[_this2.stateCurrentRow][k] = val;
              }
            }
          });
          _this2.local_seq_id = approval_history_data.data.seq_id;
          _this2.is_new = false;
          _this2.$store.state[_this2.stateIsEditingNew] = false;
          _this2.readOnly = _this2.modalIsReadOnly == true ? true : false;
        });
      } else if (this.modalIsReadOnly == true) {
        this.readOnly = true;
        this.prepareEmptyData(false);
        this.teamApplicant = this.userTeam;
        this.userApplicant = this.userShimei;
      } else {
        this.prepareEmptyData();
        this.readOnly = false;
        this.approvalHistoryId = "";
        this.teamApplicant = this.userTeam;
        this.userApplicant = this.userShimei;
      }
    },
    prepareEmptyData: function prepareEmptyData() {
      var _this3 = this;

      var is_new = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.local_seq_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.$store.state[this.stateCurrentRow] = {
        seq_id: this.local_seq_id
      };
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */]).forEach(function (f) {
        _this3.$store.state[_this3.stateCurrentRow][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id] = "";
        _this3.$store.state[_this3.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id] = "";
      });
      if (is_new) {
        setTimeout(function () {
          _this3.approvalHistoryId = "";
          _this3.$store.state[_this3.stateIsEditingNew] = true;
          _this3.read_only = false;
          _this3.is_new = true;
        }, 300);
      }
    },
    closed: function closed(mode) {
      this.showModal = false;
      if (typeof mode != "undefined") {
        this.$emit('done', mode);
      }
    },
    getSyubetuFromApplicationMode: function getSyubetuFromApplicationMode() {
      var ret = "";
      switch (this.applicationMode) {
        case MODE_DEVICE_EMBEDDED:
          ret = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.SYUBETU.DEVICE;
          break;
        case MODE_CERTIFICATE:
          ret = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.SYUBETU.CERTIFICATE;
          break;
        case MODE_USER:
          ret = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.SYUBETU.USER;
          break;
        case MODE_INVENTORY:
          ret = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.SYUBETU.INVENTORY;
          break;
        default:
          ret = __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.SYUBETU.CERTIFICATE;
          break;
      }
      return ret;
    },
    onSave: function onSave(mode) {
      var _this4 = this;

      if (mode == "yes") {
        debug_msg_bulk("On Save", { mode: this.applicationMode, url: this.process_import_url });

        if (this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED) {

          var changes = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this4.$store.state[_this4.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { list_seq_id: this.list_seq_id, changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, function (err, result) {
            if (err) {
              _this4.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              _this4.disableBtnApply = false;
            } else {
              return _this4.onConfirmExecuteProcess();
            }
          });
        } else if (this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) {
          var changes = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this4.$store.state[_this4.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { list_seq_id: this.list_seq_id, changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, function (err, result) {
            if (err) {
              _this4.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              _this4.disableBtnApply = false;
            } else {
              return _this4.onConfirmExecuteProcess();
            }
          });
        } else if (this.applicationMode == MODE_BULK_IMPORT) {
          var changes = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this4.$store.state[_this4.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { syubetu: this.syubetu, changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, function (err, result) {
            if (err) {
              _this4.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              _this4.disableBtnApply = false;
            } else {
              return _this4.onConfirmExecuteProcess();
            }
          });
        } else if (this.applicationMode == MODE_CERTIFICATE) {
          var changes = {
            ref_id: this.ref_id,
            syubetu: this.getSyubetuFromApplicationMode(),
            approval_status: "申請中",
            application_mode: this.applicationMode,
            fk_tab: __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE,
            fk_id: this.seq_id,
            update_name: "",
            update_time: null,
            create_time: __WEBPACK_IMPORTED_MODULE_12_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
          };
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this4.$store.state[_this4.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post("/approval_history/set/" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a, obj, function (err, response) {
            console.log("onSave approval _history", { response: response });
            if (err) {
              _this4.$notify({
                title: "データの保存に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              _this4.disableBtnApply = false;
            } else {
              _this4.$ajax.post("/certificate_software/set/" + _this4.seq_id, { system_change: true, changes: { approval_status: "申請中", approval_status_flag: 1, retraction_reason: "" } }, function (err, response2) {
                if (err) {
                  _this4.$notify({
                    title: "データの保存に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000
                  });
                  _this4.disableBtnApply = false;
                } else {
                  _this4.saveApplicationFlow(response.data.seq_id, function () {
                    _this4.onConfirmExecuteProcess();
                  });
                }
              });
            }
          });
        } else if (this.applicationMode == MODE_INVENTORY) {
          var changes = {
            ref_id: this.ref_id,
            control_number: !this.ref_id || this.ref_id.indexOf("BY_SEQ_ID::") == 0 ? "" : this.ref_id,
            approval_status: "申請中",
            syubetu: this.getSyubetuFromApplicationMode(),
            application_mode: this.applicationMode,
            fk_tab: this.fk_table_id,
            fk_id: this.seq_id,
            update_name: "",
            update_time: null,
            create_time: __WEBPACK_IMPORTED_MODULE_12_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
          };
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this4.$store.state[_this4.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });

          var approval_history_url = "/approval_history_inventory/set/";

          var obj = { changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(approval_history_url + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a, obj, function (err, response) {
            console.log("onSave approval _history", { response: response });
            if (err) {
              _this4.$notify({
                title: "データの保存に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              _this4.disableBtnApply = false;
            } else {
              var api_url = "inventory_report";
              _this4.$ajax.post("/" + api_url + "/set/" + _this4.seq_id, { system_change: true, changes: { approval_status: "申請中", approval_status_flag: 1, retraction_reason: "" } }, function (err, response2) {
                console.log("onSave 2 " + api_url, { response2: response2 });
                if (err) {
                  _this4.$notify({
                    title: "データの保存に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000
                  });
                  _this4.disableBtnApply = false;
                } else {
                  _this4.saveApplicationFlow(response.data.seq_id, function () {
                    _this4.onConfirmExecuteProcess();
                  });
                }
              });
            }
          });
        } else {
          var changes = {
            ref_id: this.ref_id,
            control_number: !this.ref_id || this.ref_id.indexOf("BY_SEQ_ID::") == 0 ? "" : this.ref_id,
            approval_status: "申請中",
            syubetu: this.getSyubetuFromApplicationMode(),
            application_mode: this.applicationMode,
            fk_tab: this.fk_table_id,
            fk_id: this.seq_id,
            update_name: "",
            update_time: null,
            create_time: __WEBPACK_IMPORTED_MODULE_12_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
          };
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this4.$store.state[_this4.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_8__rules_fields_approval_history_inventory__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });

          var approval_history_url = "/approval_history/set/";
          if (this.applicationMode == MODE_USER) {
            approval_history_url = "/id_approval_history/set/";
          }

          var obj = { changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(approval_history_url + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a, obj, function (err, response) {
            console.log("onSave approval _history", { response: response });
            if (err) {
              _this4.$notify({
                title: "データの保存に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              _this4.disableBtnApply = false;
            } else {
              var api_url = _this4.applicationMode == MODE_DEVICE_EMBEDDED ? "device_embedded_information" : "certificate_information";
              _this4.$ajax.post("/" + api_url + "/set/" + _this4.seq_id, { system_change: true, changes: { approval_status: "申請中", approval_status_flag: 1, retraction_reason: "" } }, function (err, response2) {
                console.log("onSave 2 " + api_url, { response2: response2 });
                if (err) {
                  _this4.$notify({
                    title: "データの保存に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000
                  });
                  _this4.disableBtnApply = false;
                } else {
                  _this4.saveApplicationFlow(response.data.seq_id, function () {
                    _this4.onConfirmExecuteProcess();
                  });
                }
              });
            }
          });
        }
      } else if (mode == "no") {
        this.disableBtnApply = false;
      }
    },
    saveApplicationFlow: function saveApplicationFlow(approval_history_seq_id, cb) {
      return cb(null);
    },
    onLocalApplication: function onLocalApplication() {
      this.$notify({ clean: true });


      this.disableBtnApply = true;
      __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformation", {
        message: "よろしいですか？",
        title: "申請を行います。",
        yes_label: "申請",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      var message = "機器・組込情報を申請しました。";
      if (this.applicationMode == MODE_CERTIFICATE) {
        message = "証書情報を申請しました。";
        if (this.is_surplus == true) {
          message = "余剰ライセンスを申請しました。";
        }
      } else if (this.applicationMode == MODE_USER) {
        message = "ユーザを申請しました。";
      } else if (this.applicationMode == MODE_INVENTORY) {
        this.showModal = false;
        this.show_modal = false;
        this.$emit('done', "yes");
        return;

        message = "棚卸報告を申請しました。";
      }
      if ((this.applicationMode == MODE_BULK_IMPORT || this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED || this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) && this.title_prefix && this.title_prefix.length > 0) {
        message = this.title_prefix + "を申請しました。";
      }
      __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("applicationConfirmatioModal", {
        title: "",
        message: message,
        yes_label: "",
        no_label: "OK",
        yes_color: "",
        no_color: "default",
        model_height: "50"
      });
    },
    onSaveApplicationConfirm: function onSaveApplicationConfirm() {
      var _this5 = this;

      this.showModal = false;
      var on_finish_go_to = "page_0010_device_embedded_information";
      if (this.applicationMode == MODE_CERTIFICATE) {
        on_finish_go_to = "page_0040_certificate_software";
        if (this.is_surplus == true) {
          on_finish_go_to = "page_0020_surplus_license";
        }
      } else if (this.applicationMode == MODE_INVENTORY) {
        return;
      } else if (this.applicationMode == MODE_USER) {
        on_finish_go_to = "page_0041_master_user";
      }
      if (this.on_finish_url_name && this.on_finish_url_name.length > 0) {
        on_finish_go_to = this.on_finish_url_name;
      }

      setTimeout(function () {
        _this5.$router.push({
          name: on_finish_go_to
        });
      }, 500);
    },
    initselectedDepartment: function initselectedDepartment() {
      this.selected_department = [];
      for (var i = 0; i < this.MaxNumberApproval; i++) {
        this.selected_department.push(this.userDepartment);
      }
    }
  },
  props: {
    tag: { type: String, default: "applicationConfimationModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
    this.initselectedDepartment();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_debug__);













var vm = this;




__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_13__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_14_debug___default()("esma:application-confirmation-modal");
var debug_msg_bulk = __WEBPACK_IMPORTED_MODULE_14_debug___default()("esma:application-confirmation-modal:bulk");

var MODE_DEVICE_EMBEDDED = "mode_device_embedded";
var MODE_CERTIFICATE = "mode_certificate";
var MODE_BULK_IMPORT = "mode_bulk_import";
var MODE_BULK_EDIT_DEVICEE_EMBEDDED = "mode_bulk_edit_device_embedded";
var MODE_BULK_EDIT_CERTIFICATE = "mode_bulk_edit_certificate";
var MODE_USER = "mode_user";
var MODE_INVENTORY = "mode_inventory";

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_8__components_form_field___default.a
  },
  data: function data() {
    return {
      show_modal: false,
      callback: null,
      model_height: "350",
      team_options: [],
      user_options: [],
      local_user_list: [],
      application_mode: null,
      ref_id: null,
      seq_id: null,
      approval_status: null,
      status: null,
      process_import_url: null,
      title_prefix: null,
      title_suffix: null,
      syubetu: null,
      list_team_department: [],
      selected_department: ["", "", "", "", ""],
      last_change: 0,
      list_seq_id: null,
      fk_table_id: -1,
      state_current_editing: "current_editing3",
      state_current_row: "current_row3",
      state_is_editing_new: "is_editing_new3",
      state_last_filter_options: "last_filter_options3",
      modal_is_read_only: false,
      approval_history_id: "",
      disable_btn_apply: false,
      approval_history_toroku_number: "",
      session_id: false,
      user_applicant: "-",
      team_applicant: "--",
      is_surplus: false,
      is_updating: false,
      pre_load_data: false,
      url_for_update: null,
      url_for_load: null,
      show_start_update: false,
      load_previous_if_exist: false,
      user_id: ""
    };
  },

  computed: {
    userId: {
      get: function get() {
        return this.user_id;
      },
      set: function set(v) {
        this.user_id = v;
      }
    },
    loadPreviousIfExist: {
      get: function get() {
        return this.load_previous_if_exist;
      },
      set: function set(v) {
        this.load_previous_if_exist = v;
      }
    },
    showStartUpdate: {
      get: function get() {
        return this.show_start_update;
      },
      set: function set(v) {
        this.show_start_update = v;
      }
    },

    preLoadData: {
      get: function get() {
        return this.pre_load_data;
      },
      set: function set(v) {
        this.pre_load_data = v;
      }
    },
    localCurrentRow: function localCurrentRow() {
      return this.$store.state[this.stateCurrentRow];
    },
    localCurrentEditingRow: function localCurrentEditingRow() {
      return this.$store.state[this.stateCurrentEditing];
    },

    isUpdating: {
      get: function get() {
        return this.is_updating;
      },
      set: function set(v) {
        this.is_updating = v;
      }
    },
    userApplicant: {
      get: function get() {
        return this.user_applicant;
      },
      set: function set(v) {
        this.user_applicant = v;
      }
    },
    teamApplicant: {
      get: function get() {
        return this.team_applicant;
      },
      set: function set(v) {
        this.team_applicant = v;
      }
    },
    showModal: {
      get: function get() {
        return this.show_modal;
      },
      set: function set(v) {
        this.show_modal = v;
      }
    },
    sessionId: {
      get: function get() {
        return this.session_id;
      },
      set: function set(v) {
        this.session_id = v;
      }
    },
    disableBtnApply: {
      get: function get() {
        return this.disable_btn_apply;
      },
      set: function set(v) {
        this.disable_btn_apply = v;
      }
    },
    approvalHistoryId: {
      get: function get() {
        if (this.approval_history_id && this.approval_history_id > -1) {
          return "申請No：" + this.approval_history_id;
        } else {
          return "";
        }
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    approvalHistoryTorokuNumber: {
      get: function get() {
        if (this.approval_history_toroku_number && this.approval_history_toroku_number > -1) {
          return "申請No：" + this.approval_history_toroku_number;
        } else {
          return "";
        }
      },
      set: function set(v) {
        this.approval_history_toroku_number = v;
      }
    },
    modalIsReadOnly: {
      get: function get() {
        return this.modal_is_read_only;
      },
      set: function set(v) {
        this.modal_is_read_only = v;
      }
    },
    lastChange: {
      get: function get() {
        return this.last_change;
      },
      set: function set(v) {
        this.last_change = v;
      }
    },
    selectedDepartment: {
      get: function get() {
        console.log("GET selectedDepartment", this.selected_department);
        return this.selected_department;
      },
      set: function set(v) {
        console.log("SET selectedDepartment", v);
        this.selected_department = v;
      }
    },
    listTeamDepartment: {
      get: function get() {
        return this.list_team_department;
      },
      set: function set(v) {
        this.list_team_department = v;
      }
    },
    localFields: function localFields() {
      return __WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */];
    },
    formFields2: function formFields2() {},
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].team_1, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].approver_1, {})],
        col3: [this.local_extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].status_0, { disabled: true, read_only: true })],
        col4: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].status_1, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].status_2, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].status_3, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].status_4, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].status_5, { disabled: true, read_only: true })],
        col5: [this.local_extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].approver_final, { disabled: true, read_only: true })],
        col6: [this.local_extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */].status_final, { disabled: true, read_only: true })]
      };
    },

    applicationMode: {
      get: function get() {
        switch (this.application_mode) {
          case "device_embedded":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION;
            return MODE_DEVICE_EMBEDDED;
            break;
          case "user":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.TABLE_ID.USER;
            return MODE_USER;
            break;
          case "bulk_import":
            this.fk_table_id = -1;
            return MODE_BULK_IMPORT;
            break;
          case "bulk_edit_device_embedded":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION;
            return MODE_BULK_EDIT_DEVICEE_EMBEDDED;
            break;
          case "bulk_edit_certificate":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE;
            return MODE_BULK_EDIT_CERTIFICATE;
            break;
          case "inventory":
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.TABLE_ID.INVENTORY;
            return MODE_INVENTORY;
            break;
          default:
            this.fk_table_id = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE;
            return MODE_CERTIFICATE;
            break;
        }
      },
      set: function set(v) {
        this.application_mode = v;
      }
    },
    title: function title() {
      if (this.applicationMode == MODE_USER) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（ユーザ）";
        }
      }
      if (this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（一括編集）";
        }
      } else if (this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（一括編集）";
        }
      } else if (this.applicationMode == MODE_BULK_IMPORT) {
        if (this.title_suffix && this.title_suffix.length > 0) {
          return "申請ルート" + this.title_suffix;
        } else {
          return "申請ルート（一括取込）";
        }
      } else if (this.applicationMode == MODE_DEVICE_EMBEDDED) {
        return "申請ルート（機器・組込情報）";
      } else if (this.applicationMode == MODE_INVENTORY) {
        return "申請ルート（棚卸）";
      } else {
        return "申請ルート（証書情報）";
      }
    },

    localUserList: {
      get: function get() {
        return this.local_user_list;
      },
      set: function set(v) {
        var _this = this;

        var ud = this.userDepartment;
        this.userOptions = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(v, function (o) {
          return o.department == ud && o.user_shimei != _this.userShimei;
        }).map(function (o) {
          return o.user_shimei;
        });
        this.teamOptions = v.map(function (o) {
          return o.team;
        });
        this.local_user_list = v;
      }
    },
    userDepartment: function userDepartment() {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].localStorage.get("userDepartment") || "";
    },
    userTeam: function userTeam() {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].localStorage.get("userTeam") || "";
    },
    userShimei: function userShimei() {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].localStorage.get("userShimei") || "";
    },


    userOptions: {
      get: function get() {
        return this.user_options;
      },
      set: function set(v) {
        this.user_options = v;
      }
    },
    teamOptions: {
      get: function get() {
        return this.team_options;
      },
      set: function set(v) {
        this.team_options = v;
      }
    }
  },
  methods: {
    localDeleteApplicant: function localDeleteApplicant(i_n) {
      var _this2 = this;

      var work_fields = ["team_", "approver_", "status_"];
      work_fields.forEach(function (wf) {
        _this2.localCurrentRow[_this2.localFields[wf + i_n].id] = "";
        _this2.localCurrentEditingRow[_this2.localFields[wf + i_n].id] = "";
        _this2.local_fields_ref[wf + i_n].ref_field.localRefreshSequecnce++;
        if (i_n < 5) {
          for (var n = i_n + 1; n <= 5; n++) {
            _this2.localCurrentRow[_this2.localFields[wf + (n - 1)].id] = "";
            _this2.localCurrentEditingRow[_this2.localFields[wf + (n - 1)].id] = "";
            if (_this2.localCurrentRow[_this2.localFields[wf + n].id] && _this2.localCurrentRow[_this2.localFields[wf + n].id].length > 0) {
              _this2.localCurrentRow[_this2.localFields[wf + (n - 1)].id] = _this2.localCurrentRow[_this2.localFields[wf + n].id];
              _this2.localCurrentEditingRow[_this2.localFields[wf + (n - 1)].id] = _this2.localCurrentRow[_this2.localFields[wf + n].id];
            } else if (_this2.localCurrentEditingRow[_this2.localFields[wf + n].id] && _this2.localCurrentEditingRow[_this2.localFields[wf + n].id].length > 0) {
              _this2.localCurrentEditingRow[_this2.localFields[wf + (n - 1)].id] = _this2.localCurrentEditingRow[_this2.localFields[wf + n].id];
              _this2.localCurrentRow[_this2.localFields[wf + (n - 1)].id] = _this2.localCurrentEditingRow[_this2.localFields[wf + n].id];
            }

            _this2.local_fields_ref[wf + (n - 1)].ref_field.localRefreshSequecnce++;
            _this2.local_fields_ref[wf + n].ref_field.localRefreshSequecnce++;
            _this2.localCurrentRow[_this2.localFields[wf + n].id] = "";
            _this2.localCurrentEditingRow[_this2.localFields[wf + n].id] = "";
            _this2.local_fields_ref[wf + n].ref_field.localRefreshSequecnce++;
          }
        }
      });
    },
    onLocalStartUpdate: function onLocalStartUpdate() {
      var _this3 = this;

      var work_fields = ["team_", "approver_"];
      work_fields.forEach(function (wf) {
        for (var n = 1; n <= 5; n++) {
          var wf_ref = _this3.local_fields_ref[wf + n].ref_field;
          if ((_this3.localCurrentRow[_this3.localFields['status_' + n].id] == '未承認' || _this3.localCurrentRow[_this3.localFields['status_' + n].id] == '' || _this3.localCurrentRow[_this3.localFields['status_' + n].id] == null) && _this3.localCurrentRow[_this3.localFields['approver_' + n].id] != _this3.userId) {
            wf_ref.forceEdit = true;
            wf_ref.load_data(false);
          }
        }
      });

      this.isUpdating = true;
    },
    disableApplicantOption: function disableApplicantOption(approval_history_data) {
      if (approval_history_data && approval_history_data.data && approval_history_data.data.applicant) {
        var applicant = approval_history_data.data.applicant;
        for (var n = 1; n <= 5; n++) {
          this.local_fields_ref["approver_" + n].ref_field.ignoreValues.push(applicant);
        }
      }
    },
    onUpdateConfirmed: function onUpdateConfirmed() {
      var _this4 = this;

      this.isUpdating = false;
      var work_fields = ["team_", "approver_"];
      var changes = {};
      work_fields.forEach(function (wf) {
        for (var n = 1; n <= 5; n++) {
          var wf_ref = _this4.local_fields_ref[wf + n].ref_field;
          wf_ref.forceEdit = false;

          if (typeof _this4.localCurrentEditingRow[_this4.localFields[wf + n].id] != "undefined") {
            changes[wf + n] = _this4.localCurrentEditingRow[_this4.localFields[wf + n].id];
            if (changes["approver_" + n] == "") {
              changes["status_" + n] = "";
            } else {
              changes["status_" + n] = "未承認";
            }
          }
        }
      });
      this.$ajax.post(this.url_for_update + this.local_seq_id, { changes: changes }, function (err, approval_history_data) {
        _this4.processRetrivedData(approval_history_data);
        __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$emit("confirmUpdateApplicationInformationFinished", {
          message: "",
          title: "登録情報を保存しました。",
          yes_label: "OK",
          no_label: "",
          yes_color: "default",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onLocalStartUpdateSave: function onLocalStartUpdateSave() {

      __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$emit("confirmUpdateApplicationInformation", {
        message: "よろしいですか？",
        title: "登録情報を保存します。",
        yes_label: "保存",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    local_extend: function local_extend(field_info) {
      var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      if (this.applicationMode == MODE_INVENTORY) {
        ext.api = '/master_user/list_user_and_team_inventory/';
      }

      if (this.preLoadData) {
        ext.api = '/master_user/list_user_and_team_and_me/';
      }
      var r = __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(field_info, ext);
      this.local_fields_ref[r.id] = r;
      return r;
    },
    onTeamSelected: function onTeamSelected(d, n) {
      try {
        var obj = JSON.parse(d);
        var temp = this.selectedDepartment;
        temp[n] = obj.department;
        this.selectedDepartment = temp;
        this.lastChange = new Date().getTime();
      } catch (error) {}
    },
    showModalWindow: function showModalWindow(data) {
      var _this5 = this;

      if (this.showModal == true) {
        return;
      }
      this.teamApplicant = "";
      this.userApplicant = "";
      this.showStartUpdate = false;
      this.seq_id = data.seq_id;
      if (data.approval_history_id != false && typeof data.approval_history_id != "undefined") {
        this.preLoadData = true;
      } else {
        this.preLoadData = false;
      }
      this.disableBtnApply = false;
      this.isUpdating = false;

      this.showModal = true;
      this.titleStyle = data.title_style || "";
      this.ref_id = data.ref_id;
      this.is_surplus = data.is_surplus || false;

      this.applicationMode = data.application_mode;
      this.process_import_url = data.process_import_url;
      if (data.on_finish_url_name) {
        this.on_finish_url_name = data.on_finish_url_name;
      }
      if (data.title_prefix) {
        this.title_prefix = data.title_prefix;
      }
      if (data.session_id) {
        this.sessionId = data.session_id;
      }
      if (data.title_suffix) {
        this.title_suffix = data.title_suffix;
      }
      if (data.syubetu) {
        this.syubetu = data.syubetu;
      }
      if (data.list_seq_id) {
        this.list_seq_id = data.list_seq_id;
      }
      if (data.modal_is_read_only) {
        this.modalIsReadOnly = true;
        this.ReadOnly = true;
      } else {
        this.modalIsReadOnly = false;
        this.ReadOnly = false;
      }

      this.loadPreviousIfExist = data.load_previous_if_exist || false;

      this.$ajax.post_cached_queued("/master_user/load_for_bulk_import/", {}, function (err, load_for_bulk_import_data) {
        _this5.localUserList = load_for_bulk_import_data;
      });
      this.$ajax.post_cached_queued("/master_belongs/list_team_and_department/", {}, function (err, list_team_and_department_data) {
        list_team_and_department_data.forEach(function (d) {
          var value = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(d);
          d.value = value;
        });
        _this5.listTeamDepartment = data;
      });
      if (data.approval_history_toroku_number != false && typeof data.approval_history_toroku_number != "undefined") {
        this.approvalHistoryTorokuNumber = data.approval_history_toroku_number;
      }
      if (data.approval_history_id != false && typeof data.approval_history_id != "undefined") {
        this.approvalHistoryId = data.approval_history_id;
        var approval_history_url = "/approval_history/get/";

        this.url_for_update = "/approval_history/update_existing/";
        if (this.applicationMode == MODE_USER) {
          approval_history_url = "/id_approval_history/get/";

          this.url_for_update = null;
        }

        this.url_for_load = approval_history_url + data.approval_history_id;
        if (data.approval_history_id == -200) {
          this.title_suffix = "一括取込";

          this.url_for_load = "/approval_history_batch_import/get_by_toroku_number/" + data.approval_history_toroku_number;

          this.url_for_update = null;
        }

        this.$ajax.post(this.url_for_load, {}, function (err, approval_history_data) {
          _this5.processRetrivedData(approval_history_data);
        });
      } else if (this.modalIsReadOnly == true) {
        this.readOnly = true;
        this.prepareEmptyData(false);
        this.teamApplicant = this.userTeam;
        this.userApplicant = this.userShimei;
      } else {
        this.prepareEmptyData();
        this.readOnly = false;
        this.approvalHistoryId = "";
        this.teamApplicant = this.userTeam;
        this.userApplicant = this.userShimei;
      }
    },
    processRetrivedData: function processRetrivedData(approval_history_data) {
      var _this6 = this;

      if (this.modalIsReadOnly == false) {
        this.teamApplicant = this.userTeam;
        this.userApplicant = this.userShimei;
        this.approvalHistoryTorokuNumber = "";
      }
      if (this.modalIsReadOnly && approval_history_data && approval_history_data.data && approval_history_data.data.applicant) {
        this.userApplicant = approval_history_data.data.applicant;
      }
      if (this.modalIsReadOnly && approval_history_data && approval_history_data.data && approval_history_data.data.applicant_label) {
        this.userApplicant = approval_history_data.data.applicant_label;
      }
      if (this.modalIsReadOnly && approval_history_data && approval_history_data.data && approval_history_data.data.applicant_team) {
        this.teamApplicant = approval_history_data.data.applicant_team;
      }
      if (approval_history_data && approval_history_data.body && approval_history_data.body.data == null) {
        return this.prepareEmptyData();
      }
      if (!(approval_history_data && approval_history_data.data && approval_history_data.data.approval_status == "差戻")) {
        this.loadPreviousIfExist = false;
      }
      if (this.modalIsReadOnly == false && this.loadPreviousIfExist != true) {
        return this.prepareEmptyData();
      }
      if (this.loadPreviousIfExist != true) {
        this.$store.state[this.stateCurrentRow] = approval_history_data.data;
      }

      this.$store.state[this.stateCurrentEditing] = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(approval_history_data.data).forEach(function (k) {
        if (k.indexOf("status") == 0 || k.indexOf("approver") == 0 || k.indexOf("team") == 0 || k.indexOf("applicant") == 0) {
          var val = approval_history_data.data[k] || false;
          if ((k.indexOf("approver") == 0 || k.indexOf("applicant") == 0) && val == _this6.userId) {
            _this6.showStartUpdate = true;
          }
          var current_status = false;
          if (k.indexOf("_0") > 0 || k.indexOf("_1") > 0 || k.indexOf("_2") > 0 || k.indexOf("_3") > 0 || k.indexOf("_4") > 0 || k.indexOf("_5") > 0) {
            current_status = approval_history_data.data["current_status"] || false;
          }
          if (val) {
            if (_this6.loadPreviousIfExist != true) {
              _this6.$store.state[_this6.stateCurrentRow][k] = val;
            }
          }
        }
      });
      if (this.showStartUpdate == false) {
        var user_company = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].localStorage.get("userCompany");
        if (approval_history_data.data["next_approver"] == "ライセンス管理窓口（最終承認）" && user_company == "ライセンス管理窓口") {
          this.showStartUpdate = true;
        }
      }
      if (this.loadPreviousIfExist == true && approval_history_data && approval_history_data.data && approval_history_data.data.approval_status == "差戻") {
        this.approvalHistoryTorokuNumber = "";
        this.approvalHistoryId = "";
        this.local_seq_id = null;
        this.is_new = true;
        this.$store.state[this.stateIsEditingNew] = true;
        this.readOnly = false;

        this.local_seq_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
        this.$store.state[this.stateCurrentRow] = {
          seq_id: this.local_seq_id
        };
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
          _this6.$store.state[_this6.stateCurrentRow][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id] = "";
          _this6.$store.state[_this6.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id] = "";
        });

        var work_fields = ["team_", "approver_"];
        work_fields.forEach(function (wf) {
          for (var n = 1; n <= 5; n++) {
            var val = approval_history_data.data[wf + n];
            if (val && val.length > 0) {
              var wf_ref = _this6.local_fields_ref[wf + n].ref_field;
              wf_ref.forceEdit = true;
              _this6.localCurrentEditingRow[_this6.localFields[wf + n].id] = val || false;
              _this6.localCurrentRow[_this6.localFields[wf + n].id] = val || false;
              wf_ref.load_data(true);
              if (typeof wf_ref.$props.data.global_emit != "undefined") {
                __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$emit(wf_ref.$props.data.global_emit, val);
              }
            }
          }
        });
      } else {
        this.local_seq_id = approval_history_data.data.seq_id;
        this.is_new = false;
        this.$store.state[this.stateIsEditingNew] = false;
        this.readOnly = this.modalIsReadOnly == true ? true : false;
      }
      this.disableApplicantOption(approval_history_data);
    },
    prepareEmptyData: function prepareEmptyData() {
      var _this7 = this;

      var is_new = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.local_seq_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.$store.state[this.stateCurrentRow] = {
        seq_id: this.local_seq_id
      };
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
        _this7.$store.state[_this7.stateCurrentRow][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id] = "";
        _this7.$store.state[_this7.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id] = "";
      });
      if (is_new) {
        setTimeout(function () {
          _this7.approvalHistoryId = "";
          _this7.$store.state[_this7.stateIsEditingNew] = true;
          _this7.read_only = false;
          _this7.is_new = true;
        }, 300);
      }
    },
    closed: function closed(mode) {
      this.showModal = false;
      if (typeof mode != "undefined") {
        this.$emit('done', mode);
      }
    },
    getSyubetuFromApplicationMode: function getSyubetuFromApplicationMode() {
      var ret = "";
      switch (this.applicationMode) {
        case MODE_DEVICE_EMBEDDED:
          ret = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.SYUBETU.DEVICE;
          break;
        case MODE_CERTIFICATE:
          ret = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.SYUBETU.CERTIFICATE;
          break;
        case MODE_USER:
          ret = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.SYUBETU.USER;
          break;
        case MODE_INVENTORY:
          ret = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.SYUBETU.INVENTORY;
          break;
        default:
          ret = __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.SYUBETU.CERTIFICATE;
          break;
      }
      return ret;
    },
    onSave: function onSave(mode) {
      var _this8 = this;

      if (mode == "yes") {
        debug_msg_bulk("On Save", { mode: this.applicationMode, url: this.process_import_url });

        if (this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED) {

          var changes = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this8.$store.state[_this8.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { list_seq_id: this.list_seq_id, changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, function (err, result) {
            if (err) {
              _this8.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              _this8.disableBtnApply = false;
            } else {
              return _this8.onConfirmExecuteProcess();
            }
          });
        } else if (this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) {
          var changes = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this8.$store.state[_this8.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { list_seq_id: this.list_seq_id, changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, function (err, result) {
            if (err) {
              _this8.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              _this8.disableBtnApply = false;
            } else {
              return _this8.onConfirmExecuteProcess();
            }
          });
        } else if (this.applicationMode == MODE_BULK_IMPORT) {
          var changes = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this8.$store.state[_this8.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { syubetu: this.syubetu, changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(this.process_import_url, obj, function (err, result) {
            if (err) {
              _this8.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              _this8.disableBtnApply = false;
            } else {
              return _this8.onConfirmExecuteProcess();
            }
          });
        } else if (this.applicationMode == MODE_CERTIFICATE) {
          var changes = {
            ref_id: this.ref_id,
            syubetu: this.getSyubetuFromApplicationMode(),
            approval_status: "申請中",
            application_mode: this.applicationMode,
            fk_tab: __WEBPACK_IMPORTED_MODULE_6__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE,
            fk_id: this.seq_id,
            update_name: "",
            update_time: null,
            create_time: __WEBPACK_IMPORTED_MODULE_11_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
          };
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this8.$store.state[_this8.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });
          var obj = { changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post("/approval_history/set/" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a, obj, function (err, response) {
            console.log("onSave approval _history", { response: response });
            if (err) {
              _this8.$notify({
                title: "データの保存に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              _this8.disableBtnApply = false;
            } else {
              _this8.$ajax.post("/certificate_software/set/" + _this8.seq_id, { system_change: true, changes: { approval_status: "申請中", approval_status_flag: 1 } }, function (err, response2) {
                if (err) {
                  _this8.$notify({
                    title: "データの保存に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000
                  });
                  _this8.disableBtnApply = false;
                } else {
                  _this8.saveApplicationFlow(response.data.seq_id, function () {
                    _this8.onConfirmExecuteProcess();
                  });
                }
              });
            }
          });
        } else if (this.applicationMode == MODE_INVENTORY) {
          var changes = {
            ref_id: this.ref_id,
            control_number: !this.ref_id || this.ref_id.indexOf("BY_SEQ_ID::") == 0 ? "" : this.ref_id,
            approval_status: "申請中",
            syubetu: this.getSyubetuFromApplicationMode(),
            application_mode: this.applicationMode,
            fk_tab: this.fk_table_id,
            fk_id: this.seq_id,
            update_name: "",
            update_time: null,
            create_time: __WEBPACK_IMPORTED_MODULE_11_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
          };
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this8.$store.state[_this8.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });

          var approval_history_url = "/approval_history_inventory/set/";

          var obj = { changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(approval_history_url + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a, obj, function (err, response) {
            console.log("onSave approval _history", { response: response });
            if (err) {
              _this8.$notify({
                title: "データの保存に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              _this8.disableBtnApply = false;
            } else {
              var api_url = "inventory_report";
              _this8.$ajax.post("/" + api_url + "/set/" + _this8.seq_id, { system_change: true, changes: { approval_status: "申請中", approval_status_flag: 1 } }, function (err, response2) {
                console.log("onSave 2 " + api_url, { response2: response2 });
                if (err) {
                  _this8.$notify({
                    title: "データの保存に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000
                  });
                  _this8.disableBtnApply = false;
                } else {
                  _this8.saveApplicationFlow(response.data.seq_id, function () {
                    _this8.onConfirmExecuteProcess();
                  });
                }
              });
            }
          });
        } else {
          var changes = {
            ref_id: this.ref_id,
            control_number: !this.ref_id || this.ref_id.indexOf("BY_SEQ_ID::") == 0 ? "" : this.ref_id,
            approval_status: "申請中",
            syubetu: this.getSyubetuFromApplicationMode(),
            application_mode: this.applicationMode,
            fk_tab: this.fk_table_id,
            fk_id: this.seq_id,
            update_name: "",
            update_time: null,
            create_time: __WEBPACK_IMPORTED_MODULE_11_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
          };
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */]).forEach(function (f) {
            if (f.indexOf("status") == 0 || f.indexOf("approver") == 0 || f.indexOf("team") == 0) {
              var v = _this8.$store.state[_this8.stateCurrentEditing][__WEBPACK_IMPORTED_MODULE_7__rules_fields_approval_history__["a" /* fields */][f].id];
              if (v && v.length > 0) {
                changes[f] = v;
              }
            }
          });

          var approval_history_url = "/approval_history/set/";
          if (this.applicationMode == MODE_USER) {
            approval_history_url = "/id_approval_history/set/";
          }

          var obj = { changes: changes };
          if (this.sessionId != false) {
            obj.session_id = this.sessionId;
          }
          this.$ajax.post(approval_history_url + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a, obj, function (err, response) {
            console.log("onSave approval _history", { response: response });
            if (err) {
              _this8.$notify({
                title: "データの保存に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              _this8.disableBtnApply = false;
            } else {
              var api_url = _this8.applicationMode == MODE_DEVICE_EMBEDDED ? "device_embedded_information" : "certificate_information";
              _this8.$ajax.post("/" + api_url + "/set/" + _this8.seq_id, { system_change: true, changes: { approval_status: "申請中", approval_status_flag: 1 } }, function (err, response2) {
                console.log("onSave 2 " + api_url, { response2: response2 });
                if (err) {
                  _this8.$notify({
                    title: "データの保存に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000
                  });
                  _this8.disableBtnApply = false;
                } else {
                  _this8.saveApplicationFlow(response.data.seq_id, function () {
                    _this8.onConfirmExecuteProcess();
                  });
                }
              });
            }
          });
        }
      } else if (mode == "no") {
        this.disableBtnApply = false;
      }
    },
    saveApplicationFlow: function saveApplicationFlow(approval_history_seq_id, cb) {
      return cb(null);
    },
    onLocalApplication: function onLocalApplication() {
      this.disableBtnApply = true;
      this.$notify({ clean: true });


      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformation", {
          message: "よろしいですか？",
          title: "申請を行います。",
          yes_label: "申請",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      }, 30);
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      var message = "機器・組込情報を申請しました。";
      if (this.applicationMode == MODE_CERTIFICATE) {
        message = "証書情報を申請しました。";
        if (this.is_surplus == true) {
          message = "余剰ライセンスを申請しました。";
        }
      } else if (this.applicationMode == MODE_USER) {
        message = "ユーザを申請しました。";
      } else if (this.applicationMode == MODE_INVENTORY) {
        this.showModal = false;
        this.show_modal = false;
        this.$emit('done', "yes");
        return;
        message = "棚卸報告を申請しました。";
      }
      if ((this.applicationMode == MODE_BULK_IMPORT || this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED || this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) && this.title_prefix && this.title_prefix.length > 0) {
        message = this.title_prefix + "を申請しました。";
      }
      __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$emit("applicationConfirmatioModal", {
        title: "",
        message: message,
        yes_label: "",
        no_label: "OK",
        yes_color: "",
        no_color: "default",
        model_height: "50"
      });
    },
    onSaveApplicationConfirm: function onSaveApplicationConfirm() {
      var _this9 = this;

      this.showModal = false;
      var on_finish_go_to = "page_0010_device_embedded_information";
      if (this.applicationMode == MODE_CERTIFICATE) {
        on_finish_go_to = "page_0040_certificate_software";
        if (this.is_surplus == true) {
          on_finish_go_to = "page_0020_surplus_license";
        }
      } else if (this.applicationMode == MODE_INVENTORY) {
        return;
      } else if (this.applicationMode == MODE_USER) {
        on_finish_go_to = "page_0041_master_user";
      }
      if (this.applicationMode == MODE_DEVICE_EMBEDDED || this.applicationMode == MODE_BULK_EDIT_DEVICEE_EMBEDDED) {
        var device_back_to_list = window.sessionStorage.getItem("device_back_to_list");
        if ((device_back_to_list || "").indexOf("/") == 0) {
          return this.$router.push(device_back_to_list);
        }
      } else if (this.applicationMode == MODE_CERTIFICATE || this.applicationMode == MODE_BULK_EDIT_CERTIFICATE) {
        var certificate_back_to_list = window.sessionStorage.getItem("certificate_back_to_list");
        if ((certificate_back_to_list || "").indexOf("/") == 0) {
          return this.$router.push(certificate_back_to_list);
        }
      } else if (this.on_finish_url_name && this.on_finish_url_name.length > 0) {
        on_finish_go_to = this.on_finish_url_name;
      }
      setTimeout(function () {
        _this9.$router.push({
          name: on_finish_go_to
        });
      }, 500);
    }
  },
  props: {
    tag: { type: String, default: "applicationConfimationModal" }
  },
  mounted: function mounted() {
    this.userId = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].localStorage.get("userID");
    __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
    for (var i = 0; i < 5; i++) {
      this.selectedDepartment[i] = this.userDepartment;
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);





var vm = this;



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_input_manual = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:input-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: "",
      qty_to_reject: 0
    };
  },

  computed: {
    qtyToReject: {
      get: function get() {
        return this.qty_to_reject;
      },
      set: function set(v) {
        this.qty_to_reject = v;
      }
    },
    localValue: {
      get: function get() {
        return this.local_value;
      },
      set: function set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },

    textTitle: function textTitle() {
      return this.title_label;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    updateValue: function updateValue(val) {
      this.localValue = val;
    },
    onShow: function onShow() {},
    showModalWindow: function showModalWindow(data) {
      var _this = this;

      debug_input_manual("showModalWindow data", data);
      this.onShow();
      this.qtyToReject = data.qty;
      this.show_modal = true;
      this.$refs.local_value.focus();
      setTimeout(function () {
        _this.$refs.local_value.focus();
      }, 100);
    },
    closed: function closed(mode) {
      debug_input_manual("mode", mode);
      this.$emit("closed", { mode: mode, value: this.localValue });
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showInputModal" },
    qty: { type: Number }
  },
  mounted: function mounted() {
    debug_input_manual("On mounted");
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);





var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:bulk-import-confirmation-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      callback: null,
      model_height: "350",
      team_options: ["tA", "E", "D", "C"],
      user_options: ["uA", "E", "D", "C"],
      local_user_list: []
    };
  },

  computed: {
    localUserList: {
      get: function get() {
        return this.local_user_list;
      },
      set: function set(v) {
        this.userOptions = v.map(function (o) {
          return o.user_shimei;
        });
        this.teamOptions = v.map(function (o) {
          return o.team;
        });
        this.local_user_list = v;
      }
    },
    userDepartment: function userDepartment() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userDepartment") || "";
    },
    userTeam: function userTeam() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userTeam") || "";
    },
    userShimei: function userShimei() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userShimei") || "";
    },

    userOptions: {
      get: function get() {
        return this.user_options;
      },
      set: function set(v) {
        this.user_options = v;
      }
    },
    teamOptions: {
      get: function get() {
        return this.team_options;
      },
      set: function set(v) {
        this.team_options = v;
      }
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow: function showModalWindow(data) {
      var _this = this;

      this.show_modal = true;
      this.titleStyle = data.title_style || "";

      this.$ajax.post("/master_user/load_for_bulk_import/", {}, function (err, data) {
        _this.localUserList = data;
      });
    },
    closed: function closed(mode) {
      if (typeof mode != "undefined") {
        console.log("mode", mode);
        this.show_modal = false;
        this.$emit('done', mode);
      }
    }
  },
  props: {
    tag: { type: String, default: "showBulkImportConfimationModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);





var vm = this;







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_yobiki = __WEBPACK_IMPORTED_MODULE_9_debug___default()('esma:certificate-list-modal');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "certificate",
      search_timeout: false,
      search_model: "",
      device_control_number: false,
      state_last_filter_options: "last_filter_options3",
      selected_row: false
    };
  },

  computed: {
    selectedRow: {
      get: function get() {
        return this.selected_row;
      },
      set: function set(v) {
        this.selected_row = v;
      }
    },
    searchModel: {
      get: function get() {
        return this.search_model;
      },
      set: function set(v) {
        this.search_model = v;
      }
    },
    rowData: {
      get: function get() {
        return this.row_data;
      },
      set: function set(v) {
        this.row_data = v;
      }
    },
    selectedData: {
      get: function get() {
        return this.selected_data;
      },
      set: function set(v) {
        this.selected_data = v;
      }
    },

    pageID: function pageID() {
      return this.$props.pageid;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch: function onSearch(txt) {
      var _this = this;

      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(function () {
        var b2 = txt == "" ? false : { block: "2", field: "certificate_management_number", value: txt, ct: "v", ca: false, t: "input" };
        var b3 = false;
        if (b2 == false) {
          b2 = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.clone(b3);
          b3 = false;
        }
        _this.searchControlChangedDatasource({
          "1": { block: "1", field: "certificate_management_number", value: "NOT_EMPTY_VALUE", ct: "v", ca: false, t: "input" },
          "2": b2,
          "3": b3,
          "j1": "AND",
          "j2": "AND",
          "b2_disabled": false,
          "b3_disabled": true
        });
      }, txt == "" ? 0 : 300);
    },
    cancelCurrentSelection: function cancelCurrentSelection() {},
    updateValue: function updateValue(vm, ev, mode) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.certificate_management_number;
        this.selectedRow = ev.node.data;
      }
    },
    onShow: function onShow() {
      this.company = this.$store.state[this.stateCurrentEditing].company || this.$store.state[this.stateCurrentRow].company || false;
      this.onSearch("");
      this.searchModel = "";
      this.selectedData = false;
      this.selectedRow = false;
      this.$notify({ clean: true });
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
    },
    showModalWindow: function showModalWindow(data) {
      debug_yobiki("showModalWindow");
      this.show_modal = true;
      this.device_control_number = data && data.device_control_number && data.device_control_number.length > 0 ? data.device_control_number : false;
      this.onShow();
    },
    closed: function closed(mode) {
      var _this2 = this;

      debug_yobiki('mode', mode);
      if (mode == "yes" && this.selectedData) {
        this.$emit("selected", this.selectedData, this.selectedRow);
        setTimeout(function () {
          _this2.selectedData = "";
          _this2.selectedData = false;
          _this2.selectedRow = false;
        }, 100);
      } else if (mode == "yes") {
        var last_terminal = false;
        var last_data = false;
        var count_rows = 0;
        this.gridOptions.api.forEachNode(function (node) {
          if (typeof node != "undefined" && typeof node.data != "undefined") {
            if (typeof node.data.seq_id != "undefined") {
              if (count_rows == 0) {
                last_terminal = node.data.number_cert;
                last_data = node.data;
              }
              count_rows++;
            }
          }
        });
        if (count_rows == 1 && last_terminal != false) {
          this.$emit("selected", last_terminal, last_data);
        }
      }
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs: function createColumnDefs() {
      return [{
        headerName: '証書管理番号',
        field: 'certificate_management_number',
        hide: false,
        sort: 'desc',
        width: 392
      }, {
        headerName: 'Seq',
        field: 'seq_id',
        hide: false,
        sort: 'desc',
        width: 392
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: false
      }];
    }
  },
  props: {
    tag: { type: String, default: 'showCertificateListModal' },
    pageid: { type: String }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: false,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: function onRowSelected(ev) {
        _this3.updateValue(_this3, ev, 'load_yobiki');
      }
    };

    this.initDatasource({ load_only_with_filter: true });
  },
  mounted: function mounted() {
    debug_yobiki('On mounted');
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_constants__);





var vm = this;







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);



var debug_log_history = __WEBPACK_IMPORTED_MODULE_9_debug___default()('esma:change_history');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "certificate_software",
      search_timeout: false,
      search_model: "",
      show_details: false,
      data_changes: [],
      show_details_label: "選択",

      state_current_editing: "current_editing3",
      state_current_row: "current_row3",
      state_is_editing_new: "is_editing_new3",
      state_last_filter_options: "last_filter_options3"
    };
  },

  computed: {
    showModal: function showModal() {
      return this.show_modal;
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].status, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].certificate_software_number, { tab_label: "証書管理番号", tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].effective_number, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].remaining_number, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].expiration_date, { type: __WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["b" /* filed_types */].DATE_PICKER }), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["a" /* fields */].maintenance_deadline, { type: __WEBPACK_IMPORTED_MODULE_5__rules_fields_certificate_software__["b" /* filed_types */].DATE_PICKER })];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      var _this = this;

      console.log('onDetailsClick', data);
      this.$emit("selected", data);
      setTimeout(function () {
        _this.show_modal = false;
      }, 100);
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: false });
    },
    onShow: function onShow(data) {
      var _this2 = this;

      this.api_request_options = { filter_mode: "select_for_upgrade" };
      this.emulateSearchControlChangedDatasource(true);
      this.$notify({ clean: true });
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
      setTimeout(function () {
        _this2.gridOptions.api.sizeColumnsToFit();
      }, 500);
      setTimeout(function () {
        _this2.gridOptions.api.sizeColumnsToFit();
      }, 1000);
      setTimeout(function () {
        _this2.gridOptions.api.sizeColumnsToFit();
      }, 3000);
    },
    showModalWindow: function showModalWindow(data) {
      debug_log_history("showModalWindow");
      this.onShow(data);
      this.show_modal = true;
    },
    closed: function closed(mode) {
      this.show_modal = false;
      this.$emit('done', mode);
    }
  },
  beforeMount: function beforeMount() {
    this.count_from_result = true;
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true });
  },
  mounted: function mounted() {
    debug_log_history('On mounted');
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  },

  props: {
    tag: { type: String, default: 'showCertificateSoftwareLinkedUpgradeModal' }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_output_config_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_output_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_output_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_fields_certificate__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_fields_approval_history__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__rules_constants__);






var vm = this;













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_4__local_modal___default.a);



var debug_log_history = __WEBPACK_IMPORTED_MODULE_16_debug___default()('esma:change_history');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_6_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "change_history",
      search_timeout: false,
      search_model: "",
      show_details: false,
      data_changes: [],

      state_current_row: "current_row3",
      state_is_editing_new: "is_editing_new3",
      change_time: null,
      use_predefined_list: false,
      bulk_toroku_number: null
    };
  },

  computed: {
    bulkTorokuNumber: {
      get: function get() {
        return this.bulk_toroku_number;
      },
      set: function set(v) {
        this.bulk_toroku_number = v;
      }
    },
    changeTime: {
      get: function get() {
        return this.change_time;
      },
      set: function set(v) {
        this.change_time = v;
      }
    },
    dataChangesA: function dataChangesA() {
      if (this.use_predefined_list == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION) {
        return this.deviceInformationFields("a");
      }
      var c = parseInt(this.dataChanges.length / 2) + 1;
      return __WEBPACK_IMPORTED_MODULE_15_lodash___default.a.chunk(this.dataChanges, c)[0];
    },
    dataChangesB: function dataChangesB() {
      if (this.use_predefined_list == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION) {
        return this.deviceInformationFields("b");
      }
      var c = parseInt(this.dataChanges.length / 2) + 1;
      return __WEBPACK_IMPORTED_MODULE_15_lodash___default.a.chunk(this.dataChanges, c)[1];
    },


    dataChanges: {
      get: function get() {
        return this.data_changes;
      },
      set: function set(v) {
        this.data_changes = v;
      }
    },
    showDetails: {
      get: function get() {
        return this.show_details;
      },
      set: function set(v) {
        this.show_details = v;
      }
    },
    searchModel: {
      get: function get() {
        return this.search_model;
      },
      set: function set(v) {
        this.search_model = v;
      }
    },
    rowData: {
      get: function get() {
        return this.row_data;
      },
      set: function set(v) {
        this.row_data = v;
      }
    },
    selectedData: {
      get: function get() {
        return this.selected_data;
      },
      set: function set(v) {
        this.selected_data = v;
      }
    },

    pageID: function pageID() {
      return this.$props.pageid;
    },

    showModal: {
      get: function get() {
        return this.show_modal;
      },
      set: function set(v) {
        this.show_modal = v;
      }
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__["a" /* fields */].change_time, { type: __WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__["b" /* filed_types */].CURRENT_TIME }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__["a" /* fields */].user_label, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__["a" /* fields */].fk_tab, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__["a" /* fields */].data_id, { tab_label: this.$props.id_label || "ID" }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__["a" /* fields */].mode, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_change_history__["a" /* fields */].description, {})];
    }
  },
  methods: {
    deviceInformationFields: function deviceInformationFields(side) {
      var _this = this;

      var list_a = ["device_control_number", "approval_status", "status", "registration_date", "last_update_date", "computer_name", "virtual_environment", "virtual_base_unit", "company", "equipment_in_charge_department", "equipment_in_charge_team", "equipment_in_charge_classification", "equipment_in_charge_system", "equipment_in_charge_system_it"];
      var list_b = ["leasing_or_rental", "manufacture_name", "model_name", "equipment_classification", "cpu_count", "installation_department", "installation_team", "installation_base", "floor", "user_name", "management_person_name", "remarks"];
      var ret = [];
      if (side == "a") {
        list_a.forEach(function (k) {
          var d = __WEBPACK_IMPORTED_MODULE_15_lodash___default.a.find(_this.dataChanges, function (i) {
            return i.id == k;
          }) || false;
          if (d) {
            ret.push(d);
          }
        });
      }
      if (side == "b") {
        list_b.forEach(function (k) {
          var d = __WEBPACK_IMPORTED_MODULE_15_lodash___default.a.find(_this.dataChanges, function (i) {
            return i.id == k;
          }) || false;
          if (d) {
            ret.push(d);
          }
        });
        this.dataChanges.forEach(function (e) {
          if (list_a.indexOf(e.id) < 0 && list_b.indexOf(e.id) < 0) {
            ret.push(e);
          }
        });
      }
      return ret;
    },
    onRowSelected: function onRowSelected(data) {
      var _this2 = this;

      console.log('onRowSelected', data.node.data);
      this.changeTime = __WEBPACK_IMPORTED_MODULE_14_moment___default()(data.node.data.change_time).format("YYYY/MM/DD HH:mm:ss");
      this.$ajax.post("/" + this.api_name + "/get/" + data.node.data.seq_id, {}, function (err, result) {
        _this2.showDetails = true;
        _this2.use_predefined_list = false;
        var use_fields = {};
        if (result.data.fk_tab == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.CERTIFICATE) {
          use_fields = __WEBPACK_IMPORTED_MODULE_10__rules_fields_certificate__["a" /* fields */];
        } else if (result.data.fk_tab == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE) {
          use_fields = __WEBPACK_IMPORTED_MODULE_11__rules_fields_certificate_software__["a" /* fields */];
        } else if (result.data.fk_tab == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION) {
          _this2.use_predefined_list = __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION;
          use_fields = __WEBPACK_IMPORTED_MODULE_12__rules_fields_device_embedded_information__["a" /* fields */];
        } else if (result.data.fk_tab == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.APPLICATION_FLOW_CERTIFICATE_SOFTWARE || result.data.fk_tab == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.TABLE_ID.APPLICATION_FLOW_DEVICE_EMBEDDED_INFORMATION) {
          use_fields = __WEBPACK_IMPORTED_MODULE_13__rules_fields_approval_history__["a" /* fields */];
        } else {}
        _this2.bulkTorokuNumber = null;
        if (result.data.bulk_toroku_number && result.data.bulk_toroku_number.length > 0) {
          _this2.bulkTorokuNumber = result.data.bulk_toroku_number;
        }
        var old_data = JSON.parse(result.data.old_data);
        var new_data = JSON.parse(result.data.new_data);
        var all_keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(old_data);
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(new_data).forEach(function (k) {
          if (all_keys.indexOf(k) < 0) {
            all_keys.push(k);
          }
        });
        _this2.dataChanges = [];
        all_keys.forEach(function (k) {
          if (k.indexOf("seq_id") < 0 && use_fields && use_fields[k]) {
            var obj = {
              id: k,
              label: use_fields && use_fields[k] ? use_fields[k].label : k,
              o: (old_data[k] || "") + "",
              n: (new_data[k] || "") + ""
            };
            if ((k == "last_update_date" || k == "registration_date") && (obj.n.length > 0 || obj.o.length > 0)) {
              obj.n = __WEBPACK_IMPORTED_MODULE_14_moment___default()(obj.n).format("YYYY/MM/DD");
              obj.o = __WEBPACK_IMPORTED_MODULE_14_moment___default()(obj.o).format("YYYY/MM/DD");
              if (obj.o == "Invalid date") {
                obj.o = "";
              }
              if (obj.n == "Invalid date") {
                obj.n = "";
              }
              if (obj.o == obj.n) {
                obj.n = "";
              }
            }
            if (obj.o.length > 0 || obj.n.length > 0) {
              if (k != "status_at_approve_request" && k != "approval_status_flag") {
                _this2.dataChanges.push(obj);
              }
            }
          }
        });
      });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: false, show_checkbox: false });
    },
    onSearch: function onSearch(txt, data) {
      var fk_id = data.fk_id;
      var fk_tab = data.fk_tab;
      var obj = {
        "1": { block: "1", field: "fk_id", value: "" + fk_id, ct: "v", ca: false, t: "input", exact_value: true },
        "2": { block: "2", field: "fk_tab", value: "" + fk_tab, ct: "v", ca: false, t: "input", exact_value: true },
        "3": false,
        "j1": "AND",
        "j2": "AND",
        "b2_disabled": false,
        "b3_disabled": true
      };

      this.searchControlChangedDatasource(obj);
    },
    cancelCurrentSelection: function cancelCurrentSelection() {},
    updateValue: function updateValue(vm, ev, mode) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.number_cert;
      }
    },
    onShow: function onShow(data) {
      var _this3 = this;

      this.searchModel = "";
      this.selectedData = false;
      this.$notify({ clean: true });
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
      this.onSearch("", data);
      setTimeout(function () {
        _this3.gridOptions.api.sizeColumnsToFit();
      }, 500);
      setTimeout(function () {
        _this3.gridOptions.api.sizeColumnsToFit();
      }, 1000);
      setTimeout(function () {
        _this3.gridOptions.api.sizeColumnsToFit();
      }, 3000);
    },
    showModalWindow: function showModalWindow(data) {
      debug_log_history("showModalWindow");
      this.onShow(data);
      this.showModal = true;
    },
    closed: function closed(mode) {
      this.showModal = false;
      this.$emit('done', mode);
    }
  },

  beforeMount: function beforeMount() {
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_15_lodash___default.a.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true });
  },
  mounted: function mounted() {
    debug_log_history('On mounted');
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off(this.$props.tag);
  },

  props: {
    tag: { type: String, default: 'showLogHistory' },
    pageid: { type: String },
    fk_tab: { type: String },
    fk_id: { type: String },
    id_label: { type: String }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);






var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_4__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:confirmation-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selected_value: "",
      show_modal: false,
      link_number: false,
      max_qty: false
    };
  },

  computed: {
    selectedValue: {
      get: function get() {
        return this.selected_value;
      },
      set: function set(v) {
        this.selected_value = v;
      }
    },
    linkNumber: {
      get: function get() {
        return this.link_number;
      },
      set: function set(v) {
        this.link_number = v;
      }
    },
    maxQty: {
      get: function get() {
        return this.max_qty;
      },
      set: function set(v) {
        this.max_qty = v;
      }
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    confirmOK: function confirmOK() {
      this.$notify({ clean: true });
      if (this.maxQty == "-") {
        this.closed('yes', this.selectedValue);
      } else if (parseInt(this.selectedValue) > 0 && parseInt(this.selectedValue) <= parseInt(this.maxQty)) {
        this.closed('yes', this.selectedValue);
      } else {
        this.$notify({
          title: "エラー",
          text: "割り当てるライセンス数がライセンス残数を上回っています。",
          type: "error",
          duration: 10000
        });
      }
    },
    showModalWindow: function showModalWindow(data) {
      this.selectedValue = "";
      this.linkNumber = data.link_number || "***";
      this.maxQty = data.max_qty || false;
      this.show_modal = true;
    },
    closed: function closed(mode) {
      var qty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log("mode", mode);
      this.show_modal = false;
      this.$emit('done', mode, qty);
    }
  },
  props: {
    tag: { type: String, default: "showConfimationModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);






var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_4__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:confirmation-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,

      title_label: "",
      message: "",
      yes_label: "",
      no_label: "",
      callback: null,
      yes_color: "primary",
      no_color: "",
      model_height: "280",
      title_style: "",
      local_width: "325px"
    };
  },

  computed: {
    localWidth: {
      get: function get() {
        return this.local_width;
      },
      set: function set(v) {
        this.local_width = v;
      }
    },
    titleStyle: {
      get: function get() {
        return this.title_style;
      },
      set: function set(v) {
        this.title_style = v;
      }
    },
    getTrue: function getTrue() {
      return true;
    },
    getFalse: function getFalse() {
      return false;
    },
    textTitle: function textTitle() {
      return this.title_label;
    },
    textMessage: function textMessage() {
      return this.message;
    },
    textYes: function textYes() {
      return this.yes_label;
    },
    textNo: function textNo() {
      return this.no_label;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow: function showModalWindow(data) {
      this.title_label = data.title;
      this.message = data.message;
      this.yes_label = data.yes_label;
      this.no_label = data.no_label;
      this.yes_color = data.yes_color || "primary";
      if (data.no_color) {
        this.no_color = "btn-" + data.no_color;
      }
      this.model_height = data.model_height || "280";
      if ((data.model_width || "").length > 0) {
        if (data.model_width.indexOf("px") > 0) {
          this.localWidth = data.model_width;
        } else {
          this.localWidth = data.model_width + "px";
        }
      } else {
        this.localWidth = "325px";
      }
      this.show_modal = true;
      this.titleStyle = data.title_style || "";
    },
    closed: function closed(mode) {
      console.log("mode", mode);
      this.show_modal = false;
      this.$emit('done', mode);
    }
  },
  props: {
    tag: { type: String, default: "showConfimationModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);





var vm = this;



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_input_manual = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:input-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: ""
    };
  },

  computed: {
    localValue: {
      get: function get() {
        return this.local_value;
      },
      set: function set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    updateValue: function updateValue(val) {
      this.localValue = val;
      this.$emit("inputed", this.localValue);
    },
    onShow: function onShow() {},
    showModalWindow: function showModalWindow(data) {
      this.onShow();
      this.localValue = data.initial_value || "";
      this.show_modal = true;
    },
    closed: function closed(mode) {
      if (mode == "yes") {
        this.$emit("save", this.localValue);
      }
      this.$emit("closed", this.localValue);
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showDeviceEmbeddedInformationAddCheck" }
  },
  mounted: function mounted() {
    debug_input_manual("On mounted");
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);





var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:bulk-import-confirmation-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      callback: null,
      model_height: "350",
      team_options: ["tA", "E", "D", "C"],
      user_options: ["uA", "E", "D", "C"],
      local_user_list: []
    };
  },

  computed: {
    localUserList: {
      get: function get() {
        return this.local_user_list;
      },
      set: function set(v) {
        this.userOptions = v.map(function (o) {
          return o.user_shimei;
        });
        this.teamOptions = v.map(function (o) {
          return o.team;
        });
        this.local_user_list = v;
      }
    },
    userDepartment: function userDepartment() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userDepartment") || "";
    },
    userTeam: function userTeam() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userTeam") || "";
    },
    userShimei: function userShimei() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userShimei") || "";
    },

    userOptions: {
      get: function get() {
        return this.user_options;
      },
      set: function set(v) {
        this.user_options = v;
      }
    },
    teamOptions: {
      get: function get() {
        return this.team_options;
      },
      set: function set(v) {
        this.team_options = v;
      }
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow: function showModalWindow(data) {
      var _this = this;

      this.show_modal = true;
      this.titleStyle = data.title_style || "";

      this.$ajax.post("/master_user/load_for_bulk_import/", {}, function (err, data) {
        _this.localUserList = data;
      });
    },
    closed: function closed(mode) {
      if (typeof mode != "undefined") {
        console.log("mode", mode);
        this.show_modal = false;
        this.$emit('done', mode);
      }
    }
  },
  props: {
    tag: { type: String, default: "showAppConfimationModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);





var vm = this;



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_input_manual = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:input-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: ""
    };
  },

  computed: {
    localValue: {
      get: function get() {
        return this.local_value;
      },
      set: function set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    updateValue: function updateValue(val) {
      this.localValue = val;
      this.$emit("inputed", this.localValue);
    },
    onShow: function onShow() {},
    showModalWindow: function showModalWindow(data) {
      var _this = this;

      this.onShow();
      this.localValue = data.initial_value || "";
      this.show_modal = true;
      this.$refs.local_value.focus();
      setTimeout(function () {
        _this.$refs.local_value.focus();
      }, 100);
    },
    closed: function closed(mode) {
      if (mode == "yes") {
        this.$emit("save", this.localValue);
      }
      this.$emit("closed", this.localValue);
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showDeviceEmbeddedInformationBachEditModal" }
  },
  mounted: function mounted() {
    debug_input_manual("On mounted");
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_device_embedded_information_application_confirmation_modal__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_device_embedded_information_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modals_device_embedded_information_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);








var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_6__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_7_debug___default()("esma:bulk-import-confirmation-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "device-embedded-information-application-confirmation-modal": __WEBPACK_IMPORTED_MODULE_3__components_modals_device_embedded_information_application_confirmation_modal___default.a
  },
  data: function data() {
    return {
      show_modal: false,
      callback: null,
      model_height: "350",
      team_options: ["tA", "E", "D", "C"],
      user_options: ["uA", "E", "D", "C"],
      local_user_list: []
    };
  },

  computed: {
    localUserList: {
      get: function get() {
        return this.local_user_list;
      },
      set: function set(v) {
        this.userOptions = v.map(function (o) {
          return o.user_shimei;
        });
        this.teamOptions = v.map(function (o) {
          return o.team;
        });
        this.local_user_list = v;
      }
    },
    userDepartment: function userDepartment() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userDepartment") || "";
    },
    userTeam: function userTeam() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userTeam") || "";
    },
    userShimei: function userShimei() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userShimei") || "";
    },

    userOptions: {
      get: function get() {
        return this.user_options;
      },
      set: function set(v) {
        this.user_options = v;
      }
    },
    teamOptions: {
      get: function get() {
        return this.team_options;
      },
      set: function set(v) {
        this.team_options = v;
      }
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow: function showModalWindow(data) {
      var _this = this;

      this.show_modal = true;
      this.titleStyle = data.title_style || "";

      this.$ajax.post("/master_user/load_for_bulk_import/", {}, function (err, data) {
        _this.localUserList = data;
      });
    },
    closed: function closed(mode) {
      if (typeof mode != "undefined") {
        console.log("mode", mode);
        this.show_modal = false;
        this.$emit('done', mode);
      }
    },
    onDeviceEmbeddedInformationAddCheckConfirm: function onDeviceEmbeddedInformationAddCheckConfirm() {
      this.read_only = false;
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddCheck", {
        title: "",
        message: "機器・組込情報の申請が完了しました。",
        yes_label: "",
        no_label: "戻る",
        yes_color: "",
        no_color: "default",
        model_height: "50"
      }), this.$router.push({
        name: "page_0010_device_embedded_information"
      });
    }
  },
  props: {
    tag: { type: String, default: "showBulkImportConfimationModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);










var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()("esma:device_embedded_detail");








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_12__local_modal___default.a);


var debug_file = __WEBPACK_IMPORTED_MODULE_6_debug___default()("esma:file-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__["AgGridVue"],
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "device_embedded_detail",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.generic,
      detail_page: "page_0015_device_embedded_information_pegging",
      detail_page_url: "/device_embedded_information_pegging/",
      state_current_editing: "current_editing2",
      state_current_row: "current_row2",
      state_is_editing_new: "is_editing_new2",
      state_last_filter_options: "last_filter_options2",
      temp_certificate_management_number: "",
      local_fk_id: -1,
      show_modal: false,
      device_management_ledger: {},
      overlay_check_delay: 3000
    };
  },

  computed: {
    showModal: {
      get: function get() {
        return this.show_modal;
      },
      set: function set(v) {
        this.show_modal = v;
      }
    },
    readOnly: {
      get: function get() {
        return this.read_only;
      },
      set: function set(v) {
        this.read_only = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_classification, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].department_in_charge, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].responsible_team, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system_name_in_use, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].maker, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].software, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].software_jurisdiction, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].item_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].virtual_id, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].certificate_management_number, {})];
    },
    formFields: function formFields() {
      return {
        col1: [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_classification, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].department_in_charge, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].responsible_team, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system_name_in_use, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].maker, {})],
        col2: [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].software, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].software_jurisdiction, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].item_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].virtual_id, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_device_embedded_detail__["a" /* fields */].certificate_management_number, {})]
      };
    }
  },
  methods: {
    closed: function closed() {
      this.setAsZeroRows();
      this.$emit("close", {});
      this.showModal = false;
    },
    local_extend: function local_extend(field_info, ext) {
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(field_info, ext);
    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirm: function onSubTableDeviceEmbeddedInformationAddCheckConfirm(mode) {
      this.readOnly = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: false, show_checkbox: false });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
      this.commonOnRowSelected(this, ev, this.api_name, function (vm) {});
    },
    localLoadData: function localLoadData(id) {
      this.searchControlChangedDatasource(this.singleSearchCreate("fk_id", "" + id));
    },
    showModalWindow: function showModalWindow(data) {

      this.fkId = data.fk_id;
      this.error_msg = "";
      this.showModal = true;
      this.localLoadData(data.fk_id);
      this.gridOptions.api.sizeColumnsToFit();
    }
  },
  mounted: function mounted() {
    debug_file("On mounted");
    __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$off(this.$props.tag);
  },

  props: {
    ref_id: { type: String, default: "" },

    tag_reload: { type: String, default: "" },
    disable_new_btn: { type: Boolean, default: false },
    disable_edit_btn: { type: Boolean, default: false },
    hide_new_btn: { type: Boolean, default: false },
    hide_edit_btn: { type: Boolean, default: false },
    tag: { type: String, default: "showfileModal" }
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);





var vm = this;







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_device = __WEBPACK_IMPORTED_MODULE_9_debug___default()('esma:device-modal');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "device_embedded_information",
      search_timeout: false,
      search_model: "",
      state_last_filter_options: "last_filter_options3"
    };
  },

  computed: {
    searchModel: {
      get: function get() {
        return this.search_model;
      },
      set: function set(v) {
        this.search_model = v;
      }
    },
    rowData: {
      get: function get() {
        return this.row_data;
      },
      set: function set(v) {
        this.row_data = v;
      }
    },
    selectedData: {
      get: function get() {
        return this.selected_data;
      },
      set: function set(v) {
        this.selected_data = v;
      }
    },

    pageID: function pageID() {
      return this.$props.pageid;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch: function onSearch(txt) {
      var _this = this;

      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(function () {
        _this.searchControlChangedDatasource({
          "1": { block: "1", field: "device_control_number", value: "NOT_EMPTY_VALUE", ct: "v", ca: false, t: "input" },
          "2": txt == "" ? false : { block: "2", field: "device_control_number", value: txt, ct: "v", ca: false, t: "input" },
          "3": false,
          "j1": "AND",
          "j2": "AND",
          "b2_disabled": false,
          "b3_disabled": true
        });
      }, txt == "" ? 0 : 300);
    },
    cancelCurrentSelection: function cancelCurrentSelection() {},
    updateValue: function updateValue(vm, ev, mode) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.device_control_number;
      }
    },
    onShow: function onShow() {
      this.onSearch("");
      this.searchModel = "";
      this.selectedData = false;
      this.$notify({ clean: true });
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
    },
    showModalWindow: function showModalWindow() {
      debug_device("showModalWindow");
      this.onShow();
      this.show_modal = true;
    },
    closed: function closed(mode) {
      var _this2 = this;

      debug_device('mode', mode);
      if (mode == "yes" && this.selectedData) {
        this.$emit("selected", this.selectedData);
        setTimeout(function () {
          _this2.selectedData = "";
          _this2.selectedData = false;
        }, 100);
      } else if (mode == "yes") {
        var last_terminal = false;
        var count_rows = 0;
        this.gridOptions.api.forEachNode(function (node) {
          if (typeof node != "undefined" && typeof node.data != "undefined") {
            if (typeof node.data.seq_id != "undefined") {
              if (count_rows == 0) {
                last_terminal = node.data.device_control_number;
              }
              count_rows++;
            }
          }
        });
        if (count_rows == 1 && last_terminal != false) {
          this.$emit("selected", last_terminal);
        }
      }
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs: function createColumnDefs() {
      return [{
        headerName: '機器管理番号',
        field: 'device_control_number',
        hide: false,
        sort: 'desc',
        width: 392
      }, {
        headerName: 'Seq',
        field: 'seq_id',
        hide: false,
        sort: 'desc',
        width: 392
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: false
      }];
    }
  },
  props: {
    tag: { type: String, default: 'showdeviceModal' },
    pageid: { type: String }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: false,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: function onRowSelected(ev) {
        _this3.updateValue(_this3, ev, 'load_device');
      }
    };
    this.initDatasource({ load_only_with_filter: true });
  },
  mounted: function mounted() {
    debug_device('On mounted');
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);





var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:file-download-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,

      title_label: "title",
      message: "msg",
      yes_label: "",
      no_label: "",
      callback: null,
      show_large: false,
      link_to_open: "#",
      spin_visable: true,
      sub_search: false,
      api_request_options: false
    };
  },

  computed: {
    spinVisable: {
      get: function get() {
        return this.spin_visable;
      },
      set: function set(v) {
        this.spin_visable = v;
      }
    },
    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    showLarge: {
      get: function get() {
        return this.show_large;
      },
      set: function set(v) {
        this.show_large = v;
      }
    },
    getTrue: function getTrue() {
      return true;
    },
    getFalse: function getFalse() {
      return false;
    },
    textTitle: function textTitle() {
      return this.title_label;
    },
    textMessage: function textMessage() {
      return this.message;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    downloadExportFile: function downloadExportFile(key) {
      var _this = this;

      var open_file = this.$refs.open_file;
      open_file.click();
      var orig_msg = this.message;
      this.message = this.on_complete_message;
      this.spinVisable = false;
      setTimeout(function () {
        _this.message = orig_msg;
        _this.closed();
      }, 2000);
    },
    checkExportFile: function checkExportFile(key) {
      var _this2 = this;

      this.$ajax.post("/print_proxy/check/" + key, {}, function (err, data) {
        var status = data.status;

        if (status == "finished") {
          _this2.downloadExportFile(key);
        } else {
          setTimeout(function () {
            _this2.checkExportFile(key);
          }, 1000);
        }
      });
    },
    initExportFile: function initExportFile() {
      var _this3 = this;

      this.spinVisable = true;
      var opt = {
        filter: this.filter,
        sort: this.sort
      };
      if (this.sub_search) {
        opt.sub_search = this.sub_search;
      }
      if (this.api_request_options) {
        opt.api_request_options = this.api_request_options;
      }
      this.$ajax.post(this.url, opt, function (err, data) {
        if (err) {
          _this3.$notify({
            title: 'データの出力に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          var key = data.print_key;
          _this3.linkToOpen = "/api/print_proxy/download/" + key;
          setTimeout(function () {
            _this3.checkExportFile(key);
          }, 1000);
        }
      });
    },
    showModalWindow: function showModalWindow(data) {
      debug_msg("data", data);
      this.title_label = data.title;
      this.message = data.message;
      this.on_complete_message = data.on_complete_message || data.message;
      this.filter = data.filter;
      this.sort = data.sort;
      this.url = data.url;
      this.show_modal = true;
      if (data.api_request_options) {
        this.api_request_options = data.api_request_options;
      }
      if (data.sub_search) {
        this.sub_search = data.sub_search;
      }

      this.initExportFile();
    },
    closed: function closed(mode) {
      this.$emit("close", {});
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "runDownloadModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pdf__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_pdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_input_modal2__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_input_modal2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_input_modal2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_debug__);








var vm = this;







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_5__local_modal___default.a);


var debug_file = __WEBPACK_IMPORTED_MODULE_11_debug___default()("esma:file-modal");
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */]],
  components: {
    "input-modal2": __WEBPACK_IMPORTED_MODULE_8__components_modals_input_modal2___default.a,
    pdf: __WEBPACK_IMPORTED_MODULE_4_vue_pdf___default.a
  },
  data: function data() {
    return {
      uploadedImage: "",
      img_name: "",
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "certificate_information",
      search_timeout: false,
      search_model: "",

      process_stage: "idle",
      file_selected_event: false,
      selected_file_name: null,
      error_msg: "",
      uploading: false,
      fk_id: "",
      existing_files: [],
      edit_file_select: false,
      edit_file_select_item: ""
    };
  },

  computed: {
    disableEditonButtons: function disableEditonButtons() {
      var role = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole");
      return role == __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.PERMISSION.CHIEF_ADMINISTRATOR || role == __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.PERMISSION.ADMINISTRATOR;
    },


    editFileSelectItem: {
      get: function get() {
        return this.edit_file_select_item;
      },
      set: function set(v) {
        this.edit_file_select_item = v;
      }
    },
    editFileSelect: {
      get: function get() {
        return this.edit_file_select;
      },
      set: function set(v) {
        this.edit_file_select = v;
      }
    },
    existingFiles: {
      get: function get() {
        return this.existing_files;
      },
      set: function set(v) {
        this.existing_files = v;
      }
    },
    fkId: {
      get: function get() {
        return this.fk_id;
      },
      set: function set(v) {
        this.fk_id = v;
      }
    },
    showModal: {
      get: function get() {
        return this.show_modal;
      },
      set: function set(v) {
        this.show_modal = v;
      }
    },
    processStage: {
      get: function get() {
        return this.process_stage;
      },
      set: function set(v) {
        this.process_stage = v;
      }
    },
    showChoseFile: function showChoseFile() {
      return this.processStage == "idle";
    },
    showUploadFile: function showUploadFile() {
      return this.processStage == "file_selected";
    },
    showCancelUpload: function showCancelUpload() {
      return this.processStage == "file_selected";
    }
  },
  methods: {
    pdfRenderError: function pdfRenderError(err) {
      console.log("pdfRenderError", err);
    },
    renameFileConfirmed: function renameFileConfirmed(result) {
      var _this = this;

      if (result.mode == "yes") {
        if (result.value.length > 0 && result.value != this.editFileSelectItem.display_file_name) {
          this.$ajax.post("/file_upload/set/" + this.editFileSelectItem.seq_id, {
            changes: {
              display_file_name: result.value
            }
          }, function (err, result) {
            if (err) {
              _this.$notify({
                title: "名称変更に失敗しました。",
                message: err,
                type: 'error',
                duration: 10000
              });
            } else {
              _this.editFileSelect = false;
              _this.loadData();
              _this.$notify({
                title: "ファイルの名称が変更されました。",
                type: 'success',
                duration: 3000
              });
            }
          });
        }
      }
    },
    renameFile: function renameFile() {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("inputFileRename", {
        title: "名称変更",
        initial_value: this.editFileSelectItem.display_file_name
      });
    },
    deleteFile: function deleteFile() {
      console.log("Delete the file " + this.editFileSelectItem.display_file_name + "？");

      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("confirmToDeleteFile", {
        message: "" + this.editFileSelectItem.display_file_name + "を削除しますか？ ",
        title: "削除",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "primary",
        no_color: "info",
        model_height: "50"
      });
    },
    deleteFileConfirmed: function deleteFileConfirmed(mode) {
      var _this2 = this;

      if (mode == "yes") {
        this.$ajax.post("/file_upload/delete/", {
          seq_id: this.editFileSelectItem.seq_id,
          seq_id_match3: this.editFileSelectItem.seq_id * 3
        }, function (err, result) {
          if (err) {
            _this2.$notify({
              title: "ファイルの削除に失敗しました。",
              type: 'error',
              duration: 10000
            });
          } else {
            _this2.loadData();
            _this2.$notify({
              title: "ファイルが削除されました。",
              type: 'success',
              duration: 3000
            });
            _this2.editFileSelect = false;
          }
        });
      }
    },
    openFile: function openFile() {
      var selected_file = this.$refs.selected_file;
      selected_file.click();
    },
    editAndOpenFile: function editAndOpenFile(file) {
      var _this3 = this;

      this.editFile(file);
      setTimeout(function () {
        _this3.openFile();
      }, 50);
    },
    editFile: function editFile(file) {
      this.editFileSelectItem = file;
      this.editFileSelect = true;
    },
    loadData: function loadData() {
      var _this4 = this;

      var obj = {
        filter: {
          1: {
            block: "1",
            field: "fk_id",
            value: this.fkId + "",
            ct: "v",
            ca: false,
            t: "input",
            exact_value: true
          },
          2: {
            block: "2",
            field: "fk_tab",
            value: __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.CERTIFICATE + "",
            ct: "v",
            ca: false,
            t: "input",
            exact_value: true
          },
          3: false,
          j1: "AND",
          j2: "AND",
          b2_disabled: false,
          b3_disabled: false
        }
      };
      this.$ajax.post("/file_upload/datasource_load/0/1000", obj, function (err, result) {
        if (err == null) {
          _this4.existingFiles = result;
        } else {
          _this4.existingFiles = [];
          _this4.error_msg = err;
        }
      });
    },
    fileSelected: function fileSelected(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      this.processStage = "file_selected";
      this.file_selected_event = e;
      this.selected_file_name = files[0].name;
    },
    choseFile: function choseFile() {
      this.editFileSelect = false;
      var pdf_file = this.$refs.pdf_file;
      pdf_file.click();
    },
    fileClicked: function fileClicked(e) {
      var pdf_file = this.$refs.pdf_file;
      pdf_file.value = null;
    },
    closed: function closed(mode) {
      this.$emit("close", { mode: mode, qty: this.existingFiles ? this.existingFiles.length : 0 });
      this.showModal = false;
    },
    showModalWindow: function showModalWindow(data) {
      this.fkId = data.fk_id;
      this.error_msg = "";
      this.showModal = true;
      this.loadData();
    },
    uploadFile: function uploadFile(options) {
      var _this5 = this;

      this.error_msg = "";
      this.processStage = "uploading";
      this.uploading = true;
      var files = this.file_selected_event.target.files;
      if (!files[0]) {
        return;
      }
      var form_data = new FormData();
      form_data.append("pdf", files[0]);
      form_data.append("fk_id", this.fkId);
      form_data.append("fk_tab", __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.CERTIFICATE);
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.$ajax.serverUrl + "/file_upload/pdf_upload/", form_data, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(function (response) {
        var data = response.data;
        if (response.data.success == true) {
          _this5.uploading = false;
          _this5.loadData();
          return _this5.processStage = "idle";
        } else {
          _this5.uploading = false;
          try {
            _this5.error_msg = "エラー ：" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.error).replace(/"/g, "") + "";
          } catch (error) {
            _this5.error_msg = "エラー ：" + response.data.error + "";
          }

          _this5.processStage = "preview_error";
          _this5.file_selected_event = null;
          _this5.selected_file_name = null;
          _this5.uploading = false;
        }
      }).catch(function (error) {
        _this5.error_msg = "エラー ：：： (" + error + ")";

        _this5.processStage = "preview_error";
        _this5.file_selected_event = null;
        _this5.selected_file_name = null;
        _this5.uploading = false;
      });
    },
    cancelUpload: function cancelUpload() {
      this.selected_file_name = null;
      this.file_selected_event = null;
      this.processStage = "idle";
    }
  },
  props: {
    tag: { type: String, default: "showfileModal" }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    debug_file("On mounted");
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);





var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:information-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,

      icon: "",
      message: "",
      yes_label: "",
      callback: null,
      show_large: false
    };
  },

  computed: {
    showLarge: {
      get: function get() {
        return this.show_large;
      },
      set: function set(v) {
        this.show_large = v;
      }
    },
    getTrue: function getTrue() {
      return true;
    },
    getFalse: function getFalse() {
      return false;
    },
    getIcon: function getIcon() {
      return this.icon || "glyphicon glyphicon-ok";
    },
    textYes: function textYes() {
      return this.yes_label || "完了";
    },
    textMessage: function textMessage() {
      return this.message;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow: function showModalWindow(data) {
      debug_msg("data", data);
      this.showLarge = data.large;
      this.icon = data.icon;
      this.yes_label = data.yes_label || "OK";
      this.yes_color = data.yes_color || "primary";
      this.message = data.message;
      this.show_modal = true;
    },
    closed: function closed(mode) {
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showInformationIconModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);





var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:information-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,

      title_label: "",
      message: "",
      yes_label: "",
      no_label: "",
      callback: null,
      show_large: false
    };
  },

  computed: {
    showLarge: {
      get: function get() {
        return this.show_large;
      },
      set: function set(v) {
        this.show_large = v;
      }
    },
    getTrue: function getTrue() {
      return true;
    },
    getFalse: function getFalse() {
      return false;
    },
    textTitle: function textTitle() {
      return this.title_label;
    },
    textYes: function textYes() {
      return this.yes_label || "完了";
    },
    textMessage: function textMessage() {
      return this.message;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow: function showModalWindow(data) {
      debug_msg("data", data);
      this.showLarge = data.large;
      this.title_label = data.title;
      this.yes_label = data.yes_label || null;
      this.message = data.message;
      this.show_modal = true;
    },
    closed: function closed(mode) {
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showInformationModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);





var vm = this;



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_input_manual = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:input-modal');

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      title_label: '',
      callback: null,
      local_value: ""

    };
  },

  computed: {
    localValue: {
      get: function get() {
        return this.local_value;
      },
      set: function set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },
    pageID: function pageID() {
      return this.$props.pageid;
    },
    textTitle: function textTitle() {
      return this.title_label;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    keyUp: function keyUp(id, value, event) {
      if (event.key == "Enter" || event.keyIdentifier == "Enter") {
        this.closed('yes');
      }
    },
    updateValue: function updateValue(val) {
      this.localValue = val;
      this.$emit('inputed', this.localValue);
    },
    onShow: function onShow() {},
    showModalWindow: function showModalWindow(data) {
      var _this = this;

      debug_input_manual('showModalWindow data', data);
      this.onShow();
      this.title_label = data.title;
      this.localValue = data.initial_value || "";
      this.show_modal = true;
      this.$emit('inputed', this.localValue);
      this.$refs.local_value.focus();
      setTimeout(function () {
        _this.$refs.local_value.focus();
      }, 100);
    },
    closed: function closed(mode) {
      debug_input_manual('mode', mode);
      if (mode == 'yes') {
        this.$emit('inputed', this.localValue);
      }
      this.$emit('closed', this.localValue);
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: 'showInputModal' },
    pageid: { type: String }
  },
  mounted: function mounted() {
    debug_input_manual('On mounted');
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);





var vm = this;



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_input_manual = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:input-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: ""
    };
  },

  computed: {
    localValue: {
      get: function get() {
        return this.local_value;
      },
      set: function set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },
    pageID: function pageID() {
      return this.$props.pageid;
    },
    textTitle: function textTitle() {
      return this.title_label;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    keyUp: function keyUp(id, value, event) {
      if (event.key == "Enter" || event.keyIdentifier == "Enter") {
        this.closed("yes");
      }
    },
    updateValue: function updateValue(val) {
      this.localValue = val;
    },
    onShow: function onShow() {},
    showModalWindow: function showModalWindow(data) {
      var _this = this;

      debug_input_manual("showModalWindow data", data);
      this.onShow();
      this.title_label = data.title;
      this.localValue = data.initial_value || "";
      this.show_modal = true;

      this.$refs.local_value.focus();
      setTimeout(function () {
        _this.$refs.local_value.focus();
      }, 100);
    },
    closed: function closed(mode) {
      debug_input_manual("mode", mode);
      this.$emit("closed", { mode: mode, value: this.localValue });
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showInputModal" },
    pageid: { type: String }
  },
  mounted: function mounted() {
    debug_input_manual("On mounted");
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);





var vm = this;



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_input_manual = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:input-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      min_val: -1,
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: "",
      message_label: "",
      input_prefix: "",
      input_suffix: "",
      yes_label: "Yes",
      no_label: "No",
      yes_style: "",
      no_style: ""
    };
  },

  computed: {
    minVal: {
      get: function get() {
        return this.min_val;
      },
      set: function set(v) {
        this.min_val = v;
      }
    },
    messageLabel: {
      get: function get() {
        return this.message_label;
      },
      set: function set(v) {
        this.message_label = v;
      }
    },
    inputPrefix: {
      get: function get() {
        return this.input_prefix;
      },
      set: function set(v) {
        this.input_prefix = v;
      }
    },
    inputSuffix: {
      get: function get() {
        return this.input_suffix;
      },
      set: function set(v) {
        this.input_suffix = v;
      }
    },
    yesLabel: {
      get: function get() {
        return this.yes_label;
      },
      set: function set(v) {
        this.yes_label = v;
      }
    },
    noLabel: {
      get: function get() {
        return this.no_label;
      },
      set: function set(v) {
        this.no_label = v;
      }
    },
    yesStyle: {
      get: function get() {
        return this.yes_style;
      },
      set: function set(v) {
        this.yes_style = v;
      }
    },
    noStyle: {
      get: function get() {
        return this.no_style;
      },
      set: function set(v) {
        this.no_style = v;
      }
    },
    localValue: {
      get: function get() {
        return this.local_value;
      },
      set: function set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },
    pageID: function pageID() {
      return this.$props.pageid;
    },
    textTitle: function textTitle() {
      return this.title_label;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    keyUp: function keyUp(id, value, event) {
      if (event.key == "Enter" || event.keyIdentifier == "Enter") {
        this.closed("yes");
      }
    },
    updateValue: function updateValue(val) {
      var _this = this;

      this.$notify({ clean: true });
      if (isNaN(val) || this.minVal !== false && parseInt(val) < this.minVal) {
        val = parseInt(val.replace(/[^0-9-.]/g, '') || 0);

        if (val < this.minVal) {
          val = "";
        }
        this.$notify({
          title: (this.minVal || 0) + '以下の数量を登録することはできません。',
          text: "",
          type: 'error',
          duration: 3000
        });
        this.localValue = "";
        setTimeout(function () {
          _this.localValue = val;
        }, 100);
      } else {
        this.localValue = val;
      }
    },
    onShow: function onShow() {},
    showModalWindow: function showModalWindow(data) {
      var _this2 = this;

      debug_input_manual("showModalWindow data", data);
      this.onShow();
      this.minVal = data.min_val || -1;
      this.title_label = data.title;
      this.inputPrefix = data.input_prefix || "";
      this.messageLabel = data.message || "";
      this.inputSuffix = data.input_suffix || "";
      this.yesLabel = data.yes_label;
      this.noLabel = data.no_label;
      this.yesStyle = data.yes_style;
      this.noStyle = data.no_style;

      this.show_modal = true;

      this.$refs.local_value.focus();
      setTimeout(function () {
        _this2.$refs.local_value.focus();
      }, 100);
    },
    closed: function closed(mode) {
      debug_input_manual("mode", mode);
      this.$emit("closed", { mode: mode, value: this.localValue });
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showInputNumberModal" },
    pageid: { type: String }
  },
  mounted: function mounted() {
    debug_input_manual("On mounted");
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);





var vm = this;







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_yobiki = __WEBPACK_IMPORTED_MODULE_9_debug___default()('esma:certificate-list-modal');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      title_label: "",
      api_name: "inventory_unreport_list",

      search_timeout: false,

      subseach: {},
      device_control_number: false,
      state_last_filter_options: "last_filter_options3",
      selected_row: false
    };
  },

  computed: {
    selectedRow: {
      get: function get() {
        return this.selected_row;
      },
      set: function set(v) {
        this.selected_row = v;
      }
    },

    rowData: {
      get: function get() {
        return this.row_data;
      },
      set: function set(v) {
        this.row_data = v;
      }
    },
    selectedData: {
      get: function get() {
        return this.selected_data;
      },
      set: function set(v) {
        this.selected_data = v;
      }
    },

    pageID: function pageID() {
      return this.$props.pageid;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch: function onSearch() {
      var _this = this;

      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(function () {
        _this.searchControlChangedDatasource({
          "1": { block: "1", field: "reporting_period", value: _this.subseach.reporting_period, ct: "v", ca: false, t: "input" },
          "2": { block: "2", field: "company", value: _this.subseach.company, ct: "v", ca: false, t: "input" },
          "3": { block: "3", field: "jurisdiction_classification", value: _this.subseach.jurisdiction_classification, ct: "v", ca: false, t: "input" },

          "j1": "AND",
          "j2": "AND",
          "b2_disabled": false,
          "b3_disabled": true
        });
      }, false ? 0 : 300);
    },
    showModalWindow: function showModalWindow(data) {
      this.title_label = data.title;
      this.subseach = data.send_subsearch;
      this.show_modal = true;
      this.onSearch("");
    },
    closed: function closed(mode) {
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs: function createColumnDefs() {
      return [{
        headerName: '状態',
        field: 'approval_status',
        hide: false,
        sort: 'desc',

        width: 50
      }, {
        headerName: '会社',
        field: 'company',
        hide: false,
        width: 160
      }, {
        headerName: '部署',
        field: 'department_in_charge',
        hide: false,
        width: 215
      }, {
        headerName: 'チーム',
        field: 'team_in_charge',
        hide: false,
        width: 310
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: false
      }];
    }
  },
  props: {
    tag: { type: String, default: 'showCertificateListModal' },
    pageid: { type: String }
  },
  beforeMount: function beforeMount() {
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      enableColResize: false,
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: function onRowSelected(ev) {}
    };

    this.initDatasource({});
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);





var vm = this;







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_yobiki = __WEBPACK_IMPORTED_MODULE_9_debug___default()('esma:certificate-list-modal');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      title_label: "",
      api_name: "inventory_unreport_list",

      search_timeout: false,

      subseach: {},
      device_control_number: false,
      state_last_filter_options: "last_filter_options3",
      selected_row: false
    };
  },

  computed: {
    selectedRow: {
      get: function get() {
        return this.selected_row;
      },
      set: function set(v) {
        this.selected_row = v;
      }
    },

    rowData: {
      get: function get() {
        return this.row_data;
      },
      set: function set(v) {
        this.row_data = v;
      }
    },
    selectedData: {
      get: function get() {
        return this.selected_data;
      },
      set: function set(v) {
        this.selected_data = v;
      }
    },

    pageID: function pageID() {
      return this.$props.pageid;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch: function onSearch() {
      var _this = this;

      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(function () {
        _this.searchControlChangedDatasource({
          "1": { block: "1", field: "reporting_period", value: _this.subseach.reporting_period, ct: "v", ca: false, t: "input" },
          "2": { block: "2", field: "company", value: _this.subseach.company, ct: "v", ca: false, t: "input" },
          "3": { block: "3", field: "jurisdiction_classification", value: _this.subseach.jurisdiction_classification, ct: "v", ca: false, t: "input" },

          "j1": "AND",
          "j2": "AND",
          "b2_disabled": false,
          "b3_disabled": true
        });
      }, false ? 0 : 300);
    },
    showModalWindow: function showModalWindow(data) {
      this.title_label = data.title;
      this.subseach = data.send_subsearch;
      this.show_modal = true;
      this.onSearch("");
    },
    closed: function closed(mode) {
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs: function createColumnDefs() {
      return [{
        headerName: '状態',
        field: 'approval_status',
        hide: false,
        sort: 'desc',

        width: 50
      }, {
        headerName: 'システム',
        field: 'reporting_system',
        hide: false,
        width: 360
      }, {
        headerName: '部署',
        field: 'department_in_charge',
        hide: false,
        width: 325
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: false
      }];
    }
  },
  props: {
    tag: { type: String, default: 'showCertificateListModal' },
    pageid: { type: String }
  },
  beforeMount: function beforeMount() {
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      enableColResize: false,
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: function onRowSelected(ev) {}
    };

    this.initDatasource({});
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);



var getScrollBarWidth = function getScrollBarWidth() {
  if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
    return 0;
  }
  var inner = document.createElement('p');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  outer.style.position = 'absolute';
  outer.style.top = '0px';
  outer.style.left = '0px';
  outer.style.visibility = 'hidden';
  outer.style.width = '200px';
  outer.style.height = '150px';
  outer.style.overflow = 'hidden';
  outer.appendChild(inner);

  document.body.appendChild(outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 === w2) w2 = outer.clientWidth;

  document.body.removeChild(outer);

  return w1 - w2;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    backdrop: { type: Boolean, default: true },
    callback: { type: Function, default: null },
    cancelText: { type: String, default: 'Close' },
    effect: { type: String, default: null },
    large: { type: Boolean, default: false },
    okText: { type: String, default: 'Save changes' },
    small: { type: Boolean, default: false },
    title: { type: String, default: '' },
    value: { type: Boolean, required: true },
    width: { default: null },
    height: { default: null },
    content_height: { default: null },
    body_height: { default: null }
  },
  data: function data() {
    return {
      transition: false,
      val: null
    };
  },

  computed: {
    optionalBodyHeight: function optionalBodyHeight() {
      if (this.body_height === null) {
        return null;
      } else if (this.body_height.indexOf("%") > 0) {
        return this.body_height;
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.body_height)) {
        return this.body_height + 'px';
      }
      return this.body_height;
    },
    optionalContentHeight: function optionalContentHeight() {
      if (this.content_height === null) {
        return null;
      } else if (this.content_height.indexOf("%") > 0) {
        return this.content_height;
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.content_height)) {
        return this.content_height + 'px';
      }
      return this.content_height;
    },
    optionalHeight: function optionalHeight() {
      if (this.height === null) {
        return null;
      } else if (this.height.indexOf("%") > 0) {
        return this.height;
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.height)) {
        return this.height + 'px';
      }
      return this.height;
    },
    optionalWidth: function optionalWidth() {
      if (this.width === null) {
        return null;
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.width)) {
        return this.width + 'px';
      }
      return this.width;
    }
  },
  watch: {
    transition: function transition(val, old) {
      if (val === old) {
        return;
      }
      var el = this.$el;
      var body = document.body;
      if (val) {
        if (this.val) {
          el.querySelector('.modal-content').focus();
          el.style.display = 'block';
          setTimeout(function () {
            return el.classList.add('in');
          }, 0);
          body.classList.add('modal-open');
          if (getScrollBarWidth() !== 0) {
            body.style.paddingRight = getScrollBarWidth() + 'px';
          }
        } else {
          el.classList.remove('in');
        }
      } else {
        this.$emit(this.val ? 'opened' : 'closed');
        if (!this.val) {
          el.style.display = 'none';
          body.style.paddingRight = null;
          body.classList.remove('modal-open');
        }
      }
    },
    val: function val(_val, old) {
      this.$emit('input', _val);
      if (old === null ? _val === true : _val !== old) this.transition = true;
    },
    value: function value(val, old) {
      if (val !== old) this.val = val;
    }
  },
  methods: {
    action: function action(val, p) {
      if (val === null) {
        return;
      }
      if (val && this.callback instanceof Function) this.callback();
      this.$emit(val ? 'ok' : 'cancel', p);
      this.val = val || false;
    }
  },
  mounted: function mounted() {
    this.val = this.value;
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_debug__);





var vm = this;








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_log_history = __WEBPACK_IMPORTED_MODULE_10_debug___default()('esma:log_history');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "log_history",
      search_timeout: false,
      search_model: ""
    };
  },

  computed: {
    searchModel: {
      get: function get() {
        return this.search_model;
      },
      set: function set(v) {
        this.search_model = v;
      }
    },
    rowData: {
      get: function get() {
        return this.row_data;
      },
      set: function set(v) {
        this.row_data = v;
      }
    },
    selectedData: {
      get: function get() {
        return this.selected_data;
      },
      set: function set(v) {
        this.selected_data = v;
      }
    },

    pageID: function pageID() {
      return this.$props.pageid;
    },
    showModal: function showModal() {
      return this.show_modal;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__["a" /* fields */].change_time, { type: __WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__["b" /* filed_types */].CURRENT_TIME }), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__["a" /* fields */].user_shimei, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__["a" /* fields */].log_tab, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__["a" /* fields */].field_name, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__["a" /* fields */].value_before, {}), __WEBPACK_IMPORTED_MODULE_2__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_8__rules_fields_log_history__["a" /* fields */].value_after, {})];
    }
  },
  methods: {
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: false, show_checkbox: false });
    },
    onSearch: function onSearch(txt, data) {
      var fk_id = data.fk_id;
      var fk_tab = data.fk_tab;
      this.searchControlChangedDatasource({
        "1": { block: "1", field: "fk_tab", value: "" + fk_tab, ct: "v", ca: false, t: "input", exact_value: true },
        "2": { block: "2", field: "fk_id", value: "" + fk_id, ct: "v", ca: false, t: "input", exact_value: true },
        "3": false,
        "j1": "AND",
        "j2": "AND",
        "b2_disabled": false,
        "b3_disabled": true
      });
    },
    cancelCurrentSelection: function cancelCurrentSelection() {},
    updateValue: function updateValue(vm, ev, mode) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.number_cert;
      }
    },
    onShow: function onShow(data) {
      var _this = this;

      this.searchModel = "";
      this.selectedData = false;
      this.$notify({ clean: true });
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
      this.onSearch("", data);
      setTimeout(function () {
        _this.gridOptions.api.sizeColumnsToFit();
      }, 500);
      setTimeout(function () {
        _this.gridOptions.api.sizeColumnsToFit();
      }, 1000);
      setTimeout(function () {
        _this.gridOptions.api.sizeColumnsToFit();
      }, 3000);
    },
    showModalWindow: function showModalWindow(data) {
      debug_log_history("showModalWindow");
      this.onShow(data);
      this.show_modal = true;
    },
    closed: function closed(mode) {
      this.show_modal = false;
      this.$emit('done', mode);
    }
  },
  props: {
    tag: { type: String, default: 'showLogHistory' },
    pageid: { type: String },
    fk_tab: { type: String },
    fk_id: { type: String }
  },
  beforeMount: function beforeMount() {
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true });
  },
  mounted: function mounted() {
    debug_log_history('On mounted');
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_md5__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_fields_notice__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_constants__);









var vm = this;


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_8__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_9_debug___default()("esma:notice-modal");
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,
      callback: null,
      api_name: "notice",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.generic,
      list_of_notices: [],

      login_expire_days: 9999,
      certificate_that_expires_in_3_months: "^",
      certificate_expired_license: "^",
      application_approval_pending: "^",
      application_approval_rejection: "^",
      bulk_import_pending: "^",
      bulk_import_rejection: "^",
      surplus_license_that_expires_in_3_months: "^",
      surplus_expired_license: "^",
      pw_approval_history: "^",
      schedule_interval: false
    };
  },

  computed: {
    isMultiCompanyAdmin: function isMultiCompanyAdmin() {
      var role = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole");
      return role == "保守担当" || role == "システム管理者";
    },
    isUserIDOperationInCharge: function isUserIDOperationInCharge() {
      var role = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole");
      return role == "ユーザIDオペレーション担当者";
    },

    pwApprovalHistory: {
      get: function get() {
        return this.pw_approval_history;
      },
      set: function set(v) {
        this.pw_approval_history = v;
      }
    },
    certificateThatExpiresIn3Months: {
      get: function get() {
        return this.certificate_that_expires_in_3_months;
      },
      set: function set(v) {
        this.certificate_that_expires_in_3_months = v;
      }
    },
    certificateExpiredLicense: {
      get: function get() {
        return this.certificate_expired_license;
      },
      set: function set(v) {
        this.certificate_expired_license = v;
      }
    },
    applicationApprovalPending: {
      get: function get() {
        return this.application_approval_pending;
      },
      set: function set(v) {
        this.application_approval_pending = v;
      }
    },
    applicationApprovalRejection: {
      get: function get() {
        return this.application_approval_rejection;
      },
      set: function set(v) {
        this.application_approval_rejection = v;
      }
    },
    bulkImportPending: {
      get: function get() {
        return this.bulk_import_pending;
      },
      set: function set(v) {
        this.bulk_import_pending = v;
      }
    },
    bulkImportRejection: {
      get: function get() {
        return this.bulk_import_rejection;
      },
      set: function set(v) {
        this.bulk_import_rejection = v;
      }
    },
    surplusLicenseThatExpiresIn3Months: {
      get: function get() {
        return this.surplus_license_that_expires_in_3_months;
      },
      set: function set(v) {
        this.surplus_license_that_expires_in_3_months = v;
      }
    },
    surplusExpiredLicense: {
      get: function get() {
        return this.surplus_expired_license;
      },
      set: function set(v) {
        this.surplus_expired_license = v;
      }
    },
    loginExpireDays: {
      get: function get() {
        return this.login_expire_days;
      },
      set: function set(v) {
        this.login_expire_days = v;
      }
    },
    listOfNotices: {
      get: function get() {
        return this.list_of_notices;
      },
      set: function set(v) {
        this.list_of_notices = v;
      }
    },
    showModal: {
      get: function get() {
        return this.show_modal;
      },
      set: function set(v) {
        this.show_modal = v;
      }
    }
  },
  methods: {
    processImportance: function processImportance(i) {
      if (i == null || (i + "").trim() == "") {
        return "";
      }
      var ret = "";
      var found = _.find(__WEBPACK_IMPORTED_MODULE_6__rules_fields_notice__["a" /* fields */].importance.options, function (o) {
        return o.value == i;
      });
      if (found && typeof found != "undefined") {
        if (found.label == "") {
          return "";
        }
        if (found.style && found.style.length > 0) {
          ret += "<span style='" + found.style + "'>" + found.label + "<span>";
        } else {
          ret += "<span>" + found.label + "<span>";
        }
      } else {
        ret += "<span>" + i + "<span>";
      }
      return ret;
    },
    processnToUserShimei: function processnToUserShimei(data) {
      if (data.to_company == __WEBPACK_IMPORTED_MODULE_10__rules_constants___default.a.COMMON.ALL_USERS_VALUE) {
        return __WEBPACK_IMPORTED_MODULE_10__rules_constants___default.a.COMMON.ALL_USERS_LABEL;
      } else if (data.to_team && data.to_team.length > 0) {
        return data.to_company + " " + data.to_department + " " + data.to_team;
      } else if (data.to_department && data.to_department.length > 0) {
        return data.to_company + " " + data.to_department;
      } else if (data.to_company && data.to_company.length > 0) {
        return data.to_company;
      }
    },
    showNoticeData: function showNoticeData(counter_data, message_data) {
      var _this = this;

      var show_the_modal = true;
      if (message_data && typeof message_data != "undefined" && Array.isArray(message_data) && message_data.length > 0) {
        message_data.forEach(function (r) {
          r.message = r.message.replace(/\n/g, "<br>");
        });

        this.listOfNotices = _.filter(message_data, function (d) {
          return d.message_schedule == null || __WEBPACK_IMPORTED_MODULE_2_moment___default()(d.message_schedule).diff(new Date(), "seconds") <= 0;
        });
        var hash = __WEBPACK_IMPORTED_MODULE_3_md5___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listOfNotices));
        if (window.sessionStorage.getItem('last_show_notification_hash') == hash) {
          show_the_modal = false;
        }
        window.sessionStorage.setItem('last_show_notification_hash', hash);

        var noticies_for_schedule = _.filter(message_data, function (d) {
          return d.message_schedule != null && __WEBPACK_IMPORTED_MODULE_2_moment___default()(d.message_schedule).diff(new Date(), "seconds") > 0;
        });
        if (Array.isArray(noticies_for_schedule) && noticies_for_schedule.length > 0) {
          var arr = [];
          message_data.forEach(function (e) {
            if (e.message_schedule && new Date(e.message_schedule).getTime() > new Date().getTime()) {
              arr.push(e.message_schedule);
            }
          });
          if (arr.length > 0) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("noticiesForSchedule", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr.sort()));
            setTimeout(function () {
              _this.checkNoticiesForSchedule(_this);
            }, 1000);
          } else {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("noticiesForSchedule", false);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("noticiesForSchedule", false);
        }

        if (isNaN(this.loginExpireDays) == false && parseInt(this.loginExpireDays) < 31) {
          show_the_modal = true;
        } else if (Array(this.listOfNotices) && this.listOfNotices.length > 0) {
          this.showModal = show_the_modal == true;
        } else {
          show_the_modal = false;
        }
      } else {
        this.showModal = false;
      }
      this.certificateThatExpiresIn3Months = counter_data.all_counters.certificate_that_expires_in_3_months;
      this.certificateExpiredLicense = counter_data.all_counters.certificate_expired_license;
      this.applicationApprovalPending = counter_data.all_counters.application_approval_pending;
      this.applicationApprovalRejection = counter_data.all_counters.application_approval_rejection;
      this.bulkImportPending = counter_data.all_counters.bulk_import_pending;
      this.bulkImportRejection = counter_data.all_counters.bulk_import_rejection;
      this.surplusLicenseThatExpiresIn3Months = counter_data.all_counters.surplus_license_that_expires_in_3_months;
      this.surplusExpiredLicense = counter_data.all_counters.surplus_expired_license;
      this.pwApprovalHistory = counter_data.all_counters.pw_approval_history || false;
      if (isNaN(this.loginExpireDays) == false && parseInt(this.loginExpireDays) < 31) {
        this.showModal = show_the_modal == true;
      } else if (Array(this.listOfNotices) && this.listOfNotices.length > 0) {
        this.showModal = show_the_modal == true;
      } else {
        this.showModal = false;
      }
      this.$store.state.show_message_after_login = false;
    },
    loadAllCounters: function loadAllCounters(cb) {
      this.$ajax.post('/common/load_menu_counters/', {}, function (err, result) {
        cb(err, result);
      });
    },
    processNoticeModalSchedule: function processNoticeModalSchedule() {
      var _this2 = this;

      if (localStorage.forceHideMessages == 1) {
        console.log("DO NOT SHOW MESSAGE MODAL DUE forceHideMessages flag");
        return;
      }
      this.loadAllCounters(function (err, all_counter_data) {
        _this2.$ajax.post("/" + _this2.api_name + "/get_list/", {}, function (err, message_data) {
          console.log(err, message_data);
          _this2.showNoticeData({ all_counters: all_counter_data }, message_data);
        });
      });
    },
    processNoticeModal: function processNoticeModal(data) {
      var _this3 = this;

      if (localStorage.forceHideMessages == 1) {
        console.log("DO NOT SHOW MESSAGE MODAL DUE forceHideMessages flag");
        return;
      }
      debug_msg("processNoticeModal");
      this.$ajax.post("/" + this.api_name + "/get_list/", {}, function (err, result) {
        var hash = __WEBPACK_IMPORTED_MODULE_3_md5___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
        if (window.sessionStorage.getItem('last_notification_hash') != hash) {
          _this3.$store.state.show_message_after_login = true;
        }
        window.sessionStorage.setItem('last_notification_hash', hash);
        if (_this3.$store.state.show_message_after_login == false) {
          return;
        }

        _this3.showNoticeData(data, result);
      });
    },
    closed: function closed(mode) {
      this.showModal = false;
    },
    checkNoticiesForSchedule: function checkNoticiesForSchedule(vm) {
      var noticiesForSchedule = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("noticiesForSchedule");
      if (noticiesForSchedule && noticiesForSchedule.length > 8) {
        noticiesForSchedule = JSON.parse(noticiesForSchedule);
        if (vm.schedule_interval == false) {
          vm.schedule_interval = [];
        } else if (Array.isArray(vm.schedule_interval) && vm.schedule_interval.length > 0) {
          vm.schedule_interval.forEach(function (cancel_time) {
            clearTimeout(cancel_time);
          });
          vm.schedule_interval = [];
        }
        noticiesForSchedule.forEach(function (time) {
          var wait_seconds = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).diff(new Date(), "seconds");
          if (wait_seconds > 0) {
            console.log('Setup timer for', time, 'in', wait_seconds, 'seconds');
            vm.scheduler_is_listening = true;
            vm.schedule_interval.push(setTimeout(function () {
              window.sessionStorage.setItem('alert_for_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).format("YYYYMMDDHHmmss"), "done");
              vm.processNoticeModalSchedule();
            }, wait_seconds * 1000));
          } else {
            if (window.sessionStorage.getItem('alert_for_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).format("YYYYMMDDHHmmss")) != "done") {
              vm.processNoticeModalSchedule();
            }
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.$props.tag != "no") {
      __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$on(this.$props.tag, this.processNoticeModal);
    }
    if (this.$props.stag != "no") {
      __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$on(this.$props.stag, this.processNoticeModalSchedule);
    }
    var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).format("YYYY/MM/DD");
    var passwordExpireDate = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("passwordExpireDate") || new Date();
    this.loginExpireDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(passwordExpireDate).diff(today, 'days');

    this.checkNoticiesForSchedule(this);
  },
  beforeDestroy: function beforeDestroy() {
    if (Array.isArray(this.schedule_interval) && this.schedule_interval.length > 0) {
      this.schedule_interval.forEach(function (time) {
        clearTimeout(time);
      });
      this.schedule_interval = [];
    }
    if (this.$props.tag != "no") {
      __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$off(this.$props.tag);
    }
    if (this.$props.stag != "no") {
      __WEBPACK_IMPORTED_MODULE_4__libs_bus__["a" /* bus */].$off(this.$props.stag);
    }
  },

  props: {
    tag: { type: String, default: "no" },
    stag: { type: String, default: "no" }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);





var vm = this;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("modal", __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_msg = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:confirmation-modal2");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show_modal: false,

      title_label: "",
      message: "",

      callback: null
    };
  },

  computed: {
    getTrue: function getTrue() {
      return true;
    },
    getFalse: function getFalse() {
      return false;
    },
    textTitle: function textTitle() {
      return this.title_label;
    },
    textMessage: function textMessage() {
      return this.message;
    },

    showModal: {
      get: function get() {
        return this.show_modal;
      },
      set: function set(v) {
        this.show_modal = v;
      }
    }
  },
  methods: {
    showModalWindow: function showModalWindow(data) {
      debug_msg("data", data);
      this.title_label = data.title;
      this.message = data.message;

      this.showModal = true;
    },
    hideModalWindow: function hideModalWindow() {
      this.showModal = false;
    },
    closed: function closed(mode) {
      console.log("mode", mode);
      this.showModal = false;
    }
  },
  props: {
    tag: { type: String, default: "showProgressModal" },
    hide_tag: { type: String, default: "hideProgressModal" }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.hide_tag, this.hideModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.hide_tag);
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_output_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_output_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);





var vm = this;







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_3__local_modal___default.a);


var debug_yobiki = __WEBPACK_IMPORTED_MODULE_9_debug___default()('esma:yobiki-modal');
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "certificate_software",
      search_timeout: false,
      search_model: "",
      device_control_number: false,
      state_last_filter_options: "last_filter_options3",
      selected_row: false,
      software_jurisdiction: false,
      pre_load_when_open: false

    };
  },

  computed: {
    preLoadWhenOpen: {
      get: function get() {
        return this.pre_load_when_open;
      },
      set: function set(v) {
        this.pre_load_when_open = v;
      }
    },
    selectedRow: {
      get: function get() {
        return this.selected_row;
      },
      set: function set(v) {
        this.selected_row = v;
      }
    },
    searchModel: {
      get: function get() {
        return this.search_model;
      },
      set: function set(v) {
        this.search_model = v;
      }
    },
    rowData: {
      get: function get() {
        return this.row_data;
      },
      set: function set(v) {
        this.row_data = v;
      }
    },
    selectedData: {
      get: function get() {
        return this.selected_data;
      },
      set: function set(v) {
        this.selected_data = v;
      }
    },

    pageID: function pageID() {
      return this.$props.pageid;
    },
    showModal: function showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch: function onSearch(txt) {
      var _this = this;

      if (this.preLoadWhenOpen == false && (txt || "").length == 0) {
        this.setManualCountRows(0);
        return;
      }
      this.api_request_options = { filter_mode: "yobiki", software_jurisdiction: this.software_jurisdiction };

      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(function () {
        var b2 = txt == "" ? false : { block: "2", field: "certificate_software_number", value: txt, ct: "v", ca: false, t: "input" };
        if (_this.software_jurisdiction == "他部署所管" && _this.isMultiCompanyAdmin != true) {
          console.log('TEST DEBUG 210615 (129 at yobiki-modal.vue)[19:48]: ', { b2: b2, index: b2.value.indexOf("-") });
          if (b2 && b2.value && b2.value.indexOf("-") < 0) {
            b2.value = b2.value + "-";
          }
          b2.starting_with = true;
        }
        var b3 = typeof _this.company == "undefined" || _this.company == false || _this.company.length == 0 ? false : { block: "3", field: "company", value: _this.company, ct: "v", ca: false, t: "select" };
        if (b2 == false) {
          b2 = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.clone(b3);
          b3 = false;
        }
        _this.searchControlChangedDatasource({
          "1": { block: "1", field: "certificate_software_number", value: "NOT_EMPTY_VALUE", ct: "v", ca: false, t: "input" },
          "2": b2,
          "3": b3,
          "j1": "AND",
          "j2": "AND",
          "b2_disabled": false,
          "b3_disabled": true
        });
      }, txt == "" ? 0 : 300);
    },
    cancelCurrentSelection: function cancelCurrentSelection() {},
    updateValue: function updateValue(vm, ev, mode) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.certificate_software_number;
        this.selectedRow = ev.node.data;
      }
    },
    onShow: function onShow() {
      this.company = this.$store.state[this.stateCurrentEditing].company || this.$store.state[this.stateCurrentRow].company || false;

      if (this.preLoadWhenOpen == true) {
        this.onSearch("");
        this.searchModel = "";
      } else {
        this.setManualCountRows(0);
      }
      this.selectedData = false;
      this.selectedRow = false;
      this.$notify({ clean: true });
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
    },
    showModalWindow: function showModalWindow(data) {

      debug_yobiki("showModalWindow");
      this.software_jurisdiction = data.software_jurisdiction;
      this.preLoadWhenOpen = this.isMultiCompanyAdmin == true || this.software_jurisdiction == "当該部署所管";
      this.show_modal = true;
      this.device_control_number = data && data.device_control_number && data.device_control_number.length > 0 ? data.device_control_number : false;
      this.onShow();
    },
    closed: function closed(mode) {
      var _this2 = this;

      debug_yobiki('mode', mode);
      if (mode == "yes" && this.selectedData) {
        this.$emit("selected", this.selectedData, this.selectedRow);
        setTimeout(function () {
          _this2.selectedData = "";
          _this2.selectedData = false;
          _this2.selectedRow = false;
        }, 100);
      } else if (mode == "yes") {
        var last_terminal = false;
        var last_data = false;
        var count_rows = 0;
        this.gridOptions.api.forEachNode(function (node) {
          if (typeof node != "undefined" && typeof node.data != "undefined") {
            if (typeof node.data.seq_id != "undefined") {
              if (count_rows == 0) {
                last_terminal = node.data.certificate_software_number;
                last_data = node.data;
              }
              count_rows++;
            }
          }
        });
        if (count_rows == 1 && last_terminal != false) {
          this.$emit("selected", last_terminal, last_data);
        }
      }
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs: function createColumnDefs() {
      return [{
        headerName: '証書管理番号',
        field: 'certificate_software_number',
        hide: false,
        sort: 'desc'
      }, {
        headerName: 'ライセンス所管部署',
        field: 'licensed_department',
        hide: false,
        suppressSorting: true
      }, {
        headerName: 'メーカー',
        field: 'maker',
        hide: false,
        sortingOrder: "none",
        sortable: false,
        suppressSorting: true
      }, {
        headerName: 'ソフトウェア名',
        field: 'software_name',
        hide: false,
        suppressSorting: true
      }, {
        headerName: '残数',
        field: 'remaining_number',
        hide: false,
        suppressSorting: true,
        width: 92
      }, {
        headerName: 'Seq',
        field: 'seq_id',
        hide: true
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: true
      }];
    }
  },
  props: {
    tag: { type: String, default: 'showYobikiModal' },
    pageid: { type: String }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    this.gridOptions = {
      defaultColDef: {
        editable: false,
        sortable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: false,
      enableColResize: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: false,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: function onRowSelected(ev) {
        _this3.updateValue(_this3, ev, 'load_yobiki');
      }
    };

    this.api_request_options = { filter_mode: "yobiki" };
    this.initDatasource({ load_only_with_filter: true });
  },
  mounted: function mounted() {
    debug_yobiki('On mounted');
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);





var debug_multiselect = __WEBPACK_IMPORTED_MODULE_2_debug___default()("esma:multi-select");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      gridOptions: [],
      row_data: [],
      data_style: ""
    };
  },

  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__["AgGridVue"]
  },
  computed: {
    getStyle: function getStyle() {
      return this.data_style;
    },
    rowData: function rowData() {
      return this.row_data;
    }
  },
  props: {
    options: { default: [] },
    msstyle: { default: "" },
    busname: { default: false }
  },
  mounted: function mounted() {
    var _this = this;

    this.gridOptions.api.sizeColumnsToFit();
    this.gridOptions.api.forEachNode(function (node) {
      debug_multiselect("Checking", node.data);
      if (typeof node != "undefined" && typeof node.data != "undefined" && node.data.selected == true) {
        _this.gridOptions.api.selectNode(node, true);
      }
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    debug_multiselect("beforeMount");
    if (this.$props.busname != false) {
      debug_multiselect("beforeMount", "listen for", this.$props.busname);
      __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.busname, function (data) {
        debug_multiselect("On new data for ", _this2.$props.busname);
        _this2.row_data = data;
      });
    }

    this.row_data = this.$props.options;
    this.data_style = "min-width:100px;width: 100%; height: 120px;border: 1px solid #ccc;" + this.$props.msstyle;
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.value;
      },
      enableSorting: false,
      enableColResize: false,
      suppressMovableColumns: false,
      rowSelection: "single",
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      headerHeight: 0,

      onRowSelected: function onRowSelected(ev) {
        if (ev.node.isSelected()) {
          debug_multiselect("ev.node", ev.node);
          _this2.$emit("onSelected", {
            selected: ev.node.data.value,
            data: ev.node.data
          });
          debug_multiselect(ev.node.data.value);
        }
      }
    };

    this.gridOptions.columnDefs = [{
      headerName: "Value",
      field: "value",
      hide: true
    }, {
      headerName: "",
      field: "name",
      hide: false
    }];
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fields_input_box_result__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fields_input_box_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_fields_input_box_result__);





var debug_search_control = __WEBPACK_IMPORTED_MODULE_2_debug___default()("esma:report_totals_box");

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "input-box-result": __WEBPACK_IMPORTED_MODULE_3__components_fields_input_box_result___default.a
  },
  data: function data() {
    return {
      data_values: {}
    };
  },

  computed: {
    dataValues: {
      get: function get() {
        return this.data_values;
      },
      set: function set(v) {
        this.data_values = v;
      }
    },
    formFields: function formFields() {
      return {
        col1: [{ name: "reportable_team", label: "報告対象数" }, { name: "number_of_reports", label: "報告数" }, { name: "unreported_number", label: "未報告数" }, { name: "report_rate", label: "報告率" }],
        col2: [{ name: "lack_of_license", label: "①ライセンス購入数の不足" }, { name: "lost_license_certificate", label: "②ライセンス証書の紛失" }, { name: "no_evidence_of_license_receipt", label: "③ライセンス証書の受領形跡無し" }, { name: "other", label: "④その他" }],
        col3: [{ name: "number_of_items_to_be_linked", label: "紐付対象件数" }, { name: "total_number_of_pegging", label: "総紐付数" }, { name: "linking_rate", label: "紐付率" }]
      };
    }
  },
  methods: {
    getVal: function getVal(n) {
      return this.dataValues[n] || 0;
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$on(this.$props.tag, function (data) {
      _this.dataValues = data;
    });
  },
  afterMount: function afterMount() {},
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__libs_bus__["a" /* bus */].$off(this.$props.tag);
  },

  props: {
    tag: { type: String, default: "reportTotalsBox" }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);








var debug_msg = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:information-modal");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      all_company: [],
      all_departments: [],
      val_company: "",
      val_jurisdiction_classification: "",
      val_licensed_department: "",
      val_license_jurisdiction_team: "",
      val_license_jurisdiction_system: "",
      opt_company: [],
      opt_jurisdiction_classification: __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].jurisdiction_classification.options,
      opt_licensed_department: [],
      opt_license_jurisdiction_team: [],
      opt_license_jurisdiction_system: [],
      name_map: {
        company: "company",
        jurisdiction_classification: "jurisdiction_classification",
        license_jurisdiction_system: "license_jurisdiction_system",
        department: "licensed_department",
        team: "license_jurisdiction_team"
      }
    };
  },

  computed: {
    valCompany: {
      get: function get() {
        return this.val_company;
      },
      set: function set(v) {
        this.val_company = v;
      }
    },
    valJurisdictionClassification: {
      get: function get() {
        return this.val_jurisdiction_classification;
      },
      set: function set(v) {
        this.val_jurisdiction_classification = v;
      }
    },
    valDepartment: {
      get: function get() {
        return this.val_licensed_department;
      },
      set: function set(v) {
        this.val_licensed_department = v;
      }
    },
    valTeam: {
      get: function get() {
        return this.val_license_jurisdiction_team;
      },
      set: function set(v) {
        this.val_license_jurisdiction_team = v;
      }
    },
    valJicenseJurisdictionSystem: {
      get: function get() {
        return this.val_license_jurisdiction_system;
      },
      set: function set(v) {
        this.val_license_jurisdiction_system = v;
      }
    },
    optCompany: {
      get: function get() {
        return this.opt_company;
      },
      set: function set(v) {
        this.opt_company = v;
      }
    },
    optJurisdictionClassification: {
      get: function get() {
        return this.opt_jurisdiction_classification;
      },
      set: function set(v) {
        this.opt_jurisdiction_classification = v;
      }
    },
    optDepartment: {
      get: function get() {
        return this.opt_licensed_department;
      },
      set: function set(v) {
        this.opt_licensed_department = v;
      }
    },
    optTeam: {
      get: function get() {
        return this.opt_license_jurisdiction_team;
      },
      set: function set(v) {
        this.opt_license_jurisdiction_team = v;
      }
    },
    optJicenseJurisdictionSystem: {
      get: function get() {
        return this.opt_license_jurisdiction_system;
      },
      set: function set(v) {
        this.opt_license_jurisdiction_system = v;
      }
    },
    localFields: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */];
      },
      set: function set(v) {}
    },
    onlyCompany: function onlyCompany() {
      return this.$props.only_company;
    }
  },
  methods: {
    onSearchValue: function onSearchValue(id, val) {
      var _this = this;

      if (id == "jurisdiction_classification") {
        if (val != "IT所管システム") {
          this.$emit("search", [{ id: this.name_map["jurisdiction_classification"], val: val }, { id: this.name_map["license_jurisdiction_system"], val: "" }]);
        } else {
          this.$emit("search", [{ id: this.name_map["jurisdiction_classification"], val: val }]);
        }
        this.valJicenseJurisdictionSystem = "";
      } else if (id == "company") {
        if (this.onlyCompany) {
          this.$emit("search", { id: this.name_map["company"], val: val });
        } else {
          this.optDepartment = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.all_departments, function (o) {
            return o.company == val;
          }).map(function (m) {
            return m.department;
          }));
          this.optTeam = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.all_departments, function (o) {
            return o.company == val && o.department == _this.valDepartment;
          }).map(function (m) {
            return m.team;
          }));
          this.valDepartment = "";
          this.valTeam = "";
          this.valJurisdictionClassification = "";
          this.valJicenseJurisdictionSystem = "";
          this.$emit("search", [{ id: this.name_map["company"], val: val }, { id: this.name_map["department"], val: "" }, { id: this.name_map["team"], val: "" }, { id: this.name_map["jurisdiction_classification"], val: "" }, { id: this.name_map["license_jurisdiction_system"], val: "" }]);
        }
      } else if (id == "department") {
        this.valTeam = "";
        this.valJurisdictionClassification = "";
        this.valJicenseJurisdictionSystem = "";
        this.$emit("search", [{ id: this.name_map["department"], val: val }, { id: this.name_map["team"], val: "" }, { id: this.name_map["jurisdiction_classification"], val: "" }, { id: this.name_map["license_jurisdiction_system"], val: "" }]);
        this.optTeam = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.all_departments, function (o) {
          return o.company == _this.valCompany && o.department == val;
        }).map(function (m) {
          return m.team;
        }));
      } else if (id == "team") {
        this.valJurisdictionClassification = "";
        this.valJicenseJurisdictionSystem = "";
        this.$emit("search", [{ id: this.name_map[id], val: val }, { id: this.name_map["jurisdiction_classification"], val: "" }, { id: this.name_map["license_jurisdiction_system"], val: "" }]);
      } else if (id == "license_jurisdiction_system") {
        this.$emit("search", [{ id: this.name_map[id], val: val }]);
      }
    }
  },
  props: {
    only_company: { type: Boolean, default: false }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
      _this2.optCompany = _companies.map(function (m) {
        return m.val;
      });

      _this2.$ajax.post_cached_queued("/master_belongs/list_team_and_department", {}, function (err, department_and_team) {
        _this2.all_departments = department_and_team;
        _this2.$ajax.post_cached_queued("/master_system/list_system_name", {}, function (err, list_system_name) {
          _this2.optJicenseJurisdictionSystem = list_system_name.map(function (m) {
            return m.val;
          });

          if (_this2.optCompany.length == 1) {
            setTimeout(function () {
              _this2.valCompany = _this2.optCompany[0];
              _this2.onSearchValue("company", _this2.optCompany[0]);
            }, 200);
          }
        });
      });
    });
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_control_block__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_control_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_search_control_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);





var debug_search_control = __WEBPACK_IMPORTED_MODULE_2_debug___default()('esma:page_common');




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "search-control-block": __WEBPACK_IMPORTED_MODULE_4__components_search_control_block___default.a
  },
  data: function data() {
    return {
      bock_info: { 1: false, 2: false, 3: false, j1: "AND", j2: "AND", b2_disabled: false, b3_disabled: false },
      b1_disabled: false,
      j1_disabled: true,
      b2_disabled: true,
      j2_disabled: true,
      b3_disabled: true,
      j1_enabled_between: false,
      j2_enabled_between: false,
      join_value_1: "AND",
      join_value_2: "AND",
      b1_controller: {},
      b2_controller: {},
      b3_controller: {}

    };
  },


  computed: {
    b1Controller: {
      get: function get() {
        return this.b1_controller;
      },
      set: function set(v) {
        this.b1_controller = v;
      }
    },
    b2Controller: {
      get: function get() {
        return this.b2_controller;
      },
      set: function set(v) {
        this.b2_controller = v;
      }
    },
    b3Controller: {
      get: function get() {
        return this.b3_controller;
      },
      set: function set(v) {
        this.b3_controller = v;
      }
    },
    joinValue1: {
      get: function get() {
        return this.join_value_1;
      },
      set: function set(v) {
        this.join_value_1 = v;
      }
    },
    joinValue2: {
      get: function get() {
        return this.join_value_2;
      },
      set: function set(v) {
        this.join_value_2 = v;
      }
    },
    j1EnabledBetween: {
      get: function get() {
        return this.j1_enabled_between;
      },
      set: function set(v) {
        this.j1_enabled_between = v;
      }
    },
    j2EnabledBetween: {
      get: function get() {
        return this.j2_enabled_between;
      },
      set: function set(v) {
        this.j2_enabled_between = v;
      }
    },
    filedList: function filedList() {
      return this.field_names.map(function (o) {
        return { id: o.id, label: o.label, type: o.type };
      });
    },

    dateFilterOptions: {
      get: function get() {
        return [];
      },
      set: function set(v) {}
    },
    isSingle: function isSingle() {
      return this.single == true;
    }
  },
  methods: {
    clearBarcode: function clearBarcode(ev) {
      ev.preventDefault();
      this.$store.state.search_dependency_groups = {};
      this.$store.state.search_data = {};
      __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onSearchClear", "");
      this.$emit("onSearchClear", "");
      this.joinValue1 = "AND";
      this.joinValue2 = "AND";
    },
    andOr: function andOr(v, id) {
      this.$store.state.search_data[id] = v;
      if (v == "BETWEEN") {
        this.j1EnabledBetween = true;
      }
      if (id == "j1") {
        this.joinValue1 = v;
        if (v == "BETWEEN") {
          this.j1EnabledBetween = true;
          this.b2Controller.enableOnly(this.b1Controller.getSelectedFieldName());
        } else {
          this.j1EnabledBetween = false;
          this.b2Controller.enableOnly("all");
        }
      }
      if (id == "j2") {
        this.joinValue2 = v;
        if (v == "BETWEEN") {
          this.j2EnabledBetween = true;
          this.b3Controller.enableOnly(this.b2Controller.getSelectedFieldName());
        } else {
          this.j2EnabledBetween = true;
          this.b3Controller.enableOnly("all");
        }
      }
      this.bock_info[id] = v;
      this.processAndEmit();
    },
    onChange: function onChange(d) {
      if (typeof this.$store.state.search_data == "undefined") {
        this.$store.state.search_data = {};
      }
      this.$store.state.search_data[d.block] = d;
      this.bock_info[d.block] = d;
      this.processAndEmit();
    },
    processAndEmit: function processAndEmit() {
      this.b2_disabled = false;
      this.b3_disabled = false;
      this.j1_disabled = false;
      this.j2_disabled = false;
      this.j1EnabledBetween = false;
      this.j2EnabledBetween = false;
      if (this.bock_info["1"] == false || this.bock_info["1"].value == "") {
        this.b2_disabled = true;
        this.b3_disabled = true;
        this.j1_disabled = true;
        this.j2_disabled = true;
      }
      if (this.bock_info["2"] == false || this.bock_info["2"].value == "") {
        this.b3_disabled = true;
        this.j2_disabled = true;
      }

      if (this.bock_info["1"] != false && this.bock_info["1"].t && (this.bock_info["1"].t.indexOf('datetime_picker') == 0 || this.bock_info["1"].t.indexOf('current_time') == 0 || this.bock_info["1"].t.indexOf('date_picker') == 0)) {
        this.j1EnabledBetween = true;
      } else if (this.bock_info["2"] != false) {
        if (this.bock_info["j1"] == "BETWEEN") {
          this.andOr("AND", "j1");
        }
      }

      if (this.bock_info["2"] != false && this.bock_info["2"].t && (this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0)) {
        this.j2EnabledBetween = true;
      } else if (this.bock_info["3"] != false) {
        if (this.bock_info["j2"] == "BETWEEN") {
          this.andOr("AND", "j2");
        }
      }
      this.bock_info["b2_disabled"] = this.b2_disabled;
      this.bock_info["b3_disabled"] = this.b3_disabled;
      console.log("Data changed", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bock_info, null, 4));
      this.$emit("change", this.bock_info);
    },
    onFilterTypeSelected: function onFilterTypeSelected(val, id) {
      console.log({ val: val, id: id });
    },
    onDateFilterSelected: function onDateFilterSelected() {}
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this = this;

    this.$store.state.search_dependency_groups = {};
    this.$store.state.search_data = {};

    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$on("onOpenPageFilterJoin1", function (data) {
      console.log('TEST DEBUG 210608 (273 at search_control.vue)[01:38]: ', {});
      setTimeout(function () {
        _this.andOr(data, "j1");
      }, 200);
    });
    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$on("onOpenPageFilterJoin2", function (data) {
      console.log('TEST DEBUG 210608 (279 at search_control.vue)[01:38]: ', {});
      setTimeout(function () {
        _this.andOr(data, "j2");
      }, 200);
    });
  },
  afterMount: function afterMount() {},
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$off("onOpenPageFilterJoin1");
    __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$off("onOpenPageFilterJoin2");
  },

  props: ['field_names', 'single']
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_field_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_input_modal__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_input_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_input_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_fields_select_box4__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_fields_select_box4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_fields_select_box4__);








var debug_search_control_block = __WEBPACK_IMPORTED_MODULE_3_debug___default()('esma:search_control_block');




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "select-box4": __WEBPACK_IMPORTED_MODULE_8__components_fields_select_box4___default.a,
    "input-modal": __WEBPACK_IMPORTED_MODULE_7__components_modals_input_modal___default.a
  },
  data: function data() {
    return {
      local_value: "",
      filed_types: __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */],
      selected_field: false,
      selected_field_type: __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].INPUT,
      field_options: [],
      clearing: false,
      selected_field_name: "",
      seqquence_refresh: 1,
      enable_only_id: "all"

    };
  },

  computed: {
    enableOnlyId: {
      get: function get() {
        return this.enable_only_id;
      },
      set: function set(v) {
        this.enable_only_id = v;
      }
    },
    seqquenceRefresh: {
      get: function get() {
        return this.seqquence_refresh;
      },
      set: function set(v) {
        this.seqquence_refresh = v;
      }
    },
    selectedField: {
      get: function get() {
        return this.selected_field;
      },
      set: function set(v) {
        this.selected_field = v;
      }
    },
    selectedFieldName: {
      get: function get() {
        return this.selected_field_name;
      },
      set: function set(v) {
        this.selected_field_name = v;
      }
    },
    clearingAll: {
      get: function get() {
        return this.clearing;
      },
      set: function set(v) {
        this.clearing = v;
      }
    },
    allDisabled: function allDisabled() {
      return this.all_disabled == true;
    },

    localValue: {
      get: function get() {
        return this.local_value;
      },
      set: function set(v) {
        this.local_value = v;
      }
    },
    fieldOptions: {
      get: function get() {
        return this.field_options;
      },
      set: function set(v) {
        this.field_options = v;
      }
    },
    selectedFieldType: {
      get: function get() {
        return this.selected_field_type;
      },
      set: function set(v) {
        this.selected_field_type = v;
      }
    },
    filedList: function filedList() {
      var _this = this;

      var local = this.field_names;

      if (this.enableOnlyId && this.enableOnlyId != "all") {
        local = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(local, function (l) {
          return l.id == _this.enableOnlyId;
        });
      }

      var r = this.seqquenceRefresh > 0 ? local.map(function (o) {
        return { id: o.id, label: o.label, type: o.type, search_dependency: o.search_dependency };
      }) : [];
      return r;
    }
  },
  methods: {
    clearAll: function clearAll() {
      var _this2 = this;

      this.clearingAll = true;
      this.localValue = "*";
      this.updateValue("");
      this.localValue = "";
      this.selected_field = false;
      this.selectedFieldType = __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].INPUT;
      this.selectedFieldName = "";
      setTimeout(function () {
        _this2.clearingAll = false;
      }, 200);
    },
    onFilterTypeSelected: function onFilterTypeSelected(val) {
      var _this3 = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};


      this.selectedFieldName = val;
      this.localValue = "*";
      var f = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.field_names, { id: val });
      var wait_time = 1;
      if (typeof f != "undefiend" && f != null && f != false && (f.type == __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].SELECT_BOX4 || f.type == __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].SELECT_BOX2)) {
        this.selected_field = false;
        this.selected_field_type = false;
        wait_time = 100;
      }
      setTimeout(function () {
        console.log("before", f, typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f));
        if (typeof f != "undefiend" && f != null && f != false) {
          _this3.selected_field = f;
          _this3.selected_field_type = f.type;
          if (f.type == __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].SELECT_BOX || f.type == __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].SELECT_BOX3 || f.type == __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].SELECT_BOX2) {
            var temp_options = f.options_original || f.options;
            _this3.fieldOptions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.clone(temp_options);
          }
        } else {
          _this3.selected_field = false;
        }
        _this3.localValue = "";
        console.log("onFilterTypeSelected", val, f);
        _this3.$emit("change", { block: _this3.block_id, field: _this3.selected_field.id, value: "", ct: "f", ca: _this3.clearingAll, t: _this3.selectedFieldType });
        return cb();
      }, wait_time);
    },
    onManualSelectClose: function onManualSelectClose(val) {
      this.value_updated = true;
      if (this.fieldOptions.indexOf(val) < 0) {
        var f = this.selected_field;
        var temp_options = f.options_original || f.options;
        this.fieldOptions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.clone(temp_options);

        this.fieldOptions.unshift(val);
      }
      this.updateValue(val);
    },
    updateValue: function updateValue(v) {
      if (v == "manual_input") {
        console.log("manual_input INPUT");
        __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("showInputModal" + this.block_id, {
          title: "手動入力検索",
          initial_value: ""
        });
        return;
      }
      if (this.clearingAll == false && this.selectedFieldType == __WEBPACK_IMPORTED_MODULE_6__constants_field_types__["a" /* filed_types */].SELECT_BOX && v == "") {
        v = "SELECTED_EMPTY_SELECT_BOX";
      }
      this.localValue = v;
      if (typeof v != "undefined" && this.selected_field != false) {
        this.$emit("change", { block: this.block_id, field: this.selected_field.id, value: v, ct: "v", ca: this.clearingAll, t: this.selectedFieldType });
      }
    },
    updateValueDate: function updateValueDate(v) {
      if (v == null) {
        return v;
      }
      this.updateValue(__WEBPACK_IMPORTED_MODULE_4_moment___default()(v).format('YYYY/MM/DD'));
    },
    updateValueDateTime: function updateValueDateTime(v) {
      if (v.length < 11) {
        this.updateValue(__WEBPACK_IMPORTED_MODULE_4_moment___default()(v).format('YYYY/MM/DD'));
      } else {
        if (__WEBPACK_IMPORTED_MODULE_4_moment___default()(v).format('HH:mm') == "00:00") {
          this.updateValue(__WEBPACK_IMPORTED_MODULE_4_moment___default()(v).format('YYYY/MM/DD'));
        } else {
          this.updateValue(__WEBPACK_IMPORTED_MODULE_4_moment___default()(v).format('YYYY/MM/DD HH:mm'));
        }
      }
    },
    enableOnly: function enableOnly(field_id) {
      this.enableOnlyId = field_id;
      this.seqquenceRefresh++;
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this4 = this;

    if (this.block_contorler) {
      this.$props.block_contorler.enableOnly = this.enableOnly;
      this.$props.block_contorler.getSelectedFieldName = function () {
        return _this4.selectedFieldName;
      };
    }
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on("onSearchClear", function () {
      _this4.localValue = "";
      _this4.updateValue("");
      _this4.clearAll();
      _this4.$store.state.last_filter_options = {};
      _this4.$store.state.last_filter_options2 = {};
    });
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on("onSearchClearById", function (obj) {
      if (_this4.selectedFieldName == obj.field_id && parseInt(_this4.block_id) > parseInt(obj.block_id)) {
        _this4.localValue = "";
        _this4.updateValue("");
        _this4.clearAll();
        _this4.$store.state.last_filter_options = {};
        _this4.$store.state.last_filter_options2 = {};
      }
    });
    if (this.block_id == 1 || this.block_id == "1") {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on("onOpenPageFilter", function (data) {
        _this4.onFilterTypeSelected(data.field, function () {
          _this4.localValue = data.val;
          _this4.updateValue(data.val);
          if (typeof data.cb == "function") {
            data.cb();
          }
        });
      });
    } else if (this.block_id == 2 || this.block_id == "2") {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on("onOpenPageFilter2", function (data) {
        _this4.onFilterTypeSelected(data.field, function () {
          _this4.localValue = data.val;
          _this4.updateValue(data.val);
          if (typeof data.cb == "function") {
            data.cb();
          }
        });
      });
    } else if (this.block_id == 3 || this.block_id == "3") {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$on("onOpenPageFilter3", function (data) {
        _this4.onFilterTypeSelected(data.field, function () {
          _this4.localValue = data.val;
          _this4.updateValue(data.val);
          if (typeof data.cb == "function") {
            data.cb();
          }
        });
      });
    }
  },
  afterMount: function afterMount() {},
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off("onSearchClear");
    __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off("onSearchClearById");
    if (this.block_id == 1 || this.block_id == "1") {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off("onOpenPageFilter");
    } else if (this.block_id == 2 || this.block_id == "2") {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off("onOpenPageFilter2");
    } else if (this.block_id == 3 || this.block_id == "3") {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$off("onOpenPageFilter3");
    }
  },

  props: ['field_names', 'block_id', 'id', 'all_disabled', "block_contorler"]
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_control_block__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_control_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_search_control_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);





var debug_search_control = __WEBPACK_IMPORTED_MODULE_2_debug___default()('esma:page_common');




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "search-control-block": __WEBPACK_IMPORTED_MODULE_4__components_search_control_block___default.a
  },
  data: function data() {
    return {
      bock_info: { 1: false, 2: false, 3: false, j1: "AND", j2: "AND", b2_disabled: false, b3_disabled: false },
      b1_disabled: false,
      j1_disabled: true,
      b2_disabled: true,
      j2_disabled: true,
      b3_disabled: true,
      j1_enabled_between: false,
      j2_enabled_between: false
    };
  },


  computed: {
    j1EnabledBetween: {
      get: function get() {
        return this.j1_enabled_between;
      },
      set: function set(v) {
        this.j1_enabled_between = v;
      }
    },
    j2EnabledBetween: {
      get: function get() {
        return this.j2_enabled_between;
      },
      set: function set(v) {
        this.j2_enabled_between = v;
      }
    },
    filedList: function filedList() {
      return this.field_names.map(function (o) {
        return { id: o.id, label: o.label, type: o.type };
      });
    },

    dateFilterOptions: {
      get: function get() {
        return [];
      },
      set: function set(v) {}
    },
    isSingle: function isSingle() {
      return this.single == true;
    }
  },
  methods: {
    clearBarcode: function clearBarcode(ev) {
      ev.preventDefault();
      __WEBPACK_IMPORTED_MODULE_5__libs_bus__["a" /* bus */].$emit("onSearchClear", "");
    },
    andOr: function andOr(v, id) {
      this.bock_info[id] = v;
      this.processAndEmit();
    },
    onChange: function onChange(d) {
      this.bock_info[d.block] = d;
      this.processAndEmit();
    },
    processAndEmit: function processAndEmit() {
      this.b2_disabled = false;
      this.b3_disabled = false;
      this.j1_disabled = false;
      this.j2_disabled = false;
      this.j1EnabledBetween = false;
      this.j2EnabledBetween = false;
      if (this.bock_info["1"] == false || this.bock_info["1"].value == "") {
        this.b2_disabled = true;
        this.b3_disabled = true;
        this.j1_disabled = true;
        this.j2_disabled = true;
      }
      if (this.bock_info["2"] == false || this.bock_info["2"].value == "") {
        this.b3_disabled = true;
        this.j2_disabled = true;
      }

      if (this.bock_info["1"] != false && this.bock_info["2"] != false && this.bock_info["1"].field == this.bock_info["2"].field && (this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0)) {
        this.j1EnabledBetween = true;
      } else if (this.bock_info.j1 == "BETWEEN") {
        this.bock_info.j1 = "AND";
      }
      if (this.bock_info["2"] != false && this.bock_info["3"] != false && this.bock_info["2"].field == this.bock_info["3"].field && (this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0)) {
        this.j2EnabledBetween = true;
      } else if (this.bock_info.j2 == "BETWEEN") {
        this.bock_info.j2 = "AND";
      }
      this.bock_info["b2_disabled"] = this.b2_disabled;
      this.bock_info["b3_disabled"] = this.b3_disabled;
      console.log("Data changed", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bock_info, null, 4));
      this.$emit("change", this.bock_info);
    },
    onFilterTypeSelected: function onFilterTypeSelected(val, id) {
      console.log({ val: val, id: id });
    },
    onDateFilterSelected: function onDateFilterSelected() {}
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  afterMount: function afterMount() {},
  beforeDestroy: function beforeDestroy() {},

  props: ['field_names', 'single']
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_bulk_reject_modal__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_bulk_reject_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_bulk_reject_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__libs_bus__ = __webpack_require__(4);











var mdebug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('esma:approval_history');











/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_8__components_form_field___default.a,
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal___default.a,
    'bulk-reject-modal': __WEBPACK_IMPORTED_MODULE_15__components_modals_bulk_reject_modal___default.a
  },
  data: function data() {
    return {
      api_name: "approval_history",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      execute_filter_on_back: true,
      page_acl: __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default.a.approval_history,
      user_id: "",
      is_logged_user_admin: false,
      load_only_with_filter: false,
      disable_page_approve: true,
      select_all: false,
      link_to_open: "#",
      filtering_reject_mode: false,
      rejected_bulk_edit_selected_records_qty: 0,
      rejected_bulk_edit_disabled: false,
      rejected_bulk_edit_sybetu: "",
      selected_approval_history_name: "selected_approval_history",
      state_last_filter_options: "last_filter_options_history"
    };
  },

  computed: {
    selectedApprovalHistoryName: {
      get: function get() {
        if (this.filteringRrejectMode == true) {
          return this.selected_approval_history_name + "_rejected";
        } else {
          return this.selected_approval_history_name;
        }
      },
      set: function set(v) {
        this.selected_approval_history_name = v;
      }
    },
    bulkEditText: function bulkEditText() {
      if (this.rejectedBulkEditSelectedRecordsQty == 0) {
        return "一括編集";
      } else {
        return "一括編集" + " (" + this.rejectedBulkEditSelectedRecordsQty + ")";
      }
    },

    rejectedBulkEditSelectedRecordsQty: {
      get: function get() {
        return this.rejected_bulk_edit_selected_records_qty;
      },
      set: function set(v) {
        this.rejected_bulk_edit_selected_records_qty = v;
      }
    },
    rejectedBulkEditDisabled: {
      get: function get() {
        return this.rejected_bulk_edit_disabled;
      },
      set: function set(v) {
        this.rejected_bulk_edit_disabled = v;
      }
    },
    filteringRrejectMode: {
      get: function get() {
        return this.filtering_reject_mode;
      },
      set: function set(v) {
        this.filtering_reject_mode = v;
      }
    },
    approveMode: {
      get: function get() {
        return this.approve_mode;
      },
      set: function set(v) {
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll: {
      get: function get() {
        return this.select_all;
      },
      set: function set(v) {
        this.select_all = v;
      }
    },
    disablePageApprove: {
      get: function get() {
        return this.disable_page_approve;
      },
      set: function set(v) {
        this.$emit("bRLFlag", !v);
        this.disable_page_approve = v;
      }
    },
    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    isLoggedUserAdmin: {
      get: function get() {
        return this.is_logged_user_admin;
      },
      set: function set(v) {
        this.is_logged_user_admin = v;
      }
    },
    userId: {
      get: function get() {
        return this.user_id;
      },
      set: function set(v) {
        this.user_id = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["b" /* filed_types */];
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].approval_status, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].current_status, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].syubetu, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].control_number, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].toroku_number, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].bulk_toroku_number, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].applicant_label, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].department, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].next_approver_label, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].update_name_label, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].create_time, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].update_time];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].approval_status, {
        search_no_blank: true,
        options: ["承認済", "申請中", "差戻"]
      }), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].current_status, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].syubetu, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].control_number, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].toroku_number, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].bulk_toroku_number, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].applicant_label, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].next_approver_label, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].update_name_label, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].create_time, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].update_time, {})];
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("runDeviceEmbededInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        sub_search: this.search_data,
        url: "/approval_history/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    allChecked: function allChecked(a, b) {
      var _this = this;

      setTimeout(function () {
        if (_this.checkBoxSelectAll == true) {
          var ops = { check: _this.checkBoxSelectAll };
          if (_this.last_data_source_filter) {
            ops.filter = _this.last_data_source_filter;
          }
          var url = "/approval_history/select_all_checkable";
          if (_this.filteringRrejectMode == true) {
            url = "/approval_history/select_all_rejected_checkable";
          }
          _this.$ajax.post(url, ops, function (err, result) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(_this.selectedApprovalHistoryName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result || []));
            _this.refreshSelectedRecord();
          });
        } else {
          _this.bulkClearApprovalStage4Confirmation("yes");
        }
      }, 100);
    },
    bulkRejectStage1: function bulkRejectStage1() {
      var qty = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName).length;
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("bulkRejectModal", {
        qty: qty
      });
    },
    bulkEdit: function bulkEdit() {
      var _this2 = this;

      var sybetu = this.rejected_bulk_edit_sybetu[0];
      var p_id = __WEBPACK_IMPORTED_MODULE_6_uuid___default.a.v4();
      var url = false;
      if (sybetu == __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.DEVICE) {
        url = "/device_embedded_information/bulk_edit/" + p_id;
      } else if (sybetu == __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.CERTIFICATE) {
        url = "/certificate/bulk_edit/" + p_id;
      }
      if (url) {
        var arr = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName);
        this.$ajax.post("/approval_history/get_rejected_details_for_edit", { arr: arr }, function (err, result) {
          var obj = { arr: result.map(function (m) {
              return m.fk_id;
            }) };
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("bulk_edit_" + p_id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
          return _this2.$router.push(url);
        });
      }
    },
    bulkRejectStage2: function bulkRejectStage2(obj) {
      var _this3 = this;

      if (obj && obj.mode == "yes") {
        var arr = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName);
        var hash = 0;
        arr.forEach(function (e) {
          hash = hash + (e + 3) * 2;
        });
        this.$ajax.post("/approval_history/bulk_reject", { arr: arr, hash: hash, changes: { retraction_reason: obj.value } }, function (err, response) {
          console.log({ response: response });
          _this3.$store.state["current_field_style"] = {};
          _this3.$store.state["current_field_style2"] = {};
          if (err) {
            var title = "データの差戻に失敗しました。";
            if (err && err.indexOf("::") == 0) {
              title = err.replace("::", "");
              err = "";
            }
            _this3.$notify({
              title: title,
              text: err,
              type: "error",
              duration: 10000
            });
          } else {
            _this3.bulkClearApprovalStage4Confirmation("yes");
            _this3.gridOptions.api.purgeInfiniteCache();
            __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("stage2RejectConfirmatioModal", {
              title: "差戻が完了しました。",
              message: "",
              yes_label: "",
              no_label: "戻る",
              yes_color: "info",
              no_color: "default",
              model_height: "50"
            });
          }
        });
      }
    },
    bulkRejctStage3: function bulkRejctStage3() {
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkRejctStage3");
    },
    bulkApprovalStage1: function bulkApprovalStage1() {
      var qty = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName).length;
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("stage1ConfirmatioModal", {
        title: "選択中　" + qty + "件",
        message: "承認を行います。よろしいですか？",
        yes_label: "承認",
        no_label: "戻る",
        yes_color: "info",
        no_color: "default",
        model_height: "50"
      });
    },
    bulkApprovalStage2: function bulkApprovalStage2(mode) {
      var _this4 = this;

      if (mode != "yes") {
        return;
      }
      var arr = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName);
      var hash = 0;
      arr.forEach(function (e) {
        hash = hash + (e + 3) * 2;
      });
      this.$ajax.post("/approval_history/approve", { arr: arr, hash: hash }, function (err, response) {
        console.log({ response: response });
        _this4.$store.state["current_field_style"] = {};
        _this4.$store.state["current_field_style2"] = {};
        if (err) {
          var title = "データの承認に失敗しました。";
          if (err && err.indexOf("::") == 0) {
            title = err.replace("::", "");
            err = "";
          }
          _this4.$notify({
            title: title,
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          _this4.bulkClearApprovalStage4Confirmation("yes");
          _this4.gridOptions.api.purgeInfiniteCache();
          __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("stage2ConfirmatioModal", {
            title: "承認が完了しました。",
            message: "",
            yes_label: "",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    bulkApprovalStage3: function bulkApprovalStage3() {
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkApprovalStage3");
    },
    bulkClearApprovalStage4Confirmation: function bulkClearApprovalStage4Confirmation(mode) {
      if (mode == "yes") {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(this.selectedApprovalHistoryName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]));
        this.refreshSelectedRecord();
      }
    },
    bulkApprovalStage4: function bulkApprovalStage4(mode) {
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("bulkApprovalStage4ConfirmatioModal", {
        title: "",
        message: "申請の確認状態をクリアします。<br>よろしいですか？",
        yes_label: "OK",
        no_label: "戻る",
        yes_color: "info",
        no_color: "default",
        model_height: "50"
      });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      var destination = "";
      if (data.fk_tab == __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION) {
        destination = "/device_embedded_information/approval/" + data.seq_id + "/" + data.fk_id;
      } else if (data.fk_tab == __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.TABLE_ID.CERTIFICATE_INFORMATION) {
        destination = "/certificate_information/approval/" + data.seq_id + "/" + data.fk_id;
      } else if (data.fk_tab == __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE) {
        destination = "/certificate/approval/" + data.seq_id + "/" + data.fk_id;
      } else {
        this.$notify({
          title: "FK ID or FK TAB was not found.",
          text: "There are some problem with the fk data.",
          type: "error",
          duration: 10000
        });
        return;
      }
      console.log('onDetailsClick', { destination: destination });

      return this.$router.push(destination);
    },
    refreshSelectedRecord: function refreshSelectedRecord() {
      var _this5 = this;

      var selected_approval_history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.rejectedBulkEditSelectedRecordsQty = 0;
      this.rejectedBulkEditDisabled = true;
      this.rejected_bulk_edit_sybetu = [];
      if (selected_approval_history == false) {
        selected_approval_history = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName);
      }
      var count_selected_on_memory = 0;
      this.gridOptions.api.forEachNode(function (node) {
        if (node.data) {
          if (selected_approval_history.indexOf(node.data.seq_id) > -1) {
            node.data.is_selected = true;
          } else {
            node.data.is_selected = false;
          }
          if (node.data.seq_id > 0 && node.data.is_selected == true) {
            if (node.data.approval_status == "差戻") {
              _this5.rejectedBulkEditSelectedRecordsQty++;
              if (_this5.rejected_bulk_edit_sybetu.indexOf(node.data.syubetu) < 0) {
                _this5.rejected_bulk_edit_sybetu.push(node.data.syubetu);
              }
              _this5.rejectedBulkEditDisabled = _this5.rejected_bulk_edit_sybetu.length != 1;
            }
            if ((_this5.isLoggedUserAdmin == true && node.data && node.data.status_final == "未承認" || node.data && node.data.next_approver == _this5.userId) && node.data && (node.data.is_selected == true || _this5.isAllSelected == true)) {
              count_selected_on_memory++;
            }
          }
        }
      });
      this.disablePageApprove = count_selected_on_memory == 0;
      this.gridOptions.api.refreshView();
    },
    onCheckBoxClick: function onCheckBoxClick(ev, row) {
      var selected_approval_history = this.loadSelectedApprovalHistory(this.selectedApprovalHistoryName);
      if (isNaN(row.seq_id) == false) {
        var seq_id = row.seq_id;
        if (selected_approval_history.indexOf(seq_id) > -1) {
          __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.remove(selected_approval_history, function (d) {
            return d == seq_id;
          });
        } else {
          selected_approval_history.push(seq_id);
        }
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(this.selectedApprovalHistoryName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selected_approval_history));
      }
      this.refreshSelectedRecord();
    },
    createColumnDefs: function createColumnDefs() {
      var _this6 = this;

      var arr = [{
        headerName: 'Seq',
        field: 'seq_id',
        hide: true
      }, {
        headerName: "SearchControl",
        field: "search_control",
        hide: true
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: true
      }];
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };

        if (f.type == "date_picker") {
          fi.cellRenderer = function (params) {
            return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].format_date(params.value);
          };
        } else if (f.type == "select") {
          fi.cellRenderer = function (params) {
            if (f.table_field_style && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(f.table_field_style) > 0) {
              return "<span style='" + f.table_field_style[params.value] + "'>" + params.value + "</span>";
            } else {
              return params.value;
            }
          };
        } else if (f.type == "datetime_picker" || f.type == "current_time") {
          fi.cellRenderer = function (params) {
            return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].format_date_time(params.value);
          };
        } else if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }

        arr.push(fi);
      });

      [__WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].more_details, __WEBPACK_IMPORTED_MODULE_3__rules_fields_approval_history__["a" /* fields */].record_checked].forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',

          cellRenderer: function cellRenderer(params) {
            if (params.column.colId == "more_details") {
              if (_this6.isLoggedUserAdmin == true && params.data && params.data.status_final == "未承認" || params.data && (params.data.next_approver == _this6.userId || params.data.applicant == _this6.userId)) {
                return _this6.createGridTextButton("詳細", "color: #5b9bd5;", _this6.onDetailsClick, params.data);
              } else {
                return "-";
              }
            }
            if (params.column.colId == "record_checked") {
              if (_this6.hideCheckBox(params.data) == true) {
                return "";
              }
              return _this6.createGridButton(params.data && params.data.record_checked == 1 ? "glyphicon glyphicon glyphicon-check" : "glyphicon glyphicon glyphicon-unchecked", "color: #5b9bd5;", function (ev, selected_row) {
                _this6.onCheckBoxClick(ev, selected_row);
              }, params.data);
            }
          }
        };
        arr.push(fi);
      });

      return arr;
    },
    hideCheckBox: function hideCheckBox(data) {
      var _this7 = this;

      if (data) {
        var found_to_hide = false;
        [1, 2, 3, 4, 5].forEach(function (f) {
          if (data["approver_" + f] == _this7.userId && data["status_" + f] != "未承認") {
            found_to_hide = true;
          }
        });
        if (found_to_hide == true) {
          return true;
        }
      }
      if (data && data.applicant == this.userId && data.approval_status == "差戻") {
        return false;
      } else if (data && (data.next_approver == this.userId || data.next_approver == "ライセンス管理窓口（最終承認）" && this.isApproverAdminForSimpleApprove && data.applicant != this.userId)) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    if (this.$route.meta.mode == "rejected") {
      window.sessionStorage.setItem('device_back_to_list', "/approval_history/rejected");
      window.sessionStorage.setItem('certificate_back_to_list', "/approval_history/rejected");
    } else {
      window.sessionStorage.setItem('device_back_to_list', "/approval_history");
      window.sessionStorage.setItem('certificate_back_to_list', "/approval_history");
    }

    this.gridOptions.api.sizeColumnsToFit();
    setTimeout(function () {
      if (_this8.$route.meta.mode == "toroku_filter") {
        __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "bulk_toroku_number", val: _this8.$route.params.bulk_toroku_number });
      } else if (_this8.$store.state["last_filter_options_history"]) {
        var lfo = _this8.$store.state[_this8.stateLastFilterOptions][_this8.api_name];
        if (_this8.executing_filter_on_back == true || lfo && lfo.filter && lfo.filter["1"] && lfo.filter["1"].value) {} else if (_this8.$route.meta.mode == "rejected") {
          __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "approval_status", val: '差戻' });
        } else {
          setTimeout(function () {
            lfo = _this8.$store.state["last_filter_options_history"]["approval_history"];
            if (_this8.executing_filter_on_back == true || lfo && lfo.filter && lfo.filter["1"] && lfo.filter["1"].value) {} else if (_this8.$route.meta.mode == "rejected") {
              __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "approval_status", val: '差戻' });
            } else {
              __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "approval_status", val: '申請中' });
            }
          }, 100);
        }
      }
    }, 100);
    this.userId = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userID") || "";
    this.isLoggedUserAdmin = this.isAdmin;
    this.$ajax.post("/approval_history/count_prepared", {}, function (err, qty) {
      _this8.$emit("selectedItemsUpd", qty || 0);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    var _this9 = this;

    this.$store.state[this.stateCurrentRow] = {};
    var use_data_source = true;

    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onColumnResized: function onColumnResized(ev, b) {},
      onRowSelected: function onRowSelected(ev) {},
      onModelUpdated: function onModelUpdated(ev, d) {},
      onGridReady: function onGridReady() {},
      getRowStyle: function getRowStyle(params) {
        if (_this9.isLoggedUserAdmin == true && params.node.data && params.node.data.status_final == "未承認" || params.node.data && params.node.data.next_approver == _this9.userId || params.node.data && params.node.data.applicant == _this9.userId && params.node.data.approval_status == "差戻") {
          if (params.node.data && (params.node.data.is_selected == true || _this9.isAllSelected == true)) {
            if (_this9.hideCheckBox(params.data) == true) {
              return {};
            } else {
              return { background: "orange" };
            }
          }
        }
      }
    };
    this.initDatasource({ load_only_with_filter: false, loaded_cb: function loaded_cb(err, data) {
        _this9.filteringRrejectMode = false;
        if (_this9.stateLastFilterOptions && _this9.api_name && _this9.$store.state[_this9.stateLastFilterOptions] && _this9.$store.state[_this9.stateLastFilterOptions][_this9.api_name]) {
          if (_this9.$store.state[_this9.stateLastFilterOptions][_this9.api_name].filter && _this9.$store.state[_this9.stateLastFilterOptions][_this9.api_name].filter["1"]) {
            _this9.filteringRrejectMode = _this9.$store.state[_this9.stateLastFilterOptions][_this9.api_name].filter["1"].value == "差戻" && _this9.$store.state[_this9.stateLastFilterOptions][_this9.api_name].filter["1"].field == "approval_status";
          }
        }
        var active_approve_button = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(data, function (d) {
          if (_this9.hideCheckBox(d) == true) {
            return false;
          }
          return (_this9.isLoggedUserAdmin == true && d && d.status_final == "未承認" || d && d.next_approver == _this9.userId) && d && (d.is_selected == true || d.record_checked == 1 || _this9.isAllSelected == true);
        });
        _this9.disablePageApprove = typeof active_approve_button == "undefined";
        _this9.refreshSelectedRecord();
      } });
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_md5__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_progress_modal__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_progress_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_progress_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_bus__ = __webpack_require__(4);









var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:approval_history');










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_6__components_form_field___default.a,
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'progress-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_progress_modal___default.a
  },
  data: function data() {
    return {
      api_name: "approval_history_batch_import",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      execute_filter_on_back: true,
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.approval_history,
      user_id: "",
      is_logged_user_admin: false,
      load_only_with_filter: false,
      disable_page_approve: true,
      selected_session_ids_for_approve: [],
      get_row_style_background: "orange",
      approve_mode: "none",
      select_all: false
    };
  },

  computed: {
    checkBoxSelectAll: {
      get: function get() {
        return this.select_all;
      },
      set: function set(v) {
        this.select_all = v;
      }
    },
    approveMode: {
      get: function get() {
        return this.approve_mode;
      },
      set: function set(v) {
        this.approve_mode = v;
      }
    },
    getRowStyleBackground: {
      get: function get() {
        return this.get_row_style_background;
      },
      set: function set(v) {
        this.get_row_style_background = v;
      }
    },
    disablePageReject: {
      get: function get() {
        if (this.approveMode != "reject") {
          return true;
        }
        if (this.formOutputQty == 0) {
          return true;
        } else {
          return false;
        }
      },
      set: function set(v) {
        this.disable_page_approve = v;
      }
    },
    disablePageApprove: {
      get: function get() {
        if (this.approveMode == "reject") {
          this.$emit("bRLFlag", !true);
          return true;
        }
        if (this.formOutputQty == 0) {
          this.$emit("bRLFlag", !true);
          return true;
        } else {
          this.$emit("bRLFlag", !false);
          return false;
        }
      },
      set: function set(v) {
        this.disable_page_approve = v;
      }
    },
    isLoggedUserAdmin: {
      get: function get() {
        return this.is_logged_user_admin;
      },
      set: function set(v) {
        this.is_logged_user_admin = v;
      }
    },
    userId: {
      get: function get() {
        return this.user_id;
      },
      set: function set(v) {
        this.user_id = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["b" /* filed_types */];
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].control_number, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].approval_status, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].syubetu, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].toroku_number, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].applicant_label, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].next_approver_label, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].update_name_label, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].create_time, __WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].update_time];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].approval_status, {
        options: ["承認済", "申請中", "差戻", "確認済"]
      }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].syubetu, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].toroku_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].applicant_label, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].next_approver_label, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].update_name_label, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].create_time, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_approval_history__["a" /* fields */].update_time, {})];
    }
  },
  methods: {
    onArraySelected: function onArraySelected() {
      this.$emit("selectedItemsUpd", this.selectedRowArr.length);
    },
    allChecked: function allChecked(a, b) {
      var _this = this;

      this.commonAllChecked("showInformationIconModalApprovalHistoryAll", function (err, qty) {
        _this.$emit("selectedItemsUpd", qty);
      });
    },
    hideInternalCheckBox: function hideInternalCheckBox(data) {
      var _this2 = this;

      if (data) {
        if (data["applicant"] == this.userId) {
          return true;
        }
        if (data.checked_to_reject == 1) {
          if (data.checked_user == null || data.checked_user == '' || data.checked_user == this.userId) {} else {
            return true;
          }
        }
        var found_to_hide = false;
        [1, 2, 3, 4, 5].forEach(function (f) {
          if (data["approver_" + f] == _this2.userId && data["status_" + f] != "未承認") {
            found_to_hide = true;
          }
        });

        if (data.status_final != "未承認" && data.status_final != "" && data.status_final != null) {
          return true;
        }
        if (found_to_hide == true) {
          return true;
        }
      }
      return false;
    },
    hideCheckBox: function hideCheckBox(data) {
      var _this3 = this;

      if (this.approveMode == "reject") {
        return true;
      }
      if (data) {
        var found_to_hide = false;
        [1, 2, 3, 4, 5].forEach(function (f) {
          if (data["approver_" + f] == _this3.userId && data["status_" + f] != "未承認") {
            found_to_hide = true;
          }
        });
        if (found_to_hide == true) {
          return true;
        }
      }
      if (data && data.checked_to_reject == 1) {
        return true;
      } else if (data && (data.next_approver == this.userId || data.next_approver == "ライセンス管理窓口（最終承認）" && this.isApproverAdminForApproveImport && data.applicant != this.userId)) {
        return false;
      } else {
        return true;
      }
    },
    bulkRejectStage1: function bulkRejectStage1() {
      var _this4 = this;

      var arr = _.filter(this.selectedRowArr, function (r) {
        return r.checked_to_reject == 1;
      }).map(function (m) {
        return m.ref_id;
      });
      if (Array.isArray(arr) == false || arr.length < 1) {
        this.$notify({
          title: "行の選択に失敗しました。",
          text: "",
          type: "error",
          duration: 10000
        });
        return;
      }
      this.selected_session_ids_for_reject = arr;
      this.$ajax.post("/" + this.api_name + "/count_prepared", { ref_id_list: arr }, function (err, qty) {
        console.log({ qty: qty });
        if (err) {
          _this4.$notify({
            title: "データの差戻に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {

          __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("stage1RejectConfirmatioModal", {
            title: "選択中　" + qty + "件",
            message: "差戻を行います。よろしいですか？",
            yes_label: "差戻",
            no_label: "戻る",
            yes_color: "danger",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    bulkRejectStage2: function bulkRejectStage2(mode) {
      var _this5 = this;

      if (mode != "yes") {
        return;
      }
      var arr = this.selected_session_ids_for_reject;
      this.$ajax.post("/" + this.api_name + "/reject_it", { ref_id_list: arr }, function (err, response) {
        _this5.selected_session_ids_for_reject = [];
        _this5.selectedRowArr = [];
        _this5.formOutputQty = 0;
        console.log({ response: response });
        _this5.$store.state["current_field_style"] = {};
        _this5.$store.state["current_field_style2"] = {};
        if (err) {
          _this5.$notify({
            title: "データの差戻に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          _this5.gridOptions.api.purgeInfiniteCache();
          var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";
          __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("stage2ConfirmatioModal", {
            message: message,
            title: "申請が差戻されました",
            yes_label: "",
            no_label: "OK",
            yes_color: "",
            no_color: "",
            model_height: "50",
            model_width: "390px"
          });
        }
      });
    },
    bulkApprovalStage1: function bulkApprovalStage1() {
      var _this6 = this;

      var arr = this.selectedRowArr.map(function (m) {
        return m.ref_id;
      });
      this.selected_session_ids_for_approve = arr;
      this.$ajax.post("/" + this.api_name + "/count_prepared", { ref_id_list: arr }, function (err, qty) {
        console.log({ qty: qty });
        if (err) {
          _this6.$notify({
            title: "データの承認に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          console.log("bulkApprovalStage1", { qty: qty });

          __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("stage1ConfirmatioModal", {
            title: "選択中　" + qty + "件",
            message: "承認を行います。よろしいですか？",
            yes_label: "承認",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    bulkApprovalStage2: function bulkApprovalStage2(mode) {
      var _this7 = this;

      if (mode != "yes") {
        return;
      }
      this.disablePageApprove = true;
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("showApproveProgressModal", {
        title: "データを処理します。",
        message: "しばらくお待ちください。",
        model_height: "50"
      });
      var arr = this.selected_session_ids_for_approve;
      this.$ajax.post("/" + this.api_name + "/approve", { ref_id_list: arr }, function (err, response) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("hideApproveProgressModal", {});
        }, 500);
        _this7.disablePageApprove = false;
        _this7.selected_session_ids_for_approve = [];
        _this7.selectedRowArr = [];
        _this7.formOutputQty = 0;
        console.log({ response: response });
        _this7.$store.state["current_field_style"] = {};
        _this7.$store.state["current_field_style2"] = {};
        if (err) {
          _this7.$notify({
            title: "データの承認に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("stage2ConfirmatioModal", {
              title: "承認が完了しました。",
              message: "",
              yes_label: "",
              no_label: "戻る",
              yes_color: "info",
              no_color: "default",
              model_height: "50"
            });
            _this7.gridOptions.api.purgeInfiniteCache();
          }, 300);
        }
      });
    },
    bulkApprovalStage3: function bulkApprovalStage3() {
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkApprovalStage3");
    },
    bulkApprovalStage4: function bulkApprovalStage4(mode) {
      var _this8 = this;

      this.$ajax.post("/" + this.api_name + "/approve_clear", {}, function (err, response) {
        console.log({ response: response });
        if (err) {
          _this8.$notify({
            title: "データの承認に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          _this8.gridOptions.api.purgeInfiniteCache();
          __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("stage2ConfirmatioModal", {
            title: "クリア",
            message: "確認をクリアしました。",
            yes_label: "",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      if (this.hideInternalCheckBox(data) == true) {
        var destination = "/approval_history/detail/" + data.ref_id + "/" + __WEBPACK_IMPORTED_MODULE_4_md5___default()("HIDE" + data.ref_id);
      } else {
        var destination = "/approval_history/detail/" + data.ref_id + "/" + __WEBPACK_IMPORTED_MODULE_4_md5___default()("SHOW" + data.ref_id);
      }
      return this.$router.push(destination);
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    if (this.$route.meta.mode == "rejected") {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "approval_status", val: '差戻' });
      }, 200);
    } else {
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onSearchClear", {});
    }
    this.userId = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userID") || "";
    this.isLoggedUserAdmin = this.isApproverAdminForApproveImport;
    this.$emit("selectedItemsUpd", 0);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onSearchClear", {});
  },
  beforeMount: function beforeMount() {
    var _this9 = this;

    this.$store.state[this.stateCurrentRow] = {};
    var use_data_source = true;

    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onColumnResized: function onColumnResized(ev, b) {},
      onRowSelected: function onRowSelected(ev) {},
      onModelUpdated: function onModelUpdated(ev, d) {},
      onGridReady: function onGridReady() {},
      getRowStyle: function getRowStyle(params) {
        if (_this9.isLoggedUserAdmin == true && params.node.data && params.node.data.status_final == "未承認" || _this9.approveMode == "reject" || params.node.data && params.node.data.next_approver == _this9.userId) {
          if (params.node.data && params.node.data.checked_to_reject == 1 && params.node.data.checked_user == _this9.userId && (params.node.data.is_selected == true || _this9.isAllSelected == true)) {
            return { background: "#ffb5b5" };
          } else if (params.node.data && params.node.data.checked_to_reject == 1 && (params.node.data.is_selected == true || _this9.isAllSelected == true)) {
            return {};
          } else if (params.node.data && (params.node.data.is_selected == true || _this9.isAllSelected == true)) {
            return { background: "orange" };
          }
        }
      }
    };
    this.initDatasource({ load_only_with_filter: false, loaded_cb: function loaded_cb(err, data, vm) {
        var active_approve_button = _.find(data, function (d) {
          return (_this9.isLoggedUserAdmin == true && d && d.status_final == "未承認" || d && d.next_approver == _this9.userId) && d && (d.is_selected == true || _this9.isAllSelected == true);
        });
        _this9.disablePageApprove = typeof active_approve_button == "undefined";
        var found = false;
        _.filter(data, function (r) {
          return r.checked_to_reject == 1 && r.checked_user == _this9.userId;
        }).forEach(function (e) {
          if (_this9.hideInternalCheckBox(e) == false) {
            _this9.onSelectedClickDatasource({}, e);
            found = true;
          }
        });
        _this9.approveMode = found ? "reject" : "approve";
      } });
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_bus__ = __webpack_require__(4);













var mdebug = __WEBPACK_IMPORTED_MODULE_8_debug___default()("esma:associated_device");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__["AgGridVue"],
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a,
    "information-modal": __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal___default.a
  },
  data: function data() {
    return {
      api_name: "associated_device",
      page_acl: __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default.a.associated_device,
      detail_page_url: "/certificate_information_linked_devices/list/",
      state_current_editing: "current_editing2",
      state_current_row: "current_row2",
      state_is_editing_new: "is_editing_new2",
      state_last_filter_options: "last_filter_options2",
      local_fk_id: -1
    };
  },

  computed: {
    deleteText: function deleteText() {
      if (this.disableDelete || this.formOutputQty == 0) {
        return "削除（ソフトウェア情報）";
      } else {
        return "削除（ソフトウェア情報）(" + this.formOutputQty + ")";
      }
    },
    disableDelete: function disableDelete() {
      if (this.formOutputQty > 0 && Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0) {
        return typeof _.find(this.selectedRowArr, function (d) {
          return Number(d.number_of_use) > 0;
        }) != "undefined";
      } else {
        if (isNaN(this.selected_row) == false && this.selected_row > -1 && this.numberOfUse == 0) {
          return this.read_only == false;
        } else {
          return true;
        }
      }
    },
    numberOfUse: function numberOfUse() {
      return Number(_.get(this.$store.state, this.stateCurrentEditing + ".number_of_use", _.get(this.$store.state, this.stateCurrentRow + ".number_of_use", 0)));
    },
    isAdminSavingApplication: function isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    disableNewBtn: function disableNewBtn() {
      return this.$props.disable_new_btn;
    },
    disableAllBtn: function disableAllBtn() {
      return this.$props.disable_all_btn;
    },
    disableEditBtn: function disableEditBtn() {
      return this.$props.disable_edit_btn;
    },
    hideNewBtn: function hideNewBtn() {
      return this.$props.hide_new_btn;
    },
    hideEditBtn: function hideEditBtn() {
      return this.$props.hide_edit_btn;
    },

    Second: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["second"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["second"] = this.local_status = v;
      }
    },
    readOnly: {
      get: function get() {
        return this.read_only;
      },
      set: function set(v) {
        this.read_only = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].number_cert, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].license_name, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].software_name, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].product_key, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].upgrade, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].number_of_upgrades, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].unlimited, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].license, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].second, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].second_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].number_of_use, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].the_number_of_remaining, {})];
    },
    formFields: function formFields() {
      return {
        col1: [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].license_name, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].software_name, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].product_key, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].upgrade, {
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("virtual_base_unit", { val: data == "有" });
            }, 100);
          }
        }), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].number_of_upgrades, {
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "virtual_base_unit",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        })],
        col2: [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].unlimited, {
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("upd_license_unlimited1", { val: data == "無制限" });
            }, 100);
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("upd_license_unlimited2", { val: data == "無制限" });
            }, 110);
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("upd_license_unlimited3", { val: data == "無制限" });
            }, 120);
          }
        }), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].second, {
          listen_for: [{
            name: "upd_license_unlimited2",
            mode: "disable_if_value",
            disable_if_value: false
          }],
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("upd_virtual_base_unit", { val: data == "有" });
            }, 100);
          }
        }), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].second_number, {
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_virtual_base_unit",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_associated_device__["a" /* fields */].license, {
          listen_for: [{
            name: "upd_license_unlimited3",
            mode: "disable_if_value",
            disable_if_value: false
          }]
        })]
      };
    }
  },
  methods: {
    btnCancel: function btnCancel() {
      this.commonValidateFieldsClear(this, function () {});
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("deleteAssociatedDeviceModal", {
        title: "削除",
        message: "ソフトウェア情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0) {
          var arr = this.selectedRowArr.map(function (m) {
            return m.seq_id;
          });
          var vm = this;
          this.commonDeleteArr(vm, arr, function () {
            vm.reloadDataAfterDelete(vm);
          });
        } else {
          this.commonDelete(this, function (err, result, vm) {
            vm.reloadDataAfterDelete(vm);
          });
        }
      }
    },
    reloadDataAfterDelete: function reloadDataAfterDelete(vm) {
      vm.gridOptions.api.purgeInfiniteCache();
      vm.countRows("onConfirmDelete");
      vm.$store.state[vm.stateCurrentRow] = {};
      vm.$store.state[vm.stateCurrentEditing] = {};
      vm.selected_row = -1;
      vm.selectedRowArr = [];
    },
    local_extend: function local_extend(field_info, ext) {
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(field_info, ext);
    },
    onSaveAssociatedDeviceConfirmdri: function onSaveAssociatedDeviceConfirmdri(mode) {
      var _this = this;

      this.readOnly = false;
      this.commonSaveInfo(this, this.api_name, {}, function (err) {
        _this.cancelCurrentSelection();
      });
    },
    numberOfUpgrades: function numberOfUpgrades() {
      return Number(_.get(this.$store.state, this.stateCurrentEditing + ".number_of_upgrades", _.get(this.$store.state, this.stateCurrentRow + ".number_of_upgrades", 0)));
    },
    numberOfLicenses: function numberOfLicenses() {
      return Number(_.get(this.$store.state, this.stateCurrentEditing + ".license", _.get(this.$store.state, this.stateCurrentRow + ".license", 0)));
    },
    onSaveAssociatedDeviceConfirm: function onSaveAssociatedDeviceConfirm(mode) {
      var _this2 = this;

      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        if (_this2.numberOfUpgrades() >= _this2.numberOfLicenses()) {
          _this2.$notify({ clear: true });
          _this2.$notify({
            title: "アップグレードの数が残数を超えているため、保存できません。",
            text: _this2.numberOfUpgrades() + " / " + _this2.numberOfLicenses(),
            type: "error",
            duration: 10000
          });
          return;
        }

        _this2.readOnly = false;
        _this2.commonSaveInfo(_this2, _this2.api_name, {}, function (err) {
          if (err == null) {
            _this2.$emit("data-saved", {});
          }
          _this2.cancelCurrentSelection();
        });
      });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      var seq_id = false;
      if (typeof this.$route.params.seq_id != "undefined" && isNaN(this.$route.params.seq_id) == false) {
        seq_id = this.$route.params.seq_id;
      } else if (typeof this.local_fk_id != "undefined" && isNaN(this.local_fk_id) == false) {
        seq_id = this.local_fk_id;
      }
      if (seq_id != false) {
        return this.$router.push(this.detail_page_url + data.seq_id + "/" + seq_id);
      }
    },
    createColumnDefs: function createColumnDefs() {
      var _this3 = this;

      var arr = this.defaultCreateColumn;
      _.find(arr, function (a) {
        return a.field == "seq_id";
      }).sort = null;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 10,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        if (fi.field == "number_cert") {
          fi.sort = "asc";
        }
        arr.push(fi);
      });

      [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(this.fieldList.more_details, { tab_label: "" }), this.fieldList.button_options].forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: function cellRenderer(params) {
            if (params.column.colId == "more_details") {
              return _this3.createLocalGridTextButton("機器", _this3.onDetailsClick, params.data);
            }
            if (params.column.colId == "button_options") {
              return _this3.createGridButton("glyphicon glyphicon glyphicon-unchecked", "color: #5b9bd5;", _this3.onSelectedClickDatasource, params.data);
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    },
    createLocalGridTextButton: function createLocalGridTextButton(text, onClick, row_data) {
      var _this4 = this;

      var center = document.createElement('center');
      var btn = document.createElement('button');

      btn.style.cssText = "padding: 0px 5px;margin-top:-2px;" + (this.disableAllBtn ? ";background:#ccc;border:solid 1px #bbb;" : "");
      btn.className = "btn btn-primary btn-xs";
      btn.innerHTML = '' + text + '';
      btn.addEventListener('click', function (ev) {
        if (_this4.disableAllBtn == false) {
          onClick(ev, row_data);
        }
      });
      center.appendChild(btn);
      return center;
    },
    onRowSelected: function onRowSelected(ev) {
      var _this5 = this;

      this.$notify({ clear: true });
      this.selected_row = ev.node.data.seq_id;
      this.commonOnRowSelected(this, ev, this.api_name, function (vm) {
        if (ev.node.data.upgrade == '有' && ev.node.data.number_of_use != 0) {
          _this5.$notify({
            title: "紐付されている機器が存在します。",
            text: "紐付を解除してください。",
            type: "error",
            duration: 10000
          });
          __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("associatedDeviceAlertMessage", {
            title: "",
            message: "紐付されている機器が存在します。<br>紐付を解除してください。",
            yes_label: "完了",
            large: false
          });
        }
      });
    },
    onEdit: function onEdit() {
      var _this6 = this;

      mdebug("onEdit");
      this.is_new = false;
      setTimeout(function () {
        _this6.readOnly = false;
      }, 300);
    },
    addNew: function addNew() {
      var _this7 = this;

      this.seq_id = "new";
      this.local_seq_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.selected_row = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.$store.state[this.stateCurrentRow] = {};
      this.$store.state[this.stateCurrentRow] = {
        seq_id: this.local_seq_id,
        ref_id: this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.CERTIFICATE_INFORMATION
      };
      this.$store.state[this.stateCurrentEditing] = {};
      this.$store.state[this.stateCurrentEditing] = {
        ref_id: this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: __WEBPACK_IMPORTED_MODULE_7__rules_constants___default.a.TABLE_ID.CERTIFICATE_INFORMATION
      };
      this.allFields.forEach(function (f) {
        _this7.$store.state[_this7.stateCurrentRow][f.id] = "";
      });
      this.is_new = true;
      setTimeout(function () {
        _this7.$store.state[_this7.stateIsEditingNew] = true;
        _this7.read_only = false;
      }, 300);
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.gridOptions.api.sizeColumnsToFit();
    if (this.$route.params.seq_id == "new") {
      this.commonLoadRecord({}, function (err, result) {
        console.log("Load DeviceEmbeddedInformation else", _this8.$route.params.seq_id);
        if (_this8.$route.params.seq_id == "new") {
          _this8.Second = "無";
        }
        if (typeof _this8.$store.state[_this8.stateCurrentRow].approval_history_id == "number") {
          _this8.approvalHistoryId = _this8.$store.state[_this8.stateCurrentRow].approval_history_id;
        }
        _this8.commonEditDeleteCmdHandler(_this8);
      });
    }

    if (this.$props.tag_reload && this.$props.tag_reload.length > 0) {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$on(this.$props.tag_reload, function (data) {
        setTimeout(function () {
          if (data.fk_id && isNaN(data.fk_id) == false && data.fk_id > 0) {
            _this8.local_fk_id = data.fk_id;
            _this8.searchControlChangedDatasource(_this8.singleSearchCreate("fk_id", "" + data.fk_id));
          }
        }, 10);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$props.tag_reload && this.$props.tag_reload.length > 0) {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$off(this.$props.tag_reload);
    }
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true });
  },

  props: {
    ref_id: { type: String, default: "" },
    fk_id: { type: Number, default: "" },
    tag_reload: { type: String, default: "" },
    disable_new_btn: { type: Boolean, default: false },
    disable_edit_btn: { type: Boolean, default: false },
    hide_new_btn: { type: Boolean, default: false },
    hide_edit_btn: { type: Boolean, default: false },
    disable_all_btn: { type: Boolean, default: false }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_file_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_file_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_file_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_list_modal__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_list_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_list_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_bus__ = __webpack_require__(4);















var mdebug = __WEBPACK_IMPORTED_MODULE_10_debug___default()("esma:certificate");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a,
    "information-modal": __WEBPACK_IMPORTED_MODULE_6__components_modals_information_modal___default.a,
    "certificate-list-modal": __WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_list_modal___default.a,
    "file-modal": __WEBPACK_IMPORTED_MODULE_7__components_modals_file_modal___default.a
  },
  data: function data() {
    return {
      api_name: "certificate",
      page_acl: __WEBPACK_IMPORTED_MODULE_11__rules_acl_rules___default.a.certificate,
      detail_page_url: "/certificate_information_linked_devices/list/",
      state_current_editing: "current_editing2",
      state_current_row: "current_row2",
      state_is_editing_new: "is_editing_new2",
      state_last_filter_options: "last_filter_options2",
      local_fk_id: -1,
      temp_certificate_management_number: "",
      last_selected_row: {},
      _temp: false,
      has_pdfs: false,
      show_has_pdfs: false,
      disable_edit: false,
      fields_validation_is_disabled: false
    };
  },

  computed: {
    DisabledEdit: {
      get: function get() {
        return this.disable_edit;
      },
      set: function set(v) {
        this.disable_edit = v;
      }
    },
    localDisablePDF: function localDisablePDF() {
      return typeof this.certificateSeqId == "undefined" || this.certificateSeqId == __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
    },

    hasPdfs: {
      get: function get() {
        return this.has_pdfs;
      },
      set: function set(v) {
        this.has_pdfs = v;
      }
    },
    showHasPdfs: {
      get: function get() {
        return this.show_has_pdfs;
      },
      set: function set(v) {
        this.show_has_pdfs = v;
      }
    },
    disableShowSelectCertificate: function disableShowSelectCertificate() {
      if (this.readOnly == true) {
        return true;
      }
      var e = this.$store.state[this.stateCurrentEditing];
      var r = this.$store.state[this.stateCurrentRow];
      var a = typeof e["certificate_management_number"] != "undefined" && e["certificate_management_number"] != "";
      var b = typeof r["certificate_management_number"] != "undefined" && r["certificate_management_number"] != "";
      var ret = a || b;
      return ret;
    },

    temp: {
      get: function get() {
        return this._temp;
      },
      set: function set(v) {
        this._temp = v;
      }
    },
    disableAllBtn: function disableAllBtn() {
      return this.$props.disable_all_btn;
    },
    disablePDFbtn: function disablePDFbtn() {
      return this.$props.disable_pdf_btn;
    },

    readOnly: {
      get: function get() {
        return this.read_only;
      },
      set: function set(v) {
        this.read_only = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */];
    },
    allFields: function allFields() {
      return [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].certificate_management_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].license_certificate_type, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].certificate_individual_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].sales_company, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].remark, {})];
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    formFields: function formFields() {
      return {
        col1: [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].certificate_management_number, { disabled: true, read_only: true }), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].license_certificate_type, { disabled: this.DisabledEdit, read_only: this.DisabledEdit }), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].certificate_individual_number, { disabled: this.DisabledEdit, read_only: this.DisabledEdit })],
        col2: [this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].sales_company, { disabled: this.DisabledEdit, read_only: this.DisabledEdit }), this.local_extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate__["a" /* fields */].remark, { label_length_4: true })]
      };
    },
    certificateSeqId: function certificateSeqId() {
      return parseInt(this.$store.state[this.stateCurrentRow]["seq_id"] || this.localSeqId);
    }
  },
  methods: {
    disableValidation: function disableValidation(mode) {
      this.formFields.col1.forEach(function (e) {
        e.ref_field.disabledIsRequired = mode;
        e.ref_field.localRefreshSequecnce++;
      });
      this.formFields.col2.forEach(function (e) {
        e.ref_field.disabledIsRequired = mode;
        e.ref_field.localRefreshSequecnce++;
      });
      this.fields_validation_is_disabled = mode;
    },
    pdfClosed: function pdfClosed(obj) {
      this.showHasPdfs = true;
      this.hasPdfs = parseInt(obj.qty) > 0;
    },
    openFileModal: function openFileModal() {
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("showFileModal", { fk_id: this.certificateSeqId });
    },
    showSelectCertificate: function showSelectCertificate() {
      return __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("showcertificateListModal");
    },
    oncertificateListModalSelected: function oncertificateListModalSelected(val, row) {
      if (val && val.length > 0) {
        var msg = "管理番号 '" + val + "' を割り当てます。よろしいですか？";
        this.temp_certificate_management_data = false;
        __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("showConfimationModalCertificateSelected", {
          title: "",
          message: msg,
          yes_label: "OK",
          no_label: "戻る",
          yes_color: "primary",
          model_height: 80
        });
        this.temp_certificate_management_number = val;
        this.last_selected_row = row || null;
      }
    },
    checkPDFs: function checkPDFs(seq_id) {
      var _this = this;

      this.showHasPdfs = false;
      if (isNaN(seq_id) == false) {
        this.$ajax.post('/file_upload/pdf_count/' + seq_id, {}, function (err, result) {
          _this.showHasPdfs = true;
          _this.hasPdfs = result && parseInt(result.qty) > 0;
        });
      }
    },
    showConfimationModalCertificateSelectedConfirmed: function showConfimationModalCertificateSelectedConfirmed(mode) {
      var _this2 = this;

      if (mode == "yes") {
        this.$store.state[this.stateCurrentRow]["seq_id"] = this.last_selected_row["seq_id"];
        this.$store.state[this.stateCurrentEditing]["seq_id"] = this.last_selected_row["seq_id"];
        this.allFields.forEach(function (f) {
          if (f.ref_field) {
            _this2.$store.state[_this2.stateCurrentRow][f.id] = _this2.last_selected_row[f.id];
            _this2.$store.state[_this2.stateCurrentEditing][f.id] = _this2.last_selected_row[f.id];
            f.ref_field.updateValue(_this2.last_selected_row[f.id]);
            f.ref_field.local_refresh_sequecnce++;
          }
        });
        if (this.last_selected_row && this.last_selected_row.seq_id) {
          this.checkPDFs(this.last_selected_row.seq_id);
        }
      } else if (mode == "no") {
        return __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("showcertificateListModal");
      }
    },
    local_extend: function local_extend(field_info, ext) {
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(field_info, ext);
    },
    loadRecord: function loadRecord(seq_id) {
      var _this3 = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (seq_id == "new") {
        this.local_seq_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
        this.$store.state[this.stateCurrentRow] = {
          seq_id: this.local_seq_id
        };
        this.allFields.forEach(function (f) {
          _this3.$store.state[_this3.stateCurrentRow][f.id] = "";
        });
        setTimeout(function () {
          _this3.$store.state[_this3.stateIsEditingNew] = true;

          _this3.is_new = true;
        }, 300);
        return cb(null, {});
      } else {
        this.is_new = false;
        this.local_seq_id = seq_id;
        if (typeof this.local_seq_id == "undefined") {
          console.error('UNEXPECTED REQUEST TO URL: ', '/' + this.api_name + '/get/' + this.local_seq_id);
        }
        this.$ajax.post('/' + this.api_name + '/get/' + this.local_seq_id, {}, function (err, result) {
          if (err) {
            _this3.$notify({
              title: 'データの読込に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          } else if (_this3.isObject(result) == false) {
            _this3.$notify({
              title: 'データの読込に失敗しました。',
              text: "Returned empty data",
              type: 'error',
              duration: 10000
            });
          }
          _this3.$store.state[_this3.stateCurrentRow] = result.data;
          _this3.commonSetStyleForChangedFields(result.data);
          if (result.data || isNaN(result.data.file_upload_qty) == false) {
            _this3.showHasPdfs = true;
            _this3.hasPdfs = parseInt(result.data.file_upload_qty) > 0;
          } else {
            _this3.showHasPdfs = false;
            _this3.$notify({
              title: 'データの読込に失敗しました。',
              text: "Could not count the PDFs",
              type: 'error',
              duration: 10000
            });
          }
          return cb(err, result);
        });
      }
    },
    onLoadData: function onLoadData(seq_id) {
      this.loadRecord(seq_id);
    },
    onEdit: function onEdit() {
      var _this4 = this;

      setTimeout(function () {
        _this4.readOnly = false;
      }, 300);
    },
    onSave: function onSave(cb) {
      var _this5 = this;

      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        if (_this5.is_new == false) {
          _this5.saveEditClicked = true;
        }
        _this5.commonSaveInfo(_this5, _this5.api_name, { ignore_empty_changes: true }, function (err, data) {
          _this5.cancelCurrentSelection();
          if (cb) {
            return cb(err, data);
          }
        });
      });
    },
    onCancel: function onCancel() {
      this.commonValidateFieldsClear(this, function () {});
      this.cancelCurrentSelection(true);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.DisabledEdit = this.isApproverUserId == true;
    if (this.$props.controller) {
      this.$props.controller.edit = this.onEdit;
      this.$props.controller.save = this.onSave;
      this.$props.controller.cancel = this.onCancel;
      this.$props.controller.load_data = this.onLoadData;
      this.$props.controller.disableValidation = this.disableValidation;
    }
    if (this.$route.params.seq_id == "new" || this.$route.meta.load_by == "clone") {
      this.commonLoadRecord({ force_seq_id: "new" }, function (err, result) {
        _this6.commonEditDeleteCmdHandler(_this6);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
  },

  props: ["controller", "disable_pdf_btn"]
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_device_embedded_information_add_check__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_device_embedded_information_add_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_device_embedded_information_add_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_async__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_yobiki_modal__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_yobiki_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_yobiki_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_confirmation_modal_device_link__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_confirmation_modal_device_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_confirmation_modal_device_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__rules_constants__);












var mdebug = __WEBPACK_IMPORTED_MODULE_7_debug___default()("esma:device_embedded_detail");






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("yobiki-modal", __WEBPACK_IMPORTED_MODULE_13__components_modals_yobiki_modal___default.a);


/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__["AgGridVue"],
    'field-box': __WEBPACK_IMPORTED_MODULE_6__components_form_field___default.a,
    'confirmation-modal-device-link': __WEBPACK_IMPORTED_MODULE_14__components_modals_confirmation_modal_device_link___default.a
  },
  data: function data() {
    return {
      api_name: "device_embedded_detail",
      page_acl: __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default.a.device_embedded_detail,
      detail_page: "page_0015_device_embedded_information_pegging",
      detail_page_url: "/device_embedded_information_pegging/",
      state_current_editing: "current_editing2",
      state_current_row: "current_row2",
      state_is_editing_new: "is_editing_new2",
      state_last_filter_options: "last_filter_options2",
      temp_certificate_management_number: "",
      temp_certificate_management_data: false,
      local_fk_id: -1,
      disable_cancel: false,
      last_selected_software_jurisdiction: false,
      processing_software_jurisdiction: false,
      software_jurisdictio_update_fields: [{ from: "equipment_in_charge_classification", to: "jurisdiction_classification" }, { from: "equipment_in_charge_department", to: "department_in_charge" }, { from: "equipment_in_charge_team", to: "responsible_team" }, { from: "equipment_in_charge_system_it", to: "jurisdiction_system" }, { from: "equipment_in_charge_system", to: "jurisdiction_system_name_in_use" }]

    };
  },

  computed: {
    disableCancel: {
      get: function get() {
        return this.disable_cancel;
      },
      set: function set(v) {
        this.disable_cancel = v;
      }
    },
    totalNumberOfRows: {
      get: function get() {
        return this.total_number_of_rows;
      },
      set: function set(v) {
        this.$emit('updatedtotalnumber', v);
        this.total_number_of_rows = v;
      }
    },
    deleteText: function deleteText() {
      if (this.disableDelete || this.formOutputQty == 0) {
        return "削除（組込情報）";
      } else {
        return "削除（組込情報）(" + this.formOutputQty + ")";
      }
    },
    disableDelete: function disableDelete() {
      if (this.formOutputQty > 0 && Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0) {
        return false;
      } else {
          return true;
        }
    },
    certificateManagementNumber: function certificateManagementNumber() {
      return _.get(this.$store.state, this.stateCurrentEditing + ".certificate_management_number", _.get(this.$store.state, this.stateCurrentRow + ".certificate_management_number", ""));
    },
    isAdminSavingApplication: function isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    disableNewBtn: function disableNewBtn() {
      return this.$props.disable_new_btn;
    },
    disableEditBtn: function disableEditBtn() {
      return this.$props.disable_edit_btn;
    },
    hideNewBtn: function hideNewBtn() {
      return this.$props.hide_new_btn;
    },
    hideEditBtn: function hideEditBtn() {
      return this.$props.hide_edit_btn;
    },

    readOnly: {
      get: function get() {
        return this.read_only;
      },
      set: function set(v) {
        this.read_only = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('TEST DEBUG 210803 (170 at device-embedded-detail.vue)[23:38]: ', { data_values: this.data_values });
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      var _this = this;

      return [this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_classification, {
        on_set_value: function on_set_value(data) {
          setTimeout(function () {
            _this.processJurisdictionClassification("tabFieldList/on_set_value", data);
          }, 300);
        }
      }), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].department_in_charge, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].responsible_team, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system, {
        disabled: false,
        required: true,
        field_style: " width: 100%;display: block;"
      }), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system_name_in_use, {
        disabled: false,
        required: true,
        field_style: " width: 100%;display: block;",
        listen_for: [{
          name: "upd_virtual_base_unit",
          mode: "disable_and_clean_if_value",
          disable_if_value: true
        }]
      }), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].maker, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].software, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].software_jurisdiction, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].item_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].virtual_id, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].certificate_management_number, {})];
    },
    formFields: function formFields() {
      var _this2 = this;

      return {
        col1: [this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_classification, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].department_in_charge, {
          default_from_local_storage: false
        }), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].responsible_team, {
          default_from_local_storage: false
        }), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system_name_in_use, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].maker, {})],
        col2: [this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].software, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].software_jurisdiction, {
          on_set_value: function on_set_value(data) {
            _this2.processing_software_jurisdiction = true;
            _this2.last_selected_software_jurisdiction = data;

            _this2.disableExternalField("formFields_1", "item_number", data == "プレインストール", true);
            _this2.disableExternalField("formFields_2", "certificate_management_number", data == "プレインストール" || data == "リース/レンタル", true, true);

            _this2.disableExternalField("formFields_2.1", "maker", data != "プレインストール" && data != "リース/レンタル" && _this2.getFieldLastValue("certificate_management_number", "") != "", true, true);
            _this2.disableExternalField("formFields_2.2", "software", data != "プレインストール" && data != "リース/レンタル" && _this2.getFieldLastValue("certificate_management_number", "") != "", true, true);

            if (data == "当該部署所管" && _this2.getFieldLastValue("certificate_management_number", "") == "") {
              _this2.software_jurisdictio_update_fields.forEach(function (ch_fld) {
                var org_val = _this2.$store.state["current_editing"][ch_fld.from] || _this2.$store.state["current_row"][ch_fld.from] || "CLEAR_VALUE";
                _this2.disableExternalField("formFields_4.1", ch_fld.to, true, false, true, org_val);
                _this2.processSoftwareJurisdiction(data, null, function () {
                  _this2.processing_software_jurisdiction = false;
                });
              });
            } else if (_this2.readOnly == false) {
              if (data == "プレインストール") {
                _this2.disableExternalField("formFields_3", "certificate_management_number", data == "プレインストール", true, true, "CLEAR_VALUE");
                _this2.software_jurisdictio_update_fields.forEach(function (ch_fld) {
                  var org_val = _this2.$store.state["current_editing"][ch_fld.from] || _this2.$store.state["current_row"][ch_fld.from] || "CLEAR_VALUE";
                  _this2.disableExternalField("formFields_4", ch_fld.to, true, true, true, org_val);
                });
              } else if (_this2.getFieldLastValue("certificate_management_number", "") == "") {
                _this2.software_jurisdictio_update_fields.forEach(function (ch_fld) {
                  _this2.disableExternalField("formFields_5", ch_fld.to, true, true, true, "CLEAR_VALUE");
                });
              }
            }

            _this2.processSoftwareJurisdiction(data, null, function () {
              _this2.processing_software_jurisdiction = false;
            });
          }
        }), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].item_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].virtual_id, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_detail__["a" /* fields */].certificate_management_number, {
          on_set_value: function on_set_value(data) {
            if (_this2.processing_software_jurisdiction == false) {
              setTimeout(function () {
                _this2.disableExternalField("formFields_6", "maker", true, true, true);
                _this2.disableExternalField("formFields_7", "software", true, true, true);
                _this2.processSoftwareJurisdiction(null, data);
              }, 200);
            }
          },
          disabled: false,
          required: true,
          force_readonly: true,
          field_style: " width: 100%;display: block;",
          buttons: [{
            btn_style: "width:100%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 10px;background: #43c9de;border-color:#43c9de;",
            type: "callback",
            callback: function callback(b) {
              _this2.yobikiPopUp();
            },
            label: "証書" }]
        })]
      };
    },
    approvalMode: function approvalMode() {
      return this.$route.meta.approval_mode || false;
    }
  },
  methods: {
    processSoftwareJurisdiction: function processSoftwareJurisdiction(software_jurisdiction, certificate_management_number) {
      var _this3 = this;

      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      var fields_arr = ["maker", "software"];
      var fields_arr_disable_for_all = ["jurisdiction_classification", "department_in_charge", "responsible_team", "jurisdiction_system", "jurisdiction_system_name_in_use"];
      software_jurisdiction = software_jurisdiction || this.getFieldLastValue("software_jurisdiction");
      certificate_management_number = certificate_management_number || this.getFieldLastValue("certificate_management_number", "");
      fields_arr_disable_for_all.forEach(function (f) {
        _this3.disableExternalField("processSoftwareJurisdiction_1", f, true);
      });
      if (software_jurisdiction == "リース/レンタル") {
        this.software_jurisdictio_update_fields.forEach(function (ch_fld) {
          var org_val = _this3.getFieldLastValue(ch_fld.to, "CLEAR_VALUE");
          _this3.disableExternalField("processSoftwareJurisdiction_4", ch_fld.to, false, true, true);
          _this3.disableExternalField("processSoftwareJurisdiction_4", ch_fld.to, false, false, true);
        });
        fields_arr.forEach(function (f) {
          _this3.disableExternalField("processSoftwareJurisdiction_5", f, false);
        });
      } else if (software_jurisdiction == "当該部署所管" || certificate_management_number == "" || certificate_management_number == null) {
        fields_arr.forEach(function (f) {
          _this3.disableExternalField("processSoftwareJurisdiction_2", f, false);
        });
      } else {
        fields_arr.forEach(function (f) {
          _this3.disableExternalField("processSoftwareJurisdiction_3", f, true);
        });
      }
      setTimeout(function () {
        if (_this3.local_fields_ref && _this3.local_fields_ref.jurisdiction_classification && _this3.local_fields_ref.jurisdiction_classification.ref_field) {
          return _this3.processJurisdictionClassification("process SoftwareJurisdiction", _this3.local_fields_ref.jurisdiction_classification.ref_field.fieldValue, cb);
        } else {
          return cb();
        }
      }, 100);
    },
    processJurisdictionClassification: function processJurisdictionClassification(requester, data) {
      var _this4 = this;

      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      if (data == " " || data == "") {
        if (this.read_only == false) {
          setTimeout(function () {
            var jurisdiction_classification = _this4.getFieldLastValue("jurisdiction_classification", "");
            if (jurisdiction_classification == "" || jurisdiction_classification == " ") {
              _this4.disableExternalField(requester + ">" + "process JurisdictionClassification_8", "jurisdiction_system", false, true, false, "CLEAR_VALUE");
              _this4.disableExternalField(requester + ">" + "process JurisdictionClassification_2", "jurisdiction_system_name_in_use", false, true, false, "CLEAR_VALUE");
            }
            return cb();
          }, 300);
        }
      } else if (data == "IT所管システム") {
        if (this.read_only == false) {
          var jurisdiction_system = this.getFieldLastValue("jurisdiction_system", "");

          if (jurisdiction_system == "所管区分：EUC・その他を選択した場合は入力不要") {
            this.disableExternalField(requester + ">" + "process JurisdictionClassification_1", "jurisdiction_system", false, true, true, "CLEAR_VALUE");
          } else {
            this.disableExternalField(requester + ">" + "process JurisdictionClassification_1", "jurisdiction_system", false, true, true);
          }
          this.disableExternalField(requester + ">" + "process JurisdictionClassification_2", "jurisdiction_system_name_in_use", true, true);
          return cb();
        }
      } else if (data == "EUC・その他") {
        if (this.read_only == false) {
          this.disableExternalField(requester + ">" + "process JurisdictionClassification_3", "jurisdiction_system_name_in_use", false, true);
        }
        var software_jurisdiction = this.getFieldLastValue("software_jurisdiction", "");
        if (software_jurisdiction == "リース/レンタル") {
          if (this.read_only == true) {
            this.disableExternalField(requester + ">" + "process JurisdictionClassification_4", "jurisdiction_system", false, true, false, "所管区分：EUC・その他を選択した場合は入力不要");
          } else {
            this.disableExternalField(requester + ">" + "process JurisdictionClassification_5", "jurisdiction_system", true, true, false, "所管区分：EUC・その他を選択した場合は入力不要");
          }
        } else if (software_jurisdiction == "他部署所管") {
          this.disableExternalField(requester + ">" + "process JurisdictionClassification_6", "jurisdiction_system", true, true, false, "CLEAR_VALUE");
        } else {
          this.disableExternalField(requester + ">" + "process JurisdictionClassification_7", "jurisdiction_system", false, true, false, "所管区分：EUC・その他を選択した場合は入力不要");
        }
        return cb();
      }
    },
    disableExternalField: function disableExternalField(requester, field_id, disable) {
      var local = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var force_preserve_value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var set_value = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      if (this.local_fields_ref && this.local_fields_ref[field_id] && this.local_fields_ref[field_id].ref_field) {
        var edited_value = false;
        if (force_preserve_value) {
          edited_value = this.getFieldLastValue(field_id, "");
        }
        if (local) {
          this.local_fields_ref[field_id].ref_field.localDisabled = disable;
        } else {
          this.local_fields_ref[field_id].ref_field.externalDisabled = disable;
        }
        if (force_preserve_value && edited_value) {
          this.$store.state[this.stateCurrentRow][field_id] = edited_value;
          this.local_fields_ref[field_id].ref_field.updateValue(edited_value);
          this.local_fields_ref[field_id].ref_field.localRefreshSequecnce++;
        }
        if (set_value) {
          if (set_value == "CLEAR_VALUE") {
            set_value = "";
          }
          this.$store.state[this.stateCurrentRow][field_id] = set_value;
          this.local_fields_ref[field_id].ref_field.updateValue(set_value);
          this.local_fields_ref[field_id].ref_field.localRefreshSequecnce++;
        }
      }
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("deleteDeiveEmbeddedDetailModal", {
        title: "削除",
        message: "組込情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0) {
          var arr = this.selectedRowArr.map(function (m) {
            return m.seq_id;
          });
          var vm = this;
          this.commonDeleteArr(vm, arr, function () {
            vm.reloadDataAfterDelete(vm);
          });
        } else {
          this.commonDelete(this, function (err, result, vm) {
            vm.reloadDataAfterDelete(vm);
          });
        }
      }
    },
    reloadDataAfterDelete: function reloadDataAfterDelete(vm) {
      vm.gridOptions.api.purgeInfiniteCache();
      vm.countRows("onConfirmDelete");
      vm.$store.state[vm.stateCurrentRow] = {};
      vm.$store.state[vm.stateCurrentEditing] = {};
      vm.selected_row = -1;
      vm.selectedRowArr = [];
    },
    local_extend: function local_extend(field_info, ext) {
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      var r = __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(field_info, ext);
      this.local_fields_ref[r.id] = r;
      return r;
    },
    btnCancel: function btnCancel() {
      this.commonValidateFieldsClear(this, function () {});
      this.cancelCurrentSelection(true);
    },
    validateItemNumberQty: function validateItemNumberQty(cb) {
      this.$notify({
        title: "エラー",
        text: "割り当てるライセンス数がライセンス残数を上回っています。",
        type: "error",
        duration: 10000
      });
      cb();
    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirmdri: function onSubTableDeviceEmbeddedInformationAddCheckConfirmdri(mode) {
      var _this5 = this;

      this.validateItemNumberQty(function (err) {
        if (err) {
          return;
        }
        _this5.readOnly = false;
        _this5.commonSaveInfo(_this5, _this5.api_name, {});
      });
    },
    onLocalSaveSubDevEmbeddedOnApprove: function onLocalSaveSubDevEmbeddedOnApprove() {
      var _this6 = this;

      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        if (_this6.is_new == false) {
          _this6.saveEditClicked = true;
        }
        __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("confirmSubDeviceEmbeddedInformationAddCheckOnApprove", {
          message: "よろしいですか？",
          title: "登録情報を上書保存します。",
          yes_label: "上書保存",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirmOnApprove: function onSubTableDeviceEmbeddedInformationAddCheckConfirmOnApprove(mode) {
      var _this7 = this;

      if (mode == "yes") {
        this.validateItemNumberQty(function (err) {
          if (err) {
            return;
          }
          _this7.commonValidateFields(_this7, {}, function (error_found) {
            if (error_found != false) {
              return;
            }
            _this7.readOnly = false;
            _this7.commonSaveInfo(_this7, _this7.api_name, {}, function (err) {
              if (err) {} else {
                __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("notificationAfterSaveDetails", {
                  message: "",
                  title: "登録情報を上書保存しました。",
                  yes_label: "",
                  no_label: "OK",
                  yes_color: "",
                  no_color: "",
                  model_height: "50"
                });
              }
            });
          });
        });
      }
    },
    onLocalSaveSubDevEmbedded: function onLocalSaveSubDevEmbedded() {
      var _this8 = this;

      var message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>承認状態が【下書中】となるので、申請が必要になります。</span>";

      if (this.showapprovalStatus == true) {
        message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>※承認状態が【承認済】のものは【下書中】になります。 </span>";
      }
      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        if (_this8.is_new == false) {
          _this8.saveEditClicked = true;
        }
        console.log("onLocalSave");
        __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("confirmSubDeviceEmbeddedInformationAddCheck", {
          message: message,
          title: "登録情報を下書保存します。",
          yes_label: "下書保存",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "100",
          model_width: "450px"
        });
      });
    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirm: function onSubTableDeviceEmbeddedInformationAddCheckConfirm(mode) {
      var _this9 = this;

      if (mode == "yes") {
        this.validateItemNumberQty(function (err) {
          if (err) {
            return;
          }

          _this9.commonValidateFields(_this9, {}, function (error_found) {
            if (error_found != false) {
              return;
            }
            _this9.readOnly = false;
            _this9.$emit("data-saved", function (err) {
              if (err == null) {
                _this9.commonSaveInfo(_this9, _this9.api_name, {}, function (err) {
                  if (err) {} else {
                    __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("notificationAfterSaveDetails", {
                      message: "",
                      title: "登録情報を下書保存しました。",
                      yes_label: "",
                      no_label: "OK",
                      yes_color: "",
                      no_color: "",
                      model_height: "50"
                    });
                  }
                });
              } else {
                _this9.disableCancel = true;
              }
            });
          });
        });
      }
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      this.$notify({ clean: true });
      if (data.certificate_management_number && data.certificate_management_number.length > 0) {
        window.sessionStorage.setItem('certificate_back_to_list', "/device_embedded_information/" + this.local_fk_id);
        return this.$router.push("/certificate/n/" + data.certificate_management_number);
      } else {
        this.$notify({
          title: "エラー",
          text: "証書情報とのリンクはありません。",
          type: "error",
          duration: 2000
        });
      }
    },
    createColumnDefs: function createColumnDefs() {
      var _this10 = this;

      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        arr.push(fi);
      });
      [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(this.fieldList.more_details, { tab_label: "-" }), this.fieldList.button_options].forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: function cellRenderer(params) {
            if (params.column.colId == "more_details") {
              return _this10.createLocalGridTextButton("証書", _this10.onDetailsClick, params.data);
            }
            if (params.column.colId == "button_options") {
              return _this10.createGridButton("glyphicon glyphicon glyphicon-unchecked", "color: #5b9bd5;", _this10.onSelectedClickDatasource, params.data);
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    },
    createLocalGridTextButton: function createLocalGridTextButton(text, onClick, row_data) {
      var center = document.createElement('center');
      var btn = document.createElement('button');
      btn.style.cssText = "padding: 0px 5px;margin-top:-2px;" + (!(row_data && row_data.certificate_management_number && row_data.certificate_management_number.length > 0) ? ";background:#ccc;border:solid 1px #bbb;" : "");
      btn.className = "btn btn-primary btn-xs";
      btn.innerHTML = '' + text + '';
      btn.addEventListener('click', function (ev, data) {
        onClick(ev, row_data);
      });
      center.appendChild(btn);
      return center;
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
      this.$store.state[this.stateCurrentEditing] = {};
      this.$store.state[this.stateCurrentRow] = {};
      this.commonOnRowSelected(this, ev, this.api_name, function (vm) {
        if (typeof vm.$store.state[vm.stateCurrentEditing].certificate_management_number == "undefined" || vm.$store.state[vm.stateCurrentEditing].certificate_management_number == null || vm.$store.state[vm.stateCurrentEditing].certificate_management_number == "") {
          vm.$store.state[vm.stateCurrentEditing].certificate_management_number = vm.$store.state[vm.stateCurrentRow].certificate_management_number || "";
        }
      });
    },
    onEdit: function onEdit() {
      var _this11 = this;

      this.disableCancel = false;
      mdebug("onEdit");
      if (this.local_fields_ref["jurisdiction_classification"] && this.local_fields_ref["jurisdiction_classification"].ref_field && this.local_fields_ref["jurisdiction_classification"].ref_field.data && this.local_fields_ref["jurisdiction_classification"].ref_field.data.options) {
        if (this.local_fields_ref["jurisdiction_classification"].ref_field.data.options[0] == " ") {
          this.local_fields_ref["jurisdiction_classification"].ref_field.data.options.shift();
        }
      }
      setTimeout(function () {
        _this11.readOnly = false;
        if (_this11.local_fields_ref && _this11.local_fields_ref.jurisdiction_classification && _this11.local_fields_ref.jurisdiction_classification.ref_field) {
          _this11.processJurisdictionClassification("onEdit", _this11.local_fields_ref.jurisdiction_classification.ref_field.fieldValue);
        }
      }, 300);
    },
    addNew: function addNew() {
      var _this12 = this;

      this.disableCancel = false;
      this.local_seq_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.selected_row = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.$store.state[this.stateCurrentRow] = {};
      this.$store.state[this.stateCurrentRow] = {
        seq_id: this.local_seq_id,
        ref_id: this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION
      };
      this.$store.state[this.stateCurrentEditing] = {};
      this.$store.state[this.stateCurrentEditing] = {
        ref_id: this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION
      };

      this.allFields.forEach(function (f) {
        _this12.$store.state[_this12.stateCurrentRow][f.id] = "";
      });
      setTimeout(function () {
        _this12.$store.state[_this12.stateIsEditingNew] = true;
        _this12.read_only = false;
        _this12.is_new = true;
      }, 300);
      mdebug("mounted as new");
      if (this.local_fields_ref["jurisdiction_classification"] && this.local_fields_ref["jurisdiction_classification"].ref_field && this.local_fields_ref["jurisdiction_classification"].ref_field.data && this.local_fields_ref["jurisdiction_classification"].ref_field.data.options) {
        if (this.local_fields_ref["jurisdiction_classification"].ref_field.data.options.indexOf(" ") < 0) {
          this.local_fields_ref["jurisdiction_classification"].ref_field.data.options.unshift(" ");
        }
      }
    },
    confirmedSetYobiki: function confirmedSetYobiki(mode, qty) {
      if (mode == "yes") {
        console.log('TEST DEBUG 210508 (443 at device-embedded-detail.vue)[01:01]: ', { num: this.temp_certificate_management_number, mode: mode, qty: qty });
        __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("management_number_force_update", this.temp_certificate_management_number);
        __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("licence_item_number_force_update", qty);


        this.localCertificateDetails();
      } else if (mode == "no") {
        return __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("showYobikiModal", { device_control_number: this.local_fk_id, software_jurisdiction: this.last_selected_software_jurisdiction });
      }
    },
    localCertificateDetails: function localCertificateDetails() {
      var _this13 = this;

      if (this.isObject(this.temp_certificate_management_data) && isNaN(this.temp_certificate_management_data.seq_id) == false && this.temp_certificate_management_data.seq_id > -1) {
        this.$ajax.post('/certificate_software/get/' + this.temp_certificate_management_data.seq_id, {}, function (err, result) {
          if (err) {
            _this13.$notify({
              title: "エラー",
              text: "Can not find related 証書情報 data.",
              type: "error",
              duration: 2000
            });
          } else if (_this13.isObject(result) && _this13.isObject(result.data)) {
            __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("software_force_update", _this13.temp_certificate_management_data.software_name);

            var upd_fld_list = [{ from: "jurisdiction_classification", to: "jurisdiction_classification_force_update" }, { from: "licensed_department", to: "department_in_charge_force_update" }, { from: "license_jurisdiction_team", to: "responsible_team_force_update" }, { from: "maker", to: "maker_force_update" }];
            if (result && result.data && result.data.jurisdiction_classification == "IT所管システム") {
              upd_fld_list.push({ from: "license_jurisdiction_system", to: "jurisdiction_system_force_update" });
            } else if (result && result.data && result.data.jurisdiction_classification == "EUC・その他") {
              upd_fld_list.push({ from: "equipment_in_charge_system", to: "jurisdiction_system_name_in_use_force_update" });
            } else {}

            __WEBPACK_IMPORTED_MODULE_8_async___default.a.mapLimit(upd_fld_list, 1, function (ufl, done) {
              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit(ufl.to, result.data[ufl.from]);
                done();
              }, 150);
              __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit(ufl.to, result.data[ufl.from]);
            }, function (err, allDone) {});
          }
        });
      }
    },
    yobikiPopUp: function yobikiPopUp() {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("showYobikiModal", { device_control_number: this.local_fk_id, software_jurisdiction: this.last_selected_software_jurisdiction });
    },
    onYobikiModalSelected: function onYobikiModalSelected(val, row) {
      if (val && val.length > 0) {
        this.temp_certificate_management_data = false;
        if (row) {
          this.temp_certificate_management_data = row;
        }
        console.log('TEST DEBUG 210508 (529 at device-embedded-detail.vue)[01:39]: ', { row: row });
        __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("showConfimationModalSetYobiki", {
          title: "",
          link_number: val,
          max_qty: row.remaining_number || false
        });
        this.temp_certificate_management_number = val;
      }
    }
  },
  mounted: function mounted() {
    var _this14 = this;

    this.gridOptions.api.sizeColumnsToFit();
    console.log("device_embedded_detail mounted");
    if (this.$props.tag_reload && this.$props.tag_reload.length > 0) {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$on(this.$props.tag_reload, function (data) {
        setTimeout(function () {
          if (data.fk_id && isNaN(data.fk_id) == false && data.fk_id > 0) {
            _this14.local_fk_id = data.fk_id;
            _this14.searchControlChangedDatasource(_this14.singleSearchCreate("fk_id", "" + data.fk_id));
          } else if (data.clear_list && isNaN(data.clear_list) == false && data.clear_list == true) {
            var selected_row = _this14.selected_row;
            _this14.gridOptions.api.purgeInfiniteCache();
            _this14.countRows("device-embedded-detail");
            if (_this14.$store.state[_this14.stateCurrentRow].software_jurisdiction == "プレインストール" || _this14.$store.state[_this14.stateCurrentEditing].software_jurisdiction == "プレインストール") {
              if (selected_row != __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a) {
                _this14.commonLoadRecord({ force_seq_id: selected_row });
              }
            }
          }
        }, 10);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$props.tag_reload && this.$props.tag_reload.length > 0) {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$off(this.$props.tag_reload);
    }
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true });
  },

  props: {
    ref_id: { type: String, default: "" },

    tag_reload: { type: String, default: "" },
    disable_new_btn: { type: Boolean, default: false },
    disable_edit_btn: { type: Boolean, default: false },
    hide_new_btn: { type: Boolean, default: false },
    hide_edit_btn: { type: Boolean, default: false }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__);









var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()("esma:inventory_certificate_list");







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "inventory_certificate_list",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.inventory,
      inventory_sub_search: {}
    };
  },

  computed: {
    EditableUser: function EditableUser() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_10__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_10__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF;
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].certificate_software_number, { label: "証書管理番号" }), __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].license_name, __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].software_name, __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].license, __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].effective_number, __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].remaining_number];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].certificate_software_number, { tab_label: "証書管理番号", tab_size: 20 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].license_name, { tab_size: 30 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].software_name, { tab_size: 30 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].license, { tab_size: 10 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].effective_number, { tab_size: 10 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_certificate_list__["a" /* fields */].remaining_number, { tab_size: 10 })];
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("runinventorycertificatelistDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        sub_search: this.inventory_sub_search,
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/inventory_certificate_list/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    addNewReport: function addNewReport() {
      window.sessionStorage.setItem('device_back_to_list', "/inventory_management");
      return this.$router.push({ name: "page_0071_inventory_report", params: { seq_id: "new", sub_search: this.inventory_sub_search } });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: false, show_checkbox: false, force_sort: { id: "certificate_software_number", direction: "asc" } });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    onSearchClear: function onSearchClear() {
      this.emulateSearchControlChangedDatasource(true);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.gridOptions.api.sizeColumnsToFit();
    __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$on("inventory_sub_search", function (data) {
      _this.inventory_sub_search = data.search_data;
      _this.gridOptions.api.purgeInfiniteCache();
      _this.countRows("inventory_certificate_list");
    });
    this.inventory_sub_search = this.$props.searchData;
    this.emulateSearchControlChangedDatasource();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$off("inventory_sub_search");
  },
  beforeMount: function beforeMount() {
    this.api_request_options = { sub_search: "inventory_sub_search" };
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true, loaded_cb: function loaded_cb(_err, _data) {} });
  },

  props: ["searchData"]
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_inventory_summary_box__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_inventory_summary_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_inventory_summary_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_device_management_ledger_modal__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_device_management_ledger_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_device_management_ledger_modal__);









var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:inventory_managment');








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__["AgGridVue"],
    'device-management-ledger-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_device_management_ledger_modal___default.a,
    "inventory-summary-box": __WEBPACK_IMPORTED_MODULE_10__components_inventory_summary_box___default.a
  },
  data: function data() {
    return {
      api_name: "device_embedded_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.inventory,

      detail_page: "page_0010_device_embedded_information_detail",
      inventory_sub_search: {}
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].computer_name, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].registration_date, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].manufacture_name, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].model_name, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].installation_base, __WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].user_name];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].manufacture_name, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].model_name, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].installation_base, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_device_embedded_information__["a" /* fields */].remarks, {})];
    }
  },
  methods: {
    addNewReport: function addNewReport() {
      return this.$router.push({ name: "page_0071_inventory_report", params: { seq_id: "new" } });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("showInventoryManagmentModal", { fk_id: data.seq_id });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: false });
    },
    onSearchClear: function onSearchClear() {
      this.emulateSearchControlChangedDatasource(true);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.gridOptions.api.sizeColumnsToFit();
    __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$on("inventory_sub_search", function (data) {
      _this.inventory_sub_search = data.search_data;
      _this.gridOptions.api.purgeInfiniteCache();
      _this.countRows("inventory_managment");
    });
    this.inventory_sub_search = this.$props.searchData;
    this.emulateSearchControlChangedDatasource();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$off("inventory_sub_search");
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.api_request_options = { sub_search: "inventory_sub_search" };
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true, loaded_cb: function loaded_cb(_err, _data) {} });
  },

  props: ["searchData"]
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:inventory_pending_items");







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "individual_linking_details",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.inventory,
      inventory_sub_search: {},
      loading_count_box_data: false
    };
  },

  computed: {
    EditableUser: function EditableUser() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_8__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_8__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF;
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].device_control_number, __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].certificate_software_number, __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].software, __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].jurisdiction_classification, __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].software_jurisdiction, __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].floor, __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].installation_base, __WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].remarks];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].device_control_number, { tab_size: 15 }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].certificate_software_number, { tab_size: 15 }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].software, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].software_jurisdiction, { tab_size: 13 }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].floor, { tab_size: 5 }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].installation_base, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_individual_linking_details__["a" /* fields */].remarks, { tab_size: 40 })];
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      var url = "/" + this.api_name + "/export_data/";
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("runinventorypendingitemsDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        sub_search: this.inventory_sub_search,
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: url
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    addNewReport: function addNewReport() {
      window.sessionStorage.setItem('device_back_to_list', "/inventory_management");
      return this.$router.push({ name: "page_0071_inventory_report", params: { seq_id: "new", sub_search: this.inventory_sub_search } });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: false, show_checkbox: false, force_sort: { id: "device_control_number", direction: "asc" } });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    onSearchClear: function onSearchClear() {
      this.emulateSearchControlChangedDatasource(true);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.gridOptions.api.sizeColumnsToFit();
    __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$on("inventory_sub_search", function (data) {
      _this.inventory_sub_search = data.search_data;
      _this.gridOptions.api.purgeInfiniteCache();
      _this.countRows("inventory_pending_items", { counted_cb: function counted_cb(err, count) {
          if (err == null && count == 0) {}
        } });
    });
    this.inventory_sub_search = this.$props.searchData;
    this.emulateSearchControlChangedDatasource();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$off("inventory_sub_search");
  },
  beforeMount: function beforeMount() {
    this.api_request_options = { sub_search: "inventory_sub_search" };
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter: true, loaded_cb: function loaded_cb(_err, _data) {} });
  },

  props: ["searchData"]
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:master_user');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_user",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master_user,
      execute_filter_on_back: true,
      limit_user_ids: [],
      state_last_filter_options: "last_filter_options",
      state_is_editing_new: "is_editing_new",
      state_current_row: "current_row"
    };
  },

  computed: {
    limitUserIds: {
      get: function get() {
        return this.limit_user_ids;
      },
      set: function set(v) {
        this.limit_user_ids = v;
      }
    },
    localShowSearch: function localShowSearch() {
      if (this.$props.showSearch == true) {
        return true;
      } else {
        return false;
      }
    },
    localAllUserIds: function localAllUserIds() {
      if (this.$props.allUserIds == true) {
        return true;
      } else {
        return false;
      }
    },
    localTabStyle: function localTabStyle() {
      if (typeof this.$props.tabStyle == "undefined" || this.$props.tabStyle == '') {
        return "width: 100%; height: 400px";
      } else {
        return this.$props.tabStyle;
      }
    },
    localShowDetailsButtons: function localShowDetailsButtons() {
      if (this.$props.showDetailsButtons == true) {
        return true;
      } else {
        return false;
      }
    },
    localShowCheckBox: function localShowCheckBox() {
      if (this.$props.showCheckBox == true) {
        return true;
      } else {
        return false;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["a" /* fields */].user_id, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["a" /* fields */].user_shimei, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["a" /* fields */].role, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_master_user__["a" /* fields */].team, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      this.$emit("onDetailsClick", data.seq_id);
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: this.localShowDetailsButtons, show_checkbox: this.localShowCheckBox });
    },
    onRowSelected: function onRowSelected(ev) {
      this.$emit("selected", [ev.node.data.seq_id]);
      this.clearSelectionsDatasource();
    },
    onArraySelected: function onArraySelected(ev) {
      this.$emit("selected", this.selectedRowArr.map(function (m) {
        return m.seq_id;
      }));
    },
    on_emails_loaded: function on_emails_loaded(err, rows) {
      var emails = "";
      rows.forEach(function (f) {
        if (emails.length > 0) {
          emails += ",";
        }
        if (f.mail_address) {
          emails += f.mail_address.trim();
        }
      });
      this.$emit("email_list_updated", emails);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.limitUserIds = {
      mode: this.$props.subSearchMode || "only",
      list: this.$props.searchData
    };
    this.emulateSearchControlChangedDatasource();
    this.gridOptions.api.sizeColumnsToFit();
    if (this.$props.refreshTag && this.$props.refreshTag.length > 0) {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$on(this.$props.refreshTag, function (data) {

        _this.limitUserIds = {
          mode: _this.$props.subSearchMode || "only",
          list: data
        };
        _this.emulateSearchControlChangedDatasource();
        _this.gridOptions.api.sizeColumnsToFit();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$props.refreshTag && this.$props.refreshTag.length > 0) {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$off(this.$props.refreshTag);
    }
  },
  beforeMount: function beforeMount() {

    if (this.$props.sourceState == "2" || this.$props.sourceState == 2) {
      this.state_last_filter_options = "last_filter_options2";
      this.state_is_editing_new = "is_editing_new2";
      this.state_current_row = "current_row2";
    }

    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = { only_with_email: true, sub_search: "limitUserIds" };
    if (this.localAllUserIds == false) {
      this.initDatasource({ load_only_with_filter: true, loaded_cb: this.on_emails_loaded });
    } else {
      this.initDatasource({ loaded_cb: this.on_emails_loaded });
    }
  },

  props: ["searchData", "showSearch", "showDetailsButtons", "showCheckBox", "tabStyle", "allUserIds", "sourceState", "refreshTag", "subSearchMode"]
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:master_user");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "temp_associated_device",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.associated_device
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].ref_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].software_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].product_key, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].unlimited, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].license, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].upgrade, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].number_of_upgrades, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].second, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_associated_device__["a" /* fields */].second_number, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs: function createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        arr.push(fi);
      });

      return arr;
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_temp_batch_import__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);









var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:master_user");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "batch_import_export",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      allow_check_box: false,
      get_row_style_background: "#ffb5b5",
      save_check_event: false,
      download_url: "",
      count_errors: 0,
      filer_by_error: false,
      show_confirmed_btn: false,
      initial_retraction_reason: "",
      retraction_reason_value: "",
      disable_retraction_reason: true,
      approval_status: "",
      local_seq_id: false,
      disable_edit_retraction_reason: false,
      cancelable_arr: []
    };
  },

  computed: {
    cancelableArr: {
      get: function get() {
        return this.cancelable_arr;
      },
      set: function set(v) {
        this.cancelable_arr = v;
      }
    },
    disableEditRetractionReason: {
      get: function get() {
        return this.disable_edit_retraction_reason;
      },
      set: function set(v) {
        this.disable_edit_retraction_reason = v;
      }
    },
    initialRetractionReason: {
      get: function get() {
        return this.initial_retraction_reason;
      },
      set: function set(v) {
        this.initial_retraction_reason = v;
      }
    },
    showRetractionReason: function showRetractionReason() {
      return this.formOutputQty > 0;
    },

    retractionReasonValue: {
      get: function get() {
        return this.retraction_reason_value;
      },
      set: function set(v) {
        this.retraction_reason_value = v;
      }
    },
    localSeqId: {
      get: function get() {
        return this.local_seq_id;
      },
      set: function set(v) {
        this.local_seq_id = v;
      }
    },
    disableRetractionReason: {
      get: function get() {
        return this.disable_retraction_reason;
      },
      set: function set(v) {
        this.$emit("editing", v == false);
        this.disable_retraction_reason = v;
      }
    },
    showConfirmedBtn: {
      get: function get() {
        return this.show_confirmed_btn;
      },
      set: function set(v) {
        this.show_confirmed_btn = v;
      }
    },
    filerByError: {
      get: function get() {
        return this.filer_by_error;
      },
      set: function set(v) {
        this.filer_by_error = v;
      }
    },
    countErrors: {
      get: function get() {
        return this.count_errors;
      },
      set: function set(v) {
        this.count_errors = v;
      }
    },
    downloadUrl: {
      get: function get() {
        return this.download_url;
      },
      set: function set(v) {
        this.download_url = v;
      }
    },
    saveCheckEvent: {
      get: function get() {
        return this.save_check_event;
      },
      set: function set(v) {
        this.save_check_event = v;
      }
    },
    getRowStyleBackground: {
      get: function get() {
        return this.get_row_style_background;
      },
      set: function set(v) {
        this.get_row_style_background = v;
      }
    },
    localAllowCheckBox: {
      get: function get() {
        return this.allow_check_box;
      },
      set: function set(v) {
        this.allow_check_box = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_temp_batch_import__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_temp_batch_import__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return _.filter(__WEBPACK_IMPORTED_MODULE_2__rules_fields_temp_batch_import__["a" /* fields */].array, function (f) {
        return f.import_details.p != null && f.id != "more_details" && f.id != "button_options";
      });
    },
    tabFieldList2: function tabFieldList2() {
      var remove_fields = ["ci_mb_department_code", "ci_licensed_department", "ci_mb_team_code", "ci_license_jurisdiction_team", "ci_jurisdiction_classification", "ci_ms_system_code", "ci_license_jurisdiction_system", "ci_equipment_in_charge_system", "ci_license_certificate_type", "ci_certificate_individual_number", "ci_mm_seq_id", "ci_maker", "ci_applicant_name", "ci_management_person_name", "ci_comprehensive_contract", "ci_sales_company", "ci_deadline_alert", "ci_expiration_date", "ci_maintenance_deadline", "ad_license_name", "ad_ms_software_code", "ad_software_name", "ad_product_key", "ad_unlimited", "ad_second", "ad_second_number"];
      var r = _.filter(__WEBPACK_IMPORTED_MODULE_2__rules_fields_temp_batch_import__["a" /* fields */].array, function (f) {
        return f.import_details.p != null && f.id != "more_details" && f.id != "button_options" && remove_fields.indexOf(f.id) < 0;
      });
      return r;
    }
  },
  methods: {
    hideCheckBox: function hideCheckBox(data) {
      return this.localAllowCheckBox == false;
    },
    onRejectedConfirmed: function onRejectedConfirmed() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("onRejectedConfirmedModal", {
        title: "確認済",
        message: "承認状態を確認済に変更します",
        yes_label: "OK",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onRejectedConfirmedStep2: function onRejectedConfirmedStep2(mode) {
      var _this = this;

      if (mode == "yes") {
        if (this.localSeqId !== false) {
          var opt = {
            changes: {
              approval_status: "確認済"
            }
          };
          this.$ajax.post('/approval_history_batch_import/set/' + this.localSeqId, opt, function (err, result) {
            setTimeout(function () {
              return _this.$router.push("/approval_history/all/rejected");
            }, 1000);
          });
        }
      }
    },
    showErrroCount: function showErrroCount() {
      if (this.countErrors > 0) {
        this.$emit("onerror", "取込データに" + this.countErrors + "行のエラーがあります。");
      } else {
        this.$emit("onerror", "");
      }
    },
    filterAll: function filterAll() {
      this.showErrroCount();
      this.filerByError = false;
      this.api_request_options = { filter_mode: "show_all", sessionId: this.sessionId };
      this.emulateSearchControlChangedDatasource(true);
    },
    filterOnlyErrors: function filterOnlyErrors() {
      this.showErrroCount();
      this.filerByError = true;
      this.api_request_options = { filter_mode: "only_error", sessionId: this.sessionId };
      this.emulateSearchControlChangedDatasource(true);
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs: function createColumnDefs() {
      var field_list_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "tabFieldList";

      return this.commonCreateColumnDefs({ show_checkbox: this.localAllowCheckBox, field_list_name: field_list_name });
    },
    cellStyle: function cellStyle(params) {
      if (params.data) {
        if (params.data.has_error) {
          if (params.data.error_type && typeof params.data.error_type == "string") {
            params.data.error_type = JSON.parse(params.data.error_type);
          }
          if (params.data.error_link && typeof params.data.error_link == "string") {
            params.data.error_link = JSON.parse(params.data.error_link);
          }
        }
        if (_.find(params.data.error_type, function (f) {
          return f.field_id == params.colDef.field;
        })) {
          return { color: 'black', backgroundColor: 'rgba(255, 165, 0 , 0.5)' };
        } else if (_.find(params.data.error_link, function (f) {
          return f.field_id == params.colDef.field;
        })) {
          return { color: 'black', backgroundColor: 'rgba(255, 165, 0 , 0.5)' };
        } else {
          return null;
        }
      }
    },
    onRowSelected: function onRowSelected(params) {
      this.selected_row = params.node.data.seq_id;
      this.showErrros(params.node.data);
    },
    showErrros: function showErrros(data) {
      if (data.has_error != 1) {
        this.showErrroCount();
        return;
      }
      var error = "";
      if (Array.isArray(data.error_type) && data.error_type.length > 0) {
        data.error_type.forEach(function (e) {
          if (e.error_header) {} else {
            error += "" + e.cell + "列" + e.row_no + "行目の" + e.field_label + "　";
          }
          error += "" + e.error + "<br><br>";
        });
      }
      if (Array.isArray(data.error_link) && data.error_link.length > 0) {
        data.error_link.forEach(function (e) {
          if (e.error_header) {} else {
            error += "" + e.cell + "列" + e.row_no + "行目の" + e.field_label + "　";
          }
          error += "" + e.error + "<br><br>";
        });
      }
      this.$emit("onerror", error);
    },
    autoSizeAll: function autoSizeAll(skipHeader) {
      var _this2 = this;

      setTimeout(function () {
        var allColumnIds = ["ci_certificate_management_number"];
        _this2.gridOptions.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        _this2.gridOptions.columnApi.autoSizeAllColumns(allColumnIds, false);
      }, 100);
    },
    localInitLoadData: function localInitLoadData() {},
    cancelRetractionReason: function cancelRetractionReason() {
      var _this3 = this;

      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      this.retractionReasonValue = this.initialRetractionReason;
      this.disableRetractionReason = true;
      if (Array.isArray(this.cancelableArr) && this.cancelableArr.length > 0) {
        this.cancelableArr.forEach(function (e) {
          _.remove(_this3.selectedRowArr, function (a) {
            return a.seq_id == e.seq_id;
          });
          _this3.gridOptions.api.forEachNode(function (node) {
            if (typeof node != "undefined" && typeof node.data != "undefined" && typeof node.data.seq_id != "undefined") {
              if (node.data.seq_id == e.seq_id) {
                node.data.is_selected = false;
              }
            }
          });
        });
      }
      this.gridOptions.api.refreshView();
    },
    onArraySelected: function onArraySelected(data) {
      if (this.saveCheckEvent == false) {
        return;
      }
      var seq_id = data.row.seq_id;
      var action = data.select_action;
      if (action == "check") {
        this.cancelableArr.push(data.row);
        this.disableRetractionReason = false;
        return;
      }
      this.$ajax.post('/' + this.api_name + '/check_control/' + action + "/" + seq_id + "/" + this.sessionId, {}, function (err, result) {});
    },
    saveRetractionReason: function saveRetractionReason() {
      var _this4 = this;

      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      setTimeout(function () {
        var checked = [];
        if (Array.isArray(_this4.selectedRowArr) && _this4.selectedRowArr.length > 0) {
          checked = _this4.selectedRowArr.map(function (m) {
            return m.seq_id;
          });
        }
        _this4.$ajax.post("/approval_history_batch_import/set_retraction_reason_by_res_id/" + _this4.sessionId, { ref_id: _this4.sessionId, retraction_reason: _this4.retraction_reason_value, checked: checked }, function (err, data) {
          if (err) {
            var title = "予期しないエラーが発生し、登録が行えません";
            if (err && err.indexOf("::") == 0) {
              title = err.replace("::", "");
              err = "";
            }
            _this4.$notify({ clean: true });
            var obj = {
              title: title,
              text: err,
              type: 'error',
              duration: 10000
            };
            _this4.$notify(obj);
            _this4.cancelRetractionReason(cb);
          } else {
            console.log("get_retraction_reason_by_res_id", { err: err, data: data });
            _this4.disableRetractionReason = true;
            _this4.initialRetractionReason = _this4.retraction_reason_value;
          }
          return cb(err, data);
        });
      }, 100);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    var user_id = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userID") || "";
    this.$ajax.post('/approval_history_batch_import/get_checked_info/' + this.sessionId, { ref_id: this.sessionId }, function (err, result) {
      if (result && result.qty > 0 && result.checked_user != user_id && result.checked_user != null && result.checked_user != '') {
        _this5.localAllowCheckBox = false;
      }
      _this5.$ajax.post('/approval_history_batch_import/get_by_res_id/' + _this5.sessionId, { ref_id: _this5.sessionId }, function (err, result) {
        _this5.retractionReasonValue = result.retraction_reason || "";
        _this5.initialRetractionReason = _this5.retractionReasonValue;
        if (result && result.approval_status == "差戻") {
          _this5.showConfirmedBtn = true;
          _this5.disableEditRetractionReason = true;
          _this5.approval_status = result.approval_status;
          _this5.DisableRetractionReasonBtn = true;
        } else if (result && result.approval_status == "確認済") {
          _this5.disableEditRetractionReason = true;
        }
        if (result && result.seq_id > -1) {
          _this5.localSeqId = result.seq_id;
        } else {
          _this5.localSeqId = false;
        }
        _this5.countErrors = 0;
        _this5.$ajax.post('/' + _this5.api_name + '/count_errors/' + _this5.sessionId, {}, function (err, result) {
          _this5.countErrors = result[0].qty;
          if (_this5.countErrors > 0) {
            _this5.showErrroCount();
          }
        });
      });
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    var _this6 = this;

    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, { suppressHorizontalScroll: false, suppressSizeToFit: false });
    var sessionId = this.$props.sessionId;
    this.downloadUrl = "/api/batch_import_export/download_imported_file/" + sessionId;
    this.api_request_options = { sessionId: sessionId };
    this.localAllowCheckBox = this.$props.allowCheckBox == true;
    this.saveCheckEvent = false;
    this.initDatasource({
      loaded_cb: function loaded_cb(err, result) {
        _.filter(result, function (r) {
          return r.checked == 1;
        }).forEach(function (e) {
          _this6.onSelectedClickDatasource({}, e);
        });
        _this6.saveCheckEvent = true;
        if (Array.isArray(result) && result.length > 0 && result[0].table_mode == 2) {
          _this6.gridOptions.api.setColumnDefs(_this6.createColumnDefs("tabFieldList2"));
        }
      }
    });
  },

  props: ['sessionId', 'allowCheckBox']
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:master_user");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "temp_certificate_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].certificate_management_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].maker, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs: function createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        if (f.id == "maker") {
          fi.cellStyle = function (params) {
            var val = _.get(params, "value", " ") || "";
            var maker_name = _.get(params, "data.maker_name", "-") || "";

            if (params.data && val.toLowerCase() != maker_name.toLowerCase()) {
              return { fontWeight: 'bold', backgroundColor: 'orange' };
            }
            if (params.value == "") {
              return { fontWeight: 'bold', backgroundColor: '#d2962a' };
            }
            return null;
          };
        }
        arr.push(fi);
      });
      return arr;
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:master_user");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "temp_device_embedded_detail",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].ref_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].department_in_charge, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].responsible_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].jurisdiction_system_name_in_use, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].software, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].software_jurisdiction, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].item_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].virtual_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_detail__["a" /* fields */].certificate_management_number, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs: function createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        arr.push(fi);
      });

      return arr;
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:master_user");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "ag-grid-vue": __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "temp_device_embedded_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log("values");
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs: function createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        arr.push(fi);
      });

      return arr;
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:surplus_license_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "surplus_license_request",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.surplus_license_detail,
      state_current_editing: "current_editing2",
      state_current_row: "current_row2",
      state_is_editing_new: "is_editing_new2",
      state_last_filter_options: "last_filter_options2",
      buttons_mode: "new",
      local_seq_id: -1,
      return_timer: false
    };
  },

  computed: {
    disableReviewButtons: function disableReviewButtons() {
      return this.approvalStatus != "未対応";
    },
    approvalStatus: function approvalStatus() {
      return this.$store.state[this.stateCurrentRow].approval_status || "";
    },

    localSeqID: {
      get: function get() {
        return this.local_seq_id;
      },
      set: function set(v) {
        this.local_seq_id = v;
      }
    },
    buttonsMode: {
      get: function get() {
        return this.buttons_mode;
      },
      set: function set(v) {
        this.buttons_mode = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [this.local_extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].jurisdiction_department, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].jurisdiction_team, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].desired_number, {}), this.local_extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].requester, {})]
      };
    }
  },
  methods: {
    approve: function approve() {
      this.approve_reject("approve");
    },
    reject: function reject() {
      this.approve_reject("reject");
    },
    onNotificationApproveRejectConfirmation: function onNotificationApproveRejectConfirmation(mode) {
      var _this = this;

      if (mode == "yes" || mode == "no") {
        clearTimeout(this.return_timer);
        this.return_timer = setTimeout(function () {
          return _this.$router.push({ name: "page_0020_surplus_license_request", params: {} });
        }, 600);
      }
    },
    approve_reject: function approve_reject(mode) {
      var _this2 = this;

      this.$ajax.post('/' + this.api_name + '/' + mode + '/' + this.localSeqID, {}, function (err, result) {
        if (err) {
          _this2.$notify({
            title: 'Failed to ' + mode + ' data',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("notificationApproveReject", {
            message: "",
            title: mode == "approve" ? "余剰ライセンスの割当依頼を承認します。<br>よろしいですか？" : "申請を差戻しました。",
            yes_label: mode == "approve" ? "承認する(割当通知発行)" : "",
            no_label: "戻る",
            yes_color: "primary",
            no_color: "",
            model_height: "50"
          });
        }
      });
    },
    onSavedConfirmation: function onSavedConfirmation(mode) {
      if (mode == "no") {
        this.backToList();
      }
    },
    local_extend: function local_extend(field_info, ext) {
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(field_info, ext);
    },
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {}, function (err) {
        if (!err) {
          __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("onSavedInformation", {
            title: "",
            message: "余剰ライセンスの割当依頼を送信しました。",
            yes_label: "",
            no_label: "戻る",
            yes_color: "",
            no_color: "primary",
            model_height: "50"
          });
        }
      });
    },
    backToList: function backToList() {
      if (this.buttonsMode == "new") {
        return this.$router.push({ name: "page_0020_surplus_license", params: {} });
      } else {
        return this.$router.push({ name: "page_0020_surplus_license_request", params: {} });
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.$props.create_new == true) {
      this.buttonsMode = "new";
      this.$route.params.seq_id = "new";
    } else {
      this.buttonsMode = "review";
      this.$route.params.seq_id = this.$props.seq_id;
      this.localSeqID = this.$props.seq_id;
    }
    this.commonLoadRecord({}, function (err, result) {
      _this3.$store.state[_this3.stateCurrentEditing]["surplus_license_seq_id"] = _this3.$props.ref_id;
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {},

  props: {
    ref_id: { type: Number },
    seq_id: { type: String },
    create_new: { type: Boolean, default: false }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);




var debug_search_control = __WEBPACK_IMPORTED_MODULE_1_debug___default()("esma:title_and_search");
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  afterMount: function afterMount() {},
  beforeDestroy: function beforeDestroy() {},

  props: ["title", "hide_search"]
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);




var debug_search_control = __WEBPACK_IMPORTED_MODULE_1_debug___default()("esma:title_and_search");
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  afterMount: function afterMount() {},
  beforeDestroy: function beforeDestroy() {},

  props: ["title"]
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_multi_select__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_multi_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_multi_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_menu_common__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);













var debug_menu = __WEBPACK_IMPORTED_MODULE_8_debug___default()("esma:menu");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("multi-select", __WEBPACK_IMPORTED_MODULE_2__components_multi_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_menu_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */]],
  components: {},
  data: function data() {
    return {
      start_is_enabled: false,
      allowed_entities: [],
      local_selected_company: "-"
    };
  },

  computed: {
    localSelectedCompany: {
      get: function get() {
        return this.local_selected_company;
      },
      set: function set(v) {
        this.local_selected_company = v;
      }
    },
    startIsEnabled: {
      get: function get() {
        return this.start_is_enabled;
      },
      set: function set(v) {
        this.start_is_enabled = v;
      }
    },
    lastSelectedCopmanyName: function lastSelectedCopmanyName() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("selectedCompany");
    },
    userCopmany: function userCopmany() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userCompany");
    },
    companyOptions: function companyOptions() {

      var roles = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("roleArray");
      if (typeof roles != "undefined") {
        roles = JSON.parse(roles);
      } else {
        return [];
      }
      var array_or_roles = roles.map(function (r) {
        return r.role;
      });

      var localIsMultiCompanyAdmin = this.isMultiCompanyAdminByArray(array_or_roles);
      this.allowed_entities = [];
      var userCopmanies = roles.map(function (r) {
        return r.company;
      });
      this.allowed_entities = [{ name: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHFG, value: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHFG, enabled: userCopmanies.indexOf(__WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHFG) > -1 }, { name: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHBK, value: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHBK, enabled: userCopmanies.indexOf(__WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHBK) > -1 }, { name: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHTB, value: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHTB, enabled: userCopmanies.indexOf(__WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.MHTB) > -1 }, { name: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.ALL, value: __WEBPACK_IMPORTED_MODULE_3__rules_constants___default.a.COMPANY.ALL, enabled: localIsMultiCompanyAdmin == true }];
      if (this.allowed_entities && this.allowed_entities.length > 0) {
        var enabled = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.allowed_entities, function (a) {
          return a.enabled == true;
        });

        var first_enabled = "";
        if (Array.isArray(enabled) && enabled.length > 0) {
          first_enabled = enabled[0].value;
        }
        var last = this.lastSelectedCopmanyName || first_enabled || "";
        this.allowed_entities.forEach(function (d) {
          d.selected = d.value == last;
        });
      }
      return this.allowed_entities;
    }
  },
  methods: {
    onStartClicked: function onStartClicked() {
      var _this = this;

      if (this.startIsEnabled) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set("selectedCompany", "-");
        this.$ajax.postExtended("/login/", { selected_company: this.localSelectedCompany }, function (err, response) {
          if (response.data.change_password == "yes") {
            _this.$router.push("/change_password");
          } else if (response.data.change_expired_password == "yes") {
            _this.$router.push("/change_password/expired");
          } else {
            var tab_session_id = new Date().getTime();
            window.sessionStorage.setItem('browser_tab_id', tab_session_id);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('browser_tab_id', tab_session_id);

            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('userShimei', response.data.user_data.user_shimei);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('userID', response.data.user_data.user_id);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('userRole', response.data.user_data.user_role);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('userCompany', response.data.user_data.user_company);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('userDepartment', response.data.user_data.user_department);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('userTeam', response.data.user_data.user_team);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set('passwordExpireDate', response.data.user_data.password_expire_date);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.set("selectedCompany", response.data.user_data.user_company);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.remove("roleArray");
            _this.$store.state.show_message_after_login = true;
            _this.resetMenuUserPermission();
            _this.$router.push("/menu");
          }
        });
      }
    },
    companySelected: function companySelected(s) {
      this.localSelectedCompany = "-";
      var comp = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.allowed_entities, function (f) {
        return f.value == s.selected;
      });
      this.startIsEnabled = typeof comp != "undefined" && comp.enabled == true;
      if (this.startIsEnabled) {
        this.localSelectedCompany = s.data.name;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.resetMenuUserPermission();

    this.$ajax.post('/ping', {}, function (err, response) {
      console.log("Ping response at company", { err: err, response: response });
    });
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_user",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master_user_password,
      local_read_only: false
    };
  },

  computed: {
    pageTitle: function pageTitle() {
      if (this.$route.meta.password_expired == true) {
        return "パスワード変更(パスワード有効期限切れ)";
      } else {
        return "パスワードの変更 (初回ログイン)";
      }
    },

    localReadOnly: {
      get: function get() {
        return this.local_read_only;
      },
      set: function set(v) {
        this.local_read_only = v;
      }
    },
    currentPassword: function currentPassword() {
      return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */].current_password, {});
    },
    newPassword: function newPassword() {
      return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */].new_password, {});
    },
    confirmPassword: function confirmPassword() {
      return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */].confirm_password, {});
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {};
    }
  },
  methods: {
    onPasswordChanged: function onPasswordChanged() {
      this.$router.push("/company");
    },
    local_show_error: function local_show_error(text) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Error";
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;

      this.$notify({ clean: true });
      this.$notify({
        title: title,
        text: text,
        type: 'error',
        duration: duration
      });
    },
    processChangePassword: function processChangePassword() {
      var _this = this;

      var current_password = this.$store.state[this.stateCurrentEditing]["current_password"];
      var new_password = this.$store.state[this.stateCurrentEditing]["new_password"];
      var confirm_password = this.$store.state[this.stateCurrentEditing]["confirm_password"];
      if (new_password != confirm_password) {
        return this.local_show_error("新しいパスワードと新しいパスワード(確認)は同じ必要があります。");
      }
      if (new_password == current_password) {
        return this.local_show_error("新しいパスワードと現在のパスワードは違う必要があります。");
      }
      if (new_password == "") {
        return this.local_show_error("新しいパスワードが空白です。");
      }
      if (current_password == "") {
        return this.local_show_error("現在のパスワードが空白です。");
      }
      var ops = {
        current_password: current_password,
        new_password: new_password,
        confirm_password: confirm_password
      };
      this.$ajax.post('/' + this.api_name + '/change_password_first_time/', ops, function (err, result) {
        if (result.success == true && err == null) {
          _this.$notify({
            title: "パスワードが変更されました。",
            type: 'success',
            duration: 5000
          });
          __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("passwordChanged", {
            message: "パスワードが変更されました。",
            title: "",
            yes_label: "完了",
            no_label: "",
            yes_color: "primary",
            no_color: "",
            model_height: "50"
          });
          _this.clearFields();
        } else {
          return _this.local_show_error(err || "Operation failed");
        }
      });
    },
    clearFields: function clearFields() {
      var _this2 = this;

      var form_fields = ["current_password", "new_password", "confirm_password"];
      form_fields.forEach(function (f) {
        _this2.$store.state[_this2.stateCurrentEditing] = {};
        _this2.$store.state[_this2.stateCurrentEditing][f] = "*";
        _this2.$store.state[_this2.stateCurrentRow][f] = "";
        _this2.$store.state[_this2.stateCurrentEditing][f] = "";
      });
      this.localReadOnly = true;
      setTimeout(function () {
        _this2.localReadOnly = false;
      }, 100);
    },
    backToList: function backToList() {
      return this.$router.push({ name: "menu_master", params: {} });
    }
  },
  mounted: function mounted() {
    this.clearFields();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.clearFields();
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_entities__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_md5__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);











var debug_login = __WEBPACK_IMPORTED_MODULE_7_debug___default()("esma:login");

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      page_version: "...",
      empty_pass: "",
      in_user: "",
      in_pass: "",
      allow_toast: true,
      allow_login_process: false,
      password_icon_open: false,
      password_type: "password"
    };
  },

  computed: {
    passwordType: {
      get: function get() {
        return this.password_type;
      },
      set: function set(v) {
        this.password_type = v;
      }
    },
    passwordIconOpen: {
      get: function get() {
        return this.password_icon_open;
      },
      set: function set(v) {
        this.password_icon_open = v;
      }
    },
    pageVersion: function pageVersion() {
      this.page_version;
    },
    pass: function pass() {
      debug_login("return pass");
      return this.empty_pass;
    },
    breadcrumb: function breadcrumb() {
      return [];
    }
  },
  methods: {
    togglePasswordDown: function togglePasswordDown() {
      this.passwordIconOpen = true;
      this.passwordType = "text";
    },
    togglePasswordUp: function togglePasswordUp() {
      this.passwordIconOpen = false;
      this.passwordType = "password";
    },
    resetPassword: function resetPassword() {
      this.$router.push("/reset_password");
    },
    clearStorage: function clearStorage(cb) {
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(window.localStorage);
      keys.forEach(function (k) {
        if (k.indexOf("user") == 0) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("bulk_edit_") == 0) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("associated_device_") == 0) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("selectedCompany") == 0) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("passwordExpireDate") == 0) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("selected_approval_history") == 0) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove(k);
        }
      });

      window.sessionStorage.clear();
      return cb();
    },
    setPageZoom: function setPageZoom(zoom, container_size) {
      if (container_size) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('pageContainerSize', container_size);
        this.$store.state["current_row"].table_size = container_size;
      }
      if (zoom) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('pageZoom', zoom);
        var page_size = parseFloat(zoom);
        this.$store.state["current_row"].page_size = page_size;
        var mb = document.getElementById('main-body');
        var iw = window.innerWidth;
        mb.style.zoom = page_size;
        if (page_size < 1) {
          mb.style.minWidth = parseInt(iw / page_size) + "px";
          mb.style.maxWidth = null;
        } else {
          mb.style.minWidth = null;
          mb.style.maxWidth = parseInt(iw / page_size) + "px";
        }
      }
    },
    onLogin: function onLogin(ev) {
      var _this = this;

      ev.preventDefault();
      this.$notify({ clean: true });
      debug_login(this.in_pass, this.in_user);
      this.clearStorage(function () {
        _this.allow_login_process = true;


        _this.$ajax.postExtended("/login/authenticate/", { user_id: __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].Base64.encode(_this.in_user), pass: __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].Base64.encode(_this.in_pass) }, function (err, response) {
          if (err && err.status == 502) {
            console.log("Connection to server failed with 502");
            window.location.href = "/error_pages/502.html";
          } else if (err && err.status >= 500) {
            console.log("Connection to server failed with " + err.status);
            window.location.href = "/error_pages/5xx.html";
          } else if (response && response.data && response.data.change_expired_password == "yes") {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('userShimei', response.data.user_data.user_shimei);
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('userID', response.data.user_data.user_id);
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('roleArray', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.role_array));
            var tab_session_id = new Date().getTime();
            window.sessionStorage.setItem('browser_tab_id', tab_session_id);
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('browser_tab_id', tab_session_id);
            _this.$router.push("/change_password/expired");
            return;
          } else {
            debug_login("Connection to server is OK");
          }
          if (response && response.data && response.data.user_data && response.data.user_data.zoom_info) {
            var zoom_info = JSON.parse(response.data.user_data.zoom_info);
            _this.setPageZoom(zoom_info.pageZoom, zoom_info.pageContainerSize);
          }
          debug_login("LOGIN RESULT", err, response);
          _this.$notify({
            clear: true
          });
          if (_this.allow_login_process) {
            _this.allow_login_process = false;
            if (response.success) {
              _this.$notify({ clean: true });
              _this.$notify({
                title: "ログインしました",
                type: "success",
                duration: 2000
              });
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('userShimei', response.data.user_data.user_shimei);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('userID', response.data.user_data.user_id);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('roleArray', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.role_array));

              var tab_session_id = new Date().getTime();
              window.sessionStorage.setItem('browser_tab_id', tab_session_id);
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('browser_tab_id', tab_session_id);

              debug_login("Open /company");
              _this.$router.push("/company");
            } else {
              var err = {
                title: err || "Error to loged in",
                type: "error",
                duration: 5500
              };
              if (typeof response.error != "undefined") {
                err.text = response.error;
              }

              _this.in_pass = "";
              _this.$notify(err);
            }
          }
        });
      });
    },
    onLogoutCompleated: function onLogoutCompleated(data) {
      var _this2 = this;

      this.setPageZoom(0.9, 1420);
      this.clearStorage(function () {
        debug_login("onLogoutCompleated", data);
        _this2.$store.state.cached_lists = {};
        _this2.$store.state.last_filter_options = {};
        _this2.$store.state.last_filter_options2 = {};
        _this2.$store.state.last_filter_options3 = {};

        _this2.allow_login_process = false;
        if (_this2.allow_toast) {
          _this2.allow_toast = false;
          _this2.$notify({ clean: true });
          if (window.location.hash.indexOf("/logout/duo") > -1) {
            _this2.$notify({
              title: "重複して起動されたため、強制ログアウトをします。",
              type: "error",
              duration: 10000
            });
            setTimeout(function () {
              _this2.$notify({
                title: "ログアウトしました",
                type: "primary",
                duration: 10000
              });
            }, 300);
          } else {
            _this2.$notify({
              title: "ログアウトしました",
              type: "primary",
              duration: 1000
            });
          }
        }
        setTimeout(function () {
          _this2.allow_toast = true;
        }, 1200);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$ajax.get_version(function (data, d2) {
      console.log("get_version", data, d2);
      _this3.page_version = "Version: " + data;
    });
    if (window.location.hash.indexOf("/expired") > -1) {
      this.$notify({ clean: true });
      this.$notify({
        title: "セッションの有効期限が切れましたので、もう一度ログインを行ってください",
        type: "error",
        duration: 10000
      });
    }
    if (window.location.hash.indexOf("/logout/duo") > -1) {
      setTimeout(function () {
        window.sessionStorage.setItem('tab_id', false);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('tab_id', false);
        _this3.$store.dispatch("makeLogout", {});
      }, 500);
    } else if (window.location.hash.indexOf("/logout") > -1) {
      window.sessionStorage.setItem('tab_id', false);
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set('tab_id', false);
      this.$store.dispatch("makeLogout", {});
    }
    var vm = this;
    vm.empty_pass = " ";
    vm.in_pass = " ";
    setTimeout(function () {
      vm.empty_pass = "";
      vm.in_pass = "";
    }, 300);

    __WEBPACK_IMPORTED_MODULE_3__libs_bus__["a" /* bus */].$on("Login", function (data) {
      debug_login("err , Unexpected event bus.$on(Login, with data", data);
      _this3.$store.state.cached_lists = {};
    });
    __WEBPACK_IMPORTED_MODULE_3__libs_bus__["a" /* bus */].$on("Logout", this.onLogoutCompleated);

    this.allow_login_process = true;

    this.$ajax.postExtended("/ping", {}, function (err, response) {
      if (err && err.status == 502) {
        console.log("Connection to server failed with 502");
        window.location.href = "/error_pages/502.html";
      } else if (err && err.status >= 500) {
        console.log("Connection to server failed with " + err.status);
        window.location.href = "/error_pages/5xx.html";
      } else {
        debug_login("Connection to server is OK");
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__libs_bus__["a" /* bus */].$off("Logout");
    __WEBPACK_IMPORTED_MODULE_3__libs_bus__["a" /* bus */].$off("Login");
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_mixin_menu_common__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_notice_modal__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_notice_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_notice_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_info_box__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_info_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_info_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);












var debug_menu = __WEBPACK_IMPORTED_MODULE_8_debug___default()("esma:menu");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_2__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_mixin_menu_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_page_common__["a" /* default */]],
  components: {
    "notice-modal": __WEBPACK_IMPORTED_MODULE_6__components_modals_notice_modal___default.a,
    "info-box": __WEBPACK_IMPORTED_MODULE_7__components_info_box___default.a
  },
  data: function data() {
    return {
      notification_certificate_over_qty: "~",
      notification_certificate_qty: "~",
      approval_history_qty: "~",
      approval_history_all_qty: "~",

      certificate_that_expires_in_3_months: "^",
      certificate_expired_license: "^",
      application_approval_pending: "^",
      application_approval_rejection: "^",
      application_approval_inventory_pending: "^",
      application_approval_inventory_rejection: "^",
      bulk_import_pending: "^",
      bulk_import_rejection: "^",
      surplus_license_that_expires_in_3_months: "^",
      surplus_expired_license: "^",
      pw_approval_history: "^",
      approval_sub_search: {},
      reject_sub_search: {}
    };
  },


  computed: {
    disablePwLink: function disablePwLink() {
      return this.checkMenuUserPermission(this.acl.master) == false || __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].constants.COMPANY.ALL != __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("selectedCompany");
    },

    certificateThatExpiresIn3Months: {
      get: function get() {
        return this.certificate_that_expires_in_3_months;
      },
      set: function set(v) {
        this.certificate_that_expires_in_3_months = v;
      }
    },
    certificateExpiredLicense: {
      get: function get() {
        return this.certificate_expired_license;
      },
      set: function set(v) {
        this.certificate_expired_license = v;
      }
    },
    applicationApprovalPending: {
      get: function get() {
        return this.application_approval_pending;
      },
      set: function set(v) {
        this.application_approval_pending = v;
      }
    },
    applicationApprovalRejection: {
      get: function get() {
        return this.application_approval_rejection;
      },
      set: function set(v) {
        this.application_approval_rejection = v;
      }
    },
    applicationApprovalInventoryPending: {
      get: function get() {
        return this.application_approval_inventory_pending;
      },
      set: function set(v) {
        this.application_approval_inventory_pending = v;
      }
    },
    applicationApprovalInventoryRejection: {
      get: function get() {
        return this.application_approval_inventory_rejection;
      },
      set: function set(v) {
        this.application_approval_inventory_rejection = v;
      }
    },
    bulkImportPending: {
      get: function get() {
        return this.bulk_import_pending;
      },
      set: function set(v) {
        this.bulk_import_pending = v;
      }
    },
    bulkImportRejection: {
      get: function get() {
        return this.bulk_import_rejection;
      },
      set: function set(v) {
        this.bulk_import_rejection = v;
      }
    },
    surplusLicenseThatExpiresIn3Months: {
      get: function get() {
        return this.surplus_license_that_expires_in_3_months;
      },
      set: function set(v) {
        this.surplus_license_that_expires_in_3_months = v;
      }
    },
    pwApprovalHistory: {
      get: function get() {
        return this.pw_approval_history;
      },
      set: function set(v) {
        this.pw_approval_history = v;
      }
    },
    surplusExpiredLicense: {
      get: function get() {
        return this.surplus_expired_license;
      },
      set: function set(v) {
        this.surplus_expired_license = v;
      }
    }

  },
  created: function created() {},

  methods: {
    loadAllCounters: function loadAllCounters(cb) {
      console.log('TEST DEBUG 210427 (377 at menu.vue)[21:50]: IS COUNTING', {});
      this.$ajax.post('/common/load_menu_counters/', {}, function (err, result) {
        cb(err, result);
      });
    },
    applicationApprovalInventoryBtn: function applicationApprovalInventoryBtn() {
      return this.$router.push({
        name: 'page_0072_inventory_report_check',
        params: { sub_search: this.approval_sub_search }
      });
    },
    applicationApprovalInventoryRejectionBtn: function applicationApprovalInventoryRejectionBtn() {
      return this.$router.push({
        name: 'page_0072_inventory_report_check',
        params: { sub_search: this.reject_sub_search }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loadAllCounters(function (err, result) {
      if (err) {
        return _this.$notify({
          text: err,
          type: 'error',
          duration: 10000
        });
      }
      _this.certificateThatExpiresIn3Months = result.certificate_that_expires_in_3_months;
      _this.certificateExpiredLicense = result.certificate_expired_license;
      _this.applicationApprovalPending = result.application_approval_pending;
      _this.applicationApprovalRejection = result.application_approval_rejection;
      _this.bulkImportPending = result.bulk_import_pending;
      _this.bulkImportRejection = result.bulk_import_rejection;
      _this.surplusLicenseThatExpiresIn3Months = result.surplus_license_that_expires_in_3_months;
      _this.surplusExpiredLicense = result.surplus_expired_license;
      _this.pwApprovalHistory = result.pw_approval_history;
      _this.applicationApprovalInventoryPending = result.application_approval_inventory_pending;
      _this.applicationApprovalInventoryRejection = result.application_approval_inventory_rejection;

      if (_this.applicationApprovalInventoryPending > 0) {
        _this.approval_sub_search = {
          company: result.approval_company,
          reporting_period: result.approval_reporting_period,
          jurisdiction_classification: "棚卸申請承認"
        };
      }
      if (_this.applicationApprovalInventoryRejection > 0) {
        _this.reject_sub_search = {
          company: result.reject_company,
          reporting_period: result.reject_reporting_period,
          jurisdiction_classification: result.reject_jurisdiction_classification
        };
      }

      if (_this.disablePwLink) {
        delete result.pw_approval_history;
      }
      return __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("processNoticeModal", { all_counters: result });
    });

    this.$ajax.post('/ping', {}, function (err, response) {
      console.log("Ping response", { err: err, response: response });
    });
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);








var debug_menu = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:menu");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__["a" /* default */]],
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    col1: function col1() {
      return [{ name: "証書情報", path: "/certificate", disabled: this.checkMenuUserPermission(this.acl.certificate_information) == false }];
    },
    col2: function col2() {
      return [{ name: "余剰ライセンス", path: "/surplus_license", disabled: this.checkMenuUserPermission(this.acl.surplus_license) == false }];
    }
  },
  created: function created() {},
  mounted: function mounted() {

    this.$ajax.post('/ping', {}, function (err, response) {
      console.log("Ping response", { err: err, response: response });
    });
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);








var debug_menu = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:menu");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__["a" /* default */]],
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    col1: function col1() {
      return [{ name: "部署・チーム", path: "/master_belongs", disabled: this.checkMenuUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }, { name: "システム", path: "/master_system", disabled: this.checkMenuUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }, { name: "メーカ", path: "/master_maker", disabled: this.checkMenuUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }, { name: "ソフトウェア", path: "/master_software", disabled: this.checkMenuUserPermission(this.acl.master_bel_mak_sys, this.permissionMode.BROWSE) == false }];
    },
    col2: function col2() {
      return [{ name: "メールメッセージ", path: "mail_message", disabled: this.checkMenuUserPermission(this.acl.master) == false }, { name: "お知らせ", path: "/notice", disabled: this.checkMenuUserPermission(this.acl.master) == false }, { name: "預り証出力", path: "/deposit_certificate_output", disabled: this.checkMenuUserPermission(this.acl.master) == false }, { name: "過不足集計表", path: "/excess_deficiency_summary", disabled: this.checkMenuUserPermission(this.acl.master) == false }, { name: "棚卸報告年度区分", path: "/inventory_reporting_period", disabled: this.checkMenuUserPermission(this.acl.master) == false }];
    }
  },
  created: function created() {},
  mounted: function mounted() {

    this.$ajax.post('/ping', {}, function (err, response) {
      console.log("Ping response", { err: err, response: response });
    });
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);








var debug_menu = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:menu");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__["a" /* default */]],
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    col1: function col1() {
      return [{ name: "棚卸業務", path: "/inventory", disabled: this.checkMenuUserPermission(this.acl.inventory_report) == false }];
    },
    col2: function col2() {
      return [{ name: "棚卸報告確認", path: "/inventory_report_check", disabled: this.checkMenuUserPermission(this.acl.inventory_report_check) == false }];
    }
  },
  created: function created() {},
  mounted: function mounted() {

    this.$ajax.post('/ping', {}, function (err, response) {
      console.log("Ping response", { err: err, response: response });
    });
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);








var debug_menu = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:menu");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__["a" /* default */]],
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    col1: function col1() {
      return [{ name: "プログラムとアクセス権限", path: "/programs_and_permissions", disabled: this.checkMenuUserPermission(this.acl.maintenance) == false }, { name: "会社", path: "/master_company", disabled: this.checkMenuUserPermission(this.acl.maintenance) == false }];
    },
    col2: function col2() {
      return [{ name: "システム設定", path: "/system_setting", disabled: this.checkMenuUserPermission(this.acl.maintenance) == false }, { name: "旧データ取込", path: "/old_bulk_import", disabled: this.checkMenuUserPermission(this.acl.maintenance) == false }];
    }
  },
  created: function created() {},
  mounted: function mounted() {

    this.$ajax.post('/ping', {}, function (err, response) {
      console.log("Ping response", { err: err, response: response });
    });
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menu_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_bus__ = __webpack_require__(4);








var debug_menu = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:menu");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("menu-btn", __WEBPACK_IMPORTED_MODULE_1__components_menu_btn___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_mixin_menu_common__["a" /* default */]],
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    col1: function col1() {
      return [{ name: "パスワードの変更", path: "/master_change_password", disabled: this.checkMenuUserPermission(this.acl.master_user_password) == false }];
    },
    col2: function col2() {
      return [{ name: "ユーザ一覧", path: "/master_user", disabled: this.checkMenuUserPermission(this.acl.master_user) == false }];
    }
  },
  created: function created() {},
  mounted: function mounted() {

    this.$ajax.post('/ping', {}, function (err, response) {
      console.log("Ping response", { err: err, response: response });
    });
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:inventory_report');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "reset_password",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master_user_password,
      show_chose_file: true,
      file_selected_event: false,
      selected_file_name: null,
      is_uploading: false
    };
  },

  computed: {
    isUploading: {
      get: function get() {
        return this.is_uploading;
      },
      set: function set(v) {
        this.is_uploading = v;
      }
    },
    disallowToSubmit: function disallowToSubmit() {
      return false;
    },

    selectedFileName: {
      get: function get() {
        return this.selected_file_name;
      },
      set: function set(v) {
        this.selected_file_name = v;
      }
    },
    showChoseFile: {
      get: function get() {
        return this.show_chose_file;
      },
      set: function set(v) {
        this.show_chose_file = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].mail_address, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].user_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].role, {})]
      };
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$notify({ clear: true });
      var disallow_submit = this.disallowToSubmit;
      this.formFields.col1.forEach(function (e) {
        var v = _this.$store.state[_this.stateCurrentEditing][e.id];
        if (typeof v == "undefiend" || v == null || v.length == 0) {
          disallow_submit = true;
          _this.$notify({
            text: e.label + "は必須項目になります。",
            type: 'error',
            duration: 15000
          });
        }
      });

      if (disallow_submit == false) {
        this.isUploading = true;

        var form_data = new FormData();
        this.formFields.col1.forEach(function (e) {
          var v = _this.$store.state[_this.stateCurrentEditing][e.id];
          form_data.append(e.id, v);
        });

        __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(this.$ajax.serverUrl + "/" + this.api_name + "/reset_request", form_data, {
          headers: { "Content-Type": "multipart/form-data" }
        }).then(function (response) {
          var data = response.data;
          __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("ResetPasswordModal", {
            title: "",
            message: "PWロック解除を送信しました。",
            yes_label: "",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        });
      }
    },
    choseFile: function choseFile() {
      var csv_file = this.$refs.csv_file;
      csv_file.click();
    },
    fileClicked: function fileClicked(e) {
      var csv_file = this.$refs.csv_file;
      csv_file.value = null;
    },
    fileSelected: function fileSelected(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      this.file_selected_event = e;
      this.selectedFileName = files[0].name;
    },
    backToList: function backToList() {
      return this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.formFields.col1.forEach(function (e) {
      _this2.$store.state[_this2.stateCurrentRow][e.id] = "";
    });
    this.$route.params.seq_id = "new";
    this.$store.state[this.stateIsEditingNew] = true;
    this.read_only = false;
    this.is_new = true;
  },
  beforeMount: function beforeMount() {},
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_system_setting__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);








var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:master_belong_details");


/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {
    clearStorage: function clearStorage(cb) {
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(window.localStorage);
      keys.forEach(function (k) {
        if (k.indexOf("user") == 0) {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("bulk_edit_") == 0) {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("associated_device_") == 0) {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("selectedCompany") == 0) {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.remove(k);
        }
        if (k.indexOf("passwordExpireDate") == 0) {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.remove(k);
        }
      });

      window.sessionStorage.clear();
      return cb();
    },
    onLogoutCompleated: function onLogoutCompleated() {
      var _this = this;

      this.clearStorage(function () {
        _this.$store.state.cached_lists = {};
        _this.$store.state.last_filter_options = {};
        _this.$store.state.last_filter_options2 = {};
        _this.$store.state.last_filter_options3 = {};

        _this.allow_login_process = false;
        if (_this.allow_toast) {
          _this.allow_toast = false;
          _this.$notify({
            title: "ログアウトしました",
            type: "primary",
            duration: 1000
          });
        }
        setTimeout(function () {
          _this.allow_toast = true;
        }, 1200);
      });
    }
  },
  mounted: function mounted() {
    window.sessionStorage.setItem("tab_id", false);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("tab_id", false);
    this.$store.dispatch("makeLogout", {});
    this.onLogoutCompleated({});
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_bach_edit_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_bach_edit_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_bach_edit_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_strap_dist_vue_strap_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_bus__ = __webpack_require__(4);











var mdebug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('esma:device_embedded_information');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__["AgGridVue"],
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_bach_edit_modal___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_12_vue_strap_dist_vue_strap_js__["tab"],
    tabs: __WEBPACK_IMPORTED_MODULE_12_vue_strap_dist_vue_strap_js__["tabs"]
  },
  data: function data() {
    return {
      api_name: "device_embedded_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default.a.device_embedded_information,
      execute_filter_on_back: true,
      detail_page: "page_0010_device_embedded_information_detail",
      link_to_open: "#",
      select_all: false,
      post_cached_timeout: 30,
      selected_tab: 0
    };
  },

  computed: {
    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    },
    approveMode: {
      get: function get() {
        return this.approve_mode;
      },
      set: function set(v) {
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll: {
      get: function get() {
        return this.select_all;
      },
      set: function set(v) {
        this.select_all = v;
      }
    },
    deleteBtnDisabled: function deleteBtnDisabled() {
      if (this.formOutputQty > 0 && this.isMaintenanceStaff == true) {
        return false;
      }
      return this.formOutputQty == 0 || typeof __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.selectedRowArr, function (d) {
        return d.device_control_number != "" && d.device_control_number != null;
      }) != "undefined";
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].company, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].approval_status, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].registration_date, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].last_update_date, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].computer_name, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system_it, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_department, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_team, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_base, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].user_name, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].status];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].status, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].last_update_date, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system_it, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_base, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, {})];
    }
  },
  methods: {
    onTabChanged: function onTabChanged(index) {
      this.checkBoxSelectAll = false;
      this.clearSearchFields();
      switch (index) {
        case 0:
        case "in_use":
          this.selectedTab = 0;
          this.api_request_options = { filter_mode: "使用中" };
          window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information/tab/in_use");
          this.$router.push({ name: "page_0010_device_embedded_information_tab", params: { mode: "in_use" } });
          break;
        case 1:
        case "disposal":
          this.selectedTab = 1;
          this.api_request_options = { filter_mode: "廃棄" };
          window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information/tab/disposal");
          this.$router.push({ name: "page_0010_device_embedded_information_tab", params: { mode: "disposal" } });
          break;
        case 2:
        case "pending":
          this.selectedTab = 2;
          this.api_request_options = { filter_mode: "下書中/申請中/差戻" };
          window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information/tab/pending");
          this.$router.push({ name: "page_0010_device_embedded_information_tab", params: { mode: "pending" } });
          break;
        default:
          return;
      }
      this.emulateSearchControlChangedDatasource(true);
    },
    allChecked: function allChecked(a, b) {
      this.commonAllChecked("showInformationIconModalDeviceEmbededInformation");
    },
    hideCheckBox: function hideCheckBox(data) {
      return data && data.approval_status == "申請中";
    },
    onDelete: function onDelete() {
      if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("deleteDeviceEmbeddedInformationModal", {
        title: "削除",
        message: "" + this.selectedRowArr.length + " 機器・組込情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        sub_search: this.search_data,
        url: "/device_embedded_information/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    bachEdit: function bachEdit() {
      var p_id = __WEBPACK_IMPORTED_MODULE_3_uuid___default.a.v4();
      var obj = { arr: this.selectedRowArr.map(function (m) {
          return m.seq_id;
        }) };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("bulk_edit_" + p_id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
      return this.$router.push("/device_embedded_information/bulk_edit/" + p_id);
    },
    onDeviceEmbeddedInformationBachEditModalSave: function onDeviceEmbeddedInformationBachEditModalSave(result) {
      console.log("onDeviceEmbeddedInformationBachEditModalSave data", { result: result });
    },
    onDeviceEmbeddedInformationBachEditModalClose: function onDeviceEmbeddedInformationBachEditModalClose() {
      console.log("onDeviceEmbeddedInformationBachEditModalSave");
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: { seq_id: data.seq_id } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true, force_sort: { id: "equipment_in_charge_department", direction: "asc" } });
    }
  },
  mounted: function mounted() {
    this.selectedTab = this.$route.meta.tab_index;
    window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information");
    this.gridOptions.api.sizeColumnsToFit();
    if (this.$route.params.mode) {
      this.onTabChanged(this.$route.params.mode);
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.count_from_result = true;
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend(this.commonGridOptions, {});
    this.api_request_options = { filter_mode: "使用中" };
    this.initDatasource({ load_only_with_filter: false });
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_add_check__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_add_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_add_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sub_pages_device_embedded_detail__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sub_pages_device_embedded_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_sub_pages_device_embedded_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_device_embedded_information_confirmation_modal__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_device_embedded_information_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_device_embedded_information_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_change_history_modal__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_change_history_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_change_history_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_modals_device_modal__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_modals_device_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_modals_device_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__libs_bus__ = __webpack_require__(4);

















var mdebug = __WEBPACK_IMPORTED_MODULE_13_debug___default()('esma:device_embedded_information');








__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component("device-modal", __WEBPACK_IMPORTED_MODULE_20__components_modals_device_modal___default.a);


/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_17__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_14__components_form_field___default.a,
    'sub-table_device-embedded-information': __WEBPACK_IMPORTED_MODULE_6__components_sub_pages_device_embedded_detail___default.a,
    "device-embedded-information-confirmation-modal": __WEBPACK_IMPORTED_MODULE_10__components_modals_device_embedded_information_confirmation_modal___default.a,
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_add_check___default.a,

    'application-confirmation-modal': __WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal___default.a,

    "change-history": __WEBPACK_IMPORTED_MODULE_15__components_modals_change_history_modal___default.a
  },
  data: function data() {
    var _ref;

    return _ref = {
      api_name: "device_embedded_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_16__rules_acl_rules___default.a.device_embedded_information_detail,
      approval_history_id: "",
      approval_id: null,
      approvalcancel_mode: false,
      hide_approval_cancel_field: true,
      local_status: false,
      save_edit_cliqued: false,
      temp_device_management_number: "",
      local_seq_id: -1,
      device_totalNumber: 0,
      approval_history_toroku_number: false,
      company_selection_started: false
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'approval_id', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'approval_history_bulk_toroku_number_qty', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'show_approval_history_bulk_toroku_number_qty', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'refresh_sequencer', 1), _ref;
  },

  computed: {
    refreshSequencer: {
      get: function get() {
        return this.refresh_sequencer;
      },
      set: function set(v) {
        this.refresh_sequencer = v;
      }
    },
    statusFieldStyle: function statusFieldStyle() {
      if (this.$store.state["current_field_style"] && this.$store.state["current_field_style"]["status"]) {
        return "border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" + this.$store.state["current_field_style"]["status"];
      } else {
        return "border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;";
      }
    },
    showApprovalHistoryBulkTorokuNumberQty: function showApprovalHistoryBulkTorokuNumberQty() {
      return this.approvalHistoryBulkTorokuNumberQty > 0 && this.loadBy == 'fk_id';
    },

    approvalHistoryBulkTorokuNumberQty: {
      get: function get() {
        return this.approval_history_bulk_toroku_number_qty;
      },
      set: function set(v) {
        this.approval_history_bulk_toroku_number_qty = v;
      }
    },
    approvalcancelmode: {
      get: function get() {
        return this.approvalcancel_mode;
      },
      set: function set(v) {
        this.approvalcancel_mode = v;
      }
    },
    localSeqId: {
      get: function get() {
        return this.local_seq_id;
      },
      set: function set(v) {
        this.local_seq_id = v;
      }
    },
    disableEditMainBtn: function disableEditMainBtn() {
      if (this.loadBy == 'fk_id') {
        return this.hideForApplicant && this.approvalStatus == "申請中";
      }
      return this.approvalStatus == "申請中";
    },
    disableNewToSubTableBtn: function disableNewToSubTableBtn() {
      if (this.loadBy == 'fk_id') {
        return this.hideForApplicant;
      }
      return this.approvalStatus == "申請中";
    },
    disableEditSubTableBtn: function disableEditSubTableBtn() {
      if (this.loadBy == 'fk_id') {
        return this.hideForApplicant;
      }
      return this.approvalStatus == "申請中";
    },
    disableCopyMainBtn: function disableCopyMainBtn() {
      return false;
    },
    disableApplicationBtn: function disableApplicationBtn() {
      return this.approvalStatus != "下書中" || this.$store.state[this.stateCurrentRow]["device_control_number"] == "" && this.device_totalNumber == 0;
    },
    draftWriteMode: function draftWriteMode() {
      return this.loadBy != "fk_id";
    },
    hideForApplicant: function hideForApplicant() {
      if (this.loadBy != 'fk_id') {
        return false;
      }
      if (typeof this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] == "undefined" && this.isAdmin == true) {
        return false;
      } else {
        return this.$store.state[this.stateCurrentRow]["approval_history_applicant"] == __WEBPACK_IMPORTED_MODULE_7_vue__["default"].localStorage.get("userID") && this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] != __WEBPACK_IMPORTED_MODULE_7_vue__["default"].localStorage.get("userID");
      }
    },
    hideApprovalcancel: function hideApprovalcancel() {
      this.hide_approval_cancel_field = this.retractionReason == "";
      this.hideApprovalCancelSet(this.hide_approval_cancel_field);
      if (this.loadBy != "fk_id" || this.approvalStatus != "申請中") {
        return true;
      } else {
        return false;
      }
    },
    hideEditMainBtn: function hideEditMainBtn() {
      return this.hideForApplicant && this.approvalStatus == "申請中";
    },
    hideNewToSubTableBtn: function hideNewToSubTableBtn() {
      return this.hideForApplicant;
    },
    hideEditSubTableBtn: function hideEditSubTableBtn() {
      return this.hideForApplicant;
    },
    hideApprovalcancelBtn: function hideApprovalcancelBtn() {
      return this.hideApprovalcancel;
    },
    hideCopyMainBtn: function hideCopyMainBtn() {
      return this.loadBy == 'fk_id' || this.is_new == true;
    },
    hideApplicationBtn: function hideApplicationBtn() {
      return this.loadBy == "fk_id" && this.approvalStatus != "下書中" || this.approvalStatus != "下書中";
    },
    hideApplyConfirmationBtn: function hideApplyConfirmationBtn() {
      if (this.loadBy != 'fk_id') {
        return true;
      }
      return this.hideForApplicant || this.approvalStatus != "申請中";
    },
    hideApplyRejectBtn: function hideApplyRejectBtn() {
      return this.refreshSequencer > 0 && this.hideApprovalcancel;
    },

    Virtual_environment: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["virtual_environment"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["virtual_environment"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["virtual_environment"] = this.local_status = v;
      }
    },
    Leasing_or_rental: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["leasing_or_rental"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["leasing_or_rental"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["leasing_or_rental"] = this.local_status = v;
      }
    },
    Equipment_Classification: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["equipment_classification"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["equipment_classification"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["equipment_classification"] = this.local_status = v;
      }
    },
    Cpu_Count: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["cpu_count"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["cpu_count"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["cpu_count"] = this.local_status = v;
      }
    },
    Status: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions: function StatusOptions() {
      var temp = __WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].status.options;
      if (this.is_new == true) {
        temp = __WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].status.options_for_new;
      }
      return temp;
    },
    subTableDeviceEmbeddedInformationStyle: function subTableDeviceEmbeddedInformationStyle() {
      if (this.saveEditClicked || this.is_new == false) {
        return "";
      } else {
        return "opacity: 0.5;";
      }
    },

    saveEditClicked: {
      get: function get() {
        return this.save_edit_cliqued;
      },
      set: function set(v) {
        this.save_edit_cliqued = v;
      }
    },
    approvalHistoryId: {
      get: function get() {
        return this.approval_history_id;
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    approvalHistoryTorokuNumber: {
      get: function get() {
        return this.approval_history_toroku_number;
      },
      set: function set(v) {
        this.approval_history_toroku_number = v;
      }
    },
    isAdminSavingApplication: function isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    showFieldchangedStyle: function showFieldchangedStyle() {
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" || this.$store.state[this.stateCurrentRow]["approval_status"] == "差戻") && (this.isAdmin || this.$store.state[this.stateCurrentRow]["approval_history_next_approver"]);
    },
    showapprovalStatus: function showapprovalStatus() {
      return this.$store.state[this.stateCurrentRow]["approval_status"] == "承認済";
    },


    approvalId: {
      get: function get() {
        return this.approval_id;
      },
      set: function set(v) {
        this.approval_id = v;
      }
    },
    approvalStatus: function approvalStatus() {
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"];
    },
    retractionReason: function retractionReason() {
      if (this.$store.state[this.stateCurrentRow]["retraction_reason"] != null) {
        return this.$store.state[this.stateCurrentRow]["retraction_reason"];
      } else {
        return "";
      }
    },
    deviceControlNumber: function deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["device_control_number"];
    },
    deviceSeqId: function deviceSeqId() {
      return parseInt(this.$store.state[this.stateCurrentRow]["seq_id"] || this.localSeqId);
    },
    registrationDate: function registrationDate() {
      return __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    formFields: function formFields() {
      var _this = this;

      return {
        col1: [__WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].virtual_environment, {
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("virtual_base_unit", { val: data == "有" });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].virtual_base_unit, {
          disabled: false,
          required: true,
          force_readonly: true,
          field_style: " width: 100%;display: block;",
          buttons: [{
            btn_style: "width:100%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 10px;background: #43c9de;border-color:#43c9de;",
            type: "callback",
            callback: function callback(b) {
              _this.devicePopUp();
            },
            label: "機器" }],
          listen_for: [{
            name: "virtual_base_unit",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {
          on_set_value: function on_set_value(data) {

            setTimeout(function () {

              if (data == "IT所管システム") {
                __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_it", { val: true });
                __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system", { val: false });
              } else if (data == "EUC・その他") {
                __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system", { val: true });
                __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_it", { val: false });
              } else {}
            }, 300);
          }
        }), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system_it, {
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system_it",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        })],
        col2: [__WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].leasing_or_rental, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].manufacture_name, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].model_name, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].equipment_classification, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].cpu_count, {})],
        col3: [__WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].installation_base, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].floor, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, {})],
        col2b: [__WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].remarks, {}), __WEBPACK_IMPORTED_MODULE_12__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_9__rules_fields_device_embedded_information__["a" /* fields */].retraction_reason, {
          disabled: true,
          hide_all: true,
          force_write: false
        })]
      };
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("deletedeviceEmbeddedInformationDetailModal", {
        title: "削除",
        message: "機器・組込情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    subTableSaved: function subTableSaved(cb) {
      this.onDeviceEmbeddedInformationAddCheckConfirm("yes", cb);
    },
    showHistory: function showHistory() {
      __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("showDeviceEmbeddedInformationlogHistoryModal", {
        fk_tab: __WEBPACK_IMPORTED_MODULE_19__rules_constants___default.a.TABLE_ID.DEVICE_EMBEDDED_INFORMATION,
        fk_id: this.localSeqId
      });
    },
    cloneRecord: function cloneRecord() {
      return this.$router.push({ name: "page_0060_redirect", params: {
          url: "/device_embedded_information/clone/" + this.localSeqId,
          message: "コピー ...",
          wait: 50
        } });
    },
    processFieldStyle: function processFieldStyle(store_key_name, last_changed_fields) {
      var _this2 = this;

      if (Array.isArray(last_changed_fields)) {
        last_changed_fields.forEach(function (e) {});
      } else {}
      this.$store.state[store_key_name] = {};
      if (last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0) {
        last_changed_fields.forEach(function (f) {
          if (_this2.showFieldchangedStyle) {
            _this2.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },
    processApproval: function processApproval(approve_mode) {
      var _this3 = this;

      var changes = {
        seq_id: this.approvalId,
        update_time: __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
      };

      if (approve_mode == "cancel") {
        this.commonSaveInfo(this, this.api_name, { from_edit_form: true }, function (err) {
          if (err) {} else {
            _this3.$ajax.post('/approval_history/prepare_to_approve/' + _this3.approvalId, { changes: changes, approve_mode: approve_mode }, function (err, result) {
              if (err) {
                _this3.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("notificationAfterdeviceInformationApprovalStartedRequest", {
                  message: "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。",
                  title: "申請が差戻されました",
                  yes_label: "",
                  no_label: "OK",
                  yes_color: "",
                  no_color: "",
                  model_height: "50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      } else {
        var selected_approval_history = this.loadSelectedApprovalHistory();
        if (selected_approval_history.indexOf(this.approvalId) < 0) {
          selected_approval_history.push(this.approvalId);
          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].localStorage.set('selected_approval_history', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(selected_approval_history));
        }
        __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("notificationAfterdeviceInformationApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50"
        });
      }
    },
    processApprovalReason: function processApprovalReason(approve_mode) {
      var _this4 = this;

      var changes = {
        seq_id: this.approvalId,
        update_time: __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
      };

      if (approve_mode == "cancel") {
        this.commonSaveInfo(this, this.api_name, { from_edit_form: true }, function (err) {
          if (err) {} else {
            _this4.$ajax.post('/approval_history/prepare_to_approve/' + _this4.approvalId, { changes: changes, approve_mode: approve_mode }, function (err, result) {
              if (err) {
                _this4.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("notificationAfterdeviceInformationApprovalStartedRequest", {
                  message: "申請が取戻されました",
                  title: "",
                  yes_label: "",
                  no_label: "OK",
                  yes_color: "",
                  no_color: "",
                  model_height: "50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      } else {
        var selected_approval_history = this.loadSelectedApprovalHistory();
        if (selected_approval_history.indexOf(this.approvalId) < 0) {
          selected_approval_history.push(this.approvalId);
          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].localStorage.set('selected_approval_history', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(selected_approval_history));
        }
        __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("notificationAfterdeviceInformationApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50"
        });
      }
    },
    processApprovalApprove: function processApprovalApprove() {
      return this.processApproval('approve');
    },
    processApprovalCancelBack: function processApprovalCancelBack(mode) {
      if (mode == "yes") {
        console.log("processApprovalCancelBack", mode);
        this.processApproval('cancel');
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    processApprovalCancelBackReason: function processApprovalCancelBackReason(mode) {
      if (mode == "yes") {
        console.log("processApprovalCancelBack", mode);
        this.processApprovalReason('cancel');
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    onDeviceEmbeddedInformationAddCheckConfirm: function onDeviceEmbeddedInformationAddCheckConfirm(mode) {
      var _this5 = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (mode == "yes") {
        console.log("onDeviceEmbeddedInformationAddCheckConfirm", mode);
        this.read_only = false;
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        this.commonSaveInfo(this, this.api_name, { from_edit_form: true }, function (err, data) {
          if (err) {
            if (cb) {
              cb(err);
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("reloadSubTableDeviceEmbeddedInformation", { clear_list: true });
            if (_this5.is_new == true) {
              _this5.saveEditClicked = true;
              __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("reloadSubTableDeviceEmbeddedInformation", { fk_id: _this5.deviceSeqId });
              _this5.localSeqId = _this5.deviceSeqId;
            }
            if (cb) {
              return cb(null);
            }
            __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("notificationAfterSave", {
              message: "",
              title: "登録情報を下書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "",
              model_height: "50"
            });
          }
        });
      }
    },
    onDeviceEmbeddedInformationUpAddCheckConfirm: function onDeviceEmbeddedInformationUpAddCheckConfirm(mode) {
      if (mode == "yes") {
        this.read_only = false;
        this.commonSaveInfo(this, this.api_name, { from_edit_form: true, overwrite_changed_fields: true, approval_id: this.approvalId }, function (err) {
          if (err) {} else {
            __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("notificationAfterSave", {
              message: "",
              title: "登録情報を上書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "",
              model_height: "50"
            });
          }
        });
      }
    },
    afterTheNotificationAfterSave: function afterTheNotificationAfterSave(mode) {
      if (mode == "no" || mode == "yes") {
        if (this.loadBy == "clone") {
          return this.$router.push({ name: "page_0092_reload", params: { return_to: "/device_embedded_information/" + this.localSeqId } });
        } else {
          if (this.loadBy != "fk_id") {
            return this.$router.push("/device_embedded_information/" + this.localSeqId);
          }
        }
      }
    },
    afterTheNotificationAftercancel: function afterTheNotificationAftercancel(mode) {
      var _this6 = this;

      setTimeout(function () {
        return _this6.$router.push("/approval_history");
      }, 600);
      console.log("afterTheNotificationAftercancel");
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      var dcn = this.deviceControlNumber;
      if ((typeof dcn === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(dcn)) == undefined || dcn == null || dcn == false || dcn.length == 0) {
        dcn = "BY_SEQ_ID::" + this.localSeqId;
      }
      __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("deviceEmbeddedApplicationConfimationModal", {
        application_mode: "device_embedded",
        ref_id: dcn,

        seq_id: this.localSeqId,
        load_previous_if_exist: true,
        approval_history_id: this.approvalHistoryId || false,
        approval_history_toroku_number: this.approvalHistoryTorokuNumber || false
      });
    },
    onConfirmExecuteProcessConfirmation: function onConfirmExecuteProcessConfirmation() {
      var dcn = this.deviceControlNumber;
      if ((typeof dcn === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(dcn)) == undefined || dcn == null || dcn == false || dcn.length == 0) {
        dcn = "BY_SEQ_ID::" + this.localSeqId;
      }
      __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("deviceEmbeddedApplicationConfimationModal", {
        application_mode: "device_embedded",
        ref_id: dcn,
        modal_is_read_only: true,
        seq_id: this.localSeqId,
        approval_history_id: this.approvalHistoryId || false,
        approval_history_toroku_number: this.approvalHistoryTorokuNumber || false
      });
    },
    hideApprovalCancelSet: function hideApprovalCancelSet(flag) {
      if (typeof this.fieldList["retraction_reason"] != "undefined") {
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined") {
          this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    ApprovalCancelModeSet: function ApprovalCancelModeSet(aflag) {
      var bflag = this.hideApprovalcancel;
      if (typeof this.fieldList["retraction_reason"] != "undefined") {
        if (aflag == true) {
          this.fieldList["retraction_reason"].force_write = true;
          this.approvalcancelmode = true;
        } else {
          this.fieldList["retraction_reason"].force_write = false;
          this.approvalcancelmode = false;
        }
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined") {
          this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    processApprovalCancel: function processApprovalCancel() {
      console.log("processApprovalCancel");
      this.ApprovalCancelModeSet(true);
    },
    onapprovalSaveDevEmbedded: function onapprovalSaveDevEmbedded() {
      __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddcancel", {
        message: "よろしいですか？",
        title: "申請を差戻します。",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onapprovalSaveDevEmbeddedReason: function onapprovalSaveDevEmbeddedReason() {
      __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddcancelReason", {
        message: "よろしいですか？",
        title: "申請を取戻します。",
        yes_label: "取戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    approvalCancelbtn: function approvalCancelbtn() {
      this.ApprovalCancelModeSet(false);
    },
    onLocalSaveDevEmbedded: function onLocalSaveDevEmbedded() {
      var _this7 = this;

      var message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>承認状態が【下書中】となるので、申請が必要になります。</span>";

      if (this.showapprovalStatus == true) {
        message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>※承認状態が【承認済】のものは【下書中】になります。 </span>";
      }
      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        if (_this7.is_new == false) {
          _this7.saveEditClicked = true;
        }
        console.log("onLocalSave");
        __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddCheck", {
          message: message,
          title: "登録情報を下書保存します。",
          yes_label: "下書保存",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "100",
          model_width: "450px"
        });
      });
    },
    onLocalUpSaveDevEmbedded: function onLocalUpSaveDevEmbedded() {
      console.log("onLocalSave");
      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationUpAddCheck", {
          message: "よろしいですか？",
          title: "登録情報を上書保存します。",
          yes_label: "上書保存",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onEdit: function onEdit() {
      mdebug("on Edit");
      this.startCompanySelection();
      this.commonOnEdit();
      if (this.loadBy == "fk_id" && this.approvalStatus == "申請中") {
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled = false;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      } else {
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled = true;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      }
    },
    btnCancel: function btnCancel() {
      this.commonValidateFieldsClear(this, function () {});
      this.cancelCurrentSelection(true);
      this.local_status = false;
      this.$store.state[this.stateCurrentEditing]["approval_status"] = "";
      this.$store.state[this.stateCurrentRow]["approval_status"] = "";
      this.loadFormData();
    },
    backToList: function backToList() {
      var device_back_to_list = window.sessionStorage.getItem("device_back_to_list");
      if (this.loadBy == "clone") {
        return this.$router.push({ name: "page_0010_device_embedded_information", params: {} });
      } else if ((device_back_to_list || "").indexOf("/") == 0) {
        return this.$router.push(device_back_to_list);
      }
    },
    gotocertificate: function gotocertificate() {
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate: function selectCertificate() {
      this.showSubTable = true;
    },
    confirmedSetdevice: function confirmedSetdevice(mode) {
      if (mode == "yes") {
        __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("device_number_force_update", this.temp_device_management_number);
      } else if (mode == "no") {
        return __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("showdeviceModal");
      }
    },
    devicePopUp: function devicePopUp() {
      __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("showdeviceModal");
    },
    ondeviceModalSelected: function ondeviceModalSelected(val) {
      if (val && val.length > 0) {
        __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("showConfimationModalSetdevice", {
          title: "",
          message: "管理番号 '" + val + "' を割り当てます。よろしいですか？",
          yes_label: "OK",
          no_label: "戻る",
          yes_color: "primary",
          model_height: 80
        });
        this.temp_device_management_number = val;
      }
    },
    prepareCompanySelection: function prepareCompanySelection(companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name) {
      var _this8 = this;

      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: true });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: true });
          }
        }
      });
      company_field.page_controller_msg({ cmd: "set_options", options: _.clone(companies) });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });
        selected_company = _this8.$store.state[_this8.stateCurrentRow][company_field.id];
        selected_department = _this8.$store.state[_this8.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          department_field.page_controller_msg({ cmd: "enable" });
          var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: false });
          if (selected_department && selected_department.length > 0) {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: false });
          }
        }
      }, this.is_new ? 100 : 500);
    },
    startCompanySelection: function startCompanySelection() {
      var _this9 = this;

      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;

        this.$ajax.post_cached_queued('/master_company/list_company_name', {}, function (err, _companies) {
          if (err) {
            _this9.$notify({
              title: '所管会社のデータが読込めませんでした。',
              text: err,
              type: 'error',
              duration: 10000
            });
            return;
          }
          var companies = [""];
          _companies.forEach(function (c) {
            companies.push(c.val);
          });

          _this9.$ajax.post_cached_queued('/master_belongs/list_team_and_department', {}, function (err, department_and_team) {
            if (err) {
              _this9.$notify({
                title: '部署・チームのデータの読込に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              return;
            }
            _this9.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.equipment_in_charge_department, temp_fields.equipment_in_charge_team, "company", "department");
            if (_this9.$route.params.seq_id == "new") {
              var default_company = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].localStorage.get(temp_fields.company.default_from_local_storage);
              if (default_company != __WEBPACK_IMPORTED_MODULE_19__rules_constants___default.a.COMPANY.ALL) {
                setTimeout(function () {
                  var default_deparment = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].localStorage.get(temp_fields.equipment_in_charge_department.default_from_local_storage);
                  var default_team = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].localStorage.get(temp_fields.equipment_in_charge_team.default_from_local_storage);
                  temp_fields.company.page_controller_msg({ cmd: "set_value", val: default_company });
                  temp_fields.equipment_in_charge_department.page_controller_msg({ cmd: "set_value", val: default_deparment });
                  temp_fields.equipment_in_charge_team.page_controller_msg({ cmd: "set_value", val: default_team });
                }, _this9.is_new ? 300 : 1000);
              }
            }
          });
        });
      }
    },
    loadFormData: function loadFormData() {
      var _this10 = this;

      console.log("Load DeviceEmbeddedInformation", this.loadBy);
      this.approvalHistoryBulkTorokuNumberQty = 0;
      this.fieldList["retraction_reason"].hide_all = true;
      if (this.loadBy == "fk_id") {
        this.is_new = false;
        this.localSeqId = this.$route.params.fk_id;
        this.approvalId = this.$route.params.approval_id;
        this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.fk_id, { fk_id: this.$route.params.fk_id }, function (err, result) {
          if (err) {
            _this10.$notify({
              title: 'データの読込に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }
          _this10.localSeqId = result.data.seq_id;
          _this10.$store.state[_this10.stateCurrentRow] = result.data;
          _this10.fieldList["retraction_reason"].hide_all = _this10.$store.state[_this10.stateCurrentRow].approval_status == "承認済";
          _this10.refreshSequencer++;
          if (typeof _this10.$store.state[_this10.stateCurrentRow].approval_history_id == "number" && isNaN(_this10.$store.state[_this10.stateCurrentRow].approval_history_toroku_number) == false) {
            _this10.approvalHistoryId = _this10.$store.state[_this10.stateCurrentRow].approval_history_id;
            if (_this10.approvalHistoryId > 0) {
              _this10.approvalId = _this10.approvalHistoryId;
            }
            _this10.approvalHistoryTorokuNumber = _this10.$store.state[_this10.stateCurrentRow].approval_history_toroku_number;
            if (_this10.approvalHistoryId == -200) {
              _this10.approvalHistoryTorokuNumber;
            }
          }
          _this10.approvalHistoryBulkTorokuNumberQty = result.data.approval_history_bulk_toroku_number_qty || 0;
          _this10.commonSetStyleForChangedFields(result.data);
          __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("reloadSubTableDeviceEmbeddedInformation", { fk_id: _this10.localSeqId });
          mdebug("LOAD DATA", { err: err, result: result });
        });
      } else if (this.loadBy == "clone") {
        this.startCompanySelection();
        this.is_new = true;
        this.localSeqId = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
        this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.seq_id, {}, function (err, result) {
          if (err) {
            _this10.$notify({
              title: 'データの読込に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }

          _this10.$store.state[_this10.stateCurrentRow] = {};
          _this10.$store.state[_this10.stateCurrentEditing] = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result.data).forEach(function (k) {
            var value = result.data[k];
            if (k == "seq_id") {
              _this10.$store.state[_this10.stateCurrentRow][k] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
            } else if (k == "device_control_number") {
              _this10.$store.state[_this10.stateCurrentRow][k] = "";
              _this10.$store.state[_this10.stateCurrentEditing][k] = "";
            } else if (k == "approval_status_flag") {
              _this10.$store.state[_this10.stateCurrentRow][k] = 0;
              _this10.$store.state[_this10.stateCurrentEditing][k] = 0;
            } else if (k == "approval_status") {
              _this10.$store.state[_this10.stateCurrentRow][k] = "";
              _this10.$store.state[_this10.stateCurrentEditing][k] = "";
            } else {
              _this10.$store.state[_this10.stateCurrentRow][k] = value;
              _this10.$store.state[_this10.stateCurrentEditing][k] = value;
            }
          });
          _this10.Status = "使用中";
          _this10.commonSetStyleForChangedFields(result.data);
          _this10.refreshSequencer++;
          setTimeout(function () {
            _this10.$store.state[_this10.stateIsEditingNew] = true;
            _this10.read_only = false;
            _this10.is_new = true;
          }, 300);
          _this10.commonEditDeleteCmdHandler(_this10);
        });
      } else {
        setTimeout(function () {
          _this10.localSeqId = _this10.$route.params.seq_id;
          console.log("Load DeviceEmbeddedInformation else 2", _this10.localSeqId);
          __WEBPACK_IMPORTED_MODULE_21__libs_bus__["a" /* bus */].$emit("reloadSubTableDeviceEmbeddedInformation", { fk_id: _this10.localSeqId });
        }, 2);

        this.commonLoadRecord({}, function (err, result) {
          console.log("Load DeviceEmbeddedInformation else", _this10.localSeqId);
          if (_this10.$route.params.seq_id == "new") {
            _this10.Cpu_Count = "1";
            _this10.Status = "使用中";
            setTimeout(function () {
              _this10.startCompanySelection();
            }, 10);
          }
          if (typeof _this10.$store.state[_this10.stateCurrentRow].approval_history_id == "number" && isNaN(_this10.$store.state[_this10.stateCurrentRow].approval_history_toroku_number) == false) {
            _this10.approvalHistoryId = _this10.$store.state[_this10.stateCurrentRow].approval_history_id;
            _this10.approvalHistoryTorokuNumber = _this10.$store.state[_this10.stateCurrentRow].approval_history_toroku_number;
            if (_this10.approvalHistoryId == -200) {
              _this10.approvalHistoryTorokuNumber;
            }
          }
          _this10.commonEditDeleteCmdHandler(_this10);
          _this10.refreshSequencer++;
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadFormData();
  },
  beforeDestroy: function beforeDestroy() {
    this.approvalHistoryBulkTorokuNumberQty = 0;
    mdebug("LOCAL beforeDestroy ");
    var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")] = {};
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_device_modal__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_device_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_modals_device_modal__);











var mdebug = __WEBPACK_IMPORTED_MODULE_9_debug___default()('esma:device_embedded_information');







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("device-modal", __WEBPACK_IMPORTED_MODULE_16__components_modals_device_modal___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_10__components_form_field___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail___default.a,
    "device-embedded-information-confirmation-modal": __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal___default.a,
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check___default.a,
    'application-confirmation-modal': __WEBPACK_IMPORTED_MODULE_7__components_modals_application_confirmation_modal___default.a
  },
  data: function data() {
    return {
      api_name: "device_embedded_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_11__rules_acl_rules___default.a.generic,
      approval_history_id: "",
      local_status: false,
      show_apply_button: false,
      approval_id: null
    };
  },

  computed: {
    showApplyButton: {
      get: function get() {
        return this.show_apply_button;
      },
      set: function set(v) {
        this.show_apply_button = v;
      }
    },

    aprovalId: {
      get: function get() {
        return this.aproval_id;
      },
      set: function set(v) {
        this.aproval_id = v;
      }
    },
    approvalHistoryId: {
      get: function get() {
        return this.approval_history_id;
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    Status: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions: function StatusOptions() {
      var temp = __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].status.options;

      return temp;
    },
    deviceControlNumber: function deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["device_control_number"];
    },
    registrationDate: function registrationDate() {
      return __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    formFields: function formFields() {
      var _this = this;

      return {
        col1: [__WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].device_control_number), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].virtual_environment), {
          error_if_blank: false,
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("upd_virtual_base_unit", { val: data == "有" });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].virtual_base_unit), {
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          buttons: [{
            btn_style: "width:100%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 10px;background: #43c9de;border-color:#43c9de;",
            type: "callback",
            callback: function callback(b) {
              _this.devicePopUp();
            },
            label: "機器" }],
          listen_for: [{
            name: "upd_virtual_base_unit",
            mode: "disable_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].company), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification), {
          error_if_blank: false,
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              if (data == "IT所管システム") {
                __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_it_bulk", { val: true });
                __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_bulk", { val: false });
              } else if (data == "EUC・その他") {
                __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_bulk", { val: true });
                __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_it_bulk", { val: false });
              } else {}
            }, 300);
          }
        }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system_it), {
          error_if_blank: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system_it_bulk",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system), {
          error_if_blank: false,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system_bulk",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        })],
        col2: [__WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].computer_name), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].leasing_or_rental), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].manufacture_name), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].model_name), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_classification), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].cpu_count), { error_if_blank: false })],
        col3: [__WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_department), { default_from_local_storage: false, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_team), { default_from_local_storage: false, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_base), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].floor), {}), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].user_name), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].management_person_name), { error_if_blank: false })],
        col2b: [__WEBPACK_IMPORTED_MODULE_8__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].remarks), {})]
      };
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    processFieldStyle: function processFieldStyle(store_key_name, last_changed_fields) {
      var _this2 = this;

      this.$store.state[store_key_name] = {};
      if (last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0) {
        last_changed_fields.forEach(function (f) {
          if (_this2.$store.state[_this2.stateCurrentRow]["approval_status"] == "申請中" && _this2.showProcessAprovalButton) {
            _this2.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },
    processApproval: function processApproval() {
      var _this3 = this;

      var changes = {
        seq_id: this.aprovalId,
        update_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
      };
      this.$ajax.post('/approval_history/prepare_to_approve/' + this.aprovalId, { changes: changes }, function (err, result) {
        if (err) {
          _this3.$notify({
            title: 'データの承認に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          return _this3.$router.push("/approval_history");
        }
      });
    },
    onBulkDeviceEmbeddedInformationAddCheckConfirm: function onBulkDeviceEmbeddedInformationAddCheckConfirm(mode) {
      var _this4 = this;

      if (mode == "yes") {
        this.read_only = false;
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        var list_seq_id = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get('bulk_edit_' + this.local_page_id);
        try {
          list_seq_id = JSON.parse(list_seq_id);
          var disabled_fields = [];
          this.allFields.forEach(function (f) {
            if (f.ref_field && (f.ref_field.data && f.ref_field.data.disabled == true || f.ref_field.localDisabled == true)) {
              disabled_fields.push(f.id);
            }
          });
          this.saveBulk(this.api_name, list_seq_id.arr, { from_edit_form: true, disabled_fields: disabled_fields }, function (err) {
            _this4.showApplyButton = true;
            _this4.read_only = true;

            setTimeout(function () {
              var temp_current = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(_this4.$store.state[_this4.stateCurrentRow]);
              var temp = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(_this4.$store.state[_this4.stateCurrentEditing]);
              _this4.allFields.forEach(function (f) {
                if (typeof temp[f.id] == "undefined") {
                  temp[f.id] = temp_current[f.id] || "";
                }
              });
              _this4.$store.state[_this4.stateCurrentRow] = temp;
              _this4.$store.state[_this4.stateCurrentEditing] = temp;
            }, 50);
          });
        } catch (error) {
          this.$notify({
            title: "予期しないエラーが発生し、登録が行えません",
            text: error,
            type: 'error',
            duration: 12000
          });
        }
      }
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      var list_seq_id = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get('bulk_edit_' + this.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id);
        var syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.DEVICE;
        __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("bulkDeviceEmbeddedApplicationConfimationModal", {
          list_seq_id: list_seq_id.arr,
          application_mode: "bulk_edit_device_embedded",
          title_suffix: "" + syubetu + "(一括編集）",
          process_import_url: '/' + this.api_name + '/bulk_to_approval_history/',
          on_finish_url_name: "page_0010_device_embedded_information",
          ref_id: null
        });
      } catch (error) {
        this.$notify({
          title: "適用する行の読込に失敗しました。",
          text: error,
          type: 'error',
          duration: 12000
        });
      }
    },
    onLocalSaveBulkDevEmbedded: function onLocalSaveBulkDevEmbedded() {
      console.log("onLocalSave");
      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("confirmBulkDeviceEmbeddedInformationAddCheck", {
          message: "",
          title: "本当に登録してよろしいでしょうか。",
          yes_label: "完了",
          no_label: "キャンセル",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onEdit: function onEdit() {
      var _this5 = this;

      mdebug("onEdit");
      setTimeout(function () {
        _this5.showApplyButton = false;
        _this5.read_only = false;
      }, 300);
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    backToList: function backToList() {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove('bulk_edit_' + this.local_page_id);
      var device_back_to_list = window.sessionStorage.getItem("device_back_to_list");
      if ((device_back_to_list || "").indexOf("/") == 0) {
        return this.$router.push(device_back_to_list);
      } else {
        return this.$router.push("/device_embedded_information");
      }
    },
    gotocertificate: function gotocertificate() {
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate: function selectCertificate() {
      this.showSubTable = true;
    },
    confirmedSetdevice: function confirmedSetdevice(mode) {
      if (mode == "yes") {
        __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("device_number_force_update", this.temp_device_management_number);
      } else if (mode == "no") {
        return __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("showdeviceModal");
      }
    },
    devicePopUp: function devicePopUp() {
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("showdeviceModal");
    },
    ondeviceModalSelected: function ondeviceModalSelected(val) {
      if (val && val.length > 0) {
        __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("showConfimationModalSetdevice", {
          title: "",
          message: "管理番号 '" + val + "' を割り当てます。よろしいですか？",
          yes_label: "OK",
          no_label: "戻る",
          yes_color: "primary",
          model_height: 80
        });
        this.temp_device_management_number = val;
      }
    },
    prepareCompanySelection: function prepareCompanySelection(companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name) {
      var _this6 = this;

      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: true });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: true });
          }
        }
      });
      company_field.page_controller_msg({ cmd: "set_options", options: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(companies) });
      company_field.page_controller_msg({ cmd: "disable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });
        selected_company = _this6.$store.state[_this6.stateCurrentRow][company_field.id];
        selected_department = _this6.$store.state[_this6.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          department_field.page_controller_msg({ cmd: "enable" });
          var departments = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: false });
          if (selected_department && selected_department.length > 0) {
            var teams = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: false });
          }
        }
        var slUserCompany = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userCompany") || false;
        if (slUserCompany && slUserCompany.indexOf("MH") == 0) {
          company_field.page_controller_msg({ cmd: "set_value", val: slUserCompany });
        } else if (slUserCompany && slUserCompany.indexOf("ライセンス管理窓口") == 0) {
          console.log('TEST DEBUG 210429 (410 at page_0010_device_embedded_information_detail_bulk_edit.vue)[16:08]: try to enable', {});
          company_field.page_controller_msg({ cmd: "enable" });
        }
      }, this.is_new ? 100 : 500);
    },
    startCompanySelection: function startCompanySelection() {
      var _this7 = this;

      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;

        this.$ajax.post_cached_queued('/master_company/list_company_name', {}, function (err, _companies) {
          if (err) {
            _this7.$notify({
              title: '所管会社のデータが読込めませんでした。',
              text: err,
              type: 'error',
              duration: 10000
            });
            return;
          }
          var companies = [""];
          _companies.forEach(function (c) {
            companies.push(c.val);
          });

          _this7.$ajax.post_cached_queued('/master_belongs/list_team_and_department', {}, function (err, department_and_team) {
            if (err) {
              _this7.$notify({
                title: '部署・チームのデータの読込に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
              return;
            }
            _this7.prepareCompanySelection(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(companies), __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(department_and_team), temp_fields.company, temp_fields.equipment_in_charge_department, temp_fields.equipment_in_charge_team, "company", "department");
            if (_this7.$route.params.seq_id == "new") {
              var default_company = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get(temp_fields.company.default_from_local_storage);
              if (default_company != __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.COMPANY.ALL) {
                setTimeout(function () {
                  var default_deparment = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get(temp_fields.equipment_in_charge_department.default_from_local_storage);
                  var default_team = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get(temp_fields.equipment_in_charge_team.default_from_local_storage);
                  temp_fields.company.page_controller_msg({ cmd: "set_value", val: default_company });
                  temp_fields.equipment_in_charge_department.page_controller_msg({ cmd: "set_value", val: default_deparment });
                  temp_fields.equipment_in_charge_team.page_controller_msg({ cmd: "set_value", val: default_team });
                }, _this7.is_new ? 300 : 1000);
              }
            }
          });
        });
      }
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.$store.state[this.stateCurrentEditing] = {};
    this.addHtmlClass(document.body, 'blue_bg');
    this.local_page_id = this.$route.params.p_id;

    this.is_new = true;

    this.allFields.forEach(function (f) {
      _this8.$store.state[_this8.stateCurrentRow][f.id] = "";
    });
    this.startCompanySelection();
    setTimeout(function () {
      _this8.$store.state[_this8.stateIsEditingNew] = true;
      _this8.read_only = false;
      _this8.is_new = true;
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_it_bulk", { val: false });
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system_bulk", { val: false });
    }, 300);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.removeHtmlClass(document.body, 'blue_bg');
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sub_pages_associated_device__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sub_pages_associated_device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sub_pages_associated_device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:device_embedded_information');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'sub-table-associated_device': __WEBPACK_IMPORTED_MODULE_3__components_sub_pages_associated_device___default.a,
    'field-box': __WEBPACK_IMPORTED_MODULE_6__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "certificate_information",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    deviceControlNumber: function deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["device_control_number"];
    },
    registrationDate: function registrationDate() {
      return __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].certificate_management_number, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_certificate_type, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].certificate_individual_number, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].comprehensive_contract, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].sales_company, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].applicant_name, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].management_person_name, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].downgrade, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].expiration_date, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].maintenance_deadline, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].deadline_alert, {})],
        col3: [],
        col2b: [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].remark, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].other_items_by_manufacturer, {})]
      };
    }
  },
  methods: {
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      var _this = this;

      mdebug("onEdit");
      setTimeout(function () {
        _this.read_only = false;
      }, 300);
    },
    backToList: function backToList() {
      return this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    mdebug("page_0015_device_embedded_information_pegging mounting");

    this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.seq_id, {}, function (err, result) {
      if (err) {
        _this2.$notify({
          title: 'データの読込に失敗しました。',
          text: err,
          type: 'error',
          duration: 10000
        });
      }
      _this2.$store.state[_this2.stateCurrentRow] = result.data;

      mdebug("LOAD DATA", { err: err, result: result });
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:certificate_information');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "certificate_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      detail_page: "page_0040_certificate_information_detail"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].certificate_management_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].effective_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].remaining_number, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    backToList: function backToList() {
      return this.$router.go(-1);
    },
    CheckToList: function CheckToList(ev, data) {
      return this.$router.go(-2);
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__rules_constants__);










var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:surplus_license');









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__["AgGridVue"],
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "certificate_software",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.surplus_license,
      detail_page: "page_0040_certificate_software_detail",
      execute_filter_on_back: true,
      link_to_open: "#",
      select_all: false
    };
  },

  computed: {

    approveMode: {
      get: function get() {
        return this.approve_mode;
      },
      set: function set(v) {
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll: {
      get: function get() {
        return this.select_all;
      },
      set: function set(v) {
        this.select_all = v;
      }
    },
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0 || typeof _.find(this.selectedRowArr, function (d) {
        return d.real_certificate_management_number != "" && d.real_certificate_management_number != null;
      }) != "undefined";
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].maker, __WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].software_name, __WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].expiration_date, __WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].maintenance_deadline];
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].certificate_software_number, { tab_label: "証書管理番号" }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].software_name, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].license, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].expiration_date, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].maintenance_deadline, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_surplus_license__["a" /* fields */].deadline_check, {
        cellRenderer: function cellRenderer(params) {
          if (params.value < 0) {
            if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF) {
              return "<span style='color:red';>" + params.value + "</span>";
            } else {
              return "";
            }
          } else {
            return params.value;
          }
        }
      })];
    }
  },
  methods: {
    onTabChanged: function onTabChanged(index, b, c) {
      this.selectedTab = index;
      this.clearSearchFields();
      switch (index) {
        case 0:
          this.api_request_options = { filter_mode: "使用中" };
          break;
        case 1:
          this.api_request_options = { filter_mode: "廃棄" };
          break;
      }
      this.emulateSearchControlChangedDatasource(true);
    },
    allChecked: function allChecked(a, b) {
      this.commonAllChecked("showInformationIconModalSurplus");
    },
    hideCheckBox: function hideCheckBox(data) {
      return data && data.approval_status == "申請中";
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("deleteCertificateInformationModal", {
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("runSurplusLicenseDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: { sub_search: "sub_search", filter_mode: "余剰" },
        sub_search: this.search_data,
        url: "/" + this.api_name + "/export_data_surplus_license/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    bachEdit: function bachEdit() {
      var p_id = __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4();
      var obj = { arr: this.selectedRowArr.map(function (m) {
          return m.seq_id;
        }) };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("bulk_edit_" + p_id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
      return this.$router.push("/surplus_license/bulk_edit/" + p_id);
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    }
  },
  mounted: function mounted() {
    window.sessionStorage.setItem('certificate_back_to_list', "/surplus_license");
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {

    this.count_from_result = true;
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = { filter_mode: "余剰" };
    this.initDatasource({ load_only_with_filter: false });
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_surplus_license_sub_page__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_surplus_license_sub_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sub_pages_surplus_license_sub_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:surplus_license_details');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a,
    'surplus-license-sub-table': __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_surplus_license_sub_page___default.a
  },
  data: function data() {
    return {
      api_name: "surplus_license",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.surplus_license,
      show_allocation_request_form: false,
      sub_table_seq_id: -1
    };
  },

  computed: {
    subTableSeqID: {
      get: function get() {
        return Number(this.sub_table_seq_id) + "";
      },
      set: function set(v) {
        this.sub_table_seq_id = v;
      }
    },
    surplusLicenseSeqID: function surplusLicenseSeqID() {
      return Number(this.$store.state[this.stateCurrentRow]["seq_id"]);
    },
    showAllocationRequestBtn: function showAllocationRequestBtn() {
      return this.is_new == false;
    },

    showAllocationRequestForm: {
      get: function get() {
        return this.show_allocation_request_form;
      },
      set: function set(v) {
        this.show_allocation_request_form = v;
      }
    },
    pageTitle: function pageTitle() {
      return this.is_new ? "余剰ライセンス登録" : "余剰ライセンス(詳細)";
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].software_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].effective_number, {})]
      };
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    onAllocationRequest: function onAllocationRequest() {
      this.showAllocationRequestForm = true;
    },
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("deleteSurplusLicenseModal", {
        title: "削除",
        message: "メーカの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      if (this.loadBy == "review") {
        return this.$router.push({ name: "page_0020_surplus_license_request", params: {} });
      } else {
        return this.$router.push({ name: "page_0020_surplus_license", params: {} });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.commonLoadRecord({}, function (err, result) {
      if (_this.loadBy == "review") {
        _this.subTableSeqID = _this.$route.params.review_seq_id;
        _this.showAllocationRequestForm = true;
      } else {
        _this.subTableSeqID = -1;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:surplus_license_request');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "surplus_license_request",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.surplus_license,
      detail_page: "page_0020_surplus_license_detail_review",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].jurisdiction_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].software_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].desired_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_surplus_license__["a" /* fields */].requester, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    backToList: function backToList() {
      return this.$router.push({ name: "page_0020_surplus_license", params: {} });
    },
    initExportFile: function initExportFile() {},
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      return this.$router.push({ name: this.detail_page, params: { review_seq_id: data.seq_id, seq_id: data.surplus_license_seq_id } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: false });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sub_pages_sub_table_temp_batch_import__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sub_pages_sub_table_temp_batch_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_sub_pages_sub_table_temp_batch_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__libs_bus__ = __webpack_require__(4);









var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:bulk_import");



















/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'sub-table-cer': __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information___default.a,
    'sub-table-dev': __WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information___default.a,

    'sub-table-associated-device': __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device___default.a,
    'sub-table-device-embedded-detail': __WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail___default.a,

    'file-download-modal': __WEBPACK_IMPORTED_MODULE_14__components_modals_file_download_modal___default.a,
    'application-confirmation-modal': __WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal___default.a,
    'sub-table-temp-batch-import': __WEBPACK_IMPORTED_MODULE_13__components_sub_pages_sub_table_temp_batch_import___default.a
  },
  data: function data() {
    return {
      btn_cer_label: "証書情報テンプレート",
      btn_dev_label: "機器情報テンプレート",
      btn_associated_device_label: "証書_ソフトウェア情報テンプレート",
      btn_device_embedded_detail_label: "機器_組込情報テンプレート",
      btn_batch_import_label: "一括取込（全量）テンプレート",
      btn_batch_import2_label: "一括取込(機器組込)テンプレート",
      dropdown_label: "テンプレートをダウンロード（Excel）",
      api_name: "bulk_import",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.bulk_import,
      file_selected_event: false,
      selected_file_name: null,
      process_stage: "idle",
      uploading: false,
      error_msg: "",
      show_sub_table_cer: false,
      show_sub_table_dev: false,

      show_sub_table_associated_device: false,
      show_sub_table_device_embedded_detail: false,

      tab_name_mode: false,
      show_sub_table_temp_batch_import: false,
      show_sub_table_temp_batch_import2: false,
      session_id: false
    };
  },

  computed: {
    disableApplyButton: function disableApplyButton() {
      return (this.errorMsg || "") != "";
    },

    errorMsg: {
      get: function get() {
        return this.error_msg;
      },
      set: function set(v) {
        this.error_msg = v;
      }
    },
    sessionId: {
      get: function get() {
        return this.session_id;
      },
      set: function set(v) {
        this.session_id = v;
      }
    },
    showSubTableAssociatedDevice: {
      get: function get() {
        return this.show_sub_table_associated_device;
      },
      set: function set(v) {
        this.show_sub_table_associated_device = v;
      }
    },
    showSubTableDeviceEmbeddedDetail: {
      get: function get() {
        return this.show_sub_table_device_embedded_detail;
      },
      set: function set(v) {
        this.show_sub_table_device_embedded_detail = v;
      }
    },
    showsubTableTempBatchImport: {
      get: function get() {
        return this.show_sub_table_temp_batch_import;
      },
      set: function set(v) {
        this.show_sub_table_temp_batch_import = v;
      }
    },
    showSubTableDev: {
      get: function get() {
        return this.show_sub_table_dev;
      },
      set: function set(v) {
        this.show_sub_table_dev = v;
      }
    },
    showSubTableCer: {
      get: function get() {
        return this.show_sub_table_cer;
      },
      set: function set(v) {
        this.show_sub_table_cer = v;
      }
    },
    processStage: {
      get: function get() {
        return this.process_stage;
      },
      set: function set(v) {
        this.process_stage = v;
      }
    },
    showChoseFile: function showChoseFile() {
      return this.processStage == "idle";
    },
    showUploadFile: function showUploadFile() {
      return this.processStage == "file_selected";
    },
    showCancelUpload: function showCancelUpload() {
      return this.processStage == "file_selected";
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].virtual_environment, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].virtual_base_unit, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].leasing_or_rental, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].manufacture_name, {})];
    }
  },
  methods: {
    checkPerimissionForDownload1: function checkPerimissionForDownload1(ev) {
      if (this.checkUserPermission(this.acl.bulk_import, this.permissionMode.EXPORT) == false) {
        return ev.preventDefault();
      }
    },
    showError: function showError(err) {
      this.errorMsg = err;
    },
    onConfirmExecuteProcessOnly: function onConfirmExecuteProcessOnly(mode) {
      var _this = this;

      if (mode == "yes") {
        if (this.tab_name_mode == false) {
          return;
        }
        var syubetu = "";
        if (this.tab_name_mode == "temp_device_embedded_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.DEVICE;
        } else if (this.tab_name_mode == "temp_certificate_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.CERTIFICATE;
        } else if (this.tab_name_mode == "temp_associated_device") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.ASSOCIATED_DEVICE;
        } else if (this.tab_name_mode == "temp_device_embedded_detail") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.DEVICE_DETAIL;
        } else if (this.tab_name_mode == "temp_batch_import") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.BATCH_IMPORT;
        }

        var url = '/' + this.tab_name_mode + '/process_only/';
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        this.$ajax.post(url, { syubetu: syubetu }, function (err, result) {
          if (err) {
            _this.$notify({
              title: 'データの処理に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_17__libs_bus__["a" /* bus */].$emit("applicationConfirmatioProcessOnlyModal", {
              title: "",
              message: syubetu + "を下書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "default",
              model_height: "50"
            });
          }
        });
      }
    },
    onConfirmExecuteProcessOnlySave: function onConfirmExecuteProcessOnlySave() {
      this.validateMaker(function (validated) {
        if (validated != true) {
          return;
        }
        console.log("onConfirmExecuteProcessOnlySave");
        __WEBPACK_IMPORTED_MODULE_17__libs_bus__["a" /* bus */].$emit("onConfirmExecuteProcessOnlySave", {
          message: "よろしいですか？",
          title: "登録情報を下書保存します。",
          yes_label: "下書保存",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onConfirmExecuteProcessAndApply: function onConfirmExecuteProcessAndApply() {
      var _this2 = this;

      this.validateMaker(function (validated) {
        if (validated != true) {
          return;
        }
        if (_this2.tab_name_mode == false) {
          return;
        }
        var syubetu = "";
        var on_finish_url_name = "";
        if (_this2.tab_name_mode == "temp_device_embedded_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.DEVICE;
          on_finish_url_name = "page_0010_device_embedded_information";
        } else if (_this2.tab_name_mode == "temp_device_embedded_detail") {
          on_finish_url_name = "page_0010_device_embedded_information";
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.DEVICE_DETAIL;
        } else if (_this2.tab_name_mode == "temp_certificate_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.CERTIFICATE;
          on_finish_url_name = "page_0040_certificate_information";
        } else if (_this2.tab_name_mode == "temp_associated_device") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.ASSOCIATED_DEVICE;
          on_finish_url_name = "page_0040_certificate_information";
        } else if (_this2.tab_name_mode == "temp_batch_import") {
          syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.BATCH_IMPORT;
          on_finish_url_name = "page_0050_approval_history_tabs_all";
        }

        __WEBPACK_IMPORTED_MODULE_17__libs_bus__["a" /* bus */].$emit("certificateApplicationConfimationModal", {
          application_mode: "bulk_import",
          title_prefix: syubetu,
          syubetu: syubetu,
          title_suffix: "（一括取込・" + syubetu + "）",
          process_import_url: '/' + _this2.tab_name_mode + '/process_and_apply/',
          on_finish_url_name: on_finish_url_name,
          ref_id: _this2.certificateManagementNumber,
          session_id: _this2.sessionId
        });
      });
    },
    validateMaker: function validateMaker(cb) {
      var _this3 = this;

      if (this.tab_name_mode == "temp_certificate_information") {
        this.$notify({ clear: true });

        this.$ajax.post('/temp_certificate_information/validate_maker/', {}, function (err, result) {
          console.log({ err: err, result: result }, result.valid);
          if (result.valid == true) {
            _this3.$notify({
              title: '成功しました。',
              text: "メーカは確認済です。",
              type: 'success',
              duration: 2000
            });
            cb(true);
          } else {
            _this3.$notify({
              title: '処理できませんでした。',
              text: "入力したメーカー名　" + result.invalid_count + " が無効です。修正してください。",
              type: 'error',
              duration: 12000
            });
            cb(false);
          }
        });
      } else {
        cb(true);
      }
    },
    onExecuteClear: function onExecuteClear() {
      var _this4 = this;

      if (this.tab_name_mode == false) {
        return;
      }
      this.showSubTableDev = false;
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showsubTableTempBatchImport = false;

      this.$ajax.post('/' + this.tab_name_mode + '/clear/', { session_id: this.sessionId || false }, function (err, result) {
        if (err) {
          _this4.$notify({
            title: 'データのクリアに失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        }
        if (_this4.tab_name_mode == "temp_device_embedded_information") {
          _this4.selectDeviceEmbeddedInformation();
        } else if (_this4.tab_name_mode == "temp_certificate_information") {
          _this4.selectCertificate();
        } else if (_this4.tab_name_mode == "temp_associated_device") {
          _this4.selectAssociatedDevice();
        } else if (_this4.tab_name_mode == "temp_device_embedded_detail") {
          _this4.selectDeviceEmbeddedDetail();
        } else if (_this4.tab_name_mode == "temp_batch_import") {
          _this4.errorMsg = "";
          _this4.selectTempBatchImport();
          _this4.showsubTableTempBatchImport = false;
        }
      });
    },
    selectDeviceEmbeddedInformation: function selectDeviceEmbeddedInformation() {
      this.dropdown_label = this.btn_dev_label;
      this.tab_name_mode = "temp_device_embedded_information";
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showsubTableTempBatchImport = false;
      this.showSubTableDev = true;
    },
    selectCertificate: function selectCertificate() {
      this.dropdown_label = this.btn_cer_label;
      this.tab_name_mode = "temp_certificate_information";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showsubTableTempBatchImport = false;
      this.showSubTableCer = true;
    },
    selectAssociatedDevice: function selectAssociatedDevice() {
      this.dropdown_label = this.btn_associated_device_label;
      this.tab_name_mode = "temp_associated_device";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = true;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showsubTableTempBatchImport = false;
      this.showSubTableCer = false;
    },
    selectDeviceEmbeddedDetail: function selectDeviceEmbeddedDetail() {
      this.dropdown_label = this.btn_device_embedded_detail_label;
      this.tab_name_mode = "temp_device_embedded_detail";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = true;
      this.showsubTableTempBatchImport = false;
      this.showSubTableCer = false;
    },
    selectTempBatchImport: function selectTempBatchImport(session_id) {
      this.sessionId = session_id;
      this.dropdown_label = this.btn_batch_import_label;
      this.tab_name_mode = "temp_batch_import";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showsubTableTempBatchImport = true;
      this.showSubTableCer = false;
    },
    cancelUpload: function cancelUpload() {
      this.selected_file_name = null;
      this.file_selected_event = null;
      this.processStage = "idle";
    },
    uploadFile: function uploadFile(options) {
      var _this5 = this;

      this.errorMsg = "";
      this.processStage = "uploading";
      this.uploading = true;
      this.result_array = [];
      this.result_executed = false;
      var files = this.file_selected_event.target.files;
      if (!files[0]) {
        return;
      }
      var csv_data = new FormData();
      csv_data.append("csv", files[0]);
      csv_data.append("company", __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("selectedCompany"));
      mdebug("csv_data", csv_data);
      this.showSubTableDev = false;
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showsubTableTempBatchImport = false;
      __WEBPACK_IMPORTED_MODULE_16_axios___default.a.post(this.$ajax.serverUrl + "/csv/upload/" + this.api_name, csv_data, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(function (response) {
        var data = response.data;
        mdebug("Upload done", response);
        if (response.data.success == true) {
          _this5.uploading = false;
          if (data.data.table == "temp_certificate_information") {
            _this5.selectCertificate();
          } else if (data.data.table == "temp_device_embedded_information") {
            _this5.selectDeviceEmbeddedInformation();
          } else if (data.data.table == "temp_associated_device") {
            _this5.selectAssociatedDevice();
          } else if (data.data.table == "temp_device_embedded_detail") {
            _this5.selectDeviceEmbeddedDetail();
          } else if (data.data.table == "temp_batch_import") {
            _this5.selectTempBatchImport(response.data.data.session_id);
          } else {}
          return _this5.processStage = "idle";
        } else {
          _this5.uploading = false;
          try {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.error) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.error).indexOf("::") < 2) {
              _this5.errorMsg = "" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.error).replace("::", "").replace(/"/g, "") + "";
            } else {
              _this5.errorMsg = "エラー" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.error).replace(/"/g, "") + "";
            }
          } catch (error) {
            _this5.errorMsg = "エラー ：" + response.data.error + "";
          }

          _this5.processStage = "preview_error";
          _this5.file_selected_event = null;
          _this5.selected_file_name = null;
          _this5.uploading = false;
          _this5.count_error++;
          _this5.result_executed = true;
        }
      }).catch(function (error) {
        _this5.errorMsg = "エラー ：：： (" + error + ")";

        _this5.result_executed = true;
        mdebug("upload File error:", error);
        _this5.count_error++;
        _this5.processStage = "preview_error";
        _this5.result_error = "failed to upload: " + error;
        _this5.file_selected_event = null;
        _this5.selected_file_name = null;
        _this5.uploading = false;
      });
    },
    choseFile: function choseFile() {
      var csv_file = this.$refs.csv_file;
      csv_file.click();
    },
    fileClicked: function fileClicked(e) {
      var csv_file = this.$refs.csv_file;
      csv_file.value = null;
    },
    fileSelected: function fileSelected(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      mdebug("file_selected", files[0]);
      this.processStage = "file_selected";
      this.file_selected_event = e;
      this.selected_file_name = files[0].name;
    },
    createColumnDefs: function createColumnDefs() {
      var _this6 = this;

      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        arr.push(fi);
      });

      [__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].more_details, __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].button_options].forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: function cellRenderer(params) {
            if (params.column.colId == "more_details") {
              return _this6.createGridTextButton("詳細", "color: #5b9bd5;", _this6.onDetailsClick, params.data);
            }
            if (params.column.colId == "button_options") {
              return _this6.createGridButton("glyphicon glyphicon glyphicon-unchecked", "color: #5b9bd5;", _this6.onSelectedClickDatasource, params.data);
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    }
  },
  mounted: function mounted() {
    if (this.$route.params.page && this.$route.params.page == "batch_import_export") {
      this.selectTempBatchImport(this.$route.params.session_id);
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal__);










var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:certificate_information');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__["AgGridVue"],
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_device_embedded_information_bach_edit_modal___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "certificate_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.certificate_information,
      detail_page: "page_0040_certificate_information_detail",
      execute_filter_on_back: true,
      link_to_open: "#",
      select_all: false
    };
  },

  computed: {
    approveMode: {
      get: function get() {
        return this.approve_mode;
      },
      set: function set(v) {
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll: {
      get: function get() {
        return this.select_all;
      },
      set: function set(v) {
        this.select_all = v;
      }
    },
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0 || typeof _.find(this.selectedRowArr, function (d) {
        return d.real_certificate_management_number != "" && d.real_certificate_management_number != null;
      }) != "undefined";
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].status, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].certificate_management_number, { tab_label: "証書管理番号", tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].effective_number, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].remaining_number, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].expiration_date, { type: __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["b" /* filed_types */].DATE_PICKER }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].maintenance_deadline, { type: __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["b" /* filed_types */].DATE_PICKER })];
    }
  },
  methods: {
    allChecked: function allChecked(a, b) {
      this.commonAllChecked("showInformationIconModalCertificateInformation");
    },
    hideCheckBox: function hideCheckBox(data) {
      return data && data.approval_status == "申請中";
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("deleteCertificateInformationModal", {
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/certificate_information/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    bachEdit: function bachEdit() {
      var p_id = __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4();
      var obj = { arr: this.selectedRowArr.map(function (m) {
          return m.seq_id;
        }) };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("bulk_edit_" + p_id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
      return this.$router.push("/certificate_information/bulk_edit/" + p_id);
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_certificate_information_connection_application_modal__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_certificate_information_connection_application_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modals_certificate_information_connection_application_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sub_pages_associated_device__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sub_pages_associated_device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sub_pages_associated_device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_file_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_file_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_file_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_log_history_modal__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_log_history_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_log_history_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__rules_constants__);










var mdebug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('esma:device_embedded_information');









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_confirmation_modal__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_file_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_file_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_file_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__rules_constants__);











var mdebug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('esma:device_embedded_information');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_9__components_form_field___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_1__components_sub_pages_device_embedded_detail___default.a,
    "device-embedded-information-confirmation-modal": __WEBPACK_IMPORTED_MODULE_5__components_modals_device_embedded_information_confirmation_modal___default.a,
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_0__components_modals_device_embedded_information_add_check___default.a,
    'file-modal': __WEBPACK_IMPORTED_MODULE_14__components_modals_file_modal___default.a,
    'application-confirmation-modal': __WEBPACK_IMPORTED_MODULE_6__components_modals_application_confirmation_modal___default.a
  },
  data: function data() {
    return {
      api_name: "certificate_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default.a.generic,
      show_apply_button: false,
      approval_id: null
    };
  },

  computed: {
    showApplyButton: {
      get: function get() {
        return this.show_apply_button;
      },
      set: function set(v) {
        this.show_apply_button = v;
      }
    },
    Status: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions: function StatusOptions() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].status.options;
    },

    aprovalId: {
      get: function get() {
        return this.aproval_id;
      },
      set: function set(v) {
        this.aproval_id = v;
      }
    },
    approvalStatus: function approvalStatus() {
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"];
    },
    deviceControlNumber: function deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["certificate_management_number"];
    },
    registrationDate: function registrationDate() {
      return __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["b" /* filed_types */];
    },
    formFields: function formFields() {
      var _this = this;

      return {
        col1: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].certificate_management_number, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].jurisdiction_classification, {
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("upd_license_jurisdiction_system", { val: data == "EUC・その他" });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_system, {
          listen_for: [{
            name: "upd_license_jurisdiction_system",
            mode: "disable_if_value",
            disable_if_value: false
          }]
        }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].license_certificate_type, {
          disabled: false,
          required: true,
          field_style: " width: 75%;display: inline;",
          buttons: [{
            btn_style: "width:20%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 2px;background: #43c9de;border-color:#43c9de;",
            type: "callback",
            callback: function callback(b) {
              _this.openFileModal();
            },
            label: "PDF"
          }]
        }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].certificate_individual_number, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].maker, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].applicant_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].management_person_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].comprehensive_contract, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].sales_company, {})],
        col3: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].downgrade, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].deadline_alert, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].expiration_date, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].maintenance_deadline, {})],
        col2b: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].remark, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_information__["a" /* fields */].other_items_by_manufacturer, {})]
      };
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    processFieldStyle: function processFieldStyle(store_key_name, last_changed_fields) {
      var _this2 = this;

      this.$store.state[store_key_name] = {};
      if (last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0) {
        last_changed_fields.forEach(function (f) {
          if (_this2.$store.state[_this2.stateCurrentRow]["approval_status"] == "申請中" && _this2.allowdToShowProcessAprovalButton) {
            _this2.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },
    openFileModal: function openFileModal() {
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("showFileModal", { fk_id: this.certificateSeqId });
    },
    processApproval: function processApproval() {
      var _this3 = this;

      var changes = {
        seq_id: this.aprovalId,
        update_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
      };
      this.$ajax.post('/approval_history/prepare_to_approve/' + this.aprovalId, { changes: changes }, function (err, result) {
        if (err) {
          _this3.$notify({
            title: 'データの承認に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          return _this3.$router.push("/approval_history");
        }
      });
    },
    onBulkCertificateInformationAddCheckConfirm: function onBulkCertificateInformationAddCheckConfirm(mode) {
      var _this4 = this;

      setTimeout(function () {
        if (mode == "yes") {
          _this4.read_only = false;
          _this4.$store.state[_this4.stateCurrentEditing]["approval_status"] = "下書中";
          var list_seq_id = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get('bulk_edit_' + _this4.local_page_id);
          try {
            list_seq_id = JSON.parse(list_seq_id);
            _this4.saveBulk(_this4.api_name, list_seq_id.arr, {}, function (err) {});
          } catch (error) {
            _this4.$notify({
              title: "予期しないエラーが発生し、登録が行えません",
              text: error,
              type: 'error',
              duration: 12000
            });
          }
        }
      }, 100);
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      var list_seq_id = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get('bulk_edit_' + this.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id);
        var syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.CERTIFICATE;
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("bulkCertificateApplicationConfimationModal", {
          list_seq_id: list_seq_id.arr,
          application_mode: "bulk_edit_certificate",
          title_prefix: "" + syubetu + "(一括編集）",
          title_suffix: "" + syubetu + "(一括編集）",
          process_import_url: '/' + this.api_name + '/bulk_to_approval_history/',
          on_finish_url_name: "close",
          ref_id: null
        });
      } catch (error) {
        this.$notify({
          title: "適用する行の読込に失敗しました。",
          text: error,
          type: 'error',
          duration: 12000
        });
      }
    },
    onLocalSaveBulkCerInfeded: function onLocalSaveBulkCerInfeded() {
      console.log("onLocalSave");
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("confirmBulkCertificateInformationAddCheck", {
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "完了",
        no_label: "キャンセル",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onEdit: function onEdit() {
      var _this5 = this;

      mdebug("onEdit");
      setTimeout(function () {
        _this5.read_only = false;
      }, 300);
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },

    approvalHistoryId: {
      get: function get() {
        return this.approval_history_id;
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    backToList: function backToList() {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.remove('bulk_edit_' + this.local_page_id);
      var device_back_to_list = window.sessionStorage.getItem("certificate_back_to_list");
      if ((device_back_to_list || "").indexOf("/") == 0) {
        return this.$router.push(device_back_to_list);
      }
    },
    gotocertificate: function gotocertificate() {
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate: function selectCertificate() {
      this.showSubTable = true;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$store.state[this.stateCurrentEditing] = {};
    this.addHtmlClass(document.body, 'blue_bg');
    this.local_page_id = this.$route.params.p_id;
    this.is_new = true;

    this.allFields.forEach(function (f) {
      _this6.$store.state[_this6.stateCurrentRow][f.id] = "";
    });
    setTimeout(function () {
      _this6.$store.state[_this6.stateIsEditingNew] = true;
      _this6.read_only = false;
      _this6.is_new = true;
    }, 300);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.removeHtmlClass(document.body, 'blue_bg');
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:certificate_information_linked_devices');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      local_certificate_seq_id: -1,
      page_mode: "list",
      api_name: "certificate_information_linked_devices",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      device_embedded_detail_seq_id: -1,
      detail_page: "page_0010_device_embedded_information_detail",
      disable_select_new: true
    };
  },

  computed: {
    localCertificateSeqId: {
      get: function get() {
        return this.local_certificate_seq_id;
      },
      set: function set(v) {
        this.local_certificate_seq_id = v;
      }
    },
    disableSelectNew: {
      get: function get() {
        return this.disable_select_new;
      },
      set: function set(v) {
        this.disable_select_new = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].item_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, {})];
    }
  },
  methods: {
    unlinkItem: function unlinkItem() {
      var _this = this;

      var obj = this.selectedRowArr.map(function (r) {
        return {
          device_embedded_detail_seq_id: r.device_embedded_detail_seq_id
        };
      });

      if (!(obj && obj.length > 0) && this.$route.params.req_ad_seq_id.length > 0) {
        obj = [{
          device_embedded_detail_seq_id: this.device_embedded_detail_seq_id
        }];
      };

      this.$ajax.post("/certificate_information_linked_devices/unlink_device/", { arr: obj }, function (err, data) {
        if (err) {
          _this.$notify({
            title: 'データの紐付解除に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          _this.$notify({
            title: '紐付されていません。',
            type: 'sucess',
            duration: 1000
          });
        }

        _this.localRefreshDeletedRow();
      });
    },
    getAssociatedDeviceInfo: function getAssociatedDeviceInfo() {
      var _this2 = this;

      this.$ajax.post("/associated_device/get/" + this.$route.params.req_ad_seq_id, {}, function (err, result) {
        if (err) {
          _this2.$notify({
            title: 'ソフトウェア情報の読込に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          if (result.data.license == "-") {
            _this2.disableSelectNew = false;
          } else {
            var the_number_of_remaining = 0;
            if (result && result.data && isNaN(result.data.the_number_of_remaining) == false) {
              the_number_of_remaining = parseInt(result.data.the_number_of_remaining);
            }
            if (the_number_of_remaining <= 0) {
              _this2.disableSelectNew = true;
            } else {
              _this2.disableSelectNew = false;
            }
          }
        }
      });
    },
    localRefreshDeletedRow: function localRefreshDeletedRow() {
      this.countRows("localRefreshDeletedRow");
      this.gridOptions.api.purgeInfiniteCache();
    },
    linkNewItem: function linkNewItem() {
      return this.$router.push("/certificate_information_linked_devices/select/" + this.$route.params.req_ad_seq_id + "/" + this.$route.params.cert_id);
    },
    backToCertificateDetail: function backToCertificateDetail() {
      return this.$router.push("/certificate_information/" + this.$route.params.cert_id);;
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: false });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
      this.device_embedded_detail_seq_id = ev.node.data.device_embedded_detail_seq_id;
      this.localCertificateSeqId = ev.node.data.certificate_seq_id;
    }
  },
  mounted: function mounted() {
    this.addHtmlClass(document.body, 'blue_bg');
    this.gridOptions.api.sizeColumnsToFit();
    this.getAssociatedDeviceInfo();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeHtmlClass(document.body, 'blue_bg');
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = { seq_id: this.$route.params.req_ad_seq_id };
    this.initDatasource();
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:certificate_information_linked_devices_select');








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'input-number-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal___default.a
  },
  data: function data() {
    return {
      local_device_control_number: null,
      api_name: "certificate_information_linked_devices_select",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      detail_page: "page_0010_device_embedded_information_detail"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, {})];
    }
  },
  methods: {
    addSelected: function addSelected() {
      __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("showNumberModalForSetDevicesQuantity", {
        title: "",
        message: "新規に組込情報を追加し証書を紐付けます。<br>組込本数を入力してください。<br><br><br>",
        input_prefix: "組込本数：",
        input_suffix: "本",
        yes_label: "組込情報を追加して紐付",
        no_label: "戻る",
        yes_style: "",
        no_style: "",
        min_val: 1
      });
    },
    onSelectedQty: function onSelectedQty(data) {
      if (data && data.mode == "yes") {
        if (data.value > 0) {
          this.saveSelected(data.value);
        }
      }
    },
    saveSelected: function saveSelected(qty) {
      var _this = this;

      var obj = this.selectedRowArr.map(function (r) {
        return {
          set_qty: qty,
          associated_device_seq_id: _this.$route.params.req_ad_seq_id,
          device_control_number: r.device_control_number,
          device_ebedded_information_seq_id: r.seq_id };
      });

      if (!(obj && obj.length > 0) && this.$route.params.req_ad_seq_id.length > 0) {
        obj = [{
          set_qty: qty,
          associated_device_seq_id: this.$route.params.req_ad_seq_id,
          device_control_number: this.local_device_control_number,
          device_ebedded_information_seq_id: this.selected_row }];
      };

      this.$ajax.post("/certificate_information_linked_devices/link_device/", { arr: obj }, function (err, data) {
        if (err) {
          _this.$notify({
            title: 'データの保存に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          _this.$notify({
            title: '紐付済',
            type: 'sucess',
            duration: 1000
          });
          setTimeout(function () {
            return _this.backToList();
          }, 1000);
        }
      });
    },
    backToList: function backToList() {
      return this.$router.push("/certificate_information_linked_devices/list/" + this.$route.params.req_ad_seq_id + "/" + this.$route.params.cert_id);
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.local_device_control_number = ev.node.data.device_control_number;
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.addHtmlClass(document.body, 'blue_bg');
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeHtmlClass(document.body, 'blue_bg');
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.api_request_options = { req_seq: this.$route.params.req_ad_seq_id };
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_device_embedded_information_bach_edit_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_device_embedded_information_bach_edit_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_device_embedded_information_bach_edit_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_certificate_information_connection_application_modal__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_certificate_information_connection_application_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_certificate_information_connection_application_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);










var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:certificate_information');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    "certificate-information-connection-application-modal": __WEBPACK_IMPORTED_MODULE_5__components_modals_certificate_information_connection_application_modal___default.a,
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_4__components_modals_device_embedded_information_bach_edit_modal___default.a
  },
  data: function data() {
    return {
      api_name: "certificate_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.generic,
      detail_page: "page_0040_certificate_information_detail"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["b" /* filed_types */];
    },
    allFields: function allFields() {

      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].certificate_management_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].effective_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].remaining_number, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    onExecuteProcess: function onExecuteProcess() {
      var _this = this;

      if (this.tab_name_mode == false) {
        return;
      }
      if (this.tab_name_mode == false) {
        return;
      }

      this.$ajax.post('/' + this.tab_name_mode + '/process/', {}, function (err, result) {
        if (err) {
          _this.$notify({
            title: 'データの処理に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          _this.confirmPositiveProcess();
        }
      });
    },
    confirmPositiveProcess: function confirmPositiveProcess() {
      __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("confirmPositiveProcess", {
        title: "",
        message: "紐付内容に変更があります。申請せずに戻りますか？",
        yes_label: "",
        no_label: "戻る",
        yes_color: "",
        no_color: "default",
        model_height: "50"
      });
    },
    onConfirmPositiveProcess: function onConfirmPositiveProcess() {
      if (this.tab_name_mode == "temp_device_embedded_information") {
        this.$router.push({
          name: "page_0010_device_embedded_information"
        });
      } else if (this.tab_name_mode == "temp_certificate_information") {
        this.$router.push({
          name: "page_0040_certificate_information"
        });
      }
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("showBulkImportConfimationModal", {});
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:certificate_information');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "certificate_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      detail_page: "page_0040_certificate_information_detail"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].certificate_management_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].effective_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_certificate_information__["a" /* fields */].remaining_number, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_strap_dist_vue_strap_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_device_embedded_information_bach_edit_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_device_embedded_information_bach_edit_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_device_embedded_information_bach_edit_modal__);











var mdebug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('esma:certificate_software');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_3_ag_grid_vue__["AgGridVue"],
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_13__components_modals_device_embedded_information_bach_edit_modal___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_11__components_modals_file_download_modal___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_6_vue_strap_dist_vue_strap_js__["tab"],
    tabs: __WEBPACK_IMPORTED_MODULE_6_vue_strap_dist_vue_strap_js__["tabs"]
  },
  data: function data() {
    return {
      api_name: "certificate_software",
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.certificate_software,
      detail_page: "page_0040_certificate_software_detail",
      execute_filter_on_back: true,
      link_to_open: "#",
      select_all: false,
      selected_tab: 0,
      post_cached_timeout: 30,
      show_edit: false
    };
  },

  computed: {
    showEdit: {
      get: function get() {
        return this.show_edit;
      },
      set: function set(v) {
        this.show_edit = v;
      }
    },
    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    },
    approveMode: {
      get: function get() {
        return this.approve_mode;
      },
      set: function set(v) {
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll: {
      get: function get() {
        return this.select_all;
      },
      set: function set(v) {
        this.select_all = v;
      }
    },
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0 || typeof _.find(this.selectedRowArr, function (d) {
        return d.real_certificate_management_number != "" && d.real_certificate_management_number != null;
      }) != "undefined";
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].approval_status, { tab_size: 22 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].status, { tab_size: 23 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].registration_date, { tab_size: 33 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].last_update_date, { tab_size: 33 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].certificate_software_number, { tab_label: "証書管理番号", tab_size: 40 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].company, { tab_size: 28 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].unlimited, { tab_size: 25 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].license, { tab_size: 25 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].effective_number, { tab_size: 25 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].remaining_number, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].expiration_date, { type: __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["b" /* filed_types */].DATE_PICKER, tab_size: 30 }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["a" /* fields */].maintenance_deadline, { type: __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__["b" /* filed_types */].DATE_PICKER, tab_size: 30 })];
    }
  },
  methods: {
    onTabChanged: function onTabChanged(index) {
      this.checkBoxSelectAll = false;
      this.clearSearchFields();
      switch (index) {
        case 0:
        case "in_use":
          this.selectedTab = 0;
          this.api_request_options = { filter_mode: "使用中" };
          this.$router.push({ name: "page_0040_certificate_software_tab", params: { mode: "in_use" } });
          window.sessionStorage.setItem('certificate_back_to_list', "/certificate/tab/in_use");
          break;
        case 1:
        case "disposal":
          this.selectedTab = 1;
          this.api_request_options = { filter_mode: "廃棄" };
          this.$router.push({ name: "page_0040_certificate_software_tab", params: { mode: "disposal" } });
          window.sessionStorage.setItem('certificate_back_to_list', "/certificate/tab/disposal");
          break;
        case 2:
        case "pending":
          this.selectedTab = 2;
          this.api_request_options = { filter_mode: "下書中/申請中/差戻" };
          this.$router.push({ name: "page_0040_certificate_software_tab", params: { mode: "pending" } });
          window.sessionStorage.setItem('certificate_back_to_list', "/certificate/tab/pending");
          break;
        default:
          return;
      }
      this.emulateSearchControlChangedDatasource(true);
    },
    allChecked: function allChecked() {
      this.commonAllChecked("showInformationIconModalCertificateSoftware");
    },
    hideCheckBox: function hideCheckBox(data) {
      return data && (data.approval_status == "申請中" || (data.upgrade_destination || "") != "");
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("deleteCertificateInformationModal", {
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        sub_search: this.search_data,
        url: "/certificate_software/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    bachEdit: function bachEdit() {
      var p_id = __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4();
      var obj = { arr: this.selectedRowArr.map(function (m) {
          return m.seq_id;
        }) };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set("bulk_edit_" + p_id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
      return this.$router.push("/certificate/bulk_edit/" + p_id);
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true, force_sort: { id: "licensed_department", direction: "asc" } });
    }
  },
  mounted: function mounted() {
    this.showEdit = this.isMaintenanceStaff == true;
    window.sessionStorage.setItem('certificate_back_to_list', "/certificate");
    this.gridOptions.api.sizeColumnsToFit();
    if (this.$route.params.mode) {
      this.onTabChanged(this.$route.params.mode);
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {

    this.count_from_result = true;
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = { filter_mode: "使用中" };
    this.initDatasource({ load_only_with_filter: false });
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_information_connection_application_modal__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_information_connection_application_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_information_connection_application_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modals_change_history_modal__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modals_change_history_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_modals_change_history_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_certificate_software_linked_upgrade_modal__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_certificate_software_linked_upgrade_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_modals_certificate_software_linked_upgrade_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_sub_pages_certificate__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_sub_pages_certificate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_sub_pages_certificate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__rules_constants__);














var mdebug = __WEBPACK_IMPORTED_MODULE_11_debug___default()("esma:device_certificate_software");












var timeout_control = {};
var queue_bus = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_14__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "field-box": __WEBPACK_IMPORTED_MODULE_12__components_form_field___default.a,
    "certificate-information-connection-application-modal": __WEBPACK_IMPORTED_MODULE_8__components_modals_certificate_information_connection_application_modal___default.a,
    "application-confirmation-modal": __WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal___default.a,
    "change-history": __WEBPACK_IMPORTED_MODULE_17__components_modals_change_history_modal___default.a,
    "certificate-sub-page": __WEBPACK_IMPORTED_MODULE_19__components_sub_pages_certificate___default.a,
    'certificate-software-linked-upgrade-modal': __WEBPACK_IMPORTED_MODULE_18__components_modals_certificate_software_linked_upgrade_modal___default.a
  },
  data: function data() {
    var _ref;

    return _ref = {
      show_sub_table_associated_device: false,
      api_name: "certificate_software",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      page_acl: __WEBPACK_IMPORTED_MODULE_13__rules_acl_rules___default.a.certificate_software,
      approval_history_id: "",
      approval_id: null,
      local_status: false,
      save_edit_cliqued: false,
      local_seq_id: -1,
      approval_history_toroku_number: false,
      sub_table_controller: {},
      allow_surplus: false,
      is_surplus: false,
      is_approved: false,
      load_upgrade_modal: false,
      force_disable_due_upgrade_destination: false,
      form_confirmation: {},
      enable_history_modal: false,
      show_surplus_alert_message: false,
      company_selection_started: false,
      approvalcancel_mode: false,
      hide_approval_cancel_field: true
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "approval_id", null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "disable_edit", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "approval_history_bulk_toroku_number_qty", 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "show_approval_history_bulk_toroku_number_qty", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "fields_validation_is_disabled", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "original_status", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "is_expired", false), _ref;
  },

  computed: {
    isExpired: {
      get: function get() {
        return this.is_expired;
      },
      set: function set(v) {
        this.is_expired = v;
      }
    },
    showApprovalHistoryBulkTorokuNumberQty: function showApprovalHistoryBulkTorokuNumberQty() {
      return this.approvalHistoryBulkTorokuNumberQty > 0 && this.loadBy == 'fk_id';
    },

    approvalHistoryBulkTorokuNumberQty: {
      get: function get() {
        return this.approval_history_bulk_toroku_number_qty;
      },
      set: function set(v) {
        this.approval_history_bulk_toroku_number_qty = v;
      }
    },
    DisabledEdit: {
      get: function get() {
        return this.disable_edit;
      },
      set: function set(v) {
        this.disable_edit = v;
      }
    },
    deleteBtnDisabled: function deleteBtnDisabled() {
      if (this.isApproverUserId == true) {
        return false;
      }
    },

    approvalcancelmode: {
      get: function get() {
        return this.approvalcancel_mode;
      },
      set: function set(v) {
        this.approvalcancel_mode = v;
      }
    },
    showSurplusAlertMessage: {
      get: function get() {
        return this.show_surplus_alert_message;
      },
      set: function set(v) {
        this.show_surplus_alert_message = v;
      }
    },
    enableHistoryModal: {
      get: function get() {
        return this.enable_history_modal;
      },
      set: function set(v) {
        this.enable_history_modal = v;
      }
    },
    forceDisableDueUpgradeDestination: {
      get: function get() {
        return this.force_disable_due_upgrade_destination;
      },
      set: function set(v) {
        this.force_disable_due_upgrade_destination = v;
      }
    },
    loadUpgradeModal: {
      get: function get() {
        return this.load_upgrade_modal;
      },
      set: function set(v) {
        this.load_upgrade_modal = v;
      }
    },
    statusFieldStyle: function statusFieldStyle() {
      if (this.$store.state["current_field_style"] && this.$store.state["current_field_style"]["status"]) {
        return this.$store.state["current_field_style"]["status"];
      } else {
        return "";
      }
    },

    isApproved: {
      get: function get() {
        return this.is_approved;
      },
      set: function set(v) {
        this.is_approved = v;
      }
    },
    isSurplus: {
      get: function get() {
        return this.is_surplus;
      },
      set: function set(v) {
        this.is_surplus = v;
      }
    },
    allowSurplus: {
      get: function get() {
        return this.allow_surplus;
      },
      set: function set(v) {
        this.allow_surplus = v;
      }
    },
    subTableController: {
      get: function get() {
        return this.sub_table_controller;
      },
      set: function set(v) {
        this.sub_table_controller = v;
      }
    },
    disableAllButtons: function disableAllButtons() {
      return this.loadBy == "certificate_software_number" || this.loadBy == "deposit_certificate_output";
    },
    disablepdfButtons: function disablepdfButtons() {
      if (this.$store.state[this.stateCurrentRow].status == "余剰") {
        if (!(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_20__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_20__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF)) {
          return true;
        }
      }
      return false;
    },

    localSeqId: {
      get: function get() {
        return this.local_seq_id;
      },
      set: function set(v) {
        this.local_seq_id = v;
      }
    },
    disableEditMainBtn: function disableEditMainBtn() {
      if (this.loadBy == "fk_id") {
        return this.hideForApplicant && this.approvalStatus == "申請中";
      }
      return this.approvalStatus == "申請中";
    },
    disableCopyMainBtn: function disableCopyMainBtn() {
      return false;
    },
    disableApplicationBtn: function disableApplicationBtn() {
      return this.approvalStatus != "下書中";
    },
    draftWriteMode: function draftWriteMode() {
      return this.loadBy != "fk_id";
    },
    hideForApplicant: function hideForApplicant() {
      if (this.loadBy != "fk_id") {
        return false;
      }
      if (typeof this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] == "undefined" && this.isAdmin == true) {
        return false;
      } else {
        return this.$store.state[this.stateCurrentRow]["approval_history_applicant"] == __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get("userID") && this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] != __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get("userID");
      }
    },
    hideApprovalcancel: function hideApprovalcancel() {
      this.hide_approval_cancel_field = this.retractionreason == "";
      this.hideApprovalCancelSet(this.hide_approval_cancel_field);

      if (this.loadBy != "fk_id" || this.approvalStatus != "申請中") {
        return true;
      } else {
        return false;
      }
    },
    hideEditMainBtn: function hideEditMainBtn() {
      return this.hideForApplicant && this.approvalStatus == "申請中";
    },
    hideCopyMainBtn: function hideCopyMainBtn() {
      return this.loadBy == "fk_id" || this.is_new == true;
    },
    hideApplicationBtn: function hideApplicationBtn() {
      return this.loadBy == "fk_id" && this.approvalStatus != "下書中" || this.approvalStatus != "下書中";
    },
    hideApplyConfirmationBtn: function hideApplyConfirmationBtn() {
      if (this.loadBy != "fk_id") {
        return true;
      }
      return this.hideForApplicant || this.approvalStatus != "申請中";
    },
    hideApplyRejectBtn: function hideApplyRejectBtn() {
      return this.hideApprovalcancel;
    },

    Deadline_Alert: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["deadline_alert"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["deadline_alert"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["deadline_alert"] = this.local_status = v;
      }
    },
    Comprehensive_contract: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["comprehensive_contract"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["comprehensive_contract"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["comprehensive_contract"] = this.local_status = v;
      }
    },
    Downgrade: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["downgrade"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["downgrade"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["downgrade"] = this.local_status = v;
      }
    },
    Status: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        if (this.isSurplus && this.$store.state[this.stateCurrentRow]["status"] == "余剰" && v == "廃棄") {
          this.disableValidation(true);
        } else if ((this.original_status == "廃棄" || this.$store.state[this.stateCurrentRow]["status"] == "廃棄") && v == "使用中") {
          this.disableValidation(false);
        }
        this.$store.state[this.stateCurrentRow]["status"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions: function StatusOptions() {
      var options = _.clone(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].status.options);
      if (this.allowSurplus == true) {
        if (options.indexOf("余剰") < 0) {
          options.push("余剰");
        }
      }
      return options;
    },
    subTableDeviceEmbeddedInformationStyle: function subTableDeviceEmbeddedInformationStyle() {
      if (this.saveEditClicked || this.is_new == false) {
        return "";
      } else {
        return "opacity: 0.5;";
      }
    },

    saveEditClicked: {
      get: function get() {
        return this.save_edit_cliqued;
      },
      set: function set(v) {
        this.save_edit_cliqued = v;
      }
    },
    approvalHistoryId: {
      get: function get() {
        return this.approval_history_id;
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    approvalHistoryTorokuNumber: {
      get: function get() {
        return this.approval_history_toroku_number;
      },
      set: function set(v) {
        this.approval_history_toroku_number = v;
      }
    },
    isAdminSavingApplication: function isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == "fk_id";
    },
    showFieldchangedStyle: function showFieldchangedStyle() {
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" || this.$store.state[this.stateCurrentRow]["approval_status"] == "差戻") && (this.isAdmin || this.$store.state[this.stateCurrentRow]["approval_history_next_approver"]);
    },
    approvalStatus: function approvalStatus() {
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"];
    },
    retractionreason: function retractionreason() {
      if (this.$store.state[this.stateCurrentRow]["retraction_reason"] != null) {
        return this.$store.state[this.stateCurrentRow]["retraction_reason"];
      } else {
        return "";
      }
    },
    allowEditjurisdictionSystem: function allowEditjurisdictionSystem() {
      return this.$store.state[this.stateCurrentRow]["jurisdiction_classification"] != "IT所管システム";
    },

    approvalId: {
      get: function get() {
        return this.approval_id;
      },
      set: function set(v) {
        this.approval_id = v;
      }
    },
    certificateSoftwareNumber: function certificateSoftwareNumber() {
      return this.$store.state[this.stateCurrentRow]["certificate_software_number"];
    },
    certificateSeqId: function certificateSeqId() {
      return parseInt(this.$store.state[this.stateCurrentRow]["seq_id"] || this.localSeqId);
    },
    showapprovalStatus: function showapprovalStatus() {
      return this.$store.state[this.stateCurrentRow]["approval_status"] == "承認済";
    },
    deviceControlNumber: function deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["device_control_number"];
    },
    updateDate: function updateDate() {
      if (this.$store.state[this.stateCurrentRow]["last_update_date"]) {
        return __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["last_update_date"]);
      } else {
        return "-";
      }
    },
    registrationDate: function registrationDate() {
      return __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["b" /* filed_types */];
    },
    formFields: function formFields() {
      var _this = this;

      return {
        col1: [__WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].certificate_software_number, {
          disabled: true,
          read_only: true
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].maker, { disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].software_name, { disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].company, { disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].license_name, { disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].jurisdiction_classification, {
          on_set_value: function on_set_value(data) {
            _this.singleTimeout("upd_license_jurisdiction_system_it", setTimeout(function () {
              _this.queuedBusEmit("upd_license_jurisdiction_system_it", {
                val: data == "IT所管システム"
              });
            }, 500));
            setTimeout(function () {
              _this.queuedBusEmit("upd_license_jurisdiction_system", {
                val: data == "EUC・その他"
              });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_system, {
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system_it",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].equipment_in_charge_system, {
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].product_key, { disabled: this.DisabledEdit, read_only: this.DisabledEdit }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].upgrade, {
          disabled: this.isSurplus, read_only: this.isSurplus || this.forceDisableDueUpgradeDestination,
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              _this.queuedBusEmit("upd_upgrade", { val: data == "有" });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].upgrade_source, {
          disabled: this.isSurplus, read_only: this.isSurplus || this.forceDisableDueUpgradeDestination,
          force_readonly: true,

          field_style: " width: 100%;display: block;",
          buttons: [{
            btn_style: "width:250px;margin-left:2px;padding-left: 1px;padding-right: 1px;float:left; margin-top: 2px;margin-bottom: 10px;    background: rgb(51 122 183);border-color: rgb(46 109 164);",
            type: "callback",
            callback: function callback(b) {
              _this.selectUpgradeCertificate();
            },
            label: "アップグレード元の証書を選択する" }],
          listen_for: [{
            name: "upd_upgrade",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        })],
        col2: [__WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].upgrade_destination, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].deadline_alert, {
          disabled: this.isSurplus, read_only: this.isSurplus || this.forceDisableDueUpgradeDestination,
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              _this.queuedBusEmit("upd_expiration_date", { val: data == "有" });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].expiration_date, {
          disabled: this.isSurplus, read_only: this.isSurplus || this.forceDisableDueUpgradeDestination,
          listen_for: [{
            name: "upd_expiration_date",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].maintenance_deadline, { disabled: this.isSurplus, read_only: this.isSurplus || this.forceDisableDueUpgradeDestination }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].second_number, { disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].unlimited, {
          disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination,
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              _this.queuedBusEmit("upd_license_unlimited", { val: data == "無制限" });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].license, {
          disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination,
          listen_for: [{
            name: "upd_license_unlimited",
            mode: "disable_and_clean_if_value",
            disable_if_value: false
          }] }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].applicant_name, {}), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].management_person_name, {}), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].comprehensive_contract, { disabled: this.DisabledEdit, read_only: this.DisabledEdit || this.forceDisableDueUpgradeDestination }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].effective_number, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].remaining_number, { disabled: true, read_only: true })],
        col2b: [__WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].remark, { label_length_4: true }), __WEBPACK_IMPORTED_MODULE_10__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_7__rules_fields_certificate_software__["a" /* fields */].retraction_reason, {
          label_length_4: true,
          disabled: true,
          hide_all: true,
          force_write: false
        })],
        col3: []
      };
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    disableValidation: function disableValidation(mode) {
      this.formFields.col1.forEach(function (e) {
        if (e.error_if_blank == true) {
          e.ref_field.disabledIsRequired = mode;
          e.ref_field.localRefreshSequecnce++;
        }
      });
      this.formFields.col2.forEach(function (e) {
        if (e.error_if_blank == true) {
          e.ref_field.disabledIsRequired = mode;
          e.ref_field.localRefreshSequecnce++;
        }
      });
      this.fields_validation_is_disabled = mode;
      this.subTableController.disableValidation(mode);
    },
    queuedBusEmit: function queuedBusEmit(id, data) {
      queue_bus.push({ id: id, data: data });
      this.queuedBusRun();
    },
    queuedBusRun: function queuedBusRun() {
      var _this2 = this;

      if (queue_bus.length > 0) {
        if (timeout_control["bus"]) {
          return;
        }
        timeout_control["bus"] = setTimeout(function () {
          var n = queue_bus.shift();
          __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit(n.id, n.data);
          timeout_control["bus"] = false;
          _this2.queuedBusRun();
        }, 50);
      } else {}
    },
    singleTimeout: function singleTimeout(name, ev) {
      if (timeout_control[name]) {
        clearTimeout(timeout_control[name]);
      }
      timeout_control[name] = ev;
    },
    selectUpgradeCertificate: function selectUpgradeCertificate() {
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("showCertificateSoftwareLinkedUpgradeModal", {
        seq_id: this.localSeqId
      });
    },
    onSelectedUpgradeCertificate: function onSelectedUpgradeCertificate(data) {
      var _this3 = this;

      this.$store.state[this.stateCurrentRow]["upgrade_source"] = data.certificate_software_number;
      this.$store.state[this.stateCurrentEditing]["upgrade_source"] = data.certificate_software_number;
      this.fieldList.upgrade_source.ref_field.updateValue(data.certificate_software_number);
      this.fieldList.upgrade_source.ref_field.localRefreshSequecnce++;
      setTimeout(function () {
        _this3.fieldList.upgrade_source.ref_field.localRefreshSequecnce++;
      }, 500);
    },
    onLinkDevice: function onLinkDevice() {
      return this.$router.push("/certificate_software_linked_devices/list/" + this.certificateSeqId);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("deleteCertificateInformationDetailModal", {
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    AllowSurplusExtraRule: function AllowSurplusExtraRule(r) {
      return r && r.data && (r.data.status == "廃棄" && (__WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_20__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_20__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF) || r.data.status == "余剰");
    },
    showHistory: function showHistory() {
      var _this4 = this;

      this.enableHistoryModal = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("showCertificateSoftwareChangeHistoryModal", {
          fk_tab: __WEBPACK_IMPORTED_MODULE_20__rules_constants___default.a.TABLE_ID.CERTIFICATE_SOFTWARE,
          fk_id: _this4.localSeqId
        });
      }, 100);
    },
    onConfirmExecuteProcessConfirmation: function onConfirmExecuteProcessConfirmation() {
      var cmn = this.certificateSoftwareNumber;
      if ((typeof cmn === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(cmn)) == undefined || cmn == null || cmn == false || cmn.length == 0) {
        cmn = "BY_SEQ_ID::" + this.localSeqId;
      }
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("certificateApplicationConfimationModal", {
        application_mode: "certificate",
        ref_id: cmn,
        modal_is_read_only: true,
        seq_id: this.localSeqId,
        approval_history_id: this.approvalHistoryId || false,
        approval_history_toroku_number: this.approvalHistoryTorokuNumber || false
      });
    },
    cloneRecord: function cloneRecord() {
      return this.$router.push({
        name: "page_0060_redirect",
        params: {
          url: "/certificate/clone/" + this.localSeqId,
          message: "コピー ...",
          wait: 50
        }
      });
    },
    processApprovalApprove: function processApprovalApprove() {
      var expiration_date = false;
      if (this.Status == "余剰") {
        var expiration_date = false;
        if (this.$store.state[this.stateCurrentRow]["expiration_date"] && this.$store.state[this.stateCurrentRow]["expiration_date"].length > 6) {
          expiration_date = new Date(this.$store.state[this.stateCurrentRow]["expiration_date"]);
        }
        if (this.$store.state[this.stateCurrentEditing]["expiration_date"] && this.$store.state[this.stateCurrentEditing]["expiration_date"].length > 6) {
          expiration_date = new Date(this.$store.state[this.stateCurrentEditing]["expiration_date"]);
        }
        if (expiration_date != false && expiration_date.getTime() < new Date().getTime()) {
          this.$notify({
            title: "ライセンスの有効期限が切れている為、余剰ライセンスへの繰り回しは出来ません",
            type: "error",
            duration: 10000
          });
          return;
        }

        var userCompany = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get("userCompany") || false;
        if (userCompany && userCompany.indexOf("ライセンス管理窓口") == 0) {
          if (this.$store.state[this.stateCurrentRow]["status_at_approve_request"] != "廃棄") {
            this.$notify({
              title: "状態が余剰となっていますので使用中に変更してください。",
              type: "error",
              duration: 10000
            });
            return;
          }
        }
      }
      return this.processApproval("approve");
    },
    processApprovalCancelBack: function processApprovalCancelBack(mode) {
      if (mode == "yes") {
        console.log("processApprovalCancelBack", mode);
        this.processApproval("cancel");
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    processApprovalCancelBackReason: function processApprovalCancelBackReason(mode) {
      if (mode == "yes") {
        console.log("processApprovalCancelBack", mode);
        this.processApprovalReason("cancel");
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    processFieldStyle: function processFieldStyle(store_key_name, last_changed_fields) {
      var _this5 = this;

      if (Array.isArray(last_changed_fields)) {
        last_changed_fields.forEach(function (e) {});
      } else {}
      this.$store.state[store_key_name] = {};
      if (last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0) {
        last_changed_fields.forEach(function (f) {
          if (_this5.showFieldchangedStyle) {
            _this5.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },
    processApproval: function processApproval(approve_mode) {
      var _this6 = this;

      var changes = {
        seq_id: this.approvalId,
        update_time: __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
      };
      if (approve_mode == "cancel") {
        this.commonSaveInfo(this, this.api_name, { from_edit_form: true }, function (err) {
          if (err) {} else {
            _this6.$ajax.post('/approval_history/prepare_to_approve/' + _this6.approvalId, { changes: changes, approve_mode: approve_mode }, function (err, result) {
              if (err) {
                _this6.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              } else {
                var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";
                __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("notificationAfterCertificateSoftwareApprovalStartedRequest", {
                  message: message,
                  title: "申請が差戻されました",
                  yes_label: "",
                  no_label: "OK",
                  yes_color: "",
                  no_color: "",
                  model_height: "50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      } else {

        var selected_approval_history = this.loadSelectedApprovalHistory();
        if (selected_approval_history.indexOf(this.approvalId) < 0) {
          selected_approval_history.push(this.approvalId);
          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.set('selected_approval_history', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(selected_approval_history));
        }
        __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("notificationAfterCertificateSoftwareApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50"
        });
      }
    },
    processApprovalReason: function processApprovalReason(approve_mode) {
      var _this7 = this;

      var changes = {
        seq_id: this.approvalId,
        update_time: __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
      };
      if (approve_mode == "cancel") {
        this.commonSaveInfo(this, this.api_name, { from_edit_form: true }, function (err) {
          if (err) {} else {
            _this7.$ajax.post('/approval_history/prepare_to_approve/' + _this7.approvalId, { changes: changes, approve_mode: approve_mode }, function (err, result) {
              if (err) {
                _this7.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("notificationAfterCertificateSoftwareApprovalStartedRequest", {
                  message: "申請が取戻されました",
                  title: "",
                  yes_label: "",
                  no_label: "OK",
                  yes_color: "",
                  no_color: "",
                  model_height: "50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      } else {

        var selected_approval_history = this.loadSelectedApprovalHistory();
        if (selected_approval_history.indexOf(this.approvalId) < 0) {
          selected_approval_history.push(this.approvalId);
          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.set('selected_approval_history', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(selected_approval_history));
        }
        __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("notificationAfterCertificateSoftwareApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50"
        });
      }
    },
    onDeviceEmbeddedInformationAddCheckConfirmStep2: function onDeviceEmbeddedInformationAddCheckConfirmStep2(mode) {
      var _this8 = this;

      console.log("onDeviceEmbeddedInformationAddCheckConfirmStep2", mode);
      this.read_only = false;
      if (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" && this.loadBy == "fk_id") {} else {
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
      }
      this.commonSaveInfo(this, this.api_name, { use_transaction: true, from_edit_form: true }, function (err, saved_data) {
        if (err) {} else {
          if (_this8.is_new == true) {
            _this8.saveEditClicked = true;
            _this8.localSeqId = _this8.certificateSeqId;
          }
          if (saved_data) {
            if (saved_data.show_alert == 1) {
              _this8.showSurplusAlertMessage = true;
            } else {
              _this8.showSurplusAlertMessage = false;
            }
          }

          __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("notificationAfterSave", {
            message: "",
            title: "登録情報を下書きに保存しました。",
            yes_label: "",
            no_label: "OK",
            yes_color: "",
            no_color: "",
            model_height: "50"
          });
        }
      });
    },
    onDeviceEmbeddedInformationAddCheckConfirm: function onDeviceEmbeddedInformationAddCheckConfirm(mode) {
      var _this9 = this;

      if (mode == "yes") {
        if (this.subTableController.save) {
          this.subTableController.save(function (err, data) {
            if (err) {
              _this9.$notify({ title: err, type: 'error', duration: 10000 });
            } else {
              if (data && data.seq_id) {
                _this9.$store.state[_this9.stateCurrentEditing]["certificate_seq_id"] = data.seq_id;
              }
              _this9.onDeviceEmbeddedInformationAddCheckConfirmStep2(mode);
            }
          });
        } else {
          this.onDeviceEmbeddedInformationAddCheckConfirmStep2(mode);
        }
      }
    },
    onLocalUpSaveCertificateSoftware: function onLocalUpSaveCertificateSoftware() {
      this.form_confirmation = {};
      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        console.log("onLocalSave");
        __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationUpAddCheck", {
          message: "よろしいですか？",
          title: "登録情報を上書保存します。",
          yes_label: "上書保存",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onDeviceEmbeddedInformationUpAddCheckConfirm: function onDeviceEmbeddedInformationUpAddCheckConfirm(mode) {
      var _this10 = this;

      if (mode == "yes") {
        console.log("onDeviceEmbeddedInformationUpAddCheckConfirm", mode);
        if (this.subTableController.save && this.forceDisableDueUpgradeDestination != true) {
          this.subTableController.save(function (err, data) {
            if (err) {
              _this10.$notify({ title: err, type: 'error', duration: 10000 });
            } else {
              if (data && data.seq_id) {
                _this10.$store.state[_this10.stateCurrentEditing]["certificate_seq_id"] = data.seq_id;
              }
              _this10.onDeviceEmbeddedInformationUpAddCheckConfirmStep2();
            }
          });
        } else {
          this.onDeviceEmbeddedInformationUpAddCheckConfirmStep2();
        }
      };
    },
    onDeviceEmbeddedInformationUpAddCheckConfirmStep2: function onDeviceEmbeddedInformationUpAddCheckConfirmStep2() {
      var _this11 = this;

      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, { from_edit_form: true, overwrite_changed_fields: true, approval_id: this.approvalId }, function (err, data) {
        if (err) {} else {
          if (data && data.show_alert == 1) {
            _this11.showSurplusAlertMessage = true;
          } else {
            _this11.showSurplusAlertMessage = false;
          }
          __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("notificationAfterSave", {
            message: "",
            title: "登録情報を上書保存しました。",
            yes_label: "",
            no_label: "OK",
            yes_color: "",
            no_color: "",
            model_height: "50"
          });
        }
      });
    },
    afterTheNotificationAfterSave: function afterTheNotificationAfterSave(mode) {
      if (mode == "no" || mode == "yes") {
        if (this.loadBy != "fk_id") {
          return this.$router.push("/certificate/" + this.localSeqId);
        }
      }
    },
    afterTheNotificationAftercancel: function afterTheNotificationAftercancel(mode) {
      var _this12 = this;

      setTimeout(function () {
        return _this12.$router.push("/approval_history");
      }, 600);
      console.log("afterTheNotificationAftercancel");
    },
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    btnCancel: function btnCancel() {
      if (this.subTableController.cancel) {
        this.subTableController.cancel();
      }
      this.commonValidateFieldsClear(this, function () {});
      this.cancelCurrentSelection(true);
      this.local_status = false;
      this.$store.state[this.stateCurrentEditing]["approval_status"] = "";
      this.$store.state[this.stateCurrentRow]["approval_status"] = "";
      this.loadFormData();
    },
    onEdit: function onEdit() {
      if (this.isSurplus && this.isNoAdminUserId && this.isExpired) {
        this.$notify({ clean: true });
        this.$notify({
          title: '有効期限が切れている為、編集する事はできません。',

          type: 'error',
          duration: 10000
        });
        return;
      }
      this.startCompanySelection();
      if (this.subTableController.edit) {
        if (this.forceDisableDueUpgradeDestination != true) {
          this.subTableController.edit();
        }
      }
      this.commonOnEdit();
      if (this.loadBy == "fk_id" && this.approvalStatus == "申請中") {
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled = false;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      } else {
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled = true;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      }
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("certificateApplicationConfimationModal", {
        application_mode: "certificate",
        ref_id: this.certificateSoftwareNumber,

        seq_id: this.localSeqId,
        is_surplus: this.isSurplus,
        load_previous_if_exist: true,
        approval_history_id: this.approvalHistoryId || false,
        approval_history_toroku_number: this.approvalHistoryTorokuNumber || false
      });
    },
    backToList: function backToList() {
      var certificate_back_to_list = window.sessionStorage.getItem("certificate_back_to_list");
      if ((certificate_back_to_list || "").indexOf("/") == 0) {
        return this.$router.push(certificate_back_to_list);
      } else if (this.loadBy == "fk_id") {
        return this.$router.push({
          name: "page_0050_approval_history_tabs",
          params: {}
        });
      } else {
        return this.$router.push({
          name: "page_0040_certificate_software",
          params: {}
        });
      }
    },
    onLocalSaveCertificateSoftware: function onLocalSaveCertificateSoftware() {
      var _this13 = this;

      this.form_confirmation = {};
      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        var status = _this13.getFieldLastValue("status");
        var effective_number = _this13.getFieldLastValue("effective_number");
        if (status == "廃棄" && effective_number > 0) {
          __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("confirmUnlinkDevices", {
            message: "機器に紐づいたソフトウェア情報を廃棄します。<br>紐付けを解除してよろしいですか？",
            title: "",
            yes_label: "はい(紐付けを解除して下書保存)",
            no_label: "キャンセル",
            yes_color: "primary",
            no_color: "",
            model_height: "50",
            model_width: "500px"
          });
        } else {
          _this13.onLocalSaveCertificateSoftwareAfterValudateStatus();
        }
      });
    },
    onConfirmUnlinkDevices: function onConfirmUnlinkDevices(mode) {
      if (mode == "yes") {
        this.form_confirmation["confirm_clear_device"] = "yes";
        this.onLocalSaveCertificateSoftwareAfterValudateStatus();
      }
    },
    onLocalSaveCertificateSoftwareAfterValudateStatus: function onLocalSaveCertificateSoftwareAfterValudateStatus() {
      var message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>承認状態が【下書中】となるので、申請が必要になります。</span>";

      if (this.showapprovalStatus == true) {
        message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>※承認状態が【承認済】のものは【下書中】になります。 </span>";
      }
      if (this.is_new == false) {
        this.saveEditClicked = true;
      }
      console.log("onLocalSave");
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddCheck", {
        message: message,
        title: "登録情報を下書保存します。",
        yes_label: "下書保存",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50",
        model_width: "450px"
      });
    },
    onLocalOnSaveCertificateSoftwareAfterValudateStatus: function onLocalOnSaveCertificateSoftwareAfterValudateStatus() {
      console.log("onLocalSave");
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddCheck", {
        message: "よろしいですか？",
        title: "登録情報を上書保存します。",
        yes_label: "上書保存",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    hideApprovalCancelSet: function hideApprovalCancelSet(flag) {
      if (typeof this.fieldList["retraction_reason"] != "undefined") {
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined") {
          this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    ApprovalCancelModeSet: function ApprovalCancelModeSet(aflag) {
      var bflag = this.hideApprovalcancel;
      if (typeof this.fieldList["retraction_reason"] != "undefined") {
        if (aflag == true) {
          this.fieldList["retraction_reason"].force_write = true;
          this.approvalcancelmode = true;
        } else {
          this.fieldList["retraction_reason"].force_write = false;
          this.approvalcancelmode = false;
        }
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined") {
          this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    processApprovalCancel: function processApprovalCancel() {
      console.log("processApprovalCancel");
      this.ApprovalCancelModeSet(true);
    },
    onapprovalSaveDevEmbedded: function onapprovalSaveDevEmbedded() {
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddcancel", {
        message: "よろしいですか？",
        title: "申請を差戻します。",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onapprovalSaveDevEmbeddedReason: function onapprovalSaveDevEmbeddedReason() {
      __WEBPACK_IMPORTED_MODULE_16__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddcancelReason", {
        message: "よろしいですか？",
        title: "申請を取戻します。",
        yes_label: "取戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    approvalCancelbtn: function approvalCancelbtn() {
      this.ApprovalCancelModeSet(false);
    },
    prepareCompanySelection: function prepareCompanySelection(companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name) {
      var _this14 = this;

      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true
            });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true
            });
          }
        }
      });

      company_field.page_controller_msg({
        cmd: "set_options",
        options: _.clone(companies)
      });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });

        selected_company = _this14.$store.state[_this14.stateCurrentRow][company_field.id];
        selected_department = _this14.$store.state[_this14.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({
            cmd: "set_options",
            options: departments,
            reset: false
          });
          department_field.page_controller_msg({ cmd: "enable" });
          if (selected_department && selected_department.length > 0) {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: false
            });
          }
        }

        if (_this14.isSurplus) {
          setTimeout(function () {
            department_field.page_controller_msg({ cmd: "enable" });
          }, 500);
        }
      }, this.is_new ? 100 : 500);
    },
    startCompanySelection: function startCompanySelection() {
      var _this15 = this;

      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;

        this.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
          if (err) {
            _this15.$notify({
              title: "所管会社のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          }
          var companies = [""];
          _companies.forEach(function (c) {
            companies.push(c.val);
          });

          _this15.$ajax.post_cached_queued("/master_belongs/list_team_and_department", {}, function (err, department_and_team) {
            if (err) {
              _this15.$notify({
                title: "部署・チームのデータの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              return;
            }
            _this15.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.licensed_department, temp_fields.license_jurisdiction_team, "company", "department");
            if (_this15.$route.params.seq_id == "new") {
              var default_company = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get(temp_fields.company.default_from_local_storage);
              if (default_company != __WEBPACK_IMPORTED_MODULE_20__rules_constants___default.a.COMPANY.ALL) {
                setTimeout(function () {
                  var default_deparment = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get(temp_fields.licensed_department.default_from_local_storage);
                  var default_team = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].localStorage.get(temp_fields.license_jurisdiction_team.default_from_local_storage);
                  temp_fields.company.page_controller_msg({
                    cmd: "set_value",
                    val: default_company
                  });
                  temp_fields.licensed_department.page_controller_msg({
                    cmd: "set_value",
                    val: default_deparment
                  });
                  temp_fields.license_jurisdiction_team.page_controller_msg({ cmd: "set_value", val: default_team });
                }, _this15.is_new ? 300 : 1000);
              }
            }
          });
        });
      }
    },
    loadFormData: function loadFormData() {
      var _this16 = this;

      mdebug("page_0040_certificate_software_detail mounting");
      this.approvalHistoryBulkTorokuNumberQty = 0;
      this.isExpired = false;
      this.fieldList["retraction_reason"].hide_all = true;
      if (this.loadBy == "certificate_software_number") {
        var certificate_software_number = this.$route.params.certificate_software_number;
        this.$ajax.post("/" + this.api_name + "/get_by_ref_id/" + certificate_software_number, { ref_id: certificate_software_number }, function (err, result) {
          if (err) {
            _this16.$notify({
              title: "データの読込に失敗しました。",
              text: err,
              type: "error",
              duration: 10000
            });
          }
          _this16.localSeqId = result.data.seq_id;
          _this16.$store.state[_this16.stateCurrentRow] = result.data;
          if (_this16.subTableController) {
            if (result && result.data && result.data.certificate_seq_id && result.data.certificate_seq_id > -1) {
              _this16.subTableController.load_data(result.data.certificate_seq_id);
            } else {
              _this16.subTableController.load_data("new");
            }
          }
          if (typeof _this16.$store.state[_this16.stateCurrentRow].approval_history_id == "number" && isNaN(_this16.$store.state[_this16.stateCurrentRow].approval_history_toroku_number) == false) {
            _this16.approvalHistoryId = _this16.$store.state[_this16.stateCurrentRow].approval_history_id;
            _this16.approvalHistoryTorokuNumber = _this16.$store.state[_this16.stateCurrentRow].approval_history_toroku_number;
            if (_this16.approvalHistoryId == -200) {
              _this16.approvalHistoryTorokuNumber;
            }
          }
          if (result && result.data && result.data.disable_validation == 1) {
            _this16.disableValidation(true);
          }
          if (result && result.data && result.data.status) {
            _this16.original_status = result.data.status || false;
          }

          if (_this16.AllowSurplusExtraRule(result)) {
            _this16.allowSurplus = true;
          } else {
            _this16.allowSurplus = false;
          }
          if (result && result.data && result.data.status == "余剰") {
            _this16.isSurplus = true;
          } else {
            _this16.isSurplus = false;
          }
          if (result && result.data && result.data.approval_status == "承認済") {
            _this16.isApproved = true;
          } else {
            _this16.isApproved = false;
          }
          if (result && result.data && result.data.show_alert == 1) {
            _this16.showSurplusAlertMessage = true;
          } else {
            _this16.showSurplusAlertMessage = false;
          }

          _this16.commonSetStyleForChangedFields(result.data);
          mdebug("LOAD DATA", { err: err, result: result });
        });
      } else if (this.loadBy == "fk_id") {
        this.is_new = false;
        this.localSeqId = this.$route.params.fk_id;
        this.approvalId = this.$route.params.approval_id;
        this.$ajax.post("/" + this.api_name + "/get/" + this.$route.params.fk_id, { fk_id: this.$route.params.fk_id }, function (err, result) {
          if (err) {
            _this16.$notify({
              title: "データの読込に失敗しました。",
              text: err,
              type: "error",
              duration: 10000
            });
          }
          _this16.localSeqId = result.data.seq_id;
          _this16.$store.state[_this16.stateCurrentRow] = result.data;
          _this16.fieldList["retraction_reason"].hide_all = _this16.$store.state[_this16.stateCurrentRow].approval_status == "承認済";
          if (typeof _this16.$store.state[_this16.stateCurrentRow].approval_history_id == "number" && isNaN(_this16.$store.state[_this16.stateCurrentRow].approval_history_toroku_number) == false) {
            _this16.approvalHistoryId = _this16.$store.state[_this16.stateCurrentRow].approval_history_id;
            if (_this16.approvalHistoryId > 0) {
              _this16.approvalId = _this16.approvalHistoryId;
            }
            _this16.approvalHistoryTorokuNumber = _this16.$store.state[_this16.stateCurrentRow].approval_history_toroku_number;
            if (_this16.approvalHistoryId == -200) {
              _this16.approvalHistoryTorokuNumber;
            }
          }
          if (_this16.subTableController) {
            if (result && result.data && result.data.certificate_seq_id && result.data.certificate_seq_id > -1) {
              _this16.subTableController.load_data(result.data.certificate_seq_id);
            } else {
              _this16.subTableController.load_data("new");
            }
          }

          if (result && result.data && result.data.disable_validation == 1) {
            _this16.disableValidation(true);
          }
          if (result && result.data && result.data.status) {
            _this16.original_status = result.data.status || false;
          }
          if (_this16.AllowSurplusExtraRule(result)) {
            _this16.allowSurplus = true;
          } else {
            _this16.allowSurplus = false;
          }
          if (result && result.data && result.data.status == "余剰") {
            _this16.isSurplus = true;
          } else {
            _this16.isSurplus = false;
          }
          if (result && result.data && result.data.approval_status == "承認済") {
            _this16.isApproved = true;
          } else {
            _this16.isApproved = false;
          }

          if (_this16.isSurplus == false && result && result.data && result.data.expiration_date) {
            var today = __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date());
            var exp_date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(result.data.expiration_date);

            var diff = exp_date.diff(today, 'days');
            if (diff < 0) {
              _this16.allowSurplus = false;
            }
          }
          if (result && result.data && result.data.expiration_date) {
            var exp_date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(result.data.expiration_date);
            var deadline_alert = result.data.deadline_alert || "無";
            var diff = exp_date.diff(today, 'days');
            if (deadline_alert == "有" && diff < 0) {
              _this16.isExpired = true;
            }
          }
          if (result && result.data && result.data.show_alert == 1) {
            _this16.showSurplusAlertMessage = true;
          } else {
            _this16.showSurplusAlertMessage = false;
          }
          _this16.approvalHistoryBulkTorokuNumberQty = result.data.approval_history_bulk_toroku_number_qty || 0;
          _this16.commonSetStyleForChangedFields(result.data);
          mdebug("LOAD DATA", { err: err, result: result });
        });
      } else if (this.loadBy == "clone") {
        this.startCompanySelection();
        this.is_new = true;
        this.localSeqId = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
        this.$ajax.post("/" + this.api_name + "/get/" + this.$route.params.seq_id, {}, function (err, result) {
          if (err) {
            _this16.$notify({
              title: "データの読込に失敗しました。",
              text: err,
              type: "error",
              duration: 10000
            });
          }

          _this16.$store.state[_this16.stateCurrentRow] = {};
          _this16.$store.state[_this16.stateCurrentEditing] = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result.data).forEach(function (k) {
            var value = result.data[k];
            if (k == "seq_id") {
              _this16.$store.state[_this16.stateCurrentRow][k] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
            } else if (k == "certificate_software_number") {
              _this16.$store.state[_this16.stateCurrentRow][k] = "";
              _this16.$store.state[_this16.stateCurrentEditing][k] = "";
            } else if (k == "approval_status_flag" || k == "effective_number") {
              _this16.$store.state[_this16.stateCurrentRow][k] = 0;
              _this16.$store.state[_this16.stateCurrentEditing][k] = 0;
            } else if (k == "approval_status") {
              _this16.$store.state[_this16.stateCurrentRow][k] = "";
              _this16.$store.state[_this16.stateCurrentEditing][k] = "";
            } else {
              _this16.$store.state[_this16.stateCurrentRow][k] = value;
              _this16.$store.state[_this16.stateCurrentEditing][k] = value;
            }
          });
          _this16.Status = "使用中";

          _this16.commonSetStyleForChangedFields(result.data);
          setTimeout(function () {
            _this16.$store.state[_this16.stateIsEditingNew] = true;
            _this16.read_only = false;
            _this16.is_new = true;
            if (_this16.subTableController) {
              _this16.subTableController.load_data("new");
            }
          }, 300);
          _this16.commonEditDeleteCmdHandler(_this16);
        });
      } else {
        this.commonLoadRecord({}, function (err, result) {
          if (typeof _this16.$store.state[_this16.stateCurrentRow].approval_history_id == "number" && isNaN(_this16.$store.state[_this16.stateCurrentRow].approval_history_toroku_number) == false) {
            _this16.approvalHistoryId = _this16.$store.state[_this16.stateCurrentRow].approval_history_id;
            _this16.approvalHistoryTorokuNumber = _this16.$store.state[_this16.stateCurrentRow].approval_history_toroku_number;
            if (_this16.approvalHistoryId == -200) {
              _this16.approvalHistoryTorokuNumber;
            }
          }

          if (_this16.$route.params.seq_id == "new") {
            _this16.Deadline_Alert = "無";
            _this16.Comprehensive_contract = "無";
            _this16.Downgrade = "無";
            _this16.Status = "使用中";
            setTimeout(function () {
              _this16.startCompanySelection();
            }, 10);
          } else {
            if (result && result.data && result.data.disable_validation == 1) {
              _this16.disableValidation(true);
            }
            if (result && result.data && result.data.status) {
              _this16.original_status = result.data.status || false;
            }
            if (_this16.AllowSurplusExtraRule(result)) {
              _this16.allowSurplus = true;
            } else {
              _this16.allowSurplus = false;
            }
            if (result && result.data && result.data.status == "余剰") {
              _this16.isSurplus = true;
              _this16.fieldList.product_key.ref_field.localDisabled = true;
            } else {
              _this16.isSurplus = false;
            }
            if (result && result.data && result.data.approval_status == "承認済") {
              _this16.isApproved = true;
            } else {
              _this16.isApproved = false;
            }
            if (_this16.isSurplus == false && result && result.data && result.data.expiration_date) {
              var today = __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date());
              var exp_date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(result.data.expiration_date);

              var diff = exp_date.diff(today, 'days');
              if (diff < 0) {
                _this16.allowSurplus = false;
              }
            }
            if (result && result.data && result.data.expiration_date) {
              var exp_date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(result.data.expiration_date);
              var deadline_alert = result.data.deadline_alert || "無";
              var diff = exp_date.diff(today, 'days');
              if (deadline_alert == "有" && diff < 0) {
                _this16.isExpired = true;
              }
            }
          }
          if (result && result.data && result.data.upgrade_destination && (result.data.upgrade_destination || "").length > 0) {
            _this16.forceDisableDueUpgradeDestination = true;
          } else {
            _this16.forceDisableDueUpgradeDestination = false;
          }
          if (_this16.subTableController) {
            if (result && result.data && result.data.certificate_seq_id && result.data.certificate_seq_id > -1) {
              _this16.subTableController.load_data(result.data.certificate_seq_id);
            } else {
              _this16.subTableController.load_data("new");
            }
          }
          if (result && result.data && result.data.show_alert == 1) {
            _this16.showSurplusAlertMessage = true;
          } else {
            _this16.showSurplusAlertMessage = false;
          }
          _this16.commonEditDeleteCmdHandler(_this16);
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadFormData();
    this.DisabledEdit = this.isApproverUserId == true;
  },
  beforeDestroy: function beforeDestroy() {
    this.approvalHistoryBulkTorokuNumberQty = 0;
    var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")] = {};
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_certificate_information_connection_application_modal__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_certificate_information_connection_application_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_certificate_information_connection_application_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_change_history_modal__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_change_history_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_change_history_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_certificate_software_linked_upgrade_modal__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_certificate_software_linked_upgrade_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_certificate_software_linked_upgrade_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__rules_constants__);










var mdebug = __WEBPACK_IMPORTED_MODULE_7_debug___default()("esma:device_certificate_software");











var timeout_control = {};
var queue_bus = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "field-box": __WEBPACK_IMPORTED_MODULE_8__components_form_field___default.a,
    "certificate-information-connection-application-modal": __WEBPACK_IMPORTED_MODULE_4__components_modals_certificate_information_connection_application_modal___default.a,
    "application-confirmation-modal": __WEBPACK_IMPORTED_MODULE_5__components_modals_application_confirmation_modal___default.a,
    "change-history": __WEBPACK_IMPORTED_MODULE_13__components_modals_change_history_modal___default.a,
    "certificate-software-linked-upgrade-modal": __WEBPACK_IMPORTED_MODULE_14__components_modals_certificate_software_linked_upgrade_modal___default.a
  },
  data: function data() {
    return {
      show_sub_table_associated_device: false,
      api_name: "certificate_software",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      page_acl: __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default.a.certificate_software,
      approval_history_id: "",
      approval_id: null,
      local_status: false,
      save_edit_cliqued: false,
      local_seq_id: -1,
      approval_history_toroku_number: false,
      allow_surplus: false,
      is_surplus: false,
      is_approved: false,
      load_upgrade_modal: false,
      force_disable_due_upgrade_destination: false,
      form_confirmation: {},
      enable_history_modal: false,
      show_surplus_alert_message: false,
      company_selection_started: false,
      disable_application_btn: false
    };
  },

  computed: {
    disableApplicationBtn: {
      get: function get() {
        return this.disable_application_btn;
      },
      set: function set(v) {
        this.disable_application_btn = v;
      }
    },
    showSurplusAlertMessage: {
      get: function get() {
        return this.show_surplus_alert_message;
      },
      set: function set(v) {
        this.show_surplus_alert_message = v;
      }
    },

    forceDisableDueUpgradeDestination: {
      get: function get() {
        return this.force_disable_due_upgrade_destination;
      },
      set: function set(v) {
        this.force_disable_due_upgrade_destination = v;
      }
    },
    loadUpgradeModal: {
      get: function get() {
        return this.load_upgrade_modal;
      },
      set: function set(v) {
        this.load_upgrade_modal = v;
      }
    },
    statusFieldStyle: function statusFieldStyle() {
      if (this.$store.state["current_field_style"] && this.$store.state["current_field_style"]["status"]) {
        return this.$store.state["current_field_style"]["status"];
      } else {
        return "";
      }
    },

    isApproved: {
      get: function get() {
        return this.is_approved;
      },
      set: function set(v) {
        this.is_approved = v;
      }
    },
    isSurplus: {
      get: function get() {
        return this.is_surplus;
      },
      set: function set(v) {
        this.is_surplus = v;
      }
    },
    allowSurplus: {
      get: function get() {
        return this.allow_surplus;
      },
      set: function set(v) {
        this.allow_surplus = v;
      }
    },
    subTableController: {
      get: function get() {
        return this.sub_table_controller;
      },
      set: function set(v) {
        this.sub_table_controller = v;
      }
    },
    disableAllButtons: function disableAllButtons() {
      return this.loadBy == "certificate_software_number";
    },

    localSeqId: {
      get: function get() {
        return this.local_seq_id;
      },
      set: function set(v) {
        this.local_seq_id = v;
      }
    },
    disableEditMainBtn: function disableEditMainBtn() {
      if (this.loadBy == "fk_id") {
        return this.hideForApplicant && this.approvalStatus == "申請中";
      }
      return this.approvalStatus == "申請中";
    },
    disableCopyMainBtn: function disableCopyMainBtn() {
      return false;
    },
    hideForApplicant: function hideForApplicant() {
      if (this.loadBy != "fk_id") {
        return false;
      }
      if (typeof this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] == "undefined" && this.isAdmin == true) {
        return false;
      } else {
        return this.$store.state[this.stateCurrentRow]["approval_history_applicant"] == __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userID") && this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] != __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userID");
      }
    },
    hideEditMainBtn: function hideEditMainBtn() {
      return this.hideForApplicant && this.approvalStatus == "申請中";
    },
    hideCopyMainBtn: function hideCopyMainBtn() {
      return this.loadBy == "fk_id" || this.is_new == true;
    },
    hideApplicationBtn: function hideApplicationBtn() {
      return this.loadBy == "fk_id" && this.approvalStatus != "下書中" || this.approvalStatus != "下書中";
    },
    hideApplyConfirmationBtn: function hideApplyConfirmationBtn() {
      if (this.loadBy != "fk_id") {
        return true;
      }
      return this.hideForApplicant || this.approvalStatus != "申請中";
    },
    hideApplyRejectBtn: function hideApplyRejectBtn() {
      return this.loadBy != "fk_id" || this.approvalStatus != "申請中";
    },

    Deadline_Alert: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["deadline_alert"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["deadline_alert"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["deadline_alert"] = this.local_status = v;
      }
    },
    Comprehensive_contract: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["comprehensive_contract"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["comprehensive_contract"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["comprehensive_contract"] = this.local_status = v;
      }
    },
    Downgrade: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["downgrade"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["downgrade"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["downgrade"] = this.local_status = v;
      }
    },
    Status: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["status"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions: function StatusOptions() {
      var options = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].status.options);
      if (this.allowSurplus == true) {
        if (options.indexOf("余剰") < 0) {
          options.push("余剰");
        }
      }
      return options;
    },
    subTableDeviceEmbeddedInformationStyle: function subTableDeviceEmbeddedInformationStyle() {
      if (this.saveEditClicked || this.is_new == false) {
        return "";
      } else {
        return "opacity: 0.5;";
      }
    },

    saveEditClicked: {
      get: function get() {
        return this.save_edit_cliqued;
      },
      set: function set(v) {
        this.save_edit_cliqued = v;
      }
    },
    approvalHistoryId: {
      get: function get() {
        return this.approval_history_id;
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    approvalHistoryTorokuNumber: {
      get: function get() {
        return this.approval_history_toroku_number;
      },
      set: function set(v) {
        this.approval_history_toroku_number = v;
      }
    },
    isAdminSavingApplication: function isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == "fk_id";
    },
    showFieldchangedStyle: function showFieldchangedStyle() {
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" || this.$store.state[this.stateCurrentRow]["approval_status"] == "差戻") && (this.isAdmin || this.$store.state[this.stateCurrentRow]["approval_history_next_approver"]);
    },
    approvalStatus: function approvalStatus() {
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"];
    },
    allowEditjurisdictionSystem: function allowEditjurisdictionSystem() {
      return this.$store.state[this.stateCurrentRow]["jurisdiction_classification"] != "IT所管システム";
    },

    aprovalId: {
      get: function get() {
        return this.aproval_id;
      },
      set: function set(v) {
        this.aproval_id = v;
      }
    },

    certificateSoftwareNumber: function certificateSoftwareNumber() {
      return this.$store.state[this.stateCurrentRow]["certificate_software_number"];
    },
    certificateSeqId: function certificateSeqId() {
      return parseInt(this.$store.state[this.stateCurrentRow]["seq_id"] || this.localSeqId);
    },
    deviceControlNumber: function deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["device_control_number"];
    },
    registrationDate: function registrationDate() {
      return __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["b" /* filed_types */];
    },
    formFields: function formFields() {
      var _this = this;

      return {
        col1: [__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].certificate_software_number), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].maker), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].software_name), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].company), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].licensed_department), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_team), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].license_name), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].jurisdiction_classification), {
          error_if_blank: false,
          on_set_value: function on_set_value(data) {
            _this.singleTimeout("upd_license_jurisdiction_system_it", setTimeout(function () {
              _this.queuedBusEmit("upd_license_jurisdiction_system_it", {
                val: data == "IT所管システム"
              });
            }, 500));
            setTimeout(function () {
              _this.queuedBusEmit("upd_license_jurisdiction_system", {
                val: data == "EUC・その他"
              });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_system), {
          error_if_blank: false,
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system_it",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].equipment_in_charge_system), {
          error_if_blank: false,
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].product_key), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].upgrade), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].upgrade_source), {
          error_if_blank: false,
          disabled: true, read_only: true,
          force_readonly: true,
          field_style: " width: 100%;display: block;",
          buttons: [{
            btn_style: "width:250px;margin-left:2px;padding-left: 1px;padding-right: 1px;float:left; margin-top: 2px;margin-bottom: 10px;    background: rgb(51 122 183);border-color: rgb(46 109 164);",
            type: "callback",
            callback: function callback(b) {},
            label: "アップグレード元の証書を選択する" }]
        })],
        col2: [__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].upgrade_destination), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].deadline_alert), {
          disabled: this.isSurplus,
          read_only: this.isSurplus,
          on_set_value: function on_set_value(data) {
            setTimeout(function () {
              _this.queuedBusEmit("upd_expiration_date", {
                val: data == "有"
              });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].expiration_date), {
          listen_for: [{
            name: "upd_expiration_date",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]
        }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].maintenance_deadline), {
          disabled: this.isSurplus,
          read_only: this.isSurplus
        }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].second_number), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].unlimited), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].license), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].applicant_name), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].management_person_name), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].comprehensive_contract), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].effective_number), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].remaining_number), { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].remark), { label_length_4: true })],
        col3: []
      };
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    queuedBusEmit: function queuedBusEmit(id, data) {
      queue_bus.push({ id: id, data: data });
      this.queuedBusRun();
    },
    queuedBusRun: function queuedBusRun() {
      var _this2 = this;

      if (queue_bus.length > 0) {
        if (timeout_control["bus"]) {
          return;
        }
        timeout_control["bus"] = setTimeout(function () {
          var n = queue_bus.shift();
          __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit(n.id, n.data);
          timeout_control["bus"] = false;
          _this2.queuedBusRun();
        }, 50);
      } else {}
    },
    singleTimeout: function singleTimeout(name, ev) {
      if (timeout_control[name]) {
        clearTimeout(timeout_control[name]);
      }
      timeout_control[name] = ev;
    },
    onEdit: function onEdit() {
      var _this3 = this;

      mdebug("onEdit");
      setTimeout(function () {
        _this3.disableApplicationBtn = false;
        _this3.read_only = false;
      }, 300);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("deleteCertificateInformationDetailModal", {
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      var list_seq_id = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('bulk_edit_' + this.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id);
        var syubetu = __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.SYUBETU.CERTIFICATE;
        __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("certificateBulkApplicationConfimationModal", {
          list_seq_id: list_seq_id.arr,
          application_mode: "bulk_edit_certificate",
          title_prefix: "" + syubetu + "(一括編集）",
          title_suffix: "" + syubetu + "(一括編集）",
          process_import_url: '/' + this.api_name + '/bulk_to_approval_history/',
          on_finish_url_name: "page_0040_certificate_software",
          ref_id: null
        });
      } catch (error) {
        this.$notify({
          title: "適用する行の読込に失敗しました。",
          text: error,
          type: 'error',
          duration: 12000
        });
      }
    },
    processFieldStyle: function processFieldStyle(store_key_name, last_changed_fields) {
      var _this4 = this;

      if (Array.isArray(last_changed_fields)) {
        last_changed_fields.forEach(function (e) {});
      } else {}
      this.$store.state[store_key_name] = {};
      if (last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0) {
        last_changed_fields.forEach(function (f) {
          if (_this4.showFieldchangedStyle) {
            _this4.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },
    onDeviceEmbeddedInformationAddCheckConfirmStep2: function onDeviceEmbeddedInformationAddCheckConfirmStep2(mode) {
      var _this5 = this;

      console.log("onDeviceEmbeddedInformationAddCheckConfirmStep2", mode);
      if (mode == "yes") {
        this.read_only = false;

        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";


        var list_seq_id = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('bulk_edit_' + this.local_page_id);

        try {
          list_seq_id = JSON.parse(list_seq_id);
          var disabled_fields = [];
          this.allFields.forEach(function (f) {
            if (f.ref_field && (f.ref_field.data && f.ref_field.data.disabled == true || f.ref_field.localDisabled == true)) {
              disabled_fields.push(f.id);
            }
          });
          this.saveBulk(this.api_name, list_seq_id.arr, { from_edit_form: true, se_transaction: true, disabled_fields: disabled_fields }, function (err) {
            _this5.disableApplicationBtn = true;
            __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("notificationCertificcateBulkAfterSave", {
              message: "",
              title: "登録情報を下書きに保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "",
              model_height: "50"
            });
            _this5.read_only = true;

            setTimeout(function () {
              var temp_current = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(_this5.$store.state[_this5.stateCurrentRow]);
              var temp = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(_this5.$store.state[_this5.stateCurrentEditing]);
              _this5.allFields.forEach(function (f) {
                if (typeof temp[f.id] == "undefined") {
                  temp[f.id] = temp_current[f.id] || "";
                }
              });
              _this5.$store.state[_this5.stateCurrentRow] = temp;
              _this5.$store.state[_this5.stateCurrentEditing] = temp;
            }, 50);
          });
        } catch (error) {
          this.$notify({
            title: "予期しないエラーが発生し、登録が行えません",
            text: error,
            type: 'error',
            duration: 12000
          });
        }
      }
    },
    onDeviceEmbeddedInformationAddCheckConfirm: function onDeviceEmbeddedInformationAddCheckConfirm(mode) {
      if (mode == "yes") {
        this.onDeviceEmbeddedInformationAddCheckConfirmStep2(mode);
      }
    },
    afterTheNotificationAfterSave: function afterTheNotificationAfterSave(mode) {
      if (mode == "no" || mode == "yes") {}
    },
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    backToList: function backToList() {
      var certificate_back_to_list = window.sessionStorage.getItem("certificate_back_to_list");
      if (this.loadBy == "fk_id") {
        return this.$router.push({
          name: "page_0050_approval_history_tabs",
          params: {}
        });
      } else if ((certificate_back_to_list || "").indexOf("/") == 0) {
        return this.$router.push(certificate_back_to_list);
      } else {
        return this.$router.push({
          name: "page_0040_certificate_software",
          params: {}
        });
      }
    },
    onLocalSaveBulkCertificateSoftware: function onLocalSaveBulkCertificateSoftware() {
      var status = this.getFieldLastValue("status");
      var effective_number = this.getFieldLastValue("effective_number");
      if (status == "廃棄" && effective_number > 0) {
        __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("confirmUnlinkDevices", {
          message: "機器に紐づいたソフトウェア情報を廃棄します。<br>紐付けを解除してよろしいですか？",
          title: "",
          yes_label: "はい(紐付けを解除して下書保存)",
          no_label: "キャンセル",
          yes_color: "primary",
          no_color: "",
          model_height: "50",
          model_width: "500px"
        });
      } else {
        this.onLocalSaveCertificateSoftwareAfterValudateStatus();
      }
    },
    onConfirmUnlinkDevices: function onConfirmUnlinkDevices(mode) {
      if (mode == "yes") {
        this.form_confirmation["confirm_clear_device"] = "yes";
        this.onLocalSaveCertificateSoftwareAfterValudateStatus();
      }
    },
    onLocalSaveCertificateSoftwareAfterValudateStatus: function onLocalSaveCertificateSoftwareAfterValudateStatus() {
      if (this.is_new == false) {
        this.saveEditClicked = true;
      }
      console.log("onLocalonLocalSaveCertificateSoftwareAfterValudateStatusSave");
      __WEBPACK_IMPORTED_MODULE_12__libs_bus__["a" /* bus */].$emit("onLocalSaveCertificateSoftwareAfterValudateStatusCheck", {
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "下書保存",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    prepareCompanySelection: function prepareCompanySelection(companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name) {
      var _this6 = this;

      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true
            });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true
            });
          }
        }
      });
      company_field.page_controller_msg({
        cmd: "set_options",
        options: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(companies)
      });
      company_field.page_controller_msg({ cmd: "disable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });

      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });
        selected_company = _this6.$store.state[_this6.stateCurrentRow][company_field.id];
        selected_department = _this6.$store.state[_this6.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          department_field.page_controller_msg({ cmd: "enable" });
          var departments = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: false });
          if (selected_department && selected_department.length > 0) {
            var teams = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: false });
          }
        }
        var slUserCompany = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userCompany") || false;
        if (slUserCompany && slUserCompany.indexOf("MH") == 0) {
          company_field.page_controller_msg({ cmd: "set_value", val: slUserCompany });
        } else if (slUserCompany && slUserCompany.indexOf("ライセンス管理窓口") == 0) {
          console.log('TEST DEBUG 210429 (410 at page_0010_device_embedded_information_detail_bulk_edit.vue)[16:08]: try to enable', {});
          company_field.page_controller_msg({ cmd: "enable" });
        }
      }, this.is_new ? 500 : 600);

      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });

        selected_company = _this6.$store.state[_this6.stateCurrentRow][company_field_name];
        selected_department = _this6.$store.state[_this6.stateCurrentRow][department_field_name];
        if (selected_company && selected_company.length > 0) {
          var departments = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({
            cmd: "set_options",
            options: departments,
            reset: false
          });
          if (selected_department && selected_department.length > 0) {
            var teams = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: false
            });
          }
        }
      }, this.is_new ? 100 : 500);
    },
    startCompanySelection: function startCompanySelection() {
      var _this7 = this;

      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;

        this.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
          if (err) {
            _this7.$notify({
              title: "所管会社のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          }
          var companies = [""];
          _companies.forEach(function (c) {
            companies.push(c.val);
          });

          _this7.$ajax.post_cached_queued("/master_belongs/list_team_and_department", {}, function (err, department_and_team) {
            if (err) {
              _this7.$notify({
                title: "部署・チームのデータの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              return;
            }
            _this7.prepareCompanySelection(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(companies), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(department_and_team), temp_fields.company, temp_fields.licensed_department, temp_fields.license_jurisdiction_team, "company", "department");
            if (_this7.$route.params.seq_id == "new") {
              var default_company = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.company.default_from_local_storage);
              if (default_company != __WEBPACK_IMPORTED_MODULE_15__rules_constants___default.a.COMPANY.ALL) {
                setTimeout(function () {
                  var default_deparment = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.licensed_department.default_from_local_storage);
                  var default_team = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.license_jurisdiction_team.default_from_local_storage);
                  temp_fields.company.page_controller_msg({
                    cmd: "set_value",
                    val: default_company
                  });
                  temp_fields.licensed_department.page_controller_msg({
                    cmd: "set_value",
                    val: default_deparment
                  });
                  temp_fields.license_jurisdiction_team.page_controller_msg({ cmd: "set_value", val: default_team });
                }, _this7.is_new ? 300 : 1000);
              }
            }
          });
        });
      }
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.Status = "";
    this.addHtmlClass(document.body, 'blue_bg');
    this.disableApplicationBtn = false;
    this.local_page_id = this.$route.params.p_id;
    this.is_new = true;

    this.allFields.forEach(function (f) {
      _this8.$store.state[_this8.stateCurrentRow][f.id] = "";
    });
    this.startCompanySelection();
    setTimeout(function () {
      _this8.Status = "";
      _this8.$store.state[_this8.stateIsEditingNew] = true;
      _this8.read_only = false;
      _this8.is_new = true;
    }, 300);
  },
  beforeDestroy: function beforeDestroy() {
    this.Status = "";
    this.removeHtmlClass(document.body, 'blue_bg');
    var store_style = this.$store.state[this.stateCurrentRow.replace("current_row", "current_field_style")] = {};
  },
  beforeMount: function beforeMount() {
    this.Status = "";
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:certificate_software_linked_devices');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      local_certificate_seq_id: -1,
      page_mode: "list",
      api_name: "certificate_software_linked_devices",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      device_embedded_detail_seq_id: -1,
      detail_page: "page_0010_device_embedded_information_detail",
      disable_select_new: true,
      local_total_licenses: -1,
      local_number_of_remaining: -1,
      local_effective_number: -1,
      disable_return: false
    };
  },

  computed: {
    localCertificateSeqId: {
      get: function get() {
        return this.local_certificate_seq_id;
      },
      set: function set(v) {
        this.local_certificate_seq_id = v;
      }
    },
    disableSelectNew: {
      get: function get() {
        return this.disable_select_new;
      },
      set: function set(v) {
        this.disable_select_new = v;
      }
    },
    disableReturn: {
      get: function get() {
        return this.disable_return;
      },
      set: function set(v) {
        this.disable_return = v;
      }
    },
    localTotalLicenses: {
      get: function get() {
        return this.local_total_licenses;
      },
      set: function set(v) {
        this.local_total_licenses = v;
      }
    },
    localNumberOfRemaining: {
      get: function get() {
        return this.local_number_of_remaining;
      },
      set: function set(v) {
        this.local_number_of_remaining = v;
      }
    },
    localEffectiveNumber: {
      get: function get() {
        return this.local_effective_number;
      },
      set: function set(v) {
        this.local_effective_number = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, { tab_size: 70 }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].item_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, {})];
    }
  },
  methods: {
    unlinkItem: function unlinkItem() {
      var _this = this;

      var obj = this.selectedRowArr.map(function (r) {
        return {
          device_embedded_detail_seq_id: r.device_embedded_detail_seq_id
        };
      });

      if (!(obj && obj.length > 0) && this.$route.params.req_certificate_software_seq_id.length > 0) {
        obj = [{ device_embedded_detail_seq_id: this.device_embedded_detail_seq_id }];
      };

      this.$ajax.post("/certificate_software_linked_devices/unlink_device/", { arr: obj }, function (err, data) {
        if (err) {
          _this.$notify({
            title: 'データの紐付解除に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          _this.$notify({
            title: '紐付が解除されました。',
            type: 'sucess',
            duration: 1000
          });
        }

        _this.localRefreshDeletedRow();
        _this.getAssociatedDeviceInfo();
      });
    },
    getAssociatedDeviceInfo: function getAssociatedDeviceInfo() {
      var _this2 = this;

      this.$ajax.post("/certificate_software/get/" + this.$route.params.req_certificate_software_seq_id, {}, function (err, result) {
        if (err) {
          _this2.$notify({
            title: 'ソフトウェア情報の読込に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          _this2.localTotalLicenses = 0;
          if (result.data.unlimited == "無制限") {
            _this2.disableSelectNew = false;
            _this2.localTotalLicenses = "-";
            _this2.localNumberOfRemaining = "-";
          } else if (result && result.data && isNaN(result.data.license) == false) {
            _this2.localTotalLicenses = result.data.license;
            if (result.data.second_number && result.data.second_number > 0) {
              _this2.localTotalLicenses = result.data.license * result.data.second_number;
            }
          }
          _this2.localEffectiveNumber = 999999999;
          if (result && result.data && isNaN(result.data.effective_number) == false) {
            _this2.localEffectiveNumber = result.data.effective_number;
          }

          if (_this2.localTotalLicenses != "-") {
            _this2.localNumberOfRemaining = _this2.localTotalLicenses - parseInt(result.data.effective_number);
          }
          if (_this2.localNumberOfRemaining <= 0) {
            _this2.disableSelectNew = true;
          } else {
            _this2.disableSelectNew = false;
          }
          if (_this2.localNumberOfRemaining < 0) {
            _this2.disableReturn = true;
          } else {
            _this2.disableReturn = false;
          }
        }
      });
    },
    localRefreshDeletedRow: function localRefreshDeletedRow() {
      this.countRows("localRefreshDeletedRow");
      this.gridOptions.api.purgeInfiniteCache();
    },
    linkNewItem: function linkNewItem() {
      return this.$router.push("/certificate_software_linked_devices/select/" + this.$route.params.req_certificate_software_seq_id);
    },
    backToCertificateDetail: function backToCertificateDetail() {
      return this.$router.push("/certificate/" + this.$route.params.req_certificate_software_seq_id);;
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);

      window.sessionStorage.setItem('device_back_to_list', "/certificate_software_linked_devices/list/" + this.$route.params.req_certificate_software_seq_id);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: false });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
      this.device_embedded_detail_seq_id = ev.node.data.device_embedded_detail_seq_id;
      this.localCertificateSeqId = ev.node.data.certificate_seq_id;
    }
  },
  mounted: function mounted() {
    this.addHtmlClass(document.body, 'blue_bg');
    this.gridOptions.api.sizeColumnsToFit();
    this.getAssociatedDeviceInfo();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeHtmlClass(document.body, 'blue_bg');
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = { seq_id: this.$route.params.req_certificate_software_seq_id };
    this.initDatasource();
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:certificate_software_linked_devices_select');








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'input-number-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_input_number_modal___default.a
  },
  data: function data() {
    return {
      local_device_control_number: null,
      api_name: "certificate_software_linked_devices_select",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      detail_page: "page_0010_device_embedded_information_detail"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_device_embedded_information__["a" /* fields */].management_person_name, {})];
    }
  },
  methods: {
    addSelected: function addSelected() {
      __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("showNumberModalForSetDevicesQuantity", {
        title: "",
        message: "新規に組込情報を追加し証書を紐付けます。<br>組込本数を入力してください。<br><br><br>",
        input_prefix: "組込本数：",
        input_suffix: "本",
        yes_label: "組込情報を追加して紐付",
        no_label: "戻る",
        yes_style: "",
        no_style: "",
        min_val: 1
      });
    },
    onSelectedQty: function onSelectedQty(data) {
      if (data && data.mode == "yes") {
        if (data.value > 0) {
          this.saveSelected(data.value);
        }
      }
    },
    saveSelected: function saveSelected(qty) {
      var _this = this;

      var obj = this.selectedRowArr.map(function (r) {
        return {
          set_qty: qty,
          certificate_software_seq_id: _this.$route.params.req_certificate_software_seq_id,
          device_control_number: r.device_control_number,
          device_ebedded_information_seq_id: r.seq_id };
      });

      if (!(obj && obj.length > 0) && this.$route.params.req_certificate_software_seq_id.length > 0) {
        obj = [{
          set_qty: qty,
          certificate_software_seq_id: this.$route.params.req_certificate_software_seq_id,
          device_control_number: this.local_device_control_number,
          device_ebedded_information_seq_id: this.selected_row }];
      };

      this.$ajax.post("/certificate_software_linked_devices/link_device/", { arr: obj }, function (err, data) {
        if (err) {
          _this.$notify({
            title: 'データの保存に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          _this.$notify({
            title: '紐付済',
            type: 'sucess',
            duration: 1000
          });
          setTimeout(function () {
            return _this.backToList();
          }, 1000);
        }
      });
    },
    backToList: function backToList() {
      return this.$router.push("/certificate_software_linked_devices/list/" + this.$route.params.req_certificate_software_seq_id);
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.local_device_control_number = ev.node.data.device_control_number;
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.addHtmlClass(document.body, 'blue_bg');
    this.gridOptions.api.sizeColumnsToFit();
    window.sessionStorage.setItem('device_back_to_list', "/certificate_software_linked_devices/select/" + this.$route.params.req_certificate_software_seq_id);
  },
  beforeDestroy: function beforeDestroy() {
    this.removeHtmlClass(document.body, 'blue_bg');
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.api_request_options = { req_seq: this.$route.params.req_certificate_software_seq_id };
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_device_embedded_information_bach_edit_modal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_device_embedded_information_bach_edit_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_device_embedded_information_bach_edit_modal__);












var mdebug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('esma:notification_certificate');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"],
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_14__components_modals_device_embedded_information_bach_edit_modal___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "notification_certificate",
      page_acl: __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default.a.generic,
      detail_page: "page_0040_certificate_software_detail",
      execute_filter_on_back: true,
      link_to_open: "#",
      load_only_with_filter: true,
      page_title: "~"
    };
  },

  computed: {
    pageTitle: {
      get: function get() {
        return this.page_title;
      },
      set: function set(v) {
        this.page_title = v;
      }
    },
    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].registration_date, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].certificate_software_number, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].licensed_department, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_team, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].jurisdiction_classification, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].license_jurisdiction_system, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].effective_number, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].remaining_number, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].expiration_date, { type: __WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["b" /* filed_types */].DATE_PICKER }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].maintenance_deadline, { type: __WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["b" /* filed_types */].DATE_PICKER })];
    },
    tabFieldList2: function tabFieldList2() {
      return [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].certificate_software_number, { tab_label: "証書管理番号" }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].software_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].license, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].expiration_date, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].maintenance_deadline, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_certificate_software__["a" /* fields */].deadline_check, {
        cellRenderer: function cellRenderer(params) {
          if (params.value < 0) {
            return "<span style='color:red';>" + params.value + "</span>";
          } else {
            return params.value;
          }
        }
      })];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    createColumnDefs: function createColumnDefs() {
      var field_list_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "tabFieldList";

      return this.commonCreateColumnDefs({ show_details: false, show_checkbox: false, field_list_name: field_list_name });
    },
    backToList: function backToList() {
      return this.$router.push("/menu/");
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/certificate_information/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    bachEdit: function bachEdit() {
      var p_id = __WEBPACK_IMPORTED_MODULE_3_uuid___default.a.v4();
      var obj = { arr: this.selectedRowArr.map(function (m) {
          return m.seq_id;
        }) };
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set("bulk_edit_" + p_id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj));
      return this.$router.push("/certificate_information/bulk_edit/" + p_id);
    }
  }, "createColumnDefs", function createColumnDefs() {
    return this.commonCreateColumnDefs({ show_details: true, show_checkbox: false });
  }),
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    switch (this.$route.meta.mode) {
      case "certificate_that_expires_in_3_months":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList"));
        this.api_request_options = { filter_mode: "all" };
        this.pageTitle = "3カ月以内に有効期限が切れるライセンス";
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "expiration_date", val: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).format("YYYY/MM/DD") });
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter2", {
          field: "expiration_date",
          val: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).add(90, "days").format("YYYY/MM/DD"),
          cb: function cb() {
            __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilterJoin1", "BETWEEN");
          } });
        break;
      case "certificate_expired_license":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList"));
        this.api_request_options = { filter_mode: "all" };
        this.pageTitle = "有効期限切れライセンス";
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "expiration_date", val: __WEBPACK_IMPORTED_MODULE_4_moment___default()("1999/01/01").format("YYYY/MM/DD") });
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter2", {
          field: "expiration_date",
          val: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).subtract(1, "day").format("YYYY/MM/DD"),
          cb: function cb() {
            __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilterJoin1", "BETWEEN");
          }
        });
        break;
      case "surplus_license_that_expires_in_3_months":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList2"));
        this.api_request_options = { filter_mode: "余剰" };
        this.pageTitle = "3カ月以内に有効期限が切れる余剰ライセンス";
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "expiration_date", val: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).format("YYYY/MM/DD") });
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter2", {
          field: "expiration_date",
          val: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).add(90, "days").format("YYYY/MM/DD"),
          cb: function cb() {
            __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilterJoin1", "BETWEEN");
          } });
        break;
      case "surplus_expired_license":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList2"));
        this.api_request_options = { filter_mode: "余剰" };
        this.pageTitle = "有効期限切れ余剰ライセンス";
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter", { field: "expiration_date", val: __WEBPACK_IMPORTED_MODULE_4_moment___default()("1999/01/01").format("YYYY/MM/DD") });
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilter2", {
          field: "expiration_date",
          val: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).subtract(1, "day").format("YYYY/MM/DD"),
          cb: function cb() {
            __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onOpenPageFilterJoin1", "BETWEEN");
          }
        });
        break;
      default:
        break;
    }
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("onSearchClear", {});
  },
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = { filter_mode: "all" };
    this.initDatasource({ load_only_with_filter: true });
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_belongs",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.master_bel_mak_sys,
      detail_page: "page_0041_master_belongs_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0;
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__["a" /* fields */].department_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__["a" /* fields */].team_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_belongs__["a" /* fields */].team, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/master_belongs/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("deletemailMessageModal", {
        title: "削除",
        message: "部署・チームの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: this.checkUserPermission(true, this.permissionMode.EDIT) });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);









var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_7__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_belongs",
      local_seq_id: -1,
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.master
    };
  },

  computed: {
    localSeqId: {
      get: function get() {
        return this.local_seq_id;
      },
      set: function set(v) {
        this.local_seq_id = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__["a" /* fields */].department_code, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__["a" /* fields */].department, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__["a" /* fields */].team, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_master_belongs__["a" /* fields */].team_code, {})],
        col3: []
      };
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    cloneRecord: function cloneRecord() {
      return this.$router.push({ name: "page_0060_redirect", params: {
          url: "/master_belongs/clone/" + this.localSeqId,
          message: "コピー ...",
          wait: 50
        } });
    },
    onSave: function onSave() {
      var _this = this;

      var field_name_arr = ["department_code", "company", "department", "team", "team_code"];
      this.commonSaveIfNotBlank(this, this.api_name, {}, field_name_arr, function (err, data) {
        if (err == null) {
          return _this.$router.push({ name: "page_0060_redirect", params: {
              url: "/master_belongs/" + data.seq_id,
              message: "登録 ...",
              wait: 50
            } });
        }
      });
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("deleteMasterBelongsModal", {
        title: "削除",
        message: "部署・チームの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_belongs", params: {} });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.loadBy == "clone") {
      this.localSeqId = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.commonLoadRecord({}, function (err, result) {
        setTimeout(function () {
          _this2.$store.state[_this2.stateIsEditingNew] = true;
          _this2.read_only = false;
          _this2.is_new = true;

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result.data).forEach(function (k) {
            var value = result.data[k];
            if (k == "seq_id") {
              _this2.$store.state[_this2.stateCurrentRow][k] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
            } else if (k == "team" || k == "team_code") {
              _this2.$store.state[_this2.stateCurrentRow][k] = "";
              _this2.$store.state[_this2.stateCurrentEditing][k] = "";
            } else {
              _this2.$store.state[_this2.stateCurrentRow][k] = value;
              _this2.$store.state[_this2.stateCurrentEditing][k] = value;
            }
          });
        }, 300);
      });
    } else {
      this.localSeqId = this.$route.params.seq_id;
      this.commonLoadRecord({}, function (err, result) {

        _this2.commonEditDeleteCmdHandler(_this2);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_user",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master_user_password,
      local_read_only: false
    };
  },

  computed: {
    localReadOnly: {
      get: function get() {
        return this.local_read_only;
      },
      set: function set(v) {
        this.local_read_only = v;
      }
    },
    currentPassword: function currentPassword() {
      return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */].current_password, {});
    },
    newPassword: function newPassword() {
      return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */].new_password, {});
    },
    confirmPassword: function confirmPassword() {
      return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */].confirm_password, {});
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_change_password__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {};
    }
  },
  methods: {
    local_show_error: function local_show_error(text) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Error";
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;

      this.$notify({ clean: true });
      this.$notify({
        title: title,
        text: text,
        type: 'error',
        duration: duration
      });
    },
    processChangePassword: function processChangePassword() {
      var _this = this;

      var current_password = this.$store.state[this.stateCurrentEditing]["current_password"];
      var new_password = this.$store.state[this.stateCurrentEditing]["new_password"];
      var confirm_password = this.$store.state[this.stateCurrentEditing]["confirm_password"];
      if (new_password != confirm_password) {
        return this.local_show_error("新しいパスワードと新しいパスワード(確認)は同じ必要があります。");
      }
      if (new_password == current_password) {
        return this.local_show_error("新しいパスワードと現在のパスワードは違う必要があります。");
      }
      if (new_password == "") {
        return this.local_show_error("新しいパスワードが空白です。");
      }
      if (current_password == "") {
        return this.local_show_error("現在のパスワードが空白です。");
      }

      var ops = {
        current_password: current_password,
        new_password: new_password,
        confirm_password: confirm_password
      };
      this.$ajax.post('/' + this.api_name + '/change_password/', ops, function (err, result) {
        if (result.success == true && err == null) {
          _this.$notify({
            title: "パスワードが変更されました。",
            type: 'success',
            duration: 5000
          });
          _this.clearFields();
        } else {
          return _this.local_show_error(err || "Operation failed");
        }
      });
    },
    clearFields: function clearFields() {
      var _this2 = this;

      var form_fields = ["current_password", "new_password", "confirm_password"];
      form_fields.forEach(function (f) {
        _this2.$store.state[_this2.stateCurrentEditing] = {};
        _this2.$store.state[_this2.stateCurrentEditing][f] = "*";
        _this2.$store.state[_this2.stateCurrentRow][f] = "";
        _this2.$store.state[_this2.stateCurrentEditing][f] = "";
      });
      this.localReadOnly = true;
      setTimeout(function () {
        _this2.localReadOnly = false;
      }, 100);
    },
    backToList: function backToList() {
      return this.$router.push({ name: "menu_master", params: {} });
    }
  },
  mounted: function mounted() {
    this.clearFields();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.clearFields();
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);









var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:master_user');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_4__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_company",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.maintenance,
      detail_page: "page_0041_master_company_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["a" /* fields */].company_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["a" /* fields */].company_name, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/master_company/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onDelete: function onDelete() {
      if (this.selected_row > -1) {
        return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "delete" } });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_company",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.maintenance
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["a" /* fields */].company_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_company__["a" /* fields */].company_name, {})]
      };
    }
  },
  methods: {
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteMasterCompanyModal", {
        title: "削除",
        message: "会社の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_company", params: {} });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_comprehensive_contract",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      detail_page: "page_0041_master_comprehensive_contract_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */].comprehensive_contract_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */].comprehensive_contract_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */].maker_name, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/master_comprehensive_contract/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onDelete: function onDelete() {
      if (this.selected_row > -1) {
        return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "delete" } });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_comprehensive_contract",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */].comprehensive_contract_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */].comprehensive_contract_name, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_comprehensive_contract__["a" /* fields */].maker_name, {})],
        col3: []
      };
    }
  },
  methods: {
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteMasterComprehensiveContractModal", {
        title: "削除",
        message: "包括契約の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_comprehensive_contract", params: {} });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "master_inventory_reporting_period",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.master,
      detail_page: "page_0041_master_inventory_reporting_period_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0;
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].reporting_period, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].expiration_date_start, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].expiration_date_end, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].last_reporting_period, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].editable, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("deletemailMessageModal", {
        title: "削除",
        message: "棚卸報告年度区分の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile: function initExportFile() {},
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_inventory_reporting_period",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].reporting_period, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].expiration_date_start, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].expiration_date_end, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].last_reporting_period, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_inventory_reporting_period__["a" /* fields */].editable, {})],
        col2: [],
        col3: []
      };
    }
  },
  methods: {
    onSave: function onSave() {
      var _this = this;

      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        _this.read_only = false;
        _this.commonSaveInfo(_this, _this.api_name, {});
      });
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteMasterInventoryReportingPeriodModal", {
        title: "削除",
        message: "棚卸報告年度区分の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_inventory_reporting_period", params: {} });
    },
    loadReportingPeriodList: function loadReportingPeriodList() {
      var _this2 = this;

      this.$ajax.post("/" + this.api_name + "/get_reporting_period_list", {}, function (err, data) {
        data.forEach(function (d) {
          _this2.reportingPeriodList.push(d.reporting_period);
        });
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.commonLoadRecord({}, function (err, result) {
      _this3.commonEditDeleteCmdHandler(_this3);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_maker",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.master_bel_mak_sys,
      detail_page: "page_0041_master_maker_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0;
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["a" /* fields */].esma_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["a" /* fields */].maker_name, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/master_maker/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("deletemailMessageModal", {
        title: "削除",
        message: "メーカの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: this.checkUserPermission(true, this.permissionMode.EDIT) });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_maker",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["a" /* fields */].esma_code, { force_readonly: true }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_maker__["a" /* fields */].maker_name, {})],
        col2: [],
        col3: []
      };
    }
  },
  methods: {
    onSave: function onSave() {

      var field_name_arr = ["maker_name"];
      this.commonSaveIfNotBlank(this, this.api_name, {}, field_name_arr);
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteMasterMakerModal", {
        title: "削除",
        message: "メーカの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_maker", params: {} });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_software",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.master_bel_mak_sys,
      detail_page: "page_0041_master_software_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0;
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].software_category, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].esma_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].software_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].maker_name, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("deletemailMessageModal", {
        title: "削除",
        message: "ソフトウェアの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/master_software/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: this.checkUserPermission(true, this.permissionMode.EDIT) });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "master_software_category",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.generic,
      detail_page: "page_0041_master_software_category_detail",
      execute_filter_on_back: true
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["a" /* fields */].category, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["a" /* fields */].category_name, {})];
    }
  },
  methods: {
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onDelete: function onDelete() {
      if (this.selected_row > -1) {
        return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "delete" } });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_software_category",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["a" /* fields */].category, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software_category__["a" /* fields */].category_name, {})]
      };
    }
  },
  methods: {
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteMasterSoftwareCategoryModal", {
        title: "抹消",
        message: "ソフトウェアカテゴリの抹消をしますがよろしいでしょうか?",
        yes_label: "抹消",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_software_category", params: {} });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_software",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].esma_code, { force_readonly: true }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].software_name, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].software_category, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_software__["a" /* fields */].maker_name, {})],
        col3: []
      };
    }
  },
  methods: {
    onSave: function onSave() {
      var field_name_arr = ["software_category", "software_name", "maker_name"];
      this.commonSaveIfNotBlank(this, this.api_name, {}, field_name_arr);
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteMasterSoftwareModal", {
        title: "削除",
        message: "ソフトウェアの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_software", params: {} });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_system",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.master_bel_mak_sys,
      detail_page: "page_0041_master_system_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0;
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].system_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].system_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].equipment_in_charge_department, {
        api: "/master_system/list_system_departments_and_teams",
        api_field_name: "department"
      }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].system_jurisdiction_team, {
        api: "/master_system/list_system_departments_and_teams",
        api_field_name: "team"
      })];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("deletemailMessageModal", {
        title: "削除",
        message: "システムの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/master_system/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: this.checkUserPermission(true, this.permissionMode.EDIT) });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_system",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].system_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].system_name, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_system__["a" /* fields */].system_jurisdiction_team, {})],
        col3: []
      };
    }
  },
  methods: {
    onSave: function onSave() {
      var field_name_arr = ["system_code", "system_name", "company", "equipment_in_charge_department", "system_jurisdiction_team"];
      this.commonSaveIfNotBlank(this, this.api_name, {}, field_name_arr);
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.startCompanySelection();
      this.commonOnEdit();
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("deleteMasterSystemModal", {
        title: "削除",
        message: "システムの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_system", params: {} });
    },
    prepareCompanySelection: function prepareCompanySelection(companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name) {
      var _this = this;

      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true
            });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true
            });
          }
        }
      });
      company_field.page_controller_msg({
        cmd: "set_options",
        options: _.clone(companies)
      });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });

        selected_company = _this.$store.state[_this.stateCurrentRow][company_field.id];
        selected_department = _this.$store.state[_this.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({
            cmd: "set_options",
            options: departments,
            reset: false
          });
          department_field.page_controller_msg({ cmd: "enable" });
          if (selected_department && selected_department.length > 0) {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: false
            });
          }
        }

        if (_this.isSurplus) {
          setTimeout(function () {
            department_field.page_controller_msg({ cmd: "enable" });
          }, 500);
        }
      }, this.is_new ? 100 : 500);
    },
    startCompanySelection: function startCompanySelection() {
      var _this2 = this;

      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;

        this.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
          if (err) {
            _this2.$notify({
              title: "所管会社のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          }
          var companies = [""];
          _companies.forEach(function (c) {
            companies.push(c.val);
          });

          _this2.$ajax.post_cached_queued("/master_belongs/list_team_and_department", {}, function (err, department_and_team) {
            if (err) {
              _this2.$notify({
                title: "部署・チームのデータの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              return;
            }
            _this2.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.equipment_in_charge_department, temp_fields.system_jurisdiction_team, "company", "department");
            if (_this2.$route.params.seq_id == "new") {
              var default_company = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.company.default_from_local_storage);
              if (default_company != __WEBPACK_IMPORTED_MODULE_9__rules_constants___default.a.COMPANY.ALL) {
                setTimeout(function () {
                  var default_deparment = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.equipment_in_charge_department.default_from_local_storage);
                  var default_team = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.system_jurisdiction_team.default_from_local_storage);
                  temp_fields.company.page_controller_msg({
                    cmd: "set_value",
                    val: default_company
                  });
                  temp_fields.equipment_in_charge_department.page_controller_msg({
                    cmd: "set_value",
                    val: default_deparment
                  });
                  temp_fields.system_jurisdiction_team.page_controller_msg({ cmd: "set_value", val: default_team });
                }, _this2.is_new ? 300 : 1000);
              }
            }
          });
        });
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.$route.params.seq_id == "new") {
      setTimeout(function () {
        _this3.startCompanySelection();
      }, 10);
    }
    this.commonLoadRecord({}, function (err, result) {
      _this3.commonEditDeleteCmdHandler(_this3);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__);











var mdebug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('esma:master_user');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_4_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_user",
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.master_user,
      execute_filter_on_back: true,
      link_to_open: "#",
      select_all: false,
      local_batch_edit_disabled: false,
      red_error_msg: ""
    };
  },

  computed: {
    redErrorMsg: {
      get: function get() {
        return this.red_error_msg;
      },
      set: function set(v) {
        this.red_error_msg = v;
      }
    },
    localBatchEditDisabled: {
      get: function get() {
        return this.local_batch_edit_disabled;
      },
      set: function set(v) {
        this.local_batch_edit_disabled = v;
      }
    },
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0;
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },

    checkBoxSelectAll: {
      get: function get() {
        return this.select_all;
      },
      set: function set(v) {
        this.select_all = v;
      }
    },
    approveMode: {
      get: function get() {
        return this.approve_mode;
      },
      set: function set(v) {
        this.approve_mode = v;
      }
    },
    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */].status, {}), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */].user_id, {}), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */].user_shimei, {}), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */].role, {}), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_6__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_master_user__["a" /* fields */].team, {})];
    }
  },
  methods: {
    onArraySelected: function onArraySelected(obj) {
      var has_multiple = _.find(this.selectedRowArr, function (d) {
        return d.has_multiple == true;
      });
      var has_multiple = _.find(this.selectedRowArr, function (d) {
        return d.has_multiple == true;
      });
      if (has_multiple) {
        this.localBatchEditDisabled = true;
      } else {
        var group_company = _.groupBy(this.selectedRowArr, function (d) {
          return d.company + "/" + d.department;
        });
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(group_company).length > 1) {
          this.localBatchEditDisabled = true;
        } else {
          this.localBatchEditDisabled = false;
          this.redErrorMsg = "";
        }
      }
    },
    allChecked: function allChecked(a, b) {
      this.commonAllChecked("showInformationIconModalMasterUser");
    },
    hideCheckBox: function hideCheckBox(data) {
      return false;
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/master_user/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    bachEdit: function bachEdit() {
      var _this = this;

      this.$notify({ clean: true });
      var group_company = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_.groupBy(this.selectedRowArr, function (d) {
        return d.company;
      }));
      if (group_company.length > 1) {
        this.redErrorMsg = '*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。';

        return;
      } else {
        var has_multiple = _.find(this.selectedRowArr, function (d) {
          return d.has_multiple == true;
        });
        if (has_multiple) {
          this.redErrorMsg = '*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。';

          return;
        }
      }
      var p_id = __WEBPACK_IMPORTED_MODULE_3_uuid___default.a.v4();
      var obj = { company: group_company[0], arr: this.selectedRowArr.map(function (m) {
          return m.seq_id;
        }) };
      this.$ajax.post('/master_user/check_user_in_charge_for_approval/', { obj: obj }, function (err, result) {
        if (err) {
          _this.$notify({
            title: 'Failed to check user data',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          if (result && result.found_user_in_charge_for_approval) {
            _this.$notify({
              title: 'このユーザーは申請中の申請ルートに含まれているため編集・一括編集できません',
              type: 'error',
              duration: 10000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.set("bulk_edit_" + p_id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return _this.$router.push("/master_user/bulk_edit/" + p_id);
          }
        }
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("deleteUsernModal", {
        title: "削除",
        message: "ユーザ一の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: "page_0041_master_user_detail", params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: "page_0041_master_user_detail", params: { seq_id: "new" } });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0041_master_user_detail", params: { seq_id: data.seq_id } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true, force_sort: { id: "department", direction: "asc" } });
    }
  },
  mounted: function mounted() {
    window.sessionStorage.setItem('user_back_to_list', this.$route.fullPath);
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {
      rowSelection: false
    });
    this.initDatasource();
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_bus__ = __webpack_require__(4);











var mdebug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_9__components_form_field___default.a,
    'application-confirmation-modal': __WEBPACK_IMPORTED_MODULE_11__components_modals_application_confirmation_modal___default.a
  },
  data: function data() {
    return {
      api_name: "master_user",
      page_acl: __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default.a.master_user_detail,
      local_seq_id: -1,
      approval_history_id: "",
      read_only_2: false,
      read_only_3: false,
      local_company: false,
      local_company_1: false,
      local_company_2: false,
      disabled_to_save: false,
      current_user_role: "",
      cacheched_form_list: false,
      original_loaded_data: {},
      local_authority_cache: {},
      user_id: "",
      local_department_and_team: []
    };
  },

  computed: {
    userId: {
      get: function get() {
        return this.user_id;
      },
      set: function set(v) {
        this.user_id = v;
      }
    },
    currentUserRole: {
      get: function get() {
        return this.current_user_role;
      },
      set: function set(v) {
        this.current_user_role = v;
      }
    },
    disabledToSave: {
      get: function get() {
        return this.disabled_to_save;
      },
      set: function set(v) {
        this.disabled_to_save = v;
      }
    },
    readOnly2: {
      get: function get() {
        return this.read_only_2;
      },
      set: function set(v) {
        this.read_only_2 = v;
      }
    },
    readOnly3: {
      get: function get() {
        return this.read_only_3;
      },
      set: function set(v) {
        this.read_only_3 = v;
      }
    },
    userInChargeForApproval: function userInChargeForApproval() {
      return this.$store.state[this.stateCurrentRow].user_in_charge_for_approval > 0 || false;
    },
    disableDeleteBtn: function disableDeleteBtn() {
      return this.userInChargeForApproval;
    },
    disableEditMainBtn: function disableEditMainBtn() {
      return false;
    },
    hideDeleteBtn: function hideDeleteBtn() {
      return this.hideForApplicant || this.loadBy == 'fk_id';
    },
    hideEditMainBtn: function hideEditMainBtn() {
      return this.hideForApplicant || this.loadBy == 'fk_id';
    },
    isAdminSavingApplication: function isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    disableApplicationBtn: function disableApplicationBtn() {
      return this.approvalStatus != "下書中";
    },
    hideApplicationBtn: function hideApplicationBtn() {
      return this.loadBy == 'fk_id';
    },
    hideApplyRejectBtn: function hideApplyRejectBtn() {
      return this.loadBy != 'fk_id';
    },
    hideApplyConfirmationBtn: function hideApplyConfirmationBtn() {
      if (this.loadBy != 'fk_id') {
        return true;
      }
      return this.hideForApplicant;
    },
    hideForApplicant: function hideForApplicant() {
      if (this.loadBy != 'fk_id') {
        return false;
      }
      if (typeof this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] == "undefined" && this.isAdmin == true) {
        return false;
      } else {
        return this.$store.state[this.stateCurrentRow]["approval_history_applicant"] == this.userId && this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] != this.userId;
      }
    },
    showFieldchangedStyle: function showFieldchangedStyle() {
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" || this.$store.state[this.stateCurrentRow]["approval_status"] == "差戻") && (this.isAdmin || this.$store.state[this.stateCurrentRow]["approval_history_next_approver"]);
    },

    localSeqId: {
      get: function get() {
        return this.local_seq_id;
      },
      set: function set(v) {
        this.local_seq_id = v;
      }
    },
    Status: {
      get: function get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["status"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    Password: {
      get: function get() {
        if (this.local_password === false) {
          return this.$store.state[this.stateCurrentEditing]["password"] || "";
        } else {
          return this.local_password;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["password"] = this.local_password = v;
      }
    },
    loginFailureCount: {
      get: function get() {
        if (this.local_login_failure_count === false) {
          return this.$store.state[this.stateCurrentEditing]["login_failure_count"] || "";
        } else {
          return this.local_login_failure_count;
        }
      },
      set: function set(v) {
        this.$store.state[this.stateCurrentRow]["login_failure_count"] = this.local_login_failure_count = v;
      }
    },
    approvalStatus: function approvalStatus() {
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"];
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["b" /* filed_types */];
    },
    rolesList: function rolesList() {
      if (__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].if_null(this.currentUserRole, "") == "") {
        this.currentUserRole = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      }
      if (this.currentUserRole == "保守担当") {
        return ["ユーザIDオペレーション担当者", "管理担当者", "管理責任者", "システム管理者", "保守担当"];
      } else if (this.currentUserRole == "システム管理者") {
        return ["ユーザIDオペレーション担当者", "管理担当者", "管理責任者", "システム管理者"];
      } else {
        return ["ユーザIDオペレーション担当者", "管理担当者", "管理責任者"];
      }
    },
    formFields: function formFields() {
      if (this.cacheched_form_list != false) {
        return this.cacheched_form_list;
      } else {
        var r = {
          col1: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].user_id, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].user_shimei, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].role), { options: this.rolesList, emit_input: true }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].company, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].team, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].last_login_date, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].password, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].mail_address, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].login_failure_count, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].status, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].last_password_changed_date, {})],
          col2_head: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].authority_1, {})],
          col2: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].company_1, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].role_1), {
            options: this.rolesList,
            listen_for: [{
              name: "main_role_update1",
              mode: "select_and_set_only"
            }]
          }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].department_1, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].team_1, {})],
          col3_head: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].authority_2, {})],
          col3: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].company_2, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].role_2), {
            options: this.rolesList,
            listen_for: [{
              name: "main_role_update2",
              mode: "select_and_set_only"
            }]
          }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].department_2, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].team_2, {})]
        };
        this.cacheched_form_list = r;
        return r;
      }
    },


    approvalHistoryId: {
      get: function get() {
        return this.approval_history_id;
      },
      set: function set(v) {
        this.approval_history_id = v;
      }
    },
    loadBy: function loadBy() {
      return this.$route.meta.load_by;
    }
  },
  methods: {
    onPreSetDefaultPassword: function onPreSetDefaultPassword() {
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("confirmSetDefaultPassword", {
        message: "パスワードを初期化しますがよろしいでしょうか？",
        title: "",
        yes_label: "OK",
        no_label: "キャンセル",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onSetDefaultPassword: function onSetDefaultPassword(mode) {
      var _this = this;

      if (mode == "yes") {
        this.$store.state[this.stateCurrentEditing].password = "mizuho01";
        this.$store.state[this.stateCurrentRow].password = "mizuho01";
        this.Password = "mizuho01";
        this.Status = "1";
        this.loginFailureCount = 0;
        setTimeout(function () {
          _this.onSave();
        }, 100);
      }
    },
    showColumns2and3: function showColumns2and3() {
      var role = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
      return role == "保守担当" || role == "システム管理者" || role == "ユーザIDオペレーション担当者";
    },
    dataUpdated: function dataUpdated(obj) {
      var c1 = this.$store.state[this.stateCurrentEditing].company || this.$store.state[this.stateCurrentRow].company || "";
      var c2 = this.$store.state[this.stateCurrentEditing].company_1 || this.$store.state[this.stateCurrentRow].company_1 || "";
      var c3 = this.$store.state[this.stateCurrentEditing].company_2 || this.$store.state[this.stateCurrentRow].company_2 || "";

      if (obj.field == "role") {
        var a2 = this.$store.state[this.stateCurrentEditing].authority_1 || this.$store.state[this.stateCurrentRow].authority_1 || 0;
        var a3 = this.$store.state[this.stateCurrentEditing].authority_2 || this.$store.state[this.stateCurrentRow].authority_2 || 0;
        var r2 = this.$store.state[this.stateCurrentEditing].role_1 || this.$store.state[this.stateCurrentRow].role_1 || "";
        var r3 = this.$store.state[this.stateCurrentEditing].role_2 || this.$store.state[this.stateCurrentRow].role_2 || "";
        var s1 = c2.length > 0 || a2 > 0 || r2.length > 0;
        var s2 = c3.length > 0 || a3 > 0 || r3.length > 0;
        __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update1", { allow: [obj.val], disable: false, select: s1 });
        __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update2", { allow: [obj.val], disable: false, select: s2 });
      } else if (obj.field == "company" || obj.field == "company_1" || obj.field == "company_2") {

        if (obj.field == "company") {
          c1 = obj.val;
        }
        if (obj.field == "company_1") {
          c2 = obj.val;
        }
        if (obj.field == "company_2") {
          c3 = obj.val;
        }
        var err_id = "";
        var is_err = false;
        if (c1 == c2 && c1 != "" && c1 != null) {
          err_id = c1;
          is_err = true;
        } else if (c1 == c3 && c1 != "" && c1 != null) {
          err_id = c1;
          is_err = true;
        } else if (c2 == c3 && c2 != "" && c2 != null) {
          err_id = c2;
          is_err = true;
        }
        if (is_err == true) {
          this.disabledToSave = true;
          this.$notify({
            title: '所属会社は同一会社を選択できません。',
            text: "所属会社" + err_id + " が複数の場所で選択されています。",
            type: 'error',
            duration: 10000
          });
        } else {
          this.$notify({ clean: true });
          this.disabledToSave = false;
        }
      }
    },
    afterTheNotificationAftercancel: function afterTheNotificationAftercancel(mode) {
      var _this2 = this;

      if (mode == "no") {
        setTimeout(function () {
          return _this2.$router.push("/id_approval_history");
        }, 600);
        console.log("afterTheNotificationAftercancel");
      }
    },
    processApprovalCancelBack: function processApprovalCancelBack(mode) {
      if (mode == "yes") {
        console.log("processApprovalCancelBack", mode);
        this.processApproval('cancel');
        this.local_status = false;
      }
    },
    processApprovalCancel: function processApprovalCancel() {
      console.log("process ApprovalCancel");
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("confirmUserAddcancel", {
        message: "よろしいですか？",
        title: "申請を差戻します。",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    processApprovalApprove: function processApprovalApprove() {
      return this.processApproval('approve');
    },
    processApproval: function processApproval(approve_mode) {
      var _this3 = this;

      var changes = {
        seq_id: this.aprovalId,
        update_time: __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss")
      };
      this.$ajax.post('/id_approval_history/prepare_to_approve/' + this.aprovalId, { changes: changes, approve_mode: approve_mode }, function (err, result) {
        if (err) {
          _this3.$notify({
            title: 'データの承認に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("notificationAfterUserCancel", {
            message: "",
            title: "動作が完了しました。",
            yes_label: "",
            no_label: "OK",
            yes_color: "",
            no_color: "",
            model_height: "50"
          });
        }
      });
    },
    processFieldStyle: function processFieldStyle(store_key_name, last_changed_fields) {
      var _this4 = this;

      this.$store.state[store_key_name] = {};
      if (last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0) {
        last_changed_fields.forEach(function (f) {
          if (_this4.showFieldchangedStyle) {
            _this4.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },
    onConfirmExecuteProcessConfirmation: function onConfirmExecuteProcessConfirmation() {
      var dcn = this.deviceControlNumber;
      if ((typeof dcn === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(dcn)) == undefined || dcn == null || dcn == false || dcn.length == 0) {
        dcn = "BY_SEQ_ID::" + this.localSeqId;
      }

      var application_obj = {
        application_mode: "user",
        ref_id: dcn,
        modal_is_read_only: true,
        seq_id: this.localSeqId,
        approval_history_id: this.approvalHistoryId || false
      };
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("userApplicationConfimationModal", application_obj);
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      var dcn = this.deviceControlNumber;
      if ((typeof dcn === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(dcn)) == undefined || dcn == null || dcn == false || dcn.length == 0) {
        dcn = "BY_SEQ_ID::" + this.localSeqId;
      }
      var application_obj = {
        application_mode: "user",
        ref_id: dcn,

        seq_id: this.localSeqId,
        approval_history_id: this.approvalHistoryId || false
      };
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("userApplicationConfimationModal", application_obj);
    },
    onSave: function onSave() {
      var _this5 = this;

      var pre_defined_errors = [];
      if (this.$route.params.seq_id == "new") {
        var password = this.$store.state[this.stateCurrentEditing].password;
        if (__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].if_null(password, "") == "") {
          pre_defined_errors.push(__WEBPACK_IMPORTED_MODULE_6__rules_fields_master_user__["a" /* fields */].password);
        }
      }
      this.commonValidateFields(this, { pre_defined_errors: pre_defined_errors }, function (error_found) {
        if (error_found != false) {
          return;
        }
        var user_id = _this5.$store.state[_this5.stateCurrentEditing].user_id || _this5.$store.state[_this5.stateCurrentRow].user_id;
        var password = _this5.$store.state[_this5.stateCurrentEditing].password || _this5.$store.state[_this5.stateCurrentRow].password;
        var mail_address = _this5.$store.state[_this5.stateCurrentEditing].mail_address || _this5.$store.state[_this5.stateCurrentRow].mail_address;
        _this5.$notify({ clean: true });
        if (_this5.userInChargeForApproval == true && _this5.original_loaded_data) {
          var has_error = false;
          var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this5.original_loaded_data);
          keys.forEach(function (k) {
            if (typeof _this5.$store.state[_this5.stateCurrentEditing][k] != "undefined") {
              if (k == "password" || k == "status") {} else if (_this5.$store.state[_this5.stateCurrentEditing][k] != _this5.original_loaded_data[k]) {
                has_error = true;
              }
            }
          });
          if (has_error == true) {
            _this5.$notify({ title: "このユーザーは申請中の申請ルートに含まれているため編集・一括編集できません", text: "", type: "error", duration: 10000 });
            return;
          }
        }
        if (user_id && user_id.length > 0 && !user_id.match(/^[\.\-0-9a-zA-Z]+$/)) {
          _this5.$notify({ title: "ユーザID　は英数字のみを使用してください。", text: "", type: "error", duration: 10000 });
          return;
        }
        if (password && password.length > 0 && password.indexOf("**") < 0 && !password.match(/^[\.\-0-9a-zA-Z]+$/)) {
          _this5.$notify({ title: "パスワード　は英数字のみを使用してください。", text: "", type: "error", duration: 10000 });
          return;
        }
        if (mail_address && mail_address.length > 0 && !mail_address.match(/^[\@\.\-0-9a-zA-Z]+$/)) {
          _this5.$notify({ title: "メールアドレス　は英数字のみを使用してください。", text: "", type: "error", duration: 10000 });
          return;
        }
        _this5.read_only = false;
        _this5.commonSaveInfo(_this5, _this5.api_name, {}, function (err, saved_data) {
          _this5.local_authority_cache = {};
          return _this5.$router.push("/master_user/" + saved_data.seq_id);
        });
      });
    },
    onDeviceEmbeddedInformationAddCheckConfirm: function onDeviceEmbeddedInformationAddCheckConfirm(mode) {
      var _this6 = this;

      if (mode == "yes") {
        console.log("onDeviceEmbeddedInformationAddCheckConfirm", mode);
        this.read_only = false;
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        this.commonSaveInfo(this, this.api_name, { from_edit_form: true }, function (err, saved_data) {
          if (err) {} else {
            if (saved_data && typeof _this6.localSeqId != "undefined") {
              if (_this6.$store.state[_this6.stateCurrentRow].seq_id == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a) {
                if (typeof saved_data.seq_id != "undefined" && saved_data.seq_id != __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a) {
                  _this6.localSeqId = saved_data.seq_id;
                }
              } else if (_this6.$store.state[_this6.stateCurrentRow].seq_id < _this6.localSeqId && _this6.localSeqId == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a) {
                _this6.localSeqId = _this6.$store.state[_this6.stateCurrentRow].seq_id;
              }
            }

            __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("notificationAfterSave", {
              message: "",
              title: "登録情報を下書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "",
              model_height: "50"
            });
          }
        });
      }
    },
    afterTheNotificationAfterSave: function afterTheNotificationAfterSave(mode) {
      if (mode == "no" || mode == "yes") {
        return this.$router.push("/master_user/" + this.localSeqId);
      }
    },
    btnCancel: function btnCancel() {
      this.commonValidateFieldsClear(this, function () {});
      this.cancelCurrentSelection(true);
    },
    onEdit: function onEdit() {
      var _this7 = this;

      this.$notify({ clean: true });
      if (this.userId == this.$store.state[this.stateCurrentRow]["user_id"]) {
        if (__WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole") == "ユーザIDオペレーション担当者") {
          this.$notify({
            title: "自分のIDは編集できません。",
            type: 'error',
            duration: 10000
          });
          return;
        }
      }
      this.$ajax.post('/' + this.api_name + '/check_can_edit/' + this.localSeqId, {}, function (err, result) {
        if (err) {
          _this7.$notify({
            title: err.replace("::", ""),
            type: 'error',
            duration: 10000
          });
        } else {
          var temp_fields = _this7.installedFieldList;
          var allowed_companies = [];
          _this7.local_department_and_team.forEach(function (item) {
            if (item.company) {
              allowed_companies.push({
                company: item.company,
                department: item.department,
                team: item.team,
                user_company_seq: item.user_company_seq
              });
            }
          });
          if (_this7.isMultiCompanyAdmin == false) {
            var base_control_cmd = "disable";
            var a0_control_cmd = "disable";
            var a1_control_cmd = "disable";
            var a2_control_cmd = "disable";
            var company = _this7.$store.state[_this7.stateCurrentRow]["company"];
            var department = _this7.$store.state[_this7.stateCurrentRow]["department"];
            var company_1 = _this7.$store.state[_this7.stateCurrentRow]["company_1"];
            var department_1 = _this7.$store.state[_this7.stateCurrentRow]["department_1"];
            var authority_1 = _this7.$store.state[_this7.stateCurrentRow]["authority_1"];
            var company_2 = _this7.$store.state[_this7.stateCurrentRow]["company_2"];
            var department_2 = _this7.$store.state[_this7.stateCurrentRow]["department_2"];
            var authority_2 = _this7.$store.state[_this7.stateCurrentRow]["authority_2"];
            var allow_0 = _.find(allowed_companies, function (a) {
              return a.company == company && a.department == department;
            }) || false;
            var allow_1 = _.find(allowed_companies, function (a) {
              return a.company == company_1 && a.department == department_1;
            }) || department_1 == null || department_1 == '' || false;
            var allow_2 = _.find(allowed_companies, function (a) {
              return a.company == company_2 && a.department == department_2;
            }) || department_2 == null || department_2 == '' || false;

            var operator_main_company = _.find(allowed_companies, function (a) {
              return a.user_company_seq == 0;
            }) || false;
            if (operator_main_company) {
              operator_main_company = operator_main_company.company;
            }
            var operator_other_companies = [];
            if (operator_main_company != false) {
              allowed_companies.forEach(function (item) {
                if (item.company != operator_main_company && operator_other_companies.indexOf(item.company) == -1) {
                  operator_other_companies.push(item.company);
                }
              });
            }
            if (allow_0) {
              base_control_cmd = "enable";
              a0_control_cmd = "enable";
            }
            if (allow_1) {
              a1_control_cmd = "enable";
            }
            if (allow_2) {
              a2_control_cmd = "enable";
            }

            temp_fields.user_id.page_controller_msg({ cmd: base_control_cmd });
            temp_fields.user_shimei.page_controller_msg({ cmd: base_control_cmd });
            temp_fields.status.page_controller_msg({ cmd: base_control_cmd });
            temp_fields.mail_address.page_controller_msg({ cmd: base_control_cmd });

            temp_fields.team.page_controller_msg({ cmd: a0_control_cmd });
            temp_fields.department.page_controller_msg({ cmd: a0_control_cmd });
            temp_fields.company.page_controller_msg({ cmd: a0_control_cmd });
            temp_fields.role.page_controller_msg({ cmd: a0_control_cmd });

            temp_fields.team_1.page_controller_msg({ cmd: a1_control_cmd });
            temp_fields.department_1.page_controller_msg({ cmd: a1_control_cmd });
            temp_fields.company_1.page_controller_msg({ cmd: a1_control_cmd });
            temp_fields.role_1.page_controller_msg({ cmd: a1_control_cmd });
            temp_fields.authority_1.page_controller_msg({ cmd: a1_control_cmd });

            temp_fields.team_2.page_controller_msg({ cmd: a2_control_cmd });
            temp_fields.department_2.page_controller_msg({ cmd: a2_control_cmd });
            temp_fields.company_2.page_controller_msg({ cmd: a2_control_cmd });
            temp_fields.role_2.page_controller_msg({ cmd: a2_control_cmd });
            temp_fields.authority_2.page_controller_msg({ cmd: a2_control_cmd });
          }

          _this7.commonOnEdit();
        }
      });
    },
    backToList: function backToList() {
      var user_back_to_list = window.sessionStorage.getItem("user_back_to_list");
      if (this.loadBy == "fk_id") {
        return this.$router.push({ name: "page_0050_id_approval_history", params: {} });
      } else if ((user_back_to_list || "").indexOf("/") == 0) {
        return this.$router.push(user_back_to_list);
      } else {
        return this.$router.push({ name: "page_0041_master_user", params: {} });
      }
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    onDelete: function onDelete() {
      this.$notify({ clean: true });
      if (this.userId == this.$store.state[this.stateCurrentRow]["user_id"]) {
        this.$notify({
          title: "自分のIDは削除できません。",
          type: 'error',
          duration: 10000
        });
        return;
      }
      __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("deleteMasterUserDetailModal", {
        title: "削除",
        message: "ユーザの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    prepareCompanySelection: function prepareCompanySelection(companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name) {
      var _this8 = this;

      var selected_company = false;
      var selected_department = false;

      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: true });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: true });
          }
        }
      });
      company_field.page_controller_msg({ cmd: "set_options", options: _.clone(companies) });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });
        selected_company = _this8.$store.state[_this8.stateCurrentRow][company_field.id];
        selected_department = _this8.$store.state[_this8.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          department_field.page_controller_msg({ cmd: "enable" });
          var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: false });
          if (selected_department && selected_department.length > 0) {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: false });
          }
        }
      }, 500);
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    this.userId = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userID") || "";

    if (true) {
      var temp_fields = this.installedFieldList;

      this.$ajax.post_cached_queued('/master_company/list_company_name_for_user_control', {}, function (err, _companies) {
        if (err) {
          _this9.$notify({
            title: '所属会社　が読み込めませんでした。',
            text: err,
            type: 'error',
            duration: 10000
          });
          return;
        }
        var companies = [""];
        _companies.forEach(function (c) {
          companies.push(c.val);
        });

        _this9.$ajax.post_cached_queued('/master_belongs/list_department_for_user_control', {}, function (err, department_and_team) {
          if (err) {
            _this9.$notify({
              title: '部署・チームのデータが読み込めませんでした。',
              text: err,
              type: 'error',
              duration: 10000
            });
            return;
          }
          _this9.local_department_and_team = department_and_team;
          _this9.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.department, temp_fields.team, "company", "department");
          _this9.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company_1, temp_fields.department_1, temp_fields.team_1, "company_1", "department_1");
          _this9.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company_2, temp_fields.department_2, temp_fields.team_2, "company_2", "department_2");
        });
      });
    }

    this.local_authority_cache = {};
    this.currentUserRole = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].localStorage.get("userRole");
    __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$off("authority_1_selected").$on("authority_1_selected", function (new_value) {
      _this9.readOnly2 = new_value == 0;
      var disable_fields = ["company_1", "role_1", "department_1", "team_1"];
      disable_fields.forEach(function (f) {
        if (_this9.readOnly2 == true) {
          _this9.local_authority_cache[f] = _this9.$store.state[_this9.stateCurrentEditing][f] || _this9.$store.state[_this9.stateCurrentRow][f] || "";
          _this9.$store.state[_this9.stateCurrentEditing][f] = "";
          _this9.$store.state[_this9.stateCurrentRow][f] = "";
        } else {
          if (_this9.local_authority_cache[f]) {
            _this9.$store.state[_this9.stateCurrentEditing][f] = _this9.local_authority_cache[f];
            _this9.$store.state[_this9.stateCurrentRow][f] = _this9.local_authority_cache[f];
            delete _this9.local_authority_cache[f];
          }
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$off("authority_2_selected").$on("authority_2_selected", function (new_value) {
      _this9.readOnly3 = new_value == 0;
      var disable_fields = ["company_2", "role_2", "department_2", "team_2"];
      disable_fields.forEach(function (f) {
        if (_this9.readOnly3 == true) {
          _this9.local_authority_cache[f] = _this9.$store.state[_this9.stateCurrentEditing][f] || _this9.$store.state[_this9.stateCurrentRow][f] || "";
          _this9.$store.state[_this9.stateCurrentEditing][f] = "";
          _this9.$store.state[_this9.stateCurrentRow][f] = "";
        } else {
          if (_this9.local_authority_cache[f]) {
            _this9.$store.state[_this9.stateCurrentEditing][f] = _this9.local_authority_cache[f];
            _this9.$store.state[_this9.stateCurrentRow][f] = _this9.local_authority_cache[f];
            delete _this9.local_authority_cache[f];
          }
        }
      });
    });

    if (this.loadBy == "fk_id") {
      this.is_new = false;
      this.localSeqId = this.$route.params.fk_id;
      this.aprovalId = this.$route.params.approval_id;
      this.$ajax.post('/' + this.api_name + '/get/' + this.localSeqId, { fk_id: this.localSeqId }, function (err, result) {
        if (err) {
          _this9.$notify({
            title: 'データの読み込みが出来ませんでした。',
            text: err,
            type: 'error',
            duration: 10000
          });
        }
        _this9.localSeqId = result.data.seq_id;
        _this9.$store.state[_this9.stateCurrentRow] = result.data;
        if (typeof _this9.$store.state[_this9.stateCurrentRow].approval_history_id == "number") {
          _this9.approvalHistoryId = _this9.$store.state[_this9.stateCurrentRow].approval_history_id;
        }

        _this9.commonSetStyleForChangedFields(result.data);

        mdebug("LOAD DATA", { err: err, result: result });
      });
    } else {
      this.commonLoadRecord({}, function (err, result) {
        if (_this9.$route.params.seq_id == "new") {
          _this9.Status = 1;
          _this9.Password = "mizuho01";
          setTimeout(function () {
            _this9.$store.state[_this9.stateCurrentEditing].password = "mizuho01";
            _this9.$store.state[_this9.stateCurrentRow].password = "mizuho01";
            _this9.Password = "mizuho01";
          }, 300);

          __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update1", { allow: [""], disable: true, select: true });
          __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update2", { allow: [""], disable: true, select: true });
        } else {
          _this9.original_loaded_data = result.data;
          console.log('TEST DEBUG 210707 (799 at page_0041_master_user_detail.vue)[23:51]: ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.original_loaded_data, null, 4));
          _this9.$store.state[_this9.stateCurrentRow].password = "**";
          if (result && result.data && result.data.role && result.data.role.length > 0) {
            __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update1", { allow: [result.data.role], disable: false, select: false });
            __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update2", { allow: [result.data.role], disable: false, select: false });
          } else {
            __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update1", { allow: [""], disable: true, select: true });
            __WEBPACK_IMPORTED_MODULE_14__libs_bus__["a" /* bus */].$emit("main_role_update2", { allow: [""], disable: true, select: true });
          }
        }
        _this9.localSeqId = _this9.$route.params.seq_id;
        if (typeof _this9.$store.state[_this9.stateCurrentRow].approval_history_id == "number") {
          _this9.approvalHistoryId = _this9.$store.state[_this9.stateCurrentRow].approval_history_id;
        }
        _this9.readOnly2 = _this9.$store.state[_this9.stateCurrentRow].authority_1 != 1;
        _this9.readOnly3 = _this9.$store.state[_this9.stateCurrentRow].authority_2 != 1;

        _this9.commonEditDeleteCmdHandler(_this9);
        console.log("CMD IN", _this9.$route.params.cmd);
      });
      console.log("CMD", this.$route.params.cmd);
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.cacheched_form_list = false;
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "master_user",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].user_id), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].user_shimei), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].role), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].company), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].department), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].team), { error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].last_login_date), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].password), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].mail_address), { disabled: true, read_only: true, error_if_blank: false }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_2__rules_fields_master_user__["a" /* fields */].login_failure_count), { disabled: true, read_only: true, error_if_blank: false })]
      };
    }
  },
  methods: {
    onLocalSaveBulkDevEmbedded: function onLocalSaveBulkDevEmbedded() {
      console.log("onLocalSave");
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("confirmBulkDeviceEmbeddedInformationAddCheck", {
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "完了",
        no_label: "キャンセル",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onBulkDeviceEmbeddedInformationAddCheckConfirm: function onBulkDeviceEmbeddedInformationAddCheckConfirm(mode) {
      if (mode == "yes") {
        this.read_only = false;
        var list_seq_id = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('bulk_edit_' + this.local_page_id);
        try {
          list_seq_id = JSON.parse(list_seq_id);
          this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
          this.saveBulk(this.api_name, list_seq_id.arr, { from_edit_form: true }, function (err) {});
        } catch (error) {
          this.$notify({
            title: "予期しないエラーが発生し、登録が行えません",
            text: error,
            type: 'error',
            duration: 12000
          });
        }
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0041_master_user", params: {} });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    prepareCompanySelection: function prepareCompanySelection(company, companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name) {
      var _this = this;

      var selected_company = false;
      var selected_department = company;
      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true
            });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true
            });
          }
        }
      });
      company_field.page_controller_msg({
        cmd: "set_options",
        options: _.clone(companies)
      });
      company_field.page_controller_msg({ cmd: "disable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });

        selected_company = _this.$store.state[_this.stateCurrentRow][company_field.id];
        selected_department = _this.$store.state[_this.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({
            cmd: "set_options",
            options: departments,
            reset: false
          });
          department_field.page_controller_msg({ cmd: "enable" });
          if (selected_department && selected_department.length > 0) {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: false
            });
          }
        }
      }, this.is_new ? 100 : 500);
    },
    startCompanySelection: function startCompanySelection(company) {
      var _this2 = this;

      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;

        this.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
          if (err) {
            _this2.$notify({
              title: "所管会社のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          }
          var companies = [company];

          _this2.$ajax.post_cached_queued("/master_belongs/list_team_and_department", {}, function (err, department_and_team) {
            if (err) {
              _this2.$notify({
                title: "部署・チームのデータの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000
              });
              return;
            }
            _this2.prepareCompanySelection(company, _.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.department, temp_fields.team, "company", "department");
            if (_this2.is_new == true) {
              setTimeout(function () {
                temp_fields.company.page_controller_msg({
                  cmd: "set_value",
                  val: company
                });
              }, _this2.is_new ? 300 : 1000);
            }
          });
        });
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.state[this.stateCurrentEditing] = {};
    this.addHtmlClass(document.body, 'blue_bg');
    this.local_page_id = this.$route.params.p_id;
    this.is_new = true;

    this.allFields.forEach(function (f) {
      _this3.$store.state[_this3.stateCurrentRow][f.id] = "";
    });
    setTimeout(function () {
      _this3.$store.state[_this3.stateIsEditingNew] = true;
      _this3.read_only = false;
      _this3.is_new = true;

      var list_seq_id = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get('bulk_edit_' + _this3.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id);
        var company = list_seq_id.company;
        console.log('TEST DEBUG 210522 (135 at page_0041_master_user_detail_bulk_edit.vue)[21:57]: ', { company: company });
        _this3.startCompanySelection(company);
      } catch (error) {
        _this3.$notify({
          title: "Error to load 所属会社",
          text: error,
          type: 'error',
          duration: 12000
        });
      }
    }, 300);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.state[this.stateCurrentEditing] = {};
    this.removeHtmlClass(document.body, 'blue_bg');
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_md5__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sub_pages_sub_table_temp_batch_import__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sub_pages_sub_table_temp_batch_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_sub_pages_sub_table_temp_batch_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__(5);











/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'sub-table-temp-batch-import': __WEBPACK_IMPORTED_MODULE_6__components_sub_pages_sub_table_temp_batch_import___default.a
  },
  data: function data() {
    return {
      page_acl: __WEBPACK_IMPORTED_MODULE_2__rules_acl_rules___default.a.inventory,
      session_id: false,
      show_table: false,
      show_check_box: false,
      local_is_editing: false
    };
  },

  computed: {
    localIsEditing: {
      get: function get() {
        return this.local_is_editing;
      },
      set: function set(v) {
        this.local_is_editing = v;
      }
    },
    showCheckBox: {
      get: function get() {
        return this.show_check_box;
      },
      set: function set(v) {
        this.show_check_box = v;
      }
    },
    showTable: {
      get: function get() {
        return this.show_table;
      },
      set: function set(v) {
        this.show_table = v;
      }
    },
    sessionId: {
      get: function get() {
        return this.session_id;
      },
      set: function set(v) {
        this.session_id = v;
      }
    }
  },
  methods: {
    isEditing: function isEditing(v) {
      this.localIsEditing = v;
    },
    backToList: function backToList() {
      var destination = "/approval_history/all/";
      return this.$router.push(destination);
    }
  },
  mounted: function mounted() {
    this.sessionId = this.$route.params.session_id;
    if (__WEBPACK_IMPORTED_MODULE_3_md5___default()("SHOW" + this.sessionId) == this.$route.params.validate) {
      this.showCheckBox = true;
    } else {
      this.showCheckBox = false;
    }
    this.showTable = true;
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_approval_history__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_approval_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sub_pages_approval_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sub_pages_approval_history_all__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sub_pages_approval_history_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sub_pages_approval_history_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_strap_dist_vue_strap_js__);













/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "approval-history-all": __WEBPACK_IMPORTED_MODULE_8__components_sub_pages_approval_history_all___default.a,
    "approval-history": __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_approval_history___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_9_vue_strap_dist_vue_strap_js__["tab"],
    tabs: __WEBPACK_IMPORTED_MODULE_9_vue_strap_dist_vue_strap_js__["tabs"]
  },
  data: function data() {
    return {
      selected_tab: -1,
      selected_tab_model: -1,
      page_acl: __WEBPACK_IMPORTED_MODULE_3__rules_acl_rules___default.a.inventory,
      loading_count_box_data: false,
      bRL_Flag: false,
      local_next_leave_page: false,
      local_next_go_to_tab: -1,
      waiting_confimation: false,
      selected_items_qty: ""
    };
  },

  computed: {
    selectedTabModel: {
      get: function get() {
        return this.selected_tab_model;
      },
      set: function set(v) {
        this.selected_tab_model = v;
      }
    },
    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    console.log('TEST DEBUG 210525 (73 at page_0050_approval_history_tabs.vue)[23:18]: ', { type: typeof to === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(to), to: to });
    if (this.bRL_Flag == false || to && to.path && (to.path.indexOf("/approval_history") == 0 || to.path.indexOf("/approval/") > 0)) {
      return next();
    } else {
      this.emitOnLeaveDialor("approvalBeforeLeaveModal");
      this.local_next_leave_page = next;
    }
  },

  methods: {
    selectedItemsUpd: function selectedItemsUpd(v) {
      this.selected_items_qty = v;
    },
    emitOnLeaveDialor: function emitOnLeaveDialor(id) {
      var msg = this.selected_items_qty + " 件の申請が確認済み未承認です。<br>承認を行わないまま画面を移動しますが、よろしいですか？";
      msg += "<br><br><span style='color:red;'>※承認を行う場合は、[キャンセル]をクリックした後、<br>[承認]をクリックしてください。</span>";
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit(id, {
        title: "",
        message: msg,
        yes_label: "ページを移動",
        no_label: "キャンセル",
        yes_color: "info",
        no_color: "default",
        model_height: "50",
        model_width: "650px"
      });
    },
    setbRLFlag: function setbRLFlag(value) {
      this.bRL_Flag = value;
    },
    beforeRouteLeaveFlag: function beforeRouteLeaveFlag() {
      return this.bRL_Flag;
    },
    approvalBeforeLeaveoConfirmedModal: function approvalBeforeLeaveoConfirmedModal(mode) {
      if (mode == "yes") {
        this.local_next_leave_page();
      } else {
        this.local_next_leave_page(false);
      }
    },
    approvalBeforeLeaveoConfirmedTabModal: function approvalBeforeLeaveoConfirmedTabModal(mode) {
      var _this = this;

      if (mode == "yes") {
        var index = this.local_next_go_to_tab;
        this.changeTab(index);
      }
      setTimeout(function () {
        _this.waiting_confimation = false;
      }, 100);
    },
    onTabChanged: function onTabChanged(index) {
      var _this2 = this;

      this.clearSearchFields();
      if (this.bRL_Flag == true) {
        if (this.waiting_confimation == true) {
          return;
        }
        this.waiting_confimation = true;
        this.local_next_go_to_tab = index;
        setTimeout(function () {
          _this2.selectedTabModel = index == 0 ? 1 : 0;
        }, 10);
        this.emitOnLeaveDialor("approvalBeforeLeaveTabModal");
      } else {
        this.changeTab(index);
      }
    },
    changeTab: function changeTab(index) {
      if (this.selectedTab != index) {
        this.selectedTab = index;
        this.selectedTabModel = index;
        switch (index) {
          case 0:
            return this.$router.push({ path: "/approval_history" });
            break;
          case 1:
            return this.$router.push({ path: "/approval_history/all" });
            break;
          default:
            break;
        }
      }
    }
  },
  mounted: function mounted() {

    this.selectedTab = this.$route.meta.tab_index;
    this.selectedTabModel = this.$route.meta.tab_index;
  },
  beforeDestroy: function beforeDestroy() {
    console.log('TEST DEBUG 210606 (164 at page_0050_approval_history_tabs.vue)[02:16]: beforeDestroy', {});
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:approval_history');








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a,
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"]
  },
  data: function data() {
    return {
      api_name: "id_approval_history",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      execute_filter_on_back: true,
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.generic,
      user_id: "",
      is_logged_user_admin: false,
      disable_page_approve: true
    };
  },

  computed: {
    disablePageApprove: {
      get: function get() {
        return this.disable_page_approve;
      },
      set: function set(v) {
        this.disable_page_approve = v;
      }
    },
    isLoggedUserAdmin: {
      get: function get() {
        return this.is_logged_user_admin;
      },
      set: function set(v) {
        this.is_logged_user_admin = v;
      }
    },
    userId: {
      get: function get() {
        return this.user_id;
      },
      set: function set(v) {
        this.user_id = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["b" /* filed_types */];
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    allSearchFields: function allSearchFields() {
      return this.tabFieldList;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].approval_status, {
        options: ["承認済", "申請中", "差戻"]
      }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].syubetu, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].control_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].toroku_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].applicant_label, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].next_approver_label, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].update_name_label, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].create_time, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].update_time, {})];
    }
  },
  methods: {
    bulkApprovalStage1: function bulkApprovalStage1() {
      var _this = this;

      this.$ajax.post("/id_approval_history/count_prepared", {}, function (err, qty) {
        console.log({ qty: qty });
        if (err) {
          _this.$notify({
            title: "データの承認に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          console.log("bulkApprovalStage1", { qty: qty });
          _this.gridOptions.api.purgeInfiniteCache();
          __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("stage1ConfirmatioModal", {
            title: "選択中　" + qty + "件",
            message: "承認を行います。よろしいですか？",
            yes_label: "承認",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    bulkApprovalStage2: function bulkApprovalStage2(mode) {
      var _this2 = this;

      if (mode != "yes") {
        return;
      }
      this.$ajax.post("/id_approval_history/approve", {}, function (err, response) {
        console.log({ response: response });
        _this2.$store.state["current_field_style"] = {};
        _this2.$store.state["current_field_style2"] = {};
        if (err) {
          _this2.$notify({
            title: "データの承認に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          _this2.gridOptions.api.purgeInfiniteCache();
          __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("stage2ConfirmatioModal", {
            title: "承認が完了しました。",
            message: "",
            yes_label: "",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    bulkApprovalStage3: function bulkApprovalStage3() {
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("bulkApprovalStage3");
    },
    bulkApprovalStage4: function bulkApprovalStage4(mode) {
      var _this3 = this;

      this.$ajax.post("/id_approval_history/approve_clear", {}, function (err, response) {
        console.log({ response: response });
        if (err) {
          _this3.$notify({
            title: "データの承認に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          _this3.gridOptions.api.purgeInfiniteCache();
          __WEBPACK_IMPORTED_MODULE_10__libs_bus__["a" /* bus */].$emit("stage2ConfirmatioModal", {
            title: "クリア",
            message: "確認をクリアしました。",
            yes_label: "",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      var destination = "/master_user/approval/" + data.seq_id + "/" + data.fk_id;

      console.log('onDetailsClick', { destination: destination });

      return this.$router.push(destination);
    },
    createColumnDefs: function createColumnDefs() {
      var _this4 = this;

      var arr = [{
        headerName: 'Seq',
        field: 'seq_id',
        hide: true
      }, {
        headerName: "SearchControl",
        field: "search_control",
        hide: true
      }, {
        headerName: "SearchFlowControl",
        field: "search_flow_control",
        hide: true
      }];
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };

        if (f.type == "date_picker") {
          fi.cellRenderer = function (params) {
            return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].format_date(params.value);
          };
        } else if (f.type == "datetime_picker" || f.type == "current_time") {
          fi.cellRenderer = function (params) {
            return __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].format_date_time(params.value);
          };
        } else if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }

        arr.push(fi);
      });

      [__WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].more_details, __WEBPACK_IMPORTED_MODULE_2__rules_fields_id_approval_history__["a" /* fields */].record_checked].forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',

          cellRenderer: function cellRenderer(params) {
            if (params.column.colId == "more_details") {
              if (_this4.isLoggedUserAdmin == true && params.data && params.data.status_final == "未承認" || params.data && (params.data.next_approver == _this4.userId || params.data.applicant == _this4.userId)) {
                return _this4.createGridTextButton("詳細", "color: #5b9bd5;", _this4.onDetailsClick, params.data);
              } else {
                return "-";
              }
            }
            if (params.column.colId == "record_checked") {
              if (params.data && params.data.record_checked == 1) {
                params.node.data.is_selected = true;
                params.data.is_selected = true;
              }
              return _this4.createGridButton(params.data && params.data.record_checked == 1 ? "glyphicon glyphicon glyphicon-check" : "glyphicon glyphicon glyphicon-unchecked", "color: #5b9bd5;", function () {}, params.data);
            }
          }
        };
        arr.push(fi);
      });

      return arr;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    this.userId = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get("userID") || "";
    this.isLoggedUserAdmin = this.isAdmin;
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    var _this5 = this;

    this.$store.state[this.stateCurrentRow] = {};
    var use_data_source = true;

    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function getRowNodeId(data) {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate: "<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onColumnResized: function onColumnResized(ev, b) {},
      onRowSelected: function onRowSelected(ev) {},
      onModelUpdated: function onModelUpdated(ev, d) {},
      onGridReady: function onGridReady() {},
      getRowStyle: function getRowStyle(params) {
        if (_this5.isLoggedUserAdmin == true && params.node.data && params.node.data.status_final == "未承認" || params.node.data && params.node.data.next_approver == _this5.userId) {
          if (params.node.data && (params.node.data.is_selected == true || _this5.isAllSelected == true)) {
            return { background: "orange" };
          }
        }
      }
    };
    this.initDatasource({ loaded_cb: function loaded_cb(err, data) {
        var active_approve_button = _.find(data, function (d) {
          return (_this5.isLoggedUserAdmin == true && d && d.status_final == "未承認" || d && d.next_approver == _this5.userId) && d && (d.is_selected == true || _this5.isAllSelected == true);
        });
        _this5.disablePageApprove = typeof active_approve_button == "undefined";
      } });
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_device_embedded_information_add_check__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_device_embedded_information_add_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_device_embedded_information_add_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sub_pages_device_embedded_detail__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sub_pages_device_embedded_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_sub_pages_device_embedded_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_bus__ = __webpack_require__(4);











var mdebug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('esma:device_embedded_information');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_9__components_form_field___default.a,
    'sub-table': __WEBPACK_IMPORTED_MODULE_2__components_sub_pages_device_embedded_detail___default.a,
    "device-embedded-information-confirmation-modal": __WEBPACK_IMPORTED_MODULE_6__components_modals_device_embedded_information_confirmation_modal___default.a,
    'device-embedded-information-bach-edit-modal': __WEBPACK_IMPORTED_MODULE_1__components_modals_device_embedded_information_add_check___default.a
  },
  data: function data() {
    return {
      api_name: "device_embedded_information",
      page_acl: __WEBPACK_IMPORTED_MODULE_10__rules_acl_rules___default.a.generic
    };
  },

  computed: {
    deviceControlNumber: function deviceControlNumber() {
      return this.$store.state.current_row["device_control_number"];
    },
    registrationDate: function registrationDate() {
      return __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].format_date(this.$store.state.current_row["registration_date"]);
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].virtual_environment, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].virtual_base_unit, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_classification, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].approval_status, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].leasing_or_rental, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].manufacture_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].model_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].equipment_classification, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].cpu_count, {})],
        col3: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_team, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_base, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].floor, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].user_name, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].installation_department, {})],
        col2b: [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_5__rules_fields_device_embedded_information__["a" /* fields */].remarks, {})]
      };
    }
  },
  methods: {
    onDeviceEmbeddedInformationAddCheckConfirm: function onDeviceEmbeddedInformationAddCheckConfirm(mode) {
      if (mode == "yes") {
        console.log("onDeviceEmbeddedInformationAddCheckConfirm", mode);
        this.read_only = false;
        this.commonSaveInfo(this, this.api_name, {});
      }
    },
    onConfirmExecuteProcess: function onConfirmExecuteProcess() {
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("showBulkImportConfimationModal", {});
    },
    onLocalSaveDevEmbedded: function onLocalSaveDevEmbedded() {
      console.log("onLocalSave");
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("confirmDeviceEmbeddedInformationAddCheck", {
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "完了",
        no_label: "キャンセル",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onEdit: function onEdit() {
      var _this = this;

      mdebug("onEdit");
      setTimeout(function () {
        _this.read_only = false;
      }, 300);
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0010_device_embedded_information", params: {} });
    },
    gotocertificate: function gotocertificate() {
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate: function selectCertificate() {
      this.showSubTable = true;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$route.params.seq_id == "new") {
      this.local_seq_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      this.$store.state.current_row = {
        seq_id: this.local_seq_id
      };
      this.allFields.forEach(function (f) {
        _this2.$store.state.current_row[f.id] = "";
      });
      setTimeout(function () {
        _this2.$store.state.is_editing_new = true;
        _this2.read_only = false;
        _this2.is_new = true;
      }, 300);
      mdebug("mounted as new");
    } else {
      this.is_new = false;
      this.local_seq_id = this.$route.params.seq_id;
      this.$ajax.post('/' + this.api_name + '/get/' + this.local_seq_id, {}, function (err, result) {
        if (err) {
          _this2.$notify({
            title: 'データの読込に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        }
        _this2.$store.state.current_row = result.data;
        mdebug("LOAD DATA", { err: err, result: result });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_mixin_page_common__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_mixin_page_common__["a" /* default */]],
  components: {},
  data: function data() {
    return {};
  },

  computed: {
    messsage: function messsage() {
      return this.$route.params.message || "Loading...";
    },
    waitTime: function waitTime() {
      return this.$route.params.wait || 10;
    },
    url: function url() {
      return this.$route.params.url || "/";
    }
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      return _this.$router.push(_this.url);
    }, this.waitTime);
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_inventory_report__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_inventory_summary_box__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_inventory_summary_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_inventory_summary_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sub_pages_inventory_certificate_list__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sub_pages_inventory_certificate_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_sub_pages_inventory_certificate_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sub_pages_inventory_management__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sub_pages_inventory_management___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_sub_pages_inventory_management__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sub_pages_inventory_pending_items__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sub_pages_inventory_pending_items___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_sub_pages_inventory_pending_items__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_strap_dist_vue_strap_js__);


var _components;







var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:inventory_report');














var timeout_control = {};
var queue_bus = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: (_components = {
    'field-box': __WEBPACK_IMPORTED_MODULE_7__components_form_field___default.a,
    "inventory-summary-box": __WEBPACK_IMPORTED_MODULE_11__components_inventory_summary_box___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_12__components_modals_file_download_modal___default.a,
    "inventory-management": __WEBPACK_IMPORTED_MODULE_15__components_sub_pages_inventory_management___default.a,
    "inventory-certificate-list": __WEBPACK_IMPORTED_MODULE_14__components_sub_pages_inventory_certificate_list___default.a,
    "inventory-pending-items": __WEBPACK_IMPORTED_MODULE_16__components_sub_pages_inventory_pending_items___default.a
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'inventory-summary-box', __WEBPACK_IMPORTED_MODULE_11__components_inventory_summary_box___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'tab', __WEBPACK_IMPORTED_MODULE_18_vue_strap_dist_vue_strap_js__["tab"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'tabs', __WEBPACK_IMPORTED_MODULE_18_vue_strap_dist_vue_strap_js__["tabs"]), _components),
  data: function data() {
    return {
      api_name: "inventory_report",
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.inventory_report,
      selected_tab: 0,
      inventory_sub_search: {},
      counter_b1: "",
      counter_b2: "",
      counter_b3: "",
      counter_b4: "",
      counter_t1: "",
      counter_t2: "",
      counter_t3: "",
      counter_t4: "",
      counter_u4: "",
      counter_b3_error_message: null,

      use_key: "cert",
      select_list: {
        company: [],
        department: [],
        jurisdiction_classification: [],
        system: [],
        team: []
      },
      select_disable: {
        company: false,
        department: false,
        jurisdiction_classification: false,
        system: false,
        team: false
      },
      select_readonly: {
        company: false,
        department: false,
        jurisdiction_classification: false,
        system: false,
        team: false
      },
      select_mode: "",
      search_map: false,
      reverse_map: false,

      allow_to_submit: false,

      page_mode: 0,
      saved_seq_id: -1
    };
  },

  computed: {
    selvalues: function selvalues() {
      return this.inventory_sub_search;
    },
    selectdisable: function selectdisable() {
      return this.select_disable;
    },
    selectreadonly: function selectreadonly() {
      return this.select_readonly;
    },

    companylist: {
      get: function get() {
        return this.select_list.company;
      },
      set: function set(v) {
        this.select_list.company = v;
      }
    },
    selectmode: {
      get: function get() {
        return this.select_mode;
      },
      set: function set(v) {
        this.select_mode = v;
        this.onselectmode(v);
      }
    },
    departmentlist: {
      get: function get() {
        return this.select_list.department;
      },
      set: function set(v) {
        this.select_list.department = v;
      }
    },
    classificationlist: {
      get: function get() {
        return this.select_list.jurisdiction_classification;
      },
      set: function set(v) {
        this.select_list.jurisdiction_classification = v;
      }
    },
    systemlist: {
      get: function get() {
        return this.select_list.system;
      },
      set: function set(v) {
        this.select_list.system = v;
      }
    },
    teamlist: {
      get: function get() {
        return this.select_list.team;
      },
      set: function set(v) {
        this.select_list.team = v;
      }
    },
    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    },

    allowToSubmit: {
      get: function get() {
        return this.allow_to_submit;
      },
      set: function set(v) {
        this.allow_to_submit = v;
      }
    },

    counterB3ErrorMessage: {
      get: function get() {
        return this.counter_b3_error_message;
      },
      set: function set(v) {
        this.counter_b3_error_message = v;
      }
    },
    counterT1: {
      get: function get() {
        return "" + this.counter_t1;
      },
      set: function set(v) {
        this.counter_t1 = v;
      }
    },
    counterT2: {
      get: function get() {
        return "" + this.counter_t2;
      },
      set: function set(v) {
        this.counter_t2 = v;
      }
    },
    counterT3: {
      get: function get() {
        return "" + this.counter_t3;
      },
      set: function set(v) {
        this.counter_t3 = v;
      }
    },
    counterT4: {
      get: function get() {
        return "" + this.counter_t4;
      },
      set: function set(v) {
        this.counter_t4 = v;
      }
    },
    counterB1: {
      get: function get() {
        return "" + this.counter_b1;
      },
      set: function set(v) {
        this.counter_b1 = v;
      }
    },
    counterB2: {
      get: function get() {
        return "" + this.counter_b2;
      },
      set: function set(v) {
        this.counter_b2 = v;
      }
    },
    counterB3: {
      get: function get() {
        return "" + this.counter_b3;
      },
      set: function set(v) {
        this.counter_b3 = v;
      }
    },
    counterB4: {
      get: function get() {
        return "" + this.counter_b4;
      },
      set: function set(v) {
        this.counter_b4 = v;
      }
    },
    counterU4: {
      get: function get() {
        return "" + this.counter_u4;
      },
      set: function set(v) {
        this.counter_u4 = v;
      }
    },
    EditableUser: function EditableUser() {
      return (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_17__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF) && __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userCompany") == "ライセンス管理窓口";
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_inventory_report__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_inventory_report__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col0: []
      };
    },
    certsearchkeys: function certsearchkeys() {
      return ["company", "jurisdiction_classification", "licensed_department", "license_jurisdiction_team", "license_jurisdiction_system"];
    },
    searchkeys: function searchkeys() {
      return ["company", "jurisdiction_classification", "department", "team", "system"];
    }
  },
  methods: {
    searchclear: function searchclear() {
      if (this.EditableUser == true) {
        this.selectmode = "";
        this.inventory_sub_search[this.Searchmap("company")] = "";
      } else {
        this.selectmode = "department";
      }
    },
    presetListSelectBox: function presetListSelectBox() {
      var _this = this;

      if (this.EditableUser == true) {
        this.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
          if (err) {
            _this.$notify({
              title: "所管会社のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          }
          _companies.forEach(function (d) {
            d.value = d.val;
          });
          _this.companylist = _companies;
          if (_this.EditableUser == false) {
            for (var k in _this.companylist) {
              _this.inventory_sub_search.company = _this.companylist[k].val;
              break;
            }
          }
          _this.selectmode = "";
        });
      } else {
        var usercompany = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("selectedCompany") || "";
        var userdepartment = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userDepartment") || "";
        this.select_list["company"] = [{ val: usercompany, value: usercompany }];
        this.select_list["department"] = [{ val: userdepartment, value: userdepartment }];
        this.inventory_sub_search[this.Searchmap("company")] = usercompany;
        this.inventory_sub_search[this.Searchmap("department")] = userdepartment;
        this.selectmode = "department";
      }
    },
    SelectSearch: function SelectSearch(p) {
      this.inventory_sub_search[this.Searchmap(p.id)] = p.value;
      if (p.value == "") {
        this.selectmode = this.get_empty_searchkey(p.id);
      } else {
        this.selectmode = p.id;
      }
    },
    onselectchange: function onselectchange(mode) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("inventory_sub_search", { search_data: this.inventory_sub_search });
      if (mode != "setonly") {
        setTimeout(function () {
          _this2.get_count_box_data();
        }, 300);
      }
    },
    get_empty_searchkey: function get_empty_searchkey(k) {
      var map = {
        reporting_period: "reporting_period",
        company: "",
        department: "company",
        jurisdiction_classification: "department",
        team: "department",
        system: "jurisdiction_classification"
      };
      return map[k];
    },
    onselectmode: function onselectmode(v) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      switch (v) {
        case "company":
          var target = {
            clear: ["department", "jurisdiction_classification", "team", "system"],
            open: ["department"],
            disable: ["jurisdiction_classification", "team", "system"],
            load_id: "department",
            api: "/master_belongs/list_department_use_subsearch",
            api_map: "belong",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
        case "department":
          var target = {
            clear: ["jurisdiction_classification", "team", "system"],
            open: ["jurisdiction_classification", "team"],
            disable: ["system"],
            load_id: "team",
            api: "/master_belongs/list_team_use_subsearch",
            api_map: "belong",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
        case "jurisdiction_classification":
          if (this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "EUC・その他") {
            var target = {
              clear: ["system"],
              open: ["team"],
              disable: ["system"],
              load_id: "team",
              api: "/master_belongs/list_team_use_subsearch",
              api_map: "belong",
              api_key: ""
            };
            this.selectmodeproc(target, mode);
          } else {
            var target = {
              clear: ["system", "team"],
              open: ["system"],
              disable: ["team"],
              load_id: "system",
              api: "/master_system/list_system_name_use_subsearch",
              api_map: "system",
              api_key: ""
            };
            this.selectmodeproc(target, mode);
          }
          break;
        case "system":
          this.onselectchange(mode);
          break;
        case "team":
          var target = {
            clear: ["system"],
            open: [],
            disable: [],
            load_id: "system",
            api: "/master_system/list_system_name_use_subsearch",
            api_map: "system",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
        case "reporting_period":
          this.onselectchange(mode);
          break;
        default:
          var target = {
            clear: ["department", "jurisdiction_classification", "team", "system"],
            open: ["company"],
            disable: ["department", "jurisdiction_classification", "team", "system"],
            load_id: "",
            api: "",
            api_map: "",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
      }
    },
    selectmodeproc: function selectmodeproc(target, mode) {
      var _this3 = this;

      var api_subsearch = {};
      var temp = "";
      for (var i in this.searchkeys) {

        if (target.clear.includes(this.searchkeys[i])) {
          if (mode != "setonly") {
            this.inventory_sub_search[this.Searchmap(this.searchkeys[i])] = "";
            this.select_list[this.searchkeys[i]] = "";
          }
        }

        if (target.disable.includes(this.searchkeys[i])) {
          this.selectdisable[this.searchkeys[i]] = true;
        }
        if (target.open.includes(this.searchkeys[i])) {
          this.selectdisable[this.searchkeys[i]] = false;
        }

        if (target.api_map != "") {
          temp = this.Searchmap(this.searchkeys[i], target.api_map);
          if (temp != "") {
            api_subsearch[temp] = this.inventory_sub_search[this.Searchmap(this.searchkeys[i])];
          }
        }
      }
      if (this.selectdisable["jurisdiction_classification"] == false) {
        this.select_list["jurisdiction_classification"] = [{ val: "EUC・その他" }, { val: "IT所管システム" }];
      }

      if (target.load_id != "" && target.api != "") {
        var keyflag = false;
        if (target.api_key != "") {
          if (this.inventory_sub_search[this.Searchmap(target.api_key)] == "") {
            keyflag = true;
          }
        }
        if (keyflag != true) {
          this.$ajax.post_cached_queued(target.api, { sub_search: api_subsearch }, function (err, data) {
            if (err) {
              _this3.$notify({
                title: "データが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000
              });
              return;
            }
            _this3.select_list[target.load_id] = data;
            _this3.onselectchange(mode);
          });
        } else {
          this.select_list[target.load_id] = [];
          this.onselectchange(mode);
        }
      } else {
        this.onselectchange(mode);
      }
    },
    Searchmap: function Searchmap(v) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.use_key;

      if (this.search_map == false) {
        this.search_map = { common: {
            reporting_period: "reporting_period",
            company: "company",
            jurisdiction_classification: "jurisdiction_classification",
            department: "department",
            team: "team",
            system: "system"
          },
          inventory: {
            reporting_period: "reporting_period",
            company: "company",
            jurisdiction_classification: "jurisdiction_classification",
            department: "department_in_charge",
            team: "team_in_charge",
            system: "reporting_system"
          },
          device: {
            company: "company",
            jurisdiction_classification: "equipment_in_charge_classification",
            department: "equipment_in_charge_department",
            team: "equipment_in_charge_team",
            system: "equipment_in_charge_system_it"
          },
          cert: {
            company: "company",
            jurisdiction_classification: "jurisdiction_classification",
            department: "licensed_department",
            team: "license_jurisdiction_team",
            system: "license_jurisdiction_system"
          },
          belong: {
            company: "company",
            department: "department",
            team: "team"
          },
          system: {
            company: "company",
            department: "equipment_in_charge_department",
            team: "system_jurisdiction_team",
            system: "system_name"
          }
        };

        this.reverse_map = {};
        for (var k in this.search_map) {
          for (var k2 in this.search_map[k]) {
            this.reverse_map[this.search_map[k][k2]] = k2;
          }
        }
      }
      var temp = this.reverse_map[v];

      return this.search_map[mode][temp] || "";
    },
    ApplyCouter: function ApplyCouter() {
      switch (this.selectedTab) {
        case 0:
          this.counterT1 = "ライセンス件数";
          this.counterT2 = "ライセンス総数";
          this.counterT3 = "使用総数";
          this.counterT4 = "残総数";
          this.counterU4 = "件";
          this.counterB1 = this.inventory_sub_search.number_of_devices_cert;
          this.counterB2 = this.inventory_sub_search.sum_license_number;
          this.counterB3 = this.inventory_sub_search.sum_effective_number;
          this.counterB4 = this.inventory_sub_search.sum_remaining_number;
          break;
        case 1:
          this.counterT1 = "紐付対象数";
          this.counterT2 = "紐付数";
          this.counterT3 = "未紐付数";
          this.counterT4 = "紐付率";
          this.counterU4 = "";
          this.counterB1 = this.inventory_sub_search.number_of_installed_software_to_be_linked;
          this.counterB2 = this.inventory_sub_search.number_of_installation_software_licenses_attached;
          this.counterB3 = this.inventory_sub_search.number_of_unattached;
          this.counterB4 = this.inventory_sub_search.linkage_ratio;
          break;
        default:
          break;
      }
    },
    addNewReport: function addNewReport() {
      return this.$router.push({ name: "page_0071_inventory_report", params: { seq_id: "new" } });
    },
    onTabChanged: function onTabChanged(index) {
      this.clearSearchFields();
      this.selectedTab = index;
      this.ApplyCouter();
      switch (index) {
        case 0:
          return this.$router.push({ path: "/inventory_certificate_list" });
          break;
        case 1:
          return this.$router.push({ path: "/inventory_pending_items" });
          break;
        default:
          break;
      }
    },
    judesubsearchmode: function judesubsearchmode(search) {
      var flag = true;
      var map = this.certsearchkeys;
      for (var key in map) {
        if (map[key] != "license_jurisdiction_team") {
          if (map[key] != "license_jurisdiction_system" || search["jurisdiction_classification"] != "EUC・その他") {
            if (search[map[key]] == "" || typeof search[map[key]] == "undefined") {
              flag = false;
            }
          }
        }
      }
      return flag;
    },
    get_count_box_data: function get_count_box_data() {
      var _this4 = this;

      if (this.judesubsearchmode(this.inventory_sub_search) == false) {
        this.inventory_sub_search.number_of_installed_software_to_be_linked = "";
        this.inventory_sub_search.number_of_installation_software_licenses_attached = "";
        this.inventory_sub_search.number_of_unattached = "";
        this.inventory_sub_search.linkage_ratio = "";
        this.inventory_sub_search.number_of_devices_cert = "";
        this.inventory_sub_search.sum_license_number = "";
        this.inventory_sub_search.sum_effective_number = "";
        this.inventory_sub_search.sum_remaining_number = "";
        this.ApplyCouter();
        return;
      }
      if (this.loading_count_box_data == true) {
        return;
      }
      var sub_search = {};
      var map = this.certsearchkeys;
      for (var k in map) {
        sub_search[this.Searchmap(map[k], "inventory")] = this.inventory_sub_search[map[k]];
      }
      this.loading_count_box_data = true;
      this.$ajax.post("/" + this.api_name + "/statistical_output/", { sub_search: sub_search, listonly: true }, function (err, result) {
        if (err) {
          _this4.$notify({
            title: "統計データの読込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          for (var k in result) {
            _this4.inventory_sub_search[k] = result[k];
          }

          _this4.loading_count_box_data = false;
          _this4.ApplyCouter();
        }
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ path: '/inventory_management', params: {} });
    },
    onInventorySaveCondirmed: function onInventorySaveCondirmed(mode) {
      var _this5 = this;

      if (mode == "yes") {
        this.commonSaveInfo(this, this.api_name, {}, function (err, data_result) {
          if (err == null && data_result && data_result && data_result.seq_id > -1) {
            _this5.saved_seq_id = data_result.seq_id;
          }
          __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("confirmInventoryExport", {
            message: "棚卸報告の送信が完了しました。<br>報告結果をExcelで出力しますか？",
            title: "",
            yes_label: "はい(Excel出力)",
            no_label: "戻る(Excel出力無し)",
            yes_color: "primary",
            no_color: "",
            model_height: "50"
          });
        });
      } else if (mode == "no") {}
    },
    onInventoryExportCondirmed: function onInventoryExportCondirmed(mode) {
      if (mode == "yes") {
        __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("runInventoryExportDownloadModal", {
          message: "ファイルを出力しています。",
          on_complete_message: "出力が完了しました。",
          title: "出力",
          filter: { seq_id: this.saved_seq_id },
          sort: null,
          url: "/inventory_report/export_form_data/"
        });
      } else if (mode == "no") {}
    },
    onCloseExportFile: function onCloseExportFile() {},
    onLocalSaveInventory: function onLocalSaveInventory() {
      console.log("onLocalSave");
      __WEBPACK_IMPORTED_MODULE_13__libs_bus__["a" /* bus */].$emit("confirmInventorySave", {
        message: "棚卸報告を送信します。よろしいですか？",
        title: "",
        yes_label: "はい",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.readOnly = false;
    this.$route.params.seq_id = "new";
    this.commonLoadRecord({}, function (err, result) {
      _this6.readOnly = false;
    });
    this.presetListSelectBox();
  },
  beforeMount: function beforeMount() {},
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal_inventory__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal_inventory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal_inventory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_inventory_summary_box__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_inventory_summary_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_inventory_summary_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_async__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_async__);









var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:inventory_report');











var timeout_control = {};
var queue_bus = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_7__components_form_field___default.a,
    "inventory-summary-box": __WEBPACK_IMPORTED_MODULE_12__components_inventory_summary_box___default.a,
    "application-confirmation-modal-inventory": __WEBPACK_IMPORTED_MODULE_9__components_modals_application_confirmation_modal_inventory___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_13__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "inventory_report",
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.inventory_report,
      page_mode: "",
      inventory_sub_search: {},
      pri_sub_search: {},
      last_search: {},
      read_only2: true,
      read_only3: true,
      read_only4: true,
      counter_b1: "-",
      counter_b2: "-",
      counter_b3: "-",
      counter_b4: "-",
      update_Date: "",
      create_Date: "",
      status_value: "",
      new_or_resubmit_value: "",
      created_by_value: "",
      total_license: "",
      cert_editable: false,
      dev_editable: false,
      alret_total_license: false,
      alret_other: false,
      alret_unused_license: false,
      alret_expired_license: false,
      alret_remark_expired_license: false,
      alret_outside: false,
      alret_team_report: false,
      alret_department_report: false,
      admin_editable: false,
      reporting_period_list: [],
      allow_to_submit: false,

      saved_seq_id: -1,

      use_key: "inventory",
      select_list: {
        reporting_period: [],
        company: [],
        department: [],
        team: [],
        jurisdiction_classification: [],
        system: []
      },
      select_disable: {
        reporting_period: false,
        company: false,
        department: false,
        team: false,
        jurisdiction_classification: false,
        system: false
      },
      select_readonly: {
        reporting_period: false,
        company: false,
        department: false,
        team: false,
        jurisdiction_classification: false,
        system: false
      },
      select_mode: "",
      search_map: false,
      reverse_map: false,
      back_jurisdiction_classification: "",

      team_mode: false
    };
  },

  computed: {
    reject_label: function reject_label() {
      if (this.$store.state[this.stateCurrentRow].approval_status == "申請中" && this.pagemode == "loaded" && this.$store.state[this.stateCurrentRow].created_by == __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID")) {
        return "取戻";
      } else {
        return "差戻";
      }
    },
    reportmodewords: function reportmodewords() {
      if (this.teammode) {
        return "部署単位の報告に変更";
      } else {
        return "チーム単位の報告に変更";
      }
    },
    savewords: function savewords() {
      if (this.$store.state[this.stateCurrentRow]["approval_status"] == "報告済") {
        return "上書保存";
      } else {
        return "下書保存";
      }
    },

    teammode: {
      get: function get() {
        return this.team_mode;
      },
      set: function set(v) {
        this.team_mode = v;
      }
    },
    selvalues: function selvalues() {
      return this.inventory_sub_search;
    },
    selectdisable: function selectdisable() {
      return this.select_disable;
    },
    selectreadonly: function selectreadonly() {
      return this.select_readonly;
    },

    companylist: {
      get: function get() {
        return this.select_list.company;
      },
      set: function set(v) {
        this.select_list.company = v;
      }
    },
    selectmode: {
      get: function get() {
        return this.select_mode;
      },
      set: function set(v) {
        this.select_mode = v;
        this.onselectmode(v);
      }
    },
    departmentlist: {
      get: function get() {
        return this.select_list.department;
      },
      set: function set(v) {
        this.select_list.department = v;
      }
    },
    teamlist: {
      get: function get() {
        return this.select_list.team;
      },
      set: function set(v) {
        this.select_list.team = v;
      }
    },
    classificationlist: {
      get: function get() {
        return this.select_list.jurisdiction_classification;
      },
      set: function set(v) {
        this.select_list.jurisdiction_classification = v;
      }
    },
    systemlist: {
      get: function get() {
        return this.select_list.system;
      },
      set: function set(v) {
        this.select_list.system = v;
      }
    },
    reportingPeriodList: {
      get: function get() {
        return this.select_list.reporting_period;
      },
      set: function set(v) {
        this.select_list.reporting_period = v;
      }
    },
    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    },

    certeditable: {
      get: function get() {
        return this.cert_editable;
      },
      set: function set(v) {
        this.cert_editable = v;
      }
    },
    deveditable: {
      get: function get() {
        return this.dev_editable;
      },
      set: function set(v) {
        this.dev_editable = v;
      }
    },
    admineditable: {
      get: function get() {
        return this.admin_editable;
      },
      set: function set(v) {
        this.admin_editable = v;
      }
    },
    totallicense: {
      get: function get() {
        return this.total_license;
      },
      set: function set(v) {

        if (0 <= v) {
          this.total_license = v;
        } else {
          this.total_license = "";
        }
      }
    },
    alrettotallicense: {
      get: function get() {
        return this.alret_total_license;
      },
      set: function set(v) {
        this.alret_total_license = v;
      }
    },
    alretunusedlicense: {
      get: function get() {
        return this.alret_unused_license;
      },
      set: function set(v) {
        this.alret_unused_license = v;
      }
    },
    alretexpiredlicense: {
      get: function get() {
        return this.alret_expired_license;
      },
      set: function set(v) {
        this.alret_expired_license = v;
      }
    },
    alretremarkexpiredlicense: {
      get: function get() {
        return this.alret_remark_expired_license;
      },
      set: function set(v) {
        this.alret_remark_expired_license = v;
      }
    },
    alretother: {
      get: function get() {
        return this.alret_other;
      },
      set: function set(v) {
        this.alret_other = v;
      }
    },
    alretoutside: {
      get: function get() {
        return this.alret_outside;
      },
      set: function set(v) {
        this.alret_outside = v;
      }
    },
    alretteamreport: {
      get: function get() {
        return this.alret_team_report && (this.inventory_sub_search.jurisdiction_classification == "EUC・その他" || this.inventory_sub_search.jurisdiction_classification == "");
      },
      set: function set(v) {
        this.alret_team_report = v;
      }
    },
    alretdepartmentreport: {
      get: function get() {
        return this.alret_department_report && (this.inventory_sub_search.jurisdiction_classification == "EUC・その他" || this.inventory_sub_search.jurisdiction_classification == "");
      },
      set: function set(v) {
        this.alret_department_report = v;
      }
    },
    adminview: function adminview() {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_14__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_14__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF;
    },
    Editable: function Editable() {
      return this.EditableUser && this.admineditable == true;
    },
    EditableUser: function EditableUser() {
      return (__WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_14__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_14__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF) && __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userCompany") == "ライセンス管理窓口";
    },

    readOnly2: {
      get: function get() {
        return this.read_only2;
      },
      set: function set(v) {
        this.read_only2 = v;
      }
    },
    readOnly3: {
      get: function get() {
        return this.read_only3;
      },
      set: function set(v) {
        this.read_only3 = v;
      }
    },
    readOnly4: {
      get: function get() {
        return this.read_only4;
      },
      set: function set(v) {
        this.read_only4 = v;
      }
    },
    readOnlycol1c: function readOnlycol1c() {

      if (typeof this.$store.state[this.stateCurrentRow]['unused_license'] === 'undefined') {
        return this.read_only2;
      }
      var flag1 = this.$store.state[this.stateCurrentRow]['unused_license'] == 0;
      var flag2 = true;
      if (typeof this.$store.state[this.stateCurrentRow]['reason_not_using'] !== 'undefined') {
        if (this.$store.state[this.stateCurrentRow]['reason_not_using'] != null) {
          var flag2 = this.$store.state[this.stateCurrentRow]['reason_not_using'] == '';
        }
      }
      return this.read_only2 || flag1 && flag2;
    },
    readOnlycol1e: function readOnlycol1e() {

      if (typeof this.$store.state[this.stateCurrentRow]['expired_license'] === 'undefined') {
        return this.read_only2;
      }
      var flag1 = this.$store.state[this.stateCurrentRow]['expired_license'] == 0;
      var flag2 = true;
      if (typeof this.$store.state[this.stateCurrentRow]['expired_license_support'] !== 'undefined') {
        if (this.$store.state[this.stateCurrentRow]['expired_license_support'] != null) {
          var flag2 = this.$store.state[this.stateCurrentRow]['expired_license_support'] == '' || this.$store.state[this.stateCurrentRow]['expired_license_support'] == '　';
        }
      }
      return this.read_only2 || flag1 && flag2;
    },
    pagemode: {
      get: function get() {
        return this.page_mode;
      },
      set: function set(v) {
        this.page_mode = v;
        this.onchangemode();
      }
    },
    statusFieldStyle: function statusFieldStyle() {
      if (this.$store.state["current_field_style"] && this.$store.state["current_field_style"]["approval_status"]) {
        return this.$store.state["current_field_style"]["approval_status"];
      } else {
        return "";
      }
    },
    viewExportFilebtn: function viewExportFilebtn() {
      return this.pagemode == "loaded";
    },
    pageEditable: function pageEditable() {
      return this.Editable == true && this.pagemode == "loaded";
    },
    ViewEditbtn: function ViewEditbtn() {
      return this.pagemode == "loaded" && (this.Editable == true || this.$store.state[this.stateCurrentRow].approval_status == "差戻" || this.$store.state[this.stateCurrentRow].approval_status == "下書中");
    },
    ViewApproval: function ViewApproval() {
      return this.pagemode == "loaded" && this.$store.state[this.stateCurrentRow].approval_status == "申請中" && this.$store.state[this.stateCurrentRow].next_approver == __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID");
    },
    ViewApprovalHistory: function ViewApprovalHistory() {
      return this.pagemode == "loaded" && this.$store.state[this.stateCurrentRow].approval_status == "申請中" || this.pagemode == "loaded" && this.$store.state[this.stateCurrentRow].approval_status == "報告済";
    },
    ViewRejectbtn: function ViewRejectbtn() {
      return this.pagemode == "loaded" && this.Editable == true && this.$store.state[this.stateCurrentRow].approval_status != "差戻" && this.$store.state[this.stateCurrentRow].approval_status != "下書中" || this.$store.state[this.stateCurrentRow].approval_status == "申請中" && this.pagemode == "loaded" && this.$store.state[this.stateCurrentRow].next_approver == __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID") || this.$store.state[this.stateCurrentRow].approval_status == "申請中" && this.pagemode == "loaded" && this.$store.state[this.stateCurrentRow].created_by == __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID");
    },
    ViewEditCancelbtn: function ViewEditCancelbtn() {
      return this.pagemode == "edit";
    },
    ViewEadminremarkditSetbtn: function ViewEadminremarkditSetbtn() {
      return this.pagemode == "adminremarkedit";
    },
    ViewRejectEditbtn: function ViewRejectEditbtn() {
      return this.pagemode == "rejectedit";
    },
    ShowRejectReason: function ShowRejectReason() {
      return this.$store.state[this.stateCurrentRow].retraction_reason != "" && typeof this.$store.state[this.stateCurrentRow].retraction_reason != "undefined" && this.$store.state[this.stateCurrentRow].retraction_reason != null || this.pagemode == "rejectedit";
    },
    ShowRejectPerson: function ShowRejectPerson() {
      return this.$store.state[this.stateCurrentRow].retraction_person_label != "" && typeof this.$store.state[this.stateCurrentRow].retraction_person_label != "undefined" && this.$store.state[this.stateCurrentRow].retraction_person_label != null;
    },
    ShowRejectBlock: function ShowRejectBlock() {
      return this.ShowRejectReason || this.ShowRejectPerson;
    },
    ViewTopInfomation: function ViewTopInfomation() {
      return this.pagemode != "search" && this.pagemode != "outside" && this.pagemode != "new";
    },
    ViewMainInfomation: function ViewMainInfomation() {
      return this.pagemode != "search" && this.pagemode != "outside" || true;
    },
    ViewSavebtn: function ViewSavebtn() {
      return this.read_only2 == false || this.page_mode == "edit";
    },
    ViewModeChangebtn: function ViewModeChangebtn() {
      return this.read_only2 == false && this.Editable == true && this.page_mode != "edit";
    },
    ViewConfirmbtn: function ViewConfirmbtn() {
      return this.read_only2 == true && this.page_mode == "loaded" && this.$store.state[this.stateCurrentRow].approval_status == "下書中";
    },

    allowToSubmit: {
      get: function get() {
        return this.allow_to_submit;
      },
      set: function set(v) {
        this.allow_to_submit = v;
      }
    },

    counterB3ErrorMessage: {
      get: function get() {
        return this.counter_b3_error_message;
      },
      set: function set(v) {
        this.counter_b3_error_message = v;
      }
    },
    counterB1: {
      get: function get() {
        return "" + this.counter_b1;
      },
      set: function set(v) {
        this.counter_b1 = v;
      }
    },
    counterB2: {
      get: function get() {
        return "" + this.counter_b2;
      },
      set: function set(v) {
        this.counter_b2 = v;
      }
    },
    counterB3: {
      get: function get() {
        return "" + this.counter_b3;
      },
      set: function set(v) {
        this.counter_b3 = v;
      }
    },
    counterB4: {
      get: function get() {
        return "" + this.counter_b4;
      },
      set: function set(v) {
        this.counter_b4 = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["b" /* filed_types */];
    },
    formFields: function formFields() {
      var _this = this;

      return {
        col0: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].reporting_period, { emit_input: true }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].company, { emit_input: true }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].department_in_charge, { emit_input: true }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].jurisdiction_classification, {
          emit_input: true,
          on_set_value: function on_set_value(data) {
            _this.singleTimeout("upd_license_jurisdiction_system_it", setTimeout(function () {
              _this.queuedBusEmit("upd_license_jurisdiction_system_it", {
                val: data == "IT所管システム"
              });
            }, 500));
            setTimeout(function () {
              _this.queuedBusEmit("upd_license_jurisdiction_system", {
                val: data == "EUC・その他"
              });
            }, 100);
          }
        }), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].reporting_system, {
          emit_input: true,
          disabled: false,
          required: true,
          field_style: " width: 100%;display: block;",
          listen_for: [{
            name: "upd_license_jurisdiction_system_it",
            mode: "disable_and_clean_if_value",
            disable_if_value: true
          }]

        })],
        col0a: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].team_in_charge, { emit_input: true })],
        col0b: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].linkage_ratio, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].last_linkage_ratio, {})],
        col0c: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].number_of_registered_devices, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].number_of_registered_licenses, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].number_of_software_packages_used, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].number_of_installed_software_to_be_linked, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].number_of_installation_software_licenses_attached, {})],
        col1: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].certificate_list_check, { emit_input: true })],
        col1a: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].new_license_registration, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].change_license_information, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].disposal_of_license, {})],
        col1b: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].unused_license, {})],
        col1c: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].reason_not_using, {})],
        col1d: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].expired_license, {})],
        col1e: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].expired_license_support, {})],
        col1f: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].certificate_remarks, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].ledger_check, { emit_input: true })],
        col2a: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].new_registration_of_equipment, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].change_device_information, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].disposal_of_device_information, {})],
        col2b: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].number_of_unattached, {})],
        col2c1: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].lack_of_license, {})],
        col2c2: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].lost_license_certificate, {})],
        col2c3: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].no_evidence_of_license_receipt, {})],
        col2c4: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].other, {})],
        col2d: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].remarks, {})],
        col3: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].contact_person, { label: "担当者（ﾌﾙﾈｰﾑ）" })],
        col3b: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].extension_number, {})],
        col4: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].admin_remark, {})],
        col4a: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].retraction_person_label, {})],
        col4b: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].retraction_reason, {})],
        col5: [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].created_date, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].last_update_date, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].approval_status, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].new_or_resubmit, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_4__rules_fields_inventory_report__["a" /* fields */].created_by_label, {})]

      };
    },
    inventsearchkeys: function inventsearchkeys() {
      return ["reporting_period", "company", "department_in_charge", "team_in_charge", "jurisdiction_classification", "reporting_system"];
    },
    searchkeys: function searchkeys() {
      return ["reporting_period", "company", "department", "team", "jurisdiction_classification", "system"];
    }
  },
  methods: {
    searchclear: function searchclear() {
      if (this.EditableUser == true) {
        this.selectmode = "";
        this.inventory_sub_search[this.Searchmap("company")] = "";
      } else {
        this.selectmode = "department";
      }
    },
    SelectSearch: function SelectSearch(p) {
      this.inventory_sub_search[this.Searchmap(p.id)] = p.value;

      this.localSeqId = "new";
      if (p.value == "") {
        this.selectmode = this.get_empty_searchkey(p.id);
      } else {
        this.selectmode = p.id;
      }
    },
    teammodechange: function teammodechange(p) {
      this.teammode = p;
      this.refreshteammode();

      this.selvalues[this.Searchmap('team')] = "";
      this.onselectchange();
    },
    onselectchange: function onselectchange() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.variousjudgment_step1(this.inventory_sub_search, mode);
    },
    get_empty_searchkey: function get_empty_searchkey(k) {
      var map = {
        reporting_period: "reporting_period",
        company: "",
        department: "company",
        jurisdiction_classification: "department",
        team: "department",
        system: "jurisdiction_classification"
      };
      return map[k];
    },
    onselectmode: function onselectmode(v) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      switch (v) {
        case "company":
          this.refreshteammode(mode);
          var target = {
            clear: ["department", "jurisdiction_classification", "team", "system"],
            open: ["department"],
            disable: ["jurisdiction_classification", "team", "system"],
            load_id: "department",
            api: "/master_belongs/list_department_use_subsearch",
            api_map: "belong",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
        case "department":
          this.refreshteammode(mode);
          var target = {
            clear: ["jurisdiction_classification", "team", "system"],
            open: ["jurisdiction_classification", "team"],
            disable: ["system"],
            load_id: "team",
            api: "/master_belongs/list_team_use_subsearch",
            api_map: "belong",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
        case "jurisdiction_classification":
          this.refreshteammode(mode);
          if (this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "EUC・その他") {
            var target = {
              clear: ["system"],
              open: ["team"],
              disable: ["system"],
              load_id: "team",
              api: "/master_belongs/list_team_use_subsearch",
              api_map: "belong",
              api_key: ""
            };
            this.selectmodeproc(target, mode);
          } else {
            var target = {
              clear: ["system", "team"],
              open: ["system"],
              disable: ["team"],
              load_id: "system",
              api: "/master_system/list_system_name_use_subsearch",
              api_map: "system",
              api_key: ""
            };
            this.selectmodeproc(target, mode);
          }
          break;
        case "system":
          this.refreshteammode(mode);
          this.onselectchange(mode);
          break;
        case "team":
          var target = {
            clear: ["system"],
            open: [],
            disable: [],
            load_id: "system",
            api: "/master_system/list_system_name_use_subsearch",
            api_map: "system",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
        case "reporting_period":
          this.refreshteammode(mode);
          this.onselectchange(mode);
          break;
        default:
          this.refreshteammode(mode);
          var target = {
            clear: ["department", "jurisdiction_classification", "team", "system"],
            open: ["company"],
            disable: ["department", "jurisdiction_classification", "team", "system"],
            load_id: "",
            api: "",
            api_map: "",
            api_key: ""
          };
          this.selectmodeproc(target, mode);
          break;
      }
    },
    selectmodeproc: function selectmodeproc(target, mode) {
      var _this2 = this;

      var api_subsearch = {};
      var temp = "";
      for (var i in this.searchkeys) {

        if (target.clear.includes(this.searchkeys[i])) {
          if (mode != "setonly") {
            this.inventory_sub_search[this.Searchmap(this.searchkeys[i])] = "";
            this.select_list[this.searchkeys[i]] = "";
          }
        }

        if (target.disable.includes(this.searchkeys[i])) {
          this.selectdisable[this.searchkeys[i]] = true;
        }
        if (target.open.includes(this.searchkeys[i])) {
          this.selectdisable[this.searchkeys[i]] = false;
        }

        if (target.api_map != "") {
          temp = this.Searchmap(this.searchkeys[i], target.api_map);
          if (temp != "") {
            api_subsearch[temp] = this.inventory_sub_search[this.Searchmap(this.searchkeys[i])];
          }
        }
      }
      if (this.selectdisable["jurisdiction_classification"] == false) {
        this.select_list["jurisdiction_classification"] = [{ val: "EUC・その他" }, { val: "IT所管システム" }];
      }

      if (target.load_id != "" && target.api != "") {
        var keyflag = false;
        if (target.api_key != "") {
          if (this.inventory_sub_search[this.Searchmap(target.api_key)] == "") {
            keyflag = true;
          }
        }
        if (keyflag != true) {
          this.$ajax.post_cached_queued(target.api, { sub_search: api_subsearch }, function (err, data) {
            if (err) {
              _this2.$notify({
                title: "データが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000
              });
              return;
            }
            _this2.select_list[target.load_id] = data;
            _this2.onselectchange(mode);
          });
        } else {
          this.select_list[target.load_id] = [];
          this.onselectchange(mode);
        }
      } else {
        this.onselectchange(mode);
      }
    },
    Searchmap: function Searchmap(v) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.use_key;

      if (this.search_map == false) {
        this.search_map = { common: {
            reporting_period: "reporting_period",
            company: "company",
            jurisdiction_classification: "jurisdiction_classification",
            department: "department",
            team: "team",
            system: "system"
          },
          inventory: {
            reporting_period: "reporting_period",
            company: "company",
            jurisdiction_classification: "jurisdiction_classification",
            department: "department_in_charge",
            team: "team_in_charge",
            system: "reporting_system"
          },
          device: {
            company: "company",
            jurisdiction_classification: "equipment_in_charge_classification",
            department: "equipment_in_charge_department",
            team: "equipment_in_charge_team",
            system: "equipment_in_charge_system_it"
          },
          cert: {
            company: "company",
            jurisdiction_classification: "jurisdiction_classification",
            department: "licensed_department",
            team: "license_jurisdiction_team",
            system: "license_jurisdiction_system"
          },
          belong: {
            company: "company",
            department: "department",
            team: "team"
          },
          system: {
            company: "company",
            department: "equipment_in_charge_department",
            team: "system_jurisdiction_team",
            system: "system_name"
          }
        };

        this.reverse_map = {};
        for (var k in this.search_map) {
          for (var k2 in this.search_map[k]) {
            this.reverse_map[this.search_map[k][k2]] = k2;
          }
        }
      }
      var temp = this.reverse_map[v];
      return this.search_map[mode][temp] || "";
    },
    SetSubSearch: function SetSubSearch() {

      var map = this.searchkeys;
      for (var k in map) {
        if (this.EditableUser == true || map[k] != "department") {
          if (map[k] == "company") {
            if (this.EditableUser == true) {
              this.inventory_sub_search[this.Searchmap(map[k])] = "";
            }
          } else if (map[k] == "reporting_period") {
            this.inventory_sub_search[this.Searchmap(map[k])] = "";
          } else {
            this.inventory_sub_search[this.Searchmap(map[k])] = "";
            this.select_list[map[k]] = [];
            this.select_disable[map[k]] = true;
          }
        }
      }

      if (this.EditableUser == false) {
        if (typeof this.pri_sub_search[this.Searchmap("company")] == "undefined") {
          this.pri_sub_search[this.Searchmap("company")] = this.inventory_sub_search[this.Searchmap("company")];
        }
        if (typeof this.pri_sub_search[this.Searchmap("department")] == "undefined") {
          this.pri_sub_search[this.Searchmap("department")] = this.inventory_sub_search[this.Searchmap("department")];
        }
      }

      var flag = false;
      for (var k in map) {
        if (map[k] != "company" || this.EditableUser == true) {
          flag = false;
          if (typeof this.pri_sub_search[this.Searchmap(map[k])] != "undefined") {
            for (var l in this.select_list[map[k]]) {
              if (this.select_list[map[k]][l].val == this.pri_sub_search[this.Searchmap(map[k])]) {
                flag = true;
                break;
              }
            }
            if (flag == false) {
              this.select_list[map[k]] = [{ val: this.pri_sub_search[this.Searchmap(map[k])] }];
            }
            this.inventory_sub_search[this.Searchmap(map[k])] = this.pri_sub_search[this.Searchmap(map[k])];
            this.onselectmode(map[k], "setonly");
          }
        }
      }
    },
    setState2PriSubSearch: function setState2PriSubSearch() {
      var map = this.searchkeys;
      this.pri_sub_search = {};
      for (var key in map) {
        if (this.$store.state[this.stateCurrentRow][this.Searchmap(map[key])] != "" && typeof this.$store.state[this.stateCurrentRow][this.Searchmap(map[key])] != "undefined") {
          this.pri_sub_search[this.Searchmap(map[key])] = this.$store.state[this.stateCurrentRow][this.Searchmap(map[key])];
        }
      }
    },
    updatecertcheck: function updatecertcheck() {
      this.certeditable = this.$store.state[this.stateCurrentEditing]["certificate_list_check"] == "不一致";
      var v = this.certeditable;
      if (v == false && this.$store.state[this.stateCurrentEditing]["certificate_list_check"] != "") {
        this.$store.state[this.stateCurrentRow]["new_license_registration"] = "無";
        this.$store.state[this.stateCurrentRow]["change_license_information"] = "無";
        this.$store.state[this.stateCurrentRow]["disposal_of_license"] = "無";
        this.$store.state[this.stateCurrentEditing]["new_license_registration"] = "無";
        this.$store.state[this.stateCurrentEditing]["change_license_information"] = "無";
        this.$store.state[this.stateCurrentEditing]["disposal_of_license"] = "無";
      } else if (v == true) {
        this.$store.state[this.stateCurrentRow]["new_license_registration"] = "";
        this.$store.state[this.stateCurrentRow]["change_license_information"] = "";
        this.$store.state[this.stateCurrentRow]["disposal_of_license"] = "";
        this.$store.state[this.stateCurrentEditing]["new_license_registration"] = "";
        this.$store.state[this.stateCurrentEditing]["change_license_information"] = "";
        this.$store.state[this.stateCurrentEditing]["disposal_of_license"] = "";
      }
    },
    updatedevicecheck: function updatedevicecheck() {
      this.deveditable = this.$store.state[this.stateCurrentEditing]["ledger_check"] == "不一致";
      var v = this.deveditable;
      if (v == false && this.$store.state[this.stateCurrentEditing]["ledger_check"] != "") {
        this.$store.state[this.stateCurrentRow]["new_registration_of_equipment"] = "無";
        this.$store.state[this.stateCurrentRow]["change_device_information"] = "無";
        this.$store.state[this.stateCurrentRow]["disposal_of_device_information"] = "無";
        this.$store.state[this.stateCurrentEditing]["new_registration_of_equipment"] = "無";
        this.$store.state[this.stateCurrentEditing]["change_device_information"] = "無";
        this.$store.state[this.stateCurrentEditing]["disposal_of_device_information"] = "無";
      } else if (v == true) {
        this.$store.state[this.stateCurrentRow]["new_registration_of_equipment"] = "";
        this.$store.state[this.stateCurrentRow]["change_device_information"] = "";
        this.$store.state[this.stateCurrentRow]["disposal_of_device_information"] = "";
        this.$store.state[this.stateCurrentEditing]["new_registration_of_equipment"] = "";
        this.$store.state[this.stateCurrentEditing]["change_device_information"] = "";
        this.$store.state[this.stateCurrentEditing]["disposal_of_device_information"] = "";
      }
    },
    updateeditable: function updateeditable() {
      this.certeditable = this.$store.state[this.stateCurrentEditing]["certificate_list_check"] == "不一致";
      this.deveditable = this.$store.state[this.stateCurrentEditing]["ledger_check"] == "不一致";
    },
    updateviewdata: function updateviewdata() {
      this.update_Date = __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].format_date_time(this.$store.state[this.stateCurrentRow]["last_update_date"]);
      this.create_Date = __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].format_date(this.$store.state[this.stateCurrentRow]["created_date"]);
      this.status_value = this.$store.state[this.stateCurrentRow]["approval_status"] || "";
      this.new_or_resubmit_value = this.$store.state[this.stateCurrentRow]["new_or_resubmit"] || "";
      this.created_by_value = this.$store.state[this.stateCurrentRow]["created_by_label"] || "";
    },
    clearviewdata: function clearviewdata() {
      this.update_Date = "";
      this.create_Date = "";
      this.status_value = "";
      this.new_or_resubmit_value = "";
      this.created_by_value = "";
    },
    alretoff: function alretoff() {
      this.alrettotallicense = false;
      this.alretother = false;
      this.alretunusedlicense = false;
      this.alretexpiredlicense = false;
      this.alretoutside = false;
      this.alretremarkexpiredlicense = false;
    },
    adminremarkeditbtn: function adminremarkeditbtn() {
      this.pagemode = "adminremarkedit";
    },
    rejecteditbtn: function rejecteditbtn() {
      if (this.$store.state[this.stateCurrentRow].created_by == __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID")) {
        this.processApprovalCancel();
      } else {
        this.pagemode = "rejectedit";
      }
    },
    adminremarkeditcancelbtn: function adminremarkeditcancelbtn() {
      this.commonValidateFieldsClear(this, function () {});
      this.readOnly4 = true;
      this.readOnly3 = true;
      this.readOnly2 = true;
      this.inventory_sub_search = this.last_search;
      this.pagemode = "load";
    },
    rejectcancelbtn: function rejectcancelbtn() {
      this.commonValidateFieldsClear(this, function () {});
      this.readOnly4 = true;
      this.readOnly3 = true;
      this.readOnly2 = true;
      this.inventory_sub_search = this.last_search;
      this.pagemode = "load";
    },
    editbtn: function editbtn() {
      this.pagemode = "edit";
    },
    editcancelbtn: function editcancelbtn() {
      this.commonValidateFieldsClear(this, function () {});
      this.readOnly4 = true;
      this.readOnly3 = true;
      this.readOnly2 = true;
      this.inventory_sub_search = this.last_search;
      this.pagemode = "load";
    },
    getStatisticalData: function getStatisticalData() {
      var _this3 = this;

      this.$ajax.post("/" + this.api_name + "/statistical_output/", { sub_search: this.inventory_sub_search }, function (err, result) {
        if (err) {
          _this3.$notify({
            title: "統計データの読込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          var tempstore = _.clone(_this3.$store.state[_this3.stateCurrentRow]);
          for (var key in result) {
            _this3.$store.state[_this3.stateCurrentEditing][key] = result[key];
            tempstore[key] = result[key];
            if (key == "jurisdiction_system") {
              _this3.inventory_sub_search[key] = result[key];
            }
          }

          if (_this3.page_mode == "new") {
            _this3.$store.state[_this3.stateCurrentEditing]["lack_of_license"] = 0;
            _this3.$store.state[_this3.stateCurrentEditing]["lost_license_certificate"] = 0;
            _this3.$store.state[_this3.stateCurrentEditing]["no_evidence_of_license_receipt"] = 0;
            _this3.$store.state[_this3.stateCurrentEditing]["other"] = 0;
            tempstore["lack_of_license"] = 0;
            tempstore["lost_license_certificate"] = 0;
            tempstore["no_evidence_of_license_receipt"] = 0;
            tempstore["other"] = 0;
            tempstore["certificate_list_check"] = "";
            tempstore["ledger_check"] = "";
            _this3.$store.state[_this3.stateCurrentEditing]["certificate_list_check"] = "";
            _this3.$store.state[_this3.stateCurrentEditing]["ledger_check"] = "";
          }
        }
        _this3.$store.state[_this3.stateCurrentRow] = tempstore;
      });
    },
    onchangemode: function onchangemode() {
      switch (this.page_mode) {
        case "search":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.refreshfield();
          break;
        case "load":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.refreshfield();
          this.inventory_admin_edit();
          break;
        case "load2":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.loadFormData();
          break;
        case "loaded":
          break;
        case "not_found":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.inventory_period_inquiry();
          break;
        case "new":
          this.onNewCreate();
          break;
        case "edit":
          this.alretoff();
          this.onEdit();
          break;
        case "adminremarkedit":

          this.onAdminRemarkEdit();
          break;
        case "rejectedit":
          this.onRejectEdit();
          break;
        case "outside":
          this.alretoutside = true;
          break;
        default:
          this.refreshfield();
      }
    },
    inventory_period_inquiry: function inventory_period_inquiry() {
      var _this4 = this;

      this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/", { reporting_period: this.inventory_sub_search["reporting_period"] }, function (err, result) {
        if (err) {
          _this4.$notify({
            title: "棚卸編集可能データの読込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          if (result.editable == "許可") {
            _this4.pagemode = "new";
            _this4.admineditable = true;
          } else {
            _this4.pagemode = "outside";
            _this4.admineditable = false;
          }
        }
      });
    },
    inventory_admin_edit: function inventory_admin_edit() {
      var _this5 = this;

      this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/", { reporting_period: this.inventory_sub_search["reporting_period"] }, function (err, result) {
        if (err) {
          _this5.$notify({
            title: "棚卸編集可能データの読込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          if (result.editable == "許可") {
            _this5.admineditable = true;
          } else {
            _this5.admineditable = false;
          }
        }
        _this5.pagemode = "load2";
      });
    },
    onNewCreate: function onNewCreate() {
      this.refreshfield();
      this.readOnly2 = false;
      this.getStatisticalData();
      this.updateeditable();

      if (this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "EUC・その他") {
        this.inventory_sub_search[this.Searchmap("system")] = "";
      } else if (this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "IT所管システム") {
        this.inventory_sub_search[this.Searchmap("team")] = "";
      }
    },
    onEdit: function onEdit() {
      this.readOnly2 = false;
      for (var key in this.$store.state[this.stateCurrentRow]) {
        this.$store.state[this.stateCurrentEditing][key] = this.$store.state[this.stateCurrentRow][key];
      }
      if (this.$store.state[this.stateCurrentRow].approval_status == "差戻") {
        this.getStatisticalData();
      }
      this.updateeditable();
    },
    onAdminRemarkEdit: function onAdminRemarkEdit() {
      this.readOnly3 = false;
    },
    onRejectEdit: function onRejectEdit() {
      this.$store.state[this.stateCurrentRow].retraction_reason = "";
      this.readOnly4 = false;
    },
    reportmodebtn: function reportmodebtn() {
      var _this6 = this;

      this.$ajax.post("/" + this.api_name + "/get_department_team_report_number/", { params: this.inventory_sub_search }, function (err, result) {
        if (err) {
          _this6.$notify({
            title: "データの読込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          if (result.team_number > 0 || result.department_number > 0) {
            var tit = _this6.reportmodewords + "できません";
            var msg = "変更対象の報告が作成されています。<BR><font color='red'>実行には報告を削除する必要があります。</font>";
            __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("reportmodeinventoryreportModalReject", {
              title: tit,
              message: msg,
              yes_label: "戻る",
              no_label: "",
              yes_color: "info",
              no_color: "",
              model_height: "50"
            });
          } else {
            var msg = _this6.reportmodewords + "しますが<BR>よろしいでしょうか?";
            __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("reportmodeinventoryreportModal", {
              title: "",
              message: msg,
              yes_label: "実行",
              no_label: "キャンセル",
              yes_color: "danger",
              no_color: "info",
              model_height: "50"
            });
          }
        }
      });
    },
    onConfirmReportModeChange: function onConfirmReportModeChange(mode) {
      var _this7 = this;

      if (mode != "yes") {
        return;
      }

      this.$ajax.post("/" + this.api_name + "/set_department_team_report_mode/", { params: this.inventory_sub_search }, function (err, result) {
        if (err) {
          _this7.$notify({
            title: "データの書込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {

          var message = "報告単位が変更されました。";
          __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("reportmodeinventoryreportEndModal", {
            message: message,
            title: "",
            yes_label: "",
            no_label: "OK",
            yes_color: "",
            no_color: "",
            model_height: "50",
            model_width: "390px"
          });
        }
      });
    },
    onConfirmReportModeChangeEnd: function onConfirmReportModeChangeEnd(mode) {
      this.teammodechange(this.teammode == false);
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("deleteinventoryreportModal", {
        title: "削除",
        message: "棚卸報告の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onLoad: function onLoad(new_seq_id) {
      this.localSeqId = new_seq_id;
      this.setState2PriSubSearch();
      this.SetSubSearch();
      this.setstateCurrentEditing();
      this.alretoff();
      this.numbersUpdated_process("", this.stateCurrentEditing);
      this.last_search = _.clone(this.inventory_sub_search);
      this.updateviewdata();
    },
    setstateCurrentEditing: function setstateCurrentEditing() {
      var map = ["certificate_list_check", "new_license_registration", "change_license_information", "disposal_of_license", "unused_license", "reason_not_using", "expired_license", "expired_license_support", "certificate_remarks", "ledger_check", "new_registration_of_equipment", "change_device_information", "disposal_of_device_information", "number_of_unattached", "lack_of_license", "lost_license_certificate", "no_evidence_of_license_receipt", "other", "remarks", "contact_person", "extension_number", "admin_remark", "created_date", "last_update_date", "approval_status", "new_or_resubmit", "created_by_label", "retraction_person", "retraction_reason"];
      for (var m in map) {
        if (typeof this.$store.state[this.stateCurrentRow][map[m]] != "undefined") {
          this.$store.state[this.stateCurrentEditing][map[m]] = _.clone(this.$store.state[this.stateCurrentRow][map[m]]);
        }
      }
    },
    refreshfield: function refreshfield() {
      this.local_seq_id = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
      var tempstore = _.clone(this.$store.state[this.stateCurrentRow]);
      tempstore = {
        seq_id: this.local_seq_id
      };

      this.$store.state[this.stateCurrentEditing] = [];
      for (var key in this.formFields) {
        for (var v in this.formFields[key]) {
          if (key != "col0") {
            tempstore[this.formFields[key][v].id] = "";
            this.$store.state[this.stateCurrentEditing][[this.formFields[key][v].id]] = "";
          } else {
            if (typeof this.inventory_sub_search[this.formFields[key][v].id] != "undefined") {
              tempstore[this.formFields[key][v].id] = this.inventory_sub_search[this.formFields[key][v].id];
            }
          }
        }
      }

      for (var k in this.inventory_sub_search) {
        tempstore[k] = this.inventory_sub_search[k];
        this.$store.state[this.stateCurrentEditing][k] = this.inventory_sub_search[k];
      }
      this.$store.state[this.stateCurrentRow] = tempstore;
      this.clearviewdata();
      this.numbersUpdated(false);
      this.alretoff();
    },
    refreshteammode: function refreshteammode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (mode != "setonly") {
        this.alretteamreport = false;
        this.alretdepartmentreport = false;
      }
    },
    numbersUpdated: function numbersUpdated(o) {
      this.numbersUpdated_process(o, this.stateCurrentEditing);
    },
    numbersUpdated_process: function numbersUpdated_process(o, SCE) {
      this.totallicense = parseInt(this.$store.state[SCE]["lack_of_license"] || 0) + parseInt(this.$store.state[SCE]["lost_license_certificate"] || 0) + parseInt(this.$store.state[SCE]["no_evidence_of_license_receipt"] || 0) + parseInt(this.$store.state[SCE]["other"] || 0);
    },
    judesubseachmode: function judesubseachmode(search) {
      var flag = true;
      var map = this.inventsearchkeys;
      for (var key in map) {
        if (!(map[key] == "reporting_system" && search["jurisdiction_classification"] == "EUC・その他" || map[key] == "team_in_charge" && (search["jurisdiction_classification"] == "IT所管システム" || this.teammode == false))) {
          if (search[map[key]] == "" || typeof search[map[key]] == "undefined") {
            flag = false;
          }
        }
      }
      return flag;
    },
    variousjudgment_step1: function variousjudgment_step1(search) {
      var _this8 = this;

      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      var tflag = true;
      var map = this.inventsearchkeys;
      for (var key in map) {
        if (map[key] == "reporting_period" || map[key] == "company" || map[key] == "department_in_charge") {
          if (search[map[key]] == "" || typeof search[map[key]] == "undefined") {
            tflag = false;
          }
        }
      }

      if (tflag) {
        this.$ajax.post("/" + this.api_name + "/get_department_team_report_mode/", { params: this.inventory_sub_search }, function (err, result) {
          if (err) {
            _this8.$notify({
              title: "データの読込に失敗しました。",
              text: err,
              type: "error",
              duration: 10000
            });
          } else {
            if (result.team_unit_reporting > 0) {
              _this8.teammode = true;
              _this8.alretteamreport = true;
            } else {
              _this8.teammode = false;
              _this8.alretdepartmentreport = true;
              _this8.selvalues[_this8.Searchmap('team')] = "";
            }
            _this8.variousjudgment_step2(search, mode);
          }
        });
      } else {
        this.teammode = false;
        this.variousjudgment_step2(search, mode);
      }
    },
    variousjudgment_step2: function variousjudgment_step2(search) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      if (mode == "setonly") {
        return;
      }
      if (this.judesubseachmode(search) == true) {
        this.pagemode = "load";
      } else {
        this.pagemode = "search";
      }
    },
    loadFormData: function loadFormData() {
      var _this9 = this;

      mdebug("page_0071_inventory_report mounting");

      if (this.judesubseachmode(this.inventory_sub_search) == false) {
        this.pagemode = "search";
        return;
      }
      var certificate_software_number = this.$route.params.certificate_software_number;
      this.$ajax.post("/" + this.api_name + "/get_by_search_data/", { params: this.inventory_sub_search, seq_id: this.localSeqId }, function (err, result) {
        if (err) {
          if (err == "not_found") {
            _this9.pagemode = "not_found";
          } else {

            _this9.$notify({
              title: "データの読込に失敗しました。",
              text: err,
              type: "error",
              duration: 10000
            });
          }
        } else {
          _this9.$store.state[_this9.stateCurrentRow] = result.data;
          _this9.pagemode = "loaded";
          _this9.onLoad(result.data.seq_id);
        }
      });
    },
    ApprovalStage1: function ApprovalStage1() {
      __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("stage1ConfirmatioInventory", {
        title: "",
        message: "承認を行います。よろしいですか？",
        yes_label: "承認",
        no_label: "戻る",
        yes_color: "info",
        no_color: "default",
        model_height: "50"
      });
    },
    ApprovalStage2: function ApprovalStage2(mode) {
      var _this10 = this;

      if (mode != "yes") {
        return;
      }
      var arr = [this.$store.state[this.stateCurrentRow].a_seq_id];
      var hash = 0;
      arr.forEach(function (e) {
        hash = hash + (e + 3) * 2;
      });
      this.$ajax.post("/approval_history_inventory/approve", { arr: arr, hash: hash }, function (err, response) {
        console.log({ response: response });
        if (err) {
          var title = "データの承認に失敗しました。";
          _this10.$notify({
            title: title,
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          _this10.back_jurisdiction_classification = _this10.inventory_sub_search.jurisdiction_classification;
          __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("ConfirmatioInvventorybackToList", {
            title: "承認が完了しました。",
            message: "",
            yes_label: "",
            no_label: "戻る",
            yes_color: "info",
            no_color: "default",
            model_height: "50"
          });
        }
      });
    },
    processApproval: function processApproval(approve_mode) {
      var _this11 = this;

      var changes = {
        seq_id: this.$store.state[this.stateCurrentRow].a_seq_id,
        update_time: __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format("YYYY/MM/DD HH:mm:ss"),
        retraction_reason: this.$store.state[this.stateCurrentEditing].retraction_reason,
        retraction_person: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID") || ""
      };
      var created_by_flag = this.$store.state[this.stateCurrentRow].created_by == __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID");
      if (approve_mode == "cancel") {
        this.$ajax.post('/approval_history_inventory/prepare_to_approve/' + this.$store.state[this.stateCurrentRow].a_seq_id, { changes: changes, approve_mode: approve_mode }, function (err, result) {
          if (err) {
            _this11.$notify({
              title: 'データの承認に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          } else {
            _this11.back_jurisdiction_classification = _this11.inventory_sub_search.jurisdiction_classification;
            if (created_by_flag == true) {
              var c_title = "";
              var message = "申請が取戻されました";
            } else {
              var c_title = "申請が差戻されました";
              var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";
            }
            __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("confirminventoryonRejectEmbeddednotification", {
              message: message,
              title: c_title,
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "",
              model_height: "50",
              model_width: "390px"
            });
          }
        });
      } else {}
    },
    onReject: function onReject(mode) {
      var _this12 = this;

      if (mode == "yes") {
        if (this.$store.state[this.stateCurrentRow].approval_status == "報告済") {
          var arr = [{
            a_seq_id: this.$store.state[this.stateCurrentRow].a_seq_id,
            seq_id: this.$store.state[this.stateCurrentRow].seq_id,
            retraction_reason: this.$store.state[this.stateCurrentEditing].retraction_reason

          }];
          var hash = 0;
          arr.forEach(function (e) {
            hash = hash + (e.seq_id + 3) * 2;
          });

          this.$ajax.post("/" + this.api_name + "/admin_reject/", { arr: arr, hash: hash }, function (err, response) {
            if (err) {
              _this12.$notify({
                title: "差戻に失敗しました",
                text: err,
                type: "error",
                duration: 10000
              });
            } else {
              _this12.back_jurisdiction_classification = _this12.inventory_sub_search.jurisdiction_classification;
              _this12.pagemode = "load";
              var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";
              __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("confirminventoryonRejectEmbeddednotification", {
                message: message,
                title: "申請が差戻されました",
                yes_label: "",
                no_label: "OK",
                yes_color: "",
                no_color: "",
                model_height: "50",
                model_width: "390px"
              });
            }
          });
        } else {

          this.processApproval("cancel");
        }
      }
    },
    onRejectEmbedded: function onRejectEmbedded() {
      var created_by_flag = this.$store.state[this.stateCurrentRow].created_by == __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userID");
      if (created_by_flag == true) {
        var c_title = "申請を取戻します。";
        var c_yes_label = "取戻";
      } else {
        var c_title = "申請を差戻します。";
        var c_yes_label = "差戻";
      }

      __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("confirminventoryonRejectEmbedded", {
        message: "よろしいですか？",
        title: c_title,
        yes_label: c_yes_label,
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    processApprovalCancel: function processApprovalCancel() {
      console.log("processApprovalCancel");
      this.onRejectEmbedded();
    },
    setdefseach: function setdefseach() {
      if (typeof this.$route.params.inventory_sub_search != "undefined") {
        var load_search = _.clone(this.$route.params.sub_search);
        for (var key in __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(load_search)) {
          this.pri_sub_search[this.Searchmap(load_search[key])] = load_search[key];
        }
      }
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      var _this13 = this;

      if (mode == "yes") {
        var option = {
          a_seq_id: this.$store.state[this.stateCurrentRow].a_seq_id,
          seq_id: this.$store.state[this.stateCurrentRow].seq_id
        };
        this.$ajax.post("/" + this.api_name + "/delete", option, function (err, response) {
          if (err) {
            _this13.$notify({
              title: "削除に失敗しました",
              text: err,
              type: "error",
              duration: 10000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("ConfirmatioInvventorybackToList", {
              title: "",
              message: "棚卸報告が削除されました",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "",
              model_height: "50",
              model_width: "390px"
            });
          }
        });
      }
    },
    initExportFile: function initExportFile() {
      this.api_request_options = { sub_search: "inventory_sub_search", seq_id: this.$store.state[this.stateCurrentRow].seq_id };

      __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("runInventoryExportreportDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        sub_search: this.inventory_sub_search,
        url: "/inventory_report/export_form_data/"
      });
    },
    backToList: function backToList() {
      var device_back_to_list_name = window.sessionStorage.getItem("device_back_to_list_name");
      var back_search = _.clone(this.inventory_sub_search);

      if (this.back_jurisdiction_classification == "") {
        if (typeof this.$route.params.force_return_jurisdiction_classification != "undefined") {
          back_search.jurisdiction_classification = this.$route.params.force_return_jurisdiction_classification;
        }
      } else {
        back_search.jurisdiction_classification = this.back_jurisdiction_classification;
      }
      if ((device_back_to_list_name || "") != "") {
        return this.$router.push({ name: device_back_to_list_name, params: { sub_search: back_search } });
      } else {
        return this.$router.push({ name: 'page_0070_inventory_tabs_management', params: { sub_search: back_search } });
      }
    },
    adminremarksetbtn: function adminremarksetbtn() {
      var _this14 = this;

      var changes = {
        seq_id: this.localSeqId,
        admin_remark: this.$store.state[this.stateCurrentEditing]["admin_remark"]
      };
      this.$ajax.post("/" + this.api_name + "/set/" + this.localSeqId, { changes: changes }, function (err, response) {
        if (err) {
          _this14.$notify({
            title: "データの保存に失敗しました。",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {}
        _this14.pagemode = "load";
      });
    },
    onInventorySaveCondirmed: function onInventorySaveCondirmed(mode) {
      var _this15 = this;

      if (mode == "yes") {

        if (this.$store.state[this.stateCurrentRow].new_or_resubmit != "新規" && this.$store.state[this.stateCurrentRow].new_or_resubmit != "再提出") {
          this.$store.state[this.stateCurrentEditing].new_or_resubmit = "新規";
        }

        if (this.$store.state[this.stateCurrentRow].approval_status == "差戻") {
          this.$store.state[this.stateCurrentEditing].retraction_person = "";
          this.$store.state[this.stateCurrentEditing].retraction_person_name = "";
          this.$store.state[this.stateCurrentEditing].retraction_reason = "";
        }

        if (this.$store.state[this.stateCurrentRow].approval_status == "報告済") {
          var message = "棚卸報告の上書き保存が完了しました。";
        } else {
          var message = "棚卸報告の下書き保存が完了しました。<BR><BR><font color='red'>※棚卸報告の編集が完了した場合は、<BR>下書き保存後、申請を行ってください。</font>";
          this.$store.state[this.stateCurrentEditing].approval_status = "下書中";
        }

        var map = this.searchkeys;
        for (var k in map) {
          this.$store.state[this.stateCurrentRow][this.Searchmap(map[k])] = this.inventory_sub_search[this.Searchmap(map[k])];
          this.$store.state[this.stateCurrentEditing][this.Searchmap(map[k])] = this.inventory_sub_search[this.Searchmap(map[k])];
        }

        var certificate_software_number = this.$route.params.certificate_software_number;
        this.$ajax.post("/" + this.api_name + "/get_by_search_data/", { params: this.inventory_sub_search, seq_id: "new" }, function (err, result) {
          if (err == "not_found" || _this15.localSeqId != "new") {
            _this15.commonSaveInfo(_this15, _this15.api_name, {}, function (err, data_result) {
              if (err == null && data_result && data_result && data_result.seq_id > -1) {
                _this15.saved_seq_id = data_result.seq_id;
              }
              __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("confirmInventorySaveEnd", {
                message: message,
                title: "",
                yes_label: "",
                no_label: "OK",
                yes_color: "",
                no_color: "",
                model_height: "50"
              });
              _this15.pagemode = "load";
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("confirmInventorySaveReject", {
              message: "<font color='red' size='2'>対象の棚卸報告は既に作成されています。</font>",
              title_style: "color: red",
              title: "※棚卸報告を作成できません※",
              yes_label: "",
              no_label: "戻る",
              yes_color: "",
              no_color: "",
              model_height: "50"
            });
            _this15.pagemode = "load";
          }
        });
      }
    },
    onInventoryExportCondirmed: function onInventoryExportCondirmed(mode) {
      if (mode == "yes") {
        this.initExportFile();
      } else if (mode == "no") {}
    },
    onCloseConfimation: function onCloseConfimation(mode) {
      if (mode == "yes") {
        var message = "棚卸報告を申請しました。<br>報告内容をExcelで出力しますか？";
        __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("confirmInventoryExport", {
          message: message,
          title: "",
          yes_label: "はい(Excel出力)",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
        this.pagemode = "load";
      } else {}
    },
    onCloseExportFile: function onCloseExportFile() {},
    onLocalSaveInventory: function onLocalSaveInventory() {
      var _this16 = this;

      console.log("onLocalSave");

      this.commonValidateFields(this, {}, function (error_found) {
        if (error_found != false) {
          return;
        }
        _this16.alretunusedlicense = (_this16.$store.state[_this16.stateCurrentEditing]["unused_license"] || 0) != 0 && (_this16.$store.state[_this16.stateCurrentEditing]["reason_not_using"] || "") == "";
        if (_this16.alretunusedlicense == true) {
          return;
        }

        _this16.alretexpiredlicense = (_this16.$store.state[_this16.stateCurrentEditing]["expired_license"] || 0) != 0 && (_this16.$store.state[_this16.stateCurrentEditing]["expired_license_support"] == "　" || _this16.$store.state[_this16.stateCurrentEditing]["expired_license_support"] == "");
        if (_this16.alretexpiredlicense == true) {
          return;
        }

        _this16.alretremarkexpiredlicense = _this16.$store.state[_this16.stateCurrentEditing]["expired_license_support"] == "その他(備考に詳細を記入)" && _this16.$store.state[_this16.stateCurrentEditing]["certificate_remarks"] == "";
        if (_this16.alretremarkexpiredlicense == true) {
          return;
        }
        _this16.alrettotallicense = _this16.total_license != _this16.$store.state[_this16.stateCurrentRow]["number_of_unattached"];
        if (_this16.alrettotallicense == true) {
          return;
        }
        _this16.alretother = (_this16.$store.state[_this16.stateCurrentEditing]["other"] || 0) != 0 && (_this16.$store.state[_this16.stateCurrentEditing]["remarks"] || "") == "";
        if (_this16.alretother == true) {
          return;
        }
        if (_this16.$store.state[_this16.stateCurrentEditing]["certificate_list_check"] == "一致") {
          _this16.$store.state[_this16.stateCurrentRow]["new_license_registration"] = "無";
          _this16.$store.state[_this16.stateCurrentRow]["change_license_information"] = "無";
          _this16.$store.state[_this16.stateCurrentRow]["disposal_of_license"] = "無";
          _this16.$store.state[_this16.stateCurrentEditing]["new_license_registration"] = "無";
          _this16.$store.state[_this16.stateCurrentEditing]["change_license_information"] = "無";
          _this16.$store.state[_this16.stateCurrentEditing]["disposal_of_license"] = "無";
        }
        if (_this16.$store.state[_this16.stateCurrentEditing]["ledger_check"] == "一致") {
          _this16.$store.state[_this16.stateCurrentRow]["new_registration_of_equipment"] = "無";
          _this16.$store.state[_this16.stateCurrentRow]["change_device_information"] = "無";
          _this16.$store.state[_this16.stateCurrentRow]["disposal_of_device_information"] = "無";
          _this16.$store.state[_this16.stateCurrentEditing]["new_registration_of_equipment"] = "無";
          _this16.$store.state[_this16.stateCurrentEditing]["change_device_information"] = "無";
          _this16.$store.state[_this16.stateCurrentEditing]["disposal_of_device_information"] = "無";
        }
        if (_this16.$store.state[_this16.stateCurrentRow]["approval_status"] != "報告済") {
          var message = "棚卸報告を下書き保存します。よろしいですか？";
        } else {
          var message = "棚卸報告を上書き保存します。よろしいですか？";
        }
        __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("confirmInventorySave", {
          message: message,
          title: "",
          yes_label: "はい",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onConfirmExecuteProcessConfirmation: function onConfirmExecuteProcessConfirmation() {
      __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("inventoryApplicationConfimationModal", {
        application_mode: "inventory",

        seq_id: this.localSeqId,
        is_surplus: this.isSurplus
      });
    },
    onConfirmInfomation: function onConfirmInfomation() {
      __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("inventoryApplicationConfimationModal", {
        application_mode: "inventory",
        ref_id: this.$store.state[this.stateCurrentRow].ref_id || false,
        modal_is_read_only: true,
        seq_id: this.localSeqId,
        approval_history_id: this.$store.state[this.stateCurrentRow].a_seq_id || false
      });
    },
    loadReportingPeriodList: function loadReportingPeriodList() {
      var _this17 = this;

      this.$ajax.post("/" + this.api_name + "/get_reporting_period_list", {}, function (err, data) {
        data.forEach(function (d) {
          _this17.reportingPeriodList.push(d.reporting_period);
        });
      });
    },
    onmouted: function onmouted() {
      var _this18 = this;

      this.commonLoadRecord({}, function (err, result) {
        if (err) {}

        if (_this18.$route.params.seq_id != "new") {
          _this18.onLoad(_this18.$route.params.seq_id);
          _this18.inventory_admin_edit();
          _this18.variousjudgment_step1(_this18.inventory_sub_search, "setonly");
          _this18.pagemode = "loaded";
        } else {
          _this18.localSeqId = "new";
          _this18.pagemode = "search";
          _this18.setdefseach();
          _this18.SetSubSearch();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this19 = this;

    this.api_request_options = { sub_search: "inventory_sub_search", seq_id: this.$route.params.seq_id };
    this.readOnly4 = true;
    this.readOnly3 = true;
    this.readOnly2 = true;
    if (typeof this.$route.params.seq_id == "undefined") {
      this.$route.params.seq_id = "new";
    }

    this.$ajax.post("/master_inventory_reporting_period/list_reporting_period", {}, function (err, data) {
      if (err) {
        _this19.$notify({
          title: "報告期分が読み込めませんでした",
          text: err,
          type: "error",
          duration: 10000
        });
      }
      _this19.reportingPeriodList = data;
      if (_this19.EditableUser == true) {
        _this19.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
          if (err) {
            _this19.$notify({
              title: "所管会社のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          }
          _companies.forEach(function (d) {
            d.value = d.val;
          });
          _this19.companylist = _companies;
          if (_this19.EditableUser == false) {
            for (var k in _this19.companylist) {
              _this19.inventory_sub_search.company = _this19.companylist[k].val;
              break;
            }
          }
          _this19.selectmode = "";
          _this19.onmouted();
        });
      } else {
        var usercompany = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("selectedCompany") || "";
        var userdepartment = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].localStorage.get("userDepartment") || "";
        _this19.select_list["company"] = [{ val: usercompany, value: usercompany }];
        _this19.select_list["department"] = [{ val: userdepartment, value: userdepartment }];
        _this19.inventory_sub_search[_this19.Searchmap("company")] = usercompany;
        _this19.inventory_sub_search[_this19.Searchmap("department")] = userdepartment;
        _this19.selectmode = "department";
        _this19.onmouted();
      }
    });
  },
  beforeMount: function beforeMount() {},
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_report_totals_box__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_report_totals_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_report_totals_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_inventory_unreport_list_euc__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_inventory_unreport_list_euc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_inventory_unreport_list_euc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_inventory_unreport_list_it__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_inventory_unreport_list_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_inventory_unreport_list_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_strap_dist_vue_strap_js__);


var _methods;









var mdebug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('esma:device_embedded_information');










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"],
    "report-totals-box": __WEBPACK_IMPORTED_MODULE_12__components_report_totals_box___default.a,
    "inventory-unreport-list-euc": __WEBPACK_IMPORTED_MODULE_13__components_modals_inventory_unreport_list_euc___default.a,
    "inventory-unreport-list-it": __WEBPACK_IMPORTED_MODULE_14__components_modals_inventory_unreport_list_it___default.a,
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_15__components_modals_file_download_modal___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_17_vue_strap_dist_vue_strap_js__["tab"],
    tabs: __WEBPACK_IMPORTED_MODULE_17_vue_strap_dist_vue_strap_js__["tabs"]
  },
  data: function data() {
    return {
      selected_tab: 0,
      api_name: "inventory_report",
      detail_page: "page_0071_inventory_report",
      page_acl: __WEBPACK_IMPORTED_MODULE_9__rules_acl_rules___default.a.inventory_report_check,
      execute_filter_on_back: true,
      inventory_approval_inquiry: -1,
      reporting_period_list: [],
      selected_company: false,
      admin_editable: true,
      within_period: true,
      rejectmode: false,
      company_list: [],
      load_count: 0,
      userID: "",
      RejectReasonText: "",
      def_subsearch: {},
      make_need_submit_List: false,
      inventory_sub_search: { reporting_period: false, company: false, jurisdiction_classification: "EUC・その他" }
    };
  },

  computed: {
    selvalues: function selvalues() {
      return this.inventory_sub_search;
    },
    RejectText: function RejectText() {
      if (this.disablePageReject) {
        return "差戻";
      } else {
        return "差戻 (" + this.formOutputQty + ")";
      }
    },
    RejectSaveText: function RejectSaveText() {
      if (this.disablePageReject) {
        return "入力完了";
      } else {
        return "入力完了 (" + this.formOutputQty + ")";
      }
    },

    loadcount: {
      get: function get() {
        return this.load_count;
      },
      set: function set(v) {
        this.load_count = v;
      }
    },
    viewcaution: function viewcaution() {
      return this.inventory_sub_search.reporting_period != "" && this.inventory_sub_search.reporting_period != false;
    },

    InventoryApprovalInquiry: {
      get: function get() {
        return true;
      },
      set: function set(v) {
        this.inventory_approval_inquiry = v;
      }
    },
    disablePageReject: {
      get: function get() {
        if (this.formOutputQty == 0) {
          return true;
        } else {
          return false;
        }
      },
      set: function set(v) {
        this.disable_page_approve = v;
      }
    },
    admineditable: {
      get: function get() {
        return this.admin_editable;
      },
      set: function set(v) {
        this.admin_editable = v;
      }
    },
    withinperiod: {
      get: function get() {
        return this.within_period;
      },
      set: function set(v) {
        this.within_period = v;
      }
    },
    EditableUser: function EditableUser() {
      return (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_16__rules_constants___default.a.PERMISSION.SYSTEM_ADMINISTRATOR || __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userRole") == __WEBPACK_IMPORTED_MODULE_16__rules_constants___default.a.PERMISSION.MAINTENANCE_STAFF) && __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userCompany") == "ライセンス管理窓口";
    },
    disableUnreportList: function disableUnreportList() {
      return this.inventory_sub_search.reporting_period == false || this.inventory_sub_search.company == false || this.inventory_sub_search.jurisdiction_classification == false;
    },

    selectedcompany: {
      get: function get() {
        return this.selected_company;
      },
      set: function set(v) {
        var _this = this;

        this.clearmode();
        this.selected_company = v;
        this.inventory_sub_search.company = v;
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(this.userID + "_inventory_report_company", v);
        if (typeof this.inventory_sub_search.reporting_period != "undefined" && this.inventory_sub_search.reporting_period != "") {
          if (v == "") {
            if (this.inventory_sub_search.jurisdiction_classification != "棚卸申請承認") {
              this.searchControlChangedDatasource(this.singleSearchCreate("jurisdiction_classification", this.inventory_sub_search.jurisdiction_classification));
            } else {
              this.searchControlChangedDatasource(this.singleSearchCreate("reporting_period", this.inventory_sub_search.reporting_period));
            }
          } else {
            this.searchControlChangedDatasource(this.singleSearchCreate("company", "" + v));
          }
        }
        this.uptReportTotalsBox(false, function () {
          _this.loadReportTotalsBox();
          _this.autoSizeAll();
        });
        setTimeout(function () {
          _this.autoSizeAll();
        }, 1000);
      }
    },
    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    },
    companylist: {
      get: function get() {
        return this.company_list;
      },
      set: function set(v) {
        this.company_list = v;
      }
    },
    reportingPeriodList: {
      get: function get() {
        return this.reporting_period_list;
      },
      set: function set(v) {
        this.reporting_period_list = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approval_status, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].device_control_number, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].registration_date, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].computer_name, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].equipment_in_charge_department, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].equipment_in_charge_team, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].equipment_in_charge_classification, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].equipment_in_charge_system, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].installation_department, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].installation_team, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].user_name, __WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].management_person_name];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approval_status, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].company), { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].team_in_charge, { tab_size: 82 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].department_in_charge), { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].created_date, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].last_update_date, { tab_size: 52 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].created_by_label, { tab_size: 52 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].contact_person, { tab_size: 52 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].ledger_check, { tab_size: 247 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].new_registration_of_equipment, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].change_device_information, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].disposal_of_device_information, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].certificate_list_check, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].new_license_registration, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].change_license_information, { tab_size: 247 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].disposal_of_license, { tab_size: 127 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].lack_of_license, { tab_size: 187 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].lost_license_certificate, { tab_size: 172 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].no_evidence_of_license_receipt, { tab_size: 232 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].other, { tab_size: 70 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].remarks, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].certificate_list_check, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].new_license_registration, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].change_license_information, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].disposal_of_license, { tab_size: 127 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].unused_license, { tab_size: 127 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].reason_not_using, { tab_size: 172 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].expired_license, { tab_size: 142 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].expired_license_support, { tab_size: 172 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].certificate_remarks, { tab_size: 97 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].linkage_ratio, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_registered_devices, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_registered_licenses, { tab_size: 120 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_software_packages_used, { tab_size: 138 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_installed_software_to_be_linked, { tab_size: 230 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_installation_software_licenses_attached, { tab_size: 250 })];
    },
    tabFieldList2: function tabFieldList2() {
      return [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approval_status, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].company), { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].reporting_system, { tab_size: 97 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].department_in_charge), { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].created_date, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].last_update_date, { tab_size: 52 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].created_by_label, { tab_size: 52 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].contact_person, { tab_size: 52 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].ledger_check, { tab_size: 247 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].new_registration_of_equipment, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].change_device_information, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].disposal_of_device_information, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].certificate_list_check, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].new_license_registration, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].change_license_information, { tab_size: 247 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].disposal_of_license, { tab_size: 127 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].lack_of_license, { tab_size: 187 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].lost_license_certificate, { tab_size: 172 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].no_evidence_of_license_receipt, { tab_size: 232 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].other, { tab_size: 70 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].remarks, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].certificate_list_check, { tab_size: 112 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].new_license_registration, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].change_license_information, { tab_size: 157 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].disposal_of_license, { tab_size: 127 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].unused_license, { tab_size: 127 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].reason_not_using, { tab_size: 172 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].expired_license, { tab_size: 142 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].expired_license_support, { tab_size: 172 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].certificate_remarks, { tab_size: 97 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].linkage_ratio, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_registered_devices, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_registered_licenses, { tab_size: 120 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_software_packages_used, { tab_size: 138 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_installed_software_to_be_linked, { tab_size: 230 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].number_of_installation_software_licenses_attached, { tab_size: 250 })];
    },
    tabFieldList3: function tabFieldList3() {
      return [__WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approval_status, {
        search_no_blank: true, tab_size: 60
      }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].company)), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].department_in_charge)), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].team_in_charge), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].jurisdiction_classification)), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].reporting_system, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].applicant_label, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].next_approver_label, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].create_time, {}), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_1_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_1, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_2_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_2, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_3_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_3, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_4_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_4, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_5_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_5, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_6_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_6, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_7_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_7, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_8_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_8, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_9_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_9, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_10_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_10, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_11_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_11, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_12_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_12, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_13_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_13, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_14_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_14, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_15_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_15, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_16_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_16, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_17_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_17, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_18_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_18, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_19_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_19, { tab_size: 60 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].approver_20_label, { tab_size: 100 }), __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_6__rules_fields_inventory_report__["a" /* fields */].status_20, { tab_size: 60 })];
    },
    searchkeys: function searchkeys() {
      return ["reporting_period", "company", "jurisdiction_classification"];
    }
  },
  methods: (_methods = {
    clearmode: function clearmode() {
      this.rejectmode = false;
    },
    inventory_admin_edit: function inventory_admin_edit() {
      var _this2 = this;

      if (typeof this.inventory_sub_search["reporting_period"] != "undefined" && this.inventory_sub_search["reporting_period"] != "") {
        this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/", { reporting_period: this.inventory_sub_search["reporting_period"] }, function (err, result) {
          if (err) {
            _this2.$notify({
              title: "棚卸編集可能データの読込に失敗しました。",
              text: err,
              type: "error",
              duration: 10000
            });
          } else {
            if (result.editable == "許可") {
              _this2.admineditable = true;
            } else {
              _this2.admineditable = false;
            }
          };
        });
      }
    },
    onlisteucFile: function onlisteucFile(mode) {
      if (mode == "yes") {
        var filter = {
          "1": { block: "1", field: "reporting_period", value: this.inventory_sub_search.reporting_period, ct: "v", ca: false, t: "input" },
          "2": { block: "2", field: "company", value: this.inventory_sub_search.company, ct: "v", ca: false, t: "input" },
          "3": { block: "3", field: "jurisdiction_classification", value: this.inventory_sub_search.jurisdiction_classification, ct: "v", ca: false, t: "input" },

          "j1": "AND",
          "j2": "AND",
          "b2_disabled": false,
          "b3_disabled": true
        };

        __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("runinventoryreportlistDownloadModal", {
          message: "ファイルを出力しています。",
          on_complete_message: "出力が完了しました。",
          title: "出力",
          sub_search: this.inventory_sub_search,
          filter: filter,

          url: "/inventory_unreport_list/export_report_data/"
        });
      }
    },
    onRejectStart: function onRejectStart() {
      this.RejectReasonText = "";
      this.rejectmode = true;
    },
    rejectcancelbtn: function rejectcancelbtn() {
      this.rejectmode = false;
    },
    onRejectEmbedded: function onRejectEmbedded() {
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("confirminventorycheckonRejectEmbedded", {
        title: "",
        message: "申請を差戻します。よろしいですか？",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50"
      });
    },
    onlistitFile: function onlistitFile(mode) {
      if (mode == "yes") {
        var filter = {
          "1": { block: "1", field: "reporting_period", value: this.inventory_sub_search.reporting_period, ct: "v", ca: false, t: "input" },
          "2": { block: "2", field: "company", value: this.inventory_sub_search.company, ct: "v", ca: false, t: "input" },
          "3": { block: "3", field: "jurisdiction_classification", value: this.inventory_sub_search.jurisdiction_classification, ct: "v", ca: false, t: "input" },

          "j1": "AND",
          "j2": "AND",
          "b2_disabled": false,
          "b3_disabled": true
        };

        __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("runinventoryreportlistDownloadModal", {
          message: "ファイルを出力しています。",
          on_complete_message: "出力が完了しました。",
          title: "出力",
          sub_search: this.inventory_sub_search,
          filter: filter,

          url: "/inventory_unreport_list/export_report_data/"
        });
      }
    },
    initExportFile: function initExportFile() {
      if (this.selectedTab == 0) {
        var url = "/inventory_report/export_report_data_euc/";
      } else {
        var url = "/inventory_report/export_report_data_it/";
      }

      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("runinventoryreportlistDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        sub_search: this.inventory_sub_search,
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: url
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    ShowUnreportList: function ShowUnreportList() {
      if (this.selectedTab == 0) {
        return __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("showinventoryunreportlisteuc", {
          title: "報告「部署」・「チーム」",
          send_subsearch: this.inventory_sub_search
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("showinventoryunreportlistit", {
          title: "報告「システム」",
          send_subsearch: this.inventory_sub_search
        });
      }
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      var force_return_jurisdiction_classification = "";
      if (this.inventory_sub_search.jurisdiction_classification == "棚卸申請承認") {
        force_return_jurisdiction_classification = "棚卸申請承認";
      }
      window.sessionStorage.setItem('device_back_to_list_name', 'page_0072_inventory_report_check');
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id, force_return_jurisdiction_classification: force_return_jurisdiction_classification } });
    },
    onTabChanged: function onTabChanged(index) {
      var _this3 = this;

      this.clearmode();
      this.clearSearchFields();
      this.selectedTab = index;
      this.set_jurisdiction_classificationFromTab();

      if (index == 0) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(this.userID + "_inventory_report_jurisdiction_classification", this.inventory_sub_search.jurisdiction_classification);
        this.gridOptions.suppressHorizontalScroll = true;
        this.gridOptions.suppressSizeToFit = false;
        this.gridOptions.api.setColumnDefs(this.createColumnDefs());
      } else if (index == 1) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(this.userID + "_inventory_report_jurisdiction_classification", this.inventory_sub_search.jurisdiction_classification);
        this.gridOptions.suppressHorizontalScroll = true;
        this.gridOptions.suppressSizeToFit = false;
        this.gridOptions.api.setColumnDefs(this.createColumnDefs());
      } else {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(this.userID + "_inventory_report_jurisdiction_classification", "棚卸申請承認");
        this.gridOptions.suppressHorizontalScroll = true;
        this.gridOptions.suppressSizeToFit = false;
        this.gridOptions.api.setColumnDefs(this.createColumnDefs());
      }

      this.uptReportTotalsBox(false, function () {
        if (_this3.inventory_sub_search.reporting_period == false) {
          _this3.loadReportTotalsBox();
        } else {
          _this3.onSelectPeriod(_this3.inventory_sub_search.reporting_period);
        }
      });
      setTimeout(function () {
        _this3.autoSizeAll();
      }, 1500);
    },
    onSelectPeriod: function onSelectPeriod(p) {
      var _this4 = this;

      this.clearmode();
      this.inventory_sub_search.reporting_period = p;
      if (p == "") {
        this.admineditable = true;
        this.withinperiod = true;
      }

      this.make_need_submit_List = true;
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.set(this.userID + "_inventory_report_reporting_period", p);
      this.searchControlChangedDatasource(this.singleSearchCreate("reporting_period", "" + p));
      this.uptReportTotalsBox(false, function () {
        _this4.loadReportTotalsBox();
        _this4.autoSizeAll();
      });
      setTimeout(function () {
        _this4.autoSizeAll();
      }, 1000);
    },
    set_jurisdiction_classificationFromTab: function set_jurisdiction_classificationFromTab() {
      switch (this.selectedTab) {
        case 0:
          this.inventory_sub_search.jurisdiction_classification = "EUC・その他";
          break;
        case 1:
          this.inventory_sub_search.jurisdiction_classification = "IT所管システム";
          break;
        case 2:
          this.inventory_sub_search.jurisdiction_classification = "棚卸申請承認";
          break;
      }
    },
    get_jurisdiction_classificationTabIndex: function get_jurisdiction_classificationTabIndex(jurisdiction_classification) {
      switch (jurisdiction_classification) {
        case "EUC・その他":
          return 0;
          break;
        case "IT所管システム":
          return 1;
          break;
        case "棚卸申請承認":
          return 2;
          break;
        default:
          return 0;
          break;
      }
    },
    createColumnDefs: function createColumnDefs() {
      switch (this.selectedTab) {
        case 0:
          var field_list_name = "tabFieldList";
          var show_checkbox = true;
          var force_sort = { id: "last_update_date", direction: "desc" };
          break;
        case 1:
          var field_list_name = "tabFieldList2";
          var show_checkbox = true;
          var force_sort = { id: "last_update_date", direction: "desc" };
          break;
        case 2:
          var field_list_name = "tabFieldList3";
          var show_checkbox = false;
          var force_sort = { id: "approval_status", direction: "desc" };
          break;
      }
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: show_checkbox, field_list_name: field_list_name, force_sort: force_sort });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    backToList: function backToList() {
      return this.$router.push({ path: '/inventory_management', params: {} });
    },
    loadReportTotalsBox: function loadReportTotalsBox() {
      var _this5 = this;

      if (typeof this.inventory_sub_search["reporting_period"] != "undefined" && this.inventory_sub_search["reporting_period"] != "") {
        this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/", { reporting_period: this.inventory_sub_search["reporting_period"] }, function (err, result) {
          if (err) {
            _this5.$notify({
              title: "棚卸編集可能データの読込に失敗しました。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          } else {
            if (result.editable == "許可") {
              _this5.admineditable = true;
            } else {
              _this5.admineditable = false;
            }
            if (_this5.EditableUser == false || _this5.selectedTab == 2) {
              return;
            }

            _this5.$ajax.post("/" + _this5.api_name + "/inventory_period_inquiry/", { reporting_period: _this5.inventory_sub_search["reporting_period"] }, function (err, result) {
              if (err) {
                _this5.$notify({
                  title: "棚卸期間データの読込に失敗しました。",
                  text: err,
                  type: "error",
                  duration: 10000
                });
                return;
              } else {
                if (result.qty > 0) {
                  _this5.withinperiod = true;
                } else {
                  _this5.withinperiod = false;
                }

                var Local_make_need_submit_List_flag = false;
                if (_this5.make_need_submit_List == true && _this5.admineditable == true && _this5.withinperiod == true) {
                  _this5.make_need_submit_List = false;
                  Local_make_need_submit_List_flag = true;
                }
                _this5.loadcount += 1;
                var current = _this5.loadcount;
                _this5.$ajax.post("/" + _this5.api_name + "/get_reporting_totals_for_period", { sub_search: _this5.inventory_sub_search, make_need_submit_List: Local_make_need_submit_List_flag }, function (err, data) {
                  if (_this5.loadcount == current) {
                    _this5.uptReportTotalsBox(data || {});
                  }
                });
              }
            });
          };
        });
      }
    },
    uptReportTotalsBox: function uptReportTotalsBox() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (val == false) {
        val = {
          reportable_team: "",
          number_of_reports: "",
          unreported_number: "",
          report_rate: "",
          lack_of_license: "",
          lost_license_certificate: "",
          no_evidence_of_license_receipt: "",
          other: "",
          number_of_items_to_be_linked: "",
          total_number_of_pegging: "",
          linking_rate: ""
        };
      }
      __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("reportTotalsBox", val);
      cb();
    },
    onReject: function onReject(mode) {
      var _this6 = this;

      if (mode != "yes") {
        return;
      }

      var arr = this.selectedRowArr.map(function (m) {
        return {
          a_seq_id: m.a_seq_id,
          seq_id: m.seq_id,
          retraction_reason: _this6.RejectReasonText
        };
      });

      var hash = 0;
      arr.forEach(function (e) {
        hash = hash + (e.seq_id + 3) * 2;
      });

      this.$ajax.post("/" + this.api_name + "/admin_reject/", { arr: arr, hash: hash }, function (err, response) {
        if (err) {
          _this6.$notify({
            title: "差戻に失敗しました",
            text: err,
            type: "error",
            duration: 10000
          });
        } else {
          var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";
          __WEBPACK_IMPORTED_MODULE_2__libs_bus__["a" /* bus */].$emit("confirminventorycheckonRejectEmbeddednotification", {
            message: message,
            title: "申請が差戻されました",
            yes_label: "",
            no_label: "OK",
            yes_color: "",
            no_color: "",
            model_height: "50",
            model_width: "390px"
          });
        }
      });
    },
    onRejectEnd: function onRejectEnd() {
      var temp = this.inventory_sub_search.reporting_period;
      this.onSelectPeriod("");
      this.onSelectPeriod(temp);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'onRowSelected', function onRowSelected(ev) {
    this.selected_row = ev.node.data.seq_id;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'updateListSelectBox', function updateListSelectBox() {
    var _this7 = this;

    this.$ajax.post("/master_inventory_reporting_period/list_reporting_period", {}, function (err, data) {
      if (err) {
        _this7.$notify({
          title: "報告期分が読み込めませんでした",
          text: err,
          type: "error",
          duration: 10000
        });
      }
      data.forEach(function (d) {
        d.value = d.val;
      });
      _this7.reportingPeriodList = data;
      _this7.$ajax.post_cached_queued("/master_company/list_company_name", {}, function (err, _companies) {
        if (err) {
          _this7.$notify({
            title: "所管会社のデータが読込めませんでした。",
            text: err,
            type: "error",
            duration: 10000
          });
          return;
        }
        var refreshflag = 0;
        _companies.forEach(function (d) {
          d.value = d.val;
        });
        _this7.companylist = _companies;
        if (_this7.EditableUser == false) {
          for (var k in _this7.companylist) {
            _this7.selectedcompany = _this7.companylist[k].val;
            refreshflag += 1;
            break;
          }
        } else {
          if (typeof _this7.def_subsearch["company"] != "undefined" && _this7.def_subsearch["company"] != "") {
            _this7.selected_company = _this7.def_subsearch["company"];
            _this7.inventory_sub_search.company = _this7.def_subsearch["company"];
            refreshflag += 1;
          }
        }
        if (typeof _this7.def_subsearch["reporting_period"] != "undefined" && _this7.def_subsearch["reporting_period"] != "") {
          setTimeout(function () {
            _this7.selvalues['reporting_period'] = _this7.def_subsearch["reporting_period"];
          }, 200);
          refreshflag += 1;
        }
        setTimeout(function () {
          _this7.uptReportTotalsBox(false, function () {
            _this7.loadReportTotalsBox();
            _this7.autoSizeAll();
          });
        }, 400);
        if (refreshflag >= 2) {
          setTimeout(function () {
            _this7.searchControlChangedDatasource(_this7.singleSearchCreate("reporting_period", _this7.inventory_sub_search.reporting_period));
          }, 1000);
        }
        setTimeout(function () {
          _this7.autoSizeAll();
        }, 1500);
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'autoSizeAll', function autoSizeAll(skipHeader) {
    var _this8 = this;

    setTimeout(function () {
      var allColumnIds = [];
      _this8.gridOptions.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      var allColumnIds_Except = ["approval_status", "company", "number_of_registered_devices", "number_of_registered_licenses", "number_of_software_packages_used", "number_of_installed_software_to_be_linked", "number_of_installation_software_licenses_attached", "lack_of_license", "lost_license_certificate", "no_evidence_of_license_receipt", "other", "disposal_of_license", "change_license_information", "new_license_registration", "certificate_list_check", "disposal_of_device_information", "change_device_information", "new_registration_of_equipment", "ledger_check"];

      var resizecolumns = allColumnIds.filter(function (n) {
        return allColumnIds_Except.includes(n) == false;
      });
      _this8.gridOptions.columnApi.autoSizeColumns(resizecolumns, false);
    }, 100);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'localInitLoadData', function localInitLoadData() {}), _methods),
  mounted: function mounted() {
    this.updateListSelectBox();
  },
  beforeMount: function beforeMount() {

    this.make_need_submit_List = true;
    this.userID = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get("userID");
    this.$store.state[this.stateCurrentRow] = {};
    var map = this.searchkeys;

    for (var k in map) {
      if (typeof __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get(this.userID + "_inventory_report_" + map[k]) != "undefind" && __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get(this.userID + "_inventory_report_" + map[k]) != "") {
        this.def_subsearch[map[k]] = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].localStorage.get(this.userID + "_inventory_report_" + map[k]) || "";
      }
      if (this.$route.params.sub_search) {
        if (typeof this.$route.params.sub_search[map[k]] != "undefind" && this.$route.params.sub_search[map[k]] != "") {
          this.def_subsearch[map[k]] = this.$route.params.sub_search[map[k]];
        }
      }
    }

    if (typeof this.def_subsearch["jurisdiction_classification"] != "undefind" && this.def_subsearch["jurisdiction_classification"] != "") {
      var tabnumber = this.get_jurisdiction_classificationTabIndex(this.def_subsearch["jurisdiction_classification"]);
      this.selected_tab = tabnumber;
    }

    this.api_request_options = { sub_search: "inventory_sub_search" };

    this.set_jurisdiction_classificationFromTab();

    this.gridOptions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.extend(this.commonGridOptions, { suppressHorizontalScroll: false, suppressSizeToFit: false });

    this.initDatasource({ load_only_with_filter: true });
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap_dist_vue_strap_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_search_company__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_search_company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_search_company__);









var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:master_user');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_4_vue_strap_dist_vue_strap_js__["tab"],
    tabs: __WEBPACK_IMPORTED_MODULE_4_vue_strap_dist_vue_strap_js__["tabs"],
    "search-company": __WEBPACK_IMPORTED_MODULE_11__components_search_company___default.a
  },
  data: function data() {
    return {
      api_name: "excess_deficiency_summary",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master,
      execute_filter_on_back: true,
      link_to_open: "#",
      selected_tab: 0,
      company: null
    };
  },

  computed: {
    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].item_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_to_be_linked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_link, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_unlinked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].linking_rate, { suppressSorting: true })];
    },
    tabFieldList1: function tabFieldList1() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].item_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_to_be_linked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_link, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_unlinked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].linking_rate, { suppressSorting: true })];
    },
    tabFieldList2: function tabFieldList2() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].system_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].item_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_to_be_linked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_link, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_unlinked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].linking_rate, { suppressSorting: true })];
    },
    tabFieldList3: function tabFieldList3() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].item_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_to_be_linked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_link, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].number_of_unlinked, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_excess_deficiency_summary__["a" /* fields */].linking_rate, { suppressSorting: true })];
    },


    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    onCopmanySearchEvent: function onCopmanySearchEvent(obj) {
      this.company = obj.val;
      this.onTabChanged(this.selectedTab);
    },
    onTabChanged: function onTabChanged(index) {
      this.selectedTab = index;
      this.clearSearchFields();
      switch (index) {
        case 0:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList"));
          this.api_request_options = { filter_mode: "department", company: this.company };
          break;
        case 1:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList1"));
          this.api_request_options = { filter_mode: "team", company: this.company };
          break;
        case 2:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList2"));
          this.api_request_options = { filter_mode: "system", company: this.company };
          break;
        case 3:
        default:
          this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList3"));
          this.api_request_options = { filter_mode: "all", company: this.company };
          break;
      }
      this.gridOptions.api.sizeColumnsToFit();
      this.emulateSearchControlChangedDatasource(true);
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("runExcessDeficiencySummaryDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        url: "/" + this.api_name + "/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {},
    createColumnDefs: function createColumnDefs() {
      var field_list_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "tabFieldList";

      return this.commonCreateColumnDefs({ show_details: false, show_checkbox: false, field_list_name: field_list_name });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.count_from_result = false;
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = { filter_mode: "department", company: null };
    this.initDatasource({ load_only_with_filter: false });
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_system_setting__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);








var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()("esma:master_belong_details");





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    "field-box": __WEBPACK_IMPORTED_MODULE_6__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "system_setting",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.maintenance
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_system_setting__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_system_setting__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [{
          id: "page_size",
          label: "ページサイズ",
          type: "select",
          options: ["80%", "90%", "100%", "110%", "120%", "130%", "140%"]
        }, {
          id: "table_size",
          label: "テーブルサイズ",
          type: "select",
          options: ["1020", "1120", "1220", "1320", "1420", "1520", "1620", "1720", "1820"]
        }]
      };
    }
  },
  methods: {
    onSave: function onSave() {
      var _this = this;

      this.read_only = true;
      if (this.$store.state[this.stateCurrentEditing]) {
        var save_to_db = {
          pageContainerSize: localStorage.getItem("pageContainerSize"),
          pageZoom: localStorage.getItem("pageZoom")
        };
        if (this.$store.state[this.stateCurrentEditing].table_size) {
          localStorage.setItem("pageContainerSize", this.$store.state[this.stateCurrentEditing].table_size);
          save_to_db["pageContainerSize"] = this.$store.state[this.stateCurrentEditing].table_size;
          this.$store.state[this.stateCurrentRow].table_size = this.$store.state[this.stateCurrentEditing].table_size;
          this.pageContainerSize = this.$store.state[this.stateCurrentEditing].table_size;
        }
        if (this.$store.state[this.stateCurrentEditing].page_size) {
          var page_size = this.$store.state[this.stateCurrentEditing].page_size;
          page_size = parseInt(page_size.replace("%", "")) / 100;
          localStorage.setItem("pageZoom", page_size);
          save_to_db["pageZoom"] = page_size;
          this.$store.state[this.stateCurrentRow].page_size = this.$store.state[this.stateCurrentEditing].page_size;

          var mb = document.getElementById('main-body');

          var iw = window.innerWidth;

          mb.style.zoom = page_size;

          if (page_size < 1) {
            mb.style.minWidth = parseInt(iw / page_size) + "px";
            mb.style.maxWidth = null;
          } else {
            mb.style.minWidth = null;
            mb.style.maxWidth = parseInt(iw / page_size) + "px";
          }
        }
        if (save_to_db.pageZoom || save_to_db.pageContainerSize) {
          this.$ajax.post("/master_user/save_browser_settings", { changes: { zoom_info: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(save_to_db) } }, function (err, result) {
            if (err) {
              _this.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
            } else {
              _this.$notify({
                title: 'データ処理が完了しました。',
                type: 'info',
                duration: 2000
              });
            }
          });
        }
      }
      setTimeout(function () {}, 500);
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    goBack: function goBack() {
      var broser_setting_back_to = window.sessionStorage.getItem("broser_setting_back_to");
      return this.$router.push(broser_setting_back_to);
    }
  },
  mounted: function mounted() {
    var pageZoom = localStorage.getItem("pageZoom") || 1;
    var pageContainerSize = localStorage.getItem("pageContainerSize") || 1420;
    this.$store.state[this.stateCurrentRow] = {
      page_size: parseInt(pageZoom * 100) + "%",
      table_size: pageContainerSize + ""
    };
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "system_setting",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.maintenance
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__["a" /* fields */].number_of_login_attempts, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__["a" /* fields */].password_expiration_date, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__["a" /* fields */].password_syntax, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__["a" /* fields */].maximum_number_of_passwords, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_system_setting__["a" /* fields */].minimum_number_of_passwords, {})],
        col3: []
      };
    }
  },
  methods: {
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$route.params.seq_id = "last";
    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "mail_message",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.master,
      execute_filter_on_back: true,
      link_to_open: "#",
      detail_page: "page_0081_mail_message_detail"
    };
  },

  computed: {
    deleteBtnDisabled: function deleteBtnDisabled() {
      return this.formOutputQty == 0;
    },
    deleteText: function deleteText() {
      if (this.deleteBtnDisabled) {
        return "削除";
      } else {
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    allSearchFields: function allSearchFields() {
      return [__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_message_number, __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_type, __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_subject];
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_message_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_type, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_subject, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/mail_message/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("deletemailMessageModal", {
        title: "削除",
        message: "メールメッセージの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        if (Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0) {
          return;
        }
        var arr = this.selectedRowArr.map(function (m) {
          return m.seq_id;
        });
        var vm = this;
        this.commonDeleteArr(vm, arr, function () {
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_master_user_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_master_user_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_sub_pages_master_user_vue__);








var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:mail_message');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_6__components_form_field___default.a,
    'master-user': __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user___default.a
  },
  data: function data() {
    return {
      api_name: "mail_message",
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.master,
      loading: true,
      selected_user_ids: [],
      local_selected_user_selected: [],
      mail_content: "",
      mail_subject: "",
      email_list: ""
    };
  },

  computed: {
    mailContent: {
      get: function get() {
        return this.mail_content;
      },
      set: function set(v) {
        this.mail_content = v;
      }
    },
    mailSubject: {
      get: function get() {
        return this.mail_subject;
      },
      set: function set(v) {
        this.mail_subject = v;
      }
    },
    selectedUserIDs: {
      get: function get() {
        return this.selected_user_ids;
      },
      set: function set(v) {
        if (Array.isArray(v) == false || v.length == 0) {
          v = [-1];
        }
        this.selected_user_ids = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__["b" /* filed_types */];
    }
  },
  methods: {
    emailListUpdated: function emailListUpdated(list) {
      this.email_list = list;
    },
    prepareSendMail: function prepareSendMail() {

      var mail_buff = "mailto:?bcc=" + (this.email_list || " ");
      mail_buff += "&subject=" + encodeURIComponent(this.mailSubject.replace(/\n/g, "").replace(/\r/g, ""));
      mail_buff += "&body=" + encodeURIComponent(this.mailContent);

      var send_mail_link = this.$refs.send_mail_link;
      send_mail_link.href = mail_buff;
      send_mail_link.click();
    },
    removeUsers: function removeUsers() {
      var _this = this;

      var temp = this.selectedUserIDs || [-1];
      var temp2 = _.remove(temp, function (r) {
        return _this.local_selected_user_selected.indexOf(r) < 0;
      });
      this.selectedUserIDs = temp2;
      if (this.selectedUserIDs.length == 0) {
        this.selectedUserIDs = [-1];
      }
      window.sessionStorage.setItem("send_mail_destination", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedUserIDs));
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("selectedUsersRefresh", this.selectedUserIDs);
    },
    onSelectedUserSelected: function onSelectedUserSelected(list) {
      this.local_selected_user_selected = list;
    },
    addUsers: function addUsers() {
      return this.$router.push({ name: "page_0081_mail_message_users", params: { seq_id: this.$route.params.seq_id } });
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0081_mail_message_detail", params: { seq_id: this.$route.params.seq_id } });
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.mailContent = window.sessionStorage.getItem("send_mail_message");
    this.mailSubject = window.sessionStorage.getItem("send_mail_subject");
    var temp = window.sessionStorage.getItem("send_mail_destination");
    if (temp && temp.length > 1) {
      temp = JSON.parse(temp);
    }
    this.selected_user_ids = temp || [-1];
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:mail_message');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "mail_message",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master,
      loading: true
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_message_number, { disabled: true, read_only: true, label_class: "col-xs-2 control-label esma_form_label", field_class: "col-xs-10" }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_type, { label_class: "col-xs-2 control-label esma_form_label", field_class: "col-xs-10" }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_subject, { label_class: "col-xs-2 control-label esma_form_label", field_class: "col-xs-10" }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_mail_message__["a" /* fields */].mail_content, {})]
      };
    }
  },
  methods: {
    onGoToSendMail: function onGoToSendMail() {
      window.sessionStorage.setItem("send_mail_subject", this.$store.state[this.stateCurrentEditing].mail_subject || this.$store.state[this.stateCurrentRow].mail_subject);
      window.sessionStorage.setItem("send_mail_message", this.$store.state[this.stateCurrentEditing].mail_content || this.$store.state[this.stateCurrentRow].mail_content);
      window.sessionStorage.setItem("send_mail_destination", "");
      return this.$router.push({ name: "page_0081_mail_message_create", params: { seq_id: this.$route.params.seq_id } });
    },
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteMailMessageDetailModal", {
        title: "削除",
        message: "メールメッセージの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0081_mail_message", params: {} });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this, function () {
        _this.loading = false;
      });
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_master_user_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_master_user_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_sub_pages_master_user_vue__);








var mdebug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('esma:mail_message');







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_6__components_form_field___default.a,
    'master-user': __WEBPACK_IMPORTED_MODULE_7__components_sub_pages_master_user___default.a
  },
  data: function data() {
    return {
      api_name: "mail_message",
      page_acl: __WEBPACK_IMPORTED_MODULE_8__rules_acl_rules___default.a.master,
      loading: true,
      local_new_user_selected: [],
      local_selected_user_selected: [],
      selected_user_ids: [-1]
    };
  },

  computed: {
    selectedUserIDs: {
      get: function get() {
        return this.selected_user_ids;
      },
      set: function set(v) {
        if (Array.isArray(v) == false || v.length == 0) {
          v = [-1];
        }
        this.selected_user_ids = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__["a" /* fields */].mail_subject), { label_class: "col-xs-2 control-label esma_form_label", field_class: "col-xs-10", label: "件名" }), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(_.clone(__WEBPACK_IMPORTED_MODULE_3__rules_fields_mail_message__["a" /* fields */].mail_content), { label: "本文" })]
      };
    }
  },
  methods: {
    addUser: function addUser() {
      var temp = this.selectedUserIDs || [-1];
      this.local_new_user_selected.forEach(function (n) {
        if (temp.indexOf(n) < 0) {
          temp.push(n);
        }
      });
      this.selectedUserIDs = temp;
      window.sessionStorage.setItem("send_mail_destination", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedUserIDs));
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("selectedUsersRefresh", this.selectedUserIDs);
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("allUsersRefresh", this.selectedUserIDs);
    },
    removeUsers: function removeUsers() {
      var _this = this;

      var temp = this.selectedUserIDs || [-1];
      var temp2 = _.remove(temp, function (r) {
        return _this.local_selected_user_selected.indexOf(r) < 0;
      });
      this.selectedUserIDs = temp2;
      if (this.selectedUserIDs.length == 0) {
        this.selectedUserIDs = [-1];
      }
      window.sessionStorage.setItem("send_mail_destination", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedUserIDs));
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("selectedUsersRefresh", this.selectedUserIDs);
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("allUsersRefresh", this.selectedUserIDs);
    },
    onSelectedUserSelected: function onSelectedUserSelected(list) {
      this.local_selected_user_selected = list;
    },
    onNewUserSelected: function onNewUserSelected(list) {
      this.local_new_user_selected = list;
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0081_mail_message_create", params: { seq_id: this.$route.params.seq_id } });
    }
  },
  mounted: function mounted() {
    var temp = window.sessionStorage.getItem("send_mail_destination");
    if (temp && temp.length > 1) {
      temp = JSON.parse(temp);
    }
    if (typeof temp == "undefined" || !temp || temp == "" || Array.isArray(temp) == false) {
      temp = [-1];
    }
    window.sessionStorage.setItem("send_mail_destination", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(temp));
    this.selectedUserIDs = temp;
    if (temp.length > 0) {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("selectedUsersRefresh", this.selectedUserIDs);
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("allUsersRefresh", this.selectedUserIDs);
    }
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_search_company__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_search_company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_search_company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_bus__ = __webpack_require__(4);










var mdebug = __WEBPACK_IMPORTED_MODULE_6_debug___default()('esma:certificate_software');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_2_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_10__components_modals_file_download_modal___default.a,
    "search-company": __WEBPACK_IMPORTED_MODULE_5__components_search_company___default.a
  },
  data: function data() {
    return {
      api_name: "certificate_software_deposit",
      page_acl: __WEBPACK_IMPORTED_MODULE_7__rules_acl_rules___default.a.master,
      detail_page: "page_0040_certificate_software_detail_number_deposit",
      execute_filter_on_back: true,
      link_to_open: "#",
      search_data: {},
      local_list_of_fields: []
    };
  },

  computed: {
    localListOfFields: {
      get: function get() {
        return this.local_list_of_fields;
      },
      set: function set(v) {
        this.local_list_of_fields = v;
      }
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].maker, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].license_name, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].license_certificate_type, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].license, {}), __WEBPACK_IMPORTED_MODULE_4__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_3__rules_fields_certificate_software__["a" /* fields */].certificate_software_number, {})];
    },
    formFields: function formFields() {
      return {
        col1: this.localListOfFields
      };
    }
  },
  methods: {
    onSearchEvent: function onSearchEvent(arr) {
      var _this = this;

      arr.forEach(function (a) {
        _this.search_data[a.id] = a.val;
      });
      this.sub_search = this.search_data;
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("inventory_certificate_list");
    },
    onSearchValue: function onSearchValue(id, val) {
      console.log('TEST DEBUG 210430 (143 at page_0090_deposit_certificate_output.vue)[23:50]: ', { id: id, val: val });
      this.search_data[id] = val;
      this.sub_search = this.search_data;
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("inventory_certificate_list");
    },
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_11__libs_bus__["a" /* bus */].$emit("runDepositCertificateOutputDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: { sub_search: "sub_search", filter_mode: "使用中" },
        sub_search: this.search_data,
        url: "/certificate_software_deposit/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      window.sessionStorage.setItem('certificate_back_to_list', "/deposit_certificate_output");
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: false });
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    setTimeout(function () {}, 500);
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.api_request_options = { sub_search: "sub_search", filter_mode: "使用中" };
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_strap_dist_vue_strap_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_strap_dist_vue_strap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_strap_dist_vue_strap_js__);













var mdebug = __WEBPACK_IMPORTED_MODULE_9_debug___default()("esma:notice");



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    tab: __WEBPACK_IMPORTED_MODULE_11_vue_strap_dist_vue_strap_js__["tab"], tabs: __WEBPACK_IMPORTED_MODULE_11_vue_strap_dist_vue_strap_js__["tabs"]
  },
  data: function data() {
    return {
      api_name: "notice",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master,
      detail_page: "page_0090_notice_detail",
      execute_filter_on_back: true,
      link_to_open: "#",
      selected_tab: 0
    };
  },

  computed: {
    pageTitle: function pageTitle() {
      if (this.selectedTab == 1) {
        return "お知らせ 履歴一覧";
      } else {
        return "お知らせ";
      }
    },

    selectedTab: {
      get: function get() {
        return this.selected_tab;
      },
      set: function set(v) {
        this.selected_tab = v;
      }
    },
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      if (this.selectedTab == 1) {
        return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].history_date, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].from_user, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].to_user, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].message, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].importance, {})];
      } else {
        return [__WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].create_date, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].from_user, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].to_user, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].message, {}), __WEBPACK_IMPORTED_MODULE_5__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].importance, {})];
      }
    }
  },
  methods: {
    onTabChanged: function onTabChanged(index) {
      var _this = this;

      this.selectedTab = index;
      this.clearSearchFields();

      this.gridOptions.api.setColumnDefs(function () {
        return _this.createColumnDefs();
      }());

      this.api_request_options = { get_history: this.selectedTab };

      this.countRows("onTabChanged");

      this.gridOptions.api.purgeInfiniteCache();

      this.gridOptions.api.sizeColumnsToFit();

      if (index == 1) {
        return this.$router.push({ name: this.detail_page.replace("_detail", "_history"), params: {} });
      } else {
        return this.$router.push({ name: this.detail_page.replace("_detail", ""), params: {} });
      }
    },
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: "new" }
      });
    },
    onDelete: function onDelete() {
      if (this.selected_row > -1) {
        return this.$router.push({
          name: this.detail_page,
          params: { seq_id: this.selected_row, cmd: "delete" }
        });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: this.selected_row, cmd: "edit" }
      });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({
        show_details: true,
        show_checkbox: false
      });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    console.log("Mounted");
    if (this.$route.meta.tab_index == 1) {
      this.selectedTab = 1;
    } else {
      this.selectedTab = 0;
    }
    this.api_request_options = { get_history: this.selectedTab };
    this.gridOptions.api.purgeInfiniteCache();
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.extend(this.commonGridOptions, {});
    this.api_request_options = { get_history: this.selectedTab };
    this.initDatasource();
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__rules_constants__);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:notice_details');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "notice",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.master,
      disable_edit_buttons: false
    };
  },

  computed: {
    pageTitle: function pageTitle() {
      if (this.isHistoryOnly) {
        return "お知らせ 履歴一覧";
      } else {
        return "お知らせ（詳細）";
      }
    },

    isHistoryOnly: {
      get: function get() {
        return this.disable_edit_buttons;
      },
      set: function set(v) {
        this.disable_edit_buttons = v;
      }
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].from_user, { disabled: true, read_only: true }), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].message_schedule, {})],
        col2: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].to_company, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].to_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].to_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].to_user, {})],
        col3: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].importance, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].create_date, { disabled: true, read_only: true })],
        col4: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_notice__["a" /* fields */].message, {})]
      };
    }
  },
  methods: {
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.startCompanySelection();
      this.commonOnEdit();
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteNoticeModal", {
        title: "削除",
        message: "お知らせの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      if (this.isHistoryOnly) {
        return this.$router.push({ name: "page_0090_notice_history", params: {} });
      } else {
        return this.$router.push({ name: "page_0090_notice", params: {} });
      }
    },
    prepareCompanySelection: function prepareCompanySelection(companies, department_and_team, user_and_teams, company_field, department_field, team_field, to_user_field, company_field_name, department_field_name, force_disable) {
      var _this = this;

      var selected_company = false;
      var selected_department = false;
      var selected_team = false;
      company_field.page_controller_setup({
        on_select: function on_select(_selected_company) {
          selected_company = _selected_company;
          if (selected_company == __WEBPACK_IMPORTED_MODULE_10__rules_constants___default.a.COMMON.ALL_USERS_LABEL) {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
            to_user_field.page_controller_msg({ cmd: "disable" });
          } else if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
            to_user_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company;
            }) || [], "department") || []);
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            to_user_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true
            });
          }
        }
      });
      department_field.page_controller_setup({
        on_select: function on_select(_selected_department) {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            to_user_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: true });
          }
        }
      });
      team_field.page_controller_setup({
        on_select: function on_select(_selected_team) {
          selected_team = _selected_team;
          if (selected_team == "") {
            to_user_field.page_controller_msg({ cmd: "disable" });
          } else {
            var users = _.filter(user_and_teams || [], function (d) {
              return d.company == selected_company && d.department == selected_department && d.team == selected_team;
            }) || [];
            users.unshift({ user_shimei: "", user_id: "" });
            to_user_field.page_controller_msg({ cmd: "enable" });
            to_user_field.page_controller_msg({ cmd: "set_options_kv", options: users, reset: true });
            to_user_field.page_controller_msg({ cmd: "set_value", val: "" });
          }
        }
      });

      company_field.page_controller_msg({ cmd: "set_options", options: _.clone(companies) });
      to_user_field.page_controller_msg({ cmd: "set_options_kv", options: user_and_teams, reset: true });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      to_user_field.page_controller_msg({ cmd: "disable" });

      setTimeout(function () {
        department_field.page_controller_msg({ cmd: "enable_if_data" });
        team_field.page_controller_msg({ cmd: "enable_if_data" });
        to_user_field.page_controller_msg({ cmd: "enable_if_data" });

        selected_company = _this.$store.state[_this.stateCurrentRow][company_field.id];
        selected_department = _this.$store.state[_this.stateCurrentRow][department_field.id];
        if (selected_company && selected_company.length > 0) {
          department_field.page_controller_msg({ cmd: "enable" });
          var departments = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
            return d.company == selected_company;
          }) || [], "department") || []);
          department_field.page_controller_msg({ cmd: "set_options", options: departments, reset: false });
          if (selected_department && selected_department.length > 0) {
            var teams = _.uniq(_.map(_.filter(department_and_team || [], function (d) {
              return d.company == selected_company && d.department == selected_department;
            }) || [], "team") || []);
            team_field.page_controller_msg({ cmd: "set_options", options: teams, reset: false });
          }
        }
        if (force_disable == true) {
          department_field.page_controller_msg({ cmd: "disable" });
          team_field.page_controller_msg({ cmd: "disable" });
          to_user_field.page_controller_msg({ cmd: "disable" });
        }
      }, this.is_new ? 100 : 500);
    },
    startCompanySelection: function startCompanySelection() {
      var _this2 = this;

      var force_disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;


        this.$ajax.post_cached_queued("/master_user/list_user_company_department_team", {}, function (err, _list_user_company_department_team) {
          if (err) {
            _this2.$notify({
              title: "ユーザ一覧のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000
            });
            return;
          }
          var list_user_company_department_team = _list_user_company_department_team;

          var companies = _.uniq(list_user_company_department_team.map(function (m) {
            return m.company;
          }));
          companies.push(__WEBPACK_IMPORTED_MODULE_10__rules_constants___default.a.COMMON.ALL_USERS_LABEL);
          var department_and_team = list_user_company_department_team.map(function (m) {
            return { company: m.company, team: m.team, department: m.department };
          });
          _this2.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), _.clone(list_user_company_department_team), temp_fields.to_company, temp_fields.to_department, temp_fields.to_team, temp_fields.to_user, "company", "department", force_disable);
          if (_this2.$route.params.seq_id == "new") {
            var default_company = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.to_company.default_from_local_storage);
            if (default_company != __WEBPACK_IMPORTED_MODULE_10__rules_constants___default.a.COMPANY.ALL) {
              setTimeout(function () {
                var default_deparment = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.to_department.default_from_local_storage);
                var default_team = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].localStorage.get(temp_fields.to_team.default_from_local_storage);
                temp_fields.to_company.page_controller_msg({
                  cmd: "set_value",
                  val: default_company
                });
              }, _this2.is_new ? 300 : 1000);
            }
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.$route.params.seq_id == "new") {
      setTimeout(function () {
        _this3.startCompanySelection();
      }, 10);
    } else {
      setTimeout(function () {
        _this3.startCompanySelection(true);
      }, 10);
    }
    this.commonLoadRecord({}, function (err, result) {
      _this3.commonEditDeleteCmdHandler(_this3);
      if (_this3.$store.state[_this3.stateCurrentRow]["is_history"] == 1) {
        _this3.isHistoryOnly = true;
      } else {
        _this3.isHistoryOnly = false;
      }
      if (_this3.$route.params.seq_id == "new") {
        _this3.$store.state[_this3.stateCurrentRow]["importance"] = 3;
        _this3.$store.state[_this3.stateCurrentEditing]["importance"] = 3;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal__);








var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_user');






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    'file-download-modal': __WEBPACK_IMPORTED_MODULE_9__components_modals_file_download_modal___default.a
  },
  data: function data() {
    return {
      api_name: "programs_and_permissions",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.maintenance,
      detail_page: "page_0091_programs_and_permissions_detail",
      execute_filter_on_back: true,
      link_to_open: "#"
    };
  },

  computed: {
    readOnly: function readOnly() {
      return this.read_only;
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    values: function values() {
      console.log('values');
      return this.data_values;
    },
    filterList: function filterList() {
      return this.filter_list;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].program_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].program_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].order_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].program_link, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].parent_program_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].type, {})];
    },

    linkToOpen: {
      get: function get() {
        return this.link_to_open;
      },
      set: function set(v) {
        this.link_to_open = v;
      }
    }
  },
  methods: {
    initExportFile: function initExportFile() {
      __WEBPACK_IMPORTED_MODULE_8__libs_bus__["a" /* bus */].$emit("runDeviceEmbeddedInformationDownloadModal", {
        message: "ファイルを出力しています。",
        on_complete_message: "出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url: "/programs_and_permissions/export_data/"
      });
    },
    onCloseExportFile: function onCloseExportFile() {},
    onDetailsClick: function onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: { seq_id: data.seq_id } });
    },
    addNew: function addNew() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: "new" } });
    },
    onDelete: function onDelete() {
      if (this.selected_row > -1) {
        return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "delete" } });
      }
    },
    onEdit: function onEdit() {
      return this.$router.push({ name: this.detail_page, params: { seq_id: this.selected_row, cmd: "edit" } });
    },
    createColumnDefs: function createColumnDefs() {
      return this.commonCreateColumnDefs({ show_details: true, show_checkbox: true });
    },
    onRowSelected: function onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted: function mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_bus__ = __webpack_require__(4);







var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('esma:master_belong_details');





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'field-box': __WEBPACK_IMPORTED_MODULE_5__components_form_field___default.a
  },
  data: function data() {
    return {
      api_name: "programs_and_permissions",
      page_acl: __WEBPACK_IMPORTED_MODULE_6__rules_acl_rules___default.a.maintenance
    };
  },

  computed: {
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["b" /* filed_types */];
    },
    formFields: function formFields() {
      return {
        col1: [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].program_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].program_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].order_id, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].program_link, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].parent_program_code, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_programs_and_permissions__["a" /* fields */].type, {})],
        col2: [],
        col3: []
      };
    }
  },
  methods: {
    onSave: function onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },
    onEdit: function onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    onDelete: function onDelete() {
      __WEBPACK_IMPORTED_MODULE_9__libs_bus__["a" /* bus */].$emit("deleteProgramsAndPermissionsModal", {
        title: "削除",
        message: "プログラムとアクセス権限の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50"
      });
    },
    btnCancel: function btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete: function onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },
    backToList: function backToList() {
      return this.$router.push({ name: "page_0091_programs_and_permissions", params: {} });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.commonLoadRecord({}, function (err, result) {
      _this.commonEditDeleteCmdHandler(_this);
    });
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);



var mdebug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('esma:reload');

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  mounted: function mounted() {
    var _this = this;

    var dest = this.$route.params.return_to;
    setTimeout(function () {
      return _this.$router.push(dest);
    }, 1);
  },
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_acl_rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__rules_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_bus__ = __webpack_require__(4);









var mdebug = __WEBPACK_IMPORTED_MODULE_4_debug___default()("esma:bulk_import");

















/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_mixin_page_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_mixin_datasource__["a" /* default */]],
  components: {
    'sub-table-cer': __WEBPACK_IMPORTED_MODULE_9__components_sub_pages_sub_table_temp_certificate_information___default.a,
    'sub-table-dev': __WEBPACK_IMPORTED_MODULE_10__components_sub_pages_sub_table_temp_device_embedded_information___default.a,
    'sub-table-associated-device': __WEBPACK_IMPORTED_MODULE_12__components_sub_pages_sub_table_temp_associated_device___default.a,
    'sub-table-device-embedded-detail': __WEBPACK_IMPORTED_MODULE_11__components_sub_pages_sub_table_temp_device_embedded_detail___default.a,
    'application-confirmation-modal': __WEBPACK_IMPORTED_MODULE_8__components_modals_application_confirmation_modal___default.a
  },
  data: function data() {
    return {
      btn_cer_label: "（旧データ用）証書情報テンプレート",
      btn_dev_label: "（旧データ用）機器情報テンプレート",
      btn_associated_device_label: "ソフトウェア情報テンプレート",
      btn_device_embedded_detail_label: "組込情報テンプレート",
      dropdown_label: "テンプレートをダウンロード（Excel）",
      api_name: "bulk_import",
      page_acl: __WEBPACK_IMPORTED_MODULE_5__rules_acl_rules___default.a.maintenance,
      file_selected_event: false,
      selected_file_name: null,
      process_stage: "idle",
      uploading: false,
      error_msg: "",
      show_sub_table_cer: false,
      show_sub_table_dev: false,

      show_sub_table_associated_device: false,
      show_sub_table_device_embedded_detail: false,

      tab_name_mode: false
    };
  },

  computed: {
    showSubTableAssociatedDevice: {
      get: function get() {
        return this.show_sub_table_associated_device;
      },
      set: function set(v) {
        this.show_sub_table_associated_device = v;
      }
    },
    showSubTableDeviceEmbeddedDetail: {
      get: function get() {
        return this.show_sub_table_device_embedded_detail;
      },
      set: function set(v) {
        this.show_sub_table_device_embedded_detail = v;
      }
    },
    showSubTableDev: {
      get: function get() {
        return this.show_sub_table_dev;
      },
      set: function set(v) {
        this.show_sub_table_dev = v;
      }
    },
    showSubTableCer: {
      get: function get() {
        return this.show_sub_table_cer;
      },
      set: function set(v) {
        this.show_sub_table_cer = v;
      }
    },
    processStage: {
      get: function get() {
        return this.process_stage;
      },
      set: function set(v) {
        this.process_stage = v;
      }
    },
    showChoseFile: function showChoseFile() {
      return this.processStage == "idle";
    },
    showUploadFile: function showUploadFile() {
      return this.processStage == "file_selected";
    },
    showCancelUpload: function showCancelUpload() {
      return this.processStage == "file_selected";
    },
    fieldList: function fieldList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */];
    },
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["b" /* filed_types */];
    },
    allFields: function allFields() {
      return this.tabFieldList;
    },
    tabFieldList: function tabFieldList() {
      return [__WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].device_control_number, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].computer_name, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].equipment_in_charge_department, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].equipment_in_charge_team, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].equipment_in_charge_system, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].virtual_environment, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].virtual_base_unit, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].leasing_or_rental, {}), __WEBPACK_IMPORTED_MODULE_3__libs_utils__["a" /* utils */].extend(__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].manufacture_name, {})];
    }
  },
  methods: {
    onConfirmExecuteProcessOnly: function onConfirmExecuteProcessOnly(mode) {
      var _this = this;

      if (mode == "yes") {
        if (this.tab_name_mode == false) {
          return;
        }
        var syubetu = "";
        if (this.tab_name_mode == "temp_device_embedded_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.DEVICE;
        } else if (this.tab_name_mode == "temp_certificate_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.CERTIFICATE;
        } else if (this.tab_name_mode == "temp_associated_device") {
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.ASSOCIATED_DEVICE;
        } else if (this.tab_name_mode == "temp_device_embedded_detail") {
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.DEVICE_DETAIL;
        }
        var url = '/' + this.tab_name_mode + '/process_only/';
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        this.$ajax.post(url, { syubetu: syubetu }, function (err, result) {
          if (err) {
            _this.$notify({
              title: 'データの処理に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("applicationConfirmatioProcessOnlyModal", {
              title: "",
              message: syubetu + "を下書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "default",
              model_height: "50"
            });
          }
        });
      }
    },
    onConfirmExecuteProcessOnlySave: function onConfirmExecuteProcessOnlySave() {
      this.validateMaker(function (validated) {
        if (validated != true) {
          return;
        }
        console.log("onConfirmExecuteProcessOnlySave");
        __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("onConfirmExecuteProcessOnlySave", {
          message: "よろしいですか？",
          title: "登録情報を下書保存します。",
          yes_label: "下書保存",
          no_label: "戻る",
          yes_color: "primary",
          no_color: "",
          model_height: "50"
        });
      });
    },
    onConfirmExecuteProcessAndApply: function onConfirmExecuteProcessAndApply() {
      var _this2 = this;

      this.validateMaker(function (validated) {
        if (validated != true) {
          return;
        }
        if (_this2.tab_name_mode == false) {
          return;
        }
        var syubetu = "";
        var on_finish_url_name = "";
        if (_this2.tab_name_mode == "temp_device_embedded_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.DEVICE;
          on_finish_url_name = "page_0010_device_embedded_information";
        } else if (_this2.tab_name_mode == "temp_device_embedded_detail") {
          on_finish_url_name = "page_0010_device_embedded_information";
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.DEVICE_DETAIL;
        } else if (_this2.tab_name_mode == "temp_certificate_information") {
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.CERTIFICATE;
          on_finish_url_name = "page_0040_certificate_information";
        } else if (_this2.tab_name_mode == "temp_associated_device") {
          syubetu = __WEBPACK_IMPORTED_MODULE_13__rules_constants___default.a.SYUBETU.ASSOCIATED_DEVICE;
          on_finish_url_name = "page_0040_certificate_information";
        }
        __WEBPACK_IMPORTED_MODULE_15__libs_bus__["a" /* bus */].$emit("certificateApplicationConfimationModal", {
          application_mode: "bulk_import",
          title_prefix: syubetu,
          syubetu: syubetu,
          title_suffix: "（一括取込・" + syubetu + "）",
          process_import_url: '/' + _this2.tab_name_mode + '/process_and_apply/',
          on_finish_url_name: on_finish_url_name,
          ref_id: _this2.certificateManagementNumber
        });
      });
    },
    validateMaker: function validateMaker(cb) {
      var _this3 = this;

      if (this.tab_name_mode == "temp_certificate_information") {
        this.$notify({ clear: true });

        this.$ajax.post('/temp_certificate_information/validate_maker/', {}, function (err, result) {
          console.log({ err: err, result: result }, result.valid);
          if (result.valid == true) {
            _this3.$notify({
              title: 'Success',
              text: "Maker validated.",
              type: 'success',
              duration: 2000
            });
            cb(true);
          } else {
            _this3.$notify({
              title: 'Can not process',
              text: "The maker value of " + result.invalid_count + " rows are invalid, please fix it and repead",
              type: 'error',
              duration: 12000
            });
            cb(false);
          }
        });
      } else {
        cb(true);
      }
    },
    onExecuteClear: function onExecuteClear() {
      var _this4 = this;

      if (this.tab_name_mode == false) {
        return;
      }
      this.showSubTableDev = false;
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;

      this.$ajax.post('/' + this.tab_name_mode + '/clear/', {}, function (err, result) {
        if (err) {
          _this4.$notify({
            title: 'データのクリアに失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        }
        if (_this4.tab_name_mode == "temp_device_embedded_information") {
          _this4.selectDeviceEmbeddedInformation();
        } else if (_this4.tab_name_mode == "temp_certificate_information") {
          _this4.selectCertificate();
        } else if (_this4.tab_name_mode == "temp_associated_device") {
          _this4.selectAssociatedDevice();
        } else if (_this4.tab_name_mode == "temp_device_embedded_detail") {
          _this4.selectDeviceEmbeddedDetail();
        }
      });
    },
    selectDeviceEmbeddedInformation: function selectDeviceEmbeddedInformation() {
      this.dropdown_label = this.btn_dev_label;
      this.tab_name_mode = "temp_device_embedded_information";
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showSubTableDev = true;
    },
    selectCertificate: function selectCertificate() {
      this.dropdown_label = this.btn_cer_label;
      this.tab_name_mode = "temp_certificate_information";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showSubTableCer = true;
    },
    selectAssociatedDevice: function selectAssociatedDevice() {
      this.dropdown_label = this.btn_associated_device_label;
      this.tab_name_mode = "temp_associated_device";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = true;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showSubTableCer = false;
    },
    selectDeviceEmbeddedDetail: function selectDeviceEmbeddedDetail() {
      this.dropdown_label = this.btn_device_embedded_detail_label;
      this.tab_name_mode = "temp_device_embedded_detail";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = true;
      this.showSubTableCer = false;
    },
    cancelUpload: function cancelUpload() {
      this.selected_file_name = null;
      this.file_selected_event = null;
      this.processStage = "idle";
    },
    uploadFile: function uploadFile(options) {
      var _this5 = this;

      this.error_msg = "";
      this.processStage = "uploading";
      this.uploading = true;
      this.result_array = [];
      this.result_executed = false;
      var files = this.file_selected_event.target.files;
      if (!files[0]) {
        return;
      }
      var csv_data = new FormData();
      csv_data.append("csv", files[0]);
      mdebug("csv_data", csv_data);
      this.showSubTableDev = false;
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.post(this.$ajax.serverUrl + "/csv/upload/" + this.api_name, csv_data, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(function (response) {
        var data = response.data;
        mdebug("Upload done", response);
        if (response.data.success == true) {
          _this5.uploading = false;
          if (data.data.table == "temp_certificate_information") {
            _this5.selectCertificate();
          } else if (data.data.table == "temp_device_embedded_information") {
            _this5.selectDeviceEmbeddedInformation();
          } else if (data.data.table == "temp_associated_device") {
            _this5.selectAssociatedDevice();
          } else if (data.data.table == "temp_device_embedded_detail") {
            _this5.selectDeviceEmbeddedDetail();
          } else {}
          return _this5.processStage = "idle";
        } else {
          _this5.uploading = false;
          try {
            _this5.error_msg = "エラー ：" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.error).replace(/"/g, "") + "";
          } catch (error) {
            _this5.error_msg = "エラー ：" + response.data.error + "";
          }

          _this5.processStage = "preview_error";
          _this5.file_selected_event = null;
          _this5.selected_file_name = null;
          _this5.uploading = false;
          _this5.count_error++;
          _this5.result_executed = true;
        }
      }).catch(function (error) {
        _this5.error_msg = "エラー ：：： (" + error + ")";

        _this5.result_executed = true;
        mdebug("upload File error:", error);
        _this5.count_error++;
        _this5.processStage = "preview_error";
        _this5.result_error = "failed to upload: " + error;
        _this5.file_selected_event = null;
        _this5.selected_file_name = null;
        _this5.uploading = false;
      });
    },
    choseFile: function choseFile() {
      var csv_file = this.$refs.csv_file;
      csv_file.click();
    },
    fileClicked: function fileClicked(e) {
      var csv_file = this.$refs.csv_file;
      csv_file.value = null;
    },
    fileSelected: function fileSelected(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      mdebug("file_selected", files[0]);
      this.processStage = "file_selected";
      this.file_selected_event = e;
      this.selected_file_name = files[0].name;
    },
    createColumnDefs: function createColumnDefs() {
      var _this6 = this;

      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        arr.push(fi);
      });

      [__WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].more_details, __WEBPACK_IMPORTED_MODULE_2__rules_fields_bulk_import__["a" /* fields */].button_options].forEach(function (f) {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: function cellRenderer(params) {
            if (params.column.colId == "more_details") {
              return _this6.createGridTextButton("詳細", "color: #5b9bd5;", _this6.onDetailsClick, params.data);
            }
            if (params.column.colId == "button_options") {
              return _this6.createGridButton("glyphicon glyphicon glyphicon-unchecked", "color: #5b9bd5;", _this6.onSelectedClickDatasource, params.data);
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateLanguages__ = __webpack_require__(200);



/* harmony default export */ __webpack_exports__["a"] = ({
  isValidDate: function isValidDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }
    return !isNaN(date.getTime());
  },
  getDayNameAbbr: function getDayNameAbbr(date, days) {
    if ((typeof date === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(date)) !== 'object') {
      throw TypeError('Invalid Type');
    }
    return days[date.getDay()];
  },
  getMonthName: function getMonthName(month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array');
    }
    if ((typeof month === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(month)) === 'object') {
      return months[month.getMonth()];
    }
    if (typeof month === 'number') {
      return months[month];
    }
    throw TypeError('Invalid type');
  },
  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array');
    }
    if ((typeof month === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(month)) === 'object') {
      return monthsAbbr[month.getMonth()];
    }
    if (typeof month === 'number') {
      return monthsAbbr[month];
    }
    throw TypeError('Invalid type');
  },
  convertToUTC: function convertToUTC(date) {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  },
  daysInMonth: function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  },
  dayDiff: function dayDiff(start, end) {
    var MS_PER_DAY = 1000 * 60 * 60 * 24;

    var utc1 = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    var utc2 = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());

    return Math.floor((utc2 - utc1) / MS_PER_DAY);
  },
  getNthSuffix: function getNthSuffix(day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';
      case 2:
      case 22:
        return 'nd';
      case 3:
      case 23:
        return 'rd';
      default:
        return 'th';
    }
  },
  formatDate: function formatDate(date, format, translation) {
    translation = !translation ? __WEBPACK_IMPORTED_MODULE_1__DateLanguages__["a" /* default */].translations.en : translation;
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(date.getMonth(), translation.months.original)).replace(/MMM/, this.getMonthNameAbbr(date.getMonth(), translation.months.abbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä)/, month).replace(/su/, this.getNthSuffix(date.getDate())).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },
  formatDateTime: function formatDateTime(date, format, translation) {
    translation = !translation ? __WEBPACK_IMPORTED_MODULE_1__DateLanguages__["a" /* default */].translations.en : translation;
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    if (hour < 10 || hour.length == 1) {
      hour = "0" + hour;
    }
    if (minute < 10 || minute.length == 1) {
      minute = "0" + minute;
    }
    if (second < 10 || second.length == 1) {
      second = "0" + second;
    }
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/mm/, minute).replace(/ss/, second).replace(/hh/, hour).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(date.getMonth(), translation.months.original)).replace(/MMM/, this.getMonthNameAbbr(date.getMonth(), translation.months.abbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä)/, month).replace(/su/, this.getNthSuffix(date.getDate())).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },
  createDateArray: function createDateArray(start, end) {
    var dates = [];
    while (start <= end) {
      dates.push(new Date(start));
      start = new Date(start).setDate(new Date(start).getDate() + 1);
    }
    return dates;
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache", function() { return cache; });
var _this = this;

var cache_ = {
  list: {},
  get: function get(key) {
    if (typeof cache_.list[key] == "undefined") {
      return null;
    }
    if (cache_.list[key].expire < new Date().getTime()) {
      delete cache_.list[key];
      return null;
    }
    return cache_.list[key].data;
  },
  set: function set(key, data) {
    var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

    cache_.list[key] = {
      data: data,
      expire: new Date().getTime() + ttl * 1000
    };
  },
  clear: function clear() {
    _this.list = {};
  }
};

var cache = cache_;

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notification__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_ajax__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_bootstrap_less_bootstrap_less__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_bootstrap_less_bootstrap_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_bootstrap_less_bootstrap_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_ag_grid_dist_styles_ag_grid_css__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_ag_grid_dist_styles_ag_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__node_modules_ag_grid_dist_styles_ag_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_ag_grid_dist_styles_theme_blue_css__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_ag_grid_dist_styles_theme_blue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__node_modules_ag_grid_dist_styles_theme_blue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_ag_grid_dist_styles_theme_bootstrap_css__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_ag_grid_dist_styles_theme_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__node_modules_ag_grid_dist_styles_theme_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_header__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_localstorage__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_barcode_input__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_barcode_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_barcode_input__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var vdebug = __WEBPACK_IMPORTED_MODULE_1_debug___default()("esma:main");

if (localStorage.devMode == 1) {
  localStorage.debug = 'esma:*';
} else {
  localStorage.debug = 'esma:disabled';
  localStorage.devMode = 0;
  localStorage.forceHideMessages = 0;
}
if (localStorage.devMode2 != 1) {
  localStorage.devMode2 = 0;
}

vdebug("Starting app");









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("app-header", __WEBPACK_IMPORTED_MODULE_11__components_header___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_notification___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("barcode-input", __WEBPACK_IMPORTED_MODULE_13__components_barcode_input___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$debug = __WEBPACK_IMPORTED_MODULE_1_debug___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_6__libs_ajax__["a" /* default */];

var last_version = false;


new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',

  store: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = [{ name: "MHFG / BK", value: "FGBK", options: ["BK", "FG"] }, { name: "MHTB", value: "MHTB", options: ["TB"] }, { name: "MHIR", value: "MHIR", options: ["IR"] }];

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* unused harmony export filed_types */
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "差戻", "承認完了"],
  table_field_style: {
    "承認済": "color:;",
    "申請中": "color:blue;",
    "下書中": "color:#a0283a",
    "差戻": "color:red;"
  },
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "fk_id",
  label: "fk_id",
  type: types.INPUT
}, {
  id: "tab_id",
  label: "tab_id",
  type: types.INPUT
}, {
  id: "ref_id",
  label: "ref_id",
  type: types.INPUT
}, {
  id: "syubetu",
  label: "種別",
  type: types.SELECT_BOX,
  options: ["機器・組込情報", "証書情報"],
  import: { enabled: true }
}, {
  id: "control_number",
  label: "管理番号",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "toroku_number",
  label: "申請No",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "bulk_toroku_number",
  label: "一括編集No",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant_team",
  label: "申請者チーム",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "update_name",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "next_approver",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "applicant_label",
  label: "申請者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "update_name_label",
  label: "最終更新者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "next_approver_label",
  label: "次回承認者",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "create_time",
  label: "開始日時",
  type: types.CURRENT_TIME,
  import: { enabled: true }
}, {
  id: "update_time",
  label: "更新日時",
  type: types.CURRENT_TIME,
  import: { enabled: true }
}, {
  id: "licensed_department",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  api: "/master_belongs/list_department",
  import: { enabled: true }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}, {
  id: "record_checked",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}, {
  id: "status_0",
  label: "状態0",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_1",
  label: "所属チーム1",

  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_1_selected",
  api_uniq_grouping: true,
  import: { enabled: true }
}, {
  id: "approver_1",
  label: "承認者1",

  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_1",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_1_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_1",
    compare_api_key: "team",
    filter_data_on_event: "team_1_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_1",
  label: "状態1",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_2",
  label: "所属チーム2",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_2_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_1_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_2",
  label: "承認者2",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_2",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_2_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_2",
    compare_api_key: "team",
    filter_data_on_event: "team_2_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_2",
  label: "状態2",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_3",
  label: "所属チーム3",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_3_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_2_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_3",
  label: "承認者3",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_3",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_3_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_3",
    compare_api_key: "team",
    filter_data_on_event: "team_3_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_3",
  label: "状態3",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_4",
  label: "所属チーム4",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_4_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_3_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_4",
  label: "承認者4",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_4",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_4_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_4",
    compare_api_key: "team",
    filter_data_on_event: "team_4_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_4",
  label: "状態4",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_5",
  label: "所属チーム5",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_5_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_4_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_5",
  label: "承認者5",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_5",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_5_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_5",
    compare_api_key: "team",
    filter_data_on_event: "team_5_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_5",
  label: "状態5",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_6",
  label: "所属チーム6",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_6_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_5_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_6",
  label: "承認者6",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_6",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_6_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_6",
    compare_api_key: "team",
    filter_data_on_event: "team_6_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_6",
  label: "状態6",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_7",
  label: "所属チーム7",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_7_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_6_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_7",
  label: "承認者7",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_7",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_7_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_7",
    compare_api_key: "team",
    filter_data_on_event: "team_7_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_7",
  label: "状態7",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_8",
  label: "所属チーム8",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_8_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_7_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_8",
  label: "承認者8",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_8",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_8_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_8",
    compare_api_key: "team",
    filter_data_on_event: "team_8_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_8",
  label: "状態8",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_9",
  label: "所属チーム9",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_9_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_8_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_9",
  label: "承認者9",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_9",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_9_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_9",
    compare_api_key: "team",
    filter_data_on_event: "team_9_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_9",
  label: "状態9",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_10",
  label: "所属チーム10",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_10_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_9_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_10",
  label: "承認者10",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_10",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_10_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_10",
    compare_api_key: "team",
    filter_data_on_event: "team_10_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_10",
  label: "状態10",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_11",
  label: "所属チーム11",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_11_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_10_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_11",
  label: "承認者11",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_11",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_11_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_11",
    compare_api_key: "team",
    filter_data_on_event: "team_11_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_11",
  label: "状態11",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_12",
  label: "所属チーム12",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_12_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_11_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_12",
  label: "承認者12",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_12",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_12_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_12",
    compare_api_key: "team",
    filter_data_on_event: "team_12_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_12",
  label: "状態12",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_13",
  label: "所属チーム13",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_13_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_12_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_13",
  label: "承認者13",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_13",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_13_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_13",
    compare_api_key: "team",
    filter_data_on_event: "team_13_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_13",
  label: "状態13",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_14",
  label: "所属チーム14",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_14_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_13_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_14",
  label: "承認者14",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_14",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_14_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_14",
    compare_api_key: "team",
    filter_data_on_event: "team_14_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_14",
  label: "状態14",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_15",
  label: "所属チーム15",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_15_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_14_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_15",
  label: "承認者15",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_15",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_15_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_15",
    compare_api_key: "team",
    filter_data_on_event: "team_15_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_15",
  label: "状態15",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_16",
  label: "所属チーム16",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_16_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_15_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_16",
  label: "承認者16",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_16",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_16_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_16",
    compare_api_key: "team",
    filter_data_on_event: "team_16_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_16",
  label: "状態16",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_17",
  label: "所属チーム17",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_17_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_16_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_17",
  label: "承認者17",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_17",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_17_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_17",
    compare_api_key: "team",
    filter_data_on_event: "team_17_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_17",
  label: "状態17",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_18",
  label: "所属チーム18",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_18_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_17_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_18",
  label: "承認者18",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_18",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_18_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_18",
    compare_api_key: "team",
    filter_data_on_event: "team_18_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_18",
  label: "状態18",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_19",
  label: "所属チーム19",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_19_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_18_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_19",
  label: "承認者19",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_19",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",
  global_emit: "approver_19_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_19",
    compare_api_key: "team",
    filter_data_on_event: "team_19_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_19",
  label: "状態19",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "team_20",
  label: "所属チーム20",
  type: types.SELECT_BOX4,
  api: "/master_user/list_user_and_team/",
  api_field_name: "team",
  global_emit: "team_20_selected",
  api_uniq_grouping: true,
  api_filter_to_other_field: {
    filter_data_on_event: "approver_19_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "approver_20",
  label: "承認者20",
  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_20",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",

  api_uniq_grouping: true,
  api_filter_to_other_field: {
    by_field: "team_20",
    compare_api_key: "team",
    filter_data_on_event: "team_20_selected",
    disable_is_no_value: true
  },
  import: { enabled: true }
}, {
  id: "status_20",
  label: "状態20",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "approver_final",
  label: "最終承認者",

  type: types.SELECT_BOX4,
  field_label_reference: "approver_label_final",
  api: "/master_user/list_user_and_team/",
  api_field_name: "user_id",
  api_field_label: "user_shimei",

  import: { enabled: true }
}, {
  id: "status_final",
  label: "最終状態",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "approver_label_1",
  label: "承認者1",
  type: types.INPUT
}, {
  id: "approver_label_2",
  label: "承認者2",
  type: types.INPUT
}, {
  id: "approver_label_3",
  label: "承認者3",
  type: types.INPUT
}, {
  id: "approver_label_4",
  label: "承認者4",
  type: types.INPUT
}, {
  id: "approver_label_5",
  label: "承認者5",
  type: types.INPUT
}, {
  id: "approver_label_6",
  label: "承認者6",
  type: types.INPUT
}, {
  id: "approver_label_7",
  label: "承認者7",
  type: types.INPUT
}, {
  id: "approver_label_8",
  label: "承認者8",
  type: types.INPUT
}, {
  id: "approver_label_9",
  label: "承認者9",
  type: types.INPUT
}, {
  id: "approver_label_10",
  label: "承認者10",
  type: types.INPUT
}, {
  id: "approver_label_11",
  label: "承認者11",
  type: types.INPUT
}, {
  id: "approver_label_12",
  label: "承認者12",
  type: types.INPUT
}, {
  id: "approver_label_13",
  label: "承認者13",
  type: types.INPUT
}, {
  id: "approver_label_14",
  label: "承認者14",
  type: types.INPUT
}, {
  id: "approver_label_15",
  label: "承認者15",
  type: types.INPUT
}, {
  id: "approver_label_16",
  label: "承認者16",
  type: types.INPUT
}, {
  id: "approver_label_17",
  label: "承認者17",
  type: types.INPUT
}, {
  id: "approver_label_18",
  label: "承認者18",
  type: types.INPUT
}, {
  id: "approver_label_19",
  label: "承認者19",
  type: types.INPUT
}, {
  id: "approver_label_20",
  label: "承認者20",
  type: types.INPUT
}, {
  id: "approver_label_final",
  label: "最終承認者",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "change_time",
  label: "更新日",
  tab_size: 20,
  type: types.INPUT
}, {
  id: "user_id",
  label: "更新者(id)",
  tab_size: 10,
  type: types.INPUT
}, {
  id: "user_label",
  label: "更新者",
  tab_size: 15,
  type: types.INPUT
}, {
  id: "fk_tab",
  label: "種別",
  type: types.SELECT_BOX2,
  error_if_blank: true,
  options: [{ value: 1, label: "機器・組込情報" }, { value: 2, label: "証書情報" }, { value: 3, label: "tab_3" }, { value: 4, label: "tab_4" }, { value: 5, label: "tab_5" }, { value: 6, label: "tab_6" }, { value: 7, label: "tab_7" }, { value: 8, label: "証書情報" }, { value: 9, label: "ソフトウェア情報" }, { value: 51, label: "申請フロー" }, { value: 52, label: "申請フロー" }],
  tab_size: 20
}, {
  id: "fk_id",
  label: "fk_id",
  type: types.INPUT,
  tab_size: 15
}, {
  id: "data_id",
  label: "証書管理番号",
  tab_size: 15,
  type: types.INPUT
}, {
  id: "mode",
  label: "操作",
  type: types.SELECT_BOX2,
  error_if_blank: true,
  options: [{ value: 1, label: "追加" }, { value: 2, label: "変更" }, { value: 3, label: "削除" }, { value: 4, label: "更新" }],
  tab_size: 5
}, {
  id: "description",
  label: "概要",
  tab_size: 50,
  type: types.INPUT
}, {
  id: "old_data",
  label: "古いデータ",
  tab_size: 20,
  type: types.INPUT
}, {
  id: "new_data",
  label: "新しいデータ",
  tab_size: 20,
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "department",
  label: "部署名",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_department: "A",
    excess_deficiency_summary_all: "A",
    excess_deficiency_summary_team: "A",
    excess_deficiency_summary_system: "B"
  }
}, {
  id: "team",
  label: "チーム名",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_team: "B"
  }
}, {
  id: "system_name",
  label: "システム名",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_system: "A"
  }
}, {
  id: "item_number",
  label: "総本数",
  field_type: "number",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_department: "B",
    excess_deficiency_summary_all: "B",
    excess_deficiency_summary_team: "C",
    excess_deficiency_summary_system: "C"
  }
}, {
  id: "number_to_be_linked",
  label: "紐付対象数",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_department: "C",
    excess_deficiency_summary_all: "C",
    excess_deficiency_summary_team: "D",
    excess_deficiency_summary_system: "D"
  }
}, {
  id: "number_of_link",
  label: "紐付数",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_department: "D",
    excess_deficiency_summary_all: "D",
    excess_deficiency_summary_team: "E",
    excess_deficiency_summary_system: "E"
  }
}, {
  id: "number_of_unlinked",
  label: "未紐付数",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_department: "E",
    excess_deficiency_summary_all: "E",
    excess_deficiency_summary_team: "F",
    excess_deficiency_summary_system: "F"
  }
}, {
  id: "linking_rate",
  label: "紐付率",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    excess_deficiency_summary_department: "F",
    excess_deficiency_summary_all: "F",
    excess_deficiency_summary_team: "G",
    excess_deficiency_summary_system: "G"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};
var constants = __webpack_require__(15);
var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "device_control_number",
  label: "機器管理番号",
  tab_size: 10,
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "A"
  }
}, {
  id: "certificate_software_number",
  label: "証書管理番号",
  type: types.INPUT,
  import: {
    enabled: true,
    alias: ["証書管理番号\r\n(必須)"]
  },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software_deposit: "F",
    certificate_software: "D",
    surplus_license: "C",
    individual_linking_details: "F"
  }
}, {
  id: "software",
  label: "ソフトウェア名",
  tab_size: 30,
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "G"
  }
}, {
  id: "item_number",
  label: "使用するライセンス数",
  tab_size: 10,
  type: types.INPUT,
  error_if_blank: true,
  listen_for_value: "licence_item_number_force_update",
  field_type: "number",
  min_value: "1",
  import: { enabled: true,
    alias: ["紐付本数\r\n(半角数字)"] },
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "I"
  }
}, {
  id: "computer_name",
  label: "コンピュータ名",
  type: types.INPUT,
  error_if_blank: true,
  import: {
    enabled: true,
    alias: ["コンピュータ名"]
  },
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "B"
  }
}, {
  id: "jurisdiction_classification",
  label: "所管",
  tab_size: 10,
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "C"
  }
}, {
  id: "software_jurisdiction",
  label: "SW所管",
  tab_size: 10,
  type: types.SELECT_BOX,
  options: [constants.SOFTWARE_JURISDICTION.OWN_DEPARTMENT, constants.SOFTWARE_JURISDICTION.OTHER_DEPARTMENT],
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "H"
  }
}, {
  id: "floor",
  label: "フロア",
  tab_size: 10,
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "E"
  }
}, {
  id: "installation_base",
  label: "ビル",
  tab_size: 10,
  type: types.INPUT,
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "D"
  }
}, {
  id: "remarks",
  label: "備考",
  tab_size: 30,
  type: types.TEXT_AREA,
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "K"
  }
}, {
  id: "software_category",
  label: "ソフトウェアカテゴリ",
  type: types.SELECT_BOX,
  options: ["アプリケーション", "OS", "ミドルウェア", "DBソフトウェア", "ウイルス対策", "その他"],
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "J"
  }
}, {
  id: "c_remarks",
  label: "ソフトウェア備考",
  tab_size: 30,
  type: types.TEXT_AREA,
  export: {
    enabled: true,
    sequence: 1000,
    individual_linking_details: "L"
  }
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _ref;

var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{
  id: "seq_id",
  label: "Unique Key",
  type: types.INPUT
}, {
  id: "certificate_seq_id",
  label: "証書管理番号(ref)",
  type: types.INPUT,
  import: {
    enabled: true
  }
}, {
  id: "certificate_software_number",
  label: "証書管理番号",
  type: types.INPUT,
  import: {
    enabled: true,
    alias: ["証書管理番号\r\n(必須)"]
  },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software_deposit: "F",
    certificate_software: "D",
    surplus_license: "C",
    inventory_certificate_list: "B"
  }
}, {
  id: "maker",
  label: "メーカ",

  type: types.SELECT_BOX4,
  error_if_blank: true,
  api_uniq_grouping: true,
  api: "/master_maker/list_maker_name",

  event_emit_bus_key: "certificate_software_manufacture_name_software_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_information: "I",
    certificate_software: "J",
    certificate_software_deposit: "B",
    surplus_license: "B"
  }
}, (_ref = {
  id: "software_name",
  label: "ソフトウェア名",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  api_uniq_grouping: true,
  api: "/master_software/list_software_name_maker_name"
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "error_if_blank", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "import", { enabled: true }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "api_field_name", "software_name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "api_filter_to_other_field", {
  by_field: "maker",
  compare_api_key: "maker_name",
  filter_data_on_event: "certificate_software_manufacture_name_software_name"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "export", {
  enabled: true,
  sequence: 1000,
  surplus_license: "D",
  inventory_certificate_list: "D"
}), _ref), {
  id: "license_name",
  label: "ライセンス名",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software_deposit: "C",
    certificate_software: "K",
    inventory_certificate_list: "C"
  }
}, {
  id: "jurisdiction_classification",
  label: "所管区分",
  type: types.SELECT_BOX,
  error_if_blank: true,
  options: ["EUC・その他", "IT所管システム"],
  import: { enabled: true },
  api_uniq_grouping: true,
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "F"
  }
}, {
  id: "company",
  label: "ライセンス所管会社",
  type: types.SELECT_BOX4,
  error_if_blank: true,
  page_controller: true,
  api_uniq_grouping: true,
  default_from_local_storage: "userCompany",
  api: "/master_company/list_company_name",
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "E"
  }
}, {
  id: "licensed_department",
  label: "ライセンス所管部署",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  api: "/master_belongs/list_department",
  default_from_local_storage: "userDepartment",
  limit_department_on_search: true,

  page_controller: true,
  api_uniq_grouping: true,
  search_option: {
    define_department_limit_to_key: "license_jurisdiction_team"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "G"
  }
}, {
  id: "license_jurisdiction_team",
  label: "ライセンス所管チーム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  api: "/master_belongs/list_team_and_department",
  default_from_local_storage: "userTeam",
  api_field_name: "team",
  api_uniq_grouping: true,

  limit_department_on_search: true,

  page_controller: true,
  search_option: {
    define_department_limit_by_key: "licensed_department",
    api_field_name: "department"
  },
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "H"
  }
}, {
  id: "license_jurisdiction_system",
  label: "ライセンス所管システム",
  type: types.SELECT_BOX4,
  search_mode_type_ahead: true,
  sort_result: true,
  error_if_blank: true,
  api: "/master_system/list_system_name",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "I"
  }
}, {
  id: "equipment_in_charge_system",
  label: "所管システム/用途",
  type: types.INPUT,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "product_key",
  label: "プロダクトキー",
  type: types.INPUT,
  import: { enabled: true }
}, {
  id: "upgrade",
  label: "アップグレード",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  default_value: "無",
  import: {
    enabled: true,
    alias: ["アップグレード\r\n(有/無)"]
  }
}, {
  id: "upgrade_source",
  label: "アップグレード元",
  type: types.INPUT,
  error_if_blank: true,
  min_value: "0",
  import: { enabled: true }
}, {
  id: "upgrade_destination",
  label: "アップグレード先",
  type: types.INPUT,
  read_only: true,
  disabled: true,
  min_value: "0",
  import: { enabled: true }
}, {
  id: "deadline_alert",
  label: "有効期限　有無",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true
  }
}, {
  id: "expiration_date",
  label: "有効期限",
  type: types.DATE_PICKER,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "N",
    surplus_license: "F"
  }
}, {
  id: "maintenance_deadline",
  label: "保守期限",
  type: types.DATE_PICKER,
  import: { enabled: true, date_format: "YYYY-MM-DD" },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "O",
    surplus_license: "G"
  }
}, {
  id: "second_number",
  label: "セカンド数",
  type: types.INPUT,
  field_type: "number",
  min_value: "0",
  import: { enabled: true }
}, {
  id: "unlimited",
  label: "無制限",
  type: types.SELECT_BOX,
  no_blank: true,
  default_value: "ー",
  options: ["無制限", "ー"],
  import: {
    enabled: true,
    alias: ["無制限\r\n(無制限/-)"]
  }
}, {
  id: "license",
  label: "ライセンス数",
  type: types.INPUT,
  error_if_blank: true,
  field_type: "number",
  min_value: "1",
  import: { enabled: true },
  export: {
    enabled: true, sequence: 1000,
    certificate_software_deposit: "E",
    surplus_license: "E",
    inventory_certificate_list: "E"
  }

}, {
  id: "applicant_name",
  label: "申請者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "management_person_name",
  label: "管理担当者名（ﾌﾙﾈｰﾑ）",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "comprehensive_contract",
  label: "包括契約",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "effective_number",
  label: "使用数",
  type: types.INPUT,
  exact_value: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "L",
    inventory_certificate_list: "F"
  }
}, {
  id: "remaining_number",
  label: "残数",
  exact_value: true,
  type: types.INPUT,
  tab_size: 20,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "M",
    inventory_certificate_list: "G"
  }
}, {
  id: "remark",
  label: "備考",
  type: types.TEXT_AREA,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000
  }
}, {
  id: "retraction_reason",
  label: "差戻通知",
  type: types.TEXT_AREA,
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "approval_status",
  label: "承認状態",
  type: types.SELECT_BOX,
  options: ["承認済", "申請中", "下書中", "差戻"],
  table_field_style: {
    "承認済": "color:;",
    "申請中": "color:blue;",
    "下書中": "color:#a0283a",
    "差戻": "color:red;"
  },
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "B",
    surplus_license: "A"
  }
}, {
  id: "status",
  label: "状態",
  type: types.SELECT_BOX,
  options: ["使用中", "廃棄"],
  import: { enabled: false },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "C"
  }
}, {
  id: "registration_date",
  label: "登録日",
  type: types.DATE_PICKER,
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software: "A"
  }
}, {
  id: "second",
  label: "セカンド",
  tab_size: 10,
  type: types.SELECT_BOX,
  default_value: "無",
  options: ["有", "無"],
  import: { enabled: true }
}, {
  id: "downgrade",
  label: "アップ・ダウングレード",
  type: types.SELECT_BOX,
  options: ["有", "無"],
  import: { enabled: true },
  export: { enabled: true, sequence: 1000 }
}, {
  id: "license_certificate_type",
  label: "ライセンス証書種類",
  type: types.INPUT,
  error_if_blank: true,
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    certificate_software_deposit: "D"
  }
}, {
  id: "deadline_check",
  label: "期限チェック",
  tab_size: 25,
  type: types.INPUT,
  error_if_blank: true,
  field_type: "number",
  min_value: "0",
  import: { enabled: true },
  export: {
    enabled: true,
    sequence: 1000,
    surplus_license: "H"
  }
}, {
  id: "more_details",
  label: "詳細",
  type: types.INPUT
}, {
  id: "button_options",
  history_label_name: "hide",
  label: "ﾁｪｯｸ",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });
var arrToObj = function arrToObj(arr) {
  var obj = {};
  arr.forEach(function (a) {
    obj[a[0]] = a[1];
  });
  return obj;
};
var types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button"
};

var arr = [{ id: "seq_id", label: "Unique Key", type: types.INPUT }, {
  id: "change_time",
  label: "更新日",
  tab_size: 20,
  type: types.INPUT
}, {
  id: "user_id",
  label: "更新者(id)",
  tab_size: 10,
  type: types.INPUT
}, {
  id: "user_shimei",
  label: "更新者",
  tab_size: 10,
  type: types.INPUT
}, {
  id: "log_tab",
  label: "種別",
  tab_size: 10,
  type: types.INPUT
}, {
  id: "log_id",
  label: "log_id",
  type: types.INPUT
}, {
  id: "fk_tab",
  label: "fk_tab",
  type: types.INPUT
}, {
  id: "fk_id",
  label: "fk_id",
  type: types.INPUT
}, {
  id: "field_name",
  label: "項目",
  tab_size: 10,
  type: types.INPUT
}, {
  id: "value_before",
  label: "変更前",
  tab_size: 20,
  type: types.INPUT
}, {
  id: "value_after",
  label: "変更後",
  tab_size: 20,
  type: types.INPUT
}, {
  id: "status",
  label: "status",
  type: types.INPUT
}];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  };
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
var fields = ret;
var filed_types = types;

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filed_types; });


var fields = {
  "ci_row_seq_label": {
    "id": "ci_row_seq_label",
    "label": "項番",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "A",
      "debug": "1"
    },
    "tab_label": "項番",
    "tab_size": 36,
    "seq_id": 1
  },
  "ci_certificate_management_number": {
    "id": "ci_certificate_management_number",
    "label": "紐付証書管理番号\r\n(自動採番)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "B",
      "partial_required": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "紐付証書管理番号\r\n(自動採番)",
    "tab_size": 218,
    "seq_id": 2
  },
  "ci_seq_id": {
    "id": "ci_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 3
  },
  "ci_seq_ref": {
    "id": "ci_seq_ref",
    "label": "証書G",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "C",
      "debug": "1"
    },
    "tab_label": "証書G",
    "tab_size": 49,
    "seq_id": 4
  },
  "ad_seq_ref": {
    "id": "ad_seq_ref",
    "label": "SW枝番",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "D",
      "debug": "1"
    },
    "tab_label": "SW枝番",
    "tab_size": 62,
    "seq_id": 5
  },
  "ci_mb_department_code": {
    "id": "ci_mb_department_code",
    "label": "ライセンス所管部署コード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "E",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "ライセンス所管部署コード※",
    "tab_size": 179,
    "seq_id": 6
  },
  "ci_licensed_department": {
    "id": "ci_licensed_department",
    "label": "ライセンス所管部署名",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "F",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス所管部署名",
    "tab_size": 140,
    "seq_id": 7
  },
  "ci_mb_team_code": {
    "id": "ci_mb_team_code",
    "label": "ライセンス所管チームコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "G",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "ライセンス所管チームコード※",
    "tab_size": 192,
    "seq_id": 8
  },
  "ci_license_jurisdiction_team": {
    "id": "ci_license_jurisdiction_team",
    "label": "ライセンス所管チーム名",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "H",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス所管チーム名",
    "tab_size": 153,
    "seq_id": 9
  },
  "ci_jurisdiction_classification": {
    "id": "ci_jurisdiction_classification",
    "label": "所管区分※\r\n(プルダウンより選択)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "I",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "所管区分※\r\n(プルダウンより選択)",
    "tab_size": 244,
    "seq_id": 10
  },
  "ci_ms_system_code": {
    "id": "ci_ms_system_code",
    "label": "ライセンス所管システムコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "J",
      "debug": "2",
      "table": "master_system"
    },
    "tab_label": "ライセンス所管システムコード※",
    "tab_size": 205,
    "seq_id": 11
  },
  "ci_license_jurisdiction_system": {
    "id": "ci_license_jurisdiction_system",
    "label": "ライセンス所管システム名",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "K",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス所管システム名",
    "tab_size": 166,
    "seq_id": 12
  },
  "ci_equipment_in_charge_system": {
    "id": "ci_equipment_in_charge_system",
    "label": "所管システム/用途",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "L",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "所管システム/用途",
    "tab_size": 127,
    "seq_id": 13
  },
  "ci_license_certificate_type": {
    "id": "ci_license_certificate_type",
    "label": "ライセンス証書種類※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "M",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "ライセンス証書種類※",
    "tab_size": 140,
    "seq_id": 14
  },
  "ci_certificate_individual_number": {
    "id": "ci_certificate_individual_number",
    "label": "証書個別番号\r\n",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "N",
      "partial_required": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "証書個別番号\r\n",
    "tab_size": 114,
    "seq_id": 15
  },
  "ci_mm_seq_id": {
    "id": "ci_mm_seq_id",
    "label": "メーカコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "O",
      "debug": "2",
      "table": "master_maker"
    },
    "tab_label": "メーカコード※",
    "tab_size": 101,
    "seq_id": 16
  },
  "ci_maker": {
    "id": "ci_maker",
    "label": "メーカー名\r\n(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "P",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "メーカー名\r\n(システム登録情報)",
    "tab_size": 231,
    "seq_id": 17
  },
  "ci_applicant_name": {
    "id": "ci_applicant_name",
    "label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "Q",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 192,
    "seq_id": 18
  },
  "ci_management_person_name": {
    "id": "ci_management_person_name",
    "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "R",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 218,
    "seq_id": 19
  },
  "ci_comprehensive_contract": {
    "id": "ci_comprehensive_contract",
    "label": "包括契約※\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "S",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "包括契約※\r\n(有/無)",
    "tab_size": 166,
    "seq_id": 20
  },
  "ci_sales_company": {
    "id": "ci_sales_company",
    "label": "販売会社",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "T",
      "partial_required": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "販売会社",
    "tab_size": 62,
    "seq_id": 21
  },
  "ci_deadline_alert": {
    "id": "ci_deadline_alert",
    "label": "期限アラート※\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "U",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "期限アラート※\r\n(有/無)",
    "tab_size": 192,
    "seq_id": 22
  },
  "ci_expiration_date": {
    "id": "ci_expiration_date",
    "label": "有効期限\r\n(YYYY/MM/DD)",
    "type": "date_picker",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "V",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "有効期限\r\n(YYYY/MM/DD)",
    "tab_size": 244,
    "seq_id": 23
  },
  "ci_maintenance_deadline": {
    "id": "ci_maintenance_deadline",
    "label": "保守期限\r\n(YYYY/MM/DD)",
    "type": "date_picker",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "W",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "保守期限\r\n(YYYY/MM/DD)",
    "tab_size": 244,
    "seq_id": 24
  },
  "ad_seq_id": {
    "id": "ad_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 25
  },
  "ad_certificate_software_number": {
    "id": "ad_certificate_software_number",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 26
  },
  "ad_license_name": {
    "id": "ad_license_name",
    "label": "ライセンス名※\r\n証書記載の通り",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "X",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス名※\r\n証書記載の通り",
    "tab_size": 218,
    "seq_id": 27
  },
  "ad_ms_software_code": {
    "id": "ad_ms_software_code",
    "label": "ソフトウェアコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "Y",
      "debug": "2",
      "table": "master_software"
    },
    "tab_label": "ソフトウェアコード※",
    "tab_size": 140,
    "seq_id": 28
  },
  "ad_software_name": {
    "id": "ad_software_name",
    "label": "ソフトウェア名\r\n(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "Z",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ソフトウェア名\r\n(システム登録情報)",
    "tab_size": 257,
    "seq_id": 29
  },
  "ad_product_key": {
    "id": "ad_product_key",
    "label": "プロダクトキー",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AA",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "プロダクトキー",
    "tab_size": 101,
    "seq_id": 30
  },
  "ad_unlimited": {
    "id": "ad_unlimited",
    "label": "無制限\r\n(無制限/-)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AB",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "無制限\r\n(無制限/-)",
    "tab_size": 166,
    "seq_id": 31
  },
  "ad_second": {
    "id": "ad_second",
    "label": "セカンド",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AC",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "セカンド",
    "tab_size": 62,
    "seq_id": 32
  },
  "ad_second_number": {
    "id": "ad_second_number",
    "label": "セカンド数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AD",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "セカンド数",
    "tab_size": 75,
    "seq_id": 33
  },
  "ad_license": {
    "id": "ad_license",
    "label": "ライセンス数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AE",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス数",
    "tab_size": 88,
    "seq_id": 34
  },
  "di_row_seq_label": {
    "id": "di_row_seq_label",
    "label": "項番_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "AF",
      "debug": "1"
    },
    "tab_label": "項番",
    "tab_size": 36,
    "seq_id": 35
  },
  "di_device_control_number": {
    "id": "di_device_control_number",
    "label": "機器管理番号\r\n(自動採番)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AG",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器管理番号\r\n(自動採番)",
    "tab_size": 192,
    "seq_id": 36
  },
  "di_seq_id": {
    "id": "di_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 37
  },
  "di_seq_ref": {
    "id": "di_seq_ref",
    "label": "機器G",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "AH",
      "debug": "1"
    },
    "tab_label": "機器G",
    "tab_size": 49,
    "seq_id": 38
  },
  "di_computer_name": {
    "id": "di_computer_name",
    "label": "コンピュータ名※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AI",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "コンピュータ名※",
    "tab_size": 114,
    "seq_id": 39
  },
  "di_virtual_environment": {
    "id": "di_virtual_environment",
    "label": "仮想環境\r\n(有/無)※",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AJ",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "仮想環境\r\n(有/無)※",
    "tab_size": 166,
    "seq_id": 40
  },
  "di_virtual_base_unit": {
    "id": "di_virtual_base_unit",
    "label": "仮想環境の親機",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AK",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "仮想環境の親機",
    "tab_size": 101,
    "seq_id": 41
  },
  "di_mb_department_code": {
    "id": "di_mb_department_code",
    "label": "機器所管部署コード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AL",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "機器所管部署コード※",
    "tab_size": 140,
    "seq_id": 42
  },
  "di_equipment_in_charge_department": {
    "id": "di_equipment_in_charge_department",
    "label": "機器所管部署名(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AM",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管部署名(システム登録情報)",
    "tab_size": 231,
    "seq_id": 43
  },
  "di_mb_team_code": {
    "id": "di_mb_team_code",
    "label": "機器所管チームコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AN",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "機器所管チームコード※",
    "tab_size": 153,
    "seq_id": 44
  },
  "di_equipment_in_charge_team": {
    "id": "di_equipment_in_charge_team",
    "label": "機器所管チーム名\r\n(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AO",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管チーム名\r\n(システム登録情報)",
    "tab_size": 270,
    "seq_id": 45
  },
  "di_equipment_in_charge_classification": {
    "id": "di_equipment_in_charge_classification",
    "label": "機器所管区分※\r\n(プルダウンより選択)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AP",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管区分※\r\n(プルダウンより選択)",
    "tab_size": 270,
    "seq_id": 46
  },
  "di_ms_system_code": {
    "id": "di_ms_system_code",
    "label": "機器所管システムコード\r\n(システム名)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AQ",
      "debug": "2",
      "table": "master_system"
    },
    "tab_label": "機器所管システムコード\r\n(システム名)",
    "tab_size": 270,
    "seq_id": 47
  },
  "di_equipment_in_charge_system_it": {
    "id": "di_equipment_in_charge_system_it",
    "label": "機器所管システム\r\n(システム名)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AR",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管システム\r\n(システム名)",
    "tab_size": 231,
    "seq_id": 48
  },
  "di_equipment_in_charge_system": {
    "id": "di_equipment_in_charge_system",
    "label": "所管システム/用途\r\n(システム名)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AS",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "所管システム/用途\r\n(システム名)",
    "tab_size": 244,
    "seq_id": 49
  },
  "di_leasing_or_rental": {
    "id": "di_leasing_or_rental",
    "label": "リース・レンタル※\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AT",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "リース・レンタル※\r\n(有/無)",
    "tab_size": 218,
    "seq_id": 50
  },
  "di_manufacture_name": {
    "id": "di_manufacture_name",
    "label": "メーカー名",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AU",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "メーカー名",
    "tab_size": 75,
    "seq_id": 51
  },
  "di_model_name": {
    "id": "di_model_name",
    "label": "機種名",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AV",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機種名",
    "tab_size": 49,
    "seq_id": 52
  },
  "di_equipment_classification": {
    "id": "di_equipment_classification",
    "label": "機器区分※\r\n(プルダウンより選択)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AW",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器区分※\r\n(プルダウンより選択)",
    "tab_size": 244,
    "seq_id": 53
  },
  "di_cpu_count": {
    "id": "di_cpu_count",
    "label": "CPU数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AX",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "CPU数",
    "tab_size": 62,
    "seq_id": 54
  },
  "di_mb2_department_code": {
    "id": "di_mb2_department_code",
    "label": "設置部署コード",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AY",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "設置部署コード",
    "tab_size": 101,
    "seq_id": 55
  },
  "di_installation_department": {
    "id": "di_installation_department",
    "label": "設置部署名※",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AZ",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "設置部署名※",
    "tab_size": 88,
    "seq_id": 56
  },
  "di_mb2_team_code": {
    "id": "di_mb2_team_code",
    "label": "設置チームコード",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BA",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "設置チームコード",
    "tab_size": 114,
    "seq_id": 57
  },
  "di_installation_team": {
    "id": "di_installation_team",
    "label": "設置チーム※",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BB",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "設置チーム※",
    "tab_size": 88,
    "seq_id": 58
  },
  "di_installation_base": {
    "id": "di_installation_base",
    "label": "設置拠点",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BC",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "設置拠点",
    "tab_size": 62,
    "seq_id": 59
  },
  "di_floor": {
    "id": "di_floor",
    "label": "フロア",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BD",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "フロア",
    "tab_size": 49,
    "seq_id": 60
  },
  "di_user_name": {
    "id": "di_user_name",
    "label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BE",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 192,
    "seq_id": 61
  },
  "di_management_person_name": {
    "id": "di_management_person_name",
    "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BF",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 218,
    "seq_id": 62
  },
  "di_remarks": {
    "id": "di_remarks",
    "label": "備考欄",
    "type": "text_area",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BG",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "備考欄",
    "tab_size": 49,
    "seq_id": 63
  },
  "ci_seq_ref_link": {
    "id": "ci_seq_ref_link",
    "label": "証書G_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "BH",
      "debug": "1"
    },
    "tab_label": "証書G",
    "tab_size": 49,
    "seq_id": 64
  },
  "ad_seq_ref_link": {
    "id": "ad_seq_ref_link",
    "label": "SW枝番_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "BI",
      "debug": "1"
    },
    "tab_label": "SW枝番",
    "tab_size": 62,
    "seq_id": 65
  },
  "dd_item_number": {
    "id": "dd_item_number",
    "label": "紐付け本数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BJ",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "紐付け本数",
    "tab_size": 75,
    "seq_id": 66
  },
  "dd_seq_id": {
    "id": "dd_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 67
  },
  "dd_associated_device_seq_id": {
    "id": "dd_associated_device_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 68
  },
  "dd_virtual_id": {
    "id": "dd_virtual_id",
    "label": "仮想\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BK",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "仮想\r\n(有/無)",
    "tab_size": 127,
    "seq_id": 69
  },
  "dd_software_jurisdiction": {
    "id": "dd_software_jurisdiction",
    "label": "ソフトウェア所管※",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BL",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "ソフトウェア所管※",
    "tab_size": 127,
    "seq_id": 70
  },
  "more_details": {
    "id": "more_details",
    "label": "詳細",
    "type": "input",
    "import_details": {
      "p": ""
    },
    "tab_label": "詳細",
    "tab_size": 36,
    "seq_id": 71
  },
  "button_options": {
    "id": "button_options",
    "history_label_name": "hide",
    "label": "要修正",
    "tab_label": "要修正",
    "type": "input",
    "import_details": {
      "p": ""
    },
    "tab_size": 70,
    "seq_id": 72
  },
  "array": [{
    "id": "ci_row_seq_label",
    "label": "項番",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "A",
      "debug": "1"
    },
    "tab_label": "項番",
    "tab_size": 36,
    "seq_id": 1
  }, {
    "id": "ci_certificate_management_number",
    "label": "紐付証書管理番号\r\n(自動採番)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "B",
      "partial_required": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "紐付証書管理番号\r\n(自動採番)",
    "tab_size": 218,
    "seq_id": 2
  }, {
    "id": "ci_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 3
  }, {
    "id": "ci_seq_ref",
    "label": "証書G",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "C",
      "debug": "1"
    },
    "tab_label": "証書G",
    "tab_size": 49,
    "seq_id": 4
  }, {
    "id": "ad_seq_ref",
    "label": "SW枝番",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "D",
      "debug": "1"
    },
    "tab_label": "SW枝番",
    "tab_size": 62,
    "seq_id": 5
  }, {
    "id": "ci_mb_department_code",
    "label": "ライセンス所管部署コード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "E",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "ライセンス所管部署コード※",
    "tab_size": 179,
    "seq_id": 6
  }, {
    "id": "ci_licensed_department",
    "label": "ライセンス所管部署名",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "F",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス所管部署名",
    "tab_size": 140,
    "seq_id": 7
  }, {
    "id": "ci_mb_team_code",
    "label": "ライセンス所管チームコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "G",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "ライセンス所管チームコード※",
    "tab_size": 192,
    "seq_id": 8
  }, {
    "id": "ci_license_jurisdiction_team",
    "label": "ライセンス所管チーム名",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "H",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス所管チーム名",
    "tab_size": 153,
    "seq_id": 9
  }, {
    "id": "ci_jurisdiction_classification",
    "label": "所管区分※\r\n(プルダウンより選択)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "I",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "所管区分※\r\n(プルダウンより選択)",
    "tab_size": 244,
    "seq_id": 10
  }, {
    "id": "ci_ms_system_code",
    "label": "ライセンス所管システムコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "J",
      "debug": "2",
      "table": "master_system"
    },
    "tab_label": "ライセンス所管システムコード※",
    "tab_size": 205,
    "seq_id": 11
  }, {
    "id": "ci_license_jurisdiction_system",
    "label": "ライセンス所管システム名",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "K",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス所管システム名",
    "tab_size": 166,
    "seq_id": 12
  }, {
    "id": "ci_equipment_in_charge_system",
    "label": "所管システム/用途",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "L",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "所管システム/用途",
    "tab_size": 127,
    "seq_id": 13
  }, {
    "id": "ci_license_certificate_type",
    "label": "ライセンス証書種類※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "M",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "ライセンス証書種類※",
    "tab_size": 140,
    "seq_id": 14
  }, {
    "id": "ci_certificate_individual_number",
    "label": "証書個別番号\r\n",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "N",
      "partial_required": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "証書個別番号\r\n",
    "tab_size": 114,
    "seq_id": 15
  }, {
    "id": "ci_mm_seq_id",
    "label": "メーカコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "O",
      "debug": "2",
      "table": "master_maker"
    },
    "tab_label": "メーカコード※",
    "tab_size": 101,
    "seq_id": 16
  }, {
    "id": "ci_maker",
    "label": "メーカー名\r\n(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "P",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "メーカー名\r\n(システム登録情報)",
    "tab_size": 231,
    "seq_id": 17
  }, {
    "id": "ci_applicant_name",
    "label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "Q",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 192,
    "seq_id": 18
  }, {
    "id": "ci_management_person_name",
    "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "R",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 218,
    "seq_id": 19
  }, {
    "id": "ci_comprehensive_contract",
    "label": "包括契約※\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "S",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "包括契約※\r\n(有/無)",
    "tab_size": 166,
    "seq_id": 20
  }, {
    "id": "ci_sales_company",
    "label": "販売会社",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "T",
      "partial_required": true,
      "debug": "2",
      "table": "certificate"
    },
    "tab_label": "販売会社",
    "tab_size": 62,
    "seq_id": 21
  }, {
    "id": "ci_deadline_alert",
    "label": "期限アラート※\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "U",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "期限アラート※\r\n(有/無)",
    "tab_size": 192,
    "seq_id": 22
  }, {
    "id": "ci_expiration_date",
    "label": "有効期限\r\n(YYYY/MM/DD)",
    "type": "date_picker",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "V",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "有効期限\r\n(YYYY/MM/DD)",
    "tab_size": 244,
    "seq_id": 23
  }, {
    "id": "ci_maintenance_deadline",
    "label": "保守期限\r\n(YYYY/MM/DD)",
    "type": "date_picker",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "W",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "保守期限\r\n(YYYY/MM/DD)",
    "tab_size": 244,
    "seq_id": 24
  }, {
    "id": "ad_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 25
  }, {
    "id": "ad_certificate_software_number",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 26
  }, {
    "id": "ad_license_name",
    "label": "ライセンス名※\r\n証書記載の通り",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "X",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス名※\r\n証書記載の通り",
    "tab_size": 218,
    "seq_id": 27
  }, {
    "id": "ad_ms_software_code",
    "label": "ソフトウェアコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "Y",
      "debug": "2",
      "table": "master_software"
    },
    "tab_label": "ソフトウェアコード※",
    "tab_size": 140,
    "seq_id": 28
  }, {
    "id": "ad_software_name",
    "label": "ソフトウェア名\r\n(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "Z",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ソフトウェア名\r\n(システム登録情報)",
    "tab_size": 257,
    "seq_id": 29
  }, {
    "id": "ad_product_key",
    "label": "プロダクトキー",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AA",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "プロダクトキー",
    "tab_size": 101,
    "seq_id": 30
  }, {
    "id": "ad_unlimited",
    "label": "無制限\r\n(無制限/-)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AB",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "無制限\r\n(無制限/-)",
    "tab_size": 166,
    "seq_id": 31
  }, {
    "id": "ad_second",
    "label": "セカンド",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AC",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "セカンド",
    "tab_size": 62,
    "seq_id": 32
  }, {
    "id": "ad_second_number",
    "label": "セカンド数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AD",
      "partial_required": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "セカンド数",
    "tab_size": 75,
    "seq_id": 33
  }, {
    "id": "ad_license",
    "label": "ライセンス数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AE",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "certificate_software"
    },
    "tab_label": "ライセンス数",
    "tab_size": 88,
    "seq_id": 34
  }, {
    "id": "di_row_seq_label",
    "label": "項番_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "AF",
      "debug": "1"
    },
    "tab_label": "項番",
    "tab_size": 36,
    "seq_id": 35
  }, {
    "id": "di_device_control_number",
    "label": "機器管理番号\r\n(自動採番)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AG",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器管理番号\r\n(自動採番)",
    "tab_size": 192,
    "seq_id": 36
  }, {
    "id": "di_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 37
  }, {
    "id": "di_seq_ref",
    "label": "機器G",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "AH",
      "debug": "1"
    },
    "tab_label": "機器G",
    "tab_size": 49,
    "seq_id": 38
  }, {
    "id": "di_computer_name",
    "label": "コンピュータ名※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AI",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "コンピュータ名※",
    "tab_size": 114,
    "seq_id": 39
  }, {
    "id": "di_virtual_environment",
    "label": "仮想環境\r\n(有/無)※",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AJ",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "仮想環境\r\n(有/無)※",
    "tab_size": 166,
    "seq_id": 40
  }, {
    "id": "di_virtual_base_unit",
    "label": "仮想環境の親機",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AK",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "仮想環境の親機",
    "tab_size": 101,
    "seq_id": 41
  }, {
    "id": "di_mb_department_code",
    "label": "機器所管部署コード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AL",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "機器所管部署コード※",
    "tab_size": 140,
    "seq_id": 42
  }, {
    "id": "di_equipment_in_charge_department",
    "label": "機器所管部署名(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AM",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管部署名(システム登録情報)",
    "tab_size": 231,
    "seq_id": 43
  }, {
    "id": "di_mb_team_code",
    "label": "機器所管チームコード※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AN",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "機器所管チームコード※",
    "tab_size": 153,
    "seq_id": 44
  }, {
    "id": "di_equipment_in_charge_team",
    "label": "機器所管チーム名\r\n(システム登録情報)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AO",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管チーム名\r\n(システム登録情報)",
    "tab_size": 270,
    "seq_id": 45
  }, {
    "id": "di_equipment_in_charge_classification",
    "label": "機器所管区分※\r\n(プルダウンより選択)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AP",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管区分※\r\n(プルダウンより選択)",
    "tab_size": 270,
    "seq_id": 46
  }, {
    "id": "di_ms_system_code",
    "label": "機器所管システムコード\r\n(システム名)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AQ",
      "debug": "2",
      "table": "master_system"
    },
    "tab_label": "機器所管システムコード\r\n(システム名)",
    "tab_size": 270,
    "seq_id": 47
  }, {
    "id": "di_equipment_in_charge_system_it",
    "label": "機器所管システム\r\n(システム名)",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AR",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器所管システム\r\n(システム名)",
    "tab_size": 231,
    "seq_id": 48
  }, {
    "id": "di_equipment_in_charge_system",
    "label": "所管システム/用途\r\n(システム名)",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AS",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "所管システム/用途\r\n(システム名)",
    "tab_size": 244,
    "seq_id": 49
  }, {
    "id": "di_leasing_or_rental",
    "label": "リース・レンタル※\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AT",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "リース・レンタル※\r\n(有/無)",
    "tab_size": 218,
    "seq_id": 50
  }, {
    "id": "di_manufacture_name",
    "label": "メーカー名",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AU",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "メーカー名",
    "tab_size": 75,
    "seq_id": 51
  }, {
    "id": "di_model_name",
    "label": "機種名",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AV",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機種名",
    "tab_size": 49,
    "seq_id": 52
  }, {
    "id": "di_equipment_classification",
    "label": "機器区分※\r\n(プルダウンより選択)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AW",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "機器区分※\r\n(プルダウンより選択)",
    "tab_size": 244,
    "seq_id": 53
  }, {
    "id": "di_cpu_count",
    "label": "CPU数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AX",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "CPU数",
    "tab_size": 62,
    "seq_id": 54
  }, {
    "id": "di_mb2_department_code",
    "label": "設置部署コード",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AY",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "設置部署コード",
    "tab_size": 101,
    "seq_id": 55
  }, {
    "id": "di_installation_department",
    "label": "設置部署名※",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "AZ",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "設置部署名※",
    "tab_size": 88,
    "seq_id": 56
  }, {
    "id": "di_mb2_team_code",
    "label": "設置チームコード",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BA",
      "debug": "2",
      "table": "master_belongs"
    },
    "tab_label": "設置チームコード",
    "tab_size": 114,
    "seq_id": 57
  }, {
    "id": "di_installation_team",
    "label": "設置チーム※",
    "type": "select4",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BB",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "設置チーム※",
    "tab_size": 88,
    "seq_id": 58
  }, {
    "id": "di_installation_base",
    "label": "設置拠点",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BC",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "設置拠点",
    "tab_size": 62,
    "seq_id": 59
  }, {
    "id": "di_floor",
    "label": "フロア",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BD",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "フロア",
    "tab_size": 49,
    "seq_id": 60
  }, {
    "id": "di_user_name",
    "label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BE",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 192,
    "seq_id": 61
  }, {
    "id": "di_management_person_name",
    "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BF",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
    "tab_size": 218,
    "seq_id": 62
  }, {
    "id": "di_remarks",
    "label": "備考欄",
    "type": "text_area",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BG",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_information"
    },
    "tab_label": "備考欄",
    "tab_size": 49,
    "seq_id": 63
  }, {
    "id": "ci_seq_ref_link",
    "label": "証書G_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "BH",
      "debug": "1"
    },
    "tab_label": "証書G",
    "tab_size": 49,
    "seq_id": 64
  }, {
    "id": "ad_seq_ref_link",
    "label": "SW枝番_1",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "link",
      "p": "BI",
      "debug": "1"
    },
    "tab_label": "SW枝番",
    "tab_size": 62,
    "seq_id": 65
  }, {
    "id": "dd_item_number",
    "label": "紐付け本数",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BJ",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "紐付け本数",
    "tab_size": 75,
    "seq_id": 66
  }, {
    "id": "dd_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 67
  }, {
    "id": "dd_associated_device_seq_id",
    "type": "input",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": null,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "",
    "tab_size": 10,
    "seq_id": 68
  }, {
    "id": "dd_virtual_id",
    "label": "仮想\r\n(有/無)",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BK",
      "partial_required": true,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "仮想\r\n(有/無)",
    "tab_size": 127,
    "seq_id": 69
  }, {
    "id": "dd_software_jurisdiction",
    "label": "ソフトウェア所管※",
    "type": "select",
    "import": {
      "enabled": true
    },
    "import_details": {
      "type": "field",
      "p": "BL",
      "partial_required": true,
      "error_if_blank": true,
      "debug": "2",
      "table": "device_embedded_detail"
    },
    "tab_label": "ソフトウェア所管※",
    "tab_size": 127,
    "seq_id": 70
  }, {
    "id": "more_details",
    "label": "詳細",
    "type": "input",
    "import_details": {
      "p": ""
    },
    "tab_label": "詳細",
    "tab_size": 36,
    "seq_id": 71
  }, {
    "id": "button_options",
    "history_label_name": "hide",
    "label": "要修正",
    "tab_label": "要修正",
    "type": "input",
    "import_details": {
      "p": ""
    },
    "tab_size": 70,
    "seq_id": 72
  }]
};

var filed_types = {
  "SELECT_BOX": "select",
  "SELECT_BOX2": "select2",
  "SELECT_BOX3": "select3",
  "SELECT_BOX4": "select4",
  "RADIO_BUTTON": "radio_button",
  "INPUT": "input",
  "DATE_PICKER": "date_picker",
  "CURRENT_TIME": "current_time",
  "PASSWORD": "password",
  "TEXT_AREA": "text_area",
  "CHECKBOX": "checkbox",
  "SPACE": "space",
  "BUTTON": "button"
};

/***/ }),
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */
/***/ (function(module, exports) {

module.exports = {"O_RDONLY":0,"O_WRONLY":1,"O_RDWR":2,"S_IFMT":61440,"S_IFREG":32768,"S_IFDIR":16384,"S_IFCHR":8192,"S_IFBLK":24576,"S_IFIFO":4096,"S_IFLNK":40960,"S_IFSOCK":49152,"O_CREAT":512,"O_EXCL":2048,"O_NOCTTY":131072,"O_TRUNC":1024,"O_APPEND":8,"O_DIRECTORY":1048576,"O_NOFOLLOW":256,"O_SYNC":128,"O_SYMLINK":2097152,"O_NONBLOCK":4,"S_IRWXU":448,"S_IRUSR":256,"S_IWUSR":128,"S_IXUSR":64,"S_IRWXG":56,"S_IRGRP":32,"S_IWGRP":16,"S_IXGRP":8,"S_IRWXO":7,"S_IROTH":4,"S_IWOTH":2,"S_IXOTH":1,"E2BIG":7,"EACCES":13,"EADDRINUSE":48,"EADDRNOTAVAIL":49,"EAFNOSUPPORT":47,"EAGAIN":35,"EALREADY":37,"EBADF":9,"EBADMSG":94,"EBUSY":16,"ECANCELED":89,"ECHILD":10,"ECONNABORTED":53,"ECONNREFUSED":61,"ECONNRESET":54,"EDEADLK":11,"EDESTADDRREQ":39,"EDOM":33,"EDQUOT":69,"EEXIST":17,"EFAULT":14,"EFBIG":27,"EHOSTUNREACH":65,"EIDRM":90,"EILSEQ":92,"EINPROGRESS":36,"EINTR":4,"EINVAL":22,"EIO":5,"EISCONN":56,"EISDIR":21,"ELOOP":62,"EMFILE":24,"EMLINK":31,"EMSGSIZE":40,"EMULTIHOP":95,"ENAMETOOLONG":63,"ENETDOWN":50,"ENETRESET":52,"ENETUNREACH":51,"ENFILE":23,"ENOBUFS":55,"ENODATA":96,"ENODEV":19,"ENOENT":2,"ENOEXEC":8,"ENOLCK":77,"ENOLINK":97,"ENOMEM":12,"ENOMSG":91,"ENOPROTOOPT":42,"ENOSPC":28,"ENOSR":98,"ENOSTR":99,"ENOSYS":78,"ENOTCONN":57,"ENOTDIR":20,"ENOTEMPTY":66,"ENOTSOCK":38,"ENOTSUP":45,"ENOTTY":25,"ENXIO":6,"EOPNOTSUPP":102,"EOVERFLOW":84,"EPERM":1,"EPIPE":32,"EPROTO":100,"EPROTONOSUPPORT":43,"EPROTOTYPE":41,"ERANGE":34,"EROFS":30,"ESPIPE":29,"ESRCH":3,"ESTALE":70,"ETIME":101,"ETIMEDOUT":60,"ETXTBSY":26,"EWOULDBLOCK":35,"EXDEV":18,"SIGHUP":1,"SIGINT":2,"SIGQUIT":3,"SIGILL":4,"SIGTRAP":5,"SIGABRT":6,"SIGIOT":6,"SIGBUS":10,"SIGFPE":8,"SIGKILL":9,"SIGUSR1":30,"SIGSEGV":11,"SIGUSR2":31,"SIGPIPE":13,"SIGALRM":14,"SIGTERM":15,"SIGCHLD":20,"SIGCONT":19,"SIGSTOP":17,"SIGTSTP":18,"SIGTTIN":21,"SIGTTOU":22,"SIGURG":16,"SIGXCPU":24,"SIGXFSZ":25,"SIGVTALRM":26,"SIGPROF":27,"SIGWINCH":28,"SIGIO":23,"SIGSYS":12,"SSL_OP_ALL":2147486719,"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION":262144,"SSL_OP_CIPHER_SERVER_PREFERENCE":4194304,"SSL_OP_CISCO_ANYCONNECT":32768,"SSL_OP_COOKIE_EXCHANGE":8192,"SSL_OP_CRYPTOPRO_TLSEXT_BUG":2147483648,"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS":2048,"SSL_OP_EPHEMERAL_RSA":0,"SSL_OP_LEGACY_SERVER_CONNECT":4,"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER":32,"SSL_OP_MICROSOFT_SESS_ID_BUG":1,"SSL_OP_MSIE_SSLV2_RSA_PADDING":0,"SSL_OP_NETSCAPE_CA_DN_BUG":536870912,"SSL_OP_NETSCAPE_CHALLENGE_BUG":2,"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG":1073741824,"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG":8,"SSL_OP_NO_COMPRESSION":131072,"SSL_OP_NO_QUERY_MTU":4096,"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION":65536,"SSL_OP_NO_SSLv2":16777216,"SSL_OP_NO_SSLv3":33554432,"SSL_OP_NO_TICKET":16384,"SSL_OP_NO_TLSv1":67108864,"SSL_OP_NO_TLSv1_1":268435456,"SSL_OP_NO_TLSv1_2":134217728,"SSL_OP_PKCS1_CHECK_1":0,"SSL_OP_PKCS1_CHECK_2":0,"SSL_OP_SINGLE_DH_USE":1048576,"SSL_OP_SINGLE_ECDH_USE":524288,"SSL_OP_SSLEAY_080_CLIENT_DH_BUG":128,"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG":0,"SSL_OP_TLS_BLOCK_PADDING_BUG":512,"SSL_OP_TLS_D5_BUG":256,"SSL_OP_TLS_ROLLBACK_BUG":8388608,"ENGINE_METHOD_DSA":2,"ENGINE_METHOD_DH":4,"ENGINE_METHOD_RAND":8,"ENGINE_METHOD_ECDH":16,"ENGINE_METHOD_ECDSA":32,"ENGINE_METHOD_CIPHERS":64,"ENGINE_METHOD_DIGESTS":128,"ENGINE_METHOD_STORE":256,"ENGINE_METHOD_PKEY_METHS":512,"ENGINE_METHOD_PKEY_ASN1_METHS":1024,"ENGINE_METHOD_ALL":65535,"ENGINE_METHOD_NONE":0,"DH_CHECK_P_NOT_SAFE_PRIME":2,"DH_CHECK_P_NOT_PRIME":1,"DH_UNABLE_TO_CHECK_GENERATOR":4,"DH_NOT_SUITABLE_GENERATOR":8,"NPN_ENABLED":1,"RSA_PKCS1_PADDING":1,"RSA_SSLV23_PADDING":2,"RSA_NO_PADDING":3,"RSA_PKCS1_OAEP_PADDING":4,"RSA_X931_PADDING":5,"RSA_PKCS1_PSS_PADDING":6,"POINT_CONVERSION_COMPRESSED":2,"POINT_CONVERSION_UNCOMPRESSED":4,"POINT_CONVERSION_HYBRID":6,"F_OK":0,"R_OK":4,"W_OK":2,"X_OK":1,"UV_UDP_REUSEADDR":4}

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 231,
	"./af.js": 231,
	"./ar": 238,
	"./ar-dz": 232,
	"./ar-dz.js": 232,
	"./ar-kw": 233,
	"./ar-kw.js": 233,
	"./ar-ly": 234,
	"./ar-ly.js": 234,
	"./ar-ma": 235,
	"./ar-ma.js": 235,
	"./ar-sa": 236,
	"./ar-sa.js": 236,
	"./ar-tn": 237,
	"./ar-tn.js": 237,
	"./ar.js": 238,
	"./az": 239,
	"./az.js": 239,
	"./be": 240,
	"./be.js": 240,
	"./bg": 241,
	"./bg.js": 241,
	"./bm": 242,
	"./bm.js": 242,
	"./bn": 243,
	"./bn.js": 243,
	"./bo": 244,
	"./bo.js": 244,
	"./br": 245,
	"./br.js": 245,
	"./bs": 246,
	"./bs.js": 246,
	"./ca": 247,
	"./ca.js": 247,
	"./cs": 248,
	"./cs.js": 248,
	"./cv": 249,
	"./cv.js": 249,
	"./cy": 250,
	"./cy.js": 250,
	"./da": 251,
	"./da.js": 251,
	"./de": 254,
	"./de-at": 252,
	"./de-at.js": 252,
	"./de-ch": 253,
	"./de-ch.js": 253,
	"./de.js": 254,
	"./dv": 255,
	"./dv.js": 255,
	"./el": 256,
	"./el.js": 256,
	"./en-au": 257,
	"./en-au.js": 257,
	"./en-ca": 258,
	"./en-ca.js": 258,
	"./en-gb": 259,
	"./en-gb.js": 259,
	"./en-ie": 260,
	"./en-ie.js": 260,
	"./en-nz": 261,
	"./en-nz.js": 261,
	"./eo": 262,
	"./eo.js": 262,
	"./es": 265,
	"./es-do": 263,
	"./es-do.js": 263,
	"./es-us": 264,
	"./es-us.js": 264,
	"./es.js": 265,
	"./et": 266,
	"./et.js": 266,
	"./eu": 267,
	"./eu.js": 267,
	"./fa": 268,
	"./fa.js": 268,
	"./fi": 269,
	"./fi.js": 269,
	"./fo": 270,
	"./fo.js": 270,
	"./fr": 273,
	"./fr-ca": 271,
	"./fr-ca.js": 271,
	"./fr-ch": 272,
	"./fr-ch.js": 272,
	"./fr.js": 273,
	"./fy": 274,
	"./fy.js": 274,
	"./gd": 275,
	"./gd.js": 275,
	"./gl": 276,
	"./gl.js": 276,
	"./gom-latn": 277,
	"./gom-latn.js": 277,
	"./gu": 278,
	"./gu.js": 278,
	"./he": 279,
	"./he.js": 279,
	"./hi": 280,
	"./hi.js": 280,
	"./hr": 281,
	"./hr.js": 281,
	"./hu": 282,
	"./hu.js": 282,
	"./hy-am": 283,
	"./hy-am.js": 283,
	"./id": 284,
	"./id.js": 284,
	"./is": 285,
	"./is.js": 285,
	"./it": 286,
	"./it.js": 286,
	"./ja": 287,
	"./ja.js": 287,
	"./jv": 288,
	"./jv.js": 288,
	"./ka": 289,
	"./ka.js": 289,
	"./kk": 290,
	"./kk.js": 290,
	"./km": 291,
	"./km.js": 291,
	"./kn": 292,
	"./kn.js": 292,
	"./ko": 293,
	"./ko.js": 293,
	"./ky": 294,
	"./ky.js": 294,
	"./lb": 295,
	"./lb.js": 295,
	"./lo": 296,
	"./lo.js": 296,
	"./lt": 297,
	"./lt.js": 297,
	"./lv": 298,
	"./lv.js": 298,
	"./me": 299,
	"./me.js": 299,
	"./mi": 300,
	"./mi.js": 300,
	"./mk": 301,
	"./mk.js": 301,
	"./ml": 302,
	"./ml.js": 302,
	"./mr": 303,
	"./mr.js": 303,
	"./ms": 305,
	"./ms-my": 304,
	"./ms-my.js": 304,
	"./ms.js": 305,
	"./my": 306,
	"./my.js": 306,
	"./nb": 307,
	"./nb.js": 307,
	"./ne": 308,
	"./ne.js": 308,
	"./nl": 310,
	"./nl-be": 309,
	"./nl-be.js": 309,
	"./nl.js": 310,
	"./nn": 311,
	"./nn.js": 311,
	"./pa-in": 312,
	"./pa-in.js": 312,
	"./pl": 313,
	"./pl.js": 313,
	"./pt": 315,
	"./pt-br": 314,
	"./pt-br.js": 314,
	"./pt.js": 315,
	"./ro": 316,
	"./ro.js": 316,
	"./ru": 317,
	"./ru.js": 317,
	"./sd": 318,
	"./sd.js": 318,
	"./se": 319,
	"./se.js": 319,
	"./si": 320,
	"./si.js": 320,
	"./sk": 321,
	"./sk.js": 321,
	"./sl": 322,
	"./sl.js": 322,
	"./sq": 323,
	"./sq.js": 323,
	"./sr": 325,
	"./sr-cyrl": 324,
	"./sr-cyrl.js": 324,
	"./sr.js": 325,
	"./ss": 326,
	"./ss.js": 326,
	"./sv": 327,
	"./sv.js": 327,
	"./sw": 328,
	"./sw.js": 328,
	"./ta": 329,
	"./ta.js": 329,
	"./te": 330,
	"./te.js": 330,
	"./tet": 331,
	"./tet.js": 331,
	"./th": 332,
	"./th.js": 332,
	"./tl-ph": 333,
	"./tl-ph.js": 333,
	"./tlh": 334,
	"./tlh.js": 334,
	"./tr": 335,
	"./tr.js": 335,
	"./tzl": 336,
	"./tzl.js": 336,
	"./tzm": 338,
	"./tzm-latn": 337,
	"./tzm-latn.js": 337,
	"./tzm.js": 338,
	"./uk": 339,
	"./uk.js": 339,
	"./ur": 340,
	"./ur.js": 340,
	"./uz": 342,
	"./uz-latn": 341,
	"./uz-latn.js": 341,
	"./uz.js": 342,
	"./vi": 343,
	"./vi.js": 343,
	"./x-pseudo": 344,
	"./x-pseudo.js": 344,
	"./yo": 345,
	"./yo.js": 345,
	"./zh-cn": 346,
	"./zh-cn.js": 346,
	"./zh-hk": 347,
	"./zh-hk.js": 347,
	"./zh-tw": 348,
	"./zh-tw.js": 348
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;

/***/ }),
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(772)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1052),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(933),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(1011),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64000659",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(1051),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ac832d7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(942),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dea290f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
  __webpack_require__(687)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-459ef818",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42b5dd50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1026),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6de98222",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(1058),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c0adefa2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(984),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5037705a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(929),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08b5cde0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(751)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1033),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7915b252",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(752)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1034),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7923c9d3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(697)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51f99387",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1060),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7439048",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(715)
  __webpack_require__(716)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1000),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5abdafec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-364f4ea1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(974),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-443ac906",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(939),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b6368bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(701)
  __webpack_require__(702)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(989),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55a88844",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-472b8f68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(970),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-428d53e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1027),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7056e163",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(932),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a787a91",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(713)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(998),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5990abcc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(995),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-589fe5d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(764)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1045),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8cfaa09c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1022),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a64dc56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(723)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1006),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-606e00e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1067),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dd459c80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(774)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1054),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b4da7ab4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1038),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cadbb14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1030),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-731234bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(930),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a263112",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1048),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-92106818",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(988),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54215f8d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(734)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1016),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66ccfa43",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47f00d80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c59f92a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1049),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-961e81ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(742)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1024),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ca5f0f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(743)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1025),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6de8969d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(762)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1043),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-82d29a6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(990),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55f31b6b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1018),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67df0cb5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1063),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf6ffa7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(704)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(991),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-571a0e1b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1062),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8c4620c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(761)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1042),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-80f03340",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(980),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4986bcd2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(784)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1064),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d26d29e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(662)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(954),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2bd2a786",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(726)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1009),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61934364",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(777)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1057),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bf6b7ac8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1061),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c79098f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(975),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4548c7c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(785)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1065),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da5cd0e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1010),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62438e5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(956),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e90b4e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-482526d9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1041),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7dde6737",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(705)
  __webpack_require__(706)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(992),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5762f00c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(934),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-122992bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(962),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38f5a77a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(747)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1029),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72d4721b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(941),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c59c7a9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1005),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f18a502",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1031),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76125fab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b66b4e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(964),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c475266",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(946),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22e92c7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(756)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1037),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b4a4cdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1066),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db1cbe40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1008),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-618b4feb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1055),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b6fed44c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(967),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e391a26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(973),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4427b613",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27ea33ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(712)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(997),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5961a3d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1053),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b37545ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1021),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69defd58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(935),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1967f5cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(940),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c5826a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-346d9774",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(759)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1040),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7dcec05d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1072),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f4412aba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-259a159e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a4ace2f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(737)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1019),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-683ce6de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1047),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-90724b7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(944),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21db4de6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(936),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-198b40fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b733542",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2704cbc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(731)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1014),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-658d8a36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(755)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1036),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(968),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-402fb5d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2efec2e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(666)
  __webpack_require__(667)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f0aab75",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(931),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a31d34a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(938),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b046a70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1001),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b8d4b58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d4e0813",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(928),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-059b271c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(779)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1059),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c6a56db6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1023),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c1d268e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(972),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-441ecc1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e8f5ec7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(987),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-538cd482",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(966),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d628374",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(994),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57d84c34",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1074),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fd9fa228",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(770)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1050),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ab102b72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(758)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1039),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d192579",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1020),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68993933",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(765)
  __webpack_require__(766)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1046),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8fa6959e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "800px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("お知らせ")])]), _vm._v(" "), _c('center', [(_vm.loginExpireDays < 31) ? _c('table', {
    staticStyle: {
      "width": "90%",
      "max-width": "400px",
      "text-align": "center",
      "background": "white",
      "font-weight": "bold",
      "border": "#404040 1px solid"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#b4d5f1"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("パスワード通知")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "12px",
      "padding": "4px",
      "border": "#404040 1px solid",
      "text-align": "left"
    }
  }, [_vm._v(" パスワード有効期限まで残り")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "12px",
      "padding": "4px",
      "border": "#404040 1px solid",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.loginExpireDays) + "日")])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-body notice-modal-body",
    staticStyle: {
      "height": "280px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('div', _vm._l((_vm.listOfNotices), function(n) {
    return _c('div', {
      key: n.seq_id
    }, [(_vm.processImportance(n.importance).length > 0) ? _c('div', [_c('span', {
      staticClass: "message_label"
    }, [_vm._v("重要度: ")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.processImportance(n.importance))
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "message_label"
    }, [_vm._v("送信者: ")]), _vm._v("\n            " + _vm._s(n.from_user_shimei || n.from_user) + "\n            "), _c('span', {
      staticClass: "message_label"
    }, [_vm._v("宛先: ")]), _vm._v(_vm._s(_vm.processnToUserShimei(n)) + "\n          ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "message_label"
    }, [_vm._v("登録日: ")]), _vm._v(" " + _vm._s(n.create_date) + "\n          ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px"
      },
      domProps: {
        "innerHTML": _vm._s(n.message)
      }
    }), _vm._v(" "), _c('hr')])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("\n        完了\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0080_system_setting\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "ブラウザ設定"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-25px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" ＜　戻る ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px",
      "background": "#92d050",
      "border-color": "#92d050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("\n          登録\n        ")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("\n          編集\n        ")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#a6a6a6",
      "border-color": "#a6a6a6"
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("\n          キャンセル\n        ")]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: _vm.labelClass,
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('select', {
    staticClass: "form-control select-box",
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0050_approval_history")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n            件数\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050",
      "margin-right": "12px"
    },
    attrs: {
      "disabled": _vm.disablePageApprove || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkApprovalStage1
    }
  }, [_vm._v("承認")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.disablePageApprove || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkApprovalStage4
    }
  }, [_vm._v("申請クリア")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")])]), _vm._v(" "), (_vm.filteringRrejectMode == false) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "12px"
    },
    attrs: {
      "disabled": _vm.disablePageApprove || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkRejectStage1
    }
  }, [_vm._v("一括差戻")]) : _vm._e(), _vm._v(" "), (_vm.filteringRrejectMode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.rejectedBulkEditDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkEdit
    }
  }, [_vm._v(_vm._s(_vm.bulkEditText))]) : _vm._e()], 1), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbededInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage2ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage3
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "bulkApprovalStage4ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkClearApprovalStage4Confirmation
    }
  }), _vm._v(" "), _c('bulk-reject-modal', {
    attrs: {
      "tag": "bulkRejectModal"
    },
    on: {
      "closed": _vm.bulkRejectStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage2RejectConfirmatioModal"
    },
    on: {
      "done": _vm.bulkRejctStage3
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "棚卸業務"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfloat"
  }, [_c('div', {
    staticClass: "form1 col-xs-6",
    staticStyle: {
      "max-width": "650"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("会社")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['company'],
      "readonly": _vm.selectreadonly['company']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('company')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'company',
          value: $event.target.value
        })
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.companylist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("部署")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['department'],
      "readonly": _vm.selectreadonly['department']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('department')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'department',
          value: $event.target.value
        })
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.departmentlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("チーム")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['team'],
      "readonly": _vm.selectreadonly['team']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('team')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'team',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.teamlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("所管区分")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['jurisdiction_classification'],
      "readonly": _vm.selectreadonly['jurisdiction_classification']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('jurisdiction_classification')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'jurisdiction_classification',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.classificationlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("システム")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['system'],
      "readonly": _vm.selectreadonly['system']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('system')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'system',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.systemlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "70px",
      "height": "32px",
      "font-size": "15px",
      "float": "right",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.searchclear
    }
  }, [_vm._v("クリア")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-top": "40px",
      "width": "40%"
    }
  }, [_c('inventory-summary-box', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "t1": _vm.counterT1,
      "t2": _vm.counterT2,
      "t3": _vm.counterT3,
      "t4": _vm.counterT4,
      "b1": _vm.counterB1,
      "b2": _vm.counterB2,
      "b3": _vm.counterB3,
      "b4": _vm.counterB4,
      "u4": _vm.counterU4
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "証書一覧"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "機器・ソフトウェア紐付け明細"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [(_vm.selectedTab == 0) ? _c('div', [_c('inventory-certificate-list', {
    ref: "inventorycertificatelistsubpage",
    attrs: {
      "searchData": _vm.inventory_sub_search
    }
  })], 1) : (_vm.selectedTab == 1) ? _c('div', {
    staticStyle: {
      "top": "-30p"
    }
  }, [_c('inventory-pending-items', {
    ref: "inventorypendingitemssubpage",
    attrs: {
      "searchData": _vm.inventory_sub_search
    }
  })], 1) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventorySave"
    },
    on: {
      "done": _vm.onInventorySaveCondirmed
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventoryExport"
    },
    on: {
      "done": _vm.onInventoryExportCondirmed
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runInventoryExportDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "output_options-modal",
    attrs: {
      "width": "460px",
      "height": "130px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body output_options-modal-body",
    staticStyle: {
      "height": "50px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "keyup": function($event) {
        _vm.keyUp($event.target.id, $event.target.value, $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("完了")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VueCtkDateTimePicker', {
    staticClass: " input-group force-white",
    attrs: {
      "disabled": _vm.isDisabled,
      "input-size": "sm",
      "format": "YYYY/MM/DD HH:mm",
      "output-format": "YYYY/MM/DD HH:mm",
      "formatted": "YYYY/MM/DD HH:mm",
      "color": "#3b89cb",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "label": null,
      "no-label": true,
      "inline": false,
      "locale": "ja-jp",
      "button-now-translation": "今",
      "no-value-to-custom-elem": true
    },
    model: {
      value: (_vm.localModel),
      callback: function($$v) {
        _vm.localModel = $$v
      },
      expression: "localModel"
    }
  }, [_c('span', {
    staticClass: "calendar-test input-group-addon btn",
    style: (_vm.inputStyle + 'padding: 0px 8px !important'),
    attrs: {
      "disabled": _vm.isDisabled
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localModel),
      expression: "localModel"
    }],
    staticClass: "form-control form-control",
    style: (_vm.inputStyle + 'height: 25px !important; marging: 2px; border-radius: 0px'),
    attrs: {
      "disabled": _vm.isDisabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.localModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localModel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "calendar-test input-group-addon btn",
    style: (_vm.inputStyle + 'padding: 0px 8px !important'),
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.clearCalendar
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove"
  })])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "証書情報 (old)"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.formBatchEditDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bachEdit
    }
  }, [_vm._v(_vm._s(_vm.batchEditText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('information-icon-modal', {
    attrs: {
      "tag": "showInformationIconModalCertificateInformation"
    }
  }), _vm._v(" "), _c('device-embedded-information-bach-edit-modal', {
    attrs: {
      "tag": "showDeviceEmbeddedInformationBachEditModal"
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_comprehensive_contract_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "包括契約"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterComprehensiveContractModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "システム（詳細）"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "2px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "2px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterSystemModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_software_category")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "ソフトウェアカテゴリ"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n         件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.selected_row == -1
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("抹消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "棚卸(棚卸報告)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          更新日時：" + _vm._s(_vm.update_Date) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n\n          報告日：" + _vm._s(_vm.create_Date) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n      状態：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "60px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.status_value
    }
  }), _vm._v("\n      提出:\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "60px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "readonly": true
    },
    domProps: {
      "value": _vm.new_or_resubmit_value
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n      報告者:\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "200px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "0px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "readonly": true
    },
    domProps: {
      "value": _vm.created_by_value
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("棚卸報告年度区分")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['reporting_period'],
      "readonly": _vm.selectreadonly['reporting_period']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('reporting_period')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'reporting_period',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.reportingPeriodList), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("会社")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['company'],
      "readonly": _vm.selectreadonly['company']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('company')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'company',
          value: $event.target.value
        })
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.companylist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("部署")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['department'],
      "readonly": _vm.selectreadonly['department']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('department')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'department',
          value: $event.target.value
        })
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.departmentlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("チーム")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['team'] || _vm.teammode == false,
      "readonly": _vm.selectreadonly['team']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('team')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'team',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.teamlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("所管区分")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['jurisdiction_classification'],
      "readonly": _vm.selectreadonly['jurisdiction_classification']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('jurisdiction_classification')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'jurisdiction_classification',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.classificationlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("システム")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['system'],
      "readonly": _vm.selectreadonly['system']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('system')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'system',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.systemlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [(_vm.alretteamreport && _vm.alretoutside == false) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※チーム単位報告\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretdepartmentreport && _vm.alretoutside == false) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※棚卸は部署単位で報告願います。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretoutside) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※報告がロックされています\n            ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ViewMainInfomation == true),
      expression: "ViewMainInfomation == true"
    }]
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col0b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id] + '％'
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col0c), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ViewMainInfomation == true),
      expression: "ViewMainInfomation == true"
    }]
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.updatecertcheck
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1a), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || _vm.certeditable == false,
        "val": _vm.values[f.id]
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col1b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1c), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnlycol1c,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1d), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1e), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnlycol1e,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1f), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  })], 2), _vm._v(" "), (_vm.alretunusedlicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※未使用ライセンスが0でない場合、ライセンスの未使用理由の記載が必要です。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretexpiredlicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※期限切れライセンスが0でない場合、期限切れライセンス対応の入力が必要です。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretremarkexpiredlicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※証書一覧備考の入力が必要です。\n            ")])], 1) : _vm._e()])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.updatedevicecheck
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2a), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || _vm.dev_editable == false,
        "val": _vm.values[f.id]
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "74%",
      "margin-bottom": "5px"
    }
  }, [_vm._v("\n            ① + ② + ③ + ④ = " + _vm._s(_vm.totallicense) + "\n          ")]), _vm._v(" "), _vm._l((_vm.formFields.col2c1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['lack_of_license'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2c2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['lost_license_certificate'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2c3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['no_evidence_of_license_receipt'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2c4), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['other'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2d), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), (_vm.alrettotallicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※①～④の合計数が未紐付数と一致しません。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretother == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※④が0でない場合、[備考]欄での理由の記載が必要です。\n            ")])], 1) : _vm._e()], 2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), (_vm.adminview == true) ? _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col4), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 && _vm.readOnly3,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), (_vm.ViewEditbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.adminremarkeditbtn
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.ViewEadminremarkditSetbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.adminremarksetbtn
    }
  }, [_vm._v("入力完了")]) : _vm._e(), _vm._v(" "), (_vm.ViewEadminremarkditSetbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.adminremarkeditcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.ShowRejectBlock) ? _c('div', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.ShowRejectPerson) ? _c('div', _vm._l((_vm.formFields.col4a), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": true,
        "val": _vm.values[f.id]
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.ShowRejectReason) ? _c('div', _vm._l((_vm.formFields.col4b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly4,
        "val": _vm.values[f.id]
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.ViewRejectEditbtn) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "end",
      "margin-bottom": "10px"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n                ※差戻理由を入力し、入力完了をクリックしてください。(任意)\n                ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.processApprovalCancel
    }
  }, [_vm._v("入力完了")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.rejectcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "30px",
      "margin-right": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), (_vm.ViewEditbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.editbtn
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.ViewEditCancelbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.editcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditable == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e(), _vm._v(" "), (_vm.ViewApproval) ? _c('button', {
    staticClass: "btn btn-primary process_approval_approve_btn",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": function($event) {
        _vm.ApprovalStage1()
      }
    }
  }, [_vm._v("承認")]) : _vm._e(), _vm._v(" "), (_vm.ViewApprovalHistory) ? _c('button', {
    staticClass: "btn btn-primary process_approval_approve_btn",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": function($event) {
        _vm.onConfirmInfomation()
      }
    }
  }, [_vm._v("申請ルート")]) : _vm._e(), _vm._v(" "), (_vm.ViewRejectbtn) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    on: {
      "click": _vm.rejecteditbtn
    }
  }, [_vm._v(_vm._s(_vm.reject_label))]) : _vm._e(), _vm._v(" "), (_vm.ViewConfirmbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onConfirmExecuteProcessConfirmation
    }
  }, [_vm._v("申請")]) : _vm._e(), _vm._v(" "), (_vm.ViewSavebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.onLocalSaveInventory
    }
  }, [_vm._v(_vm._s(_vm.savewords))]) : _vm._e(), _vm._v(" "), (_vm.ViewModeChangebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "200px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    on: {
      "click": _vm.reportmodebtn
    }
  }, [_vm._v(_vm._s(_vm.reportmodewords))]) : _vm._e(), _vm._v(" "), (_vm.viewExportFilebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]) : _vm._e()])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventorySave"
    },
    on: {
      "done": _vm.onInventorySaveCondirmed
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventorySaveEnd"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventorySaveReject"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventoryExport"
    },
    on: {
      "done": _vm.onInventoryExportCondirmed
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteinventoryreportModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "reportmodeinventoryreportModal"
    },
    on: {
      "done": _vm.onConfirmReportModeChange
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "reportmodeinventoryreportModalReject"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "reportmodeinventoryreportEndModal"
    },
    on: {
      "done": _vm.onConfirmReportModeChangeEnd
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventoryonRejectEmbedded"
    },
    on: {
      "done": _vm.onReject
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventoryonRejectEmbeddednotification"
    },
    on: {
      "done": _vm.backToList
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1ConfirmatioInventory"
    },
    on: {
      "done": _vm.ApprovalStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "ConfirmatioInvventorybackToList"
    },
    on: {
      "done": _vm.backToList
    }
  }), _vm._v(" "), _c('application-confirmation-modal-inventory', {
    attrs: {
      "tag": "inventoryApplicationConfimationModal"
    },
    on: {
      "done": _vm.onCloseConfimation
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runInventoryExportreportDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "10px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("\n          ＊入力必須項目\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field col-xs-12"
  }, [_vm._v("\n            1.証書一覧\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　2．機器・ソフトウェア紐付明細\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　3．その他\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　4．管理者記載\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　差戻\n          ")])])])
}]}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "width": "502px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("管理番号'" + _vm._s(_vm.linkNumber) + "'を割り当てます。割り当てるライセンス数を入力してください。")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body confirmation-modal-body ",
    style: ('Width: 201px;padding: 5px 15px; ')
  }, [(_vm.maxQty) ? _c('span', {
    staticStyle: {
      "float": "right",
      "font-weight": "800"
    }
  }, [_vm._v("ライセンス残数: " + _vm._s(_vm.maxQty))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-weight": "800",
      "padding": "7px"
    }
  }, [_vm._v("本")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedValue),
      expression: "selectedValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px",
      "float": "right"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxQty
    },
    domProps: {
      "value": (_vm.selectedValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-weight": "800",
      "padding": "7px"
    }
  }, [_vm._v("割り当てるライセンス数：")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※割り当てるライセンス数はライセンス残数以下の数量しか指定できません")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    class: 'btn btn-default ',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    class: 'confirmation-modal-footer-yes-btn btn btn-primary',
    attrs: {
      "type": "button",
      "id": "confirmationModalYes"
    },
    on: {
      "click": _vm.confirmOK
    }
  }, [_vm._v("OK")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_inventory_reporting_period")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "棚卸報告年度区分"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletemailMessageModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_linked_devices")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器一覧"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToCertificateDetail
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.localCertificateSeqId < 0
    },
    on: {
      "click": _vm.unlinkItem
    }
  }, [_vm._v("紐付解除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableSelectNew
    },
    on: {
      "click": _vm.linkNewItem
    }
  }, [_vm._v("追加")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "col-xs-4 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('datetimepicker', {
    attrs: {
      "disabled-picker": _vm.isDisabled,
      "disabled": _vm.isDisabled,
      "input-style": _vm.disabledStyle + ';height: 24px!important;' + _vm.filedStyle,
      "input-button-style": _vm.buttonStyle,
      "input-class": " form-control force-white",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "value": _vm.fieldValue,
      "placeholder": "",
      "calendar-style": "left:-100px;"
    },
    on: {
      "input": _vm.updateValue
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['modal', _vm.effect],
    attrs: {
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        _vm.backdrop && _vm.action(false, 1)
      },
      "transitionend": function($event) {
        _vm.transition = false
      }
    }
  }, [_c('div', {
    class: ['modal-dialog modal-lg'],
    style: ({
      width: _vm.optionalWidth,
      height: _vm.optionalHeight
    }),
    attrs: {
      "role": "document"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.action(null)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content",
    style: ({
      height: _vm.optionalContentHeight
    })
  }, [_vm._t("modal-header", [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(false, 2)
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2)])]), _vm._v(" "), _vm._t("modal-body", [_c('div', {
    staticClass: "modal-body",
    style: ({
      height: _vm.optionalBodyHeight
    })
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._t("modal-footer", [_c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(false, 3)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(true, 4)
      }
    }
  }, [_vm._v(_vm._s(_vm.okText))])])])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "システム"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletemailMessageModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("device-embedded-detail")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "100px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: " col-xs-6"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), (_vm.hideNewBtn == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "232px",
      "float": "right",
      "margin-right": "5px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.selected_row == Number.MAX_SAFE_INTEGER || _vm.disableNewBtn == true || _vm.read_only == false || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規（組込情報）")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == true),
      expression: "isAdminSavingApplication == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onSubTableDeviceEmbeddedInformationAddCheckConfirmdri
    }
  }, [_vm._v("上書登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false && _vm.approvalMode == false),
      expression: "isAdminSavingApplication == false && approvalMode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveSubDevEmbedded
    }
  }, [_vm._v("下書登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false && _vm.approvalMode == true),
      expression: "isAdminSavingApplication == false && approvalMode == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveSubDevEmbeddedOnApprove
    }
  }, [_vm._v("上書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "109px",
      "float": "right",
      "margin-right": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": _vm.disableCancel
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditBtn == false),
      expression: "hideEditBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "227px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.selected_row == -1 || _vm.disableEditBtn == true || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集（組込情報）")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditBtn == false),
      expression: "hideEditBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "240px",
      "float": "right",
      "margin-right": "7px",
      "background": "#ed791a",
      "border-color": "#ed791a"
    },
    attrs: {
      "disabled": _vm.disableDelete || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))])]), _vm._v(" "), _c('confirmation-modal-device-link', {
    attrs: {
      "tag": "showConfimationModalSetYobiki"
    },
    on: {
      "done": _vm.confirmedSetYobiki
    }
  }), _vm._v(" "), _c('yobiki-modal', {
    attrs: {
      "tag": "showYobikiModal"
    },
    on: {
      "selected": _vm.onYobikiModalSelected
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteDeiveEmbeddedDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSaveDetails"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmSubDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onSubTableDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmSubDeviceEmbeddedInformationAddCheckOnApprove"
    },
    on: {
      "done": _vm.onSubTableDeviceEmbeddedInformationAddCheckConfirmOnApprove
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0040_certificate_software_detail\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [(_vm.showSurplusAlertMessage) ? _c('div', {
    staticClass: "col-xs-12 surplus_msg"
  }, [_vm._v("\n        以下のソフトウェア情報は余剰ライセンスです。"), _c('br'), _vm._v("\n        割当を希望される場合、[編集]ボタンより[所管区分][所管部署][所管チーム][所管システム(IT所管システムの場合)][申請者名（ﾌﾙﾈｰﾑ）][管理担当者名（ﾌﾙﾈｰﾑ）]欄を記入し、[申請]ボタンより申請を行ってください。"), _c('br'), _vm._v("\n        ※ライセンス数は変更できません。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loadBy == 'deposit_certificate_output') ? _c('title-and-slot', {
    attrs: {
      "title": "預り証出力（詳細）"
    }
  }) : _c('title-and-slot', {
    attrs: {
      "title": "証書情報（詳細）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-25px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v(" ＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          更新日：" + _vm._s(_vm.updateDate) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          登録日：" + _vm._s(_vm.registrationDate) + "\n        ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n      承認状態：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.approvalStatus
    }
  }), _vm._v("\n      状態:\n      "), _c('select', {
    staticClass: "status_field",
    style: (_vm.statusFieldStyle),
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })), _vm._v("\n      申請No：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "140px",
      "padding-left": "4px",
      "margin": "2px",
      "margin-bottom": "-6px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px",
      "color": "#008cff",
      "text-decoration": "underline"
    },
    attrs: {
      "type": "button",
      "value": _vm.approvalHistoryTorokuNumber
    },
    on: {
      "click": _vm.onConfirmExecuteProcessConfirmation
    }
  }), _vm._v(" "), (_vm.showApprovalHistoryBulkTorokuNumberQty) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※この申請は一括申請です。同一の申請が " + _vm._s(_vm.approvalHistoryBulkTorokuNumberQty) + " 件あります。")]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id],
        "option": {
          rows: 2
        }
      }
    })
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.draftWriteMode == false),
      expression: "draftWriteMode == false"
    }],
    staticClass: "btn btn-primary on_local_save_certificate_software",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalUpSaveCertificateSoftware
    }
  }, [_vm._v("上書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.draftWriteMode == true),
      expression: "draftWriteMode == true"
    }],
    staticClass: "btn btn-primary on_local_save_certificate_software",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveCertificateSoftware
    }
  }, [_vm._v("下書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary btn_cancel_btn",
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditMainBtn == false && _vm.approvalcancelmode == false),
      expression: "hideEditMainBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary on_edit_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableEditMainBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplyConfirmationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": function($event) {
        _vm.processApprovalApprove()
      }
    }
  }, [_vm._v("確認")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyRejectBtn == false && _vm.hideApplyConfirmationBtn == true && _vm.approvalcancelmode == false),
      expression: "hideApplyRejectBtn == false && hideApplyConfirmationBtn == true &&  approvalcancelmode == false "
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onapprovalSaveDevEmbeddedReason
    }
  }, [_vm._v("取戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplyConfirmationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.processApprovalCancel
    }
  }, [_vm._v("差戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplicationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplicationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary on_confirm_execute_process_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableApplicationBtn || _vm.read_only == false || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCopyMainBtn == false && _vm.approvalcancelmode == false),
      expression: "hideCopyMainBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary clone_record_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.forceDisableDueUpgradeDestination || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.cloneRecord
    }
  }, [_vm._v("\n        コピー\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.approvalcancelmode == false),
      expression: "approvalcancelmode == false"
    }],
    staticClass: "btn btn-warning show_device_btn",
    attrs: {
      "disabled": _vm.isSurplus || _vm.forceDisableDueUpgradeDestination || _vm.read_only == false || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false || _vm.loadBy == 'deposit_certificate_output'
    },
    on: {
      "click": _vm.onLinkDevice
    }
  }, [_vm._v("機器")]), _vm._v(" "), (_vm.is_new == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.approvalcancelmode == false),
      expression: "approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary show_history_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.BROWSE) == false
    },
    on: {
      "click": _vm.showHistory
    }
  }, [_vm._v("更新履歴")]) : _vm._e(), _vm._v(" "), (_vm.approvalcancelmode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.approvalCancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e(), _vm._v(" "), (_vm.approvalcancelmode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.onapprovalSaveDevEmbedded
    }
  }, [_vm._v("入力完了")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.approvalcancelmode == true),
      expression: "approvalcancelmode == true"
    }]
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "15px",
      "margin-right": "-190px",
      "font-weight": "800",
      "margin-top": "-23px",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v("※差戻通知を入力し、入力完了をクリックして下さい。(任意)\n          ")])])]), _vm._v(" "), _c('certificate-sub-page', {
    attrs: {
      "controller": _vm.subTableController,
      "disable_pdf_btn": _vm.disablepdfButtons
    }
  })], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationUpAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationUpAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancel"
    },
    on: {
      "done": _vm.processApprovalCancelBack
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancelReason"
    },
    on: {
      "done": _vm.processApprovalCancelBackReason
    }
  }), _vm._v(" "), _c('certificate-information-connection-application-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUnlinkDevices"
    },
    on: {
      "done": _vm.onConfirmUnlinkDevices
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterCertificateSoftwareApprovalStartedRequest"
    },
    on: {
      "done": _vm.afterTheNotificationAftercancel
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateApplicationConfimationModal"
    }
  }), _vm._v(" "), (_vm.enableHistoryModal) ? _c('change-history', {
    attrs: {
      "tag": "showCertificateSoftwareChangeHistoryModal",
      "id_label": "証書管理番号"
    }
  }) : _vm._e(), _vm._v(" "), _c('certificate-software-linked-upgrade-modal', {
    attrs: {
      "tag": "showCertificateSoftwareLinkedUpgradeModal"
    },
    on: {
      "selected": _vm.onSelectedUpgradeCertificate
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "10px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("\n          ＊入力必須項目\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px",
      "margin": "-15px"
    }
  }, [_c('h3', [_vm._v("ソフトウェア情報")])])])
}]}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("device-embedded-information-confirmation-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "bulk-import-confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "width": "700px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("申請ルート（機器・組込情報）")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body bulk-import-confirmation-modal-body overflow-modal-body",
    style: ('height: ' + _vm.model_height + 'px;padding: 5px 15px; ')
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("申請者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("状態")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userDepartment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userTeam))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userShimei))]), _vm._v(" "), _c('td', [_vm._v("下書き")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("承認者")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("状態")])]), _vm._v(" "), _vm._l(([1, 2, 3, 4, 5]), function(n) {
    return _c('tr', {
      key: n
    }, [_c('td', [_vm._v(_vm._s(n) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userDepartment))]), _vm._v(" "), _c('td', [_c('select', {
      staticClass: "form-control select-box limited-height-box"
    }, [(n > 1) ? _c('option', [_vm._v("（選択）")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.teamOptions), function(o) {
      return _c('option', {
        key: o
      }, [_vm._v(_vm._s(o))])
    })], 2)]), _vm._v(" "), _c('td', [_c('select', {
      staticClass: "form-control select-box limited-height-box"
    }, [(n > 1) ? _c('option', [_vm._v("（選択）")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userOptions), function(o) {
      return _c('option', {
        key: o
      }, [_vm._v(_vm._s(o))])
    })], 2)]), _vm._v(" "), _c('td', [_vm._v("承認待ち")])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("最終承認")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("ライセンス管理窓口（最終承認）")]), _vm._v(" "), _c('td', [_vm._v("承認待ち")])])], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    class: 'bulk-import-confirmation-modal-footer-yes-btn btn btn-primary ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button",
      "data-cy": 'bulk-import-confirmation-modal-footer-yes-btn',
      "id": "confirmationModalYes"
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("sub-table-temp-certificate-information")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n           件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_software")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "ソフトウェア"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletemailMessageModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_user_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "ユーザ（詳細）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "max-width": "100px",
      "float": "left",
      "margin-left": "5px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.dataUpdated
      }
    })
  })), _vm._v(" "), (_vm.showColumns2and3()) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_vm._l((_vm.formFields.col2_head), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly || _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.dataUpdated
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showColumns2and3()) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_vm._l((_vm.formFields.col3_head), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly || _vm.readOnly3,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.dataUpdated
      }
    })
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', [_c('br'), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false),
      expression: "isAdminSavingApplication == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "20px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disabledToSave || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    on: {
      "click": _vm.onPreSetDefaultPassword
    }
  }, [_vm._v("パスワード初期化")]) : _vm._e(), _vm._v(" "), (_vm.read_only != false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditMainBtn == false),
      expression: "hideEditMainBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "20px"
    },
    attrs: {
      "disabled": _vm.disableEditMainBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideDeleteBtn == false),
      expression: "hideDeleteBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.disableDeleteBtn || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "userApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterUserDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUserAddcancel"
    },
    on: {
      "done": _vm.processApprovalCancelBack
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterUserCancel"
    },
    on: {
      "done": _vm.afterTheNotificationAftercancel
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmSetDefaultPassword"
    },
    on: {
      "done": _vm.onSetDefaultPassword
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "12px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("＊入力必須項目［兼務設定項目は選択時のみ］")])])
}]}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_change_password")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "パスワードの変更"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('field-box', {
    attrs: {
      "data": _vm.currentPassword,
      "read": _vm.localReadOnly,
      "val": _vm.values['currentPassword']
    }
  }), _vm._v(" "), _c('field-box', {
    attrs: {
      "data": _vm.newPassword,
      "read": _vm.localReadOnly,
      "val": _vm.values['newPassword']
    }
  }), _vm._v(" "), _c('field-box', {
    attrs: {
      "data": _vm.confirmPassword,
      "read": _vm.localReadOnly,
      "val": _vm.values['confirmPassword']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.processChangePassword
    }
  }, [_vm._v("実行")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_pegging_choice")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器一覧"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n         件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("選択")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_user")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "ユーザ一覧"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.localBatchEditDisabled || _vm.disableIfCheckBoxNotSelected || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bachEdit
    }
  }, [_vm._v(_vm._s(_vm.batchEditText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right",
      "font-weight": "900",
      "padding": "7px"
    }
  }, [_vm._v("*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。")])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteUsernModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('information-icon-modal', {
    attrs: {
      "tag": "showInformationIconModalMasterUser"
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0001_reset_password")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form1 col-xs-3",
    staticStyle: {
      "margin-left": "-15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form1 col-xs-6",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('title-and-slot', {
    attrs: {
      "title": "PWロック解除"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _c('br')], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form1 col-xs-3",
    staticStyle: {
      "margin": "-5px 15px 15px -15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form1 col-xs-6",
    staticStyle: {
      "margin": "-5px 15px 15px -15px"
    }
  }, [_vm._v("\n          ライセンス管理窓口にて内容を確認後、パスワードロック解除を行います。"), _c('br'), _vm._v("\n          作業後にご連絡いたしますので、速やかにログインできることをご確認頂きますようお願いいたします。"), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left",
      "min-width": "130px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "float": "right",
      "min-width": "130px"
    },
    attrs: {
      "disabled": _vm.disallowToSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("申請")])])])]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "ResetPasswordModal"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#FFFFFF",
      "font-size": "30px",
      "padding": "27px 50px",
      "font-weight": "800",
      "background": "#5b9bd5"
    }
  }, [_vm._v("\n      ソフトウェアライセンス管理\n      "), _c('br'), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("e-sma")])])
}]}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("inventory_pending_items")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('search-control', {
    staticStyle: {
      "padding-bottom": "10px",
      "width": "100%"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource,
      "onSearchClear": _vm.onSearchClear
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px",
      "margin-left": "-15px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n      件数　\n    ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.inventory_report, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.addNewReport
    }
  }, [_vm._v("棚卸報告")])])]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runinventorypendingitemsDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0020_surplus_license")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "余剰ライセンス検索"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), (false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]) : _vm._e(), _vm._v(" "), (false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.formBatchEditDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bachEdit
    }
  }, [_vm._v(_vm._s(_vm.batchEditText))]) : _vm._e(), _vm._v(" "), (false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('device-embedded-information-bach-edit-modal', {
    attrs: {
      "tag": "showDeviceEmbeddedInformationBachEditModal"
    }
  }), _vm._v(" "), _c('information-icon-modal', {
    attrs: {
      "tag": "showInformationIconModalSurplus"
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runSurplusLicenseDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0051_approval_history_device_embedded_information_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "機器・組込情報"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [(_vm.is_new == false) ? _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("機器登録番号：" + _vm._s(_vm.deviceControlNumber))]) : _vm._e(), _vm._v(" "), (_vm.is_new == false) ? _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("登録日：" + _vm._s(_vm.registrationDate))]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])]), _vm._v(" "), (_vm.is_new == false) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("組込情報")]), _vm._v(" "), _c('sub-table', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("更新履歴")]), _vm._v(" "), (_vm.is_new == false) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "to": "/device_embedded_information_pegging2",
      "type": "button"
    }
  }, [_vm._v("新規証書紐付")]), _vm._v(" "), (_vm.is_new == false) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("コピー")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-warning btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onLocalSaveDevEmbedded
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-warning btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])], 1)], 1), _vm._v(" "), _c('device-embedded-information-confirmation-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        状態：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "60px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "value": "使用中"
    }
  }), _vm._v("\n         [承認] 申請No.：\n      ")])
}]}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0060_redirect")]) : _vm._e(), _vm._v(" "), _c('app-header', {
    attrs: {
      "no_menu": "true"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": _vm.messsage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "float": "right",
      "margin-right": "-10px",
      "margin-bottom": "10px",
      "margin-top": "-10px"
    }
  }, [(_vm.showQrCode) ? _c('img', {
    ref: "qrCodeImg",
    staticStyle: {
      "width": "20px",
      "height": "20px",
      "float": "right",
      "margin-right": "4px",
      "background": "green",
      "display": "none"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQrCode) ? _c('button', {
    staticClass: "btn btn-primary esma_btn_form btn-xs",
    staticStyle: {
      "width": "100px",
      "float": "right",
      "margin-right": "4px"
    },
    on: {
      "click": _vm.scannQRCode
    }
  }, [_vm._v("QR コード")]) : _vm._e(), _vm._v(" "), (_vm.showQrCode) ? _c('input', {
    ref: "camera",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "capture": "camera",
      "id": "camera"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "float": "right",
      "display": "inline-flex"
    }
  }, [(_vm.isShowInputBox) ? _c('input', {
    ref: "barcodeInput",
    staticClass: "form-control",
    staticStyle: {
      "width": "200px",
      "float": "right"
    },
    attrs: {
      "autofocus": "",
      "type": "input",
      "placeholder": "バーコード入力"
    },
    on: {
      "keyup": function($event) {
        _vm.onKeyUp('UP', $event.target.value, $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn hg_dropdown"
  })]), _vm._v(" "), (_vm.isShowClearButton) ? _c('button', {
    staticClass: "btn btn-primary esma_btn_form btn-xs",
    style: (_vm.buttonStyle),
    on: {
      "click": _vm.clearBarcode
    }
  }, [_vm._v("検索クリア")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_inventory_reporting_period_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "棚卸報告年度区分"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()]), _vm._v(" "), (_vm.read_only == false) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "10px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("\n          ＊入力必須項目\n        ")])]) : _vm._e()])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterInventoryReportingPeriodModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "output_options-modal",
    attrs: {
      "width": "600px",
      "height": "330px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "padding-left": "25px"
    },
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("選択中　" + _vm._s(_vm.qtyToReject) + "件")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body output_options-modal-body",
    staticStyle: {
      "height": "120px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('div', [_vm._v("\n        差戻を行います。"), _c('br'), _vm._v("\n        差戻理由等の記入が可能です。"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(任意)")])]), _vm._v(" "), _c('textarea', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "rows": "3",
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("一括差戻")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "証書情報（詳細）(old)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-25px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("更新日：" + _vm._s(_vm.registrationDate))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("登録日：" + _vm._s(_vm.registrationDate))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        承認状態：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.approvalStatus
    }
  }), _vm._v("\n        状態:\n        "), _c('select', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })), _vm._v("\n        申請No：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "140px",
      "padding-left": "4px",
      "margin": "2px",
      "margin-bottom": "-6px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px",
      "color": "#008cff",
      "text-decoration": "underline"
    },
    attrs: {
      "type": "button",
      "value": _vm.approvalHistoryTorokuNumber
    },
    on: {
      "click": _vm.onConfirmExecuteProcessConfirmation
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == true),
      expression: "isAdminSavingApplication == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalUpSaveDevEmbedded
    }
  }, [_vm._v("上書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false),
      expression: "isAdminSavingApplication == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveDevEmbedded
    }
  }, [_vm._v("下書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditMainBtn == false),
      expression: "hideEditMainBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableEditMainBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_new == true),
      expression: "is_new == true"
    }]
  }, [_vm._v("「下書保存」ボタンを押したら「ソフトウェア情報」が出ます。")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', [_c('div', {
    style: (_vm.subTableDeviceEmbeddedInformationStyle)
  }, [_c('h3', [_vm._v("ソフトウェア情報")]), _vm._v(" "), (_vm.showAssociatedDevice) ? _c('sub-table-associated_device', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disable_new_btn": _vm.disableNewToSubTableBtn,
      "disable_edit_btn": _vm.disableEditSubTableBtn,
      "hide_new_btn": _vm.hideNewToSubTableBtn,
      "hide_edit_btn": _vm.hideEditSubTableBtn,
      "disable_all_btn": _vm.disableAllButtons,
      "ref_id": _vm.certificateManagementNumber,
      "fk_id": _vm.certificateSeqId,
      "tag_reload": "reloadSubTableCertificateInformation"
    },
    on: {
      "data-saved": function($event) {
        _vm.subTableSaved()
      }
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.is_new == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.BROWSE) == false
    },
    on: {
      "click": _vm.showHistory
    }
  }, [_vm._v("更新履歴")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false),
      expression: "hideApplyConfirmationBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": function($event) {
        _vm.processApprovalApprove()
      }
    }
  }, [_vm._v("確認")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyRejectBtn == false),
      expression: "hideApplyRejectBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.processApprovalCancel
    }
  }, [_vm._v("差戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplicationBtn == false),
      expression: "hideApplicationBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableApplicationBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCopyMainBtn == false),
      expression: "hideCopyMainBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.cloneRecord
    }
  }, [_vm._v("コピー")])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationUpAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationUpAddCheckConfirm
    }
  }), _vm._v(" "), _c('file-modal', {
    attrs: {
      "tag": "showFileModal2"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancel"
    },
    on: {
      "done": _vm.processApprovalCancelBack
    }
  }), _vm._v(" "), _c('certificate-information-connection-application-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAftercancel"
    },
    on: {
      "done": _vm.afterTheNotificationAftercancel
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('log-history', {
    attrs: {
      "tag": "showCertificateInformationlogHistoryModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "10px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("＊入力必須項目")])])
}]}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("application-confirmation-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "bulk-import-confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "backdrop": false,
      "width": "1100px",
      "value": _vm.showModal,
      "v-if": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.userDepartment))])])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-body bulk-import-confirmation-modal-body overflow-modal-body",
    style: ('height:300px' + _vm.model_height + 'px;padding: 5px 15px; ')
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("申請者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }), _vm._v(" "), (_vm.isUpdating) ? _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.teamApplicant))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userApplicant))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), (_vm.isUpdating) ? _c('td', {
    staticStyle: {
      "width": "10%"
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("承認者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }), _vm._v(" "), (_vm.isUpdating) ? _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l(([1, 2, 3, 4, 5]), function(n) {
    return _c('tr', {
      key: n
    }, [_c('td', [_vm._v(_vm._s(n) + ".")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": _vm.lastChange
      }
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['team_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['team_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['approver_' + n], {
          ignore_current_user: true
        }),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['approver_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['status_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['status_' + n].id]
      }
    })], 1)]), _vm._v(" "), (_vm.isUpdating) ? _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [(((_vm.localCurrentRow[_vm.localFields['status_' + n].id] == '未承認') || (_vm.localCurrentRow[_vm.localFields['status_' + n].id] == '' || (_vm.localCurrentRow[_vm.localFields['status_' + n].id] == null))) && _vm.localCurrentRow[_vm.localFields['approver_' + n].id] != _vm.userId) ? _c('button', {
      staticClass: "btn btn-danger btn-sm ",
      staticStyle: {
        "margin": "0px -15px",
        "height": "24px",
        "padding-top": "2px"
      },
      on: {
        "click": function($event) {
          _vm.localDeleteApplicant(n)
        }
      }
    }, [_vm._v("削除")]) : _c('button', {
      staticClass: "btn btn-danger disabled-application-button btn-sm ",
      staticStyle: {
        "margin": "0px -15px",
        "height": "24px",
        "padding-top": "2px"
      },
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("削除")])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.applicationMode != 'mode_inventory') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("最終承認")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("ライセンス管理窓口（最終承認）")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col5), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col6), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.approvalHistoryTorokuNumber))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalIsReadOnly == true && _vm.isUpdating == false && _vm.url_for_update != null && _vm.showStartUpdate == true),
      expression: "modalIsReadOnly == true && isUpdating == false  && url_for_update != null && showStartUpdate == true"
    }],
    class: 'btn btn-info ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalStartUpdate
    }
  }, [_vm._v("編集")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdating == true),
      expression: "isUpdating == true"
    }],
    class: 'btn btn-info ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalStartUpdateSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalIsReadOnly != true),
      expression: "modalIsReadOnly != true"
    }],
    class: 'btn btn-primary ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalApplication
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "applicationConfirmatioModal"
    },
    on: {
      "done": _vm.onSaveApplicationConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformation"
    },
    on: {
      "done": _vm.onSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUpdateApplicationInformation"
    },
    on: {
      "done": _vm.onUpdateConfirmed
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUpdateApplicationInformationFinished"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_software")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "証書情報"
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "使用中"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "廃棄"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "下書中/申請中/差戻"
    }
  })], 1), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "6%",
      "min-width": "80px",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), (_vm.showEdit) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.formBatchEditDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bachEdit
    }
  }, [_vm._v(_vm._s(_vm.batchEditText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('device-embedded-information-bach-edit-modal', {
    attrs: {
      "tag": "showDeviceEmbeddedInformationBachEditModal"
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('information-icon-modal', {
    attrs: {
      "tag": "showInformationIconModalCertificateSoftware"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0073_excess_deficiency_summary")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "過不足集計表"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    style: ('margin-top:3px;margin-bottom:30px;')
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('search-company', {
    attrs: {
      "only_company": true
    },
    on: {
      "search": _vm.onCopmanySearchEvent
    }
  })], 1)]), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "部署",
      "data-test": "123"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "チーム"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "システム"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "全体"
    }
  })], 1), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runExcessDeficiencySummaryDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0090_deposit_certificate_output")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "預り証出力"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    style: ('margin-top:3px;margin-bottom:30px;')
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('search-company', {
    on: {
      "search": _vm.onSearchEvent
    }
  })], 1)]), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDepositCertificateOutputDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_belongs")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "部署・チーム"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletemailMessageModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0050_id_approval_history")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "ID申請履歴"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.bulkApprovalStage4
    }
  }, [_vm._v("申請クリア")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disablePageApprove
    },
    on: {
      "click": _vm.bulkApprovalStage1
    }
  }, [_vm._v("承認")])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage2ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage3
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    inventoty_tabs\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "申請承認（詳細）"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.localIsEditing
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showTable) ? _c('sub-table-temp-batch-import', {
    attrs: {
      "sessionId": _vm.sessionId,
      "allowCheckBox": _vm.showCheckBox
    },
    on: {
      "editing": _vm.isEditing
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("device-management-ledger-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "file-modal",
    attrs: {
      "width": "1500px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    class: 'container ' + _vm.pageContainerSize,
    staticStyle: {
      "margin-right": "auto",
      "margin-left": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "100px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: " col-xs-5",
    staticStyle: {
      "margin-left": "120px"
    }
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("閉じる")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "4px 0px"
    }
  }, [(this.$props['labelSize'] != 'L') ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.labelClass,
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label lams_inventory_form_label"
  }, [_vm._v(_vm._s(_vm.fieldLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('input', {
    staticClass: "lams_inventory_form_control",
    staticStyle: {
      "text-align": "end"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.fieldValue
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "メールメッセージ詳細"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "subject"
    }
  }, [_vm._v("件名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailSubject),
      expression: "mailSubject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subject",
      "id": "subject"
    },
    domProps: {
      "value": (_vm.mailSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailSubject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "content"
    }
  }, [_vm._v("本文")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailContent),
      expression: "mailContent"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "content",
      "id": "content",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.mailContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "20px 0px"
    }
  }, [_c('master-user', {
    attrs: {
      "searchData": _vm.selectedUserIDs,
      "showSearch": false,
      "showDetailsButtons": false,
      "allUserIds": false,
      "refreshTag": "selectedUsersRefresh",
      "showCheckBox": true,
      "subSearchMode": "only",
      "tabStyle": "width: 100%; height: 200px"
    },
    on: {
      "email_list_updated": _vm.emailListUpdated,
      "selected": _vm.onSelectedUserSelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.addUsers
    }
  }, [_vm._v("ユーザ追加")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.removeUsers
    }
  }, [_vm._v("ユーザ選択解除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.prepareSendMail
    }
  }, [_vm._v("メール作成")]), _vm._v(" "), _c('a', {
    ref: "send_mail_link",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "target": "new_email"
    }
  }, [_vm._v("mailto")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_belongs_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "部署・チーム（詳細）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "5px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-lift": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.cloneRecord
    }
  }, [_vm._v("コピー")]) : _vm._e()])]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterBelongsModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("certificate-list-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "yobiki_select-modal",
    attrs: {
      "width": "460px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v("証書管理番号")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body yobiki_select-modal-body ",
    staticStyle: {
      "height": "500px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "検索",
      "id": "yobiki-search",
      "name": "yobiki-search"
    },
    domProps: {
      "value": _vm.searchModel
    },
    on: {
      "input": function($event) {
        _vm.onSearch($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("OK")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-het"
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0010_device_embedded_information_detail_bulk_edit")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "機器・組込情報(一括編集）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        状態:\n        "), _c('select', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showApplyButton == true),
      expression: "showApplyButton == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.onLocalSaveBulkDevEmbedded
    }
  }, [_vm._v("下書保存")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])])], 1), _vm._v(" "), _c('device-embedded-information-confirmation-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmBulkDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onBulkDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "bulkDeviceEmbeddedApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "showConfimationModalSetdevice"
    },
    on: {
      "done": _vm.confirmedSetdevice
    }
  }), _vm._v(" "), _c('device-modal', {
    attrs: {
      "tag": "showdeviceModal"
    },
    on: {
      "selected": _vm.ondeviceModalSelected
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: _vm.labelClass,
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5",
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "end"
    },
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID + '_user',
      "name": _vm.fieldID + '_user',
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValueUser
    },
    on: {
      "input": function($event) {
        _vm.updateValueUser($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "text-align": "center"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center",
      "color": "black",
      "padding": "0px"
    },
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID + '_at',
      "name": _vm.fieldID + '_at',
      "value": "@",
      "readonly": true,
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  }, [(_vm.isDisabled) ? _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "text-align": "end"
    },
    style: (_vm.vSelectFiledDisabledStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID + '_domain_disabled',
      "name": _vm.fieldID + '_domain_disabled',
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValue
    }
  }) : _c('v-select', {
    staticClass: "style-chooser-email",
    style: (_vm.vSelectFiledStyle),
    attrs: {
      "noDrop": _vm.isDisabled,
      "clearable": false,
      "options": _vm.fieldOptions,
      "single-line": true,
      "value": _vm.fieldValue,
      "taggable": true
    },
    on: {
      "input": _vm.updateValueDomainOption
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n        Manual input\n      ")])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_vm._m(0)]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("機器・組込情報の申請が完了しました。")])])
}]}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("inventory_managment")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ' container_auto '
  }, [_c('search-control', {
    staticStyle: {
      "padding-bottom": "10px",
      "width": "100%"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "onSearchClear": _vm.onSearchClear,
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px",
      "margin-left": "-15px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n          件数　\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('device-management-ledger-modal', {
    attrs: {
      "tag": "showInventoryManagmentModal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "-15px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": true || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.inventory_report_check, _vm.permissionMode.EXPORT) == false,
      "tag": "button",
      "to": "/inventory_report_check",
      "type": "button"
    }
  }, [_vm._v("棚卸報告確認")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.inventory_report, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.addNewReport
    }
  }, [_vm._v("棚卸報告")])], 1)]), _vm._v(" "), _c('br')])
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": _vm.pageTitle
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.showAllocationRequestBtn && _vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.showAllocationRequestForm || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.onAllocationRequest
    }
  }, [_vm._v("割当依頼")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.showAllocationRequestForm || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, [(_vm.showAllocationRequestForm) ? _c('surplus-license-sub-table', {
    attrs: {
      "create_new": this.subTableSeqID == -1,
      "ref_id": _vm.surplusLicenseSeqID,
      "seq_id": _vm.subTableSeqID
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteSurplusLicenseModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col1), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col2), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("メンテナンスメニュー")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])
}]}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("sub-table-temp-device-embedded-detail")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n           件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "device-embedded-information-bach-edit-modal",
    attrs: {
      "width": "460px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade"
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("本当に登録してよろしいでしょうか。")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body device-embedded-information-bach-edit-modal-body",
    staticStyle: {
      "height": "100px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("完了")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "メールメッセージ（詳細）"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading == false),
      expression: "loading==false"
    }],
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "-10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "-10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onGoToSendMail
    }
  }, [_vm._v("メール作成")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMailMessageDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [_c('label', {
    staticClass: "col-xs-4 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, _vm._l((_vm.buttons), function(b) {
    return _c('div', {
      key: b.text,
      staticClass: "radio-inline",
      on: {
        "click": function($event) {
          _vm.onClick(b, $event)
        }
      }
    }, [_c('label', [_c('input', {
      style: (_vm.filedStyle),
      attrs: {
        "type": "radio",
        "name": _vm.fieldLabel,
        "id": _vm.fieldLabel,
        "disabled": _vm.isDisabled
      },
      domProps: {
        "value": b.text,
        "checked": _vm.isChecked(b.text)
      }
    }), _vm._v(" " + _vm._s(b.label))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.labelNewLine) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "1px 0px 1px 0px"
    }
  }, [(_vm.showLabel && _vm.hideAll == false) ? _c('label', {
    staticClass: "col-xs-2 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.labelNewLine) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.showLabel && _vm.labelNewLine == false && _vm.hideAll == false) ? _c('label', {
    class: {
      'col-xs-2': _vm.showLabelAs4 == false, 'col-xs-4': _vm.showLabelAs4, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideAll == false),
      expression: "hideAll == false"
    }],
    ref: "local_value",
    staticClass: "form-control",
    style: (_vm.filedStyle),
    attrs: {
      "disabled": this.localRefreshSequecnce > 0 && _vm.isDisabled && _vm.forcewrite == false,
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "placeholder": "",
      "rows": _vm.fieldRows
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideAll == false),
      expression: "hideAll == false"
    }],
    staticStyle: {
      "font-size": "15px",
      "font-weight": "800",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.fieldMessage))])])])
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px"
    }
  }, [(_vm.fieldInfo.type == _vm.types.INPUT) ? _c('div', [_c('input-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "error_msg": _vm.onErrorMsg,
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.EMAIL) ? _c('div', [_c('email-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX) ? _c('div', [_c('select-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX2) ? _c('div', [_c('select-box2', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX3) ? _c('div', [_c('select-box3', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SELECT_BOX4) ? _c('div', [_c('select-box4', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    },
    on: {
      "on_update": _vm.onUpdate
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.DATE_PICKER || _vm.fieldInfo.type == _vm.types.CURRENT_TIME) ? _c('div', [(_vm.fakeDate()) ? _c('input-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  }) : _c('date-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.DATETIME_PICKER) ? _c('div', [(_vm.fakeDate()) ? _c('input-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  }) : _c('datetime-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.PASSWORD) ? _c('div', [_c('password-box', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.RADIO_BUTTON) ? _c('div', [_c('radio-button', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.TEXT_AREA) ? _c('div', [_c('text-area', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.CHECKBOX) ? _c('div', [_c('checkbox', {
    attrs: {
      "data": _vm.fieldInfo,
      "value": _vm.valinfo,
      "option": _vm.optionInfo,
      "read": _vm.readOnly
    }
  })], 1) : (_vm.fieldInfo.type == _vm.types.SPACE) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError),
      expression: "showError"
    }],
    style: ('color:white;margin:2px 0px;padding:2px 5px;text-align: end; width: 90%;float: right;background-color:' + ((_vm.errorMode == 'restrict') ? '#de5201;' : 'orange;'))
  }, [_vm._v(_vm._s(_vm.errorMsg))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [_c('br')])
}]}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "メール作成(送信先ユーザ)"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "20px 0px"
    }
  }, [_c('master-user', {
    attrs: {
      "searchData": _vm.selectedUserIDs,
      "showSearch": false,
      "showDetailsButtons": false,
      "allUserIds": false,
      "showCheckBox": true,
      "subSearchMode": "only",
      "refreshTag": "selectedUsersRefresh",
      "tabStyle": "width: 100%; height: 200px"
    },
    on: {
      "selected": _vm.onSelectedUserSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "15px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("▲ユーザ追加")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "15px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.removeUsers
    }
  }, [_vm._v("ユーザ選択解除")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "20px 0px"
    }
  }, [_c('master-user', {
    attrs: {
      "showSearch": true,
      "allUserIds": true,
      "sourceState": "2",
      "searchData": _vm.selectedUserIDs,
      "subSearchMode": "ignore",
      "refreshTag": "allUsersRefresh",
      "showDetailsButtons": false,
      "showCheckBox": true,
      "tabStyle": "width: 100%; height: 200px"
    },
    on: {
      "selected": _vm.onNewUserSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "margin-left": "15px",
      "float": "left"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "25px -20px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("certificate")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0px -10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disableShowSelectCertificate
    },
    on: {
      "click": _vm.showSelectCertificate
    }
  }, [_vm._v("登録済みの証書情報に紐付ける")])])]), _vm._v(" "), _c('div', {
    staticClass: "row ",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: " col-xs-6"
  }, [_vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "left",
      "min-width": "100px",
      "width": "7%",
      "margin-right": "10px",
      "background": "#92d050",
      "border-color": "#92d050"
    },
    attrs: {
      "disabled": _vm.disablePDFbtn || _vm.localDisablePDF
    },
    on: {
      "click": _vm.openFileModal
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "250px",
      "float": "left",
      "margin-top": "3px"
    }
  }, [_c('label', {
    staticClass: "ccontrol-label esma_form_label",
    staticStyle: {
      "width": "170px",
      "float": "left"
    }
  }, [_vm._v("添付ファイルの有無")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "63px",
      "float": "left",
      "border": "2px gray solid",
      "margin-top": "1px",
      "border-radius": "6px",
      "height": "24px",
      "text-align": "center",
      "margin-left": "9px"
    },
    domProps: {
      "innerHTML": _vm._s((_vm.hasPdfs) ? '有り' : '無し')
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), (_vm.disableShowSelectCertificate == false) ? _c('certificate-list-modal', {
    attrs: {
      "tag": "showcertificateListModal"
    },
    on: {
      "selected": _vm.oncertificateListModalSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "showConfimationModalCertificateSelected"
    },
    on: {
      "done": _vm.showConfimationModalCertificateSelectedConfirmed
    }
  }), _vm._v(" "), _c('file-modal', {
    attrs: {
      "tag": "showFileModal"
    },
    on: {
      "close": _vm.pdfClosed
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px",
      "margin": "0px 5px"
    }
  }, [_c('h3', [_vm._v("証書情報")])])
}]}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "backdrop": false,
      "width": _vm.localWidth,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [(_vm.textTitle && _vm.textTitle.length > 0) ? _c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    style: (_vm.titleStyle)
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body confirmation-modal-body ",
    style: ('Width: ' + _vm.model_height + 'px;padding: 5px 15px; '),
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.textNo.length > 0) ? _c('button', {
    class: 'btn btn-default ' + _vm.no_color,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v(_vm._s(_vm.textNo))]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.textYes.length > 0),
      expression: "textYes.length > 0"
    }],
    class: 'confirmation-modal-footer-yes-btn btn btn-' + _vm.yes_color,
    attrs: {
      "type": "button",
      "data-cy": 'confirmation-modal-footer-yes-btn' + _vm.textTitle,
      "id": "confirmationModalYes"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("first_time_change_password")]) : _vm._e(), _vm._v(" "), _c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom",
      "no_menu": "true"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": _vm.pageTitle
    }
  }, [_c('div')]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('field-box', {
    attrs: {
      "data": _vm.currentPassword,
      "read": _vm.localReadOnly,
      "val": _vm.values['currentPassword']
    }
  }), _vm._v(" "), _c('field-box', {
    attrs: {
      "data": _vm.newPassword,
      "read": _vm.localReadOnly,
      "val": _vm.values['newPassword']
    }
  }), _vm._v(" "), _c('field-box', {
    attrs: {
      "data": _vm.confirmPassword,
      "read": _vm.localReadOnly,
      "val": _vm.values['confirmPassword']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.processChangePassword
    }
  }, [_vm._v("実行")])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "passwordChanged"
    },
    on: {
      "done": _vm.onPasswordChanged
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  })])
}]}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col1), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col2), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("証書メニュー")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])
}]}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0030_bulk_import")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "一括取込"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.bulk_import, _vm.permissionMode.EXPORT) == false && _vm.checkUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.EXPORT) == false,
      "text": _vm.dropdown_label,
      "type": "warning btn  btn-xs btn-warning dropdown_yellow_import"
    }
  }, [_c('li', {
    staticStyle: {
      "width": "300px",
      "margin-top": "2px"
    }
  }, [_c('a', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "300px",
      "background": "orang",
      "color": "black"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.bulk_import, _vm.permissionMode.EXPORT) == false,
      "href": "/api/batch_import_export/export_template/",
      "target": "temp_associated_device"
    },
    on: {
      "click": _vm.checkPerimissionForDownload1
    }
  }, [_vm._v(_vm._s(_vm.btn_batch_import_label))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "300px",
      "margin-top": "2px"
    }
  }, [_c('a', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "300px",
      "background": "orang",
      "color": "black"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.EXPORT) == false,
      "href": "/api/batch_import_export/export_template2/",
      "target": "temp_associated_device"
    }
  }, [_vm._v(_vm._s(_vm.btn_batch_import2_label))])])]), _vm._v(" "), _c('div', [_c('input', {
    ref: "csv_file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "csv_file",
      "id": "csv_file",
      "data-cy": "csv_file",
      "accept": "*/*"
    },
    on: {
      "change": _vm.fileSelected,
      "click": _vm.fileClicked
    }
  }), _vm._v(" "), (_vm.showChoseFile) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "300px",
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.bulk_import, _vm.permissionMode.ADD) == false && _vm.checkUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.ADD) == false,
      "type": "button"
    },
    on: {
      "click": _vm.choseFile
    }
  }, [_vm._v("ファイルを選択（Excel）")]) : _vm._e(), _vm._v(" "), (_vm.uploading == true) ? _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        アップロード中...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showUploadFile) ? _c('div', [(this.selected_file_name != null && _vm.showUploadFile) ? _c('label', [_vm._v(_vm._s(this.selected_file_name))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "10%"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.bulk_import, _vm.permissionMode.ADD) == false && _vm.checkUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.ADD) == false,
      "data-cy": "upload_btn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.uploadFile({})
      }
    }
  }, [_vm._v("アップロード")]), _vm._v(" "), (_vm.showCancelUpload) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "10%",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("キャンセル")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.errorMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorMsg)
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (false) ? _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSubTableCer) ? _c('sub-table-cer') : _vm._e(), _vm._v(" "), (_vm.showSubTableDev) ? _c('sub-table-dev') : _vm._e(), _vm._v(" "), (_vm.showSubTableAssociatedDevice) ? _c('sub-table-associated-device') : _vm._e(), _vm._v(" "), (_vm.showSubTableDeviceEmbeddedDetail) ? _c('sub-table-device-embedded-detail') : _vm._e(), _vm._v(" "), (_vm.showsubTableTempBatchImport) ? _c('sub-table-temp-batch-import', {
    attrs: {
      "sessionId": _vm.sessionId
    },
    on: {
      "onerror": _vm.showError
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showSubTableCer || _vm.showSubTableDev || _vm.showSubTableAssociatedDevice || _vm.showSubTableDeviceEmbeddedDetail || _vm.showsubTableTempBatchImport) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.bulk_import, _vm.permissionMode.ADD) == false && _vm.checkUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.onExecuteClear
    }
  }, [_vm._v("クリア")]) : _vm._e(), _vm._v(" "), (_vm.showSubTableCer || _vm.showSubTableDev || _vm.showSubTableAssociatedDevice || _vm.showSubTableDeviceEmbeddedDetail || _vm.showsubTableTempBatchImport) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableApplyButton || (_vm.checkUserPermission(_vm.acl.bulk_import, _vm.permissionMode.ADD) == false && _vm.checkUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.ADD) == false)
    },
    on: {
      "click": _vm.onConfirmExecuteProcessAndApply
    }
  }, [_vm._v("申請")]) : _vm._e(), _vm._v(" "), (_vm.showSubTableCer || _vm.showSubTableDev || _vm.showSubTableAssociatedDevice || _vm.showSubTableDeviceEmbeddedDetail) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.bulk_import, _vm.permissionMode.ADD) == false && _vm.checkUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcessOnlySave
    }
  }, [_vm._v("下書保存")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "applicationConfirmatioProcessOnlyModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "onConfirmExecuteProcessOnlySave"
    },
    on: {
      "done": _vm.onConfirmExecuteProcessOnly
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("sub-table-temp-device-embedded-information")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n           件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0090_notice\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": _vm.pageTitle
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "お知らせ"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "お知らせ 履歴一覧"
    }
  })], 1), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.selectedTab == 0),
      expression: "this.selectedTab == 0"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("\n        新規\n      ")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("certificate-list-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "yobiki_select-modal",
    attrs: {
      "width": "800px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.title_label))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body yobiki_select-modal-body ",
    staticStyle: {
      "height": "500px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n          件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white",
      "margin-top": "20px"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "disabled": _vm.formExportFileDisabled,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showLarge) ? _c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "800px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body information-modal-body ",
    staticStyle: {
      "height": "100px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])]) : _c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "460px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body information-modal-body ",
    staticStyle: {
      "height": "100px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_company")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "会社"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.selected_row == -1 || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("certificate-list-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "yobiki_select-modal",
    attrs: {
      "width": "800px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.title_label))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body yobiki_select-modal-body ",
    staticStyle: {
      "height": "500px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n          件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "20px",
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "disabled": _vm.formExportFileDisabled,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [(_vm.clearingAll == false) ? _c('div', {
    staticClass: " col-xs-12",
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    }
  }, [_c('div', {
    staticClass: " col-xs-6",
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    }
  }, [_c('select', {
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "width": "100%!important",
      "margin-top": "0px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.allDisabled,
      "id": 'search_block' + _vm.block_id,
      "name": 'search_block' + _vm.block_id
    },
    domProps: {
      "value": _vm.selectedFieldName
    },
    on: {
      "change": function($event) {
        _vm.onFilterTypeSelected($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.filedList), function(o) {
    return _c('option', {
      key: o.id,
      attrs: {
        "data": o
      },
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-6",
    staticStyle: {
      "padding": "0px 0px 0px 3px",
      "margin": "0px"
    }
  }, [(_vm.selectedFieldType == false) ? _c('div', [_vm._v("\n              ...\n            ")]) : (_vm.selectedFieldType == _vm.filed_types.INPUT || _vm.selectedFieldType == _vm.filed_types.PASSWORD || _vm.selectedFieldType == _vm.filed_types.TEXT_AREA) ? _c('div', [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.selected_field == false || _vm.allDisabled,
      "type": "text",
      "id": 'search_local_value_' + _vm.block_id,
      "name": "local_value",
      "model": _vm.localValue
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })]) : (_vm.selectedFieldType == _vm.filed_types.SELECT_BOX && (_vm.selectedField.id == 'data_name' || _vm.selectedField.id == 'operation_type')) ? _c('div', [_c('select', {
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.selected_field == false || _vm.allDisabled,
      "id": 'search_local_value_' + _vm.block_id,
      "name": "local_value",
      "model": _vm.localValue
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o.val,
      attrs: {
        "data": o.val
      },
      domProps: {
        "value": o.val
      }
    }, [_vm._v(_vm._s(o.label))])
  }), _vm._v(" "), (_vm.selectedField.search_no_blank != true) ? _c('option', {
    attrs: {
      "value": "SELECTED_EMPTY_SELECT_BOX"
    }
  }, [_vm._v("(空白)")]) : _vm._e()], 2)]) : (_vm.selectedFieldType == _vm.filed_types.SELECT_BOX || _vm.selectedFieldType == _vm.filed_types.SELECT_BOX3) ? _c('div', [_c('select', {
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.selected_field == false || _vm.allDisabled,
      "id": 'search_local_value_' + _vm.block_id,
      "name": "local_value",
      "model": _vm.localValue
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": _vm.localValue == o
      }
    }, [_vm._v(_vm._s(o))])
  }), _vm._v(" "), (_vm.selectedFieldType == _vm.filed_types.SELECT_BOX3) ? _c('option', {
    attrs: {
      "value": "manual_input"
    }
  }, [_vm._v("手動入力検索")]) : _vm._e(), _vm._v(" "), (_vm.selectedField.search_no_blank != true) ? _c('option', {
    attrs: {
      "value": "SELECTED_EMPTY_SELECT_BOX"
    }
  }, [_vm._v("(空白)")]) : _vm._e()], 2)]) : (_vm.selectedFieldType == _vm.filed_types.SELECT_BOX4) ? _c('div', [_c('select-box4', {
    attrs: {
      "data": _vm.selected_field,
      "value": "",
      "search_value": _vm.localValue,
      "option": {
        hide_label: true,
        search_mode: true,
        search_block_id: this.block_id
      },
      "read": false,
      "search": ""
    },
    on: {
      "change": _vm.updateValue
    }
  })], 1) : (_vm.selectedFieldType == _vm.filed_types.SELECT_BOX2) ? _c('div', [_c('select', {
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.selected_field == false || _vm.allDisabled,
      "id": 'search_local_value_' + _vm.block_id,
      "name": "local_value",
      "model": _vm.localValue
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o.value,
      attrs: {
        "data": o.value
      },
      domProps: {
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  }))]) : (_vm.selectedFieldType == _vm.filed_types.DATETIME_PICKER) ? _c('div', [_c('datetimepicker', {
    staticStyle: {
      "margin-left": "8px",
      "margin-top": "0px"
    },
    attrs: {
      "calendarButton": true,
      "inputButtonStyle": "padding-left: 3px!important;padding-right: 3px!important;",
      "disabled-picker": _vm.selected_field == false || _vm.allDisabled,
      "input-style": (_vm.selected_field == false || _vm.allDisabled) ? 'border-radius: 4px;font-size:12px;' : 'border-radius: 4px;background-color: white;font-size:12px;',
      "input-class": " form-control force-white limited-height-box",
      "id": "datetimepicker",
      "name": "datetimepicker",
      "model": _vm.localValue,
      "value": _vm.localValue,
      "placeholder": "",
      "calendar-style": "left:-100px;"
    },
    on: {
      "input": _vm.updateValueDateTime
    }
  })], 1) : (_vm.selectedFieldType == _vm.filed_types.DATE_PICKER || _vm.selectedFieldType == _vm.filed_types.CURRENT_TIME) ? _c('div', [_c('datepicker', {
    staticStyle: {
      "margin-left": "8px",
      "margin-top": "0px"
    },
    attrs: {
      "calendarButton": true,
      "inputButtonStyle": "padding-left: 3px!important;padding-right: 3px!important;",
      "disabled-picker": _vm.selected_field == false || _vm.allDisabled,
      "input-style": (_vm.selected_field == false || _vm.allDisabled) ? 'border-radius: 4px;font-size:12px;' : 'border-radius: 4px;background-color: white;font-size:12px;',
      "input-class": " form-control force-white limited-height-box",
      "id": "datepicker",
      "name": "datepicker",
      "model": _vm.localValue,
      "value": _vm.localValue,
      "placeholder": "",
      "calendar-style": "left:-100px;"
    },
    on: {
      "input": _vm.updateValueDate
    }
  })], 1) : (_vm.selectedFieldType == _vm.filed_types.RADIO_BUTTON) ? _c('div', [_vm._v("\n              TBA\n              ")]) : (_vm.selectedFieldType == _vm.filed_types.CHECKBOX) ? _c('div', [_vm._v("\n              TBA\n              ")]) : _c('div', [_vm._m(0)])])]) : _vm._e(), _vm._v(" "), _c('input-modal', {
    attrs: {
      "tag": 'showInputModal' + _vm.block_id
    },
    on: {
      "inputed": _vm.updateValue,
      "closed": _vm.onManualSelectClose
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [_c('br')])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("application-confirmation-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "bulk-import-confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "backdrop": false,
      "width": "1100px",
      "value": _vm.showModal,
      "v-if": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.userDepartment))])])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-body bulk-import-confirmation-modal-body overflow-modal-body",
    style: ('height:600px' + ';padding: 5px 15px; ')
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("申請者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.teamApplicant))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userApplicant))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("承認者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  })]), _vm._v(" "), _vm._l((_vm.ApprovalNumberSet), function(n) {
    return _c('tr', {
      key: n
    }, [_c('td', [_vm._v(_vm._s(n) + ".")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": _vm.lastChange
      }
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['team_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['team_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['approver_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['approver_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['status_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['status_' + n].id]
      }
    })], 1)])])
  }), _vm._v(" "), (_vm.applicationMode != 'mode_inventory') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("最終承認")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("ライセンス管理窓口（最終承認）")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col5), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col6), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.application_mode != 'inventory') ? _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.approvalHistoryTorokuNumber))]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalIsReadOnly != true),
      expression: "modalIsReadOnly != true"
    }],
    class: 'btn btn-primary ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalApplication
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "applicationConfirmatioModal"
    },
    on: {
      "done": _vm.onSaveApplicationConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformation"
    },
    on: {
      "done": _vm.onSave
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0072_invetory_report_check")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize,
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('title-and-slot', {
    attrs: {
      "title": "棚卸報告確認"
    }
  }), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "30px",
      "float": "left"
    }
  }, [_vm._v("　　　　　　会社：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedcompany),
      expression: "selectedcompany"
    }],
    staticClass: "form-control select-box",
    staticStyle: {
      "margin-top": "30px",
      "display": "inline",
      "width": "300px",
      "height": "24px",
      "padding": "0 6px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedcompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.companylist), function(r) {
    return _c('option', {
      key: r.value,
      domProps: {
        "value": r.value
      }
    }, [_vm._v(_vm._s(r.value))])
  })], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_vm._v("棚卸報告年度区分：")]), _vm._v(" "), _c('select', {
    staticClass: "form-control select-box",
    staticStyle: {
      "display": "inline",
      "width": "300px",
      "height": "24px",
      "padding": "0 6px"
    },
    domProps: {
      "value": _vm.selvalues['reporting_period']
    },
    on: {
      "change": function($event) {
        _vm.onSelectPeriod($event.target.value)
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.reportingPeriodList), function(r) {
    return _c('option', {
      key: r.value,
      domProps: {
        "value": r.value
      }
    }, [_vm._v(_vm._s(r.value))])
  })], 2)]), _vm._v(" "), (_vm.EditableUser == true) ? _c('div', [(_vm.withinperiod == false && _vm.admineditable && _vm.viewcaution) ? _c('div', {
    staticClass: "row"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n        報告期間外です\n        ")])], 1) : (_vm.withinperiod && _vm.admineditable == false && _vm.viewcaution) ? _c('div', {
    staticClass: "row"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n        報告がロックされています\n        ")])], 1) : (_vm.withinperiod == false && _vm.admineditable == false && _vm.viewcaution) ? _c('div', {
    staticClass: "row"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n        報告がロックされており期間外です\n        ")])], 1) : _c('div', {
    staticClass: "row"
  })]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "EUC /その他"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "IT所管システム"
    }
  }), _vm._v(" "), (_vm.InventoryApprovalInquiry > 0) ? _c('tab', {
    attrs: {
      "header": "棚卸申請承認"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.EditableUser == true && _vm.selectedTab != 2) ? _c('div', {}, [_c('br'), _vm._v(" "), _c('report-totals-box', {
    attrs: {
      "tag": "reportTotalsBox"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), (_vm.selectedTab != 2) ? _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), (_vm.rejectmode == true) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RejectReasonText),
      expression: "RejectReasonText"
    }],
    staticClass: "form-control",
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px",
      "margin-right": "15px",
      "height": "100px",
      "width": "500px",
      "resize": "none"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.RejectReasonText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RejectReasonText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "end",
      "margin-bottom": "10px"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n              ※差戻理由を入力し、入力完了をクリックしてください。(任意)\n              ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.disablePageReject
    },
    on: {
      "click": _vm.onRejectEmbedded
    }
  }, [_vm._v(_vm._s(_vm.RejectSaveText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.rejectcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")])]) : _vm._e(), _vm._v(" "), (_vm.rejectmode == false) ? _c('div', [(_vm.EditableUser == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.disableUnreportList || _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]) : _vm._e(), _vm._v(" "), (_vm.EditableUser == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.disableUnreportList
    },
    on: {
      "click": _vm.ShowUnreportList
    }
  }, [_vm._v("報告リスト")]) : _vm._e(), _vm._v(" "), (_vm.EditableUser == true && this.admineditable == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.disablePageReject
    },
    on: {
      "click": _vm.onRejectStart
    }
  }, [_vm._v(_vm._s(_vm.RejectText))]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.EditableUser == true) ? _c('div', [_c('inventory-unreport-list-euc', {
    attrs: {
      "tag": "showinventoryunreportlisteuc"
    },
    on: {
      "done": _vm.onlisteucFile
    }
  }), _vm._v(" "), _c('inventory-unreport-list-it', {
    attrs: {
      "tag": "showinventoryunreportlistit"
    },
    on: {
      "done": _vm.onlistitFile
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventorycheckonRejectEmbedded"
    },
    on: {
      "done": _vm.onReject
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventorycheckonRejectEmbeddednotification"
    },
    on: {
      "done": _vm.onRejectEnd
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runinventoryreportlistDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('br')])
}]}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "bulk-import-confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "width": "700px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("申請ルート（証書情報）")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body bulk-import-confirmation-modal-body overflow-modal-body",
    style: ('height: ' + _vm.model_height + 'px;padding: 5px 15px; ')
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("申請者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("状態")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userDepartment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userTeam))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userShimei))]), _vm._v(" "), _c('td', [_vm._v("下書き")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("承認者")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("状態")])]), _vm._v(" "), _vm._l(([1, 2, 3, 4, 5]), function(n) {
    return _c('tr', {
      key: n
    }, [_c('td', [_vm._v(_vm._s(n) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userDepartment))]), _vm._v(" "), _c('td', [_c('select', {
      staticClass: "form-control select-box limited-height-box"
    }, [(n > 1) ? _c('option', [_vm._v("（選択）")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.teamOptions), function(o) {
      return _c('option', {
        key: o
      }, [_vm._v(_vm._s(o))])
    })], 2)]), _vm._v(" "), _c('td', [_c('select', {
      staticClass: "form-control select-box limited-height-box"
    }, [(n > 1) ? _c('option', [_vm._v("（選択）")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userOptions), function(o) {
      return _c('option', {
        key: o
      }, [_vm._v(_vm._s(o))])
    })], 2)]), _vm._v(" "), _c('td', [_vm._v("承認待ち")])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("最終承認")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("ライセンス管理窓口（最終承認）")]), _vm._v(" "), _c('td', [_vm._v("承認待ち")])])], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    class: 'bulk-import-confirmation-modal-footer-yes-btn btn btn-primary ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button",
      "data-cy": 'bulk-import-confirmation-modal-footer-yes-btn',
      "id": "confirmationModalYes"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("associated_device")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "100px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row ",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: " col-xs-6"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), (_vm.hideNewBtn == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "232px",
      "float": "right",
      "margin-right": "5px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.disableAllBtn || _vm.selected_row == Number.MAX_SAFE_INTEGER || _vm.disableNewBtn == true || _vm.read_only == false || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規（ソフトウェア情報）")]) : _vm._e(), _vm._v(" "), (_vm.readOnly == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == true),
      expression: "isAdminSavingApplication == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.disableAllBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onSaveAssociatedDeviceConfirmdri
    }
  }, [_vm._v("上書登録")]) : _vm._e(), _vm._v(" "), (_vm.readOnly == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false),
      expression: "isAdminSavingApplication == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.disableAllBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onSaveAssociatedDeviceConfirm
    }
  }, [_vm._v("下書登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "109px",
      "float": "right",
      "margin-right": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditBtn == false),
      expression: "hideEditBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "227px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.disableAllBtn || _vm.selected_row == -1 || _vm.disableEditBtn == true || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集（ソフトウェア情報）")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "240px",
      "float": "right",
      "margin-right": "7px",
      "background": "#ed791a",
      "border-color": "#ed791a"
    },
    attrs: {
      "disabled": _vm.disableAllBtn || _vm.disableDelete || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))])]), _vm._v(" "), _c('information-modal', {
    attrs: {
      "tag": "associatedDeviceAlertMessage"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteAssociatedDeviceModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-xs-12 app-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 app-header-user option_menu"
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 10px",
      "float": "right"
    }
  }, [(_vm.alloLogout) ? _c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    staticStyle: {
      "margin": "0px 10px",
      "float": "right",
      "background-color": "#3b89cb"
    },
    attrs: {
      "to": "/logout",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("\n            ログアウト\n          ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    attrs: {
      "text": "オプション",
      "type": "primary btn  btn-xs btn-primary "
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.goToBrowserSettings
    }
  }, [_vm._v("ブラウザ設定")])])])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "padding": "8px",
      "font-size": "12px",
      "text-align": "end",
      "color": "#FFFFFF"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userCompany))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userDepartment))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userTeam))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userShimei))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userRole))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 0px 0px 20px"
    }
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": "/menu",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("ホーム")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.checkHeaderUserPermission(_vm.acl.device_embedded_information) == false,
      "tag": "button",
      "to": "/device_embedded_information",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("機器・組込情報")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "　　証書　　",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.certificateLinksDisabled
    }
  }, _vm._l((_vm.certificateLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.checkHeaderUserPermission(_vm.acl.approval_history) == false,
      "tag": "button",
      "to": "/approval_history",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("申請承認")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "　　棚卸　　",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.inventoryLinksDisabled
    }
  }, _vm._l((_vm.inventoryLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.checkHeaderUserPermission(_vm.acl.bulk_import) == false && _vm.checkHeaderUserPermission(_vm.acl.bulk_import2) == false,
      "tag": "button",
      "to": "/bulk_import",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("一括取込")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "　ユーザ　",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.masterUserDisabled
    }
  }, _vm._l((_vm.masterUserLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "管理・マスタ",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.configurationLinksDisabled
    }
  }, _vm._l((_vm.configurationLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "11%",
      "padding": "2px 1px"
    }
  }, [_c('dropdown', {
    staticClass: " maintenance_menu",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "メンテナンス",
      "type": "btn btn-primary menu-dropdown-toggle",
      "disabled": _vm.maintenanceLinksDisabled
    }
  }, _vm._l((_vm.maintenanceLinks), function(o) {
    return _c('li', {
      key: o.name,
      staticStyle: {
        "margin": "2px -10px 2px 10px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary menu_drop_down",
      staticStyle: {
        "background": "#3b89cd"
      },
      attrs: {
        "disabled": o.path == '#' || o.disabled,
        "tag": "button",
        "to": o.path,
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(o.name))])], 1)
  }))], 1)])])]), _vm._v(" "), _c('information-modal', {
    attrs: {
      "tag": "prevendReturnMessage"
    }
  }), _vm._v(" "), _c('notice-modal', {
    attrs: {
      "stag": "processNoticeModalSchedule"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "float": "left",
      "padding": "20px 0px 0px 0px",
      "color": "#FFFFFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n          ソフトウェアライセンス管理\n          "), _c('br'), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("e-sma")])])])
}]}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_linked_devices_select")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器選択2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": this.selected_row < 0 && this.selectedRowArr.length == 0
    },
    on: {
      "click": _vm.addSelected
    }
  }, [_vm._v("選択")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('input-number-modal', {
    attrs: {
      "tag": "showNumberModalForSetDevicesQuantity"
    },
    on: {
      "closed": _vm.onSelectedQty
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("yobiki-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "yobiki_select-modal",
    attrs: {
      "width": "960px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v("証書管理番号")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body yobiki_select-modal-body ",
    staticStyle: {
      "height": "500px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "検索",
      "id": "yobiki-search",
      "name": "yobiki-search"
    },
    domProps: {
      "value": _vm.searchModel
    },
    on: {
      "input": function($event) {
        _vm.onSearch($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("OK")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("log-history-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "change_history-modal",
    attrs: {
      "width": "95%",
      "height": "90%",
      "content_height": "90%",
      "body_height": "85%",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v("更新履歴")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body change_history-modal-body ",
    staticStyle: {
      "height": "95%",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "200px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  }), _vm._v(" "), (_vm.showDetails) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "hist_td",
    staticStyle: {
      "margin": "auto",
      "margin-top": "30px",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hist_td"
  }, [_vm._v("項目")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("古いデータ")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("新しいデータ")])]), _vm._v(" "), _vm._l((_vm.dataChangesA), function(d) {
    return _c('tr', {
      key: d.id
    }, [_c('th', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.label))]), _vm._v(" "), _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))]), _vm._v(" "), (d.n.length > 0) ? _c('td', {
      staticClass: "hist_td",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(d.n))]) : _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))])])
  })], 2), _vm._v(" "), (_vm.bulkTorokuNumber != null) ? _c('table', {
    staticClass: "hist_td",
    staticStyle: {
      "margin": "auto",
      "margin-top": "20px",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hist_td",
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("一括編集No")]), _vm._v(" "), _c('td', {
    staticClass: "hist_td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-plain ",
    staticStyle: {
      "margin": "-10px -10px"
    },
    attrs: {
      "to": '/approval_history/toroku_filter/' + _vm.bulkTorokuNumber,
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.bulkTorokuNumber))])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(Array.isArray(_vm.dataChangesB)) ? _c('table', {
    staticClass: "hist_td",
    staticStyle: {
      "margin": "auto",
      "margin-top": "30px",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hist_td"
  }, [_vm._v("項目")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("古いデータ")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("新しいデータ")])]), _vm._v(" "), _vm._l((_vm.dataChangesB), function(d) {
    return _c('tr', {
      key: d.id
    }, [_c('th', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.label))]), _vm._v(" "), _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))]), _vm._v(" "), (d.n.length > 0) ? _c('td', {
      staticClass: "hist_td",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(d.n))]) : _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))])])
  })], 2) : _vm._e()])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.changeTime) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_software_linked_devices_select")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器選択"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": this.selected_row < 0 && this.selectedRowArr.length == 0
    },
    on: {
      "click": _vm.addSelected
    }
  }, [_vm._v("選択")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('input-number-modal', {
    attrs: {
      "tag": "showNumberModalForSetDevicesQuantity"
    },
    on: {
      "closed": _vm.onSelectedQty
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0002_login_expired\n  ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('div', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('center', [_vm._v("\n        30分以上ログインが確認出来なかったため、切断されました。"), _c('br'), _vm._v("\n        以下のボタンをクリックし、ログイン画面を再度開いてください。\n      ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('center', [_c('router-link', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "tag": "button",
      "to": "/",
      "type": "button"
    }
  }, [_vm._v("ログイン画面へ")])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "30px",
      "padding": "27px 50px",
      "font-weight": "800",
      "background": "#5b9bd5"
    }
  }, [_vm._v("\n    ソフトウェアライセンス管理\n    "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#ffffff"
    }
  }, [_vm._v("e-sma")])])
}]}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0016_device_embedded_information_pegging2")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "証書情報（紐付選択）"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.selected_row == -1
    },
    on: {
      "click": _vm.CheckToList
    }
  }, [_vm._v("紐付")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "col-xs-4 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "0px 0px 0px 5px"
    }
  }, [_c('input', {
    ref: _vm.fieldID,
    staticClass: "form-control",
    style: (_vm.filedStyle + 'float:left;width: 20px;height:20px;'),
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue,
      "checked": _vm.fieldValue == 1
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value, $event.target)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "float": "left",
      "padding-top": "6px",
      "font-weight": "normal",
      "font-size": "14px"
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v("\n            " + _vm._s(_vm.fieldSubLabel) + "\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "isb_box1"
  }, [_c('div', {
    staticClass: "isb_box2"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t1))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b1
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v("件")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t2))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b2
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v("件")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t3))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b3
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v("件")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t4))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b4
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v(_vm._s(_vm.u4))])])])])]), _vm._v(" "), (_vm.counter_b3_error_message != 'false') ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "-15px",
      "font-weight": "bold"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.counter_b3_error_message)
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('notifications', {
    attrs: {
      "position": "bottom center"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-het"
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_user_detail_bulk_edit")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "ユーザ（一括編集）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-10px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-right": "-10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onLocalSaveBulkDevEmbedded
    }
  }, [_vm._v("登録")])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmBulkDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onBulkDeviceEmbeddedInformationAddCheckConfirm
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("file-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "file-modal",
    attrs: {
      "width": "1000px",
      "value": _vm.showModal,
      "effect": "fade",
      "backdrop": false,
      "large": ""
    },
    on: {
      "closed": function($event) {
        _vm.closed('event')
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0px 20px",
      "font-weight": "800"
    }
  }, [_vm._v("PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    staticStyle: {
      "height": "450px",
      "overflow-y": "auto"
    }
  }, [_c('div', [(_vm.error_msg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.error_msg)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.error_msg.length == 0) ? _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, _vm._l((_vm.existingFiles), function(f) {
    return _c('div', {
      key: f.seq_id,
      staticStyle: {
        "width": "220px",
        "float": "left",
        "margin": "4px",
        "height": "250px",
        "word-wrap": "break-word"
      }
    }, [_c('center', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editFile(f)
        },
        "dblclick": function($event) {
          _vm.editAndOpenFile(f)
        }
      }
    }, [_c('pdf', {
      staticStyle: {
        "display": "inline-block",
        "width": "100px",
        "border": "solid #ccc 1px"
      },
      attrs: {
        "src": '/api/file_upload/pdf_load/' + f.seq_id + '?file=' + f.file_path + '&name=' + f.display_file_name
      },
      on: {
        "error": _vm.pdfRenderError
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(f.display_file_name))], 1)])], 1)
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white",
      "height": "100px"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row no_focus"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "height": "35px"
    }
  }, [(_vm.editFileSelect) ? _c('div', {
    staticStyle: {
      "float": "left",
      "padding-bottom": "15px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.editFileSelectItem.display_file_name) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 row no_focus"
  }, [_c('div', {
    staticClass: "col-xs-6 no_focus"
  }, [(_vm.editFileSelect) ? _c('a', {
    ref: "selected_file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "selected_file",
      "id": "selected_file",
      "href": '/api/file_upload/pdf_load/' + _vm.editFileSelectItem.seq_id + '?file=' + _vm.editFileSelectItem.file_path + '&name=' + _vm.editFileSelectItem.display_file_name,
      "target": 'file' + _vm.editFileSelectItem.seq_id
    }
  }, [_vm._v(_vm._s(_vm.editFileSelectItem.display_file_name))]) : _vm._e(), _vm._v(" "), (_vm.editFileSelect) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#92D050",
      "border-color": "#92D050",
      "float": "left"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openFile()
      }
    }
  }, [_vm._v("閲覧")]) : _vm._e(), _vm._v(" "), (_vm.editFileSelect) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "disabled": _vm.disableEditonButtons,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.renameFile()
      }
    }
  }, [_vm._v("名称変更")]) : _vm._e(), _vm._v(" "), (_vm.editFileSelect) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#FF7C80",
      "border-color": "#FF7C80",
      "float": "left"
    },
    attrs: {
      "disabled": _vm.disableEditonButtons,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteFile()
      }
    }
  }, [_vm._v("削除")]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "pdf_file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "pdf_file",
      "id": "pdf_file",
      "data-cy": "pdf_file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.fileSelected,
      "click": _vm.fileClicked
    }
  }), _vm._v(" "), (_vm.uploading == true) ? _c('div', [_c('span', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  }), _vm._v("\n              アップロード中...\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showUploadFile) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "120px",
      "width": "10%"
    },
    attrs: {
      "data-cy": "upload_btn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.uploadFile({})
      }
    }
  }, [_vm._v("アップロード")]), _vm._v(" "), (_vm.showCancelUpload) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "120px",
      "width": "10%",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (this.selected_file_name != null && _vm.showUploadFile) ? _c('label', [_vm._v(_vm._s(this.selected_file_name))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 no_focus"
  }, [(_vm.showChoseFile) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "200px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableEditonButtons
    },
    on: {
      "click": _vm.choseFile
    }
  }, [_vm._v("ファイルを選択（PDF）")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('button')
      }
    }
  }, [_vm._v("戻る")])])])])])]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmToDeleteFile"
    },
    on: {
      "done": _vm.deleteFileConfirmed
    }
  }), _vm._v(" "), _c('input-modal2', {
    attrs: {
      "tag": "inputFileRename"
    },
    on: {
      "closed": _vm.renameFileConfirmed
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("inventoty_certificate_list")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('search-control', {
    staticStyle: {
      "padding-bottom": "10px",
      "width": "100%"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "onSearchClear": _vm.onSearchClear,
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px",
      "margin-left": "-15px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n          件数　\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(_vm.acl.inventory_report, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.addNewReport
    }
  }, [_vm._v("棚卸報告")])])]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runinventorycertificatelistDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "device-embedded-information-bach-edit-modal",
    attrs: {
      "width": "460px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade"
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("一括編集")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body device-embedded-information-bach-edit-modal-body",
    staticStyle: {
      "height": "600px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("編集する項目：")]), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placehold": "",
      "er": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("編集内容：")]), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placehold": "",
      "er": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("編集する項目2：")]), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placehold": "",
      "er": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("編集内容：")]), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placehold": "",
      "er": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("編集する項目3：")]), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placehold": "",
      "er": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("編集内容：")]), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placehold": "",
      "er": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("編集項目追加")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("申請")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("ログイン")]), _vm._v(" "), _c('form', {
    staticClass: "lams_form",
    on: {
      "submit": _vm.onLogin
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_user),
      expression: "in_user"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^[\\.\\-0-9a-zA-Z]+$",
      "title": "ユーザIDは英数字のみを使用してください",
      "id": "user",
      "autocapitalize": "none",
      "autocomplete": "off",
      "placeholder": "ユーザID"
    },
    domProps: {
      "value": (_vm.in_user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.in_user = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_pass),
      expression: "in_pass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pass",
      "autocapitalize": "none",
      "autocomplete": "off",
      "placeholder": "パスワード",
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.pass,
      "checked": Array.isArray(_vm.in_pass) ? _vm._i(_vm.in_pass, _vm.pass) > -1 : (_vm.in_pass)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.in_pass,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.pass,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.in_pass = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.in_pass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.in_pass = $$c
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_pass),
      expression: "in_pass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pass",
      "autocapitalize": "none",
      "autocomplete": "off",
      "placeholder": "パスワード",
      "type": "radio"
    },
    domProps: {
      "value": _vm.pass,
      "checked": _vm._q(_vm.in_pass, _vm.pass)
    },
    on: {
      "change": function($event) {
        _vm.in_pass = _vm.pass
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_pass),
      expression: "in_pass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pass",
      "autocapitalize": "none",
      "autocomplete": "off",
      "placeholder": "パスワード",
      "type": _vm.passwordType
    },
    domProps: {
      "value": _vm.pass,
      "value": (_vm.in_pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.in_pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      glyphicon: true, 'glyphicon-eye-close': _vm.passwordIconOpen == true, 'glyphicon-eye-open': _vm.passwordIconOpen == false, 'field-icon': true
    },
    on: {
      "mousedown": _vm.togglePasswordDown,
      "mouseup": _vm.togglePasswordUp
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "login"
    }
  }, [_vm._v("ログイン")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('font', {
    staticClass: "version",
    attrs: {
      "color": "#ccc"
    }
  }, [_vm._v("2.3.3")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#FFFFFF",
      "font-size": "30px",
      "padding": "27px 50px",
      "font-weight": "800",
      "background": "#5b9bd5"
    }
  }, [_vm._v("\n    ソフトウェアライセンス管理\n    "), _c('br'), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("e-sma")])])
}]}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_software_category_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "ソフトウェアカテゴリ"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "33%",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("抹消")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterSoftwareCategoryModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Loading....\n")])
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_comprehensive_contract")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "包括契約"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.selected_row == -1
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "460px",
      "value": _vm.showModal,
      "effect": "fade",
      "backdrop": false
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body confirmation-modal-body ",
    staticStyle: {
      "height": "80px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('center', [_c('span', {
    staticClass: "glyphicon glyphicon-repeat glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0081_mail_message")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "メールメッセージ"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletemailMessageModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "10px",
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "6px 0px"
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: _vm.labelClass,
    style: (_vm.labelStyle),
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    style: (_vm.filedStyle),
    attrs: {
      "type": _vm.fieldType,
      "disabled": _vm.isDisabled,
      "min": _vm.minVal,
      "max": _vm.maxVal,
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "readonly": _vm.isReadOnly,
      "model": _vm.myModel,
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.filedStyle.indexOf('block') > -1) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, _vm._l((_vm.buttons), function(b) {
    return _c('button', {
      key: b.label,
      staticClass: "btn btn-primary esma_btn_form btn-xs",
      style: (b.btn_style),
      attrs: {
        "disabled": (b.type != 'callback' && b.type != 'dlink') || (b.type == 'callback' && (_vm.isDisabled || _vm.realValueEmpty == false)) || (b.type == 'dlink' && (_vm.fieldValue == null || _vm.fieldValue == ''))
      },
      on: {
        "click": function (ev) {
          _vm.onClick(b, ev)
        }
      }
    }, [_vm._v(_vm._s(b.label))])
  })) : _vm._l((_vm.buttons), function(b) {
    return _c('button', {
      key: b.label,
      staticClass: "btn btn-primary esma_btn_form btn-xs",
      style: (b.btn_style),
      attrs: {
        "disabled": (b.type != 'dlink' && b.type != 'callback' && _vm.isDisabled) || _vm.fieldValue == null || _vm.fieldValue == ''
      },
      on: {
        "click": function (ev) {
          _vm.onClick(b, ev)
        }
      }
    }, [_vm._v(_vm._s(b.label))])
  }), _vm._v(" "), (_vm.dbuttons.length > 0) ? _c('span', [_c('dropdown', {
    attrs: {
      "text": "",
      "type": "primary btn  btn-xs btn-primary",
      "disabled": _vm.fieldValue == null || _vm.fieldValue == ''
    }
  }, _vm._l((_vm.dbuttons), function(b) {
    return _c('li', {
      key: b.label
    }, [_c('a', {
      on: {
        "click": function (ev) {
          _vm.onClick(b, ev)
        }
      }
    }, [_vm._v(_vm._s(b.label))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorMessage),
      expression: "showErrorMessage"
    }],
    staticStyle: {
      "background": "red",
      "color": "white",
      "margin": "2px 0px",
      "padding": "2px 5px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.erroMessage) + "\n      ")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showLarge) ? _c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "800px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('span', {
    class: _vm.getIcon,
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body information-modal-body ",
    staticStyle: {
      "height": "100px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])]) : _c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "460px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('span', {
    class: _vm.getIcon,
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body information-modal-body ",
    staticStyle: {
      "height": "100px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("device-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "device_select-modal",
    attrs: {
      "width": "460px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v("機器管理番号")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body device_select-modal-body ",
    staticStyle: {
      "height": "500px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "検索",
      "id": "device-search",
      "name": "device-search"
    },
    domProps: {
      "value": _vm.searchModel
    },
    on: {
      "input": function($event) {
        _vm.onSearch($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("OK")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-het"
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_detail_bulk_edit")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "証書情報(一括編集）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        状態：\n        "), _c('select', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showApplyButton == true),
      expression: "showApplyButton == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onLocalSaveBulkCerInfeded
    }
  }, [_vm._v("下書保存")]) : _vm._e()])], 1), _vm._v(" "), _c('device-embedded-information-confirmation-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmBulkCertificateInformationAddCheck"
    },
    on: {
      "done": _vm.onBulkCertificateInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "bulkCertificateApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('file-modal', {
    attrs: {
      "tag": "showFileModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "block1 "
  }, [_c('search-control-block', {
    staticStyle: {
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px"
    },
    attrs: {
      "all_disabled": _vm.b1_disabled,
      "block_id": "1",
      "field_names": _vm.field_names
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == true),
      expression: "isSingle == true"
    }],
    staticStyle: {
      "width": "320px"
    }
  }, [_c('search-control-block', {
    staticStyle: {
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px"
    },
    attrs: {
      "all_disabled": _vm.b1_disabled,
      "block_id": "1",
      "field_names": _vm.field_names
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "block_btn "
  }, [_c('button', {
    staticClass: "btn btn-primary esma_btn_form btn-xs",
    staticStyle: {
      "width": "100px",
      "float": "left",
      "margin-left": "35px"
    },
    on: {
      "click": _vm.clearBarcode
    }
  }, [_vm._v("検索クリア")])])])])
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_pegging")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器一覧"
    }
  }), _vm._v(" "), _c('div', [_vm._v(" 紐付けした機器を解除する場合：機器を選択して[紐付解除]をクリック")]), _vm._v(" "), _c('div', [_vm._v("紐付けする機器を追加する場合：[追加]をクリックして機器を選択")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n             件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.confirmPositiveProcess
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("紐付解除")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "to": "/certificate_information_pegging_choice",
      "type": "button"
    }
  }, [_vm._v("　追加　")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmPositiveProcess"
    },
    on: {
      "done": _vm.onConfirmPositiveProcess
    }
  }), _vm._v(" "), _c('certificate-information-connection-application-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('device-embedded-information-bach-edit-modal', {
    attrs: {
      "tag": "showDeviceEmbeddedInformationBachEditModal"
    },
    on: {
      "save": _vm.onDeviceEmbeddedInformationBachEditModalSave,
      "cloase": _vm.onDeviceEmbeddedInformationBachEditModalClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("sub-table-temp-certificate-information")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "445px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row ",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("件数")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "margin-left": "5px",
      "float": "left",
      "width": "100px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRetractionReason),
      expression: "showRetractionReason"
    }],
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 10px"
    }
  }, [_c('label', {
    staticClass: "col-xs-4 control-label esma_form_label"
  }, [_vm._v("差戻理由 ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 select-box4",
    staticStyle: {
      "padding": "1px 0px 0px 7px",
      "margin-bottom": "-15px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retractionReasonValue),
      expression: "retractionReasonValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "60px !important"
    },
    attrs: {
      "disabled": _vm.disableRetractionReason,
      "placeholder": "",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.retractionReasonValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retractionReasonValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 "
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 ",
    staticStyle: {
      "padding": "0px 0px 20px 7px"
    }
  }, [(_vm.disableRetractionReason == true && _vm.disableEditRetractionReason == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "0px",
      "background": "#337ab7",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        _vm.disableRetractionReason = false
      }
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "0px",
      "background": "#A6A6A6",
      "margin-top": "30px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.cancelRetractionReason()
      }
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#337ab7",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        _vm.saveRetractionReason()
      }
    }
  }, [_vm._v("入力完了")]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == true && _vm.disableEditRetractionReason == false) ? _c('span', [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "15px",
      "margin-right": "0px",
      "font-weight": "800",
      "margin-top": "-65px",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v("※入力完了後、戻るボタンをクリックして、申請承認画面から差戻をしてください。\n               ")])]) : _vm._e(), _vm._v(" "), (_vm.disableRetractionReason == false) ? _c('span', [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "15px",
      "margin-right": "145px",
      "font-weight": "800",
      "margin-top": "-65px",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v("※差戻通知を入力し、入力完了をクリックしてください。(任意)\n               ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "white",
      "margin": "2px 0px",
      "padding": "2px 5px",
      "text-align": "end",
      "width": "90%",
      "float": "right",
      "background-color": "orange",
      "display": "none"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-lg btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": _vm.downloadUrl,
      "target": _vm.downloadUrl
    }
  }, [_vm._v("出力")]), _vm._v(" "), (_vm.showConfirmedBtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    on: {
      "click": _vm.onRejectedConfirmed
    }
  }, [_vm._v("確認済")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countErrors > 0 && _vm.filerByError == false),
      expression: "countErrors > 0 && filerByError == false"
    }],
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    on: {
      "click": _vm.filterOnlyErrors
    }
  }, [_vm._v("エラー詳細")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countErrors > 0 && _vm.filerByError == true),
      expression: "countErrors > 0 && filerByError == true"
    }],
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    on: {
      "click": _vm.filterAll
    }
  }, [_vm._v("戻る")])])])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "onRejectedConfirmedModal"
    },
    on: {
      "done": _vm.onRejectedConfirmedStep2
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: {
      'col-xs-4': true, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('select', {
    staticClass: "form-control select-box2",
    style: (_vm.fieldStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o.value,
      attrs: {
        "data": o.value
      },
      domProps: {
        "selected": o.value == _vm.fieldValue,
        "value": o.value
      }
    }, [_vm._v(_vm._s(o.label))])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "col-xs-4 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + "sb3")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('select', {
    staticClass: "form-control select-box select-box3",
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, [_vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual_input"
    }
  }, [_vm._v("手入力")])], 2)]), _vm._v(" "), _c('input-modal', {
    attrs: {
      "tag": 'showInputModal' + _vm.fieldID
    },
    on: {
      "inputed": _vm.onManualSelect
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isSearchMode == true && _vm.searchModeTypeahead == true) ? _c('v-select', {
    staticClass: "style-chooser",
    staticStyle: {
      "font-size": "12px!important"
    },
    attrs: {
      "clearable": false,
      "options": _vm.fieldOptions,
      "single-line": true,
      "value": _vm.fieldValue
    },
    on: {
      "input": _vm.updateValue
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n    対象はありません\n  ")])], 2) : (_vm.isSearchMode == true) ? _c('select', {
    class: {
      'form-control': true, 'select-box': true, 'limited-height-box': _vm.isSearchMode == true
    },
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue,
        "value": o
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  })], 2) : _c('div', {
    class: {
      'form-group': _vm.isSearchMode == false, 'esma_form_group': _vm.isSearchMode == false
    }
  }, [(_vm.showLabel && _vm.isSearchMode == false) ? _c('label', {
    class: {
      'col-xs-4': true, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass + ' select-box4',
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('select', {
    class: {
      'form-control': true, 'select-box': true, 'limited-height-box': _vm.isSearchMode == true
    },
    style: (_vm.filedStyle),
    attrs: {
      "disabled": this.isLoading || _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, [(_vm.disallowFirstEmptyOption == false) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue,
        "value": o
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    inventoty_tabs\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "申請承認"
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    },
    model: {
      value: (_vm.selectedTabModel),
      callback: function($$v) {
        _vm.selectedTabModel = $$v
      },
      expression: "selectedTabModel"
    }
  }, [_c('tab', {
    attrs: {
      "header": "申請承認"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "一括取込"
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.selectedTab == 1) ? _c('div', [_c('approval-history-all', {
    on: {
      "bRLFlag": _vm.setbRLFlag,
      "selectedItemsUpd": _vm.selectedItemsUpd
    }
  })], 1) : (_vm.selectedTab == 0) ? _c('div', [_c('approval-history', {
    on: {
      "bRLFlag": _vm.setbRLFlag,
      "selectedItemsUpd": _vm.selectedItemsUpd
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "approvalBeforeLeaveModal"
    },
    on: {
      "done": _vm.approvalBeforeLeaveoConfirmedModal
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "approvalBeforeLeaveTabModal"
    },
    on: {
      "done": _vm.approvalBeforeLeaveoConfirmedTabModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pink_bg"
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0040_certificate_software_detail_bulk_edit\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "証書情報(一括編集）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-25px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("\n          ＜　戻る\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          更新日：" + _vm._s(_vm.registrationDate) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          登録日：" + _vm._s(_vm.registrationDate) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n      承認状態：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.approvalStatus
    }
  }), _vm._v("\n      状態:\n      "), _c('select', {
    staticClass: "status_field",
    style: (_vm.statusFieldStyle),
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v("\n          " + _vm._s(option) + "\n        ")])
  })), _vm._v("\n      申請No：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "140px",
      "padding-left": "4px",
      "margin": "2px",
      "margin-bottom": "-6px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px",
      "color": "#008cff",
      "text-decoration": "underline"
    },
    attrs: {
      "type": "button",
      "value": _vm.approvalHistoryTorokuNumber
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableApplicationBtn == true),
      expression: "disableApplicationBtn == true"
    }],
    staticClass: "btn btn-primary on_confirm_execute_process_btn",
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("\n        申請\n      ")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false || true),
      expression: "isAdminSavingApplication == false || true"
    }],
    staticClass: "btn btn-primary on_local_save_certificate_software",
    attrs: {
      "disabled": _vm.disableAllButtons ||
        _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveBulkCertificateSoftware
    }
  }, [_vm._v("\n        下書保存\n      ")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])])], 1), _vm._v(" "), _c('certificate-information-connection-application-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUnlinkDevices"
    },
    on: {
      "done": _vm.onConfirmUnlinkDevices
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "onLocalSaveCertificateSoftwareAfterValudateStatusCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirmStep2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationCertificcateBulkAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateBulkApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px",
      "margin": "-15px"
    }
  }, [_c('h3', [_vm._v("ソフトウェア情報")])])])
}]}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "block1 "
  }, [_c('search-control-block', {
    staticStyle: {
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px"
    },
    attrs: {
      "all_disabled": _vm.b1_disabled,
      "block_id": "1",
      "block_contorler": _vm.b1Controller,
      "field_names": _vm.field_names
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == true),
      expression: "isSingle == true"
    }],
    staticStyle: {
      "width": "320px"
    }
  }, [_c('search-control-block', {
    staticStyle: {
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px"
    },
    attrs: {
      "all_disabled": _vm.b1_disabled,
      "block_id": "1",
      "field_names": _vm.field_names
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "join1 "
  }, [_c('select', {
    staticClass: "form-control select-box",
    staticStyle: {
      "height": "24px",
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px",
      "font-size": "12px",
      "width": "65px",
      "margin": "0 auto"
    },
    attrs: {
      "disabled": _vm.j1_disabled,
      "id": "and_or_2",
      "name": "and_or_2"
    },
    domProps: {
      "value": _vm.joinValue1
    },
    on: {
      "change": function($event) {
        _vm.andOr($event.target.value, 'j1')
      }
    }
  }, [_c('option', [_vm._v("AND")]), _vm._v(" "), _c('option', [_vm._v("OR")]), _vm._v(" "), (_vm.j1EnabledBetween) ? _c('option', {
    attrs: {
      "value": "BETWEEN"
    }
  }, [_vm._v("~")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "block2 "
  }, [_c('search-control-block', {
    staticStyle: {
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px"
    },
    attrs: {
      "all_disabled": _vm.b2_disabled,
      "block_id": "2",
      "block_contorler": _vm.b2Controller,
      "field_names": _vm.field_names
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "join2 "
  }, [_c('select', {
    staticClass: "form-control select-box",
    staticStyle: {
      "height": "24px",
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px",
      "font-size": "12px",
      "width": "65px",
      "margin": "0 auto"
    },
    attrs: {
      "disabled": _vm.j2_disabled,
      "id": "and_or_2",
      "name": "and_or_2"
    },
    domProps: {
      "value": _vm.joinValue2
    },
    on: {
      "change": function($event) {
        _vm.andOr($event.target.value, 'j2')
      }
    }
  }, [_c('option', [_vm._v("AND")]), _vm._v(" "), _c('option', [_vm._v("OR")]), _vm._v(" "), (_vm.j2EnabledBetween) ? _c('option', {
    attrs: {
      "value": "BETWEEN"
    }
  }, [_vm._v("~")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "block3 "
  }, [_c('search-control-block', {
    staticStyle: {
      "padding": "0px 0px",
      "marging": "0px 0px 0px 0px"
    },
    attrs: {
      "all_disabled": _vm.b3_disabled,
      "block_id": "3",
      "block_contorler": _vm.b3Controller,
      "field_names": _vm.field_names
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSingle == false),
      expression: "isSingle == false"
    }],
    staticClass: "block_btn "
  }, [_c('button', {
    staticClass: "btn btn-primary esma_btn_form btn-xs",
    staticStyle: {
      "width": "100px",
      "float": "left",
      "margin-left": "15px"
    },
    on: {
      "click": _vm.clearBarcode
    }
  }, [_vm._v("検索クリア")])])])])
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0091_programs_and_permissions_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "プログラムとアクセス権限（詳細）"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteProgramsAndPermissionsModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "メーカ"
    }
  }), _vm._v(" "), _c('search-control-maker', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n      ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletemailMessageModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "余剰ライセンス割当依頼一覧"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n      ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "border-color": "#7D2A2B",
      "background": "rgb(185 87 77)"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runSurplusLicenseDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col1), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col2), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("棚卸メニュー")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])
}]}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom",
      "no_menu": "true"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row menu-btns-container"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-xs-10 menu-btns"
  }, [_c('div', {
    staticClass: "entity_select_login"
  }, [_c('div', {
    staticClass: "entity_select_login_title"
  }, [_vm._v("社名選択")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('multi-select', {
    attrs: {
      "msstyle": "min-width:100px;width: 95%; height: 120px;border: 1px solid black;",
      "options": _vm.companyOptions
    },
    on: {
      "onSelected": _vm.companySelected
    }
  })], 1), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-lg btn-primary entity_select_btn",
    attrs: {
      "type": "button",
      "disabled": _vm.startIsEnabled == false,
      "title": "Start"
    },
    on: {
      "click": _vm.onStartClicked
    }
  }, [_vm._v("スタート")])])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "output_options-modal",
    attrs: {
      "width": "460px",
      "height": "130px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [(_vm.textTitle && _vm.textTitle.length > 0) ? _c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.textTitle) + " ")])])], 1)]) : _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body output_options-modal-body",
    staticStyle: {
      "height": "150px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.messageLabel)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.inputPrefix)
    }
  }), _vm._v(" "), _c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "width": "80px",
      "display": "inline"
    },
    attrs: {
      "type": "number",
      "min": _vm.minVal,
      "id": "local_value",
      "name": "local_value",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "keyup": function($event) {
        _vm.keyUp($event.target.id, $event.target.value, $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.inputSuffix)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    style: (_vm.yesStyle),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v(_vm._s(_vm.noLabel))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    style: (_vm.noStyle),
    attrs: {
      "type": "button",
      "disabled": _vm.localValue < _vm.minVal
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.yesLabel))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("log-history-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "log_history-modal",
    attrs: {
      "width": "980px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v("更新履歴")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body log_history-modal-body ",
    staticStyle: {
      "height": "500px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0030_bulk_import")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "旧データ取込"
    }
  }), _vm._v(" "), _c('dropdown', {
    staticClass: " ",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false,
      "text": _vm.dropdown_label,
      "type": "warning btn  btn-xs btn-warning dropdown_yellow_import"
    }
  }, [_c('li', {
    staticStyle: {
      "width": "300px",
      "margin-top": "2px"
    }
  }, [_c('a', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "300px",
      "background": "rgb(247, 218, 178)",
      "color": "black"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false,
      "href": "/api/temp_old_device_embedded_information/export_data/",
      "target": "temp_old_device_embedded_information"
    }
  }, [_vm._v(_vm._s(_vm.btn_dev_label))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "300px",
      "margin-top": "2px"
    }
  }, [_c('a', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "300px",
      "background": "rgb(247, 218, 178)",
      "color": "black"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false,
      "href": "/api/temp_old_certificate_information/export_data/",
      "target": "temp_old_certificate_information"
    }
  }, [_vm._v(_vm._s(_vm.btn_cer_label))])])]), _vm._v(" "), _c('div', [_c('input', {
    ref: "csv_file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "csv_file",
      "id": "csv_file",
      "data-cy": "csv_file",
      "accept": "*/*"
    },
    on: {
      "change": _vm.fileSelected,
      "click": _vm.fileClicked
    }
  }), _vm._v(" "), (_vm.showChoseFile) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "300px",
      "margin-top": "5px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false,
      "type": "button"
    },
    on: {
      "click": _vm.choseFile
    }
  }, [_vm._v("ファイルを選択（Excel）")]) : _vm._e(), _vm._v(" "), (_vm.uploading == true) ? _c('div', [_c('span', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  }), _vm._v("\n        アップロード中...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showUploadFile) ? _c('div', [(this.selected_file_name != null && _vm.showUploadFile) ? _c('label', [_vm._v(_vm._s(this.selected_file_name))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "10%"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false,
      "data-cy": "upload_btn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.uploadFile({})
      }
    }
  }, [_vm._v("アップロード")]), _vm._v(" "), (_vm.showCancelUpload) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "10%",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("キャンセル")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.error_msg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.error_msg)
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (false) ? _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSubTableCer) ? _c('sub-table-cer') : _vm._e(), _vm._v(" "), (_vm.showSubTableDev) ? _c('sub-table-dev') : _vm._e(), _vm._v(" "), (_vm.showSubTableAssociatedDevice) ? _c('sub-table-associated-device') : _vm._e(), _vm._v(" "), (_vm.showSubTableDeviceEmbeddedDetail) ? _c('sub-table-device-embedded-detail') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showSubTableCer || _vm.showSubTableDev || _vm.showSubTableAssociatedDevice || _vm.showSubTableDeviceEmbeddedDetail) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onExecuteClear
    }
  }, [_vm._v("クリア")]) : _vm._e(), _vm._v(" "), (_vm.showSubTableCer || _vm.showSubTableDev || _vm.showSubTableAssociatedDevice || _vm.showSubTableDeviceEmbeddedDetail) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onConfirmExecuteProcessAndApply
    }
  }, [_vm._v("申請")]) : _vm._e(), _vm._v(" "), (_vm.showSubTableCer || _vm.showSubTableDev || _vm.showSubTableAssociatedDevice || _vm.showSubTableDeviceEmbeddedDetail) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onConfirmExecuteProcessOnlySave
    }
  }, [_vm._v("下書保存")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "applicationConfirmatioProcessOnlyModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "onConfirmExecuteProcessOnlySave"
    },
    on: {
      "done": _vm.onConfirmExecuteProcessOnly
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateApplicationConfimationModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_software_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "ソフトウェア（詳細）"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "2px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "2px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterSoftwareModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0050_approval_history")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": true || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkApprovalStage4
    }
  }, [_vm._v("申請クリア")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disablePageApprove || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkApprovalStage1
    }
  }, [_vm._v("承認")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.disablePageReject || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkRejectStage1
    }
  }, [_vm._v("差戻")])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage2ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage3
    }
  }), _vm._v(" "), _c('information-icon-modal', {
    attrs: {
      "tag": "showInformationIconModalApprovalHistoryAll"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1RejectConfirmatioModal"
    },
    on: {
      "done": _vm.bulkRejectStage2
    }
  }), _vm._v(" "), _c('progress-modal', {
    attrs: {
      "tag": "showApproveProgressModal",
      "hide_tag": "hideApproveProgressModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#affbff",
      "margin": "30px -50px 50px -50px",
      "padding": "20px 50px 50px 50px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker_detail")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ''
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.buttonsMode == 'new') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("割当依頼を送信する")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonsMode == 'review'),
      expression: "buttonsMode == 'review'"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableReviewButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.approve
    }
  }, [_vm._v("確認")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonsMode == 'review'),
      expression: "buttonsMode == 'review'"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.disableReviewButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("差戻")])])])]), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "onSavedInformation"
    },
    on: {
      "done": _vm.onSavedConfirmation
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationApproveReject"
    },
    on: {
      "done": _vm.onNotificationApproveRejectConfirmation
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0091_programs_and_permissions")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "プログラムとアクセス権限"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n         件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.selected_row == -1 || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: {
      'col-xs-4': true, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + "  "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDisabled,
      "input-style": _vm.disabledStyle + ';height: 24px!important;' + _vm.filedStyle,
      "input-button-style": _vm.buttonStyle,
      "input-class": " form-control force-white",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "value": _vm.fieldValue,
      "controller": _vm.dp_controller,
      "placeholder": "",
      "calendar-style": "left:-100px;"
    },
    on: {
      "input": _vm.updateValue
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vdp-datepicker",
    class: _vm.wrapperClass
  }, [_c('div', {
    class: {
      'input-group': _vm.bootstrapStyling
    }
  }, [(_vm.calendarButton) ? _c('span', {
    staticClass: "vdp-datepicker__calendar-button",
    class: {
      'input-group-addon': _vm.bootstrapStyling
    },
    style: (_vm.inputButtonStyle),
    on: {
      "click": _vm.showCalendar
    }
  }, [_c('i', {
    class: _vm.calendarButtonIcon
  }, [(_vm.calendarButtonIcon.length === 0) ? _c('span', [_vm._v("…")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('input', {
    class: [_vm.inputClass, {
      'form-control': _vm.bootstrapStyling,
      'vpd-format-error': _vm.hasError
    }],
    style: (_vm.inputStyle),
    attrs: {
      "type": _vm.inline ? 'hidden' : 'text',
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "clear-button": _vm.clearButton,
      "disabled": _vm.disabledPicker,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "keydown": function($event) {
        _vm.checkForCompletedInput($event.target.value, $event)
      },
      "focusout": function($event) {
        _vm.checkForCompletedInput($event.target.value, {
          code: 'focusoutevent'
        })
      }
    }
  }), _vm._v(" "), (_vm.clearButton && _vm.selectedDate && !_vm.disabledPicker) ? _c('span', {
    staticClass: "vdp-datepicker__clear-button",
    class: {
      'input-group-addon': _vm.bootstrapStyling
    },
    style: (_vm.inputButtonStyle),
    on: {
      "click": function($event) {
        _vm.clearDate()
      }
    }
  }, [_c('i', {
    class: _vm.clearButtonIcon
  }, [(_vm.calendarButtonIcon.length === 0) ? _c('span', [_vm._v("×")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDayView),
      expression: "showDayView"
    }],
    staticClass: "vdp-datepicker__calendar",
    style: (_vm.calendarStyle)
  }, [_c('header', [_c('span', {
    staticClass: "prev",
    class: {
      'disabled': _vm.previousMonthDisabled(_vm.currDate)
    },
    on: {
      "click": _vm.previousMonth
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "up",
    on: {
      "click": _vm.showMonthCalendar
    }
  }, [_vm._v(_vm._s(_vm.currMonthName) + " " + _vm._s(_vm.currYear))]), _vm._v(" "), _c('span', {
    staticClass: "next",
    class: {
      'disabled': _vm.nextMonthDisabled(_vm.currDate)
    },
    on: {
      "click": _vm.nextMonth
    }
  }, [_vm._v(">")])]), _vm._v(" "), _vm._l((_vm.daysOfWeek), function(d) {
    return _c('span', {
      staticClass: "cell day-header"
    }, [_vm._v(_vm._s(d))])
  }), _vm._v(" "), _vm._l((_vm.blankDays), function(d) {
    return _c('span', {
      staticClass: "cell day blank"
    })
  }), _vm._l((_vm.days), function(day) {
    return _c('span', {
      staticClass: "cell day",
      class: {
        'selected': day.isSelected, 'disabled': day.isDisabled, 'highlighted': day.isHighlighted, 'today': day.isToday
      },
      attrs: {
        "track-by": "timestamp"
      },
      on: {
        "click": function($event) {
          _vm.selectDate(day)
        }
      }
    }, [_vm._v(_vm._s(day.date))])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMonthView),
      expression: "showMonthView"
    }],
    staticClass: "vdp-datepicker__calendar",
    style: (_vm.calendarStyle)
  }, [_c('header', [_c('span', {
    staticClass: "prev",
    class: {
      'disabled': _vm.previousYearDisabled(_vm.currDate)
    },
    on: {
      "click": _vm.previousYear
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "up",
    on: {
      "click": _vm.showYearCalendar
    }
  }, [_vm._v(_vm._s(_vm.getYear()))]), _vm._v(" "), _c('span', {
    staticClass: "next",
    class: {
      'disabled': _vm.nextYearDisabled(_vm.currDate)
    },
    on: {
      "click": _vm.nextYear
    }
  }, [_vm._v(">")])]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return _c('span', {
      staticClass: "cell month",
      class: {
        'selected': month.isSelected, 'disabled': month.isDisabled
      },
      attrs: {
        "track-by": "timestamp"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectMonth(month)
        }
      }
    }, [_vm._v(_vm._s(month.month))])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showYearView),
      expression: "showYearView"
    }],
    staticClass: "vdp-datepicker__calendar",
    style: (_vm.calendarStyle)
  }, [_c('header', [_c('span', {
    staticClass: "prev",
    class: {
      'disabled': _vm.previousDecadeDisabled(_vm.currDate)
    },
    on: {
      "click": _vm.previousDecade
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getDecade()))]), _vm._v(" "), _c('span', {
    staticClass: "next",
    class: {
      'disabled': _vm.nextMonthDisabled(_vm.currDate)
    },
    on: {
      "click": _vm.nextDecade
    }
  }, [_vm._v(">")])]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('span', {
      staticClass: "cell year",
      class: {
        'selected': year.isSelected, 'disabled': year.isDisabled
      },
      attrs: {
        "track-by": "timestamp"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectYear(year)
        }
      }
    }, [_vm._v(_vm._s(year.year))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_company_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "会社（詳細）"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterCompanyModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "rgb(189, 214, 236)",
      "padding": "15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('input-box-result', {
      key: f.name,
      attrs: {
        "value": _vm.dataValues[f.name],
        "label": f.label
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('input-box-result', {
      key: f.name,
      attrs: {
        "labelSize": "L",
        "value": _vm.dataValues[f.name],
        "label": f.label
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('input-box-result', {
      key: f.name,
      attrs: {
        "value": _vm.dataValues[f.name],
        "label": f.label
      }
    })
  }))])])
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_notification_certificate")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": _vm.pageTitle
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n         件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('device-embedded-information-bach-edit-modal', {
    attrs: {
      "tag": "showDeviceEmbeddedInformationBachEditModal"
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.div_class
  }, [(_vm.isEnable) ? _c('router-link', {
    attrs: {
      "to": _vm.linkTo
    }
  }, [_c('button', {
    class: 'btn btn-lg btn-primary menu-btn menu-btn-enabled ' + _vm.btn_class,
    attrs: {
      "type": "button"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.btnText)
    }
  })]) : _c('button', {
    staticClass: "btn btn-lg btn-default menu-btn menu-btn-disabled",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.btnText)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0010_device_embedded_information")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "機器・組込情報"
    }
  }), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "使用中"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "廃棄"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "下書中/申請中/差戻"
    }
  })], 1), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), (_vm.selectedTab == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.deleteBtnDisabled || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.formBatchEditDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bachEdit
    }
  }, [_vm._v(_vm._s(_vm.batchEditText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規")])])], 1), _vm._v(" "), _c('device-embedded-information-bach-edit-modal', {
    attrs: {
      "tag": "showDeviceEmbeddedInformationBachEditModal"
    },
    on: {
      "save": _vm.onDeviceEmbeddedInformationBachEditModalSave,
      "cloase": _vm.onDeviceEmbeddedInformationBachEditModalClose
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbeddedInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteDeviceEmbeddedInformationModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('information-icon-modal', {
    attrs: {
      "tag": "showInformationIconModalDeviceEmbededInformation"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [_c('label', {
    class: {
      'col-xs-4': true, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    style: (_vm.labelStyle),
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v("\n   " + _vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    style: (_vm.filedStyle),
    attrs: {
      "type": "password",
      "disabled": _vm.isDisabled,
      "autocapitalize": "none",
      "_autocomplete": "off",
      "autocomplete": "new-password",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "focus": function($event) {
        _vm.atFocus()
      },
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0080_system_setting")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "システム設定"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "width": "100%",
      "background": "#bdd6ec",
      "border": "1px solid #337ab7",
      "border-radius": "5px",
      "text-align": "start",
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), (_vm.isEditing == true) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textContent),
      expression: "textContent"
    }],
    staticClass: "form-control txt_edit",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.textContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textContent = $event.target.value
      }
    }
  }) : _c('div', {
    staticClass: "txt_edit",
    staticStyle: {
      "width": "100%",
      "text-align": "start",
      "min-height": "222px",
      "border": "1px solid #ccc",
      "border-radius": "5px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.textContent.replace(/\n/g, '<br>'))
    }
  }), _vm._v(" "), (_vm.showEdit) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing == false),
      expression: "isEditing == false"
    }],
    staticClass: "btn btn-primary btn_edit",
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing == true),
      expression: "isEditing == true"
    }],
    staticClass: "btn btn-primary btn_edit",
    staticStyle: {
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing == true),
      expression: "isEditing == true"
    }],
    staticClass: "btn btn-primary btn_edit",
    staticStyle: {
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("キャンセル")])])
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0010_device_embedded_information_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "機器・組込情報"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-10px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [(_vm.is_new == false) ? _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("機器登録番号：" + _vm._s(_vm.deviceControlNumber))]) : _vm._e(), _vm._v(" "), (_vm.is_new == false) ? _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("登録日：" + _vm._s(_vm.registrationDate))]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        承認状態：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.approvalStatus
    }
  }), _vm._v("\n        状態:\n        "), _c('select', {
    style: (_vm.statusFieldStyle),
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })), _vm._v("\n        申請No：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "140px",
      "padding-left": "4px",
      "margin": "2px",
      "margin-bottom": "-6px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px",
      "color": "#008cff",
      "text-decoration": "underline"
    },
    attrs: {
      "type": "button",
      "value": _vm.approvalHistoryTorokuNumber
    },
    on: {
      "click": _vm.onConfirmExecuteProcessConfirmation
    }
  }), _vm._v(" "), (_vm.showApprovalHistoryBulkTorokuNumberQty) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※この申請は一括申請です。同一の申請が " + _vm._s(_vm.approvalHistoryBulkTorokuNumberQty) + " 件あります。")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id],
        "option": {
          rows: 2
        }
      }
    })
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.approvalcancelmode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.approvalCancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e(), _vm._v(" "), (_vm.approvalcancelmode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.onapprovalSaveDevEmbedded
    }
  }, [_vm._v("入力完了")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.approvalcancelmode == true),
      expression: "approvalcancelmode == true"
    }]
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "15px",
      "margin-right": "70px",
      "font-weight": "800",
      "margin-top": "-35px",
      "letter-spacing": "3px",
      "color": "red"
    }
  }, [_vm._v("※差戻通知を入力し、入力完了をクリックして下さい。(任意)\n             ")])]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.draftWriteMode == false),
      expression: "draftWriteMode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalUpSaveDevEmbedded
    }
  }, [_vm._v("上書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.draftWriteMode == true),
      expression: "draftWriteMode == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveDevEmbedded
    }
  }, [_vm._v("下書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditMainBtn == false && _vm.approvalcancelmode == false),
      expression: "hideEditMainBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": (_vm.disableEditMainBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false) || _vm.approvalcancelmode == true
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_new == true),
      expression: "is_new == true"
    }]
  }, [_vm._v("「下書保存」ボタンを押したら「組込情報」が出ます。")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', [_c('div', {
    style: (_vm.subTableDeviceEmbeddedInformationStyle)
  }, [_c('h3', [_vm._v("組込情報")]), _vm._v(" "), _c('sub-table_device-embedded-information', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disable_new_btn": _vm.disableNewToSubTableBtn,
      "disable_edit_btn": _vm.disableEditSubTableBtn,
      "hide_new_btn": _vm.hideNewToSubTableBtn,
      "hide_edit_btn": _vm.hideEditSubTableBtn,
      "ref_id": _vm.deviceControlNumber,
      "fk_id": _vm.deviceSeqId,
      "tag_reload": "reloadSubTableDeviceEmbeddedInformation"
    },
    on: {
      "data-saved": _vm.subTableSaved,
      "updatedtotalnumber": function($event) {
        _vm.device_totalNumber = $event
      }
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.is_new == false && _vm.approvalcancelmode == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.BROWSE) == false
    },
    on: {
      "click": _vm.showHistory
    }
  }, [_vm._v("更新履歴")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplyConfirmationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": function($event) {
        _vm.processApprovalApprove()
      }
    }
  }, [_vm._v("確認")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.refreshSequencer > 0 && _vm.hideApplyRejectBtn == false && _vm.hideApplyConfirmationBtn == true && _vm.approvalcancelmode == false),
      expression: "this.refreshSequencer > 0  && hideApplyRejectBtn == false && hideApplyConfirmationBtn == true && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onapprovalSaveDevEmbeddedReason
    }
  }, [_vm._v("取戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplyConfirmationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.processApprovalCancel
    }
  }, [_vm._v("差戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplicationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplicationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableApplicationBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCopyMainBtn == false && _vm.approvalcancelmode == false),
      expression: "hideCopyMainBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.cloneRecord
    }
  }, [_vm._v("コピー")])])], 1), _vm._v(" "), _c('device-embedded-information-confirmation-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancel"
    },
    on: {
      "done": _vm.processApprovalCancelBack
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancelReason"
    },
    on: {
      "done": _vm.processApprovalCancelBackReason
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationUpAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationUpAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterdeviceInformationApprovalStartedRequest"
    },
    on: {
      "done": _vm.afterTheNotificationAftercancel
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "deviceEmbeddedApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('change-history', {
    attrs: {
      "tag": "showDeviceEmbeddedInformationlogHistoryModal",
      "id_label": "機器管理番号"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "showConfimationModalSetdevice"
    },
    on: {
      "done": _vm.confirmedSetdevice
    }
  }), _vm._v(" "), _c('device-modal', {
    attrs: {
      "tag": "showdeviceModal"
    },
    on: {
      "selected": _vm.ondeviceModalSelected
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deletedeviceEmbeddedInformationDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "12px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("＊入力必須項目")])])
}]}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col1), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col2), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("管理・マスタメニュー")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])
}]}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px",
      "min-width": "1100px"
    }
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.device_embedded_information, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/device_embedded_information",
      "type": "button"
    }
  }, [_vm._v("機器・組込情報")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.certificate_information, _vm.permissionMode.BROWSE) == false && _vm.checkMenuUserPermission(_vm.acl.surplus_license, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_certificate",
      "type": "button"
    }
  }, [_vm._v("証書")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.approval_history, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/approval_history",
      "type": "button"
    }
  }, [_vm._v("申請承認")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.inventory, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_inventory",
      "type": "button"
    }
  }, [_vm._v("棚卸")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.bulk_import, _vm.permissionMode.BROWSE) == false && _vm.checkMenuUserPermission(_vm.acl.bulk_import2, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/bulk_import",
      "type": "button"
    }
  }, [_vm._v("一括取込")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.master_user_password, _vm.permissionMode.BROWSE) == false && _vm.checkMenuUserPermission(_vm.acl.master_user, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_master",
      "type": "button"
    }
  }, [_vm._v("ユーザ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.master_bel_mak_sys, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_configuration",
      "type": "button"
    }
  }, [_vm._v("管理・マスタ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "min-width": "100px",
      "margin": "5px",
      "width": "80%",
      "background": "#3b89cd",
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.checkMenuUserPermission(_vm.acl.maintenance, _vm.permissionMode.BROWSE) == false,
      "tag": "button",
      "to": "/menu_maintenance",
      "type": "button"
    }
  }, [_vm._v("\n        メンテナンス")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "font-size": "13px"
    }
  }, [(_vm.isUserIDOperationInCharge == false) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("■通知")]), _vm._v(" "), _c('p', [_vm._v("\n            ■ライセンス情報\n            "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "counters"
  }, [_c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・３ヵ月以内に有効期限が切れるライセンス　")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.certificateThatExpiresIn3Months
    }
  }), _vm._v("件\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/certificate_3_months",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・有効期限切れライセンス　")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.certificateExpiredLicense
    }
  }), _vm._v("件\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/certificate_expired",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)])])]), _c('p', [_vm._v("\n            ■未承認申請情報\n            "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "counters"
  }, [_c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（申請中）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalPending
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（差戻）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalRejection
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history/rejected",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・一括取込（申請中）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.bulkImportPending
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history/all",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・一括取込（差戻）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.bulkImportRejection
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/approval_history/all/rejected",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)])])]), _vm._v(" "), (_vm.applicationApprovalInventoryPending > 0 || _vm.applicationApprovalInventoryRejection > 0) ? _c('p', [_vm._v("\n            ■棚卸情報\n            "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "counters"
  }, [(_vm.applicationApprovalInventoryPending > 0) ? _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（申請中）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalInventoryPending
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    on: {
      "click": _vm.applicationApprovalInventoryBtn
    }
  }, [_vm._v("詳細")])])]) : _vm._e(), _vm._v(" "), (_vm.applicationApprovalInventoryRejection > 0) ? _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・申請承認（差戻）")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.applicationApprovalInventoryRejection
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    on: {
      "click": _vm.applicationApprovalInventoryRejectionBtn
    }
  }, [_vm._v("詳細")])])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isMultiCompanyAdmin) ? _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px",
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("■余剰ライセンス")]), _vm._v(" "), _c('p', [_c('table', {
    staticClass: "counters"
  }, [_c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・3ヵ月以内に有効期限が切れる余剰ライセンス")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.surplusLicenseThatExpiresIn3Months
    }
  }), _vm._v("件\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/surplus_3_months",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "counters"
  }, [_c('td', {
    staticClass: "counters_first"
  }, [_vm._v("・有効期限切れ余剰ライセンス")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('input', {
    staticClass: "menu_input_box",
    staticStyle: {},
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.surplusExpiredLicense
    }
  }), _vm._v("件\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "counters"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "min-width": "50px",
      "width": "10%"
    },
    attrs: {
      "to": "/notification_certificate/surplus_expired",
      "type": "button"
    }
  }, [_vm._v("詳細")])], 1)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('info-box', {
    attrs: {
      "title": "■ライセンス管理窓口からのご案内",
      "box_id": "home_box1"
    }
  }), _vm._v(" "), _c('info-box', {
    attrs: {
      "title": "■ e-sma操作マニュアル・フロー図",
      "box_id": "home_box2"
    }
  })], 1)])]), _vm._v(" "), _c('notice-modal', {
    attrs: {
      "tag": "processNoticeModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "no_back": "true",
      "settings": "systemZoom"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col1), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.col2), function(c) {
    return _c('router-link', {
      key: c.name,
      staticClass: "btn btn-primary btn-lg",
      staticStyle: {
        "margin": "5px",
        "width": "80%",
        "background": "#5a99d2",
        "color": "white",
        "font-weight": "bold"
      },
      attrs: {
        "disabled": c.path == '#' || c.disabled,
        "tag": "button",
        "to": c.path,
        "type": "button"
      }
    }, [_vm._v(_vm._s(c.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("ユーザメニュー")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  })])
}]}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0015_device_embedded_information_pegging")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "証書情報（紐付証書）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("ソフトウェア情報")]), _c('br'), _vm._v(" "), _c('sub-table-associated_device', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "to": "/device_embedded_information_pegging2",
      "type": "button"
    }
  }, [_vm._v("紐付変更")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_software_linked_devices")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "紐付機器一覧"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.disableReturn
    },
    on: {
      "click": _vm.backToCertificateDetail
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "230px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "counter_label"
  }, [_vm._v("ライセンス数")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localTotalLicenses),
      expression: "localTotalLicenses"
    }],
    staticClass: "form-control counter_input ",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.localTotalLicenses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localTotalLicenses = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "counter_label"
  }, [_vm._v("総使用数")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localEffectiveNumber),
      expression: "localEffectiveNumber"
    }],
    staticClass: "form-control counter_input ",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.localEffectiveNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localEffectiveNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "counter_label"
  }, [_vm._v("残数")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localNumberOfRemaining),
      expression: "localNumberOfRemaining"
    }],
    class: {
      'form-control': true, counter_input: true, counter_input_error: _vm.localNumberOfRemaining < 0
    },
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.localNumberOfRemaining)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localNumberOfRemaining = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "counter_label"
  }), _vm._v(" "), _c('td', [(_vm.localNumberOfRemaining < 0) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('br'), _vm._v("\n                    ※機器の使用数がライセンスの残数を上回っています。\n                    "), _c('br'), _vm._v("不要な機器を選択し「紐付解除」より紐付けを解除してください。\n                    ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.localCertificateSeqId < 0
    },
    on: {
      "click": _vm.unlinkItem
    }
  }, [_vm._v("紐付解除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableSelectNew
    },
    on: {
      "click": _vm.linkNewItem
    }
  }, [_vm._v("追加")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 menu-container"
  }, [_c('ag-grid-vue', {
    staticClass: "ag-bootstrap",
    style: (_vm.getStyle),
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("log-history-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "change_history-modal",
    attrs: {
      "width": "95%",
      "height": "90%",
      "content_height": "90%",
      "body_height": "85%",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-body change_history-modal-body ",
    staticStyle: {
      "height": "95%",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_software_linked_upgrade")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "アップグレード元の証書を選択"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n          件数\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "output_options-modal",
    attrs: {
      "width": "460px",
      "height": "130px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body output_options-modal-body ",
    staticStyle: {
      "height": "50px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "keyup": function($event) {
        _vm.keyUp($event.target.id, $event.target.value, $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("完了")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valCompany),
      expression: "valCompany"
    }],
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "id": "company"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.valCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onSearchValue('company', $event.target.value)
      }]
    }
  }, _vm._l((_vm.optCompany), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o
      },
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }))])]), _vm._v(" "), (_vm.onlyCompany != true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valDepartment),
      expression: "valDepartment"
    }],
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.optDepartment.length == 0,
      "id": "department"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.valDepartment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onSearchValue('department', $event.target.value)
      }]
    }
  }, _vm._l((_vm.optDepartment), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o
      },
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.onlyCompany != true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valTeam),
      expression: "valTeam"
    }],
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.optTeam.length == 0,
      "id": "team"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.valTeam = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onSearchValue('team', $event.target.value)
      }]
    }
  }, _vm._l((_vm.optTeam), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o
      },
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.onlyCompany != true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valJurisdictionClassification),
      expression: "valJurisdictionClassification"
    }],
    staticClass: "form-control select-box limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "id": "jurisdiction_classification"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.valJurisdictionClassification = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onSearchValue('jurisdiction_classification', $event.target.value)
      }]
    }
  }, _vm._l((_vm.optJurisdictionClassification), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o
      },
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.onlyCompany != true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valJicenseJurisdictionSystem),
      expression: "valJicenseJurisdictionSystem"
    }],
    staticClass: "form-control select-box  limited-height-box",
    staticStyle: {
      "height": "24px",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.valJurisdictionClassification != 'IT所管システム',
      "id": "license_jurisdiction_system"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.valJicenseJurisdictionSystem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onSearchValue('license_jurisdiction_system', $event.target.value)
      }]
    }
  }, _vm._l((_vm.optJicenseJurisdictionSystem), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o
      },
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("所管会社")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "department"
    }
  }, [_vm._v("所管部署")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "team"
    }
  }, [_vm._v("所管チーム")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "jurisdiction_classification"
    }
  }, [_vm._v("所管区分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "license_jurisdiction_system"
    }
  }, [_vm._v("所管システム")])])
}]}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("sub-table-temp-associated_device")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "530px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          件数"), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "メーカ（詳細）"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterMakerModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "600px",
      "height": "100px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body file-download-modal-body",
    staticStyle: {
      "height": "150px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('center', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.spinVisable),
      expression: "spinVisable"
    }],
    staticClass: "glyphicon glyphicon-repeat glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "open_file",
    attrs: {
      "href": _vm.linkToOpen,
      "target": 'open_file' + _vm.linkToOpen
    }
  }, [_vm._v("#")])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_notice_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": _vm.pageTitle
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, _vm._l((_vm.formFields.col4), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id],
        "option": {
          label_in_new_line: true,
          field_style: 'height: 100px!important;margin-left: -7px;margin-top: 4px;',
          rows: 4
        }
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "13px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true && this.isHistoryOnly == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "13px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true && this.isHistoryOnly == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteNoticeModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  })])
}]}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("master_user")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [(_vm.localShowSearch == true) ? _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }) : _vm._e(), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    style: (_vm.localTabStyle),
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[570]);


// WEBPACK FOOTER //
// static/js/app.074e7b13e32f39d699ad.js